var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __publicField = (obj, key, value2) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value2);
import * as React from "react";
import React__default, { useState, useEffect, useContext, useReducer, createContext, memo, useMemo, useCallback, useRef, createElement, isValidElement, cloneElement, Children, Component } from "react";
import { Box as Box$1, useTheme, Typography, Grid, createTheme as createTheme$2, TextField, FormControlLabel, Switch, ThemeProvider, CssBaseline, Container, Paper, Divider, Checkbox, TableHead, TableCell, TableBody, TableRow, Table, Link, FormControl as FormControl$1, InputLabel as InputLabel$1, Select, MenuItem, Fab, Button, Card, CardHeader, CardContent, CardActions, useMediaQuery, AppBar, Toolbar, useScrollTrigger, IconButton, ListItem, ListItemIcon, ListItemText, List, Slide, Menu, ImageList, ImageListItem, CardActionArea, colors, Avatar, Drawer, Icon, Chip, Alert as Alert$1, Accordion, AccordionSummary, AccordionDetails, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slider, ToggleButton, ToggleButtonGroup, ButtonGroup, Popper, Grow, ClickAwayListener, MenuList, Collapse, CardMedia, Radio, FormGroup, RadioGroup, FormLabel, FormHelperText as FormHelperText$1, Stack, CircularProgress, LinearProgress, Input as Input$1, Snackbar, SnackbarContent, Tab, Tabs, InputAdornment, TableContainer, Autocomplete, createFilterOptions, SvgIcon as SvgIcon$1, Tooltip } from "@mui/material";
import { Chip as Chip2 } from "@mui/material";
import { useNavigate, redirect, matchPath, useLocation, Link as Link$1 } from "react-router";
import { useAuth, AuthProvider } from "react-oidc-context";
import { MDXProvider, useMDXComponents } from "@mdx-js/react";
import { LightMode, DarkMode, Check, Clear, Savings, List as List$1, Build, Pageview, Settings, LibraryBooks, LockOpen, AccountBox, Image, TextFields, ShoppingBasket, People, Dashboard, Create, Web, GridOn, Block, Save, NoteAdd, FileCopy, Delete, Store, Home, Menu as Menu$1, Storefront, Business, Factory, FamilyRestroom, Call, DangerousSharp, Collections, Info, Sell, OfflineBolt, AddShoppingCart, Notifications, Category, LastPage, FirstPage, KeyboardArrowUp, KeyboardArrowDown, KeyboardArrowRight, KeyboardArrowLeft, Colorize, House, Devices, Scanner, SmokingRooms, Pets, LocalGroceryStore, LocalHospital, Adjust, EventSeat, Highlight as Highlight$1, DirectionsCar } from "@mui/icons-material";
import PropTypes from "prop-types";
import emStyled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import Prism from "prismjs";
import dayjs from "dayjs";
import AdSense from "react-adsense";
import MaterialTable from "@material-table/core";
import * as StackTrace from "stacktrace-js";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
  function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
      maybeKey = {};
      for (var propName in config)
        "key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config ? config : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production.jsx = jsxProd;
  reactJsxRuntime_production.jsxs = jsxProd;
  return reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  "production" !== process.env.NODE_ENV && function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE$2 ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x) {
            }
        }
      return null;
    }
    function testStringCoercion(value2) {
      return "" + value2;
    }
    function checkKeyStringCoercion(value2) {
      try {
        testStringCoercion(value2);
        var JSCompiler_inline_result = false;
      } catch (e) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value2[Symbol.toStringTag] || value2.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value2);
      }
    }
    function disabledLog() {
    }
    function disableLogs() {
      if (0 === disabledDepth) {
        prevLog = console.log;
        prevInfo = console.info;
        prevWarn = console.warn;
        prevError = console.error;
        prevGroup = console.group;
        prevGroupCollapsed = console.groupCollapsed;
        prevGroupEnd = console.groupEnd;
        var props = {
          configurable: true,
          enumerable: true,
          value: disabledLog,
          writable: true
        };
        Object.defineProperties(console, {
          info: props,
          log: props,
          warn: props,
          error: props,
          group: props,
          groupCollapsed: props,
          groupEnd: props
        });
      }
      disabledDepth++;
    }
    function reenableLogs() {
      disabledDepth--;
      if (0 === disabledDepth) {
        var props = { configurable: true, enumerable: true, writable: true };
        Object.defineProperties(console, {
          log: assign({}, props, { value: prevLog }),
          info: assign({}, props, { value: prevInfo }),
          warn: assign({}, props, { value: prevWarn }),
          error: assign({}, props, { value: prevError }),
          group: assign({}, props, { value: prevGroup }),
          groupCollapsed: assign({}, props, { value: prevGroupCollapsed }),
          groupEnd: assign({}, props, { value: prevGroupEnd })
        });
      }
      0 > disabledDepth && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function describeBuiltInComponentFrame(name) {
      if (void 0 === prefix)
        try {
          throw Error();
        } catch (x) {
          var match = x.stack.trim().match(/\n( *(at )?)/);
          prefix = match && match[1] || "";
          suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
      if (!fn || reentry) return "";
      var frame2 = componentFrameCache.get(fn);
      if (void 0 !== frame2) return frame2;
      reentry = true;
      frame2 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var previousDispatcher = null;
      previousDispatcher = ReactSharedInternals.H;
      ReactSharedInternals.H = null;
      disableLogs();
      try {
        var RunInRootFrame = {
          DetermineComponentFrameRoot: function() {
            try {
              if (construct) {
                var Fake = function() {
                  throw Error();
                };
                Object.defineProperty(Fake.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                });
                if ("object" === typeof Reflect && Reflect.construct) {
                  try {
                    Reflect.construct(Fake, []);
                  } catch (x) {
                    var control = x;
                  }
                  Reflect.construct(fn, [], Fake);
                } else {
                  try {
                    Fake.call();
                  } catch (x$0) {
                    control = x$0;
                  }
                  fn.call(Fake.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (x$1) {
                  control = x$1;
                }
                (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
                });
              }
            } catch (sample) {
              if (sample && control && "string" === typeof sample.stack)
                return [sample.stack, control.stack];
            }
            return [null, null];
          }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name"
        );
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
          var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
          for (_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes(
            "DetermineComponentFrameRoot"
          ); )
            namePropDescriptor++;
          for (; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes(
            "DetermineComponentFrameRoot"
          ); )
            _RunInRootFrame$Deter++;
          if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length)
            for (namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]; )
              _RunInRootFrame$Deter--;
          for (; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)
            if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
              if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                do
                  if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    var _frame = "\n" + sampleLines[namePropDescriptor].replace(
                      " at new ",
                      " at "
                    );
                    fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                    "function" === typeof fn && componentFrameCache.set(fn, _frame);
                    return _frame;
                  }
                while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
              }
              break;
            }
        }
      } finally {
        reentry = false, ReactSharedInternals.H = previousDispatcher, reenableLogs(), Error.prepareStackTrace = frame2;
      }
      sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
      "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
      return sampleLines;
    }
    function describeUnknownElementTypeFrameInDEV(type) {
      if (null == type) return "";
      if ("function" === typeof type) {
        var prototype = type.prototype;
        return describeNativeComponentFrame(
          type,
          !(!prototype || !prototype.isReactComponent)
        );
      }
      if ("string" === typeof type) return describeBuiltInComponentFrame(type);
      switch (type) {
        case REACT_SUSPENSE_TYPE:
          return describeBuiltInComponentFrame("Suspense");
        case REACT_SUSPENSE_LIST_TYPE:
          return describeBuiltInComponentFrame("SuspenseList");
      }
      if ("object" === typeof type)
        switch (type.$$typeof) {
          case REACT_FORWARD_REF_TYPE:
            return type = describeNativeComponentFrame(type.render, false), type;
          case REACT_MEMO_TYPE:
            return describeUnknownElementTypeFrameInDEV(type.type);
          case REACT_LAZY_TYPE:
            prototype = type._payload;
            type = type._init;
            try {
              return describeUnknownElementTypeFrameInDEV(type(prototype));
            } catch (x) {
            }
        }
      return "";
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function hasValidKey(config) {
      if (hasOwnProperty.call(config, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, self, source, owner, props) {
      self = props.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props,
        _owner: owner
      };
      null !== (void 0 !== self ? self : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config, maybeKey, isStaticChildren, source, self) {
      if ("string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE$1 || void 0 !== type.getModuleId)) {
        var children = config.children;
        if (void 0 !== children)
          if (isStaticChildren)
            if (isArrayImpl(children)) {
              for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
                validateChildKeys(children[isStaticChildren], type);
              Object.freeze && Object.freeze(children);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else validateChildKeys(children, type);
      } else {
        children = "";
        if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length)
          children += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
        null === type ? isStaticChildren = "null" : isArrayImpl(type) ? isStaticChildren = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (isStaticChildren = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", children = " Did you accidentally export a JSX literal instead of a component?") : isStaticChildren = typeof type;
        console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          isStaticChildren,
          children
        );
      }
      if (hasOwnProperty.call(config, "key")) {
        children = getComponentNameFromType(type);
        var keys = Object.keys(config).filter(function(k) {
          return "key" !== k;
        });
        isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
      if ("key" in config) {
        maybeKey = {};
        for (var propName in config)
          "key" !== propName && (maybeKey[propName] = config[propName]);
      } else maybeKey = config;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(type, children, self, source, getOwner(), maybeKey);
    }
    function validateChildKeys(node, parentType) {
      if ("object" === typeof node && node && node.$$typeof !== REACT_CLIENT_REFERENCE) {
        if (isArrayImpl(node))
          for (var i = 0; i < node.length; i++) {
            var child = node[i];
            isValidElement2(child) && validateExplicitKey(child, parentType);
          }
        else if (isValidElement2(node))
          node._store && (node._store.validated = 1);
        else if (null === node || "object" !== typeof node ? i = null : (i = MAYBE_ITERATOR_SYMBOL && node[MAYBE_ITERATOR_SYMBOL] || node["@@iterator"], i = "function" === typeof i ? i : null), "function" === typeof i && i !== node.entries && (i = i.call(node), i !== node))
          for (; !(node = i.next()).done; )
            isValidElement2(node.value) && validateExplicitKey(node.value, parentType);
      }
    }
    function isValidElement2(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function validateExplicitKey(element, parentType) {
      if (element._store && !element._store.validated && null == element.key && (element._store.validated = 1, parentType = getCurrentComponentErrorInfo(parentType), !ownerHasKeyUseWarning[parentType])) {
        ownerHasKeyUseWarning[parentType] = true;
        var childOwner = "";
        element && null != element._owner && element._owner !== getOwner() && (childOwner = null, "number" === typeof element._owner.tag ? childOwner = getComponentNameFromType(element._owner.type) : "string" === typeof element._owner.name && (childOwner = element._owner.name), childOwner = " It was passed a child from " + childOwner + ".");
        var prevGetCurrentStack = ReactSharedInternals.getCurrentStack;
        ReactSharedInternals.getCurrentStack = function() {
          var stack = describeUnknownElementTypeFrameInDEV(element.type);
          prevGetCurrentStack && (stack += prevGetCurrentStack() || "");
          return stack;
        };
        console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          parentType,
          childOwner
        );
        ReactSharedInternals.getCurrentStack = prevGetCurrentStack;
      }
    }
    function getCurrentComponentErrorInfo(parentType) {
      var info = "", owner = getOwner();
      owner && (owner = getComponentNameFromType(owner.type)) && (info = "\n\nCheck the render method of `" + owner + "`.");
      info || (parentType = getComponentNameFromType(parentType)) && (info = "\n\nCheck the top-level render call using <" + parentType + ">.");
      return info;
    }
    var React2 = React__default, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE$2 = Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty = Object.prototype.hasOwnProperty, assign = Object.assign, REACT_CLIENT_REFERENCE$1 = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = true;
    var prefix, suffix, reentry = false;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var didWarnAboutKeySpread = {}, ownerHasKeyUseWarning = {};
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development.jsx = function(type, config, maybeKey, source, self) {
      return jsxDEVImpl(type, config, maybeKey, false, source, self);
    };
    reactJsxRuntime_development.jsxs = function(type, config, maybeKey, source, self) {
      return jsxDEVImpl(type, config, maybeKey, true, source, self);
    };
  }();
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
const lawFirmImg = "images/pages/";
const adStyles = {
  container: {
    width: "auto",
    height: "360px",
    borderRadius: "8px",
    overflow: "hidden",
    fontFamily: "Arial, sans-serif",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box"
  },
  img: {
    width: "100%",
    height: "140px",
    objectFit: "cover"
  },
  content: {
    padding: "12px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  headline: {
    fontSize: "16px",
    margin: "0 0 6px"
  },
  text: {
    fontSize: "13px",
    color: "#333",
    margin: 0
  },
  button: {
    display: "block",
    textAlign: "center",
    color: "#fff",
    textDecoration: "none",
    padding: "8px 0",
    borderRadius: "4px",
    fontSize: "14px",
    marginTop: "10px"
  }
};
const AdVariation1 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...adStyles.container, border: "1px solid #ddd", background: "#fff" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lawFirmImg + "law1.jpeg", alt: "Law Firm", style: adStyles.img }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: adStyles.content, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { style: { ...adStyles.headline, color: "#d32f2f" }, children: "Johnson & Meyers Legal" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: adStyles.text, children: "Injured by a recalled product? Our experienced attorneys fight for your rights. Free case evaluation today." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://recalls.me/contact", style: { ...adStyles.button, background: "#d32f2f" }, children: "Free Case Review" })
  ] })
] });
const AdVariation2 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...adStyles.container, background: "#fef5f5", border: "1px solid #e0e0e0" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lawFirmImg + "law2.jpeg", alt: "Law Firm", style: adStyles.img }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: adStyles.content, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { style: { ...adStyles.headline, color: "#b71c1c" }, children: "Parker & Lee Attorneys" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: adStyles.text, children: "🚨 Recalled product injury? Act fast — deadlines apply. No fees unless we win." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://recalls.me/contact", style: { ...adStyles.button, background: "#b71c1c" }, children: "Start My Case" })
  ] })
] });
const AdVariation3 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...adStyles.container, background: "#fafafa", border: "2px solid #e0e0e0" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lawFirmImg + "law3.jpeg", alt: "Law Firm", style: adStyles.img }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: adStyles.content, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { style: { ...adStyles.headline, color: "#2e7d32" }, children: "Greenberg Legal Group" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: adStyles.text, children: "Trusted in product recall cases nationwide. Free consultation. Proven track record." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://recalls.me/contact", style: { ...adStyles.button, background: "#2e7d32" }, children: "Get Legal Help" })
  ] })
] });
const AdVariation4 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...adStyles.container, background: "#f4f4f4", border: "2px solid #e0e0e0" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lawFirmImg + "law3.jpeg", alt: "Law Firm", style: adStyles.img }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: adStyles.content, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { style: { ...adStyles.headline, color: "#2e7dff" }, children: "Humble Group" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: adStyles.text, children: "Trusted in product recall cases nationwide. Free consultation. Proven track record." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://recalls.me/contact", style: { ...adStyles.button, background: "#2e7dff" }, children: "Get Humble Help" })
  ] })
] });
const AdVariation5 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...adStyles.container, background: "#f7f7f7", border: "2px solid #e0e0e0" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lawFirmImg + "law2.jpeg", alt: "Law Firm", style: adStyles.img }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: adStyles.content, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { style: { ...adStyles.headline, color: "#2efdff" }, children: "Action Group" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: adStyles.text, children: "Trusted in product recall cases nationwide. Free consultation. Proven track record." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://recalls.me/contact", style: { ...adStyles.button, background: "#2efdff" }, children: "Get Action Group to take action now" })
  ] })
] });
const unclaimed = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      KImage,
      {
        width: "100%",
        style: { objectFit: "scale-down", backgroundColor: "white" },
        src: "/images/claim/Unclaimed.jpg",
        alt: "Unclaimed Property Image"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { align: "center", children: "Unclaimed Property" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { align: "center", style: { color: "#339933" }, children: "Your state treasury has $Billions in unclaimed money and property." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { fontSize: "1.2rem", padding: 0, margin: 0 }, children: "Have you checked?" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { fontSize: "1.2rem", padding: 0, margin: 0 }, children: "It's your money and will remain yours until you file a claim." }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { align: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "claim", children: "How To Claim " }),
        "   that is rightly yours!"
      ] })
    ] })
  ] });
};
const donate = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PromoteDonate, { promoteFor: "advert" });
};
const adList = [
  { ad: /* @__PURE__ */ jsxRuntimeExports.jsx(AdVariation1, {}), state: "Test State", zone: "" },
  { ad: /* @__PURE__ */ jsxRuntimeExports.jsx(AdVariation2, {}), state: "Test State", zone: "" },
  { ad: /* @__PURE__ */ jsxRuntimeExports.jsx(AdVariation3, {}), state: "Test State", zone: "" },
  { ad: /* @__PURE__ */ jsxRuntimeExports.jsx(AdVariation4, {}), state: "Test State", zone: "" },
  { ad: /* @__PURE__ */ jsxRuntimeExports.jsx(AdVariation5, {}), state: "Test State", zone: "" }
];
function getRandomInt(min, max, exclusions) {
  min = Math.ceil(min);
  max = Math.floor(max);
  let val = Math.floor(Math.random() * (max - min + 1)) + min;
  if (exclusions && exclusions.includes(val)) {
    val = getRandomInt(min, max, exclusions);
  }
  return val;
}
function getRandomIntList(min, max, count) {
  console.log(`advertSvc:getRandomeIntList: min: ${min}, max: ${max}, count: ${count}`);
  const exclusions = [];
  for (let i = 0; i < count; i++) {
    const rand = getRandomInt(min, max, exclusions);
    exclusions.push(rand);
  }
  return exclusions;
}
const routeAds = [
  {
    route: "/recall",
    options: { left: false, right: true, bottom: false, isAdSmall: false, isLawAd: false }
  },
  {
    route: "/recent",
    options: { left: false, right: true, bottom: false, isAdSmall: true, isLawAd: true, count: 13 }
  },
  {
    route: "/myrecalls",
    options: { left: false, right: true, bottom: false, isAdSmall: true, isLawAd: true, count: 13 }
  },
  {
    route: "/myrecalls:slider",
    options: { left: false, right: true, bottom: false, isAdSmall: true, isLawAd: true, count: 2 }
  },
  {
    route: "/myrecalls:listOrTable",
    options: { left: false, right: true, bottom: false, isAdSmall: true, isLawAd: true, count: 2 }
  }
];
const isAds = (route, userState, testAds) => {
  console.log(`advertSvc:isAds - route: ${route}, userState: ${userState}`);
  if (!route) return null;
  const routeAds2 = getAds(route, userState, testAds);
  return routeAds2 && routeAds2.length || 0;
};
const getAdSpec = (route, userState, testAds) => {
  console.log(`advertSvc:getAdSpec - route: ${route}, userState: ${userState}`);
  if (!route) return null;
  let routeSpec = null;
  if (route) {
    routeSpec = routeAds.find((r2) => r2.route === route);
  }
  if (routeSpec) {
    if (routeSpec.options.isLawAd) {
      let stateAdsFull = null;
      if (testAds) {
        stateAdsFull = adList.filter((ad) => ad.state == testAds);
      } else {
        stateAdsFull = adList.filter((ad) => ad.state == userState);
      }
      return routeSpec && stateAdsFull && stateAdsFull.length ? routeSpec : null;
    } else {
      return routeSpec;
    }
  }
  return null;
};
const getAds = (route, userState, testAds) => {
  console.log(`advertSvc:getAds - route: ${route}, userState: ${userState}, testAds: ${testAds}`);
  if (!route) return null;
  let routeSpec = routeAds.find((r2) => r2.route === route);
  if (routeSpec) {
    if (routeSpec.options.isLawAd) {
      if (userState) {
        let stateAdsFull = null;
        if (testAds) {
          stateAdsFull = adList.filter((ad) => ad.state == testAds);
        } else {
          stateAdsFull = adList.filter((ad) => ad.state == userState);
        }
        const count = routeSpec.options.count;
        const stateAds = [];
        if (stateAdsFull && stateAdsFull.length && stateAdsFull.length > count) {
          const ndxList = getRandomIntList(0, stateAdsFull.length - 1, count);
          console.log("advertSvc:getAds: ndxList", ndxList);
          ndxList.forEach((i) => stateAds.push(stateAdsFull[i]));
          return stateAds;
        } else {
          return stateAdsFull;
        }
      } else {
        return null;
      }
    } else {
      if (route == "/recall") {
        const adRegList2 = [
          { ad: donate() },
          { ad: unclaimed() }
        ];
        return adRegList2;
      }
      return null;
    }
  } else {
    return null;
  }
};
const advertSvc = {
  // is there any ads for current user - state
  isAds: (route, userState, testAds) => {
    return isAds(route, userState, testAds);
  },
  getAdSpec: (route, userState, testAds) => {
    return getAdSpec(route, userState, testAds);
  },
  getAds: (route, userState, testAds) => {
    return getAds(route, userState, testAds);
  }
};
const Advert = (props) => {
  const { route } = props;
  const { appState, dispatch } = useAppContext();
  console.log("Advert: testAds " + appState.testAds);
  const userState = appState.loc.state;
  const stateAds = advertSvc.getAds(route, userState, appState.testAds);
  let ads = null;
  ads = stateAds && stateAds.map((f, i) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 1, maxWidth: 400, marginLeft: "auto", marginRight: "auto", marginBottom: "8px" }, "data-where": "Advert", children: f.ad }, "ad-" + i);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: ads });
};
const PromoteDonate = (props) => {
  const theme = useTheme();
  const { promoteFor } = props;
  const hdr1 = "Help us to spread awareness about recalled products.";
  const prob1 = "The magnitude of faulty products circulating out there is enormous. If we don’t educate ourselves and stay informed, this will be our warning sign for troubles ahead, for our families and to the public.";
  const cause1 = "We are on a mission to create a more informed public. To make that happen, we need you to do something extraordinary: Donate.";
  const cause2 = "Your contributions will help sustain this site and keep the public informed and safe.";
  const prob2 = "Can You Help?";
  const btn1 = "Yes, I'll Donate";
  const Hdr = (props2) => {
    const { msg } = props2;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", children: msg });
  };
  const Prob = (props2) => {
    const { msg } = props2;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", sx: { pt: 2 }, children: msg });
  };
  const Cause = (props2) => {
    const { msg } = props2;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "p", sx: { mt: 1, display: "block" }, children: msg });
  };
  if (typeof window !== "undefined") useNavigate();
  const Btn = (props2) => {
    const { msg } = props2;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { marginTop: "1.0rem", fontWeight: 600, fontSize: "1.6rem", textAlign: "center" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "donate", children: msg }),
      " "
    ] });
  };
  let content = null;
  const borderBoxProp = {
    // textAlign: 'center',
    m: 0,
    p: 2,
    border: `1px dotted ${theme.palette.secondary.main}`
    //maxWidth: '90%',
  };
  switch (promoteFor) {
    case "myrecalls":
      content = /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { ...borderBoxProp }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Hdr, { msg: hdr1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Prob, { msg: prob1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Cause, { msg: cause1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Cause, { msg: cause2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Prob, { msg: prob2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Btn, { msg: btn1 })
      ] });
      break;
    case "advert":
      content = /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { ...borderBoxProp }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Hdr, { msg: hdr1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Prob, { msg: prob1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Cause, { msg: cause1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Cause, { msg: cause2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Prob, { msg: prob2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Btn, { msg: btn1 })
      ] });
      break;
    default:
      content = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h1", { children: [
        "PROMOTION Not Found For Request: ",
        promoteFor
      ] }) });
      break;
  }
  return content;
};
function AccountOidc(props) {
  useTheme();
  const auth = useAuth();
  const { appState, dispatch } = useAppContext();
  const getEnvVar2 = appState.getEnvVar;
  const trialDays = appState.trialDays;
  let accountCreateMsg = "";
  let accountExpMsg = "";
  let accountTrialExpDate = "";
  const accountCreateDate = appState.account && appState.account.createdAt ? new Date(appState.account.createdAt) : null;
  if (accountCreateDate) {
    accountCreateMsg = `Account created on ${accountCreateDate.toLocaleDateString("en-US")}`;
    accountTrialExpDate = new Date(accountCreateDate.getTime() + trialDays * 24 * 60 * 60 * 1e3);
    accountExpMsg = appState.isTrial ? `Trial period (${trialDays} days) expires on ${accountTrialExpDate.toLocaleDateString("en-US")}` : `Trial period (${trialDays} days) expired`;
  }
  const [email, setEmail] = useState("");
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  let msg = null;
  if (auth.isLoading) {
    msg = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Loading..." });
  }
  if (auth.error) {
    msg = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      "Oops... Sign In ",
      auth.error.message
    ] });
  }
  let helperText, btnSX = {}, btnDisabled = false;
  helperText = `By signing in, you agree to web site's Terms of Service and Privacy Policy.`;
  const signin = CreateFabOrButton("button", "Sign In", "external", null, "_blank", [0, 0, 0, 0, 0, 0], () => void auth.signinRedirect(), btnDisabled, btnSX, helperText, "50%");
  helperText = "By signing out, you are disconnecting from all products and services offered by Kripa, Inc.";
  const signout = CreateFabOrButton("button", "Sign Out", "external", null, "_blank", [0, 0, 0, 0, 0, 0], () => void auth.removeUser(), btnDisabled, btnSX, helperText, "70%");
  helperText = `By signing up, you agree to web site's Terms of Service and Privacy Policy.`;
  const signupUrl = getEnvVar2.signupUrl;
  const signup = CreateFabOrButton("button", "Sign Up", "external", signupUrl, "_blank", [0, 0, 0, 0, 0, 0], null, btnDisabled, btnSX, helperText, "50%");
  helperText = "Click to retrieve id/password from authentication application.";
  const forgotUrl = getEnvVar2.forgotPwdUrl;
  const forgot = CreateFabOrButton("button", "Forgot Id/Password", "external", forgotUrl, "_blank", [0, 0, 0, 0, 0, 0], null, btnDisabled, btnSX, helperText, "50%");
  helperText = "Click to visit authentication application to change id/password.";
  const chgidpwdUrl = getEnvVar2.changeEmailPwdUrl;
  const chgidpwd = CreateFabOrButton("button", "Change Id/Password", "external", chgidpwdUrl, "_blank", [0, 0, 0, 0, 0, 0], null, btnDisabled, btnSX, helperText, "50%");
  helperText = "Click to visit authentication application.";
  const dashboardUrl = getEnvVar2.authDashboardUrl;
  const dashboard = CreateFabOrButton("button", "Auth Dashboard", "external", dashboardUrl, "_blank", [0, 0, 0, 0, 0, 0], null, btnDisabled, btnSX, helperText, "50%");
  helperText = "Click to manage account, subscription and team members.";
  const isTemmgmtApp = getEnvVar2.APP_CODE === "SCUR";
  const teammgmtUrl = `${getEnvVar2.SCUR_APP_URL}/?nav=subscriptions&display=RecallsMe`;
  const teammgmt = CreateFabOrButton("button", "Team Web App", "external", teammgmtUrl, "_blank", [0, 0, 0, 0, 0, 0], null, btnDisabled, btnSX, helperText, "50%");
  const info = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: "Account Details" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Username: ",
      auth.user?.profile.preferred_username
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Auth Id: ",
      auth.user?.profile.sub
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Name: ",
      auth.user?.profile.given_name
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Authentication Expiry: ",
      new Date(auth.user?.profile.exp * 1e3).toLocaleString(),
      " "
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Session Expiry: ",
      new Date(auth.user?.expires_at * 1e3).toLocaleString(),
      "(auto renewed)"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: accountCreateMsg }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: accountExpMsg }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
  ] });
  const subscriptions = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubscriptions, { caller: "AccountOidc" }) });
  let intro = null;
  if (isClient) {
    let userid;
    if (auth.isAuthenticated) {
      userid = auth.user?.profile.email;
      intro = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: `You are signed in as: ${userid}` }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { children: msg }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { children: info })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6, md: 6, lg: !isTemmgmtApp ? 3 : 4 }, children: signout }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6, md: 6, lg: !isTemmgmtApp ? 3 : 4 }, children: chgidpwd }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6, md: 6, lg: !isTemmgmtApp ? 3 : 4 }, children: dashboard }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6, md: 6, lg: !isTemmgmtApp ? 3 : 4 }, children: !isTemmgmtApp ? teammgmt : null }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: subscriptions })
      ] });
    } else {
      userid = appState.fpid;
      intro = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: `You are using a pre-assigned anonymous id: ${userid}` }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              `Anonymous access has only a limited set of features available. For a feature full experience please `,
              /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "Sign In" }),
              `.`
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: accountCreateMsg })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { children: msg })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 4, md: 3, lg: !isTemmgmtApp ? 3 : 4 }, children: signin }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 4, md: 3, lg: !isTemmgmtApp ? 3 : 4 }, children: signup }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 4, md: 6, lg: !isTemmgmtApp ? 3 : 4 }, children: forgot }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: subscriptions })
      ] });
    }
  } else {
    intro = /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: `You are signed in as: ` });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, justifyContent: "center", sx: { padding: 2 }, spacing: 2, children: intro });
}
function AccountPermissions() {
  const { appState, dispatch } = useAppContext();
  appState.appMembers;
  appState.isSignIn;
  appState.permission;
  appState.upap && appState.upap?.members;
  const permissions = /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Account permissions are not setup." });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: permissions });
}
function AccountPreferences() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Account preferences are not setup." }) });
}
const genMuiThemes = (options2) => {
  const {
    fontHeader,
    fontText,
    primaryLight,
    secondaryLight = "#9c27b0",
    panelBgLight,
    backpanelBgLight,
    contentpanelBgLight,
    primaryDark,
    secondaryDark = "#ce93d8",
    panelBgDark,
    backpanelBgDark,
    contentpanelBgDark,
    pagePadding = 2,
    pageGap = 1,
    // For use within pages.ts (rendered via PageContentFormat.jsx)
    // 5 sets of areas. Each set having { panel: , border: }
    areaLight,
    areaDark,
    borderLight = "#000000",
    // Used for FORM container border
    borderDark = "#ffffff"
    // Used for FORM container border
  } = options2;
  const customBaseTheme = {
    // pageGap is used for gap in between sections and viewport edge
    // emert site IS using page gaps. The banner image has border
    pagePadding,
    pageGap,
    //1.0, // [4, 5, 6, 8, 10],   // { xs:'0.5', sm:'0.62', md:'0.75', lg:'1.0', xl:'1.2'},
    // section gap is used inside a section - in between areas
    sectionGap: [1.3, 1.55, 1.8, 2.05, 2.3],
    // 1.0 === '8px'
    // area gap is used inside an area
    areaGap: [1, 1.25, 1.5, 1.75, 2],
    // 1.0 === '8px'
    btnPadding: [1, 1.25, 1.5, 1.75, 2],
    // 1.0 === '8px'
    btnFont: ["80%", "90%", "100%", "110%", "130%"],
    btnSpacing: ["0.2em", "0.3em", "0.4em", "0.5em", "06em"],
    bannerMinHeight: ["46vh", "44vh", "44vh", "44vh", "44vh"]
    //                  0       600     900     1200   1536   
  };
  const customLightTheme = {
    custom: {
      ...customBaseTheme,
      backpanelBG: backpanelBgLight,
      //'#FCFCFC', // Dark BG; Sections are layed on top; Named as Primary Light; Also, used by FORM to border containers(Collapsable, Tab)
      contentpanelBG: contentpanelBgLight,
      panelBg: panelBgLight,
      // emert landing page cards panel bg
      area: areaLight,
      // used only by PageContentFormat.jsx via sitePageData.ts
      border: borderLight
      // Used to draw border around FORM containers
    }
  };
  const customDarkTheme = {
    custom: {
      ...customBaseTheme,
      backpanelBG: backpanelBgDark,
      // Dark BG; Sections are layed on top; Named as Primary Light
      contentpanelBG: contentpanelBgDark,
      panelBg: panelBgDark,
      // should match darkTheme primary main
      area: areaDark,
      // used only by PageContentFormat.jsx via sitePageData.ts
      border: borderDark
      // Used to draw border around FORM containers
    }
  };
  const typo = {
    typography: {
      fontFamily: [fontText, "Helvetica", "Arial", "sans-serif"].join(","),
      h1: {
        fontFamily: [fontHeader, "Helvetica", "Arial", "sans-serif"].join(","),
        fontSize: "2.4rem"
        //3.4   '4.0rem',
      },
      h2: {
        fontFamily: [fontHeader, "Helvetica", "Arial", "sans-serif"].join(","),
        fontSize: "2.0rem"
        //2.6   '3.2rem',
      },
      h3: {
        fontFamily: [fontHeader, "Helvetica", "Arial", "sans-serif"].join(","),
        fontSize: "2.0rem",
        //2.6   '2.6rem',
        fontStyle: "italic"
      },
      h4: {
        fontFamily: [fontHeader, "Helvetica", "Arial", "sans-serif"].join(","),
        fontSize: "1.6rem"
        // 2.0   '2.0rem',
      },
      h5: {
        fontFamily: [fontHeader, "Helvetica", "Arial", "sans-serif"].join(","),
        fontSize: "1.6rem",
        // 2.0
        fontStyle: "ialic"
      },
      h6: {
        fontFamily: [fontHeader, "Helvetica", "Arial", "sans-serif"].join(","),
        fontSize: "1.2rem"
        // 1.5
      }
    }
  };
  const lightTheme = createTheme$2({
    palette: {
      mode: "light",
      primary: {
        main: primaryLight
      },
      secondary: {
        main: secondaryLight
      }
    },
    ...customLightTheme,
    ...typo
  });
  const darkTheme = createTheme$2({
    palette: {
      mode: "dark",
      primary: {
        main: primaryDark
      },
      secondary: {
        main: secondaryDark
      }
    },
    ...customDarkTheme,
    ...typo
  });
  return { "dark": darkTheme, "light": lightTheme };
};
const ThemeEditor = (props) => {
  const { appTheme, setAppTheme } = props;
  const [done, setDone] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const initPrimary = darkMode ? appTheme.dark.palette.primary.main : appTheme.light.palette.primary.main;
  const initSecondary = darkMode ? appTheme.dark.palette.secondary.main : appTheme.light.palette.secondary.main;
  const initBackpanelBG = darkMode ? appTheme.dark.custom.backpanelBG : appTheme.light.custom.backpanelBG;
  const initContentPaneBG = darkMode ? appTheme.dark.custom.contentpaneBG : appTheme.light.custom.contentpaneBG;
  const [primaryColor, setPrimaryColor] = useState(initPrimary);
  const [secondaryColor, setSecondaryColor] = useState(initSecondary);
  const [backpanelBGColor, setBackpanelBGColor] = useState(initBackpanelBG);
  const [contentpanelBGColor, setContentPaneBGColor] = useState(initContentPaneBG);
  const setTheme = (flag) => {
    const newTheme = Object.assign({}, appTheme);
    setDone(flag);
    if (flag) {
      setAppTheme(newTheme);
      console.log(`ThemeEditor light color settings: primary: ${newTheme.light.palette.primary.main}, secondary: ${newTheme.light.palette.secondary.main}, backpanelBG: ${newTheme.light.custom.backpanelBG}, contentpanelBG: ${newTheme.light.custom.contentpanelBG}`);
      console.log(`ThemeEditor dark color settings: primary: ${newTheme.dark.palette.primary.main}, secondary: ${newTheme.dark.palette.secondary.main}, backpanelBG: ${newTheme.dark.custom.backpanelBG}, contentpanelBG: ${newTheme.dark.custom.contentpanelBG}`);
    }
  };
  const setColor2 = (color2, type) => {
    if (darkMode) {
      if (type == "p") {
        appTheme.dark.palette.primary.main = color2;
      } else if (type == "s") {
        appTheme.dark.palette.secondary.main = color2;
      } else if (type == "b") {
        appTheme.dark.custom.backpanelBG = color2;
      } else if (type == "c") {
        appTheme.dark.custom.contentpanelBG = color2;
      }
    } else {
      if (type == "p") {
        appTheme.light.palette.primary.main = color2;
      } else if (type == "s") {
        appTheme.light.palette.secondary.main = color2;
      } else if (type == "b") {
        appTheme.light.custom.backpanelBG = color2;
      } else if (type == "c") {
        appTheme.light.custom.contentpanelBG = color2;
      }
    }
    if (type == "p") setPrimaryColor(color2);
    else if (type == "s") setSecondaryColor(color2);
    else if (type == "b") setBackpanelBGColor(color2);
    else setContentPaneBGColor(color2);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box$1,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        gap: 2,
        p: 3,
        bgcolor: "background.default",
        color: "text.primary"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextField,
          {
            label: "Primary",
            type: "color",
            value: primaryColor,
            sx: { width: "100px", input: { fontSize: "2rem" } },
            onChange: (e) => setColor2(e.target.value, "p")
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextField,
          {
            label: "Secondary",
            type: "color",
            value: secondaryColor,
            onChange: (e) => setColor2(e.target.value, "s"),
            sx: { width: "100px", input: { fontSize: "2rem" } }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextField,
          {
            label: "Backpanel",
            type: "color",
            value: backpanelBGColor,
            onChange: (e) => setColor2(e.target.value, "b"),
            sx: { width: "100px", input: { fontSize: "2rem" } }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextField,
          {
            label: "Contentpanel",
            type: "color",
            value: contentpanelBGColor,
            onChange: (e) => setColor2(e.target.value, "c"),
            sx: { width: "100px", input: { fontSize: "2rem" } }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormControlLabel,
          {
            control: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Switch,
              {
                checked: darkMode,
                onChange: (e) => setDarkMode(e.target.checked)
              }
            ),
            label: "Dark Mode",
            sx: { width: "140px" }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormControlLabel,
          {
            control: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Switch,
              {
                checked: done,
                onChange: (e) => setTheme(e.target.checked)
              }
            ),
            label: "Done",
            sx: { width: "100px" }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { p: 2, bgcolor: { primaryColor }, color: "white", width: "100px" }, children: "secondary" })
      ]
    }
  );
};
function CowIcon(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 35.67 47", ...props, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: ".CowIcon_svg__cls-1{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.CowIcon_svg__cls-2{fill:#333}" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "CowIcon_svg__Layer_2", "data-name": "Layer 2", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "CowIcon_svg__Layer_2-2", "data-name": "Layer 2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          className: "CowIcon_svg__cls-1",
          d: "M28.2 5.79a14.48 14.48 0 012 2.94M9.15 3.74A14.11 14.11 0 0117.5 1a14.09 14.09 0 018.42 2.79M4.85 8.78A14.6 14.6 0 017.4 5.26M6.83 35.4a14.2 14.2 0 01-3.65-9.57V15.69a15.31 15.31 0 01.21-2.55M24.83 38.08a12.85 12.85 0 01-6.42 1.7h-1.82A12.93 12.93 0 0110.07 38M31.69 13.63a15.49 15.49 0 01.14 2.06v10.14a14.22 14.22 0 01-3.63 9.55M21.92 28a1 1 0 00.86-.48 33.8 33.8 0 003.89-13.77 9.08 9.08 0 00-9-9.09 9.11 9.11 0 00-9 9.13 33.61 33.61 0 003.88 13.73 1 1 0 00.86.48zM15.83 28v-2M19.83 28v-2"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          className: "CowIcon_svg__cls-1",
          d: "M9.67 9.09s-3-1.76-8.67 1.08c0 0 1.22 4.12 7.39 4.62M25.71 9.41s3.29-2.08 9 .76c0 0-1.67 4.16-7.84 4.66M13 6S8.67 3.44 7.21 2.62c0 0-.7 3.2 2.46 6.47M22.34 6s4.33-2.58 5.79-3.4c0 0 .7 3.2-2.47 6.47"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { className: "CowIcon_svg__cls-2", cx: 13.78, cy: 15.33, r: 1.16 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { className: "CowIcon_svg__cls-2", cx: 21.13, cy: 15.33, r: 1.16 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          className: "CowIcon_svg__cls-1",
          d: "M10.07 34v10.38A1.62 1.62 0 018.45 46a1.62 1.62 0 01-1.62-1.62V30M28.07 30v14.38A1.62 1.62 0 0126.45 46a1.62 1.62 0 01-1.62-1.62V34"
        }
      )
    ] }) })
  ] });
}
function MeatIcon(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21.1 10.5l.3-.2c.4-1 1.1-1.8 2-2.3h.1c0-.1-.1-.1-.1-.2-.4-.7-1-1.2-1.8-1.3-.8-.2-1.5-.1-2.2.3-.7.4-1.2 1.1-1.4 1.9l-.3.1c1.3.4 2.4 1 3.4 1.7z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M29.4 12.4c-.2-.3-.4-.5-.6-.7l-.3-.9c-.4-.7-1-1.2-1.8-1.3-.8-.2-1.5-.1-2.2.3-.7.4-1.2 1.1-1.4 1.9L21 12.9c-.2.1-.5.1-.7.1-1.3-.4-3.2 0-4.9 1-1.3.7-2.4 1.8-2.9 2.8-.2.3-.5.5-.9.5-.2 0-.3 0-.5-.1-.5-.3-.7-.9-.4-1.4.8-1.4 2.1-2.6 3.7-3.6 1.1-.6 2.3-1.1 3.4-1.3-1.5-.6-3.1-.9-4.8-.9-6.1 0-11 4.2-11 9.3C2 26 10.3 26 13 26c2.3 0 8.3 0 10.3-3.8l-.5.5c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.3-1 .1-1.4.9-.8 1.5-1.8 1.8-2.6.1-.3.3-.6.7-.7l2-1.2c.8.2 1.6.2 2.4-.3 1.3-.9 1.8-2.7 1-4.1z" })
  ] });
}
function KripaRedBallIcon(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 596 451",
      ...props,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "KripaRedBallIcon_svg__c", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 0, stopColor: "#999" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 1, stopColor: "#999", stopOpacity: 0 })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "KripaRedBallIcon_svg__b", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 0, stopColor: "#fff" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 1, stopColor: "#fff", stopOpacity: 0 })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "KripaRedBallIcon_svg__a", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 0, stopColor: "#770900" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 0.5, stopColor: "#da101b" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 0.75, stopColor: "#d2400f" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 0.938, stopColor: "#d44316", stopOpacity: 0.615 }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: 1, stopColor: "#c30000", stopOpacity: 0.219 })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "linearGradient",
            {
              xlinkHref: "#KripaRedBallIcon_svg__a",
              id: "KripaRedBallIcon_svg__e",
              x1: 154.286,
              y1: 535.219,
              x2: 605.714,
              y2: 535.219,
              gradientUnits: "userSpaceOnUse"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "radialGradient",
            {
              xlinkHref: "#KripaRedBallIcon_svg__c",
              id: "KripaRedBallIcon_svg__d",
              cx: 102.143,
              cy: 545.934,
              fx: 102.143,
              fy: 545.934,
              r: 135,
              gradientUnits: "userSpaceOnUse"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "radialGradient",
            {
              xlinkHref: "#KripaRedBallIcon_svg__b",
              id: "KripaRedBallIcon_svg__f",
              gradientUnits: "userSpaceOnUse",
              cx: 102.143,
              cy: 545.934,
              fx: 102.143,
              fy: 545.934,
              r: 135
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            transform: "matrix(1.45573 -.47633 .6458 1.07372 -270.65 -99.441)",
            d: "M237.143 545.934a135 135 0 11-270 0 135 135 0 11270 0z",
            fill: "url(#KripaRedBallIcon_svg__d)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M605.714 535.22a225.714 225.714 0 11-451.428 0 225.714 225.714 0 11451.428 0z",
            transform: "rotate(-132.295 234.41 414.566)",
            fill: "url(#KripaRedBallIcon_svg__e)"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M237.143 545.934a135 135 0 11-270 0 135 135 0 11270 0z",
            transform: "translate(68.54 -383.823)",
            opacity: 0.876,
            fill: "url(#KripaRedBallIcon_svg__f)"
          }
        )
      ]
    }
  );
}
function StethoscopeIcon(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M490.7 45.9C477.4 24.1 453.8 11 427.6 11c-11.2 0-20.3 9.1-20.3 20.3s9.1 20.3 20.3 20.3c11.9 0 22.5 5.8 28.4 15.4 5.3 8.6 5.7 18.7 1.4 27.7L391.6 202c-.3.4-.5.9-.8 1.3-5.5 10.8-16.5 17.3-29.3 17.3h-.2c-12.7 0-23.6-6.4-29.3-17-.2-.4-.5-.9-.8-1.3L263.8 95.1c-4.5-9-4.1-19.1 1.1-27.9 5.9-9.8 16.5-15.6 28.5-15.6 11.2 0 20.3-9.1 20.3-20.3s-9-20.3-20.2-20.3c-26.4 0-50 13.2-63.3 35.3-12.7 21.1-13.4 46.7-1.9 68.4.2.4.5.9.8 1.3l67.5 107.5c9.4 17.4 25.4 29.8 44.2 35.1v142.7c0 13.7-19.9 29-48.4 29S244 415 244 401.3V238.2c0-39.1-39.1-69.7-89.1-69.7-50 0-89.1 30.6-89.1 69.7v119.4c-31.7 8.8-54.8 37-54.8 70.3 0 40.3 33.8 73.1 75.3 73.1s75.3-32.8 75.3-73.1c0-33.6-23.5-62-55.5-70.5V238.2c0-13.7 19.9-29 48.4-29s48.4 15.3 48.4 29v164.2c0 .5 0 1.1.1 1.6 1.8 37.7 40.3 66.9 89 66.9 50 0 89.1-30.6 89.1-69.7V258.8c19.3-5.3 35.8-18.1 45.3-36l65.9-107.4c.3-.4.5-.9.8-1.3 11.3-21.9 10.4-47.3-2.4-68.2zM121 427.9c0 17.9-15.6 32.4-34.7 32.4s-34.7-14.6-34.7-32.4c0-17.9 15.6-32.4 34.7-32.4 19.2 0 34.7 14.5 34.7 32.4z" }) });
}
function kNavigateToPage(type, link, tab) {
  console.log("kNavigateToPage: redirect to URL: " + link);
  if (type === "internal") {
    redirect(link);
  } else if (type === "external") {
    const win = window.open(link, tab);
    win.focus();
  } else ;
}
const getPageMeta = (pageContext) => {
  const meta = {
    //isProd: pageContext._isProduction,  // true|false
    pageId: pageContext._pageId,
    // '/pages/about'
    exports: pageContext.exports,
    // { layout: , message: 'hello', Page: [Function: Page] },
    type: null,
    pagePath: null
  };
  const pageInfo = pageContext._pageFilesAll.find((item) => item.pageId === pageContext._pageId);
  if (pageInfo) {
    meta["type"] = pageInfo.filePath.includes("blog/index") ? "blogindex" : pageInfo.filePath.includes("blog") ? "blogpage" : pageInfo.filePath.includes("pages/index") ? "tsxindex" : pageInfo.filePath.includes(".mdx") ? "mdxpage" : "tsxpage";
    meta["pagePath"] = pageInfo.filePath;
  }
  return meta;
};
const Context = React__default.createContext(void 0);
function PageContextProvider({ pageContext, children }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context.Provider, { value: pageContext, children });
}
function usePageContext() {
  const pageContext = useContext(Context);
  return pageContext;
}
let isBrowser$3 = typeof window === "undefined" ? false : true;
let getEnvVar$1 = null;
const getPrefState = async () => {
  let livePref = null;
  let newState2 = {};
  if (getDisplayCommonLocalStore)
    livePref = getDisplayCommonLocalStore("pref");
  newState2["themeMode"] = livePref && livePref.themeMode || "light";
  newState2["isShowDraft"] = livePref && livePref.isShowDraft || false;
  return newState2;
};
const getFpidState = () => {
  const newState2 = {};
  let fpid = -1;
  if (isBrowser$3) {
    const fingerprint = new Identity({
      canvas: true,
      ie_activex: true,
      screen_resolution: true
    });
    fpid = fingerprint.get();
  }
  newState2["fpid"] = fpid;
  return newState2;
};
let locationData = null;
const detectVisitorLocation = async (initLocationData, appState) => {
  async function reverseGeocode(lat, lon) {
    console.log("AppContext:detectVisitorLocation - reverseGeoCode()");
    const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&addressdetails=1`);
    const data = await res.json();
    if (data && data.address) {
      return {
        city: data.address.city || data.address.town || data.address.village || null,
        county: data.address.county || null,
        state: data.address.state || null,
        zip: data.address.postcode || null
      };
    }
    return {};
  }
  async function getBrowserLocation() {
    console.log("AppContext:detectVisitorLocation -getBrowserLocation");
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) return reject("Geolocation not supported");
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
        (err) => reject(err.message),
        { enableHighAccuracy: true, timeout: 5e3 }
      );
    });
  }
  async function getIpLocation() {
    console.log("AppContext:detectVisitorLocation -getIpLocation");
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();
    return {
      lat: data.latitude,
      lon: data.longitude,
      city: data.city,
      state: data.region,
      zip: data.postal
    };
  }
  try {
    if (!locationData || !locationData.lat) {
      if (initLocationData && initLocationData.state) {
        locationData = initLocationData;
        return;
      }
      const coords = await getBrowserLocation();
      if (coords && coords.lat) {
        locationData = coords && coords.lat && await reverseGeocode(coords.lat, coords.lon);
      } else {
        locationData = await getIpLocation();
      }
    } else {
      console.log("AppContext:detectVisitorLocation - Already have a location", locationData);
      return;
    }
  } catch (err) {
    console.warn("AppContext:detectVisitorLocation - Browser location failed:", err, "Falling back to IP geolocation...");
    locationData = await getIpLocation();
  }
  if (locationData && locationData.state) {
    updateDisplayCommonLocalStore$1("pref", "pref", { themeMode: appState.themeMode, isShowDraft: appState.isShowDraft, loc: JSON.stringify(locationData) });
    return;
  } else {
    console.warn("AppContext:detectVisitorLocation - Unable to get location using browser location or ip location");
    return;
  }
};
const getUpapState = async (token, fpid, appCode, correlationid2, locationDataStr) => {
  let appMembers = [];
  let newState2 = {};
  let resp;
  try {
    resp = await myFetch(
      getEnvVar$1.UPAP_SVC,
      //getEnvVar.API_SRVR_URL + '/upap',
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token ? token : fpid}`,
          "X-Fpid": fpid,
          "X-Reqaccountno": "",
          "X-CorrelationId": correlationid2,
          "X-loc": btoa(btoa(locationDataStr))
        }
      }
    );
    if (resp.code === 200 && resp.data) {
      const t = (/* @__PURE__ */ new Date()).getTime();
      newState2["time"] = t;
      const upap = resp.data;
      newState2["isOnline"] = true;
      const user = upap && upap.user && new User(upap.user) || null;
      appMembers = upap && upap.members;
      let member = null;
      let memberNdx = -1;
      if (appMembers && appMembers.length) {
        member = appMembers.find((member2, i) => {
          if (member2.account.userNo == upap.user.userNo) {
            memberNdx = i;
            return true;
          } else return false;
        });
      }
      newState2["srvrVersion"] = upap.srvrVersion || "upap-srvr-hash";
      if (member) {
        newState2["upap"] = upap;
        newState2["user"] = user;
        newState2["preference"] = member.preference ? new Preferences(member.preference) : null;
        newState2["permission"] = member.premission ? new Permissions(member.premission) : null;
        newState2["account"] = member.account ? new Account(member.account, appCode) : null;
        newState2["apps"] = member.account.jsonProp["apps"] || null;
        newState2["subCode"] = getEnvVar$1.APP_CODE;
        newState2["plans"] = member.account.jsonProp["apps"][getEnvVar$1.APP_CODE] || null;
        const trialDays = 21;
        let accountTrialExpDate = "";
        let isTrialExpired = true;
        const account = newState2["account"];
        const accountCreateDate = account.createdAt ? new Date(account.createdAt) : null;
        if (accountCreateDate) {
          accountTrialExpDate = new Date(accountCreateDate.getTime() + trialDays * 24 * 60 * 60 * 1e3);
          isTrialExpired = accountTrialExpDate.getTime() < (/* @__PURE__ */ new Date()).getTime();
        }
        newState2["isTrial"] = !isTrialExpired;
        newState2["isPayment"] = true;
        newState2["trialDays"] = trialDays;
        newState2["appMembers"] = appMembers;
        newState2["memberNdx"] = memberNdx;
        newState2["token"] = token;
        newState2["fpid"] = fpid;
        newState2.isSignIn = !!token;
        const { xxxxUser, subCode, plans } = getAppCodeDtls(appCode, member);
        newState2["consumer"] = new Consumer(xxxxUser);
        newState2["consumerOrig"] = new Consumer(xxxxUser);
        newState2["xxxxUser"] = subCode === "RECL" ? new Consumer(xxxxUser) : subCode === "BITI" ? new BitiUser(xxxxUser) : subCode === "CRUD" ? new Formuser(xxxxUser) : null;
        newState2["xxxxUserOrig"] = subCode === "RECL" ? new Consumer(xxxxUser) : subCode === "BITI" ? new BitiUser(xxxxUser) : subCode === "CRUD" ? new Formuser(xxxxUser) : null;
        newState2["subCode"] = subCode;
        newState2["plans"] = plans;
        const activePlans = newState2["plans"] && newState2["plans"].filter((subDtls) => !subDtls.deenrollts);
        activePlans && activePlans.length && activePlans.sort(function(a, b) {
          return b.enrollts - a.enrollts;
        });
        newState2["plan"] = activePlans && activePlans.length ? activePlans[0] : null;
      } else {
        console.error("AppContext:getUpapState() - member not found for: " + appCode + ", Please check the account.jsonProp[apps] property");
        newState2["upap"] = null;
        newState2["user"] = null;
        newState2["preference"] = null;
        newState2["permission"] = null;
        newState2["account"] = null;
        newState2["appMembers"] = null;
        newState2["member"] = null;
        newState2.isSignIn = false;
        newState2["token"] = "";
        newState2["fpid"] = fpid;
        newState2["emsg"] = "Appliction access not authorized or expired";
        newState2["ecode"] = 401;
      }
    } else {
      console.error("AppContext:getUpapState() - application is online, have a token or fpid. Failed to authenticat/get upap");
      newState2["token"] = "";
      newState2["fpid"] = fpid;
      newState2["emsg"] = "HTTP 401 Authentication failed";
      newState2["ecode"] = 401;
    }
  } catch (e) {
    console.error("AppContext:getUpapState() - caught exception while issuing /upap call ", e);
  }
  return newState2;
};
const printBanner$1 = () => {
  let appCode = getEnvVar$1.APP_CODE;
  console.log("=====================================================================================");
  console.log("==                                                                                 ==");
  console.log(
    "== AppContext: *** !!! App: " + appCode + " - Mode: " + getEnvVar$1.RUN_ENV + " - Node Env: " + getEnvVar$1.NODE_ENV + " !!! ***       =="
  );
  console.log("==                                                                                 ==");
  console.log("=====================================================================================");
};
const appUpdtStateFn = async (origState) => {
  getEnvVar$1.APP_CODE;
  var error = new Error();
  var stack = error.stack;
  console.log(stack);
  console.log(stack);
  console.log(stack);
  console.log(stack);
  console.log(stack);
  console.log(stack);
  console.log(stack);
  if (isBrowser$3) {
    const prefState = await getPrefState();
    const fpidState = getFpidState(newState);
    const upapState = await getUpapState(newState);
    printBanner$1();
    if (!getEnvVar$1.RUN_ENV) {
      console.error("AppContext: *** INCORRECT ENV. VAR. SETUP or NOT AVAILABLE ***");
    }
    return { ...origState, ...prefState, ...fpidState, ...upapState };
  } else
    return {};
};
let correlationid = 1;
const PADZERO = 6;
const AppContext = React__default.createContext(void 0);
const AppProvider = ({ appInitState, getEnvVarObj, appReducer: appReducer2, children }) => {
  getEnvVar$1 = getEnvVarObj;
  const auth = useAuth();
  const fpidState = getFpidState();
  const authState = {};
  if (auth && auth.isAuthenticated) {
    authState["token"] = auth.user.id_token;
    authState["accessToken"] = auth.user.accessToken;
    authState["sub"] = auth.user.profile.sub;
    authState["email"] = auth.user.profile.email;
    authState["username"] = auth.user.profile.preferred_username;
  } else {
    authState["token"] = "";
    authState["accessToken"] = "";
    authState["sub"] = "";
    authState["email"] = "";
    authState["username"] = "";
  }
  const t = (/* @__PURE__ */ new Date()).getTime();
  authState["time"] = t;
  appInitState = { ...appInitState, ...fpidState, ...authState };
  const [appState, dispatch] = useReducer(appReducer2, appInitState);
  useEffect(() => {
    async function fetchData() {
      if (getEnvVar$1.UPAP_SVC && !getEnvVar$1.UPAP_SVC.includes("undefined")) {
        await detectVisitorLocation(appInitState.loc, appState);
        console.log("AppContext: detectVisitorLocation() - useEffect", locationData);
        const locationDataStr = JSON.stringify(locationData || "");
        const upapState = await getUpapState(
          authState.token,
          fpidState.fpid,
          getEnvVar$1.APP_CODE,
          (correlationid++).toString().padStart(PADZERO, "0"),
          locationDataStr
        );
        const execCorrelationId = () => (upapState?.user?.userNo || 0).toString().padStart(PADZERO, "0") + "-" + (correlationid++).toString().padStart(PADZERO, "0") + "-" + ((/* @__PURE__ */ new Date()).getTime() % 1e6).toString().padStart(PADZERO, "0");
        const correlation = { getCorrelationId: () => execCorrelationId() };
        const features = new FeaturesAccessSecurity({
          upap: upapState.upap,
          appCode: upapState.subCode
        }, {});
        const accessCheck = { featureAccessCheck: features };
        dispatch({ type: "SET_UPAP_RELATED", payload: { isToken: true, ...authState, ...upapState, ...correlation, ...accessCheck, loc: locationData } });
      } else {
        console.warn("AppContext:useEffect: Skip fetching UPAP as the UPAP_SVC is not set");
      }
    }
    fetchData();
    printBanner$1();
  }, [getEnvVar$1.UPAP_SVC, auth.isAuthenticated, appState.isToken]);
  if (isBrowser$3) {
    window.__appState__ = appState;
  }
  const value2 = { appState, dispatch };
  async function handleConnection() {
    let isOnlineStatus;
    if (navigator.onLine) {
      try {
        isOnlineStatus = await isHomeSiteReachable();
      } catch (e) {
        isOnlineStatus = false;
      }
    } else {
      isOnlineStatus = false;
    }
    dispatch({ type: "SET_ONLINE", payload: isOnlineStatus });
  }
  if (isBrowser$3) window.addEventListener("online", handleConnection);
  if (isBrowser$3) window.addEventListener("offline", handleConnection);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppContext.Provider, { value: value2, children });
};
const useAppContext = () => {
  const context = React__default.useContext(AppContext);
  if (context === void 0) {
    throw new Error(
      "useAppContext must be used within a AppProvider"
    );
  }
  return context;
};
const appReducer = (appState, action) => {
  let newAppState = null;
  switch (action.type) {
    // For following we've doc who the users are
    case "SET_ONLINE":
      newAppState = {
        ...appState,
        isOnline: action.payload
      };
      break;
    case "SET_UPAP_RELATED":
      newAppState = {
        ...appState,
        ...action.payload
      };
      break;
    // For following we NEED TO DOC who the users are
    case "SET_TOKEN":
      const payload = action.payload;
      const token = payload.token;
      payload.accessToken;
      const sub = payload.sub;
      payload.email;
      const username = payload.username;
      Object.assign(
        appState,
        {
          authSub: sub,
          token,
          username
        }
      );
      newAppState = appState;
      break;
    case "SET_THEME_MODE":
      updateDisplayCommonLocalStore$1("pref", "pref", { themeMode: action.payload, isShowDraft: appState.isShowDraft });
      newAppState = {
        ...appState,
        themeMode: action.payload
      };
      break;
    case "SET_TESTADS":
      console.log("appReducer change SET_TESTADS " + action.payload);
      newAppState = {
        ...appState,
        testAds: action.payload
      };
      break;
    case "SET_SHOW_DRAFT":
      updateDisplayCommonLocalStore$1("pref", "pref", { themeMode: appState.themeMode, isShowDraft: action.payload });
      newAppState = {
        ...appState,
        isShowDraft: action.payload
      };
      break;
    case "SET_CURRENT_ROUTE":
      newAppState = {
        ...appState,
        currentRoute: action.payload
      };
      break;
    case "SET_SIGN_IN":
      newAppState = {
        ...appState,
        isSignIn: action.payload
      };
      break;
    case "SET_DEV":
      newAppState = {
        ...appState,
        isDev: action.payload
      };
      break;
    case "SET_MULTIPLE":
      newAppState = {
        ...appState,
        ...action.payload
      };
      break;
    case "SET_FULL_APPSTATE":
      newAppState = { ...appState, ...action.payload };
      break;
    case "SET_ACCOUNT":
      newAppState = {
        ...appState,
        account: action.payload
      };
      break;
    case "SET_RERENDER":
      newAppState = {
        ...appState,
        reRender: action.payload
      };
      break;
    case "SET_UPAP":
      newAppState = {
        ...appState,
        upap: action.payload
      };
      break;
    case "SET_USER":
      newAppState = {
        ...appState,
        user: action.payload
      };
      break;
    case "SET_PREFERENCES":
      newAppState = {
        ...appState,
        preferences: action.payload
      };
      break;
    case "SET_PERMISSIONS":
      newAppState = {
        ...appState,
        permissions: action.payload
      };
      break;
    case "SET_CONSUMER":
      newAppState = {
        ...appState,
        consumer: action.payload,
        xxxxUser: action.payload
      };
      break;
    case "SET_SYNC_CONSUMER":
      newAppState = {
        ...appState,
        ...action.payload
      };
      break;
    case "SET_FORMUSER":
      newAppState = {
        ...appState,
        xxxxUser: action.payload
      };
      break;
    case "SET_SYNC_FORMUSER":
      newAppState = {
        ...appState,
        ...action.payload
      };
      break;
    case "SET_BITIUSER":
      newAppState = {
        ...appState,
        xxxxUser: action.payload
      };
      break;
    case "SET_SYNC_BITIUSER":
      newAppState = {
        ...appState,
        ...action.payload
      };
      break;
    case "SET_NULLUSER":
      newAppState = {
        ...appState,
        xxxxUser: action.payload
      };
      break;
    case "SET_SYNC_NULLUSER":
      newAppState = {
        ...appState,
        ...action.payload
      };
      break;
    // action: { type: 'SET_IO_BUSY',
    //           payload: true|false };
    case "SET_IO_BUSY":
      let count = action.payload ? appState.fetchPending + 1 : appState.fetchPending - 1;
      if (count < 0) {
        console.warn("appReducer:dispatch - SET_IO_BUSY count is: " + count);
        count = 0;
      }
      newAppState = {
        ...appState,
        fetchPending: count
      };
      break;
    default:
      return appState;
  }
  return newAppState;
};
let isBrowser$2 = typeof window === "undefined" ? false : true;
let getEnvVar = null;
function createInitState(viteapp, getEnvVarValue, appContext, getDisplayLocalStoreVal, updateDisplayLocalStoreVal) {
  getEnvVar = getEnvVarValue;
  let pref = { themeMode: getEnvVar.DEFAULT_THEME || "light", isShowDraft: false };
  pref = isBrowser$2 ? getDisplayCommonLocalStore("pref") : pref;
  console.log("appInitState - initial pref state: ", pref);
  const appInitState = {
    // Top level context
    appContext,
    // Variables      
    getEnvVar,
    // DisplayStaticEmerts, DisplayDynamicEmerts, PainBenefit
    // States
    isToken: false,
    token: "",
    // DisplayDynamicEmerts (for useEffect), Vehicles, RecentEmertItem 
    authSub: "",
    // Used to validate UPAP's user.id against Auuth's ID_TOKEN.sub
    username: "",
    fpid: "",
    loc: pref && pref.loc ? JSON.parse(pref.loc) : null,
    // Partners
    testAds: "",
    // Partners, Advert, advertSvc
    themeMode: pref.themeMode,
    // 'dark'
    isShowDraft: pref.isShowDraft,
    // Footer, PageContentFormat
    isSignIn: false,
    // Notifications, PainBenefit, Hero, Footer, Header
    isOnline: true,
    // Notifications,
    isDev: getEnvVar.isDev,
    // Footer, 
    auditip: "2.3.4.5",
    // Unfortunately IP not avail via browser
    fetchPending: 0,
    // Used for TopProgressBar display
    // Entities
    upap: null,
    appMembers: null,
    memberNdx: -1,
    // account: DisplayDynamicEmerts (isPermission for: alerts/search/ vehicle-check /keywords-check );
    account: null,
    //new Account(defaultAccount, getEnvVar.APP_NAME),
    user: null,
    //new User(defaultUser),
    preference: null,
    //new Preferences(defaultPreferences),
    permission: null,
    //new Permissions(defaultPermissions),
    consumer: null,
    //new Consumer(defaultConsumer),
    consumerOrig: null,
    //new Consumer(defaultConsumer),
    //formuser : null, //new Formuser(defaultFormuser),
    //formuserOrig : null, //new Formuser(defaultFormuser),
    //bitiuser : null, //new Formuser(defaultFormuser),
    //bitiuserOrig : null, //new Formuser(defaultFormuser),
    //nulluser : null, //new Formuser(defaultFormuser),
    //nulluserOrig : null, //new Formuser(defaultFormuser),
    xxxxUser: null,
    //new Formuser(defaultFormuser),
    xxxxUserOrig: null,
    //new Formuser(defaultFormuser),
    apps: null,
    // apps object - list of subscription objects
    subCode: null,
    // subscription affiliated with current appCode (ELMT > BITI; RECL > RECL, FORM > CRUD)
    plans: null,
    // plans associated with the subscription
    plan: null,
    // most recent subscribed plan
    currentRoute: "/",
    ecode: null,
    emsg: null,
    srvrVersion: "srvr-hash",
    isProdPymt: true,
    // Controls donate link from Myrecalls and adverts, Controls payments on SCUR app 
    featureAccessCheck: null
    // function to decipher feature access based on APP, FPID, JWT, PLAN, SUBs
  };
  if (isBrowser$2) {
    window.__appState__ = appInitState;
  }
  return appInitState;
}
let isBrowser$1 = typeof window === "undefined" ? false : true;
let model = null, reactiveState = null;
let stateVersion, setStateVersion;
const printBanner = (appCode) => {
  console.log("=====================================================================================");
  console.log("==                                                                                 ==");
  console.log("==                 SpaContext: *** !!! App: " + appCode + " !!! ***                ==");
  console.log("==                                                                                 ==");
  console.log("=====================================================================================");
};
const binding = (obj, model2) => {
  if (!obj) return;
  Object.keys(obj).forEach((m) => {
    if (typeof obj[m] == "function") {
      obj[m] = obj[m].bind(model2);
    } else if (typeof obj[m] === "object") {
      binding(obj[m], model2);
    }
  });
};
const createReactiveState = (initialState, notifyUpdate) => {
  return new Proxy(initialState, {
    get(target, prop) {
      const value2 = target[prop];
      if (isObject(value2)) {
        return createReactiveState(value2, notifyUpdate);
      }
      return value2;
    },
    set(target, prop, value2) {
      if (target[prop] !== value2) {
        target[prop] = value2;
        notifyUpdate();
        return true;
      }
      return true;
    }
  });
};
const createReactiveMainModel = (appState, dispatch) => {
  if (!model) {
    const tm = /* @__PURE__ */ new Date();
    const builder = { ...builderProps, ...builderMethods };
    const editor = { ...editorProps, ...editorMethods };
    const metaforms = { ...metaformsProps, ...metaformsMethods };
    const repocache = { ...repocacheProps, ...repocacheMethods };
    const selection = { ...selectionProps, ...selectionMethods };
    const serverio = { ...serverioProps, ...serverioMethods };
    model = {
      createTime: tm,
      ...modelProps,
      ...modelMethods,
      builder,
      editor,
      metaforms,
      repocache,
      selection,
      serverio
    };
    reactiveState = createReactiveState(model, () => {
      setStateVersion((prev) => prev + 1);
    });
    binding(reactiveState, reactiveState);
  }
  reactiveState["appState"] = appState;
  reactiveState["dispatch"] = dispatch;
  return reactiveState;
};
const isObject = (val) => val !== null && typeof val === "object";
const spaUpdtStateFn = async (origState) => {
};
const SpaContext = createContext();
const SpaProvider = ({ spaInitState, spaReducer: spaReducer2, children }) => {
  const { appState, dispatch } = useAppContext();
  const resp = useState(0);
  [stateVersion, setStateVersion] = resp;
  reactiveState = createReactiveMainModel(appState, dispatch);
  let spaState = reactiveState;
  let spaDispatch = null;
  useEffect(() => {
    const init = async () => {
      if ((appState.token || appState.fpid) && appState.upap) {
        await reactiveState.metaforms.initRuntimeMetaforms();
        await reactiveState.editor.initRuntimeEditor();
        await reactiveState.selection.initRuntimeSelection();
        await reactiveState.serverio.initRuntimeServerio();
        await reactiveState.repocache.initRuntimeRepocache();
        await reactiveState.initRuntimeModel();
        await reactiveState.builder.initRuntimeBuilder();
      } else {
        console.log("SpaContext:useEffect() - Run useEffect - skip as there are no (tokem or fpid) and upap");
      }
    };
    init();
    printBanner(appState.getEnvVar.APP_CODE);
  }, [appState.time, appState.token, appState.fpid, appState.upap?.user]);
  if (isBrowser$1) {
    window.__spaState__ = spaState;
  }
  const value2 = { spaState: { da: spaState }, spaDispatch, setStateVersion };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SpaContext.Provider, { value: value2, children });
};
const useSpaContext = () => {
  const context = useContext(SpaContext);
  if (context === void 0) {
    throw new Error(
      "useSpaContext must be used within a SpaProvider"
    );
  }
  return context;
};
const spaReducer = (spaState, action) => {
  let newSpaState = spaState;
  switch (action.type) {
    case "SET_SHOW_DRAFT":
      updateDisplayCommonLocalStore("pref", "pref", { themeMode: spaState.themeMode, isShowDraft: action.payload });
      newSpaState = {
        ...spaState,
        isShowDraft: action.payload
      };
      break;
    case "SET_MULTIPLE":
      newSpaState = {
        ...spaState,
        ...action.payload
      };
      break;
    case "SET_FULL_SPASTATE":
      newSpaState = { ...spaState, ...action.payload };
      break;
    case "SET_RERENDER":
      newSpaState = {
        ...spaState,
        reRender: action.payload
      };
      break;
    case "SET_IO_BUSY":
      let count = action.payload ? spaState.fetchPending + 1 : spaState.fetchPending - 1;
      if (count < 0) {
        console.warn("spaReducer:dispatch - SET_IO_BUSY count is: " + count);
        count = 0;
      }
      newSpaState = {
        ...spaState,
        fetchPending: count
      };
      break;
    default:
      return spaState;
  }
  return newSpaState;
};
let isBrowser = typeof window === "undefined" ? false : true;
function createSpaInitState(options2) {
  const someValue = options2.someValue || "someValue";
  const appState = options2.appState;
  const getEnvVar2 = options2.appState?.getEnvVar;
  const dispatch = options2.dispatch;
  const spaInitState = {
    someValue,
    featureAccessCheck: null,
    // function to decipher feature access based on APP, FPID, JWT, PLAN, SUBs
    getEnvVar: getEnvVar2,
    appState,
    dispatch,
    da: null
    // Gets set within SpaContext
  };
  if (isBrowser) {
    window.__appState__ = spaInitState;
  }
  return spaInitState;
}
function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });
  const setValue2 = (value2) => {
    try {
      const valueToStore = value2 instanceof Function ? value2(storedValue) : value2;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue2];
}
function useWindowScrollPosition(localStorageKey, setCondition) {
  const [scrollYStorage, setScrollYStorage] = useLocalStorage(localStorageKey, 0);
  useEffect(() => {
    if (setCondition) {
      window.scrollTo(0, scrollYStorage);
    } else {
      setScrollYStorage(window.scrollY);
    }
  }, [setCondition, scrollYStorage]);
}
const Async = (path2, dynamicImport) => {
  const Component2 = React__default.lazy(dynamicImport);
  const isMatch = matchPath(path2, window.location.pathname);
  if (isMatch) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "list", children: "Loading..." }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {}) });
};
const isServerSide = typeof window === "undefined";
const createRoutes = async (routes, url) => {
  const allRoutes = [];
  let isMatched = false;
  let fetchDataResp = null;
  for (const route of routes) {
    let element;
    let match = null;
    try {
      match = matchPath(route.path, url);
    } catch (error) {
      console.error("createRoutes: createRoutes() - XXXXXXXXXXX exception occured during matchPath() ", JSON.stringify(error));
    }
    try {
      if (isServerSide) {
        const mod = await route.import();
        element = /* @__PURE__ */ jsxRuntimeExports.jsx(mod.default, {});
        if (match && !isMatched) {
          isMatched = true;
          fetchDataResp = await mod?.fetchData?.(url, match);
        }
      } else if (!isServerSide) {
        element = await Async(route.path, route.import);
      }
      allRoutes.push({ path: route.path, element });
    } catch (error) {
      console.error("createRoutes: createRoutes() - XXXXXXXXX exception occured ", JSON.stringify(error));
    }
  }
  let head = fetchDataResp && fetchDataResp.head || null;
  let fetchData = fetchDataResp && fetchDataResp.fetchData || null;
  return {
    routes: allRoutes,
    // Full route list. Each item having path and corresponding react module
    head,
    // headers - for server side processing only
    fetchData
    // context data - for server side processing only
  };
};
class Konsole {
  constructor(options2 = {}) {
    this.cacheSize = options2.cacheSize || 100, this.sendToServer = options2.sendToServer || false, this.serverEndpoint = options2.serverEndpoint, this.supportLevels = options2.supportLevels, this.activeLevels = options2.activeLevels, this.options = options2, this.passthroughLevels = [
      "assert",
      "clear",
      "countReset",
      "count",
      "dir",
      "dirxml",
      "groupCollapsed",
      "groupEnd",
      "group",
      "table",
      "timeEnd",
      "timeLog",
      "timeStamp",
      "time",
      "trace"
    ];
    this.fullLevels = this.passthroughLevels.concat(this.supportLevels);
    this.cache = [];
    this.origConsole = console;
    this._overrideConsole();
  }
  _cacheEntry(logEntry) {
    this.cache.push(logEntry);
    if (this.cache.length >= this.cacheSize) {
      if (this.sendToServer) {
        const resp = this._sendToServer();
        if (resp)
          this.cache = [];
        else
          this.cache.shift();
      } else {
        this.cache.shift();
      }
    }
  }
  async _sendToServer(logEntry) {
    if (!this.serverEndpoint) {
      return false;
    }
    try {
      await fetch(this.serverEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(this.cache)
      });
      return true;
    } catch (error) {
      this.origConsole.error("Konsole:_sendToServer() - Error sending log to server:", error);
      return false;
    }
  }
  dumpCache() {
    return [...this.cache];
  }
  _parseStackTrace(frame2) {
    if (!frame2) {
      return { file: "unknown", line: "unknown" };
    }
    const match = frame2.match(/at (.*?)\s*\((.*?):(\d+):(\d+)\)/);
    if (match) {
      return {
        code: match[2] ? match[2].split("/").pop() : "",
        functionName: match[1],
        //file: match[2],   // This is a full file name with path
        line: match[3]
      };
    }
    const simpleMatch = frame2.match(/at (.*?):(\d+):(\d+)/);
    if (simpleMatch) {
      return {
        functionName: "anonymous",
        file: simpleMatch[1],
        line: simpleMatch[2]
      };
    }
    return { file: "unknown", line: "unknown" };
  }
  compress(listx) {
    const listy = listx.map((item) => {
      return typeof item === "string" ? item.slice(1, -1) : item;
    });
    return listy;
  }
  objectToString(obj, separator = ",", keyValueSeparator = "=") {
    let result = "";
    let index = 0;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result += key + keyValueSeparator + obj[key];
        if (index < Object.keys(obj).length - 1) {
          result += separator;
        }
        index++;
      }
    }
    return result;
  }
  stringify(logEntryValues) {
    if (Array.isArray(logEntryValues)) {
      const valueList = logEntryValues.map((arg2) => {
        if (typeof arg2 === "object" && arg2 !== null) {
          const seen = /* @__PURE__ */ new WeakSet();
          try {
            return JSON.stringify(arg2, (key, value2) => {
              if (typeof value2 === "object" && value2 !== null) {
                if (seen.has(value2)) {
                  return "[Circular]";
                }
                seen.add(value2);
              }
              value2 = this.stringify(value2);
              return value2;
            });
          } catch (e) {
            return String(arg2);
          }
        }
        return arg2;
      });
      return valueList;
    } else if (typeof logEntryValues == "string") {
      return logEntryValues;
    } else {
      return this.objectToString(logEntryValues);
    }
  }
  _createLogEntry(level, args) {
    const error = new Error();
    const stackTrace = error.stack ? error.stack.split("\n").slice(4) : [];
    const callerInfo = this._parseStackTrace(stackTrace[0]);
    var ts = /* @__PURE__ */ new Date();
    const options2 = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      fractionalSecondDigits: 3,
      hour12: false
    };
    const timestamp = ts.toLocaleDateString() + " " + ts.toLocaleTimeString(void 0, options2);
    return {
      timestamp,
      // new Date().toISOString(),
      level,
      message: this.stringify(args),
      // args.map((arg) => (typeof arg === 'object' ? this.stringify(arg) : arg)).join(' '),
      ...callerInfo
    };
  }
  _dumpEntry(method, ...args) {
    const logEntry = this._createLogEntry(method, args);
    const logEntryValues = Object.values(logEntry);
    const values2 = logEntryValues;
    const logEntryStr = values2.join(" - ");
    this.origConsole[method](logEntryStr);
    this._cacheEntry(logEntryStr);
  }
  _overrideConsole() {
    this.fullLevels.forEach((method) => {
      if (this.activeLevels.includes(method)) {
        this[method] = (...args) => {
          this._dumpEntry(method, ...args);
        };
      } else if (this.passthroughLevels.includes(method)) {
        this[method] = (...args) => {
          this.origConsole[method](...args);
        };
      } else {
        this[method] = (...args) => {
        };
      }
    });
  }
}
const WrapLayout = (props) => {
  const { MDXComponents: MDXComponents2, appInitState, appReducer: appReducer2, getEnvVar: getEnvVar2, oidcConfig } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AuthProvider, { ...oidcConfig, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppProvider, { appInitState, getEnvVarObj: getEnvVar2, appReducer: appReducer2, children: props.children }) });
};
const AppMdxLayout = (props) => {
  const { themes: themes2, headerOptions, footerOptions, oidcConfig } = props;
  const { appState, dispatch } = useAppContext();
  const theme = appState.themeMode === "light" ? themes2.light : themes2.dark;
  const backpanel = {
    background: theme.custom.backpanelBG,
    padding: theme.custom.pageGap
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CssBaseline, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...backpanel }, "data-where": "ContentLayout-backpanel", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { maxWidth: "xl", disableGutters: true, "data-where": "ContentLayout-Container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(MDXProvider, { components: MDXComponents, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { headerOptions }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TopProgressBar, { fetchPending: appState.fetchPending }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PageLayout, { "data-where": "ContentLayout-PageLayout", children: /* @__PURE__ */ jsxRuntimeExports.jsx("main", { children: props.children }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Footer$2, { footerOptions }) })
    ] }) }) })
  ] });
};
const AppTsxLayout = (props) => {
  const { themes: themes2, headerOptions, footerOptions, oidcConfig } = props;
  const { appState, dispatch } = useAppContext();
  const theme = appState.themeMode === "light" ? themes2.light : themes2.dark;
  const backpanel = {
    background: theme.custom.backpanelBG,
    padding: theme.custom.pageGap
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CssBaseline, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...backpanel }, "data-where": "ContentLayout-backpanel", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container, { maxWidth: "xl", disableGutters: true, "data-where": "ContentLayout-Container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { headerOptions }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TopProgressBar, { fetchPending: appState.fetchPending }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PageLayout, { "data-where": "ContentLayout-PageLayout", children: /* @__PURE__ */ jsxRuntimeExports.jsx("main", { children: props.children }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Footer$2, { footerOptions }) })
    ] }) })
  ] });
};
const CommonLayout = (props) => {
  const { themes: themes2, headerOptions, footerOptions, oidcConfig } = props;
  const { appState, dispatch } = useAppContext();
  const theme = appState.themeMode === "light" ? themes2.light : themes2.dark;
  const backpanel = {
    background: theme.custom.backpanelBG,
    padding: theme.custom.pageGap
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CssBaseline, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...backpanel }, "data-where": "ContentLayout-backpanel", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { maxWidth: "xl", disableGutters: true, "data-where": "ContentLayout-Container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(MDXProvider, { components: MDXComponents, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { headerOptions }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TopProgressBar, { fetchPending: appState.fetchPending }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PageLayout, { "data-where": "ContentLayout-PageLayout", children: /* @__PURE__ */ jsxRuntimeExports.jsx("main", { children: props.children }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Footer$2, { footerOptions }) })
    ] }) }) })
  ] });
};
const SpaTsxLayout = (props) => {
  const { themes: themes2, headerOptions, footerOptions, oidcConfig } = props;
  const { appState, dispatch } = useAppContext();
  const theme = appState.themeMode === "light" ? themes2.light : themes2.dark;
  const backpanel = {
    background: theme.custom.backpanelBG,
    padding: theme.custom.pageGap
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider, { theme, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CssBaseline, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...backpanel }, "data-where": "ContentLayout-backpanel", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container, { maxWidth: "false", disableGutters: true, "data-where": "ContentLayout-Container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { headerOptions }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TopProgressBar, { fetchPending: appState.fetchPending }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("main", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageLayout, { "data-where": "ContentLayout-PageLayout", children: props.children }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Footer$2, { footerOptions }) })
    ] }) })
  ] });
};
const ContentLayout = (props) => {
  const wrapLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(WrapLayout, { ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CommonLayout, { ...props }) });
  return wrapLayout;
};
const ContentLayoutSpa = (props) => {
  const wrapLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(WrapLayout, { ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SpaTsxLayout, { ...props }) });
  return wrapLayout;
};
const ContentLayoutMdx = (props) => {
  const wrapLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(WrapLayout, { ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppMdxLayout, { ...props }) });
  return wrapLayout;
};
const ContentLayoutTsx = (props) => {
  const wrapLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(WrapLayout, { ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppTsxLayout, { ...props }) });
  return wrapLayout;
};
const ContentLayoutTest = (props) => {
  const wrapLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(WrapLayout, { ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppTsxLayout, { ...props }) });
  return wrapLayout;
};
const PageLayout = (props) => {
  const theme = useTheme();
  let { adSpecs, children } = props;
  const { appState, dispatch } = useAppContext();
  const [currentRoute, setCurrentRoute] = useState("");
  useEffect(() => {
    if (typeof window != "undefined") {
      setCurrentRoute(window.location.pathname);
    }
  }, [appState.currentRoute]);
  const currentRouteAddSpec = advertSvc.getAdSpec(currentRoute, appState.loc?.state, appState.testAds);
  let advertsLeft = null;
  let advertsRight = null;
  let advertsBottom = null;
  let content = null;
  if (currentRouteAddSpec) {
    const advertOptions = currentRouteAddSpec.options;
    let isAdSmall = advertOptions.isAdSmall;
    const smallAdSize = 2;
    const largeAdSize = 3;
    const fullSize = 12;
    let adWidth = isAdSmall ? advertOptions.left && advertOptions.right ? smallAdSize : advertOptions.left || advertOptions.right ? smallAdSize : 0 : advertOptions.left && advertOptions.right ? smallAdSize : advertOptions.left || advertOptions.right ? largeAdSize : 0;
    let mainWidth = isAdSmall ? advertOptions.left && advertOptions.right ? fullSize - (smallAdSize + smallAdSize) : advertOptions.left || advertOptions.right ? fullSize - smallAdSize : 0 : advertOptions.left && advertOptions.right ? fullSize - (smallAdSize + smallAdSize) : advertOptions.left || advertOptions.right ? fullSize - largeAdSize : 0;
    advertsLeft = advertOptions && advertOptions.left ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: adWidth }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Advert, { route: currentRouteAddSpec.route }) }) : null;
    advertsRight = advertOptions && advertOptions.right ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: adWidth }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Advert, { route: currentRouteAddSpec.route }) }) : null;
    advertsBottom = advertOptions && advertOptions.bottom ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Advert, { route: currentRouteAddSpec.route }) }) : null;
    content = advertsLeft && advertsRight ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: mainWidth }, "data-where": "PageLayout-AdLeftRight", children }) : advertsLeft ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: mainWidth }, "data-where": "PageLayout-AdLeft", children }) : advertsRight ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: mainWidth }, "data-where": "PageLayout-AdRight", children }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 12 }, "data-where": "PageLayout-AdNone", children });
  } else {
    content = /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 12 }, "data-where": "PageLayout-NoAd", children });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, "data-where": "PageLayout", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Paper,
    {
      square: true,
      sx: {
        width: "100%",
        // Margin bottom is for section bottom gap (to show darker background from slate)
        marginBottom: theme.custom.pageGap,
        backgroundColor: theme.custom.contentpanelBG,
        p: theme.custom.pagePadding || 2
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 1, "data-where": "PageLayout-SubCtnr", children: [
          advertsLeft,
          content,
          advertsRight
        ] }),
        advertsBottom
      ]
    }
  ) });
};
const createJsonLdContent = ({
  type,
  // 'inline' | 'build'
  isBlogPost,
  orgSeoCode,
  personSeoCode,
  seoPageData,
  seoOrgData,
  seoPersonData,
  children
  // object
}) => {
  const org = orgSeoCode && seoOrgData.org[orgSeoCode] ? seoOrgData.org[orgSeoCode] : seoOrgData.org["kripa"];
  const person = personSeoCode && seoPersonData.person[personSeoCode] ? seoPersonData.person[personSeoCode] : seoPersonData.person["default"];
  const BLOG_IMG_WIDTH = 600;
  const BLOG_IMG_HEIGHT = 400;
  const ORGANIZATION_LOGO_WIDTH = 48;
  const ORGANIZATION_LOGO_HEIGHT = 48;
  `${org.siteUrl}${seoPageData.path}`;
  const pageDescLen = 250;
  const pageDesc = seoPageData.description ? seoPageData.description.substring(0, pageDescLen) : org.description?.substring(0, pageDescLen);
  const pageTitleLen = 70;
  let pageTitle = seoPageData.title?.substring(0, pageTitleLen) || org.slogan.substring(0, pageTitleLen) || org.headline?.substring(0, pageTitleLen);
  pageTitle = pageTitle + " · " + org.title;
  let graph = [];
  const path2 = seoPageData.path;
  if (path2 && path2.length > 1) {
    let pathClean = path2[0] === "/" ? path2.substr(1) : path2;
    pathClean = pathClean[pathClean.length - 1] === "/" ? pathClean.substr(0, pathClean.length - 1) : pathClean;
    const pathParts = pathClean.split("/");
    const pathList = pathParts.map((part, i) => {
      const partialPath = i ? pathParts.slice(0, i + 1).join("/") : part;
      return {
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "WebPage",
          "@id": `${org.siteUrl}/${partialPath}`,
          url: `${org.siteUrl}/${partialPath}`,
          name: part
        }
      };
    });
    graph.push({
      "@type": "BreadcrumbList",
      "@id": `${org.siteUrl}/#breadcrumb`,
      itemListElement: pathList
    });
  }
  if (isBlogPost) {
    graph.push({
      "@type": "ImageObject",
      "@id": `${org.siteUrl}${seoPageData.path}/#primaryimage`,
      inLanguage: "en-US",
      url: `${org.siteUrl}/${seoPageData.pic}`,
      width: BLOG_IMG_WIDTH,
      height: BLOG_IMG_HEIGHT
    });
    graph.push({
      "@type": "Person",
      "@id": `${org.siteUrl}/${person.code}/#person`,
      name: person.name,
      image: {
        "@type": "ImageObject",
        "@id": `${org.siteUrl}/${person.code}/#personlogo`,
        inLanguage: "en-US",
        url: `${org.siteUrl}/${person.avatarUrl}`,
        caption: person.caption
      }
    });
    graph.push({
      "@context": "http://schema.org",
      "@type": "BlogPosting",
      url: `${org.siteUrl}${seoPageData.path}`,
      name: pageTitle,
      alternateName: seoPageData.slogan,
      headline: pageTitle,
      image: {
        "@type": "ImageObject",
        url: `${org.siteUrl}${seoPageData.pic}`
      },
      description: pageDesc,
      author: {
        "@type": "Person",
        name: person.name,
        email: person.email
      },
      publisher: {
        "@type": "Organization",
        url: org.siteUrl,
        logo: {
          "@type": "ImageObject",
          //url: org.logo,
          url: `${org.siteUrl}/${org.logoUrl}`,
          width: ORGANIZATION_LOGO_WIDTH,
          height: ORGANIZATION_LOGO_HEIGHT
        },
        name: org.name
      },
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": `${org.siteUrl}/blogs/`
      },
      datePublished: seoPageData.datePublished,
      dateModified: seoPageData.dateModified
    });
  } else {
    const webpage = {
      "@type": "WebPage",
      "@id": `${org.siteUrl}/#webpage`,
      url: `${org.siteUrl}${seoPageData.path}`,
      name: pageTitle,
      isPartOf: {
        "@id": `${org.siteUrl}/#website`,
        url: `${org.siteUrl}${seoPageData.path}`
      },
      about: {
        "@id": `${org.siteUrl}/#organization`
      },
      //"datePublished": datePublished,
      //"dateModified": dateModified,   // "2020-12-16T10:07:24+00:00",
      description: pageDesc,
      inLanguage: "en-US",
      potentialAction: [
        {
          "@type": "ReadAction",
          target: [`${org.siteUrl}${seoPageData.path}`]
        }
      ]
    };
    if (seoPageData.pic) {
      if (seoPageData.pic.indexOf("http") !== -1) {
        webpage["primaryImageOfPage"] = {
          "@type": "ImageObject",
          url: seoPageData.pic
        };
      } else {
        webpage["primaryImageOfPage"] = {
          "@type": "ImageObject",
          url: org.siteUrl + seoPageData.pic
        };
      }
    }
    if (seoPageData?.path?.length > 1) {
      webpage["breadcrumb"] = {
        "@id": `${org.siteUrl}/#breadcrumb`
      };
    }
    graph.push(webpage);
  }
  let pageSD = {
    "@context": "https://schema.org",
    "@graph": graph
  };
  return pageSD;
};
const createSeoContent = (seoPageData, seoOrgData, seoPersonData, getEnvVar2) => {
  const appLogoFilePath = getEnvVar2.APP_LOGO_FILE_PATH;
  const {
    //bgColor,
    //pathPrefix,
    THIS_SITE_URL,
    // just the host name to visit the site w/o trailing slash
    APP_NAME,
    SUPPORT_PWA
  } = getEnvVar2;
  const orgSeoCode = APP_NAME.toLowerCase();
  const personSeoCode = "principal";
  const siteUrl = THIS_SITE_URL;
  const logoImgUrl = appLogoFilePath?.substr(appLogoFilePath.lastIndexOf("/") + 1);
  const LOGO_HEIGHT = 48;
  const LOGO_WIDTH = 48;
  const org = orgSeoCode && seoOrgData.org[orgSeoCode] ? seoOrgData.org[orgSeoCode] : seoOrgData.org["kripa"];
  if (!org) {
    console.log(
      "PageSeo : Invalid orgSeoCode(APP_NAME) specified : " + orgSeoCode + " SEO processing aborted"
    );
    return;
  }
  seoPageData && seoPageData.personSeoCode ? seoPersonData.person[seoPageData.personSeoCode] : seoPersonData.person[personSeoCode] ? seoPersonData.person[personSeoCode] : seoPersonData.person["default"];
  const isPost = seoPageData.type === "BlogIndexPage" || seoPageData.type === "BlogPage";
  seoPageData.keywords ? seoPageData.keywords : org.keywords;
  const fullPath = `${siteUrl}${seoPageData.path}`;
  const pageDescLen = 130;
  const ogDescLen = 200;
  const twDescLen = 200;
  const pageDesc = seoPageData.description ? seoPageData.description.substring(0, pageDescLen) : org.description?.substring(0, pageDescLen);
  const ogDesc = seoPageData.description ? seoPageData.description.substring(0, ogDescLen) : org.description?.substring(0, pageDescLen);
  const twDesc = seoPageData.description ? seoPageData.description.substring(0, twDescLen) : org.description?.substring(0, pageDescLen);
  const pageTitleLen = 50;
  const ogTitleLen = 50;
  const twTitleLen = 70;
  let pageTitle = seoPageData.title?.substring(0, pageTitleLen) || org.slogan.substring(0, pageTitleLen);
  pageTitle = pageTitle + " · " + org.title;
  let ogTitle = seoPageData.ogTitle?.substring(0, ogTitleLen) || seoPageData.title.substring(0, ogTitleLen) || org.slogan.substring(0, ogTitleLen);
  let twTitle = seoPageData.twitterTitle?.substring(0, twTitleLen) || seoPageData.title?.substring(0, twTitleLen) || org.twitterTitle.substring(0, twTitleLen);
  twTitle = twTitle + " · " + org.title;
  const linkTags = [];
  if (seoPageData.isCanonical) {
    linkTags.push(`<link rel="canonical" href="${fullPath}"/>`);
  }
  linkTags.push(`<link rel="icon"             type="image/png"                  href="${org.faviconPath}?v=3"/>`);
  linkTags.push(`<link rel="sitemap"          type="application/xml"            href="${org.sitemapPath}"/>`);
  if (SUPPORT_PWA) {
    linkTags.push(`<link rel="manifest"         type="application/manifest+json"  href="${org.manifestPath}"/>`);
  }
  linkTags.push(`<link rel="apple-touch-icon" sizes="48x48"                     href="/icons/icon-48x48.png"/>`);
  linkTags.push(`<link rel="apple-touch-icon" sizes="72x72"                     href="/icons/icon-72x72.png"/>`);
  linkTags.push(`<link rel="apple-touch-icon" sizes="96x96"                     href="/icons/icon-96x96.png"/>`);
  linkTags.push(`<link rel="apple-touch-icon" sizes="144x144"                   href="/icons/icon-144x144.png"/>`);
  linkTags.push(`<link rel="apple-touch-icon" sizes="192x192"                   href="/icons/icon-192x192.png"/>`);
  linkTags.push(`<link rel="apple-touch-icon" sizes="256x256"                   href="/icons/icon-256x256.png"/>`);
  linkTags.push(`<link rel="apple-touch-icon" sizes="384x384"                   href="/icons/icon-384x384.png"/>`);
  linkTags.push(`<link rel="apple-touch-icon" sizes="512x512"                   href="/icons/icon-512x512.png"/>`);
  let imageUrl, imageAlt;
  imageAlt = "Logo image";
  imageUrl = org.sitePic ? `${siteUrl}/${org.sitePic}` : logoImgUrl;
  const metaList = [
    /* The theme color is already specified in the manifest.webmanifest 
    { name: 'theme-color',
      content: org.themeColor || '#FFFFFF',
    },
    */
    {
      name: "description",
      content: pageDesc
    },
    /* Not required anymore Apr 2023
    {
      property: 'keywords',
      content: fullSetKeywords.join(','),
    },
    */
    // og: xxxx
    {
      property: "og:locale",
      content: "en_US"
    },
    {
      property: `og:type`,
      content: isPost ? "article" : "website"
      // 'article' for a blogpost and 'website' for a web page
    },
    {
      property: `og:title`,
      content: ogTitle
    },
    {
      property: `og:site_name`,
      content: org.name
    },
    {
      property: "og:description",
      content: ogDesc
    },
    {
      property: "og:url",
      content: fullPath
      // seoPageData.slug ? `${siteUrl}/${slugWithoutSlashes()}/` : org.siteUrl + '/'
    },
    /* No longer required by FB
    {
      property: 'og:app_id',
      content: org.fbAppID,
    },
    */
    // Add following only if image exists
    {
      property: "og:image",
      content: imageUrl
    },
    {
      property: imageUrl.indexOf("https") !== -1 ? "og:image:secure_url" : "og:image",
      content: imageUrl
    },
    {
      property: "og:image:alt",
      content: imageAlt
    },
    // twitter
    {
      name: "twitter:card",
      content: isPost ? "summary_large_image" : "summary"
      // 'summary' OR 'summary_large_image'
    },
    {
      name: `twitter:site`,
      content: org.twitterID
    },
    {
      name: `twitter:creator`,
      content: seoPageData.twitterID || org.twitterID
    },
    {
      name: `twitter:title`,
      content: twTitle
    },
    {
      name: `twitter:description`,
      content: twDesc
    }
  ];
  const graph = [];
  graph.push({
    "@type": "Organization",
    id: `${siteUrl}/#organization`,
    name: org.name,
    image: `${org.siteUrl}/${org.logoUrl}`,
    logo: {
      "@type": "ImageObject",
      id: `${org.siteUrl}/#logo`,
      caption: org.caption,
      height: LOGO_HEIGHT,
      inLanguage: "en-US",
      url: `${org.siteUrl}/${org.logoUrl}`,
      width: LOGO_WIDTH
    },
    mainEntityOfPage: `${org.siteUrl}/#entity`,
    /*
       "sameAs": [
       {
       "id": `${siteUrl}/#organization-a`
       },
       {
       "id": `${siteUrl}/#organization-b`
       },
       {
       "id": `${siteUrl}/#organization-c`
       }
       ],
     */
    url: org.siteUrl + "/"
  });
  const websiteSD = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    id: `${org.siteUrl}/#website`,
    alternateName: org.alternateName,
    description: org.description,
    inLanguage: "en-US",
    name: org.name,
    publisher: {
      "@type": "Organization",
      "@id": `${org.siteUrl}/#organization`
    },
    // Publisher
    url: org.siteUrl + "/"
  };
  if (orgSeoCode === "emert") {
    websiteSD.potentialAction = {
      "@type": "SearchAction",
      "query-input": "required name=search_term_string",
      target: `${org.siteUrl}/myrecalls?display=list&type=search&term={search_term_string}`
    };
  } else if (orgSeoCode === "recalls") {
    websiteSD.potentialAction = {
      "@type": "SearchAction",
      "query-input": "required name=search_term_string",
      target: `${org.siteUrl}/myrecalls?display=list&type=search&term={search_term_string}`
    };
  }
  graph.push(websiteSD);
  const seoJsonLd = createJsonLdContent({
    type: "build",
    isBlogPost: isPost,
    orgSeoCode,
    personSeoCode,
    seoPageData,
    seoOrgData,
    seoPersonData
  });
  const homePageSD = {
    "@context": "https://schema.org",
    "@graph": graph
  };
  const metaTags = metaList.map((item) => {
    if (item.name) {
      return `<meta name="${item.name}" content="${item.content}"/>`;
    } else if (item.property) {
      return `<meta property="${item.property}" content="${item.content}"/>`;
    }
  });
  return {
    seoPage: `<script type="application/ld+json" data-jsonld-type="site"> ${JSON.stringify(homePageSD)} <\/script>`,
    seoJsonLd: `<script type="application/ld+json" data-jsonld-type="build"> ${JSON.stringify(seoJsonLd ? seoJsonLd : "") || ""} <\/script>`,
    seoMetaTags: metaTags.join("\n"),
    seoLinkTags: linkTags.join("\n"),
    seoTitle: pageTitle || "unknown title"
  };
};
function commonHead(meta, seoPageData, frontmatter, seoOrgData_json, seoPersonData_json, getEnvVar2) {
  const pageType = seoPageData.type;
  const seoContent = createSeoContent(seoPageData, seoOrgData_json, seoPersonData_json, getEnvVar2);
  if (!seoContent || !seoContent?.seoJsonLd || !seoContent.seoPage || !seoContent.seoMetaTags) {
    console.error("commonHead: No seoContent or seoPage, seoJsonLd or seoMetaTags for " + meta.pageId);
  }
  let pwaInline = "";
  if (getEnvVar2.SUPPORT_PWA) {
    pwaInline = `
<script>
if('serviceWorker' in navigator) {
var global = {};
window.store = { model: null };   // Req'd for lnch/form/scur global model 
window.addEventListener('load', () => {
navigator.serviceWorker.register('/sw.js', { scope: '/' })
.then(() => console.log('Service worker is registered!'))
.catch(() => console.error('Service worker registration failed'));
})
}
<\/script>`;
  }
  const siteId = `<meta name="site-description" content="${getEnvVar2.APP_DESC} · ${getEnvVar2.APP_NAME}" />`;
  let jsonLdInline = "";
  if (meta.exports.pageSpec && meta.exports.pageSpec.ldJsonInline) {
    const jsonData = meta.exports.pageSpec.jsonData;
    jsonLdInline = `
<script type="application/ld+json" data-jsonld-type="inline">
${JSON.stringify(jsonData.content)}
<\/script>`;
  }
  let documentHtml = null;
  if (pageType === "AppIndexPage") {
    documentHtml = `<meta name="robots" content="nofollow, noindex, max-snippet:0, max-video-preview:0, max-image-preview:none"/>
<title>${seoContent?.seoTitle || "unknown"}</title>
${siteId}
${seoContent.seoMetaTags}
${seoContent.seoLinkTags}
${seoContent.seoPage}
${seoContent.seoJsonLd}
${jsonLdInline}
${pwaInline}`;
  } else {
    let adSenseSrc = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    let adSenseKey = getEnvVar2.GOOGLE_ADSENSE_CLIENT;
    let googAdSenseScript = "";
    let googAdSenseMeta = "";
    if (getEnvVar2.RUN_ENV === "prod") {
      if (!adSenseKey || adSenseKey == "undefined") {
        adSenseSrc = "";
        adSenseKey = "NoAdSenseIn" + getEnvVar2.APP_ENVIRONMENT;
        googAdSenseMeta = `<meta name="adsense" data-ad-client="${adSenseKey}" />`;
      } else {
        googAdSenseScript = `<script async src=${adSenseSrc} data-ad-client=${adSenseKey} ><\/script>`;
      }
    } else {
      googAdSenseMeta = `<meta env="development" name="adsense" data-ad-client="${adSenseKey}" />`;
      googAdSenseScript = "";
    }
    documentHtml = `<meta name="robots" content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"/>
<title>${seoContent?.seoTitle || "unknown"}</title>
${siteId}
${googAdSenseMeta}
${seoContent?.seoMetaTags || ""}
${seoContent?.seoLinkTags || ""}
${seoContent?.seoPage || ""}
${seoContent?.seoJsonLd || ""}
${jsonLdInline || ""}
${pwaInline || ""}
${googAdSenseScript || ""}`;
  }
  return documentHtml;
}
const contentHead = (pagePath, getEnvVar2, seoSitePageData, seoOrgData_json, seoPersonData_json) => {
  const Adverts = null;
  const pageContext = {
    exports: {
      layoutName: "SpaTsxLayout",
      Adverts,
      options: {
        adverts: { left: false, right: false, bottom: false }
      },
      // jsonLd inline ONLY for following pages: FAQ, HOWTO pages - only set for these pages
      pageSpec: { ldJsonInline: true, jsonData: { content: "" } },
      meta: {}
      // mdx frontmatter
    },
    _pageId: "/"
  };
  const pageMeta = {
    pageId: pageContext._pageId,
    // '/pages/about'
    exports: pageContext.exports
  };
  const meta = pageMeta;
  const frontmatter = meta?.exports?.meta || null;
  const contentCommonHead = commonHead(meta, seoSitePageData, frontmatter, seoOrgData_json, seoPersonData_json, getEnvVar2);
  if (!contentCommonHead) {
    console.error("contentHead: No contentCommonHead for " + meta.pageId);
  }
  return contentCommonHead;
};
const TopProgressBar = (props) => {
  const progressOptions = {
    format: "form",
    items: null,
    bucket: {
      p: null,
      busy: !!props.fetchPending,
      color: "secondary",
      width: "",
      variant: "",
      size: ""
    }
  };
  let progressCompHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressComp, { ...progressOptions });
  return progressCompHtml;
};
const MDXComponents = {
  a: ((props) => {
    const A = (props2) => {
      const { href } = props2;
      if (href.startsWith("/")) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, target: "_blank", rel: "noopener noreferrer", children: props2.children });
      }
      const onPage = href.startsWith("#");
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href,
          target: onPage ? null : "_blank",
          rel: onPage ? null : "noopener noreferrer",
          children: props2.children
        }
      );
    };
    return memo(A);
  })(),
  p: (() => {
    const P2 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, variant: "body1", gutterBottom: true });
    return memo(P2);
  })(),
  h1: (() => {
    const H1 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "h1", variant: "h1", gutterBottom: true, align: "center" });
    return memo(H1);
  })(),
  h2: (() => {
    const H2 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "h2", variant: "h2", gutterBottom: true });
    return memo(H2);
  })(),
  h3: (() => {
    const H3 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "h3", variant: "h3", gutterBottom: true });
    return memo(H3);
  })(),
  h4: (() => {
    const H4 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "h4", variant: "h4", gutterBottom: true });
    return memo(H4);
  })(),
  h5: (() => {
    const H5 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "h5", variant: "h5", gutterBottom: true });
    return memo(H5);
  })(),
  h6: (() => {
    const H6 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "h6", variant: "h6", gutterBottom: true });
    return memo(H6);
  })(),
  img: (() => {
    const Img = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(KBlogImage, { ...props });
    return memo(Img);
  })(),
  // No cases for
  // subtitle1
  // subtitle2
  s: (() => {
    const S = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "p", variant: "p", gutterBottom: true, sx: { textDecoration: "line-through" } });
    return memo(S);
  })(),
  blockquote: (() => {
    const Blockquote = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { style: { borderLeft: "4px solid grey", padding: 8 }, ...props });
    return memo(Blockquote);
  })(),
  ul: (() => {
    const Ul = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "ul" });
    return memo(Ul);
  })(),
  ol: (() => {
    const Ol = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "ol" });
    return memo(Ol);
  })(),
  li: (() => {
    const Li = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { ...props, component: "li" });
    return memo(Li);
  })(),
  table: (() => {
    const Table$1 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { ...props });
    return memo(Table$1);
  })(),
  tr: (() => {
    const Tr = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableRow, { ...props });
    return memo(Tr);
  })(),
  td: (() => {
    const Td = ({ align, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableCell, { align: align || void 0, ...props });
    return memo(Td);
  })(),
  tbody: (() => {
    const TBody = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableBody, { ...props });
    return memo(TBody);
  })(),
  th: (() => {
    const Th = ({ align, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableCell, { align: align || void 0, ...props });
    return memo(Th);
  })(),
  thead: (() => {
    const THead = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableHead, { ...props });
    return memo(THead);
  })(),
  //code: MDXCodeBlock,
  hr: Divider,
  input: (() => {
    const Input2 = (props) => {
      const { type } = props;
      if (type === "checkbox") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { ...props, disabled: false, readOnly: true });
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx("input", { ...props });
    };
    return memo(Input2);
  })(),
  wrapper: (() => {
    const Wrapper = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...props, className: "markdown-body" });
    return memo(Wrapper);
  })()
};
var components$2 = { exports: {} };
var hasRequiredComponents;
function requireComponents() {
  if (hasRequiredComponents) return components$2.exports;
  hasRequiredComponents = 1;
  (function(module) {
    var components2 = { "core": { "meta": { "path": "components/prism-core.js", "option": "mandatory" }, "core": "Core" }, "themes": { "meta": { "path": "themes/{id}.css", "link": "index.html?theme={id}", "exclusive": true }, "prism": { "title": "Default", "option": "default" }, "prism-dark": "Dark", "prism-funky": "Funky", "prism-okaidia": { "title": "Okaidia", "owner": "ocodia" }, "prism-twilight": { "title": "Twilight", "owner": "remybach" }, "prism-coy": { "title": "Coy", "owner": "tshedor" }, "prism-solarizedlight": { "title": "Solarized Light", "owner": "hectormatos2011 " }, "prism-tomorrow": { "title": "Tomorrow Night", "owner": "Rosey" } }, "languages": { "meta": { "path": "components/prism-{id}", "noCSS": true, "examplesPath": "examples/prism-{id}", "addCheckAll": true }, "markup": { "title": "Markup", "alias": ["html", "xml", "svg", "mathml", "ssml", "atom", "rss"], "aliasTitles": { "html": "HTML", "xml": "XML", "svg": "SVG", "mathml": "MathML", "ssml": "SSML", "atom": "Atom", "rss": "RSS" }, "option": "default" }, "css": { "title": "CSS", "option": "default", "modify": "markup" }, "clike": { "title": "C-like", "option": "default" }, "javascript": { "title": "JavaScript", "require": "clike", "modify": "markup", "optional": "regex", "alias": "js", "option": "default" }, "abap": { "title": "ABAP", "owner": "dellagustin" }, "abnf": { "title": "ABNF", "owner": "RunDevelopment" }, "actionscript": { "title": "ActionScript", "require": "javascript", "modify": "markup", "owner": "Golmote" }, "ada": { "title": "Ada", "owner": "Lucretia" }, "agda": { "title": "Agda", "owner": "xy-ren" }, "al": { "title": "AL", "owner": "RunDevelopment" }, "antlr4": { "title": "ANTLR4", "alias": "g4", "owner": "RunDevelopment" }, "apacheconf": { "title": "Apache Configuration", "owner": "GuiTeK" }, "apex": { "title": "Apex", "require": ["clike", "sql"], "owner": "RunDevelopment" }, "apl": { "title": "APL", "owner": "ngn" }, "applescript": { "title": "AppleScript", "owner": "Golmote" }, "aql": { "title": "AQL", "owner": "RunDevelopment" }, "arduino": { "title": "Arduino", "require": "cpp", "alias": "ino", "owner": "dkern" }, "arff": { "title": "ARFF", "owner": "Golmote" }, "armasm": { "title": "ARM Assembly", "alias": "arm-asm", "owner": "RunDevelopment" }, "arturo": { "title": "Arturo", "alias": "art", "optional": ["bash", "css", "javascript", "markup", "markdown", "sql"], "owner": "drkameleon" }, "asciidoc": { "alias": "adoc", "title": "AsciiDoc", "owner": "Golmote" }, "aspnet": { "title": "ASP.NET (C#)", "require": ["markup", "csharp"], "owner": "nauzilus" }, "asm6502": { "title": "6502 Assembly", "owner": "kzurawel" }, "asmatmel": { "title": "Atmel AVR Assembly", "owner": "cerkit" }, "autohotkey": { "title": "AutoHotkey", "owner": "aviaryan" }, "autoit": { "title": "AutoIt", "owner": "Golmote" }, "avisynth": { "title": "AviSynth", "alias": "avs", "owner": "Zinfidel" }, "avro-idl": { "title": "Avro IDL", "alias": "avdl", "owner": "RunDevelopment" }, "awk": { "title": "AWK", "alias": "gawk", "aliasTitles": { "gawk": "GAWK" }, "owner": "RunDevelopment" }, "bash": { "title": "Bash", "alias": ["sh", "shell"], "aliasTitles": { "sh": "Shell", "shell": "Shell" }, "owner": "zeitgeist87" }, "basic": { "title": "BASIC", "owner": "Golmote" }, "batch": { "title": "Batch", "owner": "Golmote" }, "bbcode": { "title": "BBcode", "alias": "shortcode", "aliasTitles": { "shortcode": "Shortcode" }, "owner": "RunDevelopment" }, "bbj": { "title": "BBj", "owner": "hyyan" }, "bicep": { "title": "Bicep", "owner": "johnnyreilly" }, "birb": { "title": "Birb", "require": "clike", "owner": "Calamity210" }, "bison": { "title": "Bison", "require": "c", "owner": "Golmote" }, "bnf": { "title": "BNF", "alias": "rbnf", "aliasTitles": { "rbnf": "RBNF" }, "owner": "RunDevelopment" }, "bqn": { "title": "BQN", "owner": "yewscion" }, "brainfuck": { "title": "Brainfuck", "owner": "Golmote" }, "brightscript": { "title": "BrightScript", "owner": "RunDevelopment" }, "bro": { "title": "Bro", "owner": "wayward710" }, "bsl": { "title": "BSL (1C:Enterprise)", "alias": "oscript", "aliasTitles": { "oscript": "OneScript" }, "owner": "Diversus23" }, "c": { "title": "C", "require": "clike", "owner": "zeitgeist87" }, "csharp": { "title": "C#", "require": "clike", "alias": ["cs", "dotnet"], "owner": "mvalipour" }, "cpp": { "title": "C++", "require": "c", "owner": "zeitgeist87" }, "cfscript": { "title": "CFScript", "require": "clike", "alias": "cfc", "owner": "mjclemente" }, "chaiscript": { "title": "ChaiScript", "require": ["clike", "cpp"], "owner": "RunDevelopment" }, "cil": { "title": "CIL", "owner": "sbrl" }, "cilkc": { "title": "Cilk/C", "require": "c", "alias": "cilk-c", "owner": "OpenCilk" }, "cilkcpp": { "title": "Cilk/C++", "require": "cpp", "alias": ["cilk-cpp", "cilk"], "owner": "OpenCilk" }, "clojure": { "title": "Clojure", "owner": "troglotit" }, "cmake": { "title": "CMake", "owner": "mjrogozinski" }, "cobol": { "title": "COBOL", "owner": "RunDevelopment" }, "coffeescript": { "title": "CoffeeScript", "require": "javascript", "alias": "coffee", "owner": "R-osey" }, "concurnas": { "title": "Concurnas", "alias": "conc", "owner": "jasontatton" }, "csp": { "title": "Content-Security-Policy", "owner": "ScottHelme" }, "cooklang": { "title": "Cooklang", "owner": "ahue" }, "coq": { "title": "Coq", "owner": "RunDevelopment" }, "crystal": { "title": "Crystal", "require": "ruby", "owner": "MakeNowJust" }, "css-extras": { "title": "CSS Extras", "require": "css", "modify": "css", "owner": "milesj" }, "csv": { "title": "CSV", "owner": "RunDevelopment" }, "cue": { "title": "CUE", "owner": "RunDevelopment" }, "cypher": { "title": "Cypher", "owner": "RunDevelopment" }, "d": { "title": "D", "require": "clike", "owner": "Golmote" }, "dart": { "title": "Dart", "require": "clike", "owner": "Golmote" }, "dataweave": { "title": "DataWeave", "owner": "machaval" }, "dax": { "title": "DAX", "owner": "peterbud" }, "dhall": { "title": "Dhall", "owner": "RunDevelopment" }, "diff": { "title": "Diff", "owner": "uranusjr" }, "django": { "title": "Django/Jinja2", "require": "markup-templating", "alias": "jinja2", "owner": "romanvm" }, "dns-zone-file": { "title": "DNS zone file", "owner": "RunDevelopment", "alias": "dns-zone" }, "docker": { "title": "Docker", "alias": "dockerfile", "owner": "JustinBeckwith" }, "dot": { "title": "DOT (Graphviz)", "alias": "gv", "optional": "markup", "owner": "RunDevelopment" }, "ebnf": { "title": "EBNF", "owner": "RunDevelopment" }, "editorconfig": { "title": "EditorConfig", "owner": "osipxd" }, "eiffel": { "title": "Eiffel", "owner": "Conaclos" }, "ejs": { "title": "EJS", "require": ["javascript", "markup-templating"], "owner": "RunDevelopment", "alias": "eta", "aliasTitles": { "eta": "Eta" } }, "elixir": { "title": "Elixir", "owner": "Golmote" }, "elm": { "title": "Elm", "owner": "zwilias" }, "etlua": { "title": "Embedded Lua templating", "require": ["lua", "markup-templating"], "owner": "RunDevelopment" }, "erb": { "title": "ERB", "require": ["ruby", "markup-templating"], "owner": "Golmote" }, "erlang": { "title": "Erlang", "owner": "Golmote" }, "excel-formula": { "title": "Excel Formula", "alias": ["xlsx", "xls"], "owner": "RunDevelopment" }, "fsharp": { "title": "F#", "require": "clike", "owner": "simonreynolds7" }, "factor": { "title": "Factor", "owner": "catb0t" }, "false": { "title": "False", "owner": "edukisto" }, "firestore-security-rules": { "title": "Firestore security rules", "require": "clike", "owner": "RunDevelopment" }, "flow": { "title": "Flow", "require": "javascript", "owner": "Golmote" }, "fortran": { "title": "Fortran", "owner": "Golmote" }, "ftl": { "title": "FreeMarker Template Language", "require": "markup-templating", "owner": "RunDevelopment" }, "gml": { "title": "GameMaker Language", "alias": "gamemakerlanguage", "require": "clike", "owner": "LiarOnce" }, "gap": { "title": "GAP (CAS)", "owner": "RunDevelopment" }, "gcode": { "title": "G-code", "owner": "RunDevelopment" }, "gdscript": { "title": "GDScript", "owner": "RunDevelopment" }, "gedcom": { "title": "GEDCOM", "owner": "Golmote" }, "gettext": { "title": "gettext", "alias": "po", "owner": "RunDevelopment" }, "gherkin": { "title": "Gherkin", "owner": "hason" }, "git": { "title": "Git", "owner": "lgiraudel" }, "glsl": { "title": "GLSL", "require": "c", "owner": "Golmote" }, "gn": { "title": "GN", "alias": "gni", "owner": "RunDevelopment" }, "linker-script": { "title": "GNU Linker Script", "alias": "ld", "owner": "RunDevelopment" }, "go": { "title": "Go", "require": "clike", "owner": "arnehormann" }, "go-module": { "title": "Go module", "alias": "go-mod", "owner": "RunDevelopment" }, "gradle": { "title": "Gradle", "require": "clike", "owner": "zeabdelkhalek-badido18" }, "graphql": { "title": "GraphQL", "optional": "markdown", "owner": "Golmote" }, "groovy": { "title": "Groovy", "require": "clike", "owner": "robfletcher" }, "haml": { "title": "Haml", "require": "ruby", "optional": ["css", "css-extras", "coffeescript", "erb", "javascript", "less", "markdown", "scss", "textile"], "owner": "Golmote" }, "handlebars": { "title": "Handlebars", "require": "markup-templating", "alias": ["hbs", "mustache"], "aliasTitles": { "mustache": "Mustache" }, "owner": "Golmote" }, "haskell": { "title": "Haskell", "alias": "hs", "owner": "bholst" }, "haxe": { "title": "Haxe", "require": "clike", "optional": "regex", "owner": "Golmote" }, "hcl": { "title": "HCL", "owner": "outsideris" }, "hlsl": { "title": "HLSL", "require": "c", "owner": "RunDevelopment" }, "hoon": { "title": "Hoon", "owner": "matildepark" }, "http": { "title": "HTTP", "optional": ["csp", "css", "hpkp", "hsts", "javascript", "json", "markup", "uri"], "owner": "danielgtaylor" }, "hpkp": { "title": "HTTP Public-Key-Pins", "owner": "ScottHelme" }, "hsts": { "title": "HTTP Strict-Transport-Security", "owner": "ScottHelme" }, "ichigojam": { "title": "IchigoJam", "owner": "BlueCocoa" }, "icon": { "title": "Icon", "owner": "Golmote" }, "icu-message-format": { "title": "ICU Message Format", "owner": "RunDevelopment" }, "idris": { "title": "Idris", "alias": "idr", "owner": "KeenS", "require": "haskell" }, "ignore": { "title": ".ignore", "owner": "osipxd", "alias": ["gitignore", "hgignore", "npmignore"], "aliasTitles": { "gitignore": ".gitignore", "hgignore": ".hgignore", "npmignore": ".npmignore" } }, "inform7": { "title": "Inform 7", "owner": "Golmote" }, "ini": { "title": "Ini", "owner": "aviaryan" }, "io": { "title": "Io", "owner": "AlesTsurko" }, "j": { "title": "J", "owner": "Golmote" }, "java": { "title": "Java", "require": "clike", "owner": "sherblot" }, "javadoc": { "title": "JavaDoc", "require": ["markup", "java", "javadoclike"], "modify": "java", "optional": "scala", "owner": "RunDevelopment" }, "javadoclike": { "title": "JavaDoc-like", "modify": ["java", "javascript", "php"], "owner": "RunDevelopment" }, "javastacktrace": { "title": "Java stack trace", "owner": "RunDevelopment" }, "jexl": { "title": "Jexl", "owner": "czosel" }, "jolie": { "title": "Jolie", "require": "clike", "owner": "thesave" }, "jq": { "title": "JQ", "owner": "RunDevelopment" }, "jsdoc": { "title": "JSDoc", "require": ["javascript", "javadoclike", "typescript"], "modify": "javascript", "optional": ["actionscript", "coffeescript"], "owner": "RunDevelopment" }, "js-extras": { "title": "JS Extras", "require": "javascript", "modify": "javascript", "optional": ["actionscript", "coffeescript", "flow", "n4js", "typescript"], "owner": "RunDevelopment" }, "json": { "title": "JSON", "alias": "webmanifest", "aliasTitles": { "webmanifest": "Web App Manifest" }, "owner": "CupOfTea696" }, "json5": { "title": "JSON5", "require": "json", "owner": "RunDevelopment" }, "jsonp": { "title": "JSONP", "require": "json", "owner": "RunDevelopment" }, "jsstacktrace": { "title": "JS stack trace", "owner": "sbrl" }, "js-templates": { "title": "JS Templates", "require": "javascript", "modify": "javascript", "optional": ["css", "css-extras", "graphql", "markdown", "markup", "sql"], "owner": "RunDevelopment" }, "julia": { "title": "Julia", "owner": "cdagnino" }, "keepalived": { "title": "Keepalived Configure", "owner": "dev-itsheng" }, "keyman": { "title": "Keyman", "owner": "mcdurdin" }, "kotlin": { "title": "Kotlin", "alias": ["kt", "kts"], "aliasTitles": { "kts": "Kotlin Script" }, "require": "clike", "owner": "Golmote" }, "kumir": { "title": "KuMir (КуМир)", "alias": "kum", "owner": "edukisto" }, "kusto": { "title": "Kusto", "owner": "RunDevelopment" }, "latex": { "title": "LaTeX", "alias": ["tex", "context"], "aliasTitles": { "tex": "TeX", "context": "ConTeXt" }, "owner": "japborst" }, "latte": { "title": "Latte", "require": ["clike", "markup-templating", "php"], "owner": "nette" }, "less": { "title": "Less", "require": "css", "optional": "css-extras", "owner": "Golmote" }, "lilypond": { "title": "LilyPond", "require": "scheme", "alias": "ly", "owner": "RunDevelopment" }, "liquid": { "title": "Liquid", "require": "markup-templating", "owner": "cinhtau" }, "lisp": { "title": "Lisp", "alias": ["emacs", "elisp", "emacs-lisp"], "owner": "JuanCaicedo" }, "livescript": { "title": "LiveScript", "owner": "Golmote" }, "llvm": { "title": "LLVM IR", "owner": "porglezomp" }, "log": { "title": "Log file", "optional": "javastacktrace", "owner": "RunDevelopment" }, "lolcode": { "title": "LOLCODE", "owner": "Golmote" }, "lua": { "title": "Lua", "owner": "Golmote" }, "magma": { "title": "Magma (CAS)", "owner": "RunDevelopment" }, "makefile": { "title": "Makefile", "owner": "Golmote" }, "markdown": { "title": "Markdown", "require": "markup", "optional": "yaml", "alias": "md", "owner": "Golmote" }, "markup-templating": { "title": "Markup templating", "require": "markup", "owner": "Golmote" }, "mata": { "title": "Mata", "owner": "RunDevelopment" }, "matlab": { "title": "MATLAB", "owner": "Golmote" }, "maxscript": { "title": "MAXScript", "owner": "RunDevelopment" }, "mel": { "title": "MEL", "owner": "Golmote" }, "mermaid": { "title": "Mermaid", "owner": "RunDevelopment" }, "metafont": { "title": "METAFONT", "owner": "LaeriExNihilo" }, "mizar": { "title": "Mizar", "owner": "Golmote" }, "mongodb": { "title": "MongoDB", "owner": "airs0urce", "require": "javascript" }, "monkey": { "title": "Monkey", "owner": "Golmote" }, "moonscript": { "title": "MoonScript", "alias": "moon", "owner": "RunDevelopment" }, "n1ql": { "title": "N1QL", "owner": "TMWilds" }, "n4js": { "title": "N4JS", "require": "javascript", "optional": "jsdoc", "alias": "n4jsd", "owner": "bsmith-n4" }, "nand2tetris-hdl": { "title": "Nand To Tetris HDL", "owner": "stephanmax" }, "naniscript": { "title": "Naninovel Script", "owner": "Elringus", "alias": "nani" }, "nasm": { "title": "NASM", "owner": "rbmj" }, "neon": { "title": "NEON", "owner": "nette" }, "nevod": { "title": "Nevod", "owner": "nezaboodka" }, "nginx": { "title": "nginx", "owner": "volado" }, "nim": { "title": "Nim", "owner": "Golmote" }, "nix": { "title": "Nix", "owner": "Golmote" }, "nsis": { "title": "NSIS", "owner": "idleberg" }, "objectivec": { "title": "Objective-C", "require": "c", "alias": "objc", "owner": "uranusjr" }, "ocaml": { "title": "OCaml", "owner": "Golmote" }, "odin": { "title": "Odin", "owner": "edukisto" }, "opencl": { "title": "OpenCL", "require": "c", "modify": ["c", "cpp"], "owner": "Milania1" }, "openqasm": { "title": "OpenQasm", "alias": "qasm", "owner": "RunDevelopment" }, "oz": { "title": "Oz", "owner": "Golmote" }, "parigp": { "title": "PARI/GP", "owner": "Golmote" }, "parser": { "title": "Parser", "require": "markup", "owner": "Golmote" }, "pascal": { "title": "Pascal", "alias": "objectpascal", "aliasTitles": { "objectpascal": "Object Pascal" }, "owner": "Golmote" }, "pascaligo": { "title": "Pascaligo", "owner": "DefinitelyNotAGoat" }, "psl": { "title": "PATROL Scripting Language", "owner": "bertysentry" }, "pcaxis": { "title": "PC-Axis", "alias": "px", "owner": "RunDevelopment" }, "peoplecode": { "title": "PeopleCode", "alias": "pcode", "owner": "RunDevelopment" }, "perl": { "title": "Perl", "owner": "Golmote" }, "php": { "title": "PHP", "require": "markup-templating", "owner": "milesj" }, "phpdoc": { "title": "PHPDoc", "require": ["php", "javadoclike"], "modify": "php", "owner": "RunDevelopment" }, "php-extras": { "title": "PHP Extras", "require": "php", "modify": "php", "owner": "milesj" }, "plant-uml": { "title": "PlantUML", "alias": "plantuml", "owner": "RunDevelopment" }, "plsql": { "title": "PL/SQL", "require": "sql", "owner": "Golmote" }, "powerquery": { "title": "PowerQuery", "alias": ["pq", "mscript"], "owner": "peterbud" }, "powershell": { "title": "PowerShell", "owner": "nauzilus" }, "processing": { "title": "Processing", "require": "clike", "owner": "Golmote" }, "prolog": { "title": "Prolog", "owner": "Golmote" }, "promql": { "title": "PromQL", "owner": "arendjr" }, "properties": { "title": ".properties", "owner": "Golmote" }, "protobuf": { "title": "Protocol Buffers", "require": "clike", "owner": "just-boris" }, "pug": { "title": "Pug", "require": ["markup", "javascript"], "optional": ["coffeescript", "ejs", "handlebars", "less", "livescript", "markdown", "scss", "stylus", "twig"], "owner": "Golmote" }, "puppet": { "title": "Puppet", "owner": "Golmote" }, "pure": { "title": "Pure", "optional": ["c", "cpp", "fortran"], "owner": "Golmote" }, "purebasic": { "title": "PureBasic", "require": "clike", "alias": "pbfasm", "owner": "HeX0R101" }, "purescript": { "title": "PureScript", "require": "haskell", "alias": "purs", "owner": "sriharshachilakapati" }, "python": { "title": "Python", "alias": "py", "owner": "multipetros" }, "qsharp": { "title": "Q#", "require": "clike", "alias": "qs", "owner": "fedonman" }, "q": { "title": "Q (kdb+ database)", "owner": "Golmote" }, "qml": { "title": "QML", "require": "javascript", "owner": "RunDevelopment" }, "qore": { "title": "Qore", "require": "clike", "owner": "temnroegg" }, "r": { "title": "R", "owner": "Golmote" }, "racket": { "title": "Racket", "require": "scheme", "alias": "rkt", "owner": "RunDevelopment" }, "cshtml": { "title": "Razor C#", "alias": "razor", "require": ["markup", "csharp"], "optional": ["css", "css-extras", "javascript", "js-extras"], "owner": "RunDevelopment" }, "jsx": { "title": "React JSX", "require": ["markup", "javascript"], "optional": ["jsdoc", "js-extras", "js-templates"], "owner": "vkbansal" }, "tsx": { "title": "React TSX", "require": ["jsx", "typescript"] }, "reason": { "title": "Reason", "require": "clike", "owner": "Golmote" }, "regex": { "title": "Regex", "owner": "RunDevelopment" }, "rego": { "title": "Rego", "owner": "JordanSh" }, "renpy": { "title": "Ren'py", "alias": "rpy", "owner": "HyuchiaDiego" }, "rescript": { "title": "ReScript", "alias": "res", "owner": "vmarcosp" }, "rest": { "title": "reST (reStructuredText)", "owner": "Golmote" }, "rip": { "title": "Rip", "owner": "ravinggenius" }, "roboconf": { "title": "Roboconf", "owner": "Golmote" }, "robotframework": { "title": "Robot Framework", "alias": "robot", "owner": "RunDevelopment" }, "ruby": { "title": "Ruby", "require": "clike", "alias": "rb", "owner": "samflores" }, "rust": { "title": "Rust", "owner": "Golmote" }, "sas": { "title": "SAS", "optional": ["groovy", "lua", "sql"], "owner": "Golmote" }, "sass": { "title": "Sass (Sass)", "require": "css", "optional": "css-extras", "owner": "Golmote" }, "scss": { "title": "Sass (SCSS)", "require": "css", "optional": "css-extras", "owner": "MoOx" }, "scala": { "title": "Scala", "require": "java", "owner": "jozic" }, "scheme": { "title": "Scheme", "owner": "bacchus123" }, "shell-session": { "title": "Shell session", "require": "bash", "alias": ["sh-session", "shellsession"], "owner": "RunDevelopment" }, "smali": { "title": "Smali", "owner": "RunDevelopment" }, "smalltalk": { "title": "Smalltalk", "owner": "Golmote" }, "smarty": { "title": "Smarty", "require": "markup-templating", "optional": "php", "owner": "Golmote" }, "sml": { "title": "SML", "alias": "smlnj", "aliasTitles": { "smlnj": "SML/NJ" }, "owner": "RunDevelopment" }, "solidity": { "title": "Solidity (Ethereum)", "alias": "sol", "require": "clike", "owner": "glachaud" }, "solution-file": { "title": "Solution file", "alias": "sln", "owner": "RunDevelopment" }, "soy": { "title": "Soy (Closure Template)", "require": "markup-templating", "owner": "Golmote" }, "sparql": { "title": "SPARQL", "require": "turtle", "owner": "Triply-Dev", "alias": "rq" }, "splunk-spl": { "title": "Splunk SPL", "owner": "RunDevelopment" }, "sqf": { "title": "SQF: Status Quo Function (Arma 3)", "require": "clike", "owner": "RunDevelopment" }, "sql": { "title": "SQL", "owner": "multipetros" }, "squirrel": { "title": "Squirrel", "require": "clike", "owner": "RunDevelopment" }, "stan": { "title": "Stan", "owner": "RunDevelopment" }, "stata": { "title": "Stata Ado", "require": ["mata", "java", "python"], "owner": "RunDevelopment" }, "iecst": { "title": "Structured Text (IEC 61131-3)", "owner": "serhioromano" }, "stylus": { "title": "Stylus", "owner": "vkbansal" }, "supercollider": { "title": "SuperCollider", "alias": "sclang", "owner": "RunDevelopment" }, "swift": { "title": "Swift", "owner": "chrischares" }, "systemd": { "title": "Systemd configuration file", "owner": "RunDevelopment" }, "t4-templating": { "title": "T4 templating", "owner": "RunDevelopment" }, "t4-cs": { "title": "T4 Text Templates (C#)", "require": ["t4-templating", "csharp"], "alias": "t4", "owner": "RunDevelopment" }, "t4-vb": { "title": "T4 Text Templates (VB)", "require": ["t4-templating", "vbnet"], "owner": "RunDevelopment" }, "tap": { "title": "TAP", "owner": "isaacs", "require": "yaml" }, "tcl": { "title": "Tcl", "owner": "PeterChaplin" }, "tt2": { "title": "Template Toolkit 2", "require": ["clike", "markup-templating"], "owner": "gflohr" }, "textile": { "title": "Textile", "require": "markup", "optional": "css", "owner": "Golmote" }, "toml": { "title": "TOML", "owner": "RunDevelopment" }, "tremor": { "title": "Tremor", "alias": ["trickle", "troy"], "owner": "darach", "aliasTitles": { "trickle": "trickle", "troy": "troy" } }, "turtle": { "title": "Turtle", "alias": "trig", "aliasTitles": { "trig": "TriG" }, "owner": "jakubklimek" }, "twig": { "title": "Twig", "require": "markup-templating", "owner": "brandonkelly" }, "typescript": { "title": "TypeScript", "require": "javascript", "optional": "js-templates", "alias": "ts", "owner": "vkbansal" }, "typoscript": { "title": "TypoScript", "alias": "tsconfig", "aliasTitles": { "tsconfig": "TSConfig" }, "owner": "dkern" }, "unrealscript": { "title": "UnrealScript", "alias": ["uscript", "uc"], "owner": "RunDevelopment" }, "uorazor": { "title": "UO Razor Script", "owner": "jaseowns" }, "uri": { "title": "URI", "alias": "url", "aliasTitles": { "url": "URL" }, "owner": "RunDevelopment" }, "v": { "title": "V", "require": "clike", "owner": "taggon" }, "vala": { "title": "Vala", "require": "clike", "optional": "regex", "owner": "TemplarVolk" }, "vbnet": { "title": "VB.Net", "require": "basic", "owner": "Bigsby" }, "velocity": { "title": "Velocity", "require": "markup", "owner": "Golmote" }, "verilog": { "title": "Verilog", "owner": "a-rey" }, "vhdl": { "title": "VHDL", "owner": "a-rey" }, "vim": { "title": "vim", "owner": "westonganger" }, "visual-basic": { "title": "Visual Basic", "alias": ["vb", "vba"], "aliasTitles": { "vba": "VBA" }, "owner": "Golmote" }, "warpscript": { "title": "WarpScript", "owner": "RunDevelopment" }, "wasm": { "title": "WebAssembly", "owner": "Golmote" }, "web-idl": { "title": "Web IDL", "alias": "webidl", "owner": "RunDevelopment" }, "wgsl": { "title": "WGSL", "owner": "Dr4gonthree" }, "wiki": { "title": "Wiki markup", "require": "markup", "owner": "Golmote" }, "wolfram": { "title": "Wolfram language", "alias": ["mathematica", "nb", "wl"], "aliasTitles": { "mathematica": "Mathematica", "nb": "Mathematica Notebook" }, "owner": "msollami" }, "wren": { "title": "Wren", "owner": "clsource" }, "xeora": { "title": "Xeora", "require": "markup", "alias": "xeoracube", "aliasTitles": { "xeoracube": "XeoraCube" }, "owner": "freakmaxi" }, "xml-doc": { "title": "XML doc (.net)", "require": "markup", "modify": ["csharp", "fsharp", "vbnet"], "owner": "RunDevelopment" }, "xojo": { "title": "Xojo (REALbasic)", "owner": "Golmote" }, "xquery": { "title": "XQuery", "require": "markup", "owner": "Golmote" }, "yaml": { "title": "YAML", "alias": "yml", "owner": "hason" }, "yang": { "title": "YANG", "owner": "RunDevelopment" }, "zig": { "title": "Zig", "owner": "RunDevelopment" } }, "plugins": { "meta": { "path": "plugins/{id}/prism-{id}", "link": "plugins/{id}/" }, "line-highlight": { "title": "Line Highlight", "description": "Highlights specific lines and/or line ranges." }, "line-numbers": { "title": "Line Numbers", "description": "Line number at the beginning of code lines.", "owner": "kuba-kubula" }, "show-invisibles": { "title": "Show Invisibles", "description": "Show hidden characters such as tabs and line breaks.", "optional": ["autolinker", "data-uri-highlight"] }, "autolinker": { "title": "Autolinker", "description": "Converts URLs and emails in code to clickable links. Parses Markdown links in comments." }, "wpd": { "title": "WebPlatform Docs", "description": 'Makes tokens link to <a href="https://webplatform.github.io/docs/">WebPlatform.org documentation</a>. The links open in a new tab.' }, "custom-class": { "title": "Custom Class", "description": "This plugin allows you to prefix Prism's default classes (<code>.comment</code> can become <code>.namespace--comment</code>) or replace them with your defined ones (like <code>.editor__comment</code>). You can even add new classes.", "owner": "dvkndn", "noCSS": true }, "file-highlight": { "title": "File Highlight", "description": "Fetch external files and highlight them with Prism. Used on the Prism website itself.", "noCSS": true }, "show-language": { "title": "Show Language", "description": "Display the highlighted language in code blocks (inline code does not show the label).", "owner": "nauzilus", "noCSS": true, "require": "toolbar" }, "jsonp-highlight": { "title": "JSONP Highlight", "description": "Fetch content with JSONP and highlight some interesting content (e.g. GitHub/Gists or Bitbucket API).", "noCSS": true, "owner": "nauzilus" }, "highlight-keywords": { "title": "Highlight Keywords", "description": "Adds special CSS classes for each keyword for fine-grained highlighting.", "owner": "vkbansal", "noCSS": true }, "remove-initial-line-feed": { "title": "Remove initial line feed", "description": "Removes the initial line feed in code blocks.", "owner": "Golmote", "noCSS": true }, "inline-color": { "title": "Inline color", "description": "Adds a small inline preview for colors in style sheets.", "require": "css-extras", "owner": "RunDevelopment" }, "previewers": { "title": "Previewers", "description": "Previewers for angles, colors, gradients, easing and time.", "require": "css-extras", "owner": "Golmote" }, "autoloader": { "title": "Autoloader", "description": "Automatically loads the needed languages to highlight the code blocks.", "owner": "Golmote", "noCSS": true }, "keep-markup": { "title": "Keep Markup", "description": "Prevents custom markup from being dropped out during highlighting.", "owner": "Golmote", "optional": "normalize-whitespace", "noCSS": true }, "command-line": { "title": "Command Line", "description": "Display a command line with a prompt and, optionally, the output/response from the commands.", "owner": "chriswells0" }, "unescaped-markup": { "title": "Unescaped Markup", "description": "Write markup without having to escape anything." }, "normalize-whitespace": { "title": "Normalize Whitespace", "description": "Supports multiple operations to normalize whitespace in code blocks.", "owner": "zeitgeist87", "optional": "unescaped-markup", "noCSS": true }, "data-uri-highlight": { "title": "Data-URI Highlight", "description": "Highlights data-URI contents.", "owner": "Golmote", "noCSS": true }, "toolbar": { "title": "Toolbar", "description": "Attach a toolbar for plugins to easily register buttons on the top of a code block.", "owner": "mAAdhaTTah" }, "copy-to-clipboard": { "title": "Copy to Clipboard Button", "description": "Add a button that copies the code block to the clipboard when clicked.", "owner": "mAAdhaTTah", "require": "toolbar", "noCSS": true }, "download-button": { "title": "Download Button", "description": "A button in the toolbar of a code block adding a convenient way to download a code file.", "owner": "Golmote", "require": "toolbar", "noCSS": true }, "match-braces": { "title": "Match braces", "description": "Highlights matching braces.", "owner": "RunDevelopment" }, "diff-highlight": { "title": "Diff Highlight", "description": "Highlights the code inside diff blocks.", "owner": "RunDevelopment", "require": "diff" }, "filter-highlight-all": { "title": "Filter highlightAll", "description": "Filters the elements the <code>highlightAll</code> and <code>highlightAllUnder</code> methods actually highlight.", "owner": "RunDevelopment", "noCSS": true }, "treeview": { "title": "Treeview", "description": "A language with special styles to highlight file system tree structures.", "owner": "Golmote" } } };
    if (module.exports) {
      module.exports = components2;
    }
  })(components$2);
  return components$2.exports;
}
var componentsExports = requireComponents();
const components$1 = /* @__PURE__ */ getDefaultExportFromCjs(componentsExports);
const nativeLanguages = components$1.languages;
const nativePairs = Object.assign(
  ...Object.entries(nativeLanguages).map(([key, value2]) => ({
    [key]: { key, lang: value2 }
  }))
);
const pairs = Object.assign(
  ...Object.entries(nativePairs).filter(([key, value2]) => value2.lang.alias).map(([key, value2]) => {
    const alias = Array.isArray(value2.lang.alias) ? value2.lang.alias : [value2.lang.alias];
    return Object.assign(...alias.map((a) => ({ [a]: value2 })));
  }),
  nativePairs
);
const importLang = async (language) => {
  const { key, lang } = pairs[language];
  if (!key) {
    return;
  }
  if (lang.require) {
    const req = Array.isArray(lang.require) ? lang.require : [lang.require];
    await Promise.all(req.map((language2) => importLang(language2)));
  }
  await import(
    /* @vite-ignore */
    `prismjs/components/prism-${key}`
  );
};
const MDXCodeBlock = ({ children, className }) => {
  const language = useMemo(() => className ? className.replace(/language-/, "") : "", [
    className
  ]);
  const { key } = useMemo(() => pairs[language] || {}, [language]);
  const canBeHighlighted = useMemo(() => Boolean(key), [key]);
  const [isReady, setIsReady] = useState(!canBeHighlighted);
  useEffect(() => {
    let isCanceled = false;
    setIsReady(!canBeHighlighted);
    if (canBeHighlighted) {
      (async () => {
        await importLang(language);
        if (isCanceled) return;
        setIsReady(true);
      })();
    }
    return () => {
      isCanceled = true;
    };
  }, [canBeHighlighted, language]);
  const html = useMemo(() => {
    if (!isReady || !canBeHighlighted) {
      return Prism.util.encode(children);
    }
    return Prism.highlight(children, Prism.languages[language], language);
  }, [canBeHighlighted, children, isReady, language]);
  const createMarkup = useCallback(() => ({ __html: html }), [html]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("code", { className: `language-${language}`, dangerouslySetInnerHTML: createMarkup() });
};
const SampleMdxComponent = (props) => {
  useTheme();
  const { description } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    "hello from MdxSampleComponent and the passed description parameter is : ",
    description
  ] });
};
const SampleMdxSection = ({ children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children }) }) });
};
const SampleTitleBar = ({ text, size, bkgdColor }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    style: {
      margin: "2rem",
      padding: "5rem",
      backgroundColor: bkgdColor || "#fff"
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "h2",
      {
        style: {
          fontSize: size || "18px",
          margin: 0
        },
        children: text
      }
    )
  }
);
function Articles({ metas }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: metas.map((meta) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: `/posts/${meta.slug}`, children: meta.title }),
      meta.draft ? " (draft)" : ""
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: meta.excerpt }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: meta.tags && meta.tags.map((tag) => /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: `/tags/${tag}`, children: tag }, tag)) })
  ] }, meta.slug)) });
}
const container = {
  position: "relative",
  paddingBottom: "56.25%",
  height: 0,
  overflow: "hidden",
  maxWidth: "100%"
};
const frame = {
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  border: 0,
  position: "absolute"
};
function YouTube({ id }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...container }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "iframe",
    {
      src: `https://www.youtube.com/embed/${id}`,
      allow: "autoplay; encrypted-media",
      title: "Embedded YouTube video",
      style: { ...frame }
    }
  ) });
}
const Highlight = ({ children, color: color2 }) => jsxRuntimeExports.jsx("span", {
  style: {
    backgroundColor: color2,
    borderRadius: "2px",
    color: "#fff",
    padding: "0.2rem"
  },
  children
});
function _createMdxContent$2(props) {
  const _components = {
    a: "a",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    p: "p",
    ...useMDXComponents(),
    ...props.components
  };
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(_components.h2, {
      children: "Frequently Asked Questions"
    }), "\n", jsxRuntimeExports.jsx(_components.h3, {
      children: "Why Gatsby?"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "Gatsby delivers faster, more secure sites and apps from a variety of data\nsources"
    }), "\n", jsxRuntimeExports.jsx(_components.h3, {
      children: "Where do I start?"
    }), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: ["The documentation offers guides for all different skill levels, you can\nfind more info at the Gatsby's ", jsxRuntimeExports.jsx(_components.a, {
        href: "https://www.gatsbyjs.org/docs/quick-start",
        children: "Quick Start page"
      })]
    }), "\n", "\n", "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "Children listed:"
    }), "\n", props.children, "\n", jsxRuntimeExports.jsx(_components.h4, {
      children: "Last line"
    })]
  });
}
function MDXContent$2(props = {}) {
  const { wrapper: MDXLayout } = {
    ...useMDXComponents(),
    ...props.components
  };
  return MDXLayout ? jsxRuntimeExports.jsx(MDXLayout, {
    ...props,
    children: jsxRuntimeExports.jsx(_createMdxContent$2, {
      ...props
    })
  }) : _createMdxContent$2(props);
}
const SampleSignature = ({ children }) => jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
  children
});
function _createMdxContent$1(props) {
  const _components = {
    h2: "h2",
    hr: "hr",
    p: "p",
    ...useMDXComponents(),
    ...props.components
  };
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(_components.h2, {
      children: "Who we are"
    }), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: [props.company, ' ("us", "we", or "our") operates ', props.url, ' (the "Site"). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site.']
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy."
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Information Collection And Use"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: 'While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("Personal Information").'
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Log Data"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: 'Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data").'
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: `This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.`
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "In addition, we may use third party services for Analytics that collect, monitor and analyze this data to help us better serve our site users."
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Communications"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that provides you with better information and site experience."
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Cookies"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive."
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: 'Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.'
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Security"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security."
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Changes To This Privacy Policy"
    }), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: ["This Privacy Policy is effective as of ", props.effectivedate, " and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page."]
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy."
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website."
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Contact Us"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "If you have any questions about this Privacy Policy, please contact us."
    })]
  });
}
function MDXContent$1(props = {}) {
  const { wrapper: MDXLayout } = {
    ...useMDXComponents(),
    ...props.components
  };
  return MDXLayout ? jsxRuntimeExports.jsx(MDXLayout, {
    ...props,
    children: jsxRuntimeExports.jsx(_createMdxContent$1, {
      ...props
    })
  }) : _createMdxContent$1(props);
}
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    hr: "hr",
    p: "p",
    strong: "strong",
    ...useMDXComponents(),
    ...props.components
  };
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(_components.h2, {}), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: ['Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the ', props.url, " website and the ", props.products, ' (the "Service") operated by ', props.company, ' ("us", "we", or "our").']
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service."
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: jsxRuntimeExports.jsx(_components.strong, {
        children: "By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service."
      })
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Subscriptions"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: 'Some parts of the Service are billed on a subscription basis ("Subscription(s)"). You will be billed post usage on a recurring basis.\nYou many cancel your subscription at anytime.'
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Content"
    }), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: ['Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). Once the information is posted, the content ownership is relinquished to the site and to ', props.siteowner, " as legal owner of content."]
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Service"
    }), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: ["Our Service faciliates ease of access. The service depends on various 3rd parties (government agencies, data feeds and other businesses) for delivery of critical data.\n", props.siteowner, " do not take any responsibility for the accuracy and timely delivery of critical data."]
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Links To Other Websites"
    }), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: ["Our Service may contain links to third-party web sites or services that are not owned or controlled by ", props.company, "."]
    }), "\n", jsxRuntimeExports.jsxs(_components.p, {
      children: [props.company, " has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that ", props.company, " shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services."]
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Changes"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion."
    }), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.hr, {}), "\n", jsxRuntimeExports.jsx("br", {}), "\n", jsxRuntimeExports.jsx(_components.h2, {
      children: "Contact Us"
    }), "\n", jsxRuntimeExports.jsx(_components.p, {
      children: "If you have any questions about these Terms and Conditions, please contact us."
    })]
  });
}
function MDXContent(props = {}) {
  const { wrapper: MDXLayout } = {
    ...useMDXComponents(),
    ...props.components
  };
  return MDXLayout ? jsxRuntimeExports.jsx(MDXLayout, {
    ...props,
    children: jsxRuntimeExports.jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
const useStyles$L = (theme) => {
  return {
    content: {
      padding: "16px"
    },
    textHilite: {
      color: theme.palette.secondary.main
    },
    ctaBtn: {
      minWidth: "70%",
      padding: "0.6rem",
      fontSize: "1.4rem",
      letterSpacing: "0.2rem",
      marginTop: "1.0rem",
      marginBottom: "0.6rem"
    },
    fab: {
      marginLeft: theme.spacing(2)
    }
  };
};
const GetStartedPlans = (props) => {
  const theme = useTheme();
  const classes = useStyles$L(theme);
  const { yamlData, title, leftSubTitle, rightSubTitle } = props;
  const { appState, dispatch } = useAppContext();
  const getEnvVar2 = appState.getEnvVar;
  const items = yamlData && yamlData.length && yamlData.map((item, i) => {
    const type = item && item.type || "No type provided";
    const plan2 = item && item.plan || "No plan";
    const picture = item && item.picture || null;
    const invite22 = item && item.invite || null;
    const who = item && item.who || "No target audience provided";
    const reg2 = item.reg || "";
    const cost = item.cost;
    const status = item.status || "";
    const once2 = item.once || "";
    const fixed2 = item.fixed || "";
    const sub12 = item.sub1 || "";
    const sub22 = item.sub2 || "";
    const sub32 = item.sub3 || "";
    const benefits = item && item.benefits || ["No benefits list provided"];
    const more = item && item.more && item.more.text || "No more text provided";
    const actions = item && item.actions || [];
    const cardData = {
      type,
      plan: plan2,
      invite: invite22,
      picture,
      who,
      reg: reg2,
      cost,
      status,
      once: once2,
      fixed: fixed2,
      sub1: sub12,
      sub2: sub22,
      sub3: sub32,
      benefits,
      more,
      actions,
      steps: item.more.steps || null,
      signupText: item.more.signupText || null,
      paymentText: item.more.paymentText || null,
      charityText: item.more.charityText || null
    };
    return cardData;
  });
  let currentPlanSelection = -1;
  const queryPlan = getUrlParm("plan");
  currentPlanSelection = items.findIndex((item) => {
    return item.plan === queryPlan;
  });
  if (currentPlanSelection == -1) currentPlanSelection = 0;
  const [plan, setPlan] = useState(currentPlanSelection);
  const leftTitle = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h3", component: "h3", align: "center", display: "block", gutterBottom: true, children: leftSubTitle });
  const handleChange = (e) => {
    setPlan(e.target.value);
  };
  const options2 = () => {
    return items.filter((item) => item.status === "active").map((item, i) => {
      const disabled = item.cost === "soon" || item.cost === "Contact Us" || item.cost === "Available";
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { disabled, value: i, children: item.plan }, i);
    });
  };
  const plans = /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { variant: "filled", sx: { ...classes.formControl }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel$1, { id: "demo-simple-select-filled-label", children: "Plan" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select,
      {
        labelId: "demo-simple-select-filled-label",
        id: "demo-simple-select-filled",
        value: plan,
        onChange: handleChange,
        children: options2()
      }
    )
  ] });
  const selection = items[plan].plan;
  const description = items[plan].who;
  const steps = items[plan].steps;
  const signupText = items[plan].signupText;
  const paymentText = items[plan].paymentText;
  const invite2 = items[plan].invite;
  const charityText = items[plan].charityText;
  (items[plan].cost === "soon" ? "Planned" : items[plan].cost === "Contact Us" ? "Contact Us" : items[plan].cost === "free" ? "No Charge" : "$" + items[plan].cost) + (items[plan].cost === "soon" || items[plan].cost === "free" ? "" : items[plan].cost === "Contact Us" ? "" : "/mo");
  const reg = items[plan].reg ? "Regular " + items[plan].reg : "";
  const once = items[plan].once;
  const fixed = items[plan].fixed;
  const sub1 = items[plan].sub1;
  const sub2 = items[plan].sub2;
  const sub3 = items[plan].sub3;
  const borderBoxProp = {
    bgcolor: "background.paper",
    borderColor: "text.primary",
    my: 2,
    p: 2,
    border: 1,
    style: { width: "100%", height: "auto" }
  };
  const subscription = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h5", gutterBottom: true, children: [
      "Select your plan ",
      plans
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { component: "div", borderRadius: "8px", ...borderBoxProp, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: description }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: reg }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: once !== "" ? once : "" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: fixed !== "" ? fixed : "" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: sub1 !== "" ? sub1 : "" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: sub2 !== "" ? sub2 : "" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: sub3 !== "" ? sub3 : "" })
    ] }) })
  ] }) }) });
  const inviteCode = appState.getEnvVar.EMERT_INVITE_OFFER;
  const numMatch = inviteCode && inviteCode.match(/(\d+)/);
  let inviteCodeDays = 0;
  if (numMatch && numMatch[0])
    inviteCodeDays = numMatch[0];
  const stepsHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", align: "left", gutterBottom: true, children: steps || "Only couple of steps and you are ready!" }),
    signupText && paymentText ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { gutterBottom: true, variant: "h6", children: [
        "1) ",
        signupText
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { gutterBottom: true, variant: "h6", children: [
        "2) ",
        paymentText
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { gutterBottom: true, children: [
        "This plan includes a ",
        inviteCodeDays,
        "-days free trial period."
      ] })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { gutterBottom: true, variant: "h6", children: signupText }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { gutterBottom: true, variant: "h6", children: "No payments are required for this plan." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { gutterBottom: true, children: charityText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { gutterBottom: true, children: "You may cancel anytime." })
  ] });
  const leftPanel = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    leftTitle,
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    subscription,
    stepsHtml
  ] });
  const rightTitleHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h3", component: "h3", align: "center", display: "block", gutterBottom: true, children: rightSubTitle });
  const haveAccount = /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h5", align: "center", gutterBottom: true, children: [
    "Already have an account?",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Fab,
      {
        variant: "extended",
        sx: { ...classes.fab },
        onClick: (e) => {
          kNavigateToPage("external", getEnvVar2.signinUrl, "_self");
        },
        children: "Sign In"
      }
    )
  ] });
  const tos = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: "/pages/termsandconditions", children: "Terms of Service" }) });
  const privacy = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: "/pages/privacy", children: "Privacy Policy" }) });
  const signup = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { style: { margin: "16px" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        variant: "contained",
        color: "secondary",
        sx: { ...classes.ctaBtn },
        onClick: (e) => {
          const signupPreset = { "Application": getEnvVar2.APP_NAME.toUpperCase(), "Plan": selection, "InviteCode": inviteCode };
          const signupPresetStr = JSON.stringify(signupPreset);
          const url = `${getEnvVar2.signupPartUrl}&preset="${signupPresetStr.replace(/"/g, '\\"')}"`;
          kNavigateToPage("external", url, "_blank");
        },
        children: "Sign Up"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "caption", display: "block", gutterBottom: true, children: [
      "By signing up, you agree to Emert's ",
      tos,
      " and ",
      privacy,
      "."
    ] }),
    invite2 === "yes" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", display: "block", color: "secondary", gutterBottom: true, style: { color: "#f80000" }, children: "Currently in private beta mode. SignUp requires an invite code." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", display: "block", color: "secondary", gutterBottom: true, style: { color: "#f80000" }, children: "Contact Us to get an invite or get notified when it is publicly released." })
    ] }) : null
  ] }) });
  const rightPanel = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    rightTitleHtml,
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    haveAccount,
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    signup
  ] });
  const page = "Get Started";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SectionLayout, { option: "nopadding", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { page, title }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, size: { xs: 12 }, sx: { ...classes.content }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: leftPanel }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: rightPanel })
    ] })
  ] }) });
};
const useStyles$K = (theme) => {
  const cardWidth = "100%";
  return {
    textHilite: {
      color: theme.palette.secondary.main
    },
    root: {},
    // For PainPoints
    avatar: {},
    icon: {},
    // For CTA
    atag: {
      textDecoration: "none",
      width: "100%"
    },
    ctaBtn: {
      width: "100%",
      padding: "0.6rem",
      fontSize: "1.4rem",
      letterSpacing: "0.2rem",
      marginTop: "1.0rem",
      textDecoration: "none"
    },
    // For Cards
    card: {
      display: "flex",
      flexDirection: "column",
      width: cardWidth,
      height: "100%"
    },
    area: {},
    cardHeader: {
      backgroundColor: theme.palette.primary.main,
      //'black',
      //        theme.palette.mode === 'darkx' ? theme.palette.grey[700] : theme.palette.grey[200],
      color: theme.custom.navLogoBg,
      //        theme.palette.mode === 'darkx' ? theme.palette.grey[200] : theme.palette.grey[900],
      height: "4rem",
      order: "2"
    },
    media: {
      order: "1",
      width: cardWidth,
      height: "12rem"
    },
    content: {
      background: "white",
      width: cardWidth,
      order: "3",
      padding: 0,
      fontSize: "0.8rem",
      height: "70%"
    },
    benefitList: {},
    benefitItem: {
      marginLeft: "-35px",
      textIndent: ["-2.0em", "-2.0em", "-1.8em"],
      paddingLeft: ["2.0em", "2.0em", "1.8em"]
    },
    selected: {
      color: "green",
      marginTop: "2px",
      marginLeft: "4px",
      marginRight: "4px",
      width: 16,
      height: 16
    },
    who: {
      margin: theme.spacing(2),
      height: "6rem",
      fontSize: "0.8rem"
    },
    regPricing: {
      textDecoration: "line-through",
      color: "red"
    },
    cardActions: {
      order: "4"
    },
    cardPricing: {
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      padding: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      flexDirection: "column"
    },
    "@global": {
      ul: {
        margin: 0,
        padding: 0
      },
      li: {
        listStyle: "none"
        /*
          '&:before': {
          content: 'a',
          content: '\1F95E';
          marginLeft: '-20px',
          marginRight: '10px',
          }
        */
      }
    }
  };
};
const PriceCard$1 = (props) => {
  const theme = useTheme();
  const classes = useStyles$K(theme);
  const { cardData } = props;
  const { appState, dispatch } = useAppContext();
  const getEnvVar2 = appState.getEnvVar;
  const benefits = cardData.benefits.map((bene, i) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { style: { ...classes.benefitItem }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "Check", sx: { ...classes.selected } }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: bene })
    ] }, i);
  });
  getEnvVar2.LOGO_TEXT;
  const handleAction = (plan, action) => {
    if (action === "Get Started") {
      kNavigateToPage("internal", `/getstarted?plan=${plan}`);
    } else if (action === "Contact Us") {
      kNavigateToPage("external", getEnvVar2.contactUsUrl, "_blank");
    }
  };
  const cardActions = cardData.actions.map((action, i) => {
    const clr = action === "Get Started" || action === "Contact Us" ? "secondary" : "primary";
    if (action === "Get Started") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          fullWidth: true,
          variant: "contained",
          color: clr,
          onClick: (e) => handleAction(cardData.plan, action),
          title: "Click to see steps for getting started",
          sx: { ...classes.ctaBtn },
          children: action
        },
        i
      );
    } else if (action === "Contact Us") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          fullWidth: true,
          variant: "contained",
          color: clr,
          onClick: (e) => handleAction(cardData.plan, action),
          title: "Click to Contact Us",
          sx: { ...classes.ctaBtn },
          children: action
        },
        i
      );
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          style: { ...classes.atag },
          href: `${getEnvVar2.getNotifiedUrl}&plan=${cardData.plan}&text=${"Please notify me when the specified plan is available."}`,
          target: "_blank",
          rel: "noreferrer",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              fullWidth: true,
              variant: "contained",
              color: clr,
              onClick: (e) => handleAction(cardData.plan, action),
              title: "Click to open Get Notified form",
              sx: { ...classes.ctaBtn },
              children: action
            }
          )
        },
        i
      );
    }
  });
  const gatsbyMedia = cardData.picture ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    KImage,
    {
      src: cardData.picture,
      alt: cardData.picture.relativePath,
      style: { ...classes.media }
    }
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { sx: { ...classes.card }, children: [
    gatsbyMedia,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CardHeader,
      {
        title: cardData.plan,
        titleTypographyProps: { align: "center" },
        subheaderTypographyProps: { align: "center", style: { color: "#cccccc" } },
        sx: { ...classes.cardHeader }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { sx: { ...classes.content }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", color: "textSecondary", sx: { ...classes.who }, children: cardData.who }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { ...classes.cardPricing }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h4", color: "textPrimary", title: cardData.title, children: [
          cardData.cost === "soon" ? "Planned" : cardData.cost === "free" ? "FREE" : cardData.cost === "Contact Us" ? "Contact Us" : cardData.cost === "Available" ? "Available" : " ",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h5", color: "textPrimary", title: cardData.title, children: [
          cardData.once !== "" ? cardData.once : "",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h5", color: "textPrimary", title: cardData.title, children: [
          cardData.fixed !== "" ? cardData.fixed : "",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h6", color: "textPrimary", title: cardData.title, children: [
          cardData.sub1 !== "" ? cardData.sub1 : "",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h6", color: "textPrimary", title: cardData.title, children: [
          cardData.sub2 !== "" ? cardData.sub2 : "",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", color: "textPrimary", sx: { ...classes.regPricing }, children: cardData.reg === "" ? "" : "Regular: " + cardData.reg }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h5", color: "textPrimary", title: cardData.title, children: [
          cardData.sub3 !== "" ? cardData.sub3 : "",
          " "
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { style: { ...classes.benefitList }, children: benefits })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions, { sx: { ...classes.cardActions }, children: cardActions })
  ] });
};
const usePriceListStyles = (theme) => {
  const cardWidth = "100%";
  return {
    root: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      //overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
      padding: theme.custom.areaGap
    },
    gridList: {
      flexWrap: "wrap",
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: "translateZ(0)",
      justifyContent: "center"
    },
    title: {
      color: theme.palette.primary.light
    },
    titleBar: {
      background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)"
    },
    card: {
      width: cardWidth,
      margin: 0,
      height: "auto !important"
    }
  };
};
const PriceList$1 = (props) => {
  const theme = useTheme();
  const classes = usePriceListStyles(theme);
  const { items } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, sx: { ...classes.root }, spacing: 2, children: [
    items.map((item, i) => {
      if (item.inuse) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { sx: { ...classes.card }, size: { xs: 12, sm: 6, md: 4, lg: 3 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PriceCard$1, { cardData: item }) }, i);
      } else return null;
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
  ] });
};
const PlansDisplayDetails = (props) => {
  useTheme();
  const { plans, images } = props;
  const items = plans && plans.length && plans.map((item) => {
    const type = item && item.type || "No type provided";
    const inuse = item && item.inuse;
    const plan = item && item.plan || "No plan";
    const title = item && item.title || "";
    const who = item && item.who || "No target audience provided";
    const reg = item.reg || "";
    const cost = item.cost;
    const status = item.status || "";
    const once = item.once || "";
    const fixed = item.fixed || "";
    const sub1 = item.sub1 || "";
    const sub2 = item.sub2 || "";
    const sub3 = item.sub3 || "";
    const benefits = item && item.benefits || ["No benefits list provided"];
    const more = item && item.more && item.more.text || "No more text provided";
    const actions = item && item.actions || [];
    const cardData = {
      type,
      inuse,
      plan,
      picture: item.picture ? item.picture : null,
      title,
      who,
      reg,
      cost,
      status,
      once,
      fixed,
      sub1,
      sub2,
      sub3,
      benefits,
      more,
      actions
    };
    return cardData;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PriceList$1, { items }) });
};
const PlansDisplay = (props) => {
  const { yamlData, page, title, images } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SectionLayout, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { page, title }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlansDisplayDetails, { plans: yamlData, images }) })
  ] });
};
const PriceCard = (props) => {
  const theme = useTheme();
  const cardWidth = "100%";
  const { cardData, appDisplay, pricingCardsStyle } = props;
  const { appState, dispatch } = useAppContext();
  const getEnvVar2 = appState.getEnvVar;
  const currentPlan = appState.plan;
  getEnvVar2.LOGO_TEXT;
  const {
    bgColor,
    titleColor,
    titleFS,
    subTitleColor,
    contentFS,
    contentHeight,
    whoHeight,
    whoFS,
    whoColor,
    promoColor,
    regPriceColor,
    priceColor,
    priceYearColor,
    pricePerSeatColor,
    pricePerSeatFS,
    helpColor,
    regMsgColor,
    registerActionColor,
    contactUsActionColor,
    otherActionColor
  } = pricingCardsStyle;
  const handleAction = (plan, action2) => {
    if (action2 === "Register") {
      kNavigateToPage("external", `${getEnvVar2.SCUR_APP_URL}/?nav=plans&display=${appDisplay}&plan=${plan}`);
    } else if (action2 === "Contact Us") {
      kNavigateToPage("external", getEnvVar2.contactUsUrl, "_blank");
    }
  };
  let disabled = !appState.isSignIn ? true : false;
  let isCurrentPlanRegistered = cardData.plan === currentPlan?.plan;
  let isPlanRegistered = currentPlan?.plan || false;
  disabled = isPlanRegistered || disabled;
  const action = cardData.action;
  let cardAction = null;
  if (action === "") {
    cardAction = /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        sx: {
          width: "100%",
          height: "3.6rem"
        }
      }
    );
  } else if (action === "Register") {
    cardAction = /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        fullWidth: true,
        variant: "contained",
        color: registerActionColor,
        onClick: (e) => handleAction(cardData.plan, action),
        title: "Click to Register",
        disabled,
        sx: {
          width: "100%",
          padding: "0.6rem",
          fontSize: "1.4rem",
          letterSpacing: "0.2rem",
          //marginTop: '1.0rem',
          textDecoration: "none"
        },
        children: action
      }
    );
  } else if (action === "Contact Us") {
    cardAction = /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        fullWidth: true,
        variant: "contained",
        color: contactUsActionColor,
        onClick: (e) => handleAction(cardData.plan, action),
        title: "Click to Contact Us",
        sx: {
          width: "100%",
          padding: "0.6rem",
          fontSize: "1.4rem",
          letterSpacing: "0.2rem",
          //marginTop: '1.0rem',
          textDecoration: "none"
        },
        children: action
      }
    );
  } else {
    cardAction = /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        style: { textDecoration: "none", width: "100%" },
        href: `${getEnvVar2.getNotifiedUrl}&plan=${cardData.plan}&text=${"Please notify me when the specified plan is available."}`,
        target: "_blank",
        rel: "noreferrer",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            fullWidth: true,
            variant: "contained",
            color: otherActionColor,
            onClick: (e) => handleAction(cardData.plan, action),
            title: "Click to open Get Notified form",
            sx: {
              width: "100%",
              padding: "0.6rem",
              fontSize: "1.4rem",
              letterSpacing: "0.2rem",
              //marginTop: '1.0rem',
              textDecoration: "none"
            },
            children: action
          }
        )
      }
    );
  }
  const gatsbyMedia = cardData.picture ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    KImage,
    {
      src: cardData.picture,
      alt: cardData.picture.relativePath,
      style: {
        order: "1",
        width: cardWidth,
        height: "10rem",
        borderWidth: "2px",
        borderColor: theme.palette.secondary.main,
        borderStyle: "solid"
      }
    }
  ) : null;
  const { partApp, partPlan, partId } = pymtUtil.splitPlanInfo(cardData.plan);
  const tip = !appState.isSignIn && action === "Register" ? "Please Sign In To Register" : "";
  const planIsRegisteredMsg = isCurrentPlanRegistered ? "Plan Registered" : "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { sx: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-evenly",
    background: bgColor
  }, children: [
    gatsbyMedia,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CardHeader,
      {
        title: partPlan,
        titleTypographyProps: { align: "center", fontSize: titleFS },
        subheaderTypographyProps: { align: "center", style: { color: subTitleColor } },
        sx: {
          color: titleColor,
          // color for title
          order: "2"
        }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { sx: {
      background: bgColor,
      //      width: cardWidth,
      order: "3",
      padding: 0,
      fontSize: contentFS,
      height: contentHeight
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", color: "textSecondary", sx: {
        margin: theme.spacing(1),
        height: whoHeight,
        fontSize: whoFS,
        color: whoColor
      }, children: cardData.who }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        flexDirection: "column"
        //height: '70%',
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h4", color: promoColor, title: tip, sx: { minHeight: "2rem" }, children: [
          cardData.promo != "" ? cardData.promo : " ",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", color: regPriceColor, title: tip, sx: {
          minHeight: "2rem",
          textDecoration: "line-through",
          color: "red"
        }, children: cardData.reg === "" ? "" : cardData.reg }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h5", color: priceColor, title: tip, sx: { minHeight: "1rem" }, children: [
          cardData.price !== "" && cardData.price !== "000.00" ? cardData.price : "",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "h5", color: priceYearColor, title: tip, sx: { minHeight: "1rem" }, children: [
          cardData.priceYear !== "" && cardData.priceYear !== "000.00" ? cardData.priceYear : "",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "p", color: pricePerSeatColor, title: tip, sx: { minHeight: "1rem", fontSize: pricePerSeatFS }, children: [
          cardData.pricePerSeat !== "" && cardData.pricePerSeat !== "000.00" ? cardData.pricePerSeat : "",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", color: helpColor, title: tip, sx: { minHeight: "0.5rem", marginTop: "0.5rem" }, children: cardData.help !== "" ? cardData.help : "" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", color: regMsgColor, title: tip, sx: { minHeight: "1rem", padding: "1.2rem" }, children: planIsRegisteredMsg !== "" ? planIsRegisteredMsg : "" })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions, { sx: { order: "4", padding: 0, backgroundColor: bgColor }, children: cardAction })
  ] });
};
const PriceList = (props) => {
  const theme = useTheme();
  theme.custom.contentpanelBG;
  const { items, appDisplay, pricingCardsStyle } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, sx: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    //overflow: 'hidden',
    background: pricingCardsStyle.cardsPanelBG,
    padding: 1
    //margin:'1rem',
    //width: '98%'
  }, children: [
    items.map((item, i) => {
      if (item.inuse) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Grid,
          {
            sx: { height: "auto !important", background: pricingCardsStyle.bgColor, margin: 1 },
            size: { xs: 12, sm: 6, md: 3, lg: 2, xl: 2 },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(PriceCard, { cardData: item, appDisplay, pricingCardsStyle })
          },
          i
        );
      } else return null;
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
  ] });
};
const PricingDisplayDetails = (props) => {
  const theme = useTheme();
  useMediaQuery(theme.breakpoints.up("sm"));
  useMediaQuery(theme.breakpoints.up("xs"));
  const { appsSubs, pricingDisplayStyle, pricingCardsStyle } = props;
  const { appState, dispatch } = useAppContext();
  const plans = appsSubs.plans;
  const features = appsSubs.features;
  const appDisplay = appsSubs.display;
  const items = [];
  const {
    respPadding,
    respFont,
    featureBorder,
    featureFS,
    featureTitleFS,
    checkMarkColor
  } = pricingDisplayStyle;
  Object.keys(plans).forEach((key) => {
    const item = plans[key];
    const plan = key;
    const inuse = item && item.inuse;
    const who = item && item.who || "No target audience provided";
    const title = item && item.title || "";
    const promo = item.promo;
    const reg = item.reg || "";
    const price = item.price || "";
    const priceYear = item.priceYear || "";
    const pricePerSeat = item.pricePerSeat || "";
    const features2 = item.features || [];
    const action = item && item.action || "";
    const help = item && item.help || "";
    const cardData = {
      plan,
      inuse,
      picture: item.picture ? item.picture : null,
      who,
      title,
      promo,
      reg,
      price,
      priceYear,
      pricePerSeat,
      features: features2,
      action,
      help
    };
    items.push(cardData);
  });
  const planBenefits = items.reduce((agg, item) => {
    if (item.inuse) agg[item.plan] = item.features;
    return agg;
  }, {});
  const getPlans2 = () => {
    return Object.keys(planBenefits);
  };
  const isPlanFeature = (plan, id) => {
    const benefits = planBenefits[plan];
    const index = benefits ? benefits.indexOf(id) : -1;
    return index !== -1;
  };
  const planValues = (featureId) => {
    const tdEntries = getPlans2().map((plan, i) => {
      let tdEntry;
      if (isPlanFeature(plan, featureId)) {
        tdEntry = /* @__PURE__ */ jsxRuntimeExports.jsx("td", { style: { textAlign: "center", border: featureBorder }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Check", sx: {
          color: checkMarkColor,
          marginLeft: "4px",
          width: 24,
          height: 24
        } }) }) }, plan + "-" + i + "-" + featureId);
      } else {
        tdEntry = /* @__PURE__ */ jsxRuntimeExports.jsx("td", { style: { border: featureBorder, padding: "1rem" }, children: "  " }, plan + "-" + i + "-" + featureId);
      }
      return tdEntry;
    });
    return tdEntries;
  };
  const featuresHtml = features && features.length && features.map((benefit, i) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { style: { border: featureBorder, paddingLeft: "1rem" }, children: [
        " ",
        benefit,
        " "
      ] }),
      planValues(i + 1)
    ] }, i);
  });
  const planHeaders = getPlans2().map((plan, i) => {
    const { partApp, partPlan, partId } = pymtUtil.splitPlanInfo(plan);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("th", { style: { border: featureBorder, padding: respPadding }, children: [
      " ",
      partPlan,
      " "
    ] }, "th-" + i);
  });
  const signin = CreateFabOrButton("fab", "Sign In To Register Plan", "external", "/myaccount", "_blank", [0, 0, 4, 4, 4, 9]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: {
    margin: 1
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PriceList, { items, appDisplay, pricingCardsStyle }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: !appState.isSignIn ? signin : null }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { style: { padding: "0rem" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { style: { width: "auto", border: featureBorder, fontSize: featureFS, borderCollapse: "collapse" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("caption", { style: { fontSize: featureTitleFS }, children: "Compare Plans" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { style: { border: featureBorder, padding: respPadding }, children: "Feature" }),
        planHeaders
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: featuresHtml })
    ] }) })
  ] });
};
const PricingDisplay = (props) => {
  const theme = useTheme();
  const { appsSubs, page, title } = props;
  const matches600up = useMediaQuery(theme.breakpoints.up("sm"));
  const matches400up = useMediaQuery(theme.breakpoints.up("xs"));
  const pricingDisplayStyle = {
    respPadding: matches600up ? "0.8rem" : "0.4rem",
    respFont: matches600up ? "14px" : matches400up ? "9px" : "8px",
    featureFS: matches600up ? "14px" : matches400up ? "9px" : "8px",
    featureBorder: "1px solid black",
    featureTitleFS: "300%",
    checkMarkColor: "green"
  };
  const pricingCardsStyle = {
    cardsPanelBG: theme.custom.backpanelBG,
    // body color
    //bgColor: theme.custom.panelBG,   // white
    bgColor: theme.custom.contentpanelBG,
    // content bg color
    titleColor: theme.palette.text.primary,
    titleFS: "1.4rem",
    subTitleColor: "#cccccc",
    contentFS: "0.8rem",
    contentHeight: "66%",
    whoHeight: "14rem",
    whoFS: "1.0rem",
    whoColor: theme.palette.text.primary,
    promoColor: theme.palette.text.primary,
    regPriceColor: theme.palette.text.primary,
    priceColor: theme.palette.text.primary,
    priceYearColor: theme.palette.text.primary,
    pricePerSeatColor: theme.palette.text.primary,
    pricePerSeatFS: "1.0rem",
    helpColor: theme.palette.success.main,
    regMsgColor: theme.palette.success.main,
    registerActionColor: "secondary",
    contactUsActionColor: "primary",
    otherActionColor: "primary"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { page, title }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, "data-where": "PricingPage", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, "data-where": "PricingPageHeader" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, "data-where": "PricingPageCards", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        PricingDisplayDetails,
        {
          appsSubs,
          pricingDisplayStyle,
          pricingCardsStyle
        }
      ) })
    ] })
  ] });
};
const urlB64ToUint8Array$1 = (base64String) => {
  const padding2 = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding2).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};
const PWA = (props) => {
  const { appState, dispatch } = useAppContext();
  const getEnvVar2 = appState.getEnvVar;
  const CLNT_JWT = appState.token;
  const CLNT_FPID = appState.fpid;
  const vapidKey = getEnvVar2.VAPID_KEY;
  const subscriptionSvc = getEnvVar2.SUBSCRIPTION_SVC;
  const notichoSvc = getEnvVar2.NOTICHO_SVC;
  const APP_CODE = getEnvVar2.APP_CODE;
  const TempSpaContext = createContext(null);
  const [notify, setNotify] = useState(Notification && Notification.permission || "");
  const [SpaContext2, setSpaContext] = useState(() => TempSpaContext);
  const [isReady, setIsReady] = useState(false);
  let pwaContent;
  useEffect(() => {
    const saveSubscriptionY = async () => {
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration && registration.pushManager) {
          let subscription = await registration.pushManager.getSubscription();
          if (!subscription) {
            const options2 = {
              userVisibleOnly: true,
              applicationServerKey: urlB64ToUint8Array$1(vapidKey)
            };
            subscription = await registration.pushManager.subscribe(options2);
          }
          const resp = await persistServerside(subscription);
        }
      } catch (e) {
        console.error(">>PWA:saveSubscriptionY - exception ", e);
      }
    };
    const syncWaitSaveSubscription = async () => await saveSubscriptionY();
    if (notify === "granted" && navigator && navigator.serviceWorker) {
      syncWaitSaveSubscription();
    }
  }, [notify]);
  const issueWebPushTest = async (APP_CODE2) => {
    dispatch({ type: "SET_IO_BUSY", payload: true });
    let resp = await myFetch(notichoSvc + "/?appCode=" + APP_CODE2, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${CLNT_JWT || CLNT_FPID}`,
        "content-type": "application/json",
        "x-reqaccountno": appState.account?.accountNo
      }
    });
    dispatch({ type: "SET_IO_BUSY", payload: false });
    return resp;
  };
  const saveSubscriptionX = async (APP_CODE2, subscription) => {
    dispatch({ type: "SET_IO_BUSY", payload: true });
    let resp = await myFetch(subscriptionSvc, {
      method: "POST",
      body: JSON.stringify(subscription),
      headers: {
        Authorization: `Bearer ${CLNT_JWT || CLNT_FPID}`,
        "content-type": "application/json",
        "x-reqaccountno": appState.account?.accountNo
      }
    });
    dispatch({ type: "SET_IO_BUSY", payload: false });
    return resp;
  };
  const serverTestHandler = async () => {
    let resp;
    try {
      resp = issueWebPushTest(APP_CODE);
    } catch (e) {
      console.error("PWA:serverTestHandler() - webPushTest failed", e);
    }
  };
  const persistServerside = async (subscription) => {
    let resp;
    try {
      resp = saveSubscriptionX(APP_CODE, subscription);
    } catch (e) {
      console.error("PWA:persistServerside() - webPushTest failed", e);
    }
    return resp;
  };
  const requestPermissionHandler = async (status) => {
    if (status === "granted") {
      const options2 = {
        userVisibleOnly: true,
        applicationServerKey: urlB64ToUint8Array$1(vapidKey)
      };
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        const subscription = await registration && registration.pushManager.subscribe(options2) || null;
        const resp = await persistServerside(subscription);
      } catch (e) {
        console.error("PWA:requestPermissionHandler - exception ", e);
      }
    }
  };
  navigator && navigator.serviceWorker && navigator.serviceWorker.addEventListener("message", (event2) => {
  });
  if ("Notification" in window && navigator.serviceWorker) {
    const clickHandler = async () => {
      await Notification.requestPermission(requestPermissionHandler);
      setNotify(Notification.permission);
    };
    let display = notify === "denied" ? "Block" : notify === "default" ? "Ask" : "Allow";
    if (notify === "default") {
      pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "For better user experience please turn on browser notifications and set it to 'Allow'." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle1", gutterBottom: true, children: [
          "Your notification is currently set to : ",
          display
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { color: "primary", variant: "contained", onClick: clickHandler, children: "Change Notification Setting" }) })
      ] });
    } else if (notify === "denied") {
      pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "For better user experience please turn on browser notifications and set it to 'Allow'." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle1", gutterBottom: true, children: [
          "Your notification is currently set to : ",
          display
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "overline", gutterBottom: true, sx: { color: "warning.main" }, children: "Please use your browser controls now to set your notifications. Click on the 'lock icon' next to URL in your browser and set the notifications to 'Allow'." })
      ] });
    } else if (notify === "granted") {
      const localTestButton = null;
      const testButton = /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle2", gutterBottom: true, children: [
        "Test your notifications :",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        localTestButton,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { color: "secondary", variant: "contained", onClick: serverTestHandler, children: "Test Server Notification" })
      ] });
      pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "For better user experience please keep the browser notifications set to 'Allow'." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle1", gutterBottom: true, children: [
          "Your notification is currently set to : ",
          display
        ] }),
        testButton
      ] });
    }
  } else {
    pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, children: "Your browser does not support notifications" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, children: "Your real time recalls will be delivered as set in your profile." })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { p: 1 }, children: pwaContent });
};
const urlB64ToUint8Array = (base64String) => {
  const padding2 = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding2).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};
const FormPWA = (props) => {
  const { appState, dispatch } = useAppContext();
  const getEnvVar2 = appState.getEnvVar;
  const CLNT_JWT = appState.token;
  const CLNT_FPID = appState.fpid;
  const vapidKey = getEnvVar2.VAPID_KEY;
  const subscriptionSvc = getEnvVar2.SUBSCRIPTION_SVC;
  const notichoSvc = getEnvVar2.NOTICHO_SVC;
  const APP_CODE = getEnvVar2.APP_CODE;
  const TempSpaContext = createContext(null);
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const [notify, setNotify] = useState(Notification && Notification.permission || "");
  const [SpaContext2, setSpaContext] = useState(() => TempSpaContext);
  const [isReady, setIsReady] = useState(false);
  let pwaContent;
  useEffect(() => {
    const saveSubscriptionY = async () => {
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration && registration.pushManager) {
          let subscription = await registration.pushManager.getSubscription();
          if (!subscription) {
            const options2 = {
              userVisibleOnly: true,
              applicationServerKey: urlB64ToUint8Array(vapidKey)
            };
            subscription = await registration.pushManager.subscribe(options2);
          }
          const resp = await persistServerside(subscription);
        }
      } catch (e) {
        console.error(">>PWA:saveSubscriptionY - exception ", e);
      }
    };
    const syncWaitSaveSubscription = async () => await saveSubscriptionY();
    if (notify === "granted" && navigator && navigator.serviceWorker) {
      syncWaitSaveSubscription();
    }
  }, [notify]);
  const issueWebPushTest = async (APP_CODE2, da2) => {
    let resp = await da2.serverio.webPushTest(notichoSvc + "/?appCode=" + APP_CODE2, CLNT_JWT, CLNT_FPID);
    return resp;
  };
  const saveSubscriptionX = async (APP_CODE2, da2, subscription) => {
    let resp = await da2.serverio.persistSubscription(subscriptionSvc, CLNT_JWT, CLNT_FPID, subscription);
    return resp;
  };
  const serverTestHandler = async () => {
    let resp;
    try {
      resp = issueWebPushTest(APP_CODE, da);
    } catch (e) {
      console.error("PWA:serverTestHandler() - webPushTest failed", e);
    }
  };
  const persistServerside = async (subscription) => {
    let resp;
    try {
      resp = saveSubscriptionX(APP_CODE, da, subscription);
    } catch (e) {
      console.error("PWA:persistServerside() - webPushTest failed", e);
    }
    return resp;
  };
  const requestPermissionHandler = async (status) => {
    if (status === "granted") {
      const options2 = {
        userVisibleOnly: true,
        applicationServerKey: urlB64ToUint8Array(vapidKey)
      };
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        const subscription = await registration && registration.pushManager.subscribe(options2) || null;
        const resp = await persistServerside(subscription);
      } catch (e) {
        console.error("PWA:requestPermissionHandler - exception ", e);
      }
    }
  };
  navigator && navigator.serviceWorker && navigator.serviceWorker.addEventListener("message", (event2) => {
  });
  if ("Notification" in window && navigator.serviceWorker) {
    const clickHandler = async () => {
      await Notification.requestPermission(requestPermissionHandler);
      setNotify(Notification.permission);
    };
    let display = notify === "denied" ? "Block" : notify === "default" ? "Ask" : "Allow";
    if (notify === "default") {
      pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "For better user experience please turn on browser notifications and set it to 'Allow'." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle1", gutterBottom: true, children: [
          "Your notification is currently set to : ",
          display
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle2", gutterBottom: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { color: "primary", variant: "contained", onClick: clickHandler, children: "Change Notification Setting" }) })
      ] });
    } else if (notify === "denied") {
      pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "For better user experience please turn on browser notifications and set it to 'Allow'." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle1", gutterBottom: true, children: [
          "Your notification is currently set to : ",
          display
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "overline", gutterBottom: true, sx: { color: "warning.main" }, children: "Please use your browser controls now to set your notifications. Click on the 'lock icon' next to URL in your browser and set the notifications to 'Allow'." })
      ] });
    } else if (notify === "granted") {
      const localTestButton = null;
      const testButton = /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle2", gutterBottom: true, children: [
        "Test your notifications :",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        localTestButton,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { color: "secondary", variant: "contained", onClick: serverTestHandler, children: "Test Server Notification" })
      ] });
      pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "For better user experience please keep the browser notifications set to 'Allow'." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle1", gutterBottom: true, children: [
          "Your notification is currently set to : ",
          display
        ] }),
        testButton
      ] });
    }
  } else {
    pwaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, children: "Your browser does not support notifications" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, children: "Your real time recalls will be delivered as set in your profile." })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { p: 1 }, children: pwaContent });
};
const css = ".muicomp {\n    color: black;\n  background: yellow;\n}\n";
const MuiComp = (props) => {
  console.log("MuiComp ", css);
  const Comp = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { background: "blue", color: "white", padding: 10, mt: 3 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "A Sub Component" }) });
  };
  const sx = {
    mr: 2,
    fontFamily: "monospace",
    fontWeight: 700,
    letterSpacing: ".3rem",
    color: "inherit",
    textDecoration: "none"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...sx }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Comp, {}) }) });
};
const useStyles$J = (theme) => {
  const rand = Math.floor(Math.random() * 10);
  const heroImage = theme.heroImages[rand];
  return {
    sectionbg: {
      position: "relative",
      backgroundColor: theme.palette.grey[800],
      backgroundImage: `linear-gradient(to right, #ffffff, transparent 20%),  url(${heroImage})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      marginBottom: theme.custom.sectionGap,
      color: theme.palette.common.white
    },
    overlay: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      backgroundColor: "rgba(f,f,f,.1)"
    },
    textHilite: {
      color: theme.palette.secondary.main
    },
    ctabtn: {
      margin: theme.spacing(1, 10),
      padding: theme.spacing(2),
      width: "300px",
      letterSpacing: "0.2em"
    }
  };
};
const SampleSectionBG = (props) => {
  const theme = useTheme();
  const classes = useStyles$J(theme);
  const title = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...classes.textHilite }, children: "EMERGENCY" }),
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Recall " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...classes.textHilite }, children: "ALERT" })
  ] });
  const subtitle = "Be Informed, Aware and Safe. ";
  const body = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Let our timely alerts keep you informed and aware of all voluntary and regulatory recalls. You can choose and filter notifications that are relevant and suppress others. Be Vigilant of goods and products you consume to keep your self and your loved ones safe." }) });
  const tail = /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { href: "/pricing", variant: "contained", color: "secondary", sx: { ...classes.ctabtn }, children: "Subscribe" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SectionLayout, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { ...classes.sectionbg }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classes.overlay } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 9, sm: 5 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SectionWrapper, { title, subtitle, body, tail }) }) })
  ] }) });
};
const useStyles$I = (theme) => {
  return {
    textHilite: {
      color: theme.palette.secondary.main
    },
    ctabtn: {
      margin: theme.spacing(1, 10),
      padding: theme.spacing(2),
      width: "300px",
      letterSpacing: "0.2em"
    }
  };
};
const SampleSection = (props) => {
  const theme = useTheme();
  const classes = useStyles$I(theme);
  const title = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Col Title " }) });
  const subtitle = "Col Sub Title";
  const body = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Col Body Text" }) });
  const tail = /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { href: "/pricing", variant: "contained", color: "secondary", sx: { ...classes.ctabtn }, children: "Call To Action Button" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SectionLayout, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SectionWrapper, { title, subtitle, body, tail }) }) });
};
const useStyles$H = (theme) => {
  return {
    section: {
      marginBottom: theme.custom.sectionGap
    },
    textHilite: {
      color: theme.palette.secondary.main
    },
    ctabtn: {
      margin: theme.spacing(1, 10),
      padding: theme.spacing(2),
      width: "300px",
      letterSpacing: "0.2em"
    }
  };
};
const SampleSectionTwoCol = (props) => {
  const theme = useTheme();
  const classes = useStyles$H(theme);
  const titleLeft = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Left Col Title " }) });
  const subtitleLeft = "Left Col Sub Title";
  const bodyLeft = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Left Col Body Text" }) });
  const tailLeft = /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { href: "/pricing", variant: "contained", color: "secondary", sx: { ...classes.ctabtn }, children: "CTA Left" });
  const titleRight = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Right Col Title " }) });
  const subtitleRight = "Right Col Sub Title";
  const bodyRight = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Right Col Body Text" }) });
  const tailRight = /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { href: "/pricing", variant: "contained", color: "secondary", sx: { ...classes.ctabtn }, children: "CTA Right" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SectionLayout, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      SectionWrapper,
      {
        title: titleLeft,
        subtitle: subtitleLeft,
        body: bodyLeft,
        tail: tailLeft
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      SectionWrapper,
      {
        title: titleRight,
        subtitle: subtitleRight,
        body: bodyRight,
        tail: tailRight
      }
    ) })
  ] }) });
};
function Counter() {
  const [count, setCount] = useState(0);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { type: "button", onClick: () => setCount((count2) => count2 + 1), children: [
    "Counter ",
    count,
    " (React)"
  ] });
}
class Identity {
  constructor(options2) {
    this.hasher = options2.hasher;
    this.screen_resolution = options2.screen_resolution;
    this.screen_orientation = options2.screen_orientation;
    this.canvas = options2.canvas;
    this.ie_activex = options2.ie_activex;
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
  }
  get() {
    var keys = [];
    keys.push(navigator.language);
    keys.push(screen.colorDepth);
    if (this.screen_resolution) {
      var resolution = this.getScreenResolution();
      if (typeof resolution !== "undefined") {
        keys.push(this.getScreenResolution().join("x"));
      }
    }
    keys.push((/* @__PURE__ */ new Date()).getTimezoneOffset());
    keys.push(this.hasSessionStorage());
    keys.push(this.hasLocalStorage());
    keys.push(!!window.indexedDB);
    if (document.body) {
      keys.push(typeof document.body.addBehavior);
    } else {
      keys.push("undefined");
    }
    keys.push(navigator.cpuClass);
    keys.push(navigator.platform);
    keys.push(this.getPluginsString());
    keys.push(this.getMimeTypes());
    keys.push(navigator.userAgent);
    keys.push(typeof window.openDatabase);
    keys.push(navigator.doNotTrack);
    if (this.canvas && this.isCanvasSupported()) {
      keys.push(this.getCanvasIdentity());
    }
    keys.push(this.fingerprint_fonts());
    let fpid = null;
    if (this.hasher) {
      fpid = this.hasher(keys.join("#"), 31);
    } else {
      fpid = this.murmurhash3_32_gc(keys.join("#"), 31);
    }
    if (fpid > 2147483647) {
      fpid = fpid % 2147483647;
    }
    return fpid;
  }
  /*
  getStackTrace() {
    var stack;
    try {
      throw new Error('');
    }
    catch (error) {
      stack = error.stack || '';
    }
    stack = stack.split('\n').map(function (line) { return line.trim(); });
    return stack;
    //return stack.splice(stack[0] == 'Error' ? 2 : 1);
  }
  */
  murmurhash3_32_gc(key, seed) {
    var remainder, bytes, h1, h1b, c1, c2, k1, i;
    remainder = key.length & 3;
    bytes = key.length - remainder;
    h1 = seed;
    c1 = 3432918353;
    c2 = 461845907;
    i = 0;
    while (i < bytes) {
      k1 = key.charCodeAt(i) & 255 | (key.charCodeAt(++i) & 255) << 8 | (key.charCodeAt(++i) & 255) << 16 | (key.charCodeAt(++i) & 255) << 24;
      ++i;
      k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
      k1 = k1 << 15 | k1 >>> 17;
      k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
      h1 ^= k1;
      h1 = h1 << 13 | h1 >>> 19;
      h1b = (h1 & 65535) * 5 + (((h1 >>> 16) * 5 & 65535) << 16) & 4294967295;
      h1 = (h1b & 65535) + 27492 + (((h1b >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch (remainder) {
      case 3:
        k1 ^= (key.charCodeAt(i + 2) & 255) << 16;
      case 2:
        k1 ^= (key.charCodeAt(i + 1) & 255) << 8;
      case 1:
        k1 ^= key.charCodeAt(i) & 255;
        k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
        h1 ^= k1;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = (h1 & 65535) * 2246822507 + (((h1 >>> 16) * 2246822507 & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = (h1 & 65535) * 3266489909 + (((h1 >>> 16) * 3266489909 & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 16;
    return h1 >>> 0;
  }
  //
  // Supporting functions
  // 
  getScreenResolution() {
    var resolution;
    if (this.screen_orientation) {
      resolution = screen.height > screen.width ? [
        screen.height,
        screen.width
      ] : [
        screen.width,
        screen.height
      ];
    } else {
      resolution = [
        screen.height,
        screen.width
      ];
    }
    return resolution;
  }
  hasSessionStorage() {
    try {
      return !!window.sessionStorage;
    } catch (e) {
      return true;
    }
  }
  hasLocalStorage() {
    try {
      return !!window.localStorage;
    } catch (e) {
      return true;
    }
  }
  isIE() {
    if (navigator.appName === "Microsoft Internet Explorer") {
      return true;
    } else if (navigator.appName === "Netscape" && /Trident/.test(navigator.userAgent)) {
      return true;
    }
    return false;
  }
  getRegularPluginsString() {
    const plugins = navigator.plugins;
    const lengthPlugins = plugins.length;
    const plugs = [];
    for (let i = 0; i < lengthPlugins; i++) {
      const p = plugins[i];
      const lengthMime = p.length;
      const mims = [];
      for (let j = 0; j < lengthMime; j++) {
        mims.push(`${p[j].type}~${p[j].suffixes}`);
      }
      const mimsStr = mims.join(",");
      plugs.push(`${p.name}::${p.description}::${mimsStr}`);
    }
    const plugsStr = plugs.join(";");
    return plugsStr;
  }
  /* original using map()
  getRegularPluginsStringXX() {
    return this.map(navigator.plugins, function (p) {
      var mimeTypes = this.map(p, function (mt) {
        return [
          mt.type,
          mt.suffixes
        ].join('~');
      }).join(',');
      return [
        p.name,
        p.description,
        mimeTypes
      ].join('::');
    }, this).join(';');
  }
  */
  getIEPluginsString() {
    if (window.ActiveXObject) {
      var names = [
        "ShockwaveFlash.ShockwaveFlash",
        "AcroPDF.PDF",
        "PDF.PdfCtrl",
        "QuickTime.QuickTime",
        "rmocx.RealPlayer G2 Control",
        "rmocx.RealPlayer G2 Control.1",
        "RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)",
        "RealVideo.RealVideo(tm) ActiveX Control (32-bit)",
        "RealPlayer",
        "SWCtl.SWCtl",
        "WMPlayer.OCX",
        "AgControl.AgControl",
        "Skype.Detection"
      ];
      return this.map(names, function(name) {
        try {
          new ActiveXObject(name);
          return name;
        } catch (e) {
          return null;
        }
      }).join(";");
    } else {
      return "";
    }
  }
  getPluginsString() {
    if (this.isIE() && this.ie_activex) {
      return this.getIEPluginsString();
    } else {
      return this.getRegularPluginsString();
    }
  }
  isCanvasSupported() {
    var elem = document.createElement("canvas");
    return !!(elem.getContext && elem.getContext("2d"));
  }
  getCanvasIdentity() {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    var txt = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*()_+-={}|[]:"<>?;,.';
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);
    return canvas.toDataURL();
  }
  //
  // Added by Yatin to improve accuracy
  //
  fingerprint_fonts() {
    var strOnError, style2, fonts, count, template, fragment, divs, i, font, div, body, result, e;
    strOnError = "Error";
    style2 = null;
    fonts = null;
    font = null;
    count = 0;
    template = null;
    divs = null;
    e = null;
    div = null;
    body = null;
    i = 0;
    try {
      style2 = "position: absolute; visibility: hidden; display: block !important";
      fonts = ["Abadi MT Condensed Light", "Adobe Fangsong Std", "Adobe Hebrew", "Adobe Ming Std", "Agency FB", "Aharoni", "Andalus", "Angsana New", "AngsanaUPC", "Aparajita", "Arab", "Arabic Transparent", "Arabic Typesetting", "Arial Baltic", "Arial Black", "Arial CE", "Arial CYR", "Arial Greek", "Arial TUR", "Arial", "Batang", "BatangChe", "Bauhaus 93", "Bell MT", "Bitstream Vera Serif", "Bodoni MT", "Bookman Old Style", "Braggadocio", "Broadway", "Browallia New", "BrowalliaUPC", "Calibri Light", "Calibri", "Californian FB", "Cambria Math", "Cambria", "Candara", "Castellar", "Casual", "Centaur", "Century Gothic", "Chalkduster", "Colonna MT", "Comic Sans MS", "Consolas", "Constantia", "Copperplate Gothic Light", "Corbel", "Cordia New", "CordiaUPC", "Courier New Baltic", "Courier New CE", "Courier New CYR", "Courier New Greek", "Courier New TUR", "Courier New", "DFKai-SB", "DaunPenh", "David", "DejaVu LGC Sans Mono", "Desdemona", "DilleniaUPC", "DokChampa", "Dotum", "DotumChe", "Ebrima", "Engravers MT", "Eras Bold ITC", "Estrangelo Edessa", "EucrosiaUPC", "Euphemia", "Eurostile", "FangSong", "Forte", "FrankRuehl", "Franklin Gothic Heavy", "Franklin Gothic Medium", "FreesiaUPC", "French Script MT", "Gabriola", "Gautami", "Georgia", "Gigi", "Gisha", "Goudy Old Style", "Gulim", "GulimChe", "GungSeo", "Gungsuh", "GungsuhChe", "Haettenschweiler", "Harrington", "Hei S", "HeiT", "Heisei Kaku Gothic", "Hiragino Sans GB", "Impact", "Informal Roman", "IrisUPC", "Iskoola Pota", "JasmineUPC", "KacstOne", "KaiTi", "Kalinga", "Kartika", "Khmer UI", "Kino MT", "KodchiangUPC", "Kokila", "Kozuka Gothic Pr6N", "Lao UI", "Latha", "Leelawadee", "Levenim MT", "LilyUPC", "Lohit Gujarati", "Loma", "Lucida Bright", "Lucida Console", "Lucida Fax", "Lucida Sans Unicode", "MS Gothic", "MS Mincho", "MS PGothic", "MS PMincho", "MS Reference Sans Serif", "MS UI Gothic", "MV Boli", "Magneto", "Malgun Gothic", "Mangal", "Marlett", "Matura MT Script Capitals", "Meiryo UI", "Meiryo", "Menlo", "Microsoft Himalaya", "Microsoft JhengHei", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Sans Serif", "Microsoft Tai Le", "Microsoft Uighur", "Microsoft YaHei", "Microsoft Yi Baiti", "MingLiU", "MingLiU-ExtB", "MingLiU_HKSCS", "MingLiU_HKSCS-ExtB", "Miriam Fixed", "Miriam", "Mongolian Baiti", "MoolBoran", "NSimSun", "Narkisim", "News Gothic MT", "Niagara Solid", "Nyala", "PMingLiU", "PMingLiU-ExtB", "Palace Script MT", "Palatino Linotype", "Papyrus", "Perpetua", "Plantagenet Cherokee", "Playbill", "Prelude Bold", "Prelude Condensed Bold", "Prelude Condensed Medium", "Prelude Medium", "PreludeCompressedWGL Black", "PreludeCompressedWGL Bold", "PreludeCompressedWGL Light", "PreludeCompressedWGL Medium", "PreludeCondensedWGL Black", "PreludeCondensedWGL Bold", "PreludeCondensedWGL Light", "PreludeCondensedWGL Medium", "PreludeWGL Black", "PreludeWGL Bold", "PreludeWGL Light", "PreludeWGL Medium", "Raavi", "Rachana", "Rockwell", "Rod", "Sakkal Majalla", "Sawasdee", "Script MT Bold", "Segoe Print", "Segoe Script", "Segoe UI Light", "Segoe UI Semibold", "Segoe UI Symbol", "Segoe UI", "Shonar Bangla", "Showcard Gothic", "Shruti", "SimHei", "SimSun", "SimSun-ExtB", "Simplified Arabic Fixed", "Simplified Arabic", "Snap ITC", "Sylfaen", "Symbol", "Tahoma", "Times New Roman Baltic", "Times New Roman CE", "Times New Roman CYR", "Times New Roman Greek", "Times New Roman TUR", "Times New Roman", "TlwgMono", "Traditional Arabic", "Trebuchet MS", "Tunga", "Tw Cen MT Condensed Extra Bold", "Ubuntu", "Umpush", "Univers", "Utopia", "Utsaah", "Vani", "Verdana", "Vijaya", "Vladimir Script", "Vrinda", "Webdings", "Wide Latin", "Wingdings"];
      count = fonts.length;
      template = `<b style="display:inline !important; width:auto !important; font:normal 10px/1 'X',sans-serif !important">wwmmllii</b><b style="display:inline !important; width:auto !important; font:normal 10px/1 'X',monospace !important">wwmmllii</b>`;
      fragment = document.createDocumentFragment();
      divs = [];
      for (i = 0; i < count; i = i + 1) {
        font = fonts[i];
        div = document.createElement("div");
        font = font.replace(/['"<>]/g, "");
        div.innerHTML = template.replace(/X/g, font);
        div.style.cssText = style2;
        fragment.appendChild(div);
        divs.push(div);
      }
      body = document.body;
      body.insertBefore(fragment, body.firstChild);
      result = [];
      for (i = 0; i < count; i = i + 1) {
        e = divs[i].getElementsByTagName("b");
        if (e[0].offsetWidth === e[1].offsetWidth) {
          result.push(fonts[i]);
        }
      }
      for (i = 0; i < count; i = i + 1) {
        body.removeChild(divs[i]);
      }
      return result.join("|");
    } catch (err) {
      return strOnError;
    }
  }
  // Get Mime Types.  Return a string containing a list of installed mime types.
  getMimeTypes() {
    var mimeTypeList = "";
    if (navigator.mimeTypes) {
      for (var i = 0; i < navigator.mimeTypes.length; i++) {
        if (i == navigator.mimeTypes.length - 1) {
          mimeTypeList += navigator.mimeTypes[i].description;
        } else {
          mimeTypeList += navigator.mimeTypes[i].description + ", ";
        }
      }
      return mimeTypeList;
    } else {
      return "No-Mime-Type-List";
    }
  }
}
const constants = { USAGE_PREF: "pref" };
const cache = {};
function _initPrefState() {
  const defaultPrefState = {
    themeMode: "light",
    // 'dark'
    isShowDraft: false
    // true
  };
  return defaultPrefState;
}
function _initLocalStore(usage) {
  const defaultPrefState = _initPrefState();
  const initPrefState = _setDisplayCommonLocalStore(constants.USAGE_PREF, defaultPrefState);
  return initPrefState;
}
const getDisplayCommonLocalStore = (usage) => {
  if (typeof window === "undefined") {
    let state = cache[usage];
    if (!state) {
      state = _initPrefState();
      cache[usage] = state;
      return state;
    } else {
      return state;
    }
  } else {
    let state = localStorage.getItem(usage);
    if (!state || state === "null") {
      state = _initLocalStore();
      return state;
    } else {
      return state ? JSON.parse(state) : null;
    }
  }
};
const updateDisplayCommonLocalStore$1 = (usage, type, updates) => {
  if (typeof window === "undefined") {
    throw "Invalid state - request local store update for SSR";
  }
  if (type === constants.USAGE_PREF) {
    const stateStr = localStorage.getItem(usage);
    const state = JSON.parse(stateStr);
    const newState2 = { ...state, ...updates };
    localStorage.setItem(usage, JSON.stringify(newState2));
    return newState2;
  } else
    return null;
};
const _setDisplayCommonLocalStore = (usage, params) => {
  if (typeof window === "undefined") {
    return params;
  } else {
    localStorage.setItem(usage, JSON.stringify(params));
    return params;
  }
};
let urlCache = [];
const myFetch = async (url, options2) => {
  const fetchData = async function() {
    let buffer = { code: 200, msg: "ok", data: null };
    let response;
    try {
      urlCache.push(url);
      response = await fetch(url, options2);
    } catch (error) {
      buffer.code = 999;
      buffer.msg = "myFetch failed(999) : " + error;
      console.error("myFetch failed(999) : ", error);
      return buffer;
    }
    urlCache.pop(url);
    try {
      buffer.data = options2.method == "HEAD" ? response : await response.json();
    } catch (ex) {
      console.warn("myFetch: Got exception in converting response to json" + JSON.stringify(ex));
    }
    buffer.code = response.status || 999;
    buffer.msg = response.statusText || "Error 999";
    buffer.ok = response.ok;
    buffer.type = response.type || "No response type";
    return buffer;
  };
  return await fetchData();
};
const particles = () => {
  if (typeof window !== "undefined") {
    let seedAngles = function() {
      seedsX = [];
      seedsY = [];
      for (var i = 0; i < maxAngles; i++) {
        seedsX.push(Math.random() * 20 - 10);
        seedsY.push(Math.random() * 30 - 10);
      }
    }, Particle = function() {
      if (currentAngle !== maxAngles) {
        this.x = settings.startingX;
        this.y = settings.startingY;
        this.vx = seedsX[currentAngle];
        this.vy = seedsY[currentAngle];
        currentAngle++;
        particleIndex++;
        particles2[particleIndex] = this;
        this.id = particleIndex;
        this.life = 0;
        this.maxLife = settings.maxLife;
      } else {
        console.log("Generating more seed angles");
        seedAngles();
        currentAngle = 0;
      }
    };
    var canvas = window.document.getElementById("myCanvas");
    var context = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = "500";
    canvas.height / 2;
    var particles2 = {}, particleIndex = 0, settings = {
      density: 1,
      particleSize: 5,
      startingX: canvas.width / 2,
      startingY: canvas.height / 4,
      gravity: 0.5,
      maxLife: 150,
      groundLevel: canvas.height,
      leftWall: canvas.width * 0.1,
      rightWall: canvas.width
    };
    var seedsX = [];
    var seedsY = [];
    var maxAngles = 100;
    var currentAngle = 0;
    seedAngles();
    Particle.prototype.draw = function() {
      this.x += this.vx;
      this.y += this.vy;
      if (this.y + settings.particleSize > settings.groundLevel) {
        this.vy *= -0.6;
        this.vx *= 0.75;
        this.y = settings.groundLevel - settings.particleSize;
      }
      if (this.x - settings.particleSize <= settings.leftWall) {
        this.vx *= -1;
        this.x = settings.leftWall + settings.particleSize;
      }
      if (this.x + settings.particleSize >= settings.rightWall) {
        this.vx *= -1;
        this.x = settings.rightWall - settings.particleSize;
      }
      this.vy += settings.gravity;
      this.life++;
      if (this.life >= this.maxLife) {
        delete particles2[this.id];
      }
      context.clearRect(settings.leftWall, settings.groundLevel, canvas.width, canvas.height);
      context.beginPath();
      context.fillStyle = "#0000ff";
      context.arc(this.x, this.y, settings.particleSize, 0, Math.PI * 2, true);
      context.closePath();
      context.fill();
    };
    setInterval(function() {
      context.fillStyle = "rgba(10,10,10,0.8)";
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "white";
      context.fillRect(0, 0, settings.leftWall, canvas.height);
      context.fillRect(settings.rightWall, 0, canvas.width, canvas.height);
      context.fillRect(0, settings.groundLevel, canvas.width, canvas.height);
      for (var i = 0; i < settings.density; i++) {
        new Particle();
      }
      for (var i in particles2) {
        particles2[i].draw();
      }
    }, 30);
  }
};
async function isHomeSiteReachable() {
  let url = null;
  if (typeof window !== "undefined")
    url = window.location.origin;
  if (!url) return false;
  try {
    const resp = await myFetch(url, { method: "HEAD", mode: "cors" });
    if (resp && (resp.ok || resp.type === "opaque")) {
      return true;
    } else {
      console.warn("isHomeSiteReachable() - HEAD request failed:", resp);
      return false;
    }
  } catch (e) {
    return false;
  }
}
var utc$2 = { exports: {} };
var utc$1 = utc$2.exports;
var hasRequiredUtc;
function requireUtc() {
  if (hasRequiredUtc) return utc$2.exports;
  hasRequiredUtc = 1;
  (function(module, exports) {
    !function(t, i) {
      module.exports = i();
    }(utc$1, function() {
      var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
      return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t2) {
          var i2 = { date: t2, utc: true, args: arguments };
          return new f(i2);
        }, u.utc = function(i2) {
          var e2 = n(this.toDate(), { locale: this.$L, utc: true });
          return i2 ? e2.add(this.utcOffset(), t) : e2;
        }, u.local = function() {
          return n(this.toDate(), { locale: this.$L, utc: false });
        };
        var o = u.parse;
        u.parse = function(t2) {
          t2.utc && (this.$u = true), this.$utils().u(t2.$offset) || (this.$offset = t2.$offset), o.call(this, t2);
        };
        var r2 = u.init;
        u.init = function() {
          if (this.$u) {
            var t2 = this.$d;
            this.$y = t2.getUTCFullYear(), this.$M = t2.getUTCMonth(), this.$D = t2.getUTCDate(), this.$W = t2.getUTCDay(), this.$H = t2.getUTCHours(), this.$m = t2.getUTCMinutes(), this.$s = t2.getUTCSeconds(), this.$ms = t2.getUTCMilliseconds();
          } else r2.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s2, f2) {
          var n2 = this.$utils().u;
          if (n2(s2)) return this.$u ? 0 : n2(this.$offset) ? a.call(this) : this.$offset;
          if ("string" == typeof s2 && (s2 = function(t2) {
            void 0 === t2 && (t2 = "");
            var s3 = t2.match(i);
            if (!s3) return null;
            var f3 = ("" + s3[0]).match(e) || ["-", 0, 0], n3 = f3[0], u3 = 60 * +f3[1] + +f3[2];
            return 0 === u3 ? 0 : "+" === n3 ? u3 : -u3;
          }(s2), null === s2)) return this;
          var u2 = Math.abs(s2) <= 16 ? 60 * s2 : s2, o2 = this;
          if (f2) return o2.$offset = u2, o2.$u = 0 === s2, o2;
          if (0 !== s2) {
            var r3 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (o2 = this.local().add(u2 + r3, t)).$offset = u2, o2.$x.$localOffset = r3;
          } else o2 = this.utc();
          return o2;
        };
        var h = u.format;
        u.format = function(t2) {
          var i2 = t2 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return h.call(this, i2);
        }, u.valueOf = function() {
          var t2 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t2;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t2) {
          return "s" === t2 && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t2, i2, e2) {
          if (t2 && this.$u === t2.$u) return c.call(this, t2, i2, e2);
          var s2 = this.local(), f2 = n(t2).local();
          return c.call(s2, f2, i2, e2);
        };
      };
    });
  })(utc$2);
  return utc$2.exports;
}
var utcExports = requireUtc();
const utc = /* @__PURE__ */ getDefaultExportFromCjs(utcExports);
var relativeTime$2 = { exports: {} };
var relativeTime$1 = relativeTime$2.exports;
var hasRequiredRelativeTime;
function requireRelativeTime() {
  if (hasRequiredRelativeTime) return relativeTime$2.exports;
  hasRequiredRelativeTime = 1;
  (function(module, exports) {
    !function(r2, e) {
      module.exports = e();
    }(relativeTime$1, function() {
      return function(r2, e, t) {
        r2 = r2 || {};
        var n = e.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function i(r3, e2, t2, o2) {
          return n.fromToBase(r3, e2, t2, o2);
        }
        t.en.relativeTime = o, n.fromToBase = function(e2, n2, i2, d2, u) {
          for (var f, a, s, l = i2.$locale().relativeTime || o, h = r2.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], m = h.length, c = 0; c < m; c += 1) {
            var y = h[c];
            y.d && (f = d2 ? t(e2).diff(i2, y.d, true) : i2.diff(e2, y.d, true));
            var p = (r2.rounding || Math.round)(Math.abs(f));
            if (s = f > 0, p <= y.r || !y.r) {
              p <= 1 && c > 0 && (y = h[c - 1]);
              var v = l[y.l];
              u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n2, y.l, s);
              break;
            }
          }
          if (n2) return a;
          var M = s ? l.future : l.past;
          return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r3, e2) {
          return i(r3, e2, this, true);
        }, n.from = function(r3, e2) {
          return i(r3, e2, this);
        };
        var d = function(r3) {
          return r3.$u ? t.utc() : t();
        };
        n.toNow = function(r3) {
          return this.to(d(this), r3);
        }, n.fromNow = function(r3) {
          return this.from(d(this), r3);
        };
      };
    });
  })(relativeTime$2);
  return relativeTime$2.exports;
}
var relativeTimeExports = requireRelativeTime();
const relativeTime = /* @__PURE__ */ getDefaultExportFromCjs(relativeTimeExports);
var timezone$2 = { exports: {} };
var timezone$1 = timezone$2.exports;
var hasRequiredTimezone;
function requireTimezone() {
  if (hasRequiredTimezone) return timezone$2.exports;
  hasRequiredTimezone = 1;
  (function(module, exports) {
    !function(t, e) {
      module.exports = e();
    }(timezone$1, function() {
      var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, e = {};
      return function(n, i, o) {
        var r2, a = function(t2, n2, i2) {
          void 0 === i2 && (i2 = {});
          var o2 = new Date(t2), r3 = function(t3, n3) {
            void 0 === n3 && (n3 = {});
            var i3 = n3.timeZoneName || "short", o3 = t3 + "|" + i3, r4 = e[o3];
            return r4 || (r4 = new Intl.DateTimeFormat("en-US", { hour12: false, timeZone: t3, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: i3 }), e[o3] = r4), r4;
          }(n2, i2);
          return r3.formatToParts(o2);
        }, u = function(e2, n2) {
          for (var i2 = a(e2, n2), r3 = [], u2 = 0; u2 < i2.length; u2 += 1) {
            var f2 = i2[u2], s2 = f2.type, m = f2.value, c = t[s2];
            c >= 0 && (r3[c] = parseInt(m, 10));
          }
          var d = r3[3], l = 24 === d ? 0 : d, h = r3[0] + "-" + r3[1] + "-" + r3[2] + " " + l + ":" + r3[4] + ":" + r3[5] + ":000", v = +e2;
          return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t2, e2) {
          void 0 === t2 && (t2 = r2);
          var n2, i2 = this.utcOffset(), a2 = this.toDate(), u2 = a2.toLocaleString("en-US", { timeZone: t2 }), f2 = Math.round((a2 - new Date(u2)) / 1e3 / 60), s2 = 15 * -Math.round(a2.getTimezoneOffset() / 15) - f2;
          if (!Number(s2)) n2 = this.utcOffset(0, e2);
          else if (n2 = o(u2, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(s2, true), e2) {
            var m = n2.utcOffset();
            n2 = n2.add(i2 - m, "minute");
          }
          return n2.$x.$timezone = t2, n2;
        }, f.offsetName = function(t2) {
          var e2 = this.$x.$timezone || o.tz.guess(), n2 = a(this.valueOf(), e2, { timeZoneName: t2 }).find(function(t3) {
            return "timezonename" === t3.type.toLowerCase();
          });
          return n2 && n2.value;
        };
        var s = f.startOf;
        f.startOf = function(t2, e2) {
          if (!this.$x || !this.$x.$timezone) return s.call(this, t2, e2);
          var n2 = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return s.call(n2, t2, e2).tz(this.$x.$timezone, true);
        }, o.tz = function(t2, e2, n2) {
          var i2 = n2 && e2, a2 = n2 || e2 || r2, f2 = u(+o(), a2);
          if ("string" != typeof t2) return o(t2).tz(a2);
          var s2 = function(t3, e3, n3) {
            var i3 = t3 - 60 * e3 * 1e3, o2 = u(i3, n3);
            if (e3 === o2) return [i3, e3];
            var r3 = u(i3 -= 60 * (o2 - e3) * 1e3, n3);
            return o2 === r3 ? [i3, o2] : [t3 - 60 * Math.min(o2, r3) * 1e3, Math.max(o2, r3)];
          }(o.utc(t2, i2).valueOf(), f2, a2), m = s2[0], c = s2[1], d = o(m).utcOffset(c);
          return d.$x.$timezone = a2, d;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t2) {
          r2 = t2;
        };
      };
    });
  })(timezone$2);
  return timezone$2.exports;
}
var timezoneExports = requireTimezone();
const timezone = /* @__PURE__ */ getDefaultExportFromCjs(timezoneExports);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
const friendlyDate = (dateIn) => {
  const dateOut = dayjs(dateIn).fromNow();
  return dateOut;
};
const friendlyMonthDay = (dateIn) => {
  let val;
  const d = dayjs.tz(dateIn, "utc");
  const diff = d.diff(dayjs(), "year");
  if (diff) val = d.format("MMM D, YYYY");
  else val = d.format("MMM D ");
  return val;
};
const relativeDaysDiff = (dateIn1, dateIn2) => {
  if (!dateIn1) dateIn1 = new dayjs();
  else dateIn1 = new dayjs(dateIn1);
  if (!dateIn2) dateIn2 = new dayjs();
  else dateIn2 = new dayjs(dateIn2);
  return dateIn2.diff(dateIn1, "day");
};
const friendlyTitle = (titleIn) => {
  return titleIn;
};
const encode = (str) => str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/[\r\n\t]+/g, "-").replace(/^-+/, "").replace(/-+$/, "") || "untitled";
const slugify = (slugType, emert) => {
  const tit = emert && emert.jsonProp && emert.jsonProp.Title && emert.jsonProp.Title.substring(0, 80) || "";
  const desc = emert && emert.jsonProp && emert.jsonProp.Description && emert.jsonProp.Description.substring(0, 80) || "";
  const prodesc = emert.jsonProp.PRODUCTDESCRIPTIONTXT && emert.jsonProp.PRODUCTDESCRIPTIONTXT.substring(0, 80) || "";
  const title = tit || desc || prodesc;
  const slug = encode(title || "untitled");
  let emertIdStr = "";
  if (emert.id) {
    if (emert.id < 20001) {
      emertIdStr = "01-" + (emert.id + "").padStart(8, "0");
    } else if (emert.id < 40001) {
      emertIdStr = "02-" + (emert.id + "").padStart(8, "0");
    } else if (emert.id < 60001) {
      emertIdStr = "03-" + (emert.id + "").padStart(8, "0");
    } else if (emert.id < 80001) {
      emertIdStr = "04-" + (emert.id + "").padStart(8, "0");
    } else if (emert.id < 100001) {
      emertIdStr = "05-" + (emert.id + "").padStart(8, "0");
    } else if (emert.id < 109001) {
      emertIdStr = "06-" + (emert.id + "").padStart(8, "0");
    } else {
      emertIdStr = "07-" + (emert.id + "").padStart(8, "0");
    }
  }
  return `/${slugType}/${emertIdStr}-${slug}`;
};
const typeToTextList = {
  cpsc: "Consumer Products",
  nhtsa: "Vehicles",
  tire: "Tires",
  equipment: "Equipments",
  css: "Child Safety Seats",
  fdacfsan: "Food",
  fdacder: "Drugs",
  fdacber: "Biologics",
  fdacdrh: "Devices",
  fdacvm: "Veterinary",
  fdactp: "Tobacco",
  fsis: "Meat"
};
const recallTypeToText = (type) => typeToTextList[type];
const displayNumber = (locale, value2) => {
  const options2 = { maximumSignificantDigits: 9 };
  if (typeof value2 !== "number" || isNaN(value2)) return null;
  return new Intl.NumberFormat("en-US", options2).format(value2);
};
const displayDate = (locale, value2) => {
  return displayDateNew(locale, value2);
};
const displayDateNew = (locale, value2) => {
  let retVal = "";
  let isInvalid = false;
  if (value2) {
    try {
      retVal = dayjs.utc(value2).format("MMM D, YYYY");
    } catch (e) {
      isInvalid = true;
    }
  } else {
    return retVal;
  }
  if (isInvalid) {
    console.log("util.js:displayDateNew() type of value is " + typeof value2);
    console.log(value2);
    if (typeof value2 === "object") {
      value2 = value2.toString();
    }
    if (value2 && value2.indexOf("-") === -1) {
      const newValue = value2.substring(0, 4) + "-" + value2.substring(4, 6) + "-" + value2.substring(6) + "T09:00:00.000Z";
      try {
        retVal = dayjs.utc(newValue).format("MMM D, YYYY");
      } catch (e) {
        isInvalid = true;
      }
    } else retVal = "Invalid Date: " + value2;
  }
  return retVal;
};
const suffixSeverity = (data, emertNo) => {
  if (data.severity && data.severity === "1") return emertNo + "  ***";
  else if (data.severity && data.severity === "2") return emertNo + "   **";
  else if (data.severity && data.severity === "3") return emertNo + "    *";
  else if (data.severity && data.severity === "4") return emertNo + "     ";
  else return emertNo + "     ";
};
const friendlyStatus = (value2) => {
  const status = value2 === "load" ? "Announced" : value2 === "created" ? "Announced" : value2 === "updated" ? "Updated" : value2 === "notified" ? "Notified" : "Unknown";
  return status;
};
function getUrlParm(name) {
  let value2 = null;
  if (typeof window !== "undefined" && window.location && window.location.pathname) {
    const searchStr = document.location.search.substring(1);
    if (searchStr) {
      value2 = new URLSearchParams(searchStr).get(name);
      value2 = value2 && value2.substr(0, 1250) || "";
    }
  }
  return value2;
}
const splitPlanInfo = (plan) => {
  let parts = plan.split("-");
  let partApp = parts[0];
  let partPlan = parts[1];
  let partId = parts[2];
  return { partApp, partPlan, partId };
};
const getAccountApps = (appState) => {
  const members = appState.upap && appState.upap?.members;
  const user = appState.user;
  const member = members && members.find((member2) => {
    const acct = member2.account;
    if (user.userNo === acct.userNo) return true;
    else return false;
  });
  const isAccountOwner2 = member.member.type == "Owner";
  const accountApps = member.account.jsonProp["apps"];
  const acctId = member.account.accountCode ? `${member.account.accountNo} (${member.account.accountCode})` : `${member.account.accountNo}`;
  return { isAccountOwner: isAccountOwner2, accountApps, acctId, user };
};
const getAppKey = (appsSubs, display) => {
  let appKey = null;
  Object.keys(appsSubs).forEach((key) => {
    if (appsSubs[key].display === display) {
      appKey = key;
    }
  });
  return appKey;
};
const getAccountAppSub = (accountApps, appKey, type) => {
  let appSubList = accountApps[appKey] || [];
  let accountAppSub = null;
  appSubList && appSubList.forEach((appSubDtls) => {
    if (type == "subscribed") {
      if (appSubDtls.enrollts && !appSubDtls.deenrollts && (!appSubDtls.paymentts && !appSubDtls.depaymentts || appSubDtls.paymentts && appSubDtls.depaymentts)) {
        accountAppSub = appSubDtls;
      }
    } else {
      if (appSubDtls.enrollts && !appSubDtls.deenrollts && appSubDtls.paymentts && !appSubDtls.depaymentts) {
        accountAppSub = appSubDtls;
      }
    }
  });
  return accountAppSub;
};
const getPlans = (appsSubs, app) => {
  let availPlans = [];
  let subKey = null;
  let appPlans = null;
  if (app) {
    Object.keys(appsSubs).forEach((appCode) => {
      const appDtls = appsSubs[appCode];
      if (appDtls.display === app) {
        appPlans = appDtls.plans;
        Object.keys(appPlans).forEach((planKey) => {
          const name = planKey;
          const { partApp, partPlan, partId } = pymtUtil.splitPlanInfo(planKey);
          const planDtls = appPlans[planKey];
          if (planDtls.inuse && planDtls.register) {
            availPlans.push(name);
          }
        });
        subKey = appCode;
      }
    });
  }
  if (!availPlans.length) availPlans = ["None"];
  return { appPlans, availPlans, subKey };
};
const getPymtData = async (apiHost, token, appCode, correlationid2) => {
  const url = appCode ? `${apiHost}/pymtSvc?service=appssubs&appCode=${appCode}` : `${apiHost}/pymtSvc?service=appssubs`;
  const appsSubsMap = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
      "X-CorrelationId": correlationid2
    }
  }).then(async (r2) => await r2.json());
  return appsSubsMap.appssubs;
};
const pymtUtil = { splitPlanInfo, getAccountApps, getPlans, getPymtData, getAccountAppSub, getAppKey };
const getAppSubListHtml = (appState, appssubs2, appSubList, caller, appDisplay, trial) => {
  const appSubListHtml = appSubList.map((appSubDtls, i) => {
    const { partApp, partPlan, partId } = pymtUtil.splitPlanInfo(appSubDtls.plan);
    const planInfo = appssubs2.plans[appSubDtls.plan];
    const planHtmlDiv = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      "Plan: ",
      partPlan
    ] });
    const planRegisterHtmlLi = /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
      "Registered:  ",
      appSubDtls.enrollts ? new Date(appSubDtls.enrollts).toLocaleDateString() : "?",
      "   ",
      appSubDtls.deenrollts ? "Deregistered: " + new Date(appSubDtls.deenrollts).toLocaleDateString() : ""
    ] });
    const planAmountHtmlLi = planInfo.price ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
      " Price: ",
      planInfo.price,
      " "
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: " Price: Unknown " });
    const planAmountYearHtmlLi = planInfo.priceYear ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
      " Annual: ",
      planInfo.priceYear,
      " "
    ] }) : null;
    const planPricePerSeatHtmlLi = planInfo.pricePerSeat ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
      "  ",
      planInfo.pricePerSeat,
      " "
    ] }) : null;
    let createdAt = appSubDtls.createdAt ? new Date(appSubDtls.createdAt) : /* @__PURE__ */ new Date();
    let trialExpiry = new Date(createdAt.getTime() + trial * 24 * 60 * 60 * 1e3);
    const planExpiryHtmlLi = /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: "Trial Expiry: " + new Date(trialExpiry).toLocaleDateString() });
    let planInviteCodeHtmlLi = appSubDtls.invitecode ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
      "Invite Code:  ",
      appSubDtls.invitecode || "",
      " "
    ] }) : null;
    const pymtUrl = `${appState.getEnvVar.SCUR_APP_URL}?nav=subscriptions&display=${appDisplay}&plan=${appSubDtls.plan}`;
    const paymenttsStr = appSubDtls.paymentts ? "Subscription Start: " + new Date(appSubDtls.paymentts).toLocaleDateString() : "";
    const depaymenttsStr = appSubDtls.depaymentts ? "Stop: " + new Date(appSubDtls.depaymentts).toLocaleDateString() : "";
    const paymentTypeStr = appSubDtls.paymenttype == "month" ? "Monthly" : appSubDtls.paymenttype == "year" ? "Annual" : "";
    const planSubscriptionHtmlLi = paymenttsStr || depaymenttsStr ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
      paymenttsStr,
      "  ",
      paymentTypeStr,
      "  ",
      depaymenttsStr
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      "Subscription Not ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { target: "_blank", href: pymtUrl, children: "Setup" })
    ] }) });
    const planDtlsHtmlDiv = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { marginBottom: "1.0rem" }, children: [
      planHtmlDiv,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { style: { listStyle: "none", marginTop: "0rem", marginLeft: "0rem", marginBottom: 0 }, children: [
        planAmountHtmlLi,
        planAmountYearHtmlLi,
        planPricePerSeatHtmlLi,
        planExpiryHtmlLi,
        planInviteCodeHtmlLi,
        planRegisterHtmlLi,
        planSubscriptionHtmlLi
      ] })
    ] });
    const li = /* @__PURE__ */ jsxRuntimeExports.jsx("li", { style: { listStyle: "none", padding: 0, marginTop: "-12px" }, children: planDtlsHtmlDiv }, appSubDtls.plan + "-" + i);
    return li;
  });
  return appSubListHtml;
};
const getAppDescAndSubListHtml = (appState, appssubs2, appKey, appSubList, caller) => {
  const appDisplay = appssubs2[appKey].display;
  const trial = appssubs2[appKey].trial;
  const param = `${appKey}_WWW_URL`;
  const path2 = appssubs2[appKey].plansUrl;
  const pricingHost = appState.getEnvVar[param] || "http://unknown";
  const pricingUrl = `${pricingHost}${path2}`;
  const isDraft = appState.getEnvVar.isDev && appssubs2[appKey].active === "nonprod";
  const descHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        target: "_blank",
        style: { backgroundColor: isDraft ? "yellow" : "transparent" },
        href: pricingUrl,
        children: appssubs2[appKey].display
      }
    ),
    "  -   ",
    appssubs2[appKey].desc
  ] });
  let appSubListDescHtml = "";
  if (appSubList) {
    appSubList.sort(function(a, b) {
      return b.enrollts - a.enrollts;
    });
    const appSubListHtml = getAppSubListHtml(appState, appssubs2[appKey], appSubList, caller, appDisplay, trial);
    appSubListDescHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { style: { padding: 0 }, children: [
      descHtml,
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { listStyle: "none", paddingLeft: "1rem" }, children: appSubListHtml })
    ] }, appKey);
  } else {
    appSubListDescHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { style: { listStyle: "none", padding: 0 }, children: [
      descHtml,
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { paddingLeft: "42px", marginTop: "-12px" }, children: "No Subscriptions" })
    ] }, appKey);
  }
  return appSubListDescHtml;
};
const listSubscriptions = (appState, appssubs2, caller) => {
  appState.isSignIn;
  appState.permission;
  const {
    isAccountOwner: isAccountOwner2,
    accountApps,
    acctId
    /*, user */
  } = pymtUtil.getAccountApps(appState);
  const accountAppsHtml = [];
  if (!isAccountOwner2 || !appssubs2) {
    return null;
  } else {
    Object.keys(appssubs2).forEach((appKey, s) => {
      const appSubList = accountApps[appKey];
      const isActive = appState.getEnvVar.isDev || !appState.getEnvVar.isDev && appssubs2[appKey].active === "prod";
      if (appssubs2[appKey] && isActive) {
        const appSubListDescHtml = getAppDescAndSubListHtml(appState, appssubs2, appKey, appSubList, caller);
        accountAppsHtml.push(appSubListDescHtml);
      }
    });
    const accountAppsAggStr = /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
      " ",
      accountAppsHtml,
      " "
    ] });
    const acctApps = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        "Account: ",
        acctId
      ] }),
      accountAppsAggStr
    ] });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { listStyle: "none", paddingLeft: 0 }, children: [
      acctApps,
      " "
    ] }, "member-1");
  }
};
function ListSubscriptions(props) {
  useTheme();
  const { caller } = props;
  const { appState, dispatch } = useAppContext();
  const [appssubs2, setAppssubs] = useState(null);
  useEffect(() => {
    async function fetchData() {
      const host = appState.getEnvVar.API_SRVR_PYMT_URL;
      const token = appState.token;
      const fpid = appState.fpid;
      const appCode = null;
      const correlationid2 = appState.getCorrelationId ? appState.getCorrelationId() : "?-?";
      const appssubsMap = await pymtUtil.getPymtData(host, token || fpid, appCode, correlationid2);
      setAppssubs(appssubsMap);
    }
    fetchData();
  }, [appState.token]);
  let subscriptionsHtml = null;
  if (!appState.isSignIn) {
    subscriptionsHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: "Plans & Subscriptions" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { sx: {
        p: 0,
        m: 0
      }, children: "Plan registration is not available to pre-assigned anonymous id. Please SignUp and/or SignIn." })
    ] });
  } else {
    if (caller === "PlansPage") {
      subscriptionsHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Current Plans & Subscriptions" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { sx: {
          p: 0,
          mt: 0
        }, children: "Application pricing page provides details on available plans and pricing." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { sx: {
          p: 0,
          mt: 1
        }, children: "All users are automatically registered for a Basic plan. Choose a plan that's right for your needs and try it for free during trial period. Setup a monthly or an annual plan subscription for continuious service." }),
        listSubscriptions(appState, appssubs2, caller)
      ] });
    } else if (caller === "SubscriptionsPage") {
      subscriptionsHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Current Plans & Subscriptions" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { sx: {
          p: 0,
          mt: 0
        }, children: "Application pricing page provides details on available plans and pricing." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { sx: {
          p: 0,
          mt: 2
        }, children: "All users are automatically registered for a Basic plan. Choose a plan that's right for your needs and try it for free during trial period. Setup a monthly or an annual plan subscription for continuious service." }),
        listSubscriptions(appState, appssubs2, caller)
      ] });
    } else if (caller === "AccountOidc") {
      subscriptionsHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: "Plans & Subscriptions" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { sx: {
          p: 0,
          m: 0
        }, children: "Application pricing page provides details on available plans and pricing." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { sx: {
          p: 0,
          mt: 1
        }, children: "All users are automatically registered for a Basic plan. Choose a plan that's right for your needs and try it for free during trial period. Setup a monthly or an annual plan subscription for continuious service." }),
        listSubscriptions(appState, appssubs2, caller)
      ] });
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: subscriptionsHtml });
}
const Frame = (props) => {
  const theme = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { width: 1, height: 1, border: theme.spacing(2), borderColor: theme.palette.grey[400], children: props.children });
};
const PageHeader = (props) => {
  const { page, title } = props;
  if (page) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h1", align: "center", gutterBottom: true, sx: { mt: 1 }, children: page }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h2", align: "center", sx: { mb: 2 }, children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { variant: "middle" })
    ] });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h1", align: "center", gutterBottom: true, sx: { mt: 1 }, children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { variant: "middle" })
    ] });
  }
};
const LogoIcon = (props) => {
  const { appLogoFilePath, logoWidth, logoHeight, appLogoHref, onLogoClick } = props;
  const logoIcon = appLogoFilePath ? /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: appLogoHref || "unknown", onClick: () => onLogoClick("/"), "aria-label": "Home Page", children: /* @__PURE__ */ jsxRuntimeExports.jsx(KLogoImage, { src: appLogoFilePath, height: logoHeight, width: logoWidth, alt: "Site Logo" }) }) : null;
  return logoIcon;
};
const MuiIcon = (props) => {
  const { appLogoFilePath, logoWidth, logoHeight, logoTextColor, appLogoHref, onLogoClick } = props;
  const muiIcon = appLogoFilePath ? /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: appLogoHref || "unknown", onClick: () => onLogoClick("/"), "aria-label": "Home Page", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: appLogoFilePath, sx: {
    verticalAlign: "middle",
    width: logoWidth,
    height: logoHeight,
    color: logoTextColor
  } }) }) : null;
  return muiIcon;
};
const LogoText = (props) => {
  const { text, logoTextColor, logoTextType, logoRainbowColor, logoFont, appLogoHref, onLogoClick } = props;
  const rainbow = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Typography,
    {
      variant: "h6",
      noWrap: true,
      component: "a",
      href: appLogoHref || "unknown",
      onClick: () => onLogoClick("/"),
      "aria-label": "Home Page",
      sx: { textDecoration: "none" },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { component: "span", sx: {
        fontFamily: `${logoFont}`,
        fontSize: "1.8em",
        fontWeight: "bold",
        letterSpacing: ".25rem",
        backgroundImage: `linear-gradient(to right, ${logoTextColor}, ${logoRainbowColor} )`,
        "WebkitBackgroundClip": "text",
        "MozBackgroundClip": "text",
        "WebkitTextFillColor": "transparent",
        "MozTextFillColor": "transparent",
        "&:hover": { backgroundImage: `linear-gradient(to right, ${logoRainbowColor}, ${logoTextColor} )` }
      }, children: [
        " ",
        text,
        " "
      ] })
    }
  );
  const boxed = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Typography,
    {
      variant: "h6",
      noWrap: true,
      component: "a",
      href: appLogoHref || "unknown",
      onClick: () => onLogoClick("/"),
      "aria-label": "Home Page",
      sx: {
        textDecoration: "none"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box$1,
        {
          component: "span",
          sx: {
            fontFamily: `${logoFont}`,
            fontSize: "2.0rem",
            fontWeight: 700,
            lineHeight: "2",
            // Added for FORM
            //border: '4px solid #ff0000',
            //padding: '4px 12px',
            //borderRadius: '8px',
            color: logoTextColor,
            letterSpacing: "0.2rem"
            //backgroundColor: '#f9f9b7',
          },
          children: text
        }
      )
    }
  );
  const plain = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Typography,
    {
      variant: "h6",
      noWrap: true,
      component: "a",
      href: appLogoHref || "unknown",
      onClick: () => onLogoClick("/"),
      "aria-label": "Home Page",
      sx: { textDecoration: "none" },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
        fontSize: "2.0rem",
        fontFamily: `${logoFont}`,
        fontWeight: 700,
        letterSpacing: ".2rem",
        color: logoTextColor
      }, children: text })
    }
  );
  const logoText = text ? logoTextType === "rainbow" ? rainbow : logoTextType === "boxed" ? boxed : plain : null;
  return logoText;
};
function ElevationScroll(props) {
  const { children, window: window2 } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window2 ? window2() : void 0
  });
  return children ? React__default.cloneElement(children, {
    elevation: trigger ? 4 : 0
  }) : null;
}
const Header = (props) => {
  const { headerOptions } = props;
  const {
    appLogoFilePath,
    logoWidth,
    logoHeight,
    logoText,
    logoTextColor,
    logoTextType,
    logoRainbowColor,
    logoFont,
    appLogoHref,
    headerPaths,
    activeStyle,
    inactiveStyle,
    navBarHeightOffset
  } = headerOptions;
  let location = useLocation();
  let fullURL = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
  const { appState, dispatch } = useAppContext();
  const isAuthenticated2 = appState.token ? true : false;
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const [navSelection, setNavSelection] = React__default.useState(null);
  let navigate;
  if (typeof window !== "undefined") navigate = useNavigate();
  appState.getEnvVar;
  const isShowDraft = appState.isShowDraft;
  const ddLabel = "MY ACCOUNT";
  const handleClick = async (pp) => {
    if (!pp || pp == "undefined") return;
    setNavSelection(pp);
    dispatch({ type: "SET_CURRENT_ROUTE", payload: pp });
  };
  const onDropDownClick = async (path2) => {
    handleClick(path2);
    if (typeof window !== "undefined") {
      navigate(path2, { state: { previousLocationPathname: fullURL } });
      event.preventDefault();
    }
  };
  const onNavClick = async (event2, path2, pp) => {
    handleClick(path2);
    if (typeof window !== "undefined") {
      navigate(path2, { state: { previousLocationPathname: fullURL } });
      event2.preventDefault();
    }
  };
  const onLogoClick = (path2) => {
    handleClick(path2);
    if (typeof window !== "undefined") {
      navigate(path2, { state: { previousLocationPathname: fullURL } });
      event.preventDefault();
    }
  };
  const authHdrPaths = headerPaths.filter((item) => item.use.includes("hdr") && item.auth.includes("y") && (!item.draft || isShowDraft));
  const noauthHdrPaths = headerPaths.filter((item) => item.use.includes("hdr") && item.auth.includes("n") && (!item.draft || isShowDraft));
  const authBgrPaths = headerPaths.filter((item) => item.use.includes("bgr") && item.auth.includes("y") && (!item.draft || isShowDraft));
  const noauthBgrPaths = headerPaths.filter((item) => item.use.includes("bgr") && item.auth.includes("n") && (!item.draft || isShowDraft));
  headerPaths.filter((item) => item.use.includes("dd") && item.auth.includes("y") && (!item.draft || isShowDraft));
  headerPaths.filter((item) => item.use.includes("dd") && item.auth.includes("n") && (!item.draft || isShowDraft));
  const hdrPaths = isAuthenticated2 ? authHdrPaths : noauthHdrPaths;
  const bgrPaths = isAuthenticated2 ? authBgrPaths : noauthBgrPaths;
  let userName = appState.username ? appState.username : appState.fpid;
  let isBrowser2 = typeof window === "undefined" ? false : true;
  const items = /* @__PURE__ */ jsxRuntimeExports.jsx(
    NavItems,
    {
      navPaths: hdrPaths,
      onClick: onNavClick,
      urlPathname: location.pathname,
      activeStyle,
      inactiveStyle
    }
  );
  const dropDownMenuLong = bgrPaths && bgrPaths.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    DropDownMenu,
    {
      type: "burger",
      ddPaths: bgrPaths,
      userName,
      ddLabel,
      onClick: onDropDownClick,
      viteUrlPathname: location.pathname,
      activeStyle,
      inactiveStyle
    }
  ) : null;
  const SwitchModeButton = ({ appState: appState2, dispatch: dispatch2 }) => {
    useTheme();
    const payload = appState2.themeMode === "light" ? "dark" : "light";
    const callBack = (e, dispatch3) => dispatch3({ type: "SET_THEME_MODE", payload });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        sx: { ml: 1, fontSize: "2.5rem" },
        title: `Click to switch to ${payload} mode`,
        onClick: (e) => callBack(e, dispatch2),
        color: "inherit",
        children: appState2.themeMode === "dark" ? /* @__PURE__ */ jsxRuntimeExports.jsx(LightMode, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(DarkMode, {})
      }
    );
  };
  let logo = appLogoFilePath && appLogoFilePath.includes("images") ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoIcon, { appLogoFilePath, logoWidth, logoHeight, appLogoHref, onLogoClick }) : /* @__PURE__ */ jsxRuntimeExports.jsx(MuiIcon, { appLogoFilePath, logoWidth, logoHeight, logoTextColor, appLogoHref, onLogoClick });
  const offlineFlag = appState.isOnline ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 6 }, title: "No connection to back end server", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Offline", sx: { verticalAlign: "middle", fontSize: "1.6rem" } }) });
  const nav = isClient ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 2, display: { xs: "none", md: "flex" }, justifyContent: "center" }, children: items }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 3, display: { xs: "flex", md: "none" } }, children: dropDownMenuLong }),
    offlineFlag
  ] }) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ElevationScroll, { ...props, "data-where": "Header-ElevationScroll", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppBar, { sx: { pl: 1, pr: 1, backgroundColor: "primary.main" }, "data-where": "Header-AppBar", position: "fixed", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Toolbar, { disableGutters: true, sx: { display: "flex", flexDirection: "row", justifyContent: "space-between", minHeight: { navBarHeightOffset } }, "data-where": "Header-Toolbar", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { order: 1, display: "flex", flexDirection: "row", flexGrow: 4 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { component: "span", sx: { order: 1, pr: "4px", mt: "2px", ml: "8px" }, children: logo }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { component: "span", sx: { order: 2 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LogoText, { text: logoText, logoTextColor, logoTextType, logoRainbowColor, logoFont, appLogoHref, onLogoClick }) })
      ] }),
      nav,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 5 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchModeButton, { appState, dispatch }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 6, marginTop: 1, marginLeft: 1, mr: "8px", fontWeight: 500, fontSize: "1.0rem" }, title: isAuthenticated2 ? "User Name" : "Anonymous User ID", children: isBrowser2 ? userName : "" })
    ] }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { height: navBarHeightOffset } })
  ] });
};
const Footer$2 = (props) => {
  const theme = useTheme();
  const { footerPaths, hoverTextColor } = props.footerOptions;
  const { appState, dispatch } = useAppContext();
  const [buildInfoState, setBuildInfoState] = React__default.useState(false);
  const getEnvVar2 = appState.getEnvVar;
  const isShowDraft = appState.isShowDraft;
  const authFtrPaths = footerPaths.filter((item) => item.use.includes("ftr") && (!item.draft || isShowDraft) && item.auth.includes("y"));
  const noauthFtrPaths = footerPaths.filter((item) => item.use.includes("ftr") && (!item.draft || isShowDraft) && item.auth.includes("n"));
  const isAuth = appState.isSignIn;
  const ftrPaths = isAuth ? authFtrPaths : noauthFtrPaths;
  appState.isSignIn;
  const appVersion = getEnvVar2.APP_VERSION;
  const appSrvrVersion = appState.srvrVersion;
  getEnvVar2.RUN_ENV;
  const app = getEnvVar2.APP_NAME;
  getEnvVar2.contactUsUrl;
  let buildInfo = null;
  const bg = theme.palette.primary.main;
  const fghide = theme.palette.text.main;
  const draftfg = "error.light";
  const fg = theme.palette.primary.contrastText;
  const handleClick = async (event2, currentRoute) => {
    dispatch({ type: "SET_CURRENT_ROUTE", payload: currentRoute });
  };
  const references = () => {
    const list = ftrPaths.map((item, i) => {
      const buttonStyles = {
        color: item.draft ? draftfg : fg,
        cursor: "pointer",
        paddingRight: "36px",
        "&:hover": { textDecoration: "none", color: hoverTextColor },
        fontSize: "1.0rem",
        textDecoration: "none"
      };
      if (item.type === "ext") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link$1,
          {
            target: "_blank",
            style: { ...buttonStyles },
            to: item.path || "unknown",
            onClick: (event2) => handleClick(event2, item.path),
            rel: "noopener",
            children: item.display
          },
          i
        );
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link$1,
          {
            style: { ...buttonStyles },
            to: item.path || "unknown",
            onClick: (event2) => handleClick(event2, item.path),
            children: item.display
          },
          i
        );
      }
    });
    return list;
  };
  const ToggleBtn = () => {
    if (getEnvVar2.RUN_ENV === "prod")
      return null;
    else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          style: { minWidth: "70%", fontSize: "0.8rem", letterSpacing: "0.2rem", cursor: "grab" },
          onClick: (e) => {
            if (getEnvVar2.RUN_ENV !== "prod") {
              dispatch({ type: "SET_SHOW_DRAFT", payload: !appState.isShowDraft });
            }
          },
          children: appState.isShowDraft ? " DRAFT" : " ."
        }
      ) });
    }
  };
  buildInfo = buildInfoState ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { order: 3, height: "3rem" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { color: fghide, fontSize: "0.8rem" }, children: [
      app,
      ": ",
      appVersion
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { color: fghide, fontSize: "0.8rem" }, children: [
      "server: ",
      appSrvrVersion
    ] })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 3, height: "3rem" } });
  const BuildToggleBtn = (props2) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      buildInfo,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          style: { minWidth: "70%", fontSize: "0.8rem", letterSpacing: "0.2rem", cursor: "grab", height: "30px", width: "100px", display: "table-cell" },
          onClick: (e) => {
            setBuildInfoState(!buildInfoState);
          },
          children: " "
        }
      )
    ] });
  };
  function Copyright() {
    const kripaWebsite = getEnvVar2.KRIP_WWW_URL || "unknown";
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
      "Copyright © ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Link$1,
        {
          target: "_blank",
          style: {
            color: fg,
            textDecoration: "none",
            cursor: "pointer",
            paddingRight: "8px",
            "&:hover": { textDecoration: "none", color: hoverTextColor },
            fontSize: "1.0rem"
          },
          to: kripaWebsite,
          rel: "noopener",
          children: [
            "Kripa, Inc ",
            (/* @__PURE__ */ new Date()).getFullYear()
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ToggleBtn, {})
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { backgroundColor: bg, color: fg, py: 3 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container, { sx: { display: "flex", flexDirection: "column", textDecoration: "none" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 1, display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "start", pb: 1, pl: 2 }, children: references() }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 2, px: 2, py: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Copyright, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { order: 3, px: 2, py: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BuildToggleBtn, {}) })
  ] }) });
};
const useStyles$G = (theme) => {
  return {
    root: {
      overflowY: "scroll"
    }
    // a style rule
  };
};
const Scroller = (props) => {
  useTheme();
  const classes = useStyles$G();
  const { height: height2, width: width2, className } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classes.root, ...className }, style: { height: height2, width: width2 }, children: props.children });
};
const PageContentFormat = (props) => {
  const theme = useTheme();
  const { pageContent } = props;
  const { appState, dispatch } = useAppContext();
  const isShowDraft = appState.isShowDraft;
  const contentLinks = (type, content2, secId) => {
    let contentList;
    if (type === "sections") {
      contentList = content2.sections;
    } else {
      contentList = content2.areas;
    }
    if (content2.links && contentList.length > 2) {
      const items = contentList.map((item, i) => {
        if (!isShowDraft && item.draft) return null;
        const target = secId > -1 ? "#targetitem-" + secId + "-" + i : "#targetitem-" + i;
        const title = item.title.replace(/(<([^>]+)>)/ig, "");
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6, md: 4 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { sx: { padding: "0px", paddingRight: "2rem" }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { sx: { width: "14px", height: "14px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(KripaRedBallIcon, {}) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: target, sx: {
            marginLeft: "-2.2rem",
            textDecoration: `none`,
            "&:hover, &:focus": { textDecoration: `none` }
          }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: title, primaryTypographyProps: { color: "primary.contrastText", fontSize: "120%" } }) })
        ] }) }, "linkitem-" + i);
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", sx: { py: 3 }, children: "OUR " + pageContent.page.toUpperCase() }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(List, { sx: { pt: 1, pb: 4, px: 8 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, children: items }) })
      ] });
    }
    return null;
  };
  const singleAreaContent = (pageContent2, section, secId, area, areaId) => {
    if (!isShowDraft && area.draft) return null;
    const isDraftClass = area.draft ? { background: "yellow" } : null;
    const lgCols = Math.round(12 / section.cols || 3);
    let mdCols = Math.round(12 / (section.cols / 2) || 2);
    mdCols = mdCols > 12 ? 12 : mdCols;
    const areaStyle = area.style && area.style.box ? area.style.box : null;
    const areaAnimate = area.style && area.style.animate ? area.style.animate : null;
    area.icon ? /* @__PURE__ */ jsxRuntimeExports.jsx(KImage, { src: area.icon }) : null;
    const areaPic = area.image ? /* @__PURE__ */ jsxRuntimeExports.jsx(KImage, { width: "140", src: area.image }) : null;
    const areaQuestion = area.question ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", gutterBottom: true, dangerouslySetInnerHTML: { __html: area.question } }) : null;
    const areaTitle = area.title ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, dangerouslySetInnerHTML: { __html: area.title } }) : null;
    const areaSubTitle = area.subTitle ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", gutterBottom: true, dangerouslySetInnerHTML: { __html: area.subTitle } }) : null;
    const areaPara = area.para && area.para.length && area.para.map((p, pId) => {
      if (!p) return null;
      if (p.startsWith("<ol>")) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { dangerouslySetInnerHTML: { __html: p.substring(4, p.length - 5) }, style: { padding: "0.2rem 0rem 0rem 2rem" } }, `sec-${secId}-area-${areaId}-ol-${pId}`);
      } else if (p.startsWith("<ul>")) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { dangerouslySetInnerHTML: { __html: p.substring(4, p.length - 5) }, style: { padding: "0.2rem 0rem 0rem 2rem" } }, `sec-${secId}-area-${areaId}-ul-${pId}`);
      } else if (p.startsWith("<p>")) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: { __html: p.substring(3, p.length - 4) }, style: { padding: "0.2rem 0rem 0rem 0rem" } }, `sec-${secId}-area-${areaId}-p-${pId}`);
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: { __html: p }, style: { padding: "0.2rem 0rem 0rem 0rem" } }, `sec-${secId}-area-${areaId}-p-${pId}`);
      }
    }) || null;
    const areaFooter = area.footer ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, dangerouslySetInnerHTML: { __html: area.footer } }) : null;
    const areaSubFooter = area.subFooter ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", gutterBottom: true, dangerouslySetInnerHTML: { __html: area.subFooter } }) : null;
    const areaContent = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "targetitem-" + secId + "-" + areaId, children: [
      areaPic,
      areaQuestion,
      areaTitle,
      areaSubTitle,
      areaPara,
      areaFooter,
      areaSubFooter
    ] });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: mdCols, lg: lgCols }, sx: { ...isDraftClass }, children: areaAnimate ? /* @__PURE__ */ jsxRuntimeExports.jsx(Slide, { direction: areaAnimate.direction, in: areaAnimate.in, mountOnEnter: true, unmountOnExit: true, timeout: { enter: areaAnimate.timeoutEnter }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...areaStyle }, children: areaContent }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...areaStyle }, children: areaContent }) }, `sec-${secId}-area-${areaId}`);
  };
  const areasContentFormat = (pageContent2, section, secId) => {
    if (!section.areas) return null;
    const areasHtml = section.areas.map((area, areaId) => {
      if (!area) return null;
      else {
        return singleAreaContent(pageContent2, section, secId, area, areaId);
      }
    });
    return areasHtml;
  };
  const wrapSVG = (Content) => {
    const noanimate = {
      position: "absolute",
      top: 0,
      left: 0,
      fill: "#cccccc",
      //'#023F92',  // blogGray
      width: "50vmax",
      //zIndex: -1,
      transformOrigin: "50% 50%"
    };
    const animate = {
      "@keyframes move": {
        "0%": { transform: "scale(1)   translate(10px, -30px)" },
        "38%": { transform: "scale(0.8, 1) translate(80vw, 30vh) rotate(160deg)" },
        "40%": { transform: "scale(0.8, 1) translate(80vw, 30vh) rotate(160deg)" },
        "78%": { transform: "scale(1.3) translate(0vw, 50vh) rotate(-20deg)" },
        "80%": { transform: "scale(1.3) translate(0vw, 50vh) rotate(-20deg)" },
        "100%": { transform: "scale(1)   translate(10px, -30px)" }
      },
      animation: "move 10s ease-in-out infinite"
    };
    let classValue = noanimate;
    if (pageContent.svg.toLowerCase().indexOf("animate") !== -1) {
      classValue = { ...noanimate, ...animate };
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: {
      m: 0,
      p: 0,
      width: "auto",
      height: "auto",
      overflow: "hidden",
      position: "relative",
      display: "flex",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { zIndex: 100 }, children: Content }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classValue }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "00 00 310 350", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "g",
        {
          fill: "#f6d9d9",
          stroke: "none",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  \nc-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" })
        }
      ) }) })
    ] });
  };
  const sectionBanner = (pageContent2) => {
    if (!pageContent2.image) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h1", gutterBottom: true, dangerouslySetInnerHTML: { __html: pageContent2.title } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h3", gutterBottom: true, dangerouslySetInnerHTML: { __html: pageContent2.subTitle } })
      ] });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Banner, { pageContent: pageContent2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        pageContent2.para.map((p, pId) => {
          if (!p) return null;
          const paraStyle = pageContent2.style?.paraStyle ? pageContent2.style.paraStyle : {};
          paraStyle["fontSize"] = "1.2rem";
          paraStyle["fontWeight"] = "500";
          if (p.startsWith("<ol>")) {
            return /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { dangerouslySetInnerHTML: { __html: p.substring(4, p.length - 5) }, style: { ...paraStyle, p: { xs: "0.2rem 1rem 0rem 2rem", sm: "1rem 6rem 0rem 6rem", md: "1rem 4rem 0rem 4rem" } } }, `p-${pId}`);
          } else if (p.startsWith("<ul>")) {
            return /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { dangerouslySetInnerHTML: { __html: p.substring(4, p.length - 5) }, style: { ...paraStyle, p: { xs: "0.2rem 1rem 0rem 2rem", sm: "1rem 6rem 0rem 6rem", md: "1rem 4rem 0rem 4rem" } } }, `p-${pId}`);
          } else if (p.startsWith("<p>")) {
            return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: { __html: p.substring(3, p.length - 4) }, style: { ...paraStyle, p: { xs: "0.2rem 1rem 0rem 0rem", sm: "1rem 6rem 0rem 6rem", md: "1rem 4rem 0rem 4rem" } } }, `p-${pId}`);
          } else {
            return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: { __html: p }, style: { ...paraStyle, p: { xs: "0.2rem 1rem 0rem 0rem", sm: "1rem 6rem 0rem 6rem", md: "1rem 4rem 0rem 4rem" } } }, `p-${pId}`);
          }
        })
      ] });
    }
  };
  const singleSectionContent = (pageContent2, section, secId) => {
    if (!isShowDraft && section.draft) return null;
    const isDraftClass = section.draft ? { background: "yellow" } : null;
    const sectionPic = section.image ? /* @__PURE__ */ jsxRuntimeExports.jsx(KImage, { width: "100%", src: section.image }) : null;
    const sectionQuestion = section.question ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, dangerouslySetInnerHTML: { __html: section.question } }) : null;
    const sectionTitle = section.title ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h2", gutterBottom: true, dangerouslySetInnerHTML: { __html: section.title } }) : null;
    const sectionSubTitle = section.subTitle ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, dangerouslySetInnerHTML: { __html: section.subTitle } }) : null;
    const sectionPara = section.para && section.para.length && section.para.map((p, pId) => {
      if (!p) return null;
      if (p.startsWith("<ol>")) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { dangerouslySetInnerHTML: { __html: p.substring(4, p.length - 5) }, style: { padding: "0.2rem 0rem 0rem 2rem" } }, `sec-${secId}-ol-${pId}`);
      } else if (p.startsWith("<ul>")) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { dangerouslySetInnerHTML: { __html: p.substring(4, p.length - 5) }, style: { padding: "0.2rem 0rem 0rem 2rem" } }, `sec-${secId}-ul-${pId}`);
      } else if (p.startsWith("<p>")) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: { __html: p.substring(3, p.length - 4) }, style: { padding: "0.2rem 0rem 0rem 0rem" } }, `sec-${secId}-p-${pId}`);
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: { __html: p }, style: { padding: "0.2rem 0rem 0rem 0rem" } }, `sec-${secId}-p-${pId}`);
      }
    }) || null;
    const sectionFooter = section.footer ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h3", gutterBottom: true, dangerouslySetInnerHTML: { __html: section.footer } }) : null;
    const sectionSubFooter = section.subFooter ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h3", gutterBottom: true, dangerouslySetInnerHTML: { __html: section.subFooter } }) : null;
    const sectionAreaLinks = contentLinks("areas", section, secId);
    const sectionDetail = areasContentFormat(pageContent2, section, secId);
    const sectionContentTop = /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { id: "targetitem-" + secId, sx: { p: { xs: "1rem", sm: "2rem", md: "4rem" } }, children: [
      sectionQuestion,
      sectionTitle,
      sectionSubTitle,
      sectionPara
    ] });
    const sectionContentMid = /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { margin: "1rem" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, children: [
      sectionAreaLinks,
      sectionDetail
    ] }) });
    const sectionContentBot = /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { m: { xs: "1rem 0rem", sm: "2rem 0rem", md: "4rem 0rem" } }, children: [
      sectionFooter,
      sectionSubFooter
    ] });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, sx: { ...isDraftClass }, children: [
      secId % 2 === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, alignItems: "center", spacing: 2, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: sectionPic }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: sectionContentTop })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, alignItems: "center", spacing: 2, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: sectionContentTop }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: sectionPic })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: sectionContentMid }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: sectionContentBot })
    ] }, `sec-${secId}`);
  };
  const sectionsContentFormat = (pageContent2) => {
    const sectionsHtml = pageContent2.sections.map((section, secId) => {
      if (!section) return null;
      else {
        return singleSectionContent(pageContent2, section, secId);
      }
    });
    return sectionsHtml;
  };
  const sectionsContent = (pageContent2) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: pageContent2.svg ? wrapSVG(sectionsContentFormat(pageContent2)) : sectionsContentFormat(pageContent2) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, sx: { paddingBottom: "5rem" }, children: [
        pageContent2.footer ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h3", gutterBottom: true, dangerouslySetInnerHTML: { __html: pageContent2.footer } }) : null,
        pageContent2.subFooter ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", gutterBottom: true, dangerouslySetInnerHTML: { __html: pageContent2.subFooter } }) : null
      ] })
    ] });
  };
  const banner = sectionBanner(pageContent);
  const links = contentLinks("sections", pageContent, -1);
  const content = sectionsContent(pageContent);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(SectionLayout, { option: "nopadding", sectionStyle: { backgroundColor: theme.custom.contentpanelBG }, children: [
    banner,
    links,
    content
  ] }) });
};
const useStyles$F = (theme) => {
  return {
    addsense: {
      border: "10px solid #558B2F"
    }
  };
};
const GooAdverts = (props) => {
  useTheme();
  const classes = useStyles$F();
  const { type, client, slot, format } = props;
  let html = null;
  switch (type) {
    case "nosetup":
      html = /* @__PURE__ */ jsxRuntimeExports.jsx(
        AdSense.Google,
        {
          client: client || "ca-pub-7292810486004926",
          slot: slot || "7806394673"
        }
      );
      break;
    case "custom":
      html = /* @__PURE__ */ jsxRuntimeExports.jsx(
        AdSense.Google,
        {
          client: client || "ca-pub-7292810486004926",
          slot: slot || "7806394673",
          style: { width: 500, height: 300, float: "left" },
          format: ""
        }
      );
      break;
    case "responsive":
      html = /* @__PURE__ */ jsxRuntimeExports.jsx(
        AdSense.Google,
        {
          client: client || "ca-pub-7292810486004926",
          slot: slot || "7806394673",
          style: { display: "block" },
          layout: "in-article",
          format: "fluid"
        }
      );
      break;
    case "fullwidth":
    case "default":
      html = /* @__PURE__ */ jsxRuntimeExports.jsx(
        AdSense.Google,
        {
          client: client || "ca-pub-7292810486004926",
          slot: slot || "7806394673",
          style: { display: "block" },
          format: "auto",
          responsive: "true",
          layoutKey: "-gw-1+2a-9x+5c"
        }
      );
      break;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { ...classes.addsense }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        margin: "2rem",
        padding: "5rem",
        backgroundColor: "#fff"
      },
      children: html
    }
  ) });
};
const FaqFormatter = (props) => {
  const { faqData } = props;
  const faqContent = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: faqData.content.mainEntity.map((data, index) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h2", gutterBottom: true, children: data.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "div", gutterBottom: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: data.acceptedAnswer.text } }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { sx: { my: 4 } })
    ] }, `content_item_${index}`);
  }) });
  const page = faqData.meta.title;
  const title = "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { page, title }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { marginTop: 4 }, children: faqContent })
  ] });
};
const useStyles$E = (theme) => {
  const border2 = `5px solid ${theme.palette.text.primary}`;
  return {
    root: {
      flexGrow: 1
    },
    menu: {
      backgroundColor: theme.palette.primary.main
    },
    menuitem: {
      color: theme.palette.text.primary,
      //       color: 'black',
      padding: theme.custom.sectionGap
    },
    link: {
      textDecoration: `none`,
      paddingBottom: "5px",
      "&:hover, &:focus": {
        textDecoration: `none`,
        borderBottom: border2,
        paddingBottom: "0px"
      },
      color: theme.palette.text.primary
      //       color: 'black',
    },
    linkActive: {
      borderBottom: border2
    }
  };
};
function BurgerMenu(props) {
  const theme = useTheme();
  const classes = useStyles$E(theme);
  const { anchorEl, setAnchorEl, menuLinks, menuProc } = props;
  const handleClose = () => {
    setAnchorEl(null);
  };
  const menuCurrent = typeof window !== "undefined" && window.location && window.location.pathname || "";
  const links = menuLinks.map((menu, i) => {
    const className = menu.link === menuCurrent ? { ...classes.link, ...classes.linkActive } : classes.link;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onClick: handleClose, style: { ...classes.menuitem }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { onClick: (e) => menuProc(menu), style: { ...className }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "button", display: "block", gutterBottom: true, color: "inherit", children: menu.name }) }, i) }, i) });
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Menu,
    {
      id: "simple-menu",
      anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      classes: { list: classes.menu },
      children: links
    }
  ) });
}
const useStyles$D = (theme) => {
  return {
    step: {
      padding: "1.0rem"
    },
    desc: {
      padding: "2.0rem",
      margin: "1.0rem",
      verticalAlign: "center",
      lineHeight: "2.0rem",
      border: "1px solid gray"
    },
    supply: {
      padding: "1.0rem",
      marginBottom: "1.0rem"
    },
    tools: {
      padding: "1.0rem",
      marginBottom: "1.0rem"
    }
  };
};
const HowToFormatter = (props) => {
  useTheme();
  const classes = useStyles$D();
  const { howToData } = props;
  const howToSteps = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: howToData.content.step.map((data, index) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, style: { ...classes.step }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", gutterBottom: true, children: 1 + index + ". " + data.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", gutterBottom: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: data.text } }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "caption", gutterBottom: true, children: data.image ? "Include image and URL for the step" : null })
    ] }, `content_step_${index}`);
  }) });
  const page = howToData.meta.title;
  const title = "";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SectionLayout, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container, { maxWidth: "md", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { page, title }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, size: { xs: 12 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(KImage, { src: howToData.content.image.url }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", gutterBottom: true, style: { ...classes.desc }, children: howToData.content.description }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 6 }, style: { ...classes.supply }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", gutterBottom: true, children: "Supply:" }),
        howToData.content.supply.map((item, index) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: item.name }, `content_subtitle_${index}`);
        })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 6 }, style: { ...classes.tools }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", gutterBottom: true, children: "Tools:" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "p", gutterBottom: true, children: howToData.content.tool.map((item) => item.name) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, style: { ...classes.tools }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Steps" }) }),
      howToSteps
    ] })
  ] }) });
};
function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === "production") {
    return () => null;
  }
  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}
var reactIs$1 = { exports: {} };
var reactIs_production$1 = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production$1;
function requireReactIs_production$1() {
  if (hasRequiredReactIs_production$1) return reactIs_production$1;
  hasRequiredReactIs_production$1 = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
  var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function typeOf(object) {
    if ("object" === typeof object && null !== object) {
      var $$typeof = object.$$typeof;
      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          switch (object = object.type, object) {
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
            case REACT_SUSPENSE_LIST_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
              return object;
            default:
              switch (object = object && object.$$typeof, object) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                  return object;
                case REACT_CONSUMER_TYPE:
                  return object;
                default:
                  return $$typeof;
              }
          }
        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }
  }
  reactIs_production$1.ContextConsumer = REACT_CONSUMER_TYPE;
  reactIs_production$1.ContextProvider = REACT_CONTEXT_TYPE;
  reactIs_production$1.Element = REACT_ELEMENT_TYPE;
  reactIs_production$1.ForwardRef = REACT_FORWARD_REF_TYPE;
  reactIs_production$1.Fragment = REACT_FRAGMENT_TYPE;
  reactIs_production$1.Lazy = REACT_LAZY_TYPE;
  reactIs_production$1.Memo = REACT_MEMO_TYPE;
  reactIs_production$1.Portal = REACT_PORTAL_TYPE;
  reactIs_production$1.Profiler = REACT_PROFILER_TYPE;
  reactIs_production$1.StrictMode = REACT_STRICT_MODE_TYPE;
  reactIs_production$1.Suspense = REACT_SUSPENSE_TYPE;
  reactIs_production$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
  reactIs_production$1.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
  };
  reactIs_production$1.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  };
  reactIs_production$1.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  };
  reactIs_production$1.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  };
  reactIs_production$1.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  };
  reactIs_production$1.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  };
  reactIs_production$1.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  };
  reactIs_production$1.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  };
  reactIs_production$1.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  };
  reactIs_production$1.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  };
  reactIs_production$1.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  };
  reactIs_production$1.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
  };
  reactIs_production$1.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
  };
  reactIs_production$1.typeOf = typeOf;
  return reactIs_production$1;
}
var reactIs_development$1 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  "production" !== process.env.NODE_ENV && function() {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object = object.type, object) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (object = object && object.$$typeof, object) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development$1.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development$1.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development$1.Element = REACT_ELEMENT_TYPE;
    reactIs_development$1.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development$1.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development$1.Lazy = REACT_LAZY_TYPE;
    reactIs_development$1.Memo = REACT_MEMO_TYPE;
    reactIs_development$1.Portal = REACT_PORTAL_TYPE;
    reactIs_development$1.Profiler = REACT_PROFILER_TYPE;
    reactIs_development$1.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development$1.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development$1.isContextConsumer = function(object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development$1.isContextProvider = function(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development$1.isElement = function(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    reactIs_development$1.isForwardRef = function(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development$1.isFragment = function(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development$1.isLazy = function(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development$1.isMemo = function(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development$1.isPortal = function(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development$1.isProfiler = function(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development$1.isStrictMode = function(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development$1.isSuspense = function(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development$1.isSuspenseList = function(object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development$1.isValidElementType = function(type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
    };
    reactIs_development$1.typeOf = typeOf;
  }();
  return reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1) return reactIs$1.exports;
  hasRequiredReactIs$1 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$1.exports = /* @__PURE__ */ requireReactIs_production$1();
  } else {
    reactIs$1.exports = /* @__PURE__ */ requireReactIs_development$1();
  }
  return reactIs$1.exports;
}
var reactIsExports$1 = /* @__PURE__ */ requireReactIs$1();
function isPlainObject$1(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone$1(source) {
  if (/* @__PURE__ */ React.isValidElement(source) || reactIsExports$1.isValidElementType(source) || !isPlainObject$1(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone$1(source[key]);
  });
  return output;
}
function deepmerge$1(target, source, options2 = {
  clone: true
}) {
  const output = options2.clone ? {
    ...target
  } : target;
  if (isPlainObject$1(target) && isPlainObject$1(source)) {
    Object.keys(source).forEach((key) => {
      if (/* @__PURE__ */ React.isValidElement(source[key]) || reactIsExports$1.isValidElementType(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject$1(source[key]) && // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject$1(target[key])) {
        output[key] = deepmerge$1(target[key], source[key], options2);
      } else if (options2.clone) {
        output[key] = isPlainObject$1(source[key]) ? deepClone$1(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
function isClassComponent(elementType) {
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === "undefined") {
    return null;
  }
  let warningHint;
  if (typeof propValue === "function" && !isClassComponent(propValue)) {
    warningHint = "Did you accidentally provide a plain function component instead?";
  }
  if (warningHint !== void 0) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an element type that can hold a ref. ${warningHint} For more information see https://mui.com/r/caveat-with-refs-guide`);
  }
  return null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);
function formatMuiErrorMessage$1(code, ...args) {
  const url = new URL(`https://mui.com/production-error/?code=${code}`);
  args.forEach((arg2) => url.searchParams.append("args[]", arg2));
  return `Minified MUI error #${code}; visit ${url} for the full message.`;
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function capitalize$1(string) {
  if (typeof string !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage$1(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function setRef(ref, value2) {
  if (typeof ref === "function") {
    ref(value2);
  } else if (ref) {
    ref.current = value2;
  }
}
const useEnhancedEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
function useEventCallback(fn) {
  const ref = React.useRef(fn);
  useEnhancedEffect(() => {
    ref.current = fn;
  });
  return React.useRef((...args) => (
    // @ts-expect-error hide `this`
    (0, ref.current)(...args)
  )).current;
}
function useForkRef(...refs) {
  return React.useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }
    return (instance) => {
      refs.forEach((ref) => {
        setRef(ref, instance);
      });
    };
  }, refs);
}
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
  const ref = React.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}
const EMPTY = [];
function useOnMount(fn) {
  React.useEffect(fn, EMPTY);
}
class Timeout {
  constructor() {
    __publicField(this, "currentId", null);
    __publicField(this, "clear", () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    });
    __publicField(this, "disposeEffect", () => {
      return this.clear;
    });
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn();
    }, delay);
  }
}
function useTimeout() {
  const timeout = useLazyRef(Timeout.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}
function isFocusVisible(element) {
  try {
    return element.matches(":focus-visible");
  } catch (error) {
    if (process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent)) {
      console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join("\n"));
    }
  }
  return false;
}
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  for (const slotName in slots) {
    const slot = slots[slotName];
    let buffer = "";
    let start = true;
    for (let i = 0; i < slot.length; i += 1) {
      const value2 = slot[i];
      if (value2) {
        buffer += (start === true ? "" : " ") + getUtilityClass(value2);
        start = false;
        if (classes && classes[value2]) {
          buffer += " " + classes[value2];
        }
      }
    }
    output[slotName] = buffer;
  }
  return output;
}
const defaultGenerator = (componentName) => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
}
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
  const result = {};
  slots.forEach((slot) => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
function formatMuiErrorMessage(code, ...args) {
  const url = new URL(`https://mui.com/production-error/?code=${code}`);
  args.forEach((arg2) => url.searchParams.append("args[]", arg2));
  return `Minified MUI error #${code}; visit ${url} for the full message.`;
}
function capitalize(string) {
  if (typeof string !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var reactIs = { exports: {} };
var reactIs_production = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
  var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function typeOf(object) {
    if ("object" === typeof object && null !== object) {
      var $$typeof = object.$$typeof;
      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          switch (object = object.type, object) {
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
            case REACT_SUSPENSE_LIST_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
              return object;
            default:
              switch (object = object && object.$$typeof, object) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                  return object;
                case REACT_CONSUMER_TYPE:
                  return object;
                default:
                  return $$typeof;
              }
          }
        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }
  }
  reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
  reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
  reactIs_production.Element = REACT_ELEMENT_TYPE;
  reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
  reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
  reactIs_production.Lazy = REACT_LAZY_TYPE;
  reactIs_production.Memo = REACT_MEMO_TYPE;
  reactIs_production.Portal = REACT_PORTAL_TYPE;
  reactIs_production.Profiler = REACT_PROFILER_TYPE;
  reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
  reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
  reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
  reactIs_production.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
  };
  reactIs_production.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  };
  reactIs_production.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  };
  reactIs_production.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  };
  reactIs_production.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  };
  reactIs_production.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  };
  reactIs_production.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  };
  reactIs_production.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  };
  reactIs_production.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  };
  reactIs_production.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  };
  reactIs_production.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  };
  reactIs_production.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
  };
  reactIs_production.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
  };
  reactIs_production.typeOf = typeOf;
  return reactIs_production;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  "production" !== process.env.NODE_ENV && function() {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object = object.type, object) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (object = object && object.$$typeof, object) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development.Element = REACT_ELEMENT_TYPE;
    reactIs_development.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development.Lazy = REACT_LAZY_TYPE;
    reactIs_development.Memo = REACT_MEMO_TYPE;
    reactIs_development.Portal = REACT_PORTAL_TYPE;
    reactIs_development.Profiler = REACT_PROFILER_TYPE;
    reactIs_development.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development.isContextConsumer = function(object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development.isContextProvider = function(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development.isElement = function(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    reactIs_development.isForwardRef = function(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development.isFragment = function(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development.isLazy = function(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development.isMemo = function(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development.isPortal = function(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development.isProfiler = function(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development.isStrictMode = function(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development.isSuspense = function(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development.isSuspenseList = function(object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development.isValidElementType = function(type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
    };
    reactIs_development.typeOf = typeOf;
  }();
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = /* @__PURE__ */ requireReactIs_production();
  } else {
    reactIs.exports = /* @__PURE__ */ requireReactIs_development();
  }
  return reactIs.exports;
}
var reactIsExports = /* @__PURE__ */ requireReactIs();
function isPlainObject(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (/* @__PURE__ */ React.isValidElement(source) || reactIsExports.isValidElementType(source) || !isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options2 = {
  clone: true
}) {
  const output = options2.clone ? {
    ...target
  } : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (/* @__PURE__ */ React.isValidElement(source[key]) || reactIsExports.isValidElementType(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject(source[key]) && // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        output[key] = deepmerge(target[key], source[key], options2);
      } else if (options2.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
const responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function sortContainerQueries(theme, css2) {
  if (!theme.containerQueries) {
    return css2;
  }
  const sorted = Object.keys(css2).filter((key) => key.startsWith("@container")).sort((a, b) => {
    const regex = /min-width:\s*([0-9.]+)/;
    return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
  });
  if (!sorted.length) {
    return css2;
  }
  return sorted.reduce((acc, key) => {
    const value2 = css2[key];
    delete acc[key];
    acc[key] = value2;
    return acc;
  }, {
    ...css2
  });
}
function isCqShorthand(breakpointKeys, value2) {
  return value2 === "@" || value2.startsWith("@") && (breakpointKeys.some((key) => value2.startsWith(`@${key}`)) || !!value2.match(/^@\d/));
}
function getContainerQuery(theme, shorthand) {
  const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
  if (!matches) {
    if (process.env.NODE_ENV !== "production") {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${shorthand})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : formatMuiErrorMessage(18, `(${shorthand})`));
    }
    return null;
  }
  const [, containerQuery, containerName] = matches;
  const value2 = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
  return theme.containerQueries(containerName).up(value2);
}
function cssContainerQueries(themeInput) {
  const toContainerQuery = (mediaQuery, name) => mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
  function attachCq(node2, name) {
    node2.up = (...args) => toContainerQuery(themeInput.breakpoints.up(...args), name);
    node2.down = (...args) => toContainerQuery(themeInput.breakpoints.down(...args), name);
    node2.between = (...args) => toContainerQuery(themeInput.breakpoints.between(...args), name);
    node2.only = (...args) => toContainerQuery(themeInput.breakpoints.only(...args), name);
    node2.not = (...args) => {
      const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
      if (result.includes("not all and")) {
        return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
      }
      return result;
    };
  }
  const node = {};
  const containerQueries = (name) => {
    attachCq(node, name);
    return node;
  };
  attachCq(containerQueries);
  return {
    ...themeInput,
    containerQueries
  };
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values$1[key]}px)`
};
const defaultContainerQueries = {
  containerQueries: (containerName) => ({
    up: (key) => {
      let result = typeof key === "number" ? key : values$1[key] || key;
      if (typeof result === "number") {
        result = `${result}px`;
      }
      return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
    }
  })
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (isCqShorthand(themeBreakpoints.keys, breakpoint)) {
        const containerKey = getContainerQuery(theme.containerQueries ? theme : defaultContainerQueries, breakpoint);
        if (containerKey) {
          acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
        }
      } else if (Object.keys(themeBreakpoints.values || values$1).includes(breakpoint)) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style2) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style2);
}
function getPath(obj, path2, checkVars = true) {
  if (!path2 || typeof path2 !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path2}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path2.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value2;
  if (typeof themeMapping === "function") {
    value2 = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value2 = themeMapping[propValueFinal] || userValue;
  } else {
    value2 = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value2 = transform(value2, userValue, themeMapping);
  }
  return value2;
}
function style$1(options2) {
  const {
    prop,
    cssProperty = options2.prop,
    themeKey,
    transform
  } = options2;
  const fn = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value2 = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value2 && typeof propValueFinal === "string") {
        value2 = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value2;
      }
      return {
        [cssProperty]: value2
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? {
    [prop]: responsivePropType
  } : {};
  fn.filterProps = [prop];
  return fn;
}
function memoize$1(fn) {
  const cache2 = {};
  return (arg2) => {
    if (cache2[arg2] === void 0) {
      cache2[arg2] = fn(arg2);
    }
    return cache2[arg2];
  };
}
const properties = {
  m: "margin",
  p: "padding"
};
const directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
const getCssProperties = memoize$1((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split("");
  const property = properties[a];
  const direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
});
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  const themeSpacing = getPath(theme, themeKey, true) ?? defaultValue;
  if (typeof themeSpacing === "number" || typeof themeSpacing === "string") {
    return (val) => {
      if (typeof val === "string") {
        return val;
      }
      if (process.env.NODE_ENV !== "production") {
        if (typeof val !== "number") {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${val}.`);
        }
      }
      if (typeof themeSpacing === "string") {
        if (themeSpacing.startsWith("var(") && val === 0) {
          return 0;
        }
        if (themeSpacing.startsWith("var(") && val === 1) {
          return themeSpacing;
        }
        return `calc(${val} * ${themeSpacing})`;
      }
      return themeSpacing * val;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (val) => {
      if (typeof val === "string") {
        return val;
      }
      const abs = Math.abs(val);
      if (process.env.NODE_ENV !== "production") {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join("\n"));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join("\n"));
        }
      }
      const transformed = themeSpacing[abs];
      if (val >= 0) {
        return transformed;
      }
      if (typeof transformed === "number") {
        return -transformed;
      }
      if (typeof transformed === "string" && transformed.startsWith("var(")) {
        return `calc(-1 * ${transformed})`;
      }
      return `-${transformed}`;
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, "It should be a number, an array or a function."].join("\n"));
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  return transformer(propValue);
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  if (!keys.includes(prop)) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
function margin(props) {
  return style(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
function compose(...styles) {
  const handlers = styles.reduce((acc, style2) => {
    style2.filterProps.forEach((prop) => {
      acc[prop] = style2;
    });
    return acc;
  }, {});
  const fn = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? styles.reduce((acc, style2) => Object.assign(acc, style2.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style2) => acc.concat(style2.filterProps), []);
  return fn;
}
function borderTransform(value2) {
  if (typeof value2 !== "number") {
    return value2;
  }
  return `${value2}px solid`;
}
function createBorderStyle(prop, transform) {
  return style$1({
    prop,
    themeKey: "borders",
    transform
  });
}
const border = createBorderStyle("border", borderTransform);
const borderTop = createBorderStyle("borderTop", borderTransform);
const borderRight = createBorderStyle("borderRight", borderTransform);
const borderBottom = createBorderStyle("borderBottom", borderTransform);
const borderLeft = createBorderStyle("borderLeft", borderTransform);
const borderColor = createBorderStyle("borderColor");
const borderTopColor = createBorderStyle("borderTopColor");
const borderRightColor = createBorderStyle("borderRightColor");
const borderBottomColor = createBorderStyle("borderBottomColor");
const borderLeftColor = createBorderStyle("borderLeftColor");
const outline = createBorderStyle("outline", borderTransform);
const outlineColor = createBorderStyle("outlineColor");
const borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4, "borderRadius");
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "gap");
    const styleFromPropValue = (propValue) => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "columnGap");
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "rowGap");
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
});
const gridRow = style$1({
  prop: "gridRow"
});
const gridAutoFlow = style$1({
  prop: "gridAutoFlow"
});
const gridAutoColumns = style$1({
  prop: "gridAutoColumns"
});
const gridAutoRows = style$1({
  prop: "gridAutoRows"
});
const gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
});
const gridTemplateRows = style$1({
  prop: "gridTemplateRows"
});
const gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
});
const gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(value2, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value2;
}
const color = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
const bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
const backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);
function sizingTransform(value2) {
  return value2 <= 1 && value2 !== 0 ? `${value2 * 100}%` : value2;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
});
const maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      const breakpoint = props.theme?.breakpoints?.values?.[propValue] || values$1[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (props.theme?.breakpoints?.unit !== "px") {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
});
const height = style$1({
  prop: "height",
  transform: sizingTransform
});
const maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
});
const minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: (value2) => ({
      "@media print": {
        display: value2
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every((object) => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg2) {
  return typeof maybeFn === "function" ? maybeFn(arg2) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options2 = config[prop];
    if (!options2) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style: style2
    } = options2;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style2) {
      return style2(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value2 = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value2 && typeof propValueFinal === "string") {
        value2 = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value2;
      }
      return {
        [cssProperty]: value2
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    const {
      sx,
      theme = {},
      nested
    } = props || {};
    if (!sx) {
      return null;
    }
    const config = theme.unstable_sxConfig ?? defaultSxConfig;
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css2 = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value2 = callIfFn(sxObject[styleKey], theme);
        if (value2 !== null && value2 !== void 0) {
          if (typeof value2 === "object") {
            if (config[styleKey]) {
              css2 = merge(css2, getThemeValue(styleKey, value2, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value2, (x) => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value2)) {
                css2[styleKey] = styleFunctionSx2({
                  sx: value2,
                  theme,
                  nested: true
                });
              } else {
                css2 = merge(css2, breakpointsValues);
              }
            }
          } else {
            css2 = merge(css2, getThemeValue(styleKey, value2, theme, config));
          }
        }
      });
      if (!nested && theme.modularCssLayers) {
        return {
          "@layer sx": sortContainerQueries(theme, removeUnusedBreakpoints(breakpointsKeys, css2))
        };
      }
      return sortContainerQueries(theme, removeUnusedBreakpoints(breakpointsKeys, css2));
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(fn) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg2) {
    if (cache2[arg2] === void 0) cache2[arg2] = fn(arg2);
    return cache2[arg2];
  };
}
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value2) {
  return value2 != null && typeof value2 !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value2) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value2 === "string") {
        return value2.replace(animationRegex, function(match, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value2 === "number" && value2 !== 0) {
    return value2 + "px";
  }
  return value2;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes2 = interpolation;
      if (keyframes2.anim === 1) {
        cursor = {
          name: keyframes2.name,
          styles: keyframes2.styles,
          next: cursor
        };
        return keyframes2.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next = serializedStyles.next;
        if (next !== void 0) {
          while (next !== void 0) {
            cursor = {
              name: next.name,
              styles: next.styles,
              next: cursor
            };
            next = next.next;
          }
        }
        var styles = serializedStyles.styles + ";";
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
  }
  var asString = interpolation;
  {
    return asString;
  }
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value2 = obj[key];
      if (typeof value2 !== "object") {
        var asString = value2;
        if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (Array.isArray(value2) && typeof value2[0] === "string" && registered == null) {
          for (var _i = 0; _i < value2.length; _i++) {
            if (isProcessableValue(value2[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value2[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value2);
          switch (key) {
            case "animation":
            case "animationName": {
              string += processStyleName(key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles += asTemplateStringsArr[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match;
  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + match[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name,
    styles,
    next: cursor
  };
}
/**
 * @mui/styled-engine v7.3.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$1(tag, options2) {
  const stylesFactory = emStyled(tag, options2);
  if (process.env.NODE_ENV !== "production") {
    return (...styles) => {
      const component = typeof tag === "string" ? `"${tag}"` : "component";
      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join("\n"));
      } else if (styles.some((style2) => style2 === void 0)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles);
    };
  }
  return stylesFactory;
}
function internal_mutateStyles(tag, processor) {
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
}
const wrapper = [];
function internal_serializeStyles(styles) {
  wrapper[0] = styles;
  return serializeStyles(wrapper);
}
const sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return {
      ...acc,
      [obj.key]: obj.val
    };
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: values2 = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit = "px",
    step = 5,
    ...other
  } = breakpoints;
  const sortedValues = sortBreakpointsValues(values2);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value2 = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value2}${unit})`;
  }
  function down(key) {
    const value2 = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value2 - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values2[start] === "number" ? values2[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys[endIndex]] === "number" ? values2[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit,
    ...other
  };
}
const shape = {
  borderRadius: 4
};
function createSpacing(spacingInput = 8, transform = createUnarySpacing({
  spacing: spacingInput
})) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== "production") {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing.mui = true;
  return spacing;
}
function applyStyles(key, styles) {
  const theme = this;
  if (theme.vars) {
    if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== "function") {
      return {};
    }
    let selector = theme.getColorSchemeSelector(key);
    if (selector === "&") {
      return styles;
    }
    if (selector.includes("data-") || selector.includes(".")) {
      selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
    }
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}
function createTheme$1(options2 = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {},
    ...other
  } = options2;
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...paletteInput
    },
    spacing,
    shape: {
      ...shape,
      ...shapeInput
    }
  }, other);
  muiTheme = cssContainerQueries(muiTheme);
  muiTheme.applyStyles = applyStyles;
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = {
    ...defaultSxConfig,
    ...other?.unstable_sxConfig
  };
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
function getFunctionComponentName(Component2, fallback = "") {
  return Component2.displayName || Component2.name || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component2) {
  if (Component2 == null) {
    return void 0;
  }
  if (typeof Component2 === "string") {
    return Component2;
  }
  if (typeof Component2 === "function") {
    return getFunctionComponentName(Component2, "Component");
  }
  if (typeof Component2 === "object") {
    switch (Component2.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component2, Component2.render, "ForwardRef");
      case reactIsExports.Memo:
        return getWrappedName(Component2, Component2.type, "memo");
      default:
        return void 0;
    }
  }
  return void 0;
}
function preprocessStyles(input) {
  const {
    variants,
    ...style2
  } = input;
  const result = {
    variants,
    style: internal_serializeStyles(style2),
    isProcessed: true
  };
  if (result.style === style2) {
    return result;
  }
  if (variants) {
    variants.forEach((variant) => {
      if (typeof variant.style !== "function") {
        variant.style = internal_serializeStyles(variant.style);
      }
    });
  }
  return result;
}
const systemDefaultTheme = createTheme$1();
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
function shallowLayer(serialized, layerName) {
  if (layerName && serialized && typeof serialized === "object" && serialized.styles && !serialized.styles.startsWith("@layer")) {
    serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
  }
  return serialized;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (_props, styles) => styles[slot];
}
function attachTheme(props, themeId, defaultTheme2) {
  props.theme = isObjectEmpty(props.theme) ? defaultTheme2 : props.theme[themeId] || props.theme;
}
function processStyle(props, style2, layerName) {
  const resolvedStyle = typeof style2 === "function" ? style2(props) : style2;
  if (Array.isArray(resolvedStyle)) {
    return resolvedStyle.flatMap((subStyle) => processStyle(props, subStyle, layerName));
  }
  if (Array.isArray(resolvedStyle?.variants)) {
    let rootStyle;
    if (resolvedStyle.isProcessed) {
      rootStyle = layerName ? shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
    } else {
      const {
        variants,
        ...otherStyles
      } = resolvedStyle;
      rootStyle = layerName ? shallowLayer(internal_serializeStyles(otherStyles), layerName) : otherStyles;
    }
    return processStyleVariants(props, resolvedStyle.variants, [rootStyle], layerName);
  }
  if (resolvedStyle?.isProcessed) {
    return layerName ? shallowLayer(internal_serializeStyles(resolvedStyle.style), layerName) : resolvedStyle.style;
  }
  return layerName ? shallowLayer(internal_serializeStyles(resolvedStyle), layerName) : resolvedStyle;
}
function processStyleVariants(props, variants, results = [], layerName = void 0) {
  let mergedState;
  variantLoop: for (let i = 0; i < variants.length; i += 1) {
    const variant = variants[i];
    if (typeof variant.props === "function") {
      mergedState ?? (mergedState = {
        ...props,
        ...props.ownerState,
        ownerState: props.ownerState
      });
      if (!variant.props(mergedState)) {
        continue;
      }
    } else {
      for (const key in variant.props) {
        if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) {
          continue variantLoop;
        }
      }
    }
    if (typeof variant.style === "function") {
      mergedState ?? (mergedState = {
        ...props,
        ...props.ownerState,
        ownerState: props.ownerState
      });
      results.push(layerName ? shallowLayer(internal_serializeStyles(variant.style(mergedState)), layerName) : variant.style(mergedState));
    } else {
      results.push(layerName ? shallowLayer(internal_serializeStyles(variant.style), layerName) : variant.style);
    }
  }
  return results;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme: defaultTheme2 = systemDefaultTheme,
    rootShouldForwardProp: rootShouldForwardProp2 = shouldForwardProp,
    slotShouldForwardProp: slotShouldForwardProp2 = shouldForwardProp
  } = input;
  function styleAttachTheme(props) {
    attachTheme(props, themeId, defaultTheme2);
  }
  const styled2 = (tag, inputOptions = {}) => {
    internal_mutateStyles(tag, (styles) => styles.filter((style2) => style2 !== styleFunctionSx));
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: overridesResolver2 = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)),
      ...options2
    } = inputOptions;
    const layerName = componentName && componentName.startsWith("Mui") || !!componentSlot ? "components" : "custom";
    const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false
    );
    const skipSx = inputSkipSx || false;
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === "Root" || componentSlot === "root") {
      shouldForwardPropOption = rootShouldForwardProp2;
    } else if (componentSlot) {
      shouldForwardPropOption = slotShouldForwardProp2;
    } else if (isStringTag(tag)) {
      shouldForwardPropOption = void 0;
    }
    const defaultStyledResolver = styled$1(tag, {
      shouldForwardProp: shouldForwardPropOption,
      label: generateStyledLabel(componentName, componentSlot),
      ...options2
    });
    const transformStyle = (style2) => {
      if (style2.__emotion_real === style2) {
        return style2;
      }
      if (typeof style2 === "function") {
        return function styleFunctionProcessor(props) {
          return processStyle(props, style2, props.theme.modularCssLayers ? layerName : void 0);
        };
      }
      if (isPlainObject(style2)) {
        const serialized = preprocessStyles(style2);
        return function styleObjectProcessor(props) {
          if (!serialized.variants) {
            return props.theme.modularCssLayers ? shallowLayer(serialized.style, layerName) : serialized.style;
          }
          return processStyle(props, serialized, props.theme.modularCssLayers ? layerName : void 0);
        };
      }
      return style2;
    };
    const muiStyledResolver = (...expressionsInput) => {
      const expressionsHead = [];
      const expressionsBody = expressionsInput.map(transformStyle);
      const expressionsTail = [];
      expressionsHead.push(styleAttachTheme);
      if (componentName && overridesResolver2) {
        expressionsTail.push(function styleThemeOverrides(props) {
          const theme = props.theme;
          const styleOverrides = theme.components?.[componentName]?.styleOverrides;
          if (!styleOverrides) {
            return null;
          }
          const resolvedStyleOverrides = {};
          for (const slotKey in styleOverrides) {
            resolvedStyleOverrides[slotKey] = processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? "theme" : void 0);
          }
          return overridesResolver2(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsTail.push(function styleThemeVariants(props) {
          const theme = props.theme;
          const themeVariants = theme?.components?.[componentName]?.variants;
          if (!themeVariants) {
            return null;
          }
          return processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? "theme" : void 0);
        });
      }
      if (!skipSx) {
        expressionsTail.push(styleFunctionSx);
      }
      if (Array.isArray(expressionsBody[0])) {
        const inputStrings = expressionsBody.shift();
        const placeholdersHead = new Array(expressionsHead.length).fill("");
        const placeholdersTail = new Array(expressionsTail.length).fill("");
        let outputStrings;
        {
          outputStrings = [...placeholdersHead, ...inputStrings, ...placeholdersTail];
          outputStrings.raw = [...placeholdersHead, ...inputStrings.raw, ...placeholdersTail];
        }
        expressionsHead.unshift(outputStrings);
      }
      const expressions = [...expressionsHead, ...expressionsBody, ...expressionsTail];
      const Component2 = defaultStyledResolver(...expressions);
      if (tag.muiName) {
        Component2.muiName = tag.muiName;
      }
      if (process.env.NODE_ENV !== "production") {
        Component2.displayName = generateDisplayName(componentName, componentSlot, tag);
      }
      return Component2;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
  return styled2;
}
function generateDisplayName(componentName, componentSlot, tag) {
  if (componentName) {
    return `${componentName}${capitalize(componentSlot || "")}`;
  }
  return `Styled(${getDisplayName(tag)})`;
}
function generateStyledLabel(componentName, componentSlot) {
  let label2;
  if (process.env.NODE_ENV !== "production") {
    if (componentName) {
      label2 = `${componentName}-${lowercaseFirstLetter(componentSlot || "Root")}`;
    }
  }
  return label2;
}
function isObjectEmpty(object) {
  for (const _2 in object) {
    return false;
  }
  return true;
}
function isStringTag(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(string) {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
}
function resolveProps(defaultProps2, props, mergeClassNameAndStyle = false) {
  const output = {
    ...props
  };
  for (const key in defaultProps2) {
    if (Object.prototype.hasOwnProperty.call(defaultProps2, key)) {
      const propName = key;
      if (propName === "components" || propName === "slots") {
        output[propName] = {
          ...defaultProps2[propName],
          ...output[propName]
        };
      } else if (propName === "componentsProps" || propName === "slotProps") {
        const defaultSlotProps = defaultProps2[propName];
        const slotProps = props[propName];
        if (!slotProps) {
          output[propName] = defaultSlotProps || {};
        } else if (!defaultSlotProps) {
          output[propName] = slotProps;
        } else {
          output[propName] = {
            ...slotProps
          };
          for (const slotKey in defaultSlotProps) {
            if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
              const slotPropName = slotKey;
              output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
            }
          }
        }
      } else if (propName === "className" && mergeClassNameAndStyle && props.className) {
        output.className = clsx(defaultProps2?.className, props?.className);
      } else if (propName === "style" && mergeClassNameAndStyle && props.style) {
        output.style = {
          ...defaultProps2?.style,
          ...props?.style
        };
      } else if (output[propName] === void 0) {
        output[propName] = defaultProps2[propName];
      }
    }
  }
  return output;
}
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}
function clampWrapper(value2, min = 0, max = 1) {
  if (process.env.NODE_ENV !== "production") {
    if (value2 < min || value2 > max) {
      console.error(`MUI: The value provided ${value2} is out of range [${min}, ${max}].`);
    }
  }
  return clamp(value2, min, max);
}
function hexToRgb(color2) {
  color2 = color2.slice(1);
  const re = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
  let colors2 = color2.match(re);
  if (colors2 && colors2[0].length === 1) {
    colors2 = colors2.map((n) => n + n);
  }
  if (process.env.NODE_ENV !== "production") {
    if (color2.length !== color2.trim().length) {
      console.error(`MUI: The color: "${color2}" is invalid. Make sure the color input doesn't contain leading/trailing space.`);
    }
  }
  return colors2 ? `rgb${colors2.length === 4 ? "a" : ""}(${colors2.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
  }).join(", ")})` : "";
}
function decomposeColor(color2) {
  if (color2.type) {
    return color2;
  }
  if (color2.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color2));
  }
  const marker = color2.indexOf("(");
  const type = color2.substring(0, marker);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(type)) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color2}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, color2));
  }
  let values2 = color2.substring(marker + 1, color2.length - 1);
  let colorSpace;
  if (type === "color") {
    values2 = values2.split(" ");
    colorSpace = values2.shift();
    if (values2.length === 4 && values2[3].charAt(0) === "/") {
      values2[3] = values2[3].slice(1);
    }
    if (!["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(colorSpace)) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, colorSpace));
    }
  } else {
    values2 = values2.split(",");
  }
  values2 = values2.map((value2) => parseFloat(value2));
  return {
    type,
    values: values2,
    colorSpace
  };
}
const colorChannel = (color2) => {
  const decomposedColor = decomposeColor(color2);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.includes("hsl") && idx !== 0 ? `${val}%` : val).join(" ");
};
const private_safeColorChannel = (color2, warning) => {
  try {
    return colorChannel(color2);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== "production") {
      console.warn(warning);
    }
    return color2;
  }
};
function recomposeColor(color2) {
  const {
    type,
    colorSpace
  } = color2;
  let {
    values: values2
  } = color2;
  if (type.includes("rgb")) {
    values2 = values2.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.includes("hsl")) {
    values2[1] = `${values2[1]}%`;
    values2[2] = `${values2[2]}%`;
  }
  if (type.includes("color")) {
    values2 = `${colorSpace} ${values2.join(" ")}`;
  } else {
    values2 = `${values2.join(", ")}`;
  }
  return `${type}(${values2})`;
}
function hslToRgb(color2) {
  color2 = decomposeColor(color2);
  const {
    values: values2
  } = color2;
  const h = values2[0];
  const s = values2[1] / 100;
  const l = values2[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = "rgb";
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color2.type === "hsla") {
    type += "a";
    rgb.push(values2[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
function getLuminance(color2) {
  color2 = decomposeColor(color2);
  let rgb = color2.type === "hsl" || color2.type === "hsla" ? decomposeColor(hslToRgb(color2)).values : color2.values;
  rgb = rgb.map((val) => {
    if (color2.type !== "color") {
      val /= 255;
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color2, value2) {
  color2 = decomposeColor(color2);
  value2 = clampWrapper(value2);
  if (color2.type === "rgb" || color2.type === "hsl") {
    color2.type += "a";
  }
  if (color2.type === "color") {
    color2.values[3] = `/${value2}`;
  } else {
    color2.values[3] = value2;
  }
  return recomposeColor(color2);
}
function private_safeAlpha(color2, value2, warning) {
  try {
    return alpha(color2, value2);
  } catch (error) {
    return color2;
  }
}
function darken(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.includes("hsl")) {
    color2.values[2] *= 1 - coefficient;
  } else if (color2.type.includes("rgb") || color2.type.includes("color")) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeDarken(color2, coefficient, warning) {
  try {
    return darken(color2, coefficient);
  } catch (error) {
    return color2;
  }
}
function lighten(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.includes("hsl")) {
    color2.values[2] += (100 - color2.values[2]) * coefficient;
  } else if (color2.type.includes("rgb")) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (255 - color2.values[i]) * coefficient;
    }
  } else if (color2.type.includes("color")) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (1 - color2.values[i]) * coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeLighten(color2, coefficient, warning) {
  try {
    return lighten(color2, coefficient);
  } catch (error) {
    return color2;
  }
}
function emphasize(color2, coefficient = 0.15) {
  return getLuminance(color2) > 0.5 ? darken(color2, coefficient) : lighten(color2, coefficient);
}
function private_safeEmphasize(color2, coefficient, warning) {
  try {
    return emphasize(color2, coefficient);
  } catch (error) {
    return color2;
  }
}
const PropsContext = /* @__PURE__ */ React.createContext(void 0);
process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
} : void 0;
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  const config = theme.components[name];
  if (config.defaultProps) {
    return resolveProps(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
  }
  if (!config.styleOverrides && !config.variants) {
    return resolveProps(config, props, theme.components.mergeClassNameAndStyle);
  }
  return props;
}
function useDefaultProps$1({
  props,
  name
}) {
  const ctx = React.useContext(PropsContext);
  return getThemeProps({
    props,
    name,
    theme: {
      components: ctx
    }
  });
}
const arg = {
  theme: void 0
};
function unstable_memoTheme(styleFn) {
  let lastValue;
  let lastTheme;
  return function styleMemoized(props) {
    let value2 = lastValue;
    if (value2 === void 0 || props.theme !== lastTheme) {
      arg.theme = props.theme;
      value2 = preprocessStyles(styleFn(arg));
      lastValue = value2;
      lastTheme = props.theme;
    }
    return value2;
  };
}
function createGetCssVar$1(prefix = "") {
  function appendVar(...vars) {
    if (!vars.length) {
      return "";
    }
    const value2 = vars[0];
    if (typeof value2 === "string" && !value2.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) {
      return `, var(--${prefix ? `${prefix}-` : ""}${value2}${appendVar(...vars.slice(1))})`;
    }
    return `, ${value2}`;
  }
  const getCssVar = (field, ...fallbacks) => {
    return `var(--${prefix ? `${prefix}-` : ""}${field}${appendVar(...fallbacks)})`;
  };
  return getCssVar;
}
const assignNestedKeys = (obj, keys, value2, arrayKeys = []) => {
  let temp = obj;
  keys.forEach((k, index) => {
    if (index === keys.length - 1) {
      if (Array.isArray(temp)) {
        temp[Number(k)] = value2;
      } else if (temp && typeof temp === "object") {
        temp[k] = value2;
      }
    } else if (temp && typeof temp === "object") {
      if (!temp[k]) {
        temp[k] = arrayKeys.includes(k) ? [] : {};
      }
      temp = temp[k];
    }
  });
};
const walkObjectDeep = (obj, callback, shouldSkipPaths) => {
  function recurse(object, parentKeys = [], arrayKeys = []) {
    Object.entries(object).forEach(([key, value2]) => {
      if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([...parentKeys, key])) {
        if (value2 !== void 0 && value2 !== null) {
          if (typeof value2 === "object" && Object.keys(value2).length > 0) {
            recurse(value2, [...parentKeys, key], Array.isArray(value2) ? [...arrayKeys, key] : arrayKeys);
          } else {
            callback([...parentKeys, key], value2, arrayKeys);
          }
        }
      }
    });
  }
  recurse(obj);
};
const getCssValue = (keys, value2) => {
  if (typeof value2 === "number") {
    if (["lineHeight", "fontWeight", "opacity", "zIndex"].some((prop) => keys.includes(prop))) {
      return value2;
    }
    const lastKey = keys[keys.length - 1];
    if (lastKey.toLowerCase().includes("opacity")) {
      return value2;
    }
    return `${value2}px`;
  }
  return value2;
};
function cssVarsParser(theme, options2) {
  const {
    prefix,
    shouldSkipGeneratingVar: shouldSkipGeneratingVar2
  } = options2 || {};
  const css2 = {};
  const vars = {};
  const varsWithDefaults = {};
  walkObjectDeep(
    theme,
    (keys, value2, arrayKeys) => {
      if (typeof value2 === "string" || typeof value2 === "number") {
        if (!shouldSkipGeneratingVar2 || !shouldSkipGeneratingVar2(keys, value2)) {
          const cssVar = `--${prefix ? `${prefix}-` : ""}${keys.join("-")}`;
          const resolvedValue = getCssValue(keys, value2);
          Object.assign(css2, {
            [cssVar]: resolvedValue
          });
          assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
          assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
        }
      }
    },
    (keys) => keys[0] === "vars"
    // skip 'vars/*' paths
  );
  return {
    css: css2,
    vars,
    varsWithDefaults
  };
}
function prepareCssVars(theme, parserConfig = {}) {
  const {
    getSelector = defaultGetSelector2,
    disableCssColorScheme,
    colorSchemeSelector: selector,
    enableContrastVars
  } = parserConfig;
  const {
    colorSchemes = {},
    components: components2,
    defaultColorScheme = "light",
    ...otherTheme
  } = theme;
  const {
    vars: rootVars,
    css: rootCss,
    varsWithDefaults: rootVarsWithDefaults
  } = cssVarsParser(otherTheme, parserConfig);
  let themeVars = rootVarsWithDefaults;
  const colorSchemesMap = {};
  const {
    [defaultColorScheme]: defaultScheme,
    ...otherColorSchemes
  } = colorSchemes;
  Object.entries(otherColorSchemes || {}).forEach(([key, scheme]) => {
    const {
      vars,
      css: css2,
      varsWithDefaults
    } = cssVarsParser(scheme, parserConfig);
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[key] = {
      css: css2,
      vars
    };
  });
  if (defaultScheme) {
    const {
      css: css2,
      vars,
      varsWithDefaults
    } = cssVarsParser(defaultScheme, parserConfig);
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[defaultColorScheme] = {
      css: css2,
      vars
    };
  }
  function defaultGetSelector2(colorScheme, cssObject) {
    let rule = selector;
    if (selector === "class") {
      rule = ".%s";
    }
    if (selector === "data") {
      rule = "[data-%s]";
    }
    if (selector?.startsWith("data-") && !selector.includes("%s")) {
      rule = `[${selector}="%s"]`;
    }
    if (colorScheme) {
      if (rule === "media") {
        if (theme.defaultColorScheme === colorScheme) {
          return ":root";
        }
        const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
        return {
          [`@media (prefers-color-scheme: ${mode})`]: {
            ":root": cssObject
          }
        };
      }
      if (rule) {
        if (theme.defaultColorScheme === colorScheme) {
          return `:root, ${rule.replace("%s", String(colorScheme))}`;
        }
        return rule.replace("%s", String(colorScheme));
      }
    }
    return ":root";
  }
  const generateThemeVars = () => {
    let vars = {
      ...rootVars
    };
    Object.entries(colorSchemesMap).forEach(([, {
      vars: schemeVars
    }]) => {
      vars = deepmerge(vars, schemeVars);
    });
    return vars;
  };
  const generateStyleSheets = () => {
    const stylesheets = [];
    const colorScheme = theme.defaultColorScheme || "light";
    function insertStyleSheet(key, css2) {
      if (Object.keys(css2).length) {
        stylesheets.push(typeof key === "string" ? {
          [key]: {
            ...css2
          }
        } : key);
      }
    }
    insertStyleSheet(getSelector(void 0, {
      ...rootCss
    }), rootCss);
    const {
      [colorScheme]: defaultSchemeVal,
      ...other
    } = colorSchemesMap;
    if (defaultSchemeVal) {
      const {
        css: css2
      } = defaultSchemeVal;
      const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
      const finalCss = !disableCssColorScheme && cssColorSheme ? {
        colorScheme: cssColorSheme,
        ...css2
      } : {
        ...css2
      };
      insertStyleSheet(getSelector(colorScheme, {
        ...finalCss
      }), finalCss);
    }
    Object.entries(other).forEach(([key, {
      css: css2
    }]) => {
      const cssColorSheme = colorSchemes[key]?.palette?.mode;
      const finalCss = !disableCssColorScheme && cssColorSheme ? {
        colorScheme: cssColorSheme,
        ...css2
      } : {
        ...css2
      };
      insertStyleSheet(getSelector(key, {
        ...finalCss
      }), finalCss);
    });
    if (enableContrastVars) {
      stylesheets.push({
        ":root": {
          // use double underscore to indicate that these are private variables
          "--__l-threshold": "0.7",
          "--__l": "clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)",
          "--__a": "clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)"
          // 0.87 is the default alpha value for black text.
        }
      });
    }
    return stylesheets;
  };
  return {
    vars: themeVars,
    generateThemeVars,
    generateStyleSheets
  };
}
function createGetColorSchemeSelector(selector) {
  return function getColorSchemeSelector(colorScheme) {
    if (selector === "media") {
      if (process.env.NODE_ENV !== "production") {
        if (colorScheme !== "light" && colorScheme !== "dark") {
          console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${colorScheme}'.`);
        }
      }
      return `@media (prefers-color-scheme: ${colorScheme})`;
    }
    if (selector) {
      if (selector.startsWith("data-") && !selector.includes("%s")) {
        return `[${selector}="${colorScheme}"] &`;
      }
      if (selector === "class") {
        return `.${colorScheme} &`;
      }
      if (selector === "data") {
        return `[data-${colorScheme}] &`;
      }
      return `${selector.replace("%s", colorScheme)} &`;
    }
    return "&";
  };
}
const common = {
  black: "#000",
  white: "#fff"
};
const grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
const purple = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
};
const red = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
};
const orange = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
};
const blue = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
};
const lightBlue = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
};
const green = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function getLight() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: common.white,
      default: common.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const light = getLight();
function getDark() {
  return {
    text: {
      primary: common.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: common.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const dark = getDark();
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = "light") {
  if (mode === "dark") {
    return {
      main: blue[200],
      light: blue[50],
      dark: blue[400]
    };
  }
  return {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}
function getDefaultSecondary(mode = "light") {
  if (mode === "dark") {
    return {
      main: purple[200],
      light: purple[50],
      dark: purple[400]
    };
  }
  return {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}
function getDefaultError(mode = "light") {
  if (mode === "dark") {
    return {
      main: red[500],
      light: red[300],
      dark: red[700]
    };
  }
  return {
    main: red[700],
    light: red[400],
    dark: red[800]
  };
}
function getDefaultInfo(mode = "light") {
  if (mode === "dark") {
    return {
      main: lightBlue[400],
      light: lightBlue[300],
      dark: lightBlue[700]
    };
  }
  return {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(mode = "light") {
  if (mode === "dark") {
    return {
      main: green[400],
      light: green[300],
      dark: green[700]
    };
  }
  return {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}
function getDefaultWarning(mode = "light") {
  if (mode === "dark") {
    return {
      main: orange[400],
      light: orange[300],
      dark: orange[700]
    };
  }
  return {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange[500],
    dark: orange[900]
  };
}
function createPalette(palette) {
  const {
    mode = "light",
    contrastThreshold = 3,
    tonalOffset = 0.2,
    ...other
  } = palette;
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);
  function getContrastText(background) {
    const contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const contrast = getContrastRatio(background, contrastText);
      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join("\n"));
      }
    }
    return contrastText;
  }
  const augmentColor = ({
    color: color2,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color2 = {
      ...color2
    };
    if (!color2.main && color2[mainShade]) {
      color2.main = color2[mainShade];
    }
    if (!color2.hasOwnProperty("main")) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : formatMuiErrorMessage$1(11, name ? ` (${name})` : "", mainShade));
    }
    if (typeof color2.main !== "string") {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color2.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, name ? ` (${name})` : "", JSON.stringify(color2.main)));
    }
    addLightOrDark(color2, "light", lightShade, tonalOffset);
    addLightOrDark(color2, "dark", darkShade, tonalOffset);
    if (!color2.contrastText) {
      color2.contrastText = getContrastText(color2.main);
    }
    return color2;
  };
  let modeHydrated;
  if (mode === "light") {
    modeHydrated = getLight();
  } else if (mode === "dark") {
    modeHydrated = getDark();
  }
  if (process.env.NODE_ENV !== "production") {
    if (!modeHydrated) {
      console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    }
  }
  const paletteOutput = deepmerge$1({
    // A collection of common colors.
    common: {
      ...common
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset,
    // The light and dark mode object.
    ...modeHydrated
  }, other);
  return paletteOutput;
}
function prepareTypographyVars(typography) {
  const vars = {};
  const entries = Object.entries(typography);
  entries.forEach((entry) => {
    const [key, value2] = entry;
    if (typeof value2 === "object") {
      vars[key] = `${value2.fontStyle ? `${value2.fontStyle} ` : ""}${value2.fontVariant ? `${value2.fontVariant} ` : ""}${value2.fontWeight ? `${value2.fontWeight} ` : ""}${value2.fontStretch ? `${value2.fontStretch} ` : ""}${value2.fontSize || ""}${value2.lineHeight ? `/${value2.lineHeight} ` : ""}${value2.fontFamily || ""}`;
    }
  });
  return vars;
}
function createMixins(breakpoints, mixins) {
  return {
    toolbar: {
      minHeight: 56,
      [breakpoints.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [breakpoints.up("sm")]: {
        minHeight: 64
      }
    },
    ...mixins
  };
}
function round(value2) {
  return Math.round(value2 * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  const {
    fontFamily = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2,
    ...other
  } = typeof typography === "function" ? typography(palette) : typography;
  if (process.env.NODE_ENV !== "production") {
    if (typeof fontSize !== "number") {
      console.error("MUI: `fontSize` is required to be a number.");
    }
    if (typeof htmlFontSize !== "number") {
      console.error("MUI: `htmlFontSize` is required to be a number.");
    }
  }
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => ({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...fontFamily === defaultFontFamily ? {
      letterSpacing: `${round(letterSpacing / size)}em`
    } : {},
    ...casing,
    ...allVariants
  });
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge$1({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold,
    ...variants
  }, other, {
    clone: false
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height2) {
  if (!height2) {
    return 0;
  }
  const constant = height2 / 36;
  return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3e3);
}
function createTransitions(inputTransitions) {
  const mergedEasing = {
    ...easing,
    ...inputTransitions.easing
  };
  const mergedDuration = {
    ...duration,
    ...inputTransitions.duration
  };
  const create = (props = ["all"], options2 = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0,
      ...other
    } = options2;
    if (process.env.NODE_ENV !== "production") {
      const isString = (value2) => typeof value2 === "string";
      const isNumber = (value2) => !Number.isNaN(parseFloat(value2));
      if (!isString(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }
      if (!isString(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (typeof options2 !== "object") {
        console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join("\n"));
      }
      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(",")}].`);
      }
    }
    return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
  };
  return {
    getAutoHeightDuration,
    create,
    ...inputTransitions,
    easing: mergedEasing,
    duration: mergedDuration
  };
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function isSerializable(val) {
  return isPlainObject$1(val) || typeof val === "undefined" || typeof val === "string" || typeof val === "boolean" || typeof val === "number" || Array.isArray(val);
}
function stringifyTheme(baseTheme = {}) {
  const serializableTheme = {
    ...baseTheme
  };
  function serializeTheme(object) {
    const array = Object.entries(object);
    for (let index = 0; index < array.length; index++) {
      const [key, value2] = array[index];
      if (!isSerializable(value2) || key.startsWith("unstable_")) {
        delete object[key];
      } else if (isPlainObject$1(value2)) {
        object[key] = {
          ...value2
        };
        serializeTheme(object[key]);
      }
    }
  }
  serializeTheme(serializableTheme);
  return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function createThemeNoVars(options2 = {}, ...args) {
  const {
    breakpoints: breakpointsInput,
    mixins: mixinsInput = {},
    spacing: spacingInput,
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {},
    shape: shapeInput,
    ...other
  } = options2;
  if (options2.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  options2.generateThemeVars === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : formatMuiErrorMessage$1(20));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$1(options2);
  let muiTheme = deepmerge$1(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: {
      ...zIndex
    }
  });
  muiTheme = deepmerge$1(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  if (process.env.NODE_ENV !== "production") {
    const stateClasses = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"];
    const traverse = (node, component) => {
      let key;
      for (key in node) {
        const child = node[key];
        if (stateClasses.includes(key) && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const stateClass = generateUtilityClass("", key);
            console.error([`MUI: The \`${component}\` component increases the CSS specificity of the \`${key}\` internal state.`, "You can not override it like this: ", JSON.stringify(node, null, 2), "", `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join("\n"));
          }
          node[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach((component) => {
      const styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.startsWith("Mui")) {
        traverse(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = {
    ...defaultSxConfig,
    ...other?.unstable_sxConfig
  };
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  muiTheme.toRuntimeSource = stringifyTheme;
  return muiTheme;
}
function getOverlayAlpha(elevation) {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return Math.round(alphaValue * 10) / 1e3;
}
const defaultDarkOverlays = [...Array(25)].map((_2, index) => {
  if (index === 0) {
    return "none";
  }
  const overlay = getOverlayAlpha(index);
  return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function getOpacity(mode) {
  return {
    inputPlaceholder: mode === "dark" ? 0.5 : 0.42,
    inputUnderline: mode === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: mode === "dark" ? 0.2 : 0.12,
    switchTrack: mode === "dark" ? 0.3 : 0.38
  };
}
function getOverlays(mode) {
  return mode === "dark" ? defaultDarkOverlays : [];
}
function createColorScheme(options2) {
  const {
    palette: paletteInput = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity,
    overlays,
    ...rest
  } = options2;
  const palette = createPalette(paletteInput);
  return {
    palette,
    opacity: {
      ...getOpacity(palette.mode),
      ...opacity
    },
    overlays: overlays || getOverlays(palette.mode),
    ...rest
  };
}
function shouldSkipGeneratingVar(keys) {
  return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
  keys[0] === "palette" && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
const excludeVariablesFromRoot = (cssVarPrefix) => [...[...Array(25)].map((_2, index) => `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}overlays-${index}`), `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkBg`, `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkColor`];
const defaultGetSelector = (theme) => (colorScheme, css2) => {
  const root = theme.rootSelector || ":root";
  const selector = theme.colorSchemeSelector;
  let rule = selector;
  if (selector === "class") {
    rule = ".%s";
  }
  if (selector === "data") {
    rule = "[data-%s]";
  }
  if (selector?.startsWith("data-") && !selector.includes("%s")) {
    rule = `[${selector}="%s"]`;
  }
  if (theme.defaultColorScheme === colorScheme) {
    if (colorScheme === "dark") {
      const excludedVariables = {};
      excludeVariablesFromRoot(theme.cssVarPrefix).forEach((cssVar) => {
        excludedVariables[cssVar] = css2[cssVar];
        delete css2[cssVar];
      });
      if (rule === "media") {
        return {
          [root]: css2,
          [`@media (prefers-color-scheme: dark)`]: {
            [root]: excludedVariables
          }
        };
      }
      if (rule) {
        return {
          [rule.replace("%s", colorScheme)]: excludedVariables,
          [`${root}, ${rule.replace("%s", colorScheme)}`]: css2
        };
      }
      return {
        [root]: {
          ...css2,
          ...excludedVariables
        }
      };
    }
    if (rule && rule !== "media") {
      return `${root}, ${rule.replace("%s", String(colorScheme))}`;
    }
  } else if (colorScheme) {
    if (rule === "media") {
      return {
        [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
          [root]: css2
        }
      };
    }
    if (rule) {
      return rule.replace("%s", String(colorScheme));
    }
  }
  return root;
};
function assignNode(obj, keys) {
  keys.forEach((k) => {
    if (!obj[k]) {
      obj[k] = {};
    }
  });
}
function setColor(obj, key, defaultValue) {
  if (!obj[key] && defaultValue) {
    obj[key] = defaultValue;
  }
}
function toRgb(color2) {
  if (typeof color2 !== "string" || !color2.startsWith("hsl")) {
    return color2;
  }
  return hslToRgb(color2);
}
function setColorChannel(obj, key) {
  if (!(`${key}Channel` in obj)) {
    obj[`${key}Channel`] = private_safeColorChannel(toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
  }
}
function getSpacingVal(spacingInput) {
  if (typeof spacingInput === "number") {
    return `${spacingInput}px`;
  }
  if (typeof spacingInput === "string" || typeof spacingInput === "function" || Array.isArray(spacingInput)) {
    return spacingInput;
  }
  return "8px";
}
const silent = (fn) => {
  try {
    return fn();
  } catch (error) {
  }
  return void 0;
};
const createGetCssVar = (cssVarPrefix = "mui") => createGetCssVar$1(cssVarPrefix);
function attachColorScheme$1(colorSchemes, scheme, restTheme, colorScheme) {
  if (!scheme) {
    return void 0;
  }
  scheme = scheme === true ? {} : scheme;
  const mode = colorScheme === "dark" ? "dark" : "light";
  if (!restTheme) {
    colorSchemes[colorScheme] = createColorScheme({
      ...scheme,
      palette: {
        mode,
        ...scheme?.palette
      }
    });
    return void 0;
  }
  const {
    palette,
    ...muiTheme
  } = createThemeNoVars({
    ...restTheme,
    palette: {
      mode,
      ...scheme?.palette
    }
  });
  colorSchemes[colorScheme] = {
    ...scheme,
    palette,
    opacity: {
      ...getOpacity(mode),
      ...scheme?.opacity
    },
    overlays: scheme?.overlays || getOverlays(mode)
  };
  return muiTheme;
}
function createThemeWithVars(options2 = {}, ...args) {
  const {
    colorSchemes: colorSchemesInput = {
      light: true
    },
    defaultColorScheme: defaultColorSchemeInput,
    disableCssColorScheme = false,
    cssVarPrefix = "mui",
    shouldSkipGeneratingVar: shouldSkipGeneratingVar$1 = shouldSkipGeneratingVar,
    colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? "media" : void 0,
    rootSelector = ":root",
    ...input
  } = options2;
  const firstColorScheme = Object.keys(colorSchemesInput)[0];
  const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== "light" ? "light" : firstColorScheme);
  const getCssVar = createGetCssVar(cssVarPrefix);
  const {
    [defaultColorScheme]: defaultSchemeInput,
    light: builtInLight,
    dark: builtInDark,
    ...customColorSchemes
  } = colorSchemesInput;
  const colorSchemes = {
    ...customColorSchemes
  };
  let defaultScheme = defaultSchemeInput;
  if (defaultColorScheme === "dark" && !("dark" in colorSchemesInput) || defaultColorScheme === "light" && !("light" in colorSchemesInput)) {
    defaultScheme = true;
  }
  if (!defaultScheme) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${defaultColorScheme}\` option is either missing or invalid.` : formatMuiErrorMessage$1(21, defaultColorScheme));
  }
  const muiTheme = attachColorScheme$1(colorSchemes, defaultScheme, input, defaultColorScheme);
  if (builtInLight && !colorSchemes.light) {
    attachColorScheme$1(colorSchemes, builtInLight, void 0, "light");
  }
  if (builtInDark && !colorSchemes.dark) {
    attachColorScheme$1(colorSchemes, builtInDark, void 0, "dark");
  }
  let theme = {
    defaultColorScheme,
    ...muiTheme,
    cssVarPrefix,
    colorSchemeSelector: selector,
    rootSelector,
    getCssVar,
    colorSchemes,
    font: {
      ...prepareTypographyVars(muiTheme.typography),
      ...muiTheme.font
    },
    spacing: getSpacingVal(input.spacing)
  };
  Object.keys(theme.colorSchemes).forEach((key) => {
    const palette = theme.colorSchemes[key].palette;
    const setCssVarColor = (cssVar) => {
      const tokens = cssVar.split("-");
      const color2 = tokens[1];
      const colorToken = tokens[2];
      return getCssVar(cssVar, palette[color2][colorToken]);
    };
    if (palette.mode === "light") {
      setColor(palette.common, "background", "#fff");
      setColor(palette.common, "onBackground", "#000");
    }
    if (palette.mode === "dark") {
      setColor(palette.common, "background", "#000");
      setColor(palette.common, "onBackground", "#fff");
    }
    assignNode(palette, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]);
    if (palette.mode === "light") {
      setColor(palette.Alert, "errorColor", private_safeDarken(palette.error.light, 0.6));
      setColor(palette.Alert, "infoColor", private_safeDarken(palette.info.light, 0.6));
      setColor(palette.Alert, "successColor", private_safeDarken(palette.success.light, 0.6));
      setColor(palette.Alert, "warningColor", private_safeDarken(palette.warning.light, 0.6));
      setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-main"));
      setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-main"));
      setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-main"));
      setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-main"));
      setColor(palette.Alert, "errorFilledColor", silent(() => palette.getContrastText(palette.error.main)));
      setColor(palette.Alert, "infoFilledColor", silent(() => palette.getContrastText(palette.info.main)));
      setColor(palette.Alert, "successFilledColor", silent(() => palette.getContrastText(palette.success.main)));
      setColor(palette.Alert, "warningFilledColor", silent(() => palette.getContrastText(palette.warning.main)));
      setColor(palette.Alert, "errorStandardBg", private_safeLighten(palette.error.light, 0.9));
      setColor(palette.Alert, "infoStandardBg", private_safeLighten(palette.info.light, 0.9));
      setColor(palette.Alert, "successStandardBg", private_safeLighten(palette.success.light, 0.9));
      setColor(palette.Alert, "warningStandardBg", private_safeLighten(palette.warning.light, 0.9));
      setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
      setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
      setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
      setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
      setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-100"));
      setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-400"));
      setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-300"));
      setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-A100"));
      setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-400"));
      setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-700"));
      setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-700"));
      setColor(palette.FilledInput, "bg", "rgba(0, 0, 0, 0.06)");
      setColor(palette.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)");
      setColor(palette.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)");
      setColor(palette.LinearProgress, "primaryBg", private_safeLighten(palette.primary.main, 0.62));
      setColor(palette.LinearProgress, "secondaryBg", private_safeLighten(palette.secondary.main, 0.62));
      setColor(palette.LinearProgress, "errorBg", private_safeLighten(palette.error.main, 0.62));
      setColor(palette.LinearProgress, "infoBg", private_safeLighten(palette.info.main, 0.62));
      setColor(palette.LinearProgress, "successBg", private_safeLighten(palette.success.main, 0.62));
      setColor(palette.LinearProgress, "warningBg", private_safeLighten(palette.warning.main, 0.62));
      setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.11)`);
      setColor(palette.Slider, "primaryTrack", private_safeLighten(palette.primary.main, 0.62));
      setColor(palette.Slider, "secondaryTrack", private_safeLighten(palette.secondary.main, 0.62));
      setColor(palette.Slider, "errorTrack", private_safeLighten(palette.error.main, 0.62));
      setColor(palette.Slider, "infoTrack", private_safeLighten(palette.info.main, 0.62));
      setColor(palette.Slider, "successTrack", private_safeLighten(palette.success.main, 0.62));
      setColor(palette.Slider, "warningTrack", private_safeLighten(palette.warning.main, 0.62));
      const snackbarContentBackground = private_safeEmphasize(palette.background.default, 0.8);
      setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
      setColor(palette.SnackbarContent, "color", silent(() => palette.getContrastText(snackbarContentBackground)));
      setColor(palette.SpeedDialAction, "fabHoverBg", private_safeEmphasize(palette.background.paper, 0.15));
      setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-400"));
      setColor(palette.StepContent, "border", setCssVarColor("palette-grey-400"));
      setColor(palette.Switch, "defaultColor", setCssVarColor("palette-common-white"));
      setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-100"));
      setColor(palette.Switch, "primaryDisabledColor", private_safeLighten(palette.primary.main, 0.62));
      setColor(palette.Switch, "secondaryDisabledColor", private_safeLighten(palette.secondary.main, 0.62));
      setColor(palette.Switch, "errorDisabledColor", private_safeLighten(palette.error.main, 0.62));
      setColor(palette.Switch, "infoDisabledColor", private_safeLighten(palette.info.main, 0.62));
      setColor(palette.Switch, "successDisabledColor", private_safeLighten(palette.success.main, 0.62));
      setColor(palette.Switch, "warningDisabledColor", private_safeLighten(palette.warning.main, 0.62));
      setColor(palette.TableCell, "border", private_safeLighten(private_safeAlpha(palette.divider, 1), 0.88));
      setColor(palette.Tooltip, "bg", private_safeAlpha(palette.grey[700], 0.92));
    }
    if (palette.mode === "dark") {
      setColor(palette.Alert, "errorColor", private_safeLighten(palette.error.light, 0.6));
      setColor(palette.Alert, "infoColor", private_safeLighten(palette.info.light, 0.6));
      setColor(palette.Alert, "successColor", private_safeLighten(palette.success.light, 0.6));
      setColor(palette.Alert, "warningColor", private_safeLighten(palette.warning.light, 0.6));
      setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-dark"));
      setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-dark"));
      setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-dark"));
      setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-dark"));
      setColor(palette.Alert, "errorFilledColor", silent(() => palette.getContrastText(palette.error.dark)));
      setColor(palette.Alert, "infoFilledColor", silent(() => palette.getContrastText(palette.info.dark)));
      setColor(palette.Alert, "successFilledColor", silent(() => palette.getContrastText(palette.success.dark)));
      setColor(palette.Alert, "warningFilledColor", silent(() => palette.getContrastText(palette.warning.dark)));
      setColor(palette.Alert, "errorStandardBg", private_safeDarken(palette.error.light, 0.9));
      setColor(palette.Alert, "infoStandardBg", private_safeDarken(palette.info.light, 0.9));
      setColor(palette.Alert, "successStandardBg", private_safeDarken(palette.success.light, 0.9));
      setColor(palette.Alert, "warningStandardBg", private_safeDarken(palette.warning.light, 0.9));
      setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
      setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
      setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
      setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
      setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-900"));
      setColor(palette.AppBar, "darkBg", setCssVarColor("palette-background-paper"));
      setColor(palette.AppBar, "darkColor", setCssVarColor("palette-text-primary"));
      setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-600"));
      setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-800"));
      setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-700"));
      setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-700"));
      setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-300"));
      setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-300"));
      setColor(palette.FilledInput, "bg", "rgba(255, 255, 255, 0.09)");
      setColor(palette.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)");
      setColor(palette.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)");
      setColor(palette.LinearProgress, "primaryBg", private_safeDarken(palette.primary.main, 0.5));
      setColor(palette.LinearProgress, "secondaryBg", private_safeDarken(palette.secondary.main, 0.5));
      setColor(palette.LinearProgress, "errorBg", private_safeDarken(palette.error.main, 0.5));
      setColor(palette.LinearProgress, "infoBg", private_safeDarken(palette.info.main, 0.5));
      setColor(palette.LinearProgress, "successBg", private_safeDarken(palette.success.main, 0.5));
      setColor(palette.LinearProgress, "warningBg", private_safeDarken(palette.warning.main, 0.5));
      setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.13)`);
      setColor(palette.Slider, "primaryTrack", private_safeDarken(palette.primary.main, 0.5));
      setColor(palette.Slider, "secondaryTrack", private_safeDarken(palette.secondary.main, 0.5));
      setColor(palette.Slider, "errorTrack", private_safeDarken(palette.error.main, 0.5));
      setColor(palette.Slider, "infoTrack", private_safeDarken(palette.info.main, 0.5));
      setColor(palette.Slider, "successTrack", private_safeDarken(palette.success.main, 0.5));
      setColor(palette.Slider, "warningTrack", private_safeDarken(palette.warning.main, 0.5));
      const snackbarContentBackground = private_safeEmphasize(palette.background.default, 0.98);
      setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
      setColor(palette.SnackbarContent, "color", silent(() => palette.getContrastText(snackbarContentBackground)));
      setColor(palette.SpeedDialAction, "fabHoverBg", private_safeEmphasize(palette.background.paper, 0.15));
      setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-600"));
      setColor(palette.StepContent, "border", setCssVarColor("palette-grey-600"));
      setColor(palette.Switch, "defaultColor", setCssVarColor("palette-grey-300"));
      setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-600"));
      setColor(palette.Switch, "primaryDisabledColor", private_safeDarken(palette.primary.main, 0.55));
      setColor(palette.Switch, "secondaryDisabledColor", private_safeDarken(palette.secondary.main, 0.55));
      setColor(palette.Switch, "errorDisabledColor", private_safeDarken(palette.error.main, 0.55));
      setColor(palette.Switch, "infoDisabledColor", private_safeDarken(palette.info.main, 0.55));
      setColor(palette.Switch, "successDisabledColor", private_safeDarken(palette.success.main, 0.55));
      setColor(palette.Switch, "warningDisabledColor", private_safeDarken(palette.warning.main, 0.55));
      setColor(palette.TableCell, "border", private_safeDarken(private_safeAlpha(palette.divider, 1), 0.68));
      setColor(palette.Tooltip, "bg", private_safeAlpha(palette.grey[700], 0.92));
    }
    setColorChannel(palette.background, "default");
    setColorChannel(palette.background, "paper");
    setColorChannel(palette.common, "background");
    setColorChannel(palette.common, "onBackground");
    setColorChannel(palette, "divider");
    Object.keys(palette).forEach((color2) => {
      const colors2 = palette[color2];
      if (color2 !== "tonalOffset" && colors2 && typeof colors2 === "object") {
        if (colors2.main) {
          setColor(palette[color2], "mainChannel", private_safeColorChannel(toRgb(colors2.main)));
        }
        if (colors2.light) {
          setColor(palette[color2], "lightChannel", private_safeColorChannel(toRgb(colors2.light)));
        }
        if (colors2.dark) {
          setColor(palette[color2], "darkChannel", private_safeColorChannel(toRgb(colors2.dark)));
        }
        if (colors2.contrastText) {
          setColor(palette[color2], "contrastTextChannel", private_safeColorChannel(toRgb(colors2.contrastText)));
        }
        if (color2 === "text") {
          setColorChannel(palette[color2], "primary");
          setColorChannel(palette[color2], "secondary");
        }
        if (color2 === "action") {
          if (colors2.active) {
            setColorChannel(palette[color2], "active");
          }
          if (colors2.selected) {
            setColorChannel(palette[color2], "selected");
          }
        }
      }
    });
  });
  theme = args.reduce((acc, argument) => deepmerge$1(acc, argument), theme);
  const parserConfig = {
    prefix: cssVarPrefix,
    disableCssColorScheme,
    shouldSkipGeneratingVar: shouldSkipGeneratingVar$1,
    getSelector: defaultGetSelector(theme)
  };
  const {
    vars,
    generateThemeVars,
    generateStyleSheets
  } = prepareCssVars(theme, parserConfig);
  theme.vars = vars;
  Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value2]) => {
    theme[key] = value2;
  });
  theme.generateThemeVars = generateThemeVars;
  theme.generateStyleSheets = generateStyleSheets;
  theme.generateSpacing = function generateSpacing() {
    return createSpacing(input.spacing, createUnarySpacing(this));
  };
  theme.getColorSchemeSelector = createGetColorSchemeSelector(selector);
  theme.spacing = theme.generateSpacing();
  theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar$1;
  theme.unstable_sxConfig = {
    ...defaultSxConfig,
    ...input?.unstable_sxConfig
  };
  theme.unstable_sx = function sx(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  theme.toRuntimeSource = stringifyTheme;
  return theme;
}
function attachColorScheme(theme, scheme, colorScheme) {
  if (!theme.colorSchemes) {
    return void 0;
  }
  if (colorScheme) {
    theme.colorSchemes[scheme] = {
      ...colorScheme !== true && colorScheme,
      palette: createPalette({
        ...colorScheme === true ? {} : colorScheme.palette,
        mode: scheme
      })
      // cast type to skip module augmentation test
    };
  }
}
function createTheme(options2 = {}, ...args) {
  const {
    palette,
    cssVariables = false,
    colorSchemes: initialColorSchemes = !palette ? {
      light: true
    } : void 0,
    defaultColorScheme: initialDefaultColorScheme = palette?.mode,
    ...rest
  } = options2;
  const defaultColorSchemeInput = initialDefaultColorScheme || "light";
  const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
  const colorSchemesInput = {
    ...initialColorSchemes,
    ...palette ? {
      [defaultColorSchemeInput]: {
        ...typeof defaultScheme !== "boolean" && defaultScheme,
        palette
      }
    } : void 0
  };
  if (cssVariables === false) {
    if (!("colorSchemes" in options2)) {
      return createThemeNoVars(options2, ...args);
    }
    let paletteOptions = palette;
    if (!("palette" in options2)) {
      if (colorSchemesInput[defaultColorSchemeInput]) {
        if (colorSchemesInput[defaultColorSchemeInput] !== true) {
          paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
        } else if (defaultColorSchemeInput === "dark") {
          paletteOptions = {
            mode: "dark"
          };
        }
      }
    }
    const theme = createThemeNoVars({
      ...options2,
      palette: paletteOptions
    }, ...args);
    theme.defaultColorScheme = defaultColorSchemeInput;
    theme.colorSchemes = colorSchemesInput;
    if (theme.palette.mode === "light") {
      theme.colorSchemes.light = {
        ...colorSchemesInput.light !== true && colorSchemesInput.light,
        palette: theme.palette
      };
      attachColorScheme(theme, "dark", colorSchemesInput.dark);
    }
    if (theme.palette.mode === "dark") {
      theme.colorSchemes.dark = {
        ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
        palette: theme.palette
      };
      attachColorScheme(theme, "light", colorSchemesInput.light);
    }
    return theme;
  }
  if (!palette && !("light" in colorSchemesInput) && defaultColorSchemeInput === "light") {
    colorSchemesInput.light = true;
  }
  return createThemeWithVars({
    ...rest,
    colorSchemes: colorSchemesInput,
    defaultColorScheme: defaultColorSchemeInput,
    ...typeof cssVariables !== "boolean" && cssVariables
  }, ...args);
}
const defaultTheme = createTheme();
const THEME_ID = "$$material";
function slotShouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const rootShouldForwardProp = (prop) => slotShouldForwardProp(prop) && prop !== "classes";
const styled = createStyled({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
const memoTheme = unstable_memoTheme;
process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object.isRequired
} : void 0;
function useDefaultProps(params) {
  return useDefaultProps$1(params);
}
function getSvgIconUtilityClass(slot) {
  return generateUtilityClass("MuiSvgIcon", slot);
}
generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const useUtilityClasses$2 = (ownerState) => {
  const {
    color: color2,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ["root", color2 !== "inherit" && `color${capitalize$1(color2)}`, `fontSize${capitalize$1(fontSize)}`]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};
const SvgIconRoot = styled("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== "inherit" && styles[`color${capitalize$1(ownerState.color)}`], styles[`fontSize${capitalize$1(ownerState.fontSize)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  display: "inline-block",
  flexShrink: 0,
  transition: theme.transitions?.create?.("fill", {
    duration: (theme.vars ?? theme).transitions?.duration?.shorter
  }),
  variants: [
    {
      props: (props) => !props.hasSvgAsChild,
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: "currentColor"
      }
    },
    {
      props: {
        fontSize: "inherit"
      },
      style: {
        fontSize: "inherit"
      }
    },
    {
      props: {
        fontSize: "small"
      },
      style: {
        fontSize: theme.typography?.pxToRem?.(20) || "1.25rem"
      }
    },
    {
      props: {
        fontSize: "medium"
      },
      style: {
        fontSize: theme.typography?.pxToRem?.(24) || "1.5rem"
      }
    },
    {
      props: {
        fontSize: "large"
      },
      style: {
        fontSize: theme.typography?.pxToRem?.(35) || "2.1875rem"
      }
    },
    // TODO v5 deprecate color prop, v6 remove for sx
    ...Object.entries((theme.vars ?? theme).palette).filter(([, value2]) => value2 && value2.main).map(([color2]) => ({
      props: {
        color: color2
      },
      style: {
        color: (theme.vars ?? theme).palette?.[color2]?.main
      }
    })),
    {
      props: {
        color: "action"
      },
      style: {
        color: (theme.vars ?? theme).palette?.action?.active
      }
    },
    {
      props: {
        color: "disabled"
      },
      style: {
        color: (theme.vars ?? theme).palette?.action?.disabled
      }
    },
    {
      props: {
        color: "inherit"
      },
      style: {
        color: void 0
      }
    }
  ]
})));
const SvgIcon = /* @__PURE__ */ React.forwardRef(function SvgIcon2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiSvgIcon"
  });
  const {
    children,
    className,
    color: color2 = "inherit",
    component = "svg",
    fontSize = "medium",
    htmlColor,
    inheritViewBox = false,
    titleAccess,
    viewBox = "0 0 24 24",
    ...other
  } = props;
  const hasSvgAsChild = /* @__PURE__ */ React.isValidElement(children) && children.type === "svg";
  const ownerState = {
    ...props,
    color: color2,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox,
    hasSvgAsChild
  };
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses$2(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, {
    as: component,
    className: clsx(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? void 0 : true,
    role: titleAccess ? "img" : void 0,
    ref,
    ...more,
    ...other,
    ...hasSvgAsChild && children.props,
    ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: titleAccess
    }) : null]
  });
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = "SvgIcon";
function createSvgIcon(path2, displayName) {
  function Component2(props, ref) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${displayName}Icon` : void 0,
      ref,
      ...props,
      children: path2
    });
  }
  if (process.env.NODE_ENV !== "production") {
    Component2.displayName = `${displayName}Icon`;
  }
  Component2.muiName = SvgIcon.muiName;
  return /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(Component2));
}
const CloseIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const useStyles$C = (theme) => {
  return {
    popup: {
      backgroundColor: "white",
      overflow: "hidden",
      padding: "8px"
    },
    header: {},
    left: {
      fontSize: "150%",
      textDecoration: "none"
    },
    right: {
      float: "right"
    },
    body: {},
    footer: {
      position: "absolute",
      left: "8px",
      bottom: "8px"
    }
  };
};
const Modal = (props) => {
  useTheme();
  const classes = useStyles$C();
  const { closeTo } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { ...classes.popup }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classes.header }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: closeTo, style: { ...classes.right }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {}) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classes.body }, children: props.children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classes.footer }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: closeTo, style: { ...classes.left }, children: "Close" }) })
  ] });
};
const useStyles$B = (theme) => {
  return {
    root: {
      padding: ".6rem 0",
      // top/bottom, left/right
      [theme.breakpoints.up("sm")]: {
        padding: ".8rem 0"
      },
      [theme.breakpoints.up("md")]: {
        padding: "1.0rem 0"
      },
      [theme.breakpoints.up("lg")]: {
        padding: "1.2rem 0"
      }
    },
    link: {
      textDecoration: "none"
    }
  };
};
function BlogCards({ isDev: isDev2, metas }) {
  const theme = useTheme();
  const classes = useStyles$B(theme);
  let pinnedPosts = null;
  let filteredPosts = null;
  if (isDev2) {
    pinnedPosts = metas.filter((meta) => {
      return meta.pin;
    });
    filteredPosts = metas.filter((meta) => {
      return !meta.pin;
    });
  } else {
    pinnedPosts = metas.filter((meta) => {
      return meta.pin;
    });
    filteredPosts = metas.filter((meta) => {
      return !meta.draft && !meta.pin;
    });
  }
  const blogCard = (meta, i) => {
    let {
      pic,
      picTitle,
      title,
      excerpt,
      draft,
      datePub,
      dateMod,
      tags,
      file
      // slug
      // pin
      // blog,
      // personSeoCode,
    } = meta;
    if (title.length >= 74) {
      const titleSubstr = title.substr(0, 74);
      title = title.substr(0, titleSubstr.lastIndexOf(" ")) + "...";
    }
    const href = "/blog/" + file;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { to: href, style: { ...classes.link }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      MuiCard,
      {
        img: pic,
        imgTitle: picTitle,
        title,
        excerpt,
        updated: dateMod,
        draft
      }
    ) }, i);
  };
  const pinnedCards = pinnedPosts.map((meta, i) => {
    return blogCard(meta, i);
  });
  const filteredCards = filteredPosts.map((meta, i) => {
    return blogCard(meta, i);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(SectionLayout, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Grid,
      {
        container: true,
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        sx: { ...classes.root },
        children: pinnedCards
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("hr", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Grid,
      {
        container: true,
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        sx: { ...classes.root },
        children: filteredCards
      }
    )
  ] }) });
}
const BannerImage = (props) => {
  const theme = useTheme();
  const { pageContent } = props;
  const imageUrl = `url(${pageContent.image})`;
  const height2 = pageContent.height || theme.custom.bannerMinHeight;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      sx: {
        /* Here's the trick */
        background: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.1)), var(--image-url) center center",
        /* Here's the same styles we applied to our content-div earlier */
        color: "white",
        height: height2,
        display: "flex",
        alignItems: "stretch",
        justifyContent: "left",
        objectFit: "scale-down",
        backgroundSize: "cover"
      },
      style: {
        "--image-url": imageUrl
      },
      children: props.children
    }
  );
};
const SectionHeader = (props) => {
  useTheme();
  const { title, subtitle } = props;
  const titleHtml = title ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h2", align: "center", gutterBottom: true, children: title }) : null;
  const subtitleHtml = subtitle ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", align: "center", children: subtitle }) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { py: 2 }, children: [
    titleHtml,
    subtitleHtml
  ] });
};
const useStyles$A = (theme) => {
  return {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      padding: theme.custom.btnPadding,
      marginBottom: theme.custom.sectionGap
    },
    title: {
      color: theme.palette.primary.main,
      marginBottom: theme.custom.sectionGap
    },
    subtitle: {
      color: theme.palette.primary.main,
      marginBottom: theme.custom.sectionGap
    },
    body: {
      marginBottom: theme.custom.sectionGap
    },
    tail: {
      marginBottom: theme.custom.sectionGap,
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    }
  };
};
const SectionWrapper = (props) => {
  const theme = useTheme();
  const classes = useStyles$A(theme);
  const { title, subtitle, body, tail } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { ...classes.wrapper }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h1", component: "h1", sx: { ...classes.title }, children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h3", component: "h3", sx: { ...classes.subtitle }, children: subtitle }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body1", sx: { ...classes.body }, children: body }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", sx: { ...classes.tail }, children: tail })
  ] });
};
const useStyles$z = (theme) => {
  return {
    section: {
      width: "100%",
      // Margin bottom is for section bottom gap (to show darker background from slate)
      marginBottom: theme.custom.pageGap,
      backgroundColor: theme.custom.contentpanelBG
    },
    padding: {
      // Section's inner padding
      paddingTop: ".4rem",
      paddingLeft: ".4rem",
      paddingRight: ".4rem"
    }
  };
};
const SectionLayout = (props) => {
  const theme = useTheme();
  const classes = useStyles$z(theme);
  const { option, children, sectionStyle } = props;
  if (option === "nopadding") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { square: true, sx: { ...classes.section, ...sectionStyle }, children });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { square: true, sx: { ...classes.section, ...classes.padding, ...sectionStyle }, children });
  }
};
const Banner = (props) => {
  useTheme();
  const { pageContent } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BannerImage, { pageContent, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box$1,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "1.2rem",
        margin: "1.6rem 0 0 0.4rem",
        width: "70%"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography,
          {
            variant: "h1",
            gutterBottom: true,
            dangerouslySetInnerHTML: { __html: pageContent.title },
            sx: { fontSize: ["1.8rem", "2.0rem"] }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography,
          {
            variant: "h3",
            gutterBottom: true,
            dangerouslySetInnerHTML: { __html: pageContent.subTitle },
            sx: { fontSize: [" 1.4rem", "1.6rem"] }
          }
        )
      ]
    }
  ) });
};
const RecallsWidgetWrapper = ({ config, widgetSrc }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (!containerRef.current) {
      return;
    }
    window.recallsWidgetConfig = {
      ...config,
      containerId: containerRef.current.id
      // Ensure the widget targets this component's div
    };
    const script = document.createElement("script");
    script.src = widgetSrc;
    script.async = true;
    script.onload = () => {
      if (window.RecallsWidget && typeof window.RecallsWidget.init === "function") {
        window.RecallsWidget.init();
      }
    };
    script.onerror = (error) => {
      console.error("Failed to load Recalls Widget script:", error);
      if (containerRef.current) {
        containerRef.current.innerHTML = '<p style="color: red;">Failed to load recalls widget.</p>';
      }
    };
    document.body.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
      delete window.recallsWidgetConfig;
    };
  }, [config]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: config.containerId || "recalls-content", ref: containerRef });
};
const useCardStyles = (theme) => {
  return {
    /*
        root: {
    	flexGrow: 1,
    	padding: theme.spacing(1),
    	paddingRight: theme.spacing(1),
        },
    */
    paper: {
      margin: theme.spacing(1),
      padding: theme.spacing(1)
    },
    typo: {
      marginBottom: theme.spacing(2)
    },
    // For PainPoints
    avatar: {},
    icon: {},
    // For CTA
    btn: {
      margin: theme.spacing(1, 10),
      padding: theme.spacing(2),
      width: "calc(100% - 160px)"
    },
    // For Addl. Details.
    moreBtn: {
      padding: theme.spacing(1)
    },
    /*
        // visual gap between sub sections
        benefits: {
    	padding: theme.spacing(1),
        },
    */
    // For Cards
    card: {
      border: "1px solid black",
      paddingRight: "1rem",
      height: "26.0rem",
      margin: "0.2rem"
    },
    area: {
      display: "flex",
      flexDirection: "column",
      margin: "0.6rem"
    },
    media: {
      margin: "auto",
      // makes the image horizontally centered
      width: "6rem",
      height: "6rem",
      // image height without image label
      objectFit: "scale-down",
      // 'contain',
      padding: "1rem"
    },
    content: {
      background: "white",
      order: "2"
    }
  };
};
const ImageListCard = (props) => {
  const theme = useTheme();
  const classes = useCardStyles(theme);
  const { cardData, inclPictures } = props;
  const gatsbyMedia = inclPictures && cardData.picture ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    KImage,
    {
      style: { ...classes.media },
      src: cardData.picture,
      alt: cardData.picture,
      width: "100%",
      height: "100%"
    }
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { sx: { ...classes.card }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CardActionArea, { sx: { ...classes.area }, children: [
      gatsbyMedia,
      /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { sx: { ...classes.content }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { gutterBottom: true, variant: "h6", children: cardData.title }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", color: "textSecondary", component: "p", children: cardData.quote }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", color: "textSecondary", component: "p", children: cardData.name + "," + cardData.location }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", color: "textSecondary", component: "p", children: cardData.date.toString() })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions, {})
  ] });
};
const useStyles$y = (theme) => {
  return {
    root: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      overflow: "hidden",
      backgroundColor: theme.palette.background.paper,
      paddingBottom: "0.6rem"
    },
    gridList: {
      flexWrap: "nowrap",
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: "translateZ(0)"
    },
    title: {
      color: theme.palette.primary.light
    },
    titleBar: {
      background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)"
    },
    tile: {
      height: "26.8rem !important",
      // white section height
      width: "26rem !important"
      // card with
      //    marginRight: '20px !important',
      //    marginLeft: '20px !important',
    }
  };
};
const TestimonialsDisplayDetails = (props) => {
  const theme = useTheme();
  const classes = useStyles$y(theme);
  const { testimonials, inclPictures } = props;
  const items = testimonials.map((item) => {
    const date = item.date || "No date";
    const id = item.id || "No ID";
    const quote = item.quote || "No quote provided";
    const title = item.title || "No title";
    const type = item.type || "No type provided";
    const path2 = item.path || "No path provided";
    const location = item.location && (item.location.city ? item.location.city + ", " : "") + (item.location.state ? item.location.state : "") || "No location";
    const name = item.name && (item.name.title ? item.name.title + " " : "") + (item.name.first ? item.name.first + " " : "") + (item.name.last ? item.name.last : "") || "No name";
    const cardData = {
      date,
      id,
      picture: item.picture.medium || null,
      quote,
      title,
      type,
      path: path2,
      location,
      name
    };
    return cardData;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classes.root }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ImageList, { sx: { ...classes.gridList }, cols: items.length, children: items.map((item, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(ImageListItem, { sx: { ...classes.tile }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ImageListCard, { cardData: item, inclPictures }) }, i)) }) });
};
const TestimonialsDisplay = (props) => {
  const { title, testimonials, inclPictures } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SectionLayout, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SectionHeader, { title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TestimonialsDisplayDetails, { testimonials, inclPictures })
  ] });
};
const defaultAccount = {
  id: "",
  accountNo: "",
  dept: "",
  status: "",
  // 'active' | 'inactive' | 'suspend'    (used for preventing abuse)
  type: "",
  // 'system' | 'sole' | 'test' | 'corp' | 'user' USED ONLY IN BILLING and set in user.hooks.js
  email: "",
  // NOTE: email for account may not be same as the email for user
  first: "",
  last: "",
  tele: "",
  name: "",
  accountCode: "",
  expiry: "",
  userNo: "",
  syscomment: "",
  comment: "",
  tags: [],
  jsonProp: {
    "RECALLS": {
      type: "courtesy",
      // 'courtesy' | 'subscriber'(when pymt setup) | 'waiver' | 'trial'
      plan: "CONSUMER-PERSISTANT",
      // 'CONSUMER-PERSISTANT' | 'CONSUMER-PREMIUM' | 'INSTITUTION-PARTNER' | 'INSTITUTION-PREMIUM' | 'SUPPLIER-PREMIUM'
      payment: "done",
      // 'todo' | 'done' (when pymt setup) | 'cxl' | 'waiver' (when waiver processed)
      inviteCode: "invite265free",
      trialExpiry: null,
      // Date value (when acct created) 1731513304904 = Wed Nov 13 2024 10:55:04 GMT-0500
      waiverExpiry: null,
      payorExpiry: null,
      // Date value (when sub is cancelled)
      waiverDays: 0,
      // Number of days of waiver   (when waiver processed)
      waiverAmount: 0
      // 100, 50 percentage
    }
  },
  auditip: "",
  auditlusr: "",
  createdAt: "",
  //
  updatedAt: "",
  deletedAt: "",
  version: ""
};
class Account {
  constructor(account, application) {
    for (const [key, value2] of Object.entries(account)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
    this.application = application?.toUpperCase();
    this.apps = this.jsonProp["apps"];
    this.app = this.jsonProp["apps"][application];
  }
  // Getter
  get id() {
    return this.id;
  }
  get accountNo() {
    return this.accountNo;
  }
  get dept() {
    return this.dept;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  get email() {
    return this.email;
  }
  get first() {
    return this.first;
  }
  get last() {
    return this.last;
  }
  get tele() {
    return this.tele;
  }
  get name() {
    return this.name;
  }
  get accountCode() {
    return this.accountCode;
  }
  get expiry() {
    return this.expiry;
  }
  get userNo() {
    return this.userNo;
  }
  get syscomment() {
    return this.syscomment;
  }
  get comment() {
    return this.comment;
  }
  get tags() {
    return this.tags;
  }
  // jsonProp subset ... begin
  /*
  type:                                              //'courtesy' | 'subscriber'(when pymt setup) | 'waiver' | 'trial' 
  plan: inputData.plan,                              // plan: 'CONSUMER-INFO' | 'CONSUMER-AWARE' | 'INSTITUTION'
  payment: payment,                                  // payment: 'todo' | 'done' | 'cxl' | 'waiver'
  invitecode: inputData.inviteCode || '',            // see: env. var.  
  trialExpiry: null ,                                // date when trial expires
  waiverExpiry: null,                                // date when waiver expires
  payorExpiry: null ,                                // date when payor's plan is cancelled
  waiverAmount: 0,                                   // waiverAmount: 100, 50 percentage
  waiverDays: nn,                                    // number days of waiver - filled in when waiver is approved   
  */
  get planType() {
    return null;
  }
  get plan() {
    return null;
  }
  get payment() {
    return null;
  }
  get inviteCode() {
    return null;
  }
  get inviteCodeDays() {
    if (this.app.inviteCode) {
      const numMatch = this.app.inviteCode.match(/(\d+)/);
      if (numMatch && numMatch[0]) Number(numMatch[0]);
    }
    return 0;
  }
  get trialExpiry() {
    return false;
  }
  get waiverExpiry() {
    return false;
  }
  get payorExpiry() {
    return false;
  }
  get waiverDays() {
    return false;
  }
  get waiverAmount() {
    return false;
  }
  // jsonProp subset ... end
  get auditip() {
    return this.auditip;
  }
  get auditlusr() {
    return this.auditlusr;
  }
  get createdAt() {
    return this.createdAt;
  }
  get updatedAt() {
    return this.updatedAt;
  }
  // deletedAt
  // version
  //
  // Method
  //
  get obj() {
    return this;
  }
  updateField(field, value2) {
    this[field] = value2;
  }
  isDatePastGone(d) {
    if (!d) return false;
    var now = /* @__PURE__ */ new Date();
    now.setHours(0, 0, 0, 0);
    if (d < now) {
      return true;
    } else {
      return false;
    }
  }
  isAccountInfoPlan() {
    return false;
  }
  isAccountAwarePlan() {
    return false;
  }
  isTrialExpiryPast() {
    return false;
  }
  isPayorExpiryPast() {
    return false;
  }
  isWaiverExpiryPast() {
    return false;
  }
  // returns true if permission is to be granted
  isPermission(resource) {
    if (resource === "alerts" || resource === "search" || resource === "vehicle-check" || resource === "keywords-check" || resource === "monitor" || resource === "details") {
      return true;
    }
  }
  /*
    isAwarePlanActive() {
      // could be in trial
      // could be in trial expired
      // could be in waiver expired
      // could be in valid payor mode 'subscriber' and 'done'
      // could be in valid waiver mode 'waiver' and 'done'
      // could be in payor cxl expired
      const status =
        this.isAccountAwarePlan() &&
  	((this.type === 'subscriber' && this.payment === 'done') || 
  	  (!this.isTrialExpiryPast() && !this.isPayorExpiryPast() && !this.isWaiverExpiryPast()));
      return status;
    }
  
    isInfoPlanActive() {
      return this.isAccountInfoPlan();
    }
  */
  /*
    isExpiryPast() {  // retire this function
      const isTrialExpiryPast = ((this.type === 'trial') &&
        (this.app.payment === 'todo') &&
        (this.isDatePastGone(this.app.trialExpiry)));
  
      // Evaluate payor expiry - payor subscription expired if :
      // type = 'subscriber' + payment = 'cxl' + payorExpiry date is past gone
      const isPayorExpiryPast = ((this.type === 'subscriber') &&
        (this.app.payment === 'cxl') &&
        (this.isDatePastGone(this.app.payorExpiry)));
  
      // Evaluate waiver expiry - waiver expired if :
      // type = 'waiver' + payment = 'waiver' + waiverExpiry date is past gone
      const isWaiverExpiryPast = ((this.type === 'waiver') &&
        (this.app.payment === 'waiver') &&
        (this.isDatePastGone(this.app.waiverExpiry)));
      
      //console.log('Account.jsx - isTrialExpiryPast/isPayorExpiryPast/isWaiverExpiryPast : ' + isTrialExpiryPast+ '/' +
      //  isPayorExpiryPast + '/' + isWaiverExpiryPast);
      
      if (isTrialExpiryPast || isPayorExpiryPast || isWaiverExpiryPast) {
        return true;
      }
      else
        return false;
    }
  */
}
const defaultConsumer = {
  id: "",
  userNo: "",
  accountNo: "",
  status: "",
  type: "",
  basicCategories: "1125899906842623",
  foodCategories: "1125899906842623",
  homeCategories: "1125899906842623",
  spareCategories: "1125899906842623",
  vehicleCodes: [],
  keywords: [],
  exclusions: 0,
  notifications: 0,
  regions: 1,
  cell: "",
  altCell: "",
  email: "",
  altEmail: "",
  location: null,
  webkey: "",
  syscomment: null,
  comments: null,
  tags: [],
  jsonProp: {
    type: "courtesy",
    // 'courtesy' | 'subscriber'(when pymt setup) | 'waiver' | 'trial'
    plan: "CONSUMER-ANONYMOUS",
    // 'CONSUMER-PERSISTANT' | 'CONSUMER-PREMIUM' | 'INSTITUTION-PARTNER' | 'INSTITUTION-PREMIUM' | 'SUPPLIER-PREMIUM'
    payment: "done",
    // 'todo' | 'done' (when pymt setup) | 'cxl' | 'waiver' (when waiver processed)
    inviteCode: "invite265free",
    trialExpiry: null,
    // Date value (when acct created) 1731513304904 = Wed Nov 13 2024 10:55:04 GMT-0500
    waiverExpiry: null,
    payorExpiry: null,
    // Date value (when sub is cancelled)
    waiverDays: 0,
    // Number of days of waiver   (when waiver processed)
    waiverAmount: 0
    // 100, 50 percentage
  },
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  version: 1
};
class Consumer {
  constructor(consumer) {
    for (const [key, value2] of Object.entries(consumer)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
  // Getter
  get id() {
    return this.id;
  }
  get userNo() {
    return this.userNo;
  }
  get accountNo() {
    return this.accountNo;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  get basicCategories() {
    return this.basicCategories;
  }
  get foodCategories() {
    return this.foodCategories;
  }
  get homeCategories() {
    return this.homeCategories;
  }
  // spareCategories
  get vehicleCodes() {
    return this.vehicleCodes;
  }
  set vehicleCodes(v) {
    this.vehicleCodes = v;
  }
  get keywords() {
    return this.keywords || [];
  }
  set keywords(k) {
    this.keywords = k;
  }
  get exclusions() {
    return this.exclusions;
  }
  set exclusions(e) {
    this.exclusions = e;
  }
  get notifications() {
    return this.notifications;
  }
  set notifications(n) {
    this.notifications = n;
  }
  // regions
  get cell() {
    return this.cell;
  }
  get altCell() {
    return this.altCell;
  }
  get email() {
    return this.email;
  }
  get altEmail() {
    return this.altEmail;
  }
  // location
  // webkey
  // syscomment
  get comments() {
    return this.comments;
  }
  // tags []
  // jsonProp
  get createdAt() {
    return this.createdAt;
  }
  // deletedAt
  // version
  //
  // Methods
  //
  get obj() {
    return this;
  }
  updateCategories(food, basic, home) {
    this.foodCategories = "" + food;
    this.basicCategories = "" + basic;
    this.homeCategories = "" + home;
  }
  updateField(field, value2) {
    this[field] = value2;
  }
  async postConsumer(appState) {
    const token = appState.token;
    const fpid = appState.fpid;
    const consumersSvcUrl = appState?.getEnvVar.CONSUMERS_SVC;
    let resp = { error: "post failed" };
    const consumersURL = `${consumersSvcUrl}/${this.id}`;
    console.log("Consumer: postConsumer updating server with :", this.obj);
    try {
      const options2 = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token ? token : fpid}`,
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(this.obj)
      };
      resp = await myFetch(consumersURL, options2);
      console.log("Consumer: consumer post successful response: " + JSON.stringify(resp.data));
      return resp.data;
    } catch (e) {
      console.error("Consumer: consumer post failed response: " + JSON.stringify(e));
      return resp;
    }
  }
  // postConsumer()
}
const defaultFormuser = {
  id: "",
  userNo: "",
  status: "",
  type: "",
  notifications: 0,
  regions: 1,
  cell: "",
  altCell: "",
  email: "",
  altEmail: "",
  location: null,
  webkey: "",
  syscomment: null,
  comments: null,
  tags: [],
  jsonProp: {},
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  version: 1
};
class Formuser {
  constructor(formuser) {
    for (const [key, value2] of Object.entries(formuser)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
  // Getter
  get id() {
    return this.id;
  }
  get userNo() {
    return this.userNo;
  }
  get accountNo() {
    return this.accountNo;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  get notifications() {
    return this.notifications;
  }
  set notifications(n) {
    this.notifications = n;
  }
  // regions
  get cell() {
    return this.cell;
  }
  get altCell() {
    return this.altCell;
  }
  get email() {
    return this.email;
  }
  get altEmail() {
    return this.altEmail;
  }
  // location
  // webkey
  // syscomment
  get comments() {
    return this.comments;
  }
  // tags []
  // jsonProp
  get createdAt() {
    return this.createdAt;
  }
  // deletedAt
  // version
  //
  // Methods
  //
  get obj() {
    return this;
  }
  updateField(field, value2) {
    this[field] = value2;
  }
  async postFormuser(appState) {
    const token = appState.token;
    const fpid = appState.fpid;
    const formusersSvcUrl = appState?.getEnvVar.FORMUSERS_SVC;
    let resp = { error: "post failed" };
    const formusersURL = `${formusersSvcUrl}/${this.id}`;
    console.log("Formuser: postFormuser updating server with :", this.obj);
    try {
      const options2 = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token ? token : fpid}`,
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(this.obj)
      };
      resp = await myFetch(formusersURL, options2);
      console.log("Formuser: formuser post successful response: " + JSON.stringify(resp));
      return resp.data;
    } catch (e) {
      console.error("Formuser: formuser post failed response: " + JSON.stringify(e));
      return resp;
    }
  }
  // postFormuser()
}
const defaultBitiuser = {
  id: "",
  userNo: "",
  status: "",
  type: "",
  notifications: 0,
  regions: 1,
  cell: "",
  altCell: "",
  email: "",
  altEmail: "",
  location: null,
  webkey: "",
  syscomment: null,
  comments: null,
  tags: [],
  jsonProp: {},
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  version: 1
};
class Bitiuser {
  constructor(bitiuser) {
    for (const [key, value2] of Object.entries(bitiuser)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
  // Getter
  get id() {
    return this.id;
  }
  get userNo() {
    return this.userNo;
  }
  get accountNo() {
    return this.accountNo;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  get notifications() {
    return this.notifications;
  }
  set notifications(n) {
    this.notifications = n;
  }
  // regions
  get cell() {
    return this.cell;
  }
  get altCell() {
    return this.altCell;
  }
  get email() {
    return this.email;
  }
  get altEmail() {
    return this.altEmail;
  }
  // location
  // webkey
  // syscomment
  get comments() {
    return this.comments;
  }
  // tags []
  // jsonProp
  get createdAt() {
    return this.createdAt;
  }
  // deletedAt
  // version
  //
  // Methods
  //
  get obj() {
    return this;
  }
  updateField(field, value2) {
    this[field] = value2;
  }
  async postBitiuser(appState) {
    const token = appState.token;
    const fpid = appState.fpid;
    const bitiusersSvcUrl = appState?.getEnvVar.BITIUSERS_SVC;
    let resp = { error: "post failed" };
    const bitiusersURL = `${bitiusersSvcUrl}/${this.id}`;
    console.log("Bitiuser: postBitiuser updating server with :", this.obj);
    try {
      const options2 = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token ? token : fpid}`,
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(this.obj)
      };
      resp = await myFetch(bitiusersURL, options2);
      console.log("Bitiuser: bitiuser post successful response: " + JSON.stringify(resp));
      return resp.data;
    } catch (e) {
      console.error("Bitiuser: bitiuser post failed response: " + JSON.stringify(e));
      return resp;
    }
  }
  // postBitiuser()
}
const defaultNulluser = {
  id: "",
  userNo: "",
  status: "",
  type: "",
  notifications: 0,
  regions: 1,
  cell: "",
  altCell: "",
  email: "",
  altEmail: "",
  location: null,
  webkey: "",
  syscomment: null,
  comments: null,
  tags: [],
  jsonProp: {},
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  version: 1
};
class Nulluser {
  constructor(nulluser) {
    for (const [key, value2] of Object.entries(nulluser)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
  // Getter
  get id() {
    return this.id;
  }
  get userNo() {
    return this.userNo;
  }
  get accountNo() {
    return this.accountNo;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  get notifications() {
    return this.notifications;
  }
  set notifications(n) {
    this.notifications = n;
  }
  // regions
  get cell() {
    return this.cell;
  }
  get altCell() {
    return this.altCell;
  }
  get email() {
    return this.email;
  }
  get altEmail() {
    return this.altEmail;
  }
  // location
  // webkey
  // syscomment
  get comments() {
    return this.comments;
  }
  // tags []
  // jsonProp
  get createdAt() {
    return this.createdAt;
  }
  // deletedAt
  // version
  //
  // Methods
  //
  get obj() {
    return this;
  }
  updateField(field, value2) {
    this[field] = value2;
  }
  async postNulluser(appState) {
    const token = appState.token;
    const fpid = appState.fpid;
    const nullusersSvcUrl = appState?.getEnvVar.NULLUSERS_SVC;
    let resp = { error: "post failed" };
    const nullusersURL = `${nullusersSvcUrl}/${this.id}`;
    console.log("Nulluser: postNulluser updating server with :", this.obj);
    try {
      const options2 = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token ? token : fpid}`,
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(this.obj)
      };
      resp = await myFetch(nullusersURL, options2);
      console.log("Nulluser: nulluser post successful response: " + JSON.stringify(resp));
      return resp.data;
    } catch (e) {
      console.error("Nulluser: nulluser post failed response: " + JSON.stringify(e));
      return resp;
    }
  }
  // postNulluser()
}
const defaultPermissions = {
  id: "",
  userNo: "",
  accountNo: "",
  dept: "",
  status: "",
  type: "",
  jsonProp: {},
  auditip: "",
  auditlusr: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: "",
  version: ""
};
class Permissions {
  constructor(permissions) {
    for (const [key, value2] of Object.entries(permissions)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
  // Getter
  get id() {
    return this.id;
  }
  get userNo() {
    return this.userNo;
  }
  get accountNo() {
    return this.accountNo;
  }
  get dept() {
    return this.dept;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  // jsonProp
  get auditip() {
    return this.auditip;
  }
  get auditlusr() {
    return this.autidlusr;
  }
  get createdAt() {
    return this.createdAt;
  }
  // deletedAt
  // version
  //
  // Methods
  //
  get obj() {
    return this;
  }
}
const defaultPreferences = {
  id: "",
  userNo: "",
  accountNo: "",
  dept: "",
  status: "",
  type: "",
  jsonProp: {},
  auditip: "",
  auditlusr: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: "",
  version: ""
};
class Preferences {
  constructor(preferences) {
    for (const [key, value2] of Object.entries(preferences)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
  // Getter
  get id() {
    return this.id;
  }
  get userNo() {
    return this.userNo;
  }
  get accountNo() {
    return this.accountNo;
  }
  get dept() {
    return this.dept;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  // jsonProp
  get auditip() {
    return this.auditip;
  }
  get auditlusr() {
    return this.autidlusr;
  }
  get createdAt() {
    return this.createdAt;
  }
  // deletedAt
  // version
  //
  // Methods
  //
  get obj() {
    return this;
  }
}
const defaultUser = {
  id: "",
  userNo: "",
  status: "",
  type: "",
  email: "",
  first: "",
  last: "",
  tele: "",
  password: "",
  syscomment: "",
  comment: "",
  tags: [],
  jsonProp: {},
  auditLoginCnt: 0,
  auditip: "",
  auditlusr: "",
  isVerified: false,
  verifyToken: "",
  verifyShortToken: "",
  verifyExpires: "",
  verifyChanges: "",
  resetToken: "",
  resetShortToken: "",
  resetExpires: "",
  preferredComm: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  version: 1
};
class User {
  constructor(user) {
    for (const [key, value2] of Object.entries(user)) {
      Object.defineProperty(this, key, {
        value: value2,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  }
  // Getter
  get id() {
    return this.id;
  }
  get userNo() {
    return this.userNo;
  }
  get status() {
    return this.status;
  }
  get type() {
    return this.type;
  }
  get email() {
    return this.email;
  }
  get first() {
    return this.first;
  }
  get last() {
    return this.last;
  }
  get tele() {
    return this.tele;
  }
  get password() {
    return this.password;
  }
  get syscomment() {
    return this.syscomment;
  }
  get comment() {
    return this.comment;
  }
  get tags() {
    return this.tags;
  }
  //jsonProp
  //
  get auditLoginCnt() {
    return this.auditLoginCnt;
  }
  get auditip() {
    return this.auditip;
  }
  get auditlusr() {
    return this.autidlusr;
  }
  get isVerified() {
    return this.isVerified;
  }
  //isVerified: { type: DataTypes.BOOLEAN },
  //verifyToken: { type: DataTypes.STRING },
  //verifyShortToken: { type: DataTypes.STRING },
  //verifyExpires: { type: DataTypes.DATE },
  //verifyChanges: { type: DataTypes.JSON },
  //resetToken: { type: DataTypes.STRING },
  //resetShortToken: { type: DataTypes.STRING },
  //resetExpires: { type: DataTypes.DATE },
  //preferredComm: { type: DataTypes.STRING },
  get createdAt() {
    return this.createdAt;
  }
  // deletedAt
  // version
  //
  // Methods
  //
  get obj() {
    return this;
  }
}
class Form {
  constructor(options2) {
    __publicField(this, "id", null);
    __publicField(this, "accountNo", -1);
    __publicField(this, "formNo", -1);
    __publicField(this, "status", "Enabled");
    // 'Enabled' | 'Disabled'
    __publicField(this, "type", "User");
    // 'User' |
    __publicField(this, "accessType", "Private");
    // 'Public' | 'System' | 'Private'
    __publicField(this, "activeType", "Recent");
    // 'Recent' | 'Specific'
    __publicField(this, "activeVerNo", 1);
    __publicField(this, "retain", 5);
    __publicField(this, "desc", "");
    __publicField(this, "markup", "");
    __publicField(this, "syscomment", "");
    __publicField(this, "comment", "");
    __publicField(this, "tags", []);
    // Commented out as it has DB write problems
    __publicField(this, "jsonProp", "{}");
    __publicField(this, "audtip", "1.1.1.1");
    // "192.168.1.35";
    __publicField(this, "auditlusr", "formclass");
    // "gist.metaforms";
    __publicField(this, "createdAt", "");
    __publicField(this, "updatedAt", "");
    __publicField(this, "deletedAt", null);
    __publicField(this, "version", 1);
    if (options2) {
      Object.assign(this, options2);
    }
  }
  /* Sample methods
    // Getter
    // Access as classInstance.propid
    get propid() {
      return this.id + '-' + this.userProp.id;
    }
  
    // Setter
    // Access as classInstance.something = 5
    set something(val) {
      if (val.length < 5) {
        alert('Something is too short');
      }
      this.something = val;
    }
  
    // Computed method
    // Access as Item().sayHi()
    ['say' + 'Hi']() {
      alert('Hello');
    }
  
    // Access as Item.catItem(item, item)
    static catItem(first, second) {
      return first.category + ' ' + second.item;
    }
  */
  // Getters and Setters
  // If the set is not defined then this will be read-only property
  /*
   Object.defineProperties(this, {
   "FirstName": {
   get: function () {
   return _firstName;
   },
   set: function (value) {
   _firstName = value;
   }
   }
   });
   */
}
class Instance {
  constructor(options2) {
    __publicField(this, "id", null);
    __publicField(this, "accountNo", -1);
    __publicField(this, "formNo", -1);
    __publicField(this, "instanceNo", -1);
    __publicField(this, "status", "Enabled");
    // ???
    __publicField(this, "type", "");
    // ???
    __publicField(this, "name", "No Form Name Provided");
    //
    __publicField(this, "srcNo", 1);
    // -1 | instanceNo
    __publicField(this, "syscomments", "");
    // ''
    __publicField(this, "comments", "");
    // ''
    __publicField(this, "tags", []);
    // Commented out as it has DB write problems
    __publicField(this, "jsonProp", "");
    // style, layout  bgimage = '' etc
    __publicField(this, "audtip", "");
    // "192.168.1.35";
    __publicField(this, "auditlusr", "");
    //
    __publicField(this, "createdAt", "");
    __publicField(this, "updatedAt", "");
    __publicField(this, "deletedAt", null);
    __publicField(this, "version", 1);
    if (options2) {
      Object.assign(this, options2);
    }
  }
  /* Sample methods
    // Getter
    // Access as classInstance.propid
    get propid() {
      return this.id + '-' + this.userProp.id;
    }
  
    // Setter
    // Access as classInstance.something = 5
    set something(val) {
      if (val.length < 5) {
        alert('Something is too short');
      }
      this.something = val;
    }
  
    // Computed method
    // Access as Item().sayHi()
    ['say' + 'Hi']() {
      alert('Hello');
    }
  
    // Access as Item.catItem(item, item)
    static catItem(first, second) {
      return first.category + ' ' + second.item;
    }
  */
  // Getters and Setters
  // If the set is not defined then this will be read-only property
  /*
   Object.defineProperties(this, {
   "FirstName": {
   get: function () {
   return _firstName;
   },
   set: function (value) {
   _firstName = value;
   }
   }
   });
   */
}
class Item {
  constructor(options2) {
    __publicField(this, "id", null);
    __publicField(this, "accountNo", -1);
    __publicField(this, "formNo", -1);
    __publicField(this, "instanceNo", -1);
    __publicField(this, "seqno", -1);
    // 1007
    __publicField(this, "status", "Enabled");
    // Unused ???
    __publicField(this, "type", "");
    // Component|Theme
    __publicField(this, "category", "");
    // Basic / Info ...
    __publicField(this, "wgt", "");
    // Button / Accordion ...
    __publicField(this, "name", "");
    // column name
    __publicField(this, "parent", "");
    // "1000-1"
    __publicField(this, "child", []);
    // In future start using child as it's represented as array on DB
    // The userProp for Item depends on the widget.
    // When an Item is created afresh, the widget dictates which properties are
    // needed by the widget and it is set in the CompConfig.js.
    // For DB based creation, the options in the ctor will supply the needed properties.
    // TODO So, the userProp object here can be an empty object.
    __publicField(this, "userProp", {});
    __publicField(this, "createdAt", "");
    __publicField(this, "updatedAt", "");
    __publicField(this, "deletedAt", null);
    __publicField(this, "version", 1);
    // Non DB prperties used in app
    // CONFLICTS WITH ABOVE TODO id = ''; // internally generated DOM id
    //defaultValue: '',     // (prefills the entry field)
    __publicField(this, "isError", false);
    // Use it in TextField
    __publicField(this, "errorMsg", "");
    // Use it in TextField
    //isValid: false,       // to be replaced with isError
    // *** item selection classes props ***
    __publicField(this, "itemHiliteClass", "");
    __publicField(this, "nailedHiliteClass", "");
    if (options2) {
      if (typeof options2.childSeqnoStr == "string" && options2.childSeqnoStr.length > 0) {
        options2.childSeqnoList = JSON.parse(options2.childSeqnoStr);
      }
      if (typeof options2.userProp == "string") {
        options2.userProp = JSON.parse(options2.userProp.replace(/'/g, '"'));
      }
      Object.assign(this, options2);
      if (options2 && options2.userProp) Object.assign(this.userProp, options2.userProp);
    }
  }
  disabled() {
    let rc = this.userProp.disabled && this.userProp.disabled[0] === "Yes";
    var disabled = rc ? "disabled " : "";
    return disabled;
  }
  readonly() {
    let rc = this.userProp.readonly && this.userProp.readonly[0] === "Yes";
    return rc;
  }
  required() {
    let rc = this.userProp.required && this.userProp.required[0] === "Yes";
    return rc;
  }
  autofocus() {
    let rc = this.userProp.autofocus && this.userProp.autofocus[0] === "Yes";
    return rc;
  }
  /* sample methods
    // Getter
    // Access as classInstance.propid
    get propid() {
      return this.id + '-' + this.userProp.id;
    }
  
    // Setter
    // Access as classInstance.something = 5
    set something(val) {
      if (val.length < 5) {
        alert('Something is too short');
      }
      this.something = val;
    }
  
    // Computed method
    // Access as Item().sayHi()
    ['say' + 'Hi']() {
      alert('Hello');
    }
  
    // Access as Item.catItem(item, item)
    static catItem(first, second) {
      return first.category + ' ' + second.item;
    }
  */
  // Getters and Setters
  // If the set is not defined then this will be read-only property
  /*
   Object.defineProperties(this, {
   "FirstName": {
   get: function () {
   return _firstName;
   },
   set: function (value) {
   _firstName = value;
   }
   }
   });
   */
  /* Formbuild is the only user of this method and it'll directly set the value
    setValue(val) {
      // used for value and valueSet
      //console.log('setValue() : ' + val + ' formtype : ' + this.formtype() + ', wrk %o', this.appState.workWrk);
      this.userProp.value = val;
    }
  */
  /* This is moved to P.js
    getWgtClass() {
      return 'gi-' + this.wgt.replace(/ /g, '').toLowerCase();
    }
  */
}
class Submission {
  constructor(options2) {
    __publicField(this, "id", null);
    __publicField(this, "accountNo", -1);
    __publicField(this, "formNo", -1);
    __publicField(this, "instanceNo", -1);
    __publicField(this, "userNo", -1);
    __publicField(this, "count", -1);
    __publicField(this, "columns", {
      // JSON object / JSON Stringified
    });
    //audit_ip = '';   replaced with auditip
    //audit_lusr = ''; replaced with auditlusr
    __publicField(this, "createdAt", "2018-12-31T19:00:00.000Z");
    __publicField(this, "updatedAt", "2018-12-31T19:00:00.000Z");
    __publicField(this, "deletedAt", null);
    __publicField(this, "version", 1);
    if (options2) {
      if (typeof options2.columns == "string") {
        options2.columns = JSON.parse(options2.columns.replace(/'/g, '"'));
      }
      Object.assign(this, options2);
      if (options2 && options2.columns) Object.assign(this.columns, options2.columns);
    }
  }
  setUnqColumn(keyLabel, keySeqno, value2) {
    if (keyLabel && keyLabel in this.columns) {
      this.columns[keyLabel + "-" + keySeqno] = value2;
    } else {
      this.columns[keyLabel || keySeqno] = value2;
    }
  }
  setColumn(key, value2) {
    this.columns[key] = value2;
  }
  getUnqColumn(keyLabel, keySeqno) {
    let val = null;
    if (keyLabel && keyLabel in this.columns) val = this.columns[keyLabel + "-" + keySeqno];
    if (val) return val;
    else if (keyLabel in this.columns) return this.columns[keyLabel];
    else return this.columns[keySeqno];
  }
  getColumn(key) {
    return this.columns[key];
  }
  setCount(val) {
    this.count = val;
  }
  getCount(val) {
    return this.count;
  }
  setReference(accountNo, formNo, instanceNo) {
    this.accountNo = accountNo;
    this.formNo = formNo;
    this.instanceNo = instanceNo;
  }
  setUserNo(val) {
    this.userNo = val;
  }
  setName(name) {
    this.name = name;
  }
  compress() {
    for (let c in this.columns) {
      if (typeof this.columns[c] == "string") {
        this.columns[c] = this.columns[c].replace(/'/g, '"');
      }
    }
    let str = JSON.stringify(this.columns);
    this.columns = str;
  }
  uncompress() {
    this.columns = JSON.parse(this.columns);
  }
  // Getter
  // Access as classInstance.propid
  get propid() {
    return this.id + "-" + this.userProp.id;
  }
  // Setter
  // Access as classInstance.something = 5
  set something(val) {
    if (val.length < 5) {
      alert("Something is too short");
    }
    this.something = val;
  }
  // Computed method
  // Access as Item().sayHi()
  ["sayHi"]() {
    alert("Hello");
  }
  // Access as Item.catItem(item, item)
  static catItem(first, second) {
    return first.category + " " + second.item;
  }
  // Getters and Setters
  // If the set is not defined then this will be read-only property
  /*
   Object.defineProperties(this, {
   "FirstName": {
   get: function () {
   return _firstName;
   },
   set: function (value) {
   _firstName = value;
   }
   }
   });
   */
}
const modelProps = {
  nav: "home",
  // home | list | build | preview | data | launch | signin | signup etc.
  state: ["start"],
  // start | init | stop | reset | upap | jwt | userforms | metaforms
  stateMsg: "Please wait. Application initializing... ",
  ioBusy: false,
  // Asynch Snackbar messaging support
  snackbarMsg: "",
  snackbarDuration: 6e3,
  snackbarVariant: "success",
  // success | info | warning | error |
  // values: $instance.name / $form.activeVerNo  / $form.activeType
  //         item.create / item.move / item.copy etc
  trackChanges: [],
  // From Selection.js
  selectedForm: {},
  // Used by selected()
  selectedInstance: {},
  // Used by selected()
  selectedItems: [],
  // Used by selected()
  upapMemberNdx: -1,
  // Ndx into current Account/Permissions/Preferences
  // From MetaForms.js
  metaForms: {},
  // metaForms has fixed forms/instances/items and modifiable structures. The FIXED stuff need not be in the mobx space. TODO ???
  // From Editor.js
  // Wrk/Cut/Copy is gradually using seqno and discarding use of id as of V2
  workWrk: { item: null, id: -1, seqno: -1 },
  workCut: { item: null, id: -1, seqno: -1 },
  workCopy: { item: null, id: -1, seqno: -1 },
  workNail: { item: null, id: -1, seqno: -1, compId: "", ctr: 0 },
  workFlags: {
    // Track instance editability : 'view' / 'edit'
    // Highest instanceNo is editable and all others are view only
    configMode: "view",
    // editorSetup | editorAccess | editorComponents | editorThemes
    configEditor: "editorComponents",
    // Usage: ItemListActionToolbrCtnr
    configView: "configItems",
    // configItems | configForm
    // GUI data
    prevSelCategory: "Container",
    // Track prior category selection
    submitButtonDisabled: false
    // Control submit button enabled/disable
  },
  // From ServerIO.js
  // No local state for ServerIO
  // RepoCache.js
  // There are chaces for forms/instances/items/submission and keeping it within RepoCache for now 
  // Builder.js
  // No local state for Builder
  // Constants
  // formPanelHeight = 600;
  // values: whoami? form-clnt | lnch-clnt | auth-clnt | emrt-clnt | chip-clnt
  whoami: "whoami?",
  getEnvVar: null,
  appMeta: null,
  appPalette: null,
  //webpackMode : 'unknown',
  scrollChecked: true,
  // upap: { user:                    {             },
  //         members: [{ account:     {             },
  //                     member:      { type: Owner },
  //                     preference:  {             },
  //                     permissions: {             },
  //                   }]
  //       }
  upap: null
};
const initRuntimeModel = async function() {
  console.log("Model:initRuntimeModel() invoked");
  this.getEnvVar = this.appState.getEnvVar;
  this.upap = this.appState.upap;
  if (this.upap) this.addState("upap");
  this.appPalette = CompConfig();
  this.whoami = this.getEnvVar.APP_CODE;
  if (this.getEnvVar?.locationData?.nav && this.getEnvVar.locationData.nav != "nav?") {
    this.setNav(this.getEnvVar.locationData.nav);
  }
  this.setupUserFormsWithDebounce = debounceWithThrottle(
    this.setupUserForms,
    100,
    0,
    false,
    true
  );
  this.genericHandleButtonClickWithDebounce = debounceWithThrottle(
    this.genericHandleButtonClick,
    700,
    0,
    false,
    true
  );
  if (!this.isWhoamiLaunch()) {
    try {
      await this.metaforms.setupMetaForms();
    } catch (e) {
      console.error("Model:initRuntime() - Exception while setting up meta forms" + e);
      throw e;
    }
  }
  if (!this.appState.appMembers || !this.appState.appMembers.length) {
    console.error(`Model.initRuntime() - Current user IS NOT a subscriber to ${this.getEnvVar.APP_CODE} application.`);
    const msg = `You do not have a permission to use the ${this.getEnvVar.APP_CODE} application `;
    this.appendStateMsg(msg);
    throw msg;
  }
  if (this.isWhoamiForm()) {
    try {
      await this.setupUserForms();
    } catch (e) {
      console.error("Model:initRuntime() - Exception while setting up builder" + e);
    }
  }
  if (this.isWhoamiLaunch()) {
    try {
      await this.setupLaunchForms();
    } catch (e) {
      console.error("Model:initRuntime() - Exception while setting up launcher" + e);
      throw e;
    }
  }
  this.setWorkFlag("configEditor", "editorComponents");
  this.setInit();
  console.log("Model:initRuntimeModel - get current nav: ", this.getNav());
  return true;
};
const isWhoamiLaunch = function() {
  return this.whoami == "LNCH";
};
const isWhoamiForm = function() {
  return this.whoami == "FORM";
};
const isDev = function() {
  return this?.appState?.isDev || false;
};
const setInit = function() {
  return this.state.push("init");
};
const isInit = function() {
  return this.state.includes("init");
};
const addState = function(state) {
  if (this.isState(state)) return;
  this.state.push(state);
};
const removeState = function(state) {
  return this.state.slice(this.state.indexOf(state), 1);
};
const isState = function(state) {
  return this.state.includes(state);
};
const setUpap = function(upap) {
  return this.upap = upap;
};
const getNav = function() {
  return this.nav;
};
const setNav = function(mode) {
  this.nav = mode;
};
const isNavModePreview = function() {
  return this.nav === "preview";
};
const isAuthenticated = function() {
  return this.upap && this.upap.user;
};
const setIOBusy = function(value2) {
  this.dispatch({ type: "SET_IO_BUSY", payload: value2 });
};
const isFormSelected$1 = function() {
  return this.selection.isFormSelected();
};
const getMembers$1 = function(type) {
  let m = null;
  m = this.selection && this.selection.getMembers(type);
  return m;
};
const isAccountOwner = function() {
  const member = this.getMembers("selection");
  return member && member.member?.type?.toLowerCase() === "owner";
};
const currentSubscriptions = function() {
  const subs = this.upap.members.reduce(function(ag, member) {
    const type = member.member.type;
    if (type !== "Owner") return ag;
    const account = member.account;
    const keys = Object.keys(account.jsonProp);
    const keysFl = keys.filter(function(key) {
      return account.jsonProp[key].type;
    });
    const keysStr = keysFl.join(", ");
    ag = ag + keysStr + " ";
    return ag;
  }, "");
  return subs.trim();
};
const isAccountOwnerSubscriber = function() {
  return this.isAccountOwner() && this.currentSubscriptions();
};
const getStateMsg = function() {
  return this.stateMsg;
};
const setStateMsg = function(msg) {
  return this.stateMsg = msg;
};
const appendStateMsg = function(msg) {
  return this.stateMsg = this.stateMsg + "  " + msg;
};
const getResourcePath = function(accountNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  return "/form/assets/uploads/" + accountNo + "/resources/";
};
const getUploadPath = function() {
  const accountNo = this.selected({
    entity: "accounts",
    type: "get",
    action: "prop",
    property: "accountNo"
  });
  const formNo = this.selected({
    entity: "forms",
    type: "get",
    action: "prop",
    property: "formNo"
  });
  return "uploads/" + accountNo + "/" + formNo + "/";
};
const getSubmissionUrl = function(accountNo, formNo, instanceNo) {
  if (!accountNo)
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  if (!formNo)
    formNo = this.selected({
      entity: "forms",
      type: "get",
      action: "prop",
      property: "formNo"
    });
  if (!instanceNo)
    instanceNo = this.selected({
      entity: "instances",
      type: "get",
      action: "prop",
      property: "instanceNo"
    });
  return "accounts/" + accountNo + "/forms/" + formNo + "/versions/" + instanceNo;
};
const getFormUqId = function(accountNo, formNo, instanceNo) {
  if (!accountNo)
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  if (!formNo)
    formNo = this.selected({
      entity: "forms",
      type: "get",
      action: "prop",
      property: "formNo"
    });
  if (!instanceNo)
    instanceNo = this.selected({
      entity: "instances",
      type: "get",
      action: "prop",
      property: "instanceNo"
    });
  return accountNo + "." + formNo + "." + instanceNo;
};
const path = function(itemWgt, type) {
  if (itemWgt === "images") {
    return this.getResourcePath();
  } else {
    return this.getUploadPath();
  }
};
const fullFormDisabled = function() {
  if (this._isMetaFormSubmission()) {
    console.error("Model:fullFormDisabled() - May want to allow editing metaForms");
    return true;
  } else return false;
};
const getRunEnv = function() {
  return this.getEnvVar.RUN_ENV;
};
const getPalette = function() {
  return this.appPalette;
};
const addTracker = function(type) {
  return this.trackChanges.push(type);
};
const clearTracker = function() {
  return this.trackChanges = [];
};
const isTracker = function() {
  return this.trackChanges.length;
};
const isTrackerForms = function() {
  return this.trackChanges.find(function(type) {
    return type.includes("form");
  });
};
const isTrackerInstances = function() {
  return this.trackChanges.find(function(type) {
    return type.includes("instance") || type.includes("instance");
  });
};
const isTrackerItems = function() {
  return this.trackChanges.find(function(type) {
    return type.includes("item");
  });
};
const processFindChildren = function(formtype, formName, parentItem, parentCompositeSeqno) {
  const childSeqnoList = parentItem.child;
  let child = [];
  if (formtype == "User" || formtype == "Raw") {
    if (childSeqnoList.length) {
      const myThis = this;
      child = childSeqnoList.reduce(function(accum, childSeqno) {
        const child2 = myThis.editor.findSelectedItem(childSeqno);
        if (child2 && child2.parent === parentCompositeSeqno) {
          accum.push(child2);
        }
        return accum;
      }, child);
    }
  } else {
    const itemList = this.metaforms.getMetaFormsProperty(formName, "items");
    if (childSeqnoList.length) {
      child = childSeqnoList.reduce(function(accum, childSeqno) {
        const child2 = itemList.find(function(item) {
          return item.seqno == childSeqno;
        });
        if (child2 && child2.parent === parentCompositeSeqno) {
          accum.push(child2);
        }
        return accum;
      }, child);
    }
  }
  return child;
};
const processItems = function(method) {
  this.props.p.items.forEach(function(item) {
    if (item.category === "Basic") {
      method.call(this, item);
    }
  }, this);
};
const formResetHandler = function(e) {
  this.processItems(function(item) {
    item.userProp.newValue = null;
    item.userProp.isVal = true;
    this.getFormDisabledFunction()(true);
  });
};
const getMetaReference = function(property) {
  if (!property) return null;
  console.error("Model:getMetaReference() In cl-form this function not supported");
  return this.getEnvVar.metaReference[property];
};
const setSnackbar = function(msg, variant = "info", duration2 = 4e3) {
  this["snackbarMsg"] = msg;
  this["snackbarDuration"] = duration2;
  this["snackbarVariant"] = variant;
};
const getSnackbarMsg = function() {
  return this["snackbarMsg"];
};
const setSnackbarMsg = function(msg) {
  this["snackbarMsg"] = msg;
};
const getSnackbarDuration = function() {
  return this["snackbarDuration"];
};
const setSnackbarDuration = function(duration2) {
  this["snackbarDuration"] = duration2;
};
const getSnackbarVariant = function() {
  return this["snackbarVariant"];
};
const setSnackbarVariant = function(variant) {
  this["snackbarVariant"] = variant;
};
const label = function(p) {
  let refResults, cursorResults;
  if (this._isFormtypeMeta(p)) {
    if (p.item.userProp.ref) {
      refResults = this._getRefData("label", p.item.userProp.ref);
    }
  }
  if (this._isFormtypeMeta(p)) {
    if (p.item.userProp.cursor) {
      cursorResults = this._getCursorData("label", p.item.userProp.ref);
    }
  }
  return refResults || cursorResults || p.item.userProp.label;
};
const options = function(p) {
  let refResults = null;
  if (this._isFormtypeMeta(p)) {
    if (p.item.userProp.ref) {
      refResults = this._getRefData("options", p.item.userProp.ref);
    }
  }
  return refResults || p.item.userProp.options;
};
const value = function(p) {
  return this._isFormtypeMeta(p) && p.item.userProp.cursor && this._getCursorData("value", p.item.userProp.cursor) || p.item.userProp.value;
};
const setValue = function(p, val) {
  const isValid = this._validateSingleItem(p.item, val);
  this.setSubmitDisabled(!isValid);
  if (this._isFormtypeMeta(p) && p.item.userProp.cursor) {
    this._setCursorData("value", p.item.userProp.cursor, val);
  } else p.item.userProp.value = val;
};
const _handleChangeAndBlur = function(event2, p, item, i, newValue) {
  var temp;
  if (p.item.wgt === "Radio Buttons") {
    return this.setValue(p, event2.target.value);
  } else if (p.item.wgt === "Checkboxes" || p.item.wgt === "Switches") {
    temp = this.value(p) || [];
    temp = temp.filter(function(v) {
      return v !== event2.target.value;
    });
    if (event2.target.checked) {
      temp = temp.concat(event2.target.value);
    }
    return this.setValue(p, temp);
  } else if (p.item.wgt === "OnOff") {
    return this.setValue(p, event2.target.checked);
  } else if (p.item.wgt === "Select List") {
    return this.setValue(p, event2.target.value);
  } else if (p.item.wgt === "Autocomplete Tagger" || p.item.wgt === "Tag Autocomplete") {
    return this.setValue(p, newValue);
  } else {
    return this.setValue(p, event2.target.value);
  }
};
const genericHandleChange = function(event2, p, item, i, newValue) {
  return this._handleChangeAndBlur(event2, p, item, i, newValue);
};
const genericHandleSelection = function(event2, p, item, i) {
  var selected2 = [];
  for (var i = 0; i < event2.target.selectedOptions.length; i++) {
    selected2.push(event2.target.selectedOptions[i].value);
  }
  if (selected2.length > 1) {
    this.setValue(p, event2.target.value);
  } else {
    console.error(
      "genericHandleSelection() - how to set a sinle selection? in array or string ?"
    );
    this.setValue(p, event2.target.value);
  }
};
const genericHandleFile = function(p, event2) {
  if (p.rendertype() === "submit") {
    p.fileHandler(event2);
  }
  var validator = p.validator();
  validator(p, event2.target.value);
};
const genericHandleFocus = function(p, event2) {
  console.log("genericHandleFocus() - occured at : ", event2);
};
const genericHandleBlur = function(event2, p, item, i) {
  return this._handleChangeAndBlur(event2, p, item, i);
};
const genericHandleButtonClick = async function(event2, p, item, i) {
  if (p.item.wgt === CONST.SUBMIT_BUTTON) {
    if (this.isNavModePreview() || p.rendertype() !== "submit") {
      this.setSnackbar("Form submission is not permitted in preview mode.", "warning");
      return;
    }
    this.setSubmitDisabled(true);
    if (p.formtype() === "Service") {
      const isFormValid = this._validateAllItems("metaForm", p.formName());
      if (!isFormValid) {
        return;
      }
      if (p.formName() === "addanapp") {
        await this.serverio.addanapp(p.formName());
      } else if (p.formName() === "invite") {
        await this.serverio.invite(p.formName());
      }
    } else {
      const isFormValid = this._validateAllItems("regForm", null);
      if (!isFormValid) {
        return;
      }
      await this._handleSubmission();
    }
  }
  if (p.item.wgt === CONST.RESET_BUTTON) {
    this._handleReset();
  }
};
const genericCheckDisabled = function(p, item, i) {
  const configMode = this.editor.work({
    entity: "flag",
    type: "get",
    action: "prop",
    property: "configMode"
  });
  if (configMode === "view") return true;
  else {
    return this._checkItemIsDisabled(p);
  }
};
const genericHandleTagChange = function(p, tag, action) {
  let chips = this.value(p);
  if (action == "remove") {
    const i = chips.indexOf(tag);
    if (i != -1) {
      chips.splice(i, 1);
      this.setValue(p, chips);
      return true;
    }
  } else if (action == "add") {
    chips.push(tag);
    this.setValue(p, chips);
    return true;
  }
  return false;
};
const repo$1 = function(param) {
  return this.repocache.repo(param);
};
const selected$1 = function(param) {
  return this.selection?.selected(param);
};
const processDeleteForm$1 = function(form, instance) {
  return this.editor.processDeleteForm(form, instance);
};
const processAccountChange = async function(ndx) {
  this.selected({ entity: "members", type: "set", action: "index", value: ndx });
  this.selected({ entity: "forms", type: "set", value: null });
  this.selected({ entity: "instances", type: "set", value: null });
  this.selected({ entity: "items", type: "set", value: null });
  await this.setupUserFormsWithDebounce();
};
const setupUserForms = async function() {
  this.addState("reset");
  const account = this.selection.selected({ entity: "accounts", type: "get" });
  const resp = await this.repocache.setupUserOrLaunchForms(account, this.isWhoamiLaunch());
  if (resp) {
    throw resp;
  }
  this.selection.setupUserFormsSelection(this.isWhoamiLaunch());
  this.editor.work({
    entity: "flag",
    type: "set",
    action: "prop",
    property: "configMode",
    value: "edit"
  });
  this.addState("init");
};
const setupLaunchForms = async function() {
  this.addState("reset");
  console.log("Model:setupLaunchForms() - get forms for user/launcher +++++++++++++++++++++++");
  const resp = await this.repocache.setupUserOrLaunchForms(null, this.isWhoamiLaunch());
  if (resp) {
    throw resp;
  }
  console.log("Model:setupLaunchForms() - get forms for user/launcher done ++++++++++++++++++++");
  this.selection.setupUserFormsSelection(this.isWhoamiLaunch());
  this.addState("init");
};
const processActiveInstanceNo$1 = function(instanceNo) {
  return this.editor.processActiveInstanceNo(instanceNo);
};
const processWidgetSelection$1 = function(type, category, paletteItem) {
  return this.editor.processWidgetSelection(type, category, paletteItem);
};
const processSave$1 = async function() {
  return await this.editor.processSave();
};
const processInstanceDeleteContinue$1 = async function() {
  return await this.editor.processInstanceDeleteContinue();
};
const processChangeInstance = function(direction) {
  this.itemDeSelection();
  const selectedInstance = this.selected({ entity: "instances", type: "set", action: direction });
  const accountNo = this.selected({
    entity: "accounts",
    type: "get",
    action: "prop",
    property: "accountNo"
  });
  const formNo = this.selected({
    entity: "forms",
    type: "get",
    action: "prop",
    property: "formNo"
  });
  const recentInstance = this.repocache.findRecentInstance(accountNo, formNo);
  if (selectedInstance.instanceNo === recentInstance.instanceNo) {
    this.work({
      entity: "flag",
      type: "set",
      action: "prop",
      property: "configMode",
      value: "edit"
    });
  } else {
    this.work({
      entity: "flag",
      type: "set",
      action: "prop",
      property: "configMode",
      value: "view"
    });
  }
};
const shareForm = function(form, instance) {
  console.log("Model:shareForm - TODO ??? Needs Code");
};
const viewData = function(form, instance) {
  this.selection.changeSelected(form, instance);
  this.setNav("submissions");
};
const editForm = function(form, instance) {
  this.selection.changeSelected(form, instance);
  this.setNav("build");
};
const setSelection = function(form, instance) {
  this.selection.changeSelected(form, instance);
};
const previewForm = function(form, instance) {
  this.selection.changeSelected(form, instance);
  this.setNav("preview");
};
const getSelectedFormURL = function() {
  const accountNo = this.selection.selected({ entity: "accounts", type: "get", action: "prop", property: "accountNo" });
  const formNo = this.selection.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" });
  const launchParam = `?account=${accountNo}&form=${formNo}`;
  const host = this.getEnvVar.LNCH_APP_URL;
  return host + launchParam;
};
const launchForm = function(form, instance) {
  const accountNo = form.accountNo;
  const formNo = form.formNo;
  const launchParam = `?account=${accountNo}&form=${formNo}`;
  const host = this.getEnvVar.LNCH_APP_URL;
  const url = host + launchParam;
  if (typeof window !== "undefined")
    window.open(url, "_blank");
};
const work$1 = function(param) {
  return this.editor?.work(param);
};
const setSubmitDisabled = function(val) {
  this.editor.work({
    entity: "flag",
    type: "set",
    action: "prop",
    property: "submitButtonDisabled",
    value: val
  });
};
const isSubmitDisabled = function() {
  return this.editor?.work({
    entity: "flag",
    type: "get",
    action: "prop",
    property: "submitButtonDisabled"
  });
};
const getWorkWrk = function(type) {
  return this.editor.work({ entity: "wrk", type: "get" });
};
const processMoveSelectedItem$1 = function(direction) {
  return this.editor.processMoveSelectedItem(direction);
};
const resetSelectedItem$1 = function() {
  return this.editor.resetSelectedItem();
};
const itemDeSelection$1 = function() {
  return this.editor.itemDeSelection();
};
const selectItem$1 = function(item) {
  return this.editor.selectItem(item);
};
const itemSelection$1 = function(seqno) {
  return this.editor.itemSelection(seqno);
};
const setConfigViewItems = function(flag) {
  return "configItems" === this.editor.work({
    entity: "flag",
    type: "set",
    action: "prop",
    property: "configView",
    value: flag
  });
};
const isConfigViewItems = function() {
  return "configItems" === this.editor.work({ entity: "flag", type: "get", action: "prop", property: "configView" });
};
const isConfigEditorComponents = function() {
  return "editorComponents" === this.editor.work({ entity: "flag", type: "get", action: "prop", property: "configEditor" });
};
const resetWrk = function() {
  this.editor.work({ entity: "wrk", type: "set", action: "reset" });
};
const resetNail = function() {
  this.editor.work({ entity: "nail", type: "set", action: "reset" });
};
const selectNail$1 = function(seqno, compid) {
  return this.editor.selectNail(seqno, compid);
};
const nailSelection$1 = function(seqno, compid) {
  return this.editor.nailSelection(seqno, compid);
};
const processCutSelectedItem$1 = function() {
  return this.editor.processCutSelectedItem();
};
const processCopySelectedItem$1 = function() {
  return this.editor.processCopySelectedItem();
};
const processPasteSelectedItem$1 = function() {
  return this.editor.processPasteSelectedItem();
};
const processDeleteSelectedItem$1 = function() {
  return this.editor.processDeleteSelectedItem();
};
const deleteSelectedItemFromParent$1 = function() {
  return this.editor.deleteSelectedItemFromParent();
};
const deleteSelectedItemChildren$1 = function() {
  return this.editor.deleteSelectedItemChildren();
};
const processClearAllItems$1 = function() {
  return this.editor.processClearAllItems();
};
const setWorkFlag = function(type, flag) {
  this.editor.work({ entity: "flag", type: "set", action: "prop", property: type, value: flag });
};
const getWorkFlag = function(type) {
  return this.editor.work({ entity: "flag", type: "get", action: "prop", property: type });
};
const isWorkFlag = function(type) {
  return this.editor.work({ entity: "flag", type: "get", action: "prop", property: type });
};
const _isMetaFormSubmission = function() {
  return this.metaforms.isMetaFormSubmission(this.getSubmissionUrl());
};
const getMetaFormsProperty$1 = function(metaName, objType2) {
  return this.metaforms.getMetaFormsProperty(metaName, objType2);
};
const getMetaForms$1 = function(metaName) {
  return this.metaforms.getMetaForms(metaName);
};
const createMetaStructure$1 = function(formtype) {
  return this.metaforms.createMetaStructure(formtype);
};
const processCreateNewForm$1 = function() {
  this.builder.processCreateNewForm();
  this.setNav("build");
};
const createNewInstance$1 = function() {
  return this.builder.createNewInstance();
};
const _convertValidationsToObject = function(valListArray) {
  var valList = valListArray.join(",");
  if (typeof valList === "string") {
    return valList.split(/\,(?![^{\[]*[}\]])/g).reduce(function(validationsObj, validation) {
      var args = validation.split(":");
      var validateMethod = args.shift();
      args = args.map(function(arg2) {
        try {
          return JSON.parse(arg2);
        } catch (e) {
          return arg2;
        }
      });
      validationsObj[validateMethod] = args.length ? args : true;
      return validationsObj;
    }, {});
  }
  return valList || {};
};
const _runRules = function(item, valAllObj, newValue) {
  var results = {
    errors: [],
    failed: [],
    success: []
  };
  if (!validationRules) {
    results.errors.push("No system validation rules found");
    results.failed.push("");
    return results;
  }
  Object.keys(valAllObj).every(function(validationMethod) {
    const func = validationRules[validationMethod];
    if (!validationMethod || !func || typeof func !== "function") {
      results.errors.push("Invalid validation request");
      results.failed.push(validationMethod);
      return;
    }
    var validationResult = null;
    validationResult = func.call(validationRules, newValue, valAllObj[validationMethod]);
    if (typeof validationResult === "string") {
      results.errors.push(validationResult);
      results.failed.push(validationMethod);
    } else if (validationResult == false) {
      results.failed.push(validationMethod);
    } else {
      results.success.push(validationMethod);
    }
    return true;
  });
  return results;
};
const _validateSingleItem = function(item, newValue) {
  item.isError = false;
  item.errorMsg = "";
  if (item.userProp.readonly || item.userProp.disabled || item.category !== "Basic" && item.category !== "Inputs") {
    return true;
  }
  let valAll = [];
  if (item.userProp.isRequired) valAll = ["isRequired"];
  if (item.userProp.valDfltRules && item.userProp.valDfltRules.length) {
    valAll = valAll.concat(item.userProp.valDfltRules);
  }
  if (item.userProp.valUserRules && item.userProp.valUserRules.length) {
    valAll = valAll.concat(item.userProp.valUserRules);
  }
  valAll = [...new Set(valAll)];
  if (valAll.length === 0) {
    return true;
  }
  const valAllObj = this._convertValidationsToObject(valAll);
  var valAllResults = this._runRules(item, valAllObj, newValue);
  item.isError = valAllResults.failed.length !== 0;
  if (valAllResults.failed.length !== 0) {
    const errMsg = valAllResults.errors[0];
    const valUserMsgs = item.userProp.valUserMsgs;
    item.errorMsg = errMsg || valUserMsgs + " (" + valAllResults.failed[0] + ")";
  } else {
    item.errorMsg = null;
  }
  return !item.isError;
};
const _validateAllItems = function(formType, formName) {
  let items;
  let metaFormObj;
  if (formType === "regForm") items = this.selected({ entity: "items", type: "get" });
  else {
    metaFormObj = this.getMetaForms(formName);
    items = metaFormObj.items;
  }
  const myThis = this;
  const result = items.reduce(
    function(accum, item) {
      let val;
      if (formType === "regForm") val = item.userProp.value;
      else
        val = metaFormObj.metaStructure[item.name && item.name.toLowerCase() || item.seqno];
      const isValid = myThis._validateSingleItem(item, val);
      accum.isValid = accum.isValid && isValid;
      return accum;
    },
    { isValid: true }
  );
  return result.isValid;
};
const _hasOwnChildProperty = function(obj, props) {
  if (!obj || !props || !props.length) return false;
  if (props.length == 1) {
    return obj.hasOwnProperty(props[0]);
  } else {
    return obj.hasOwnProperty(props[0]) && this._hasOwnChildProperty(obj[props[0]], props.splice(1));
  }
};
const _setOwnChildProperty = function(obj, props, val) {
  if (!obj || !props || !props.length) return false;
  if (props.length == 1) {
    return obj[props[0]] = val;
  } else {
    return this._setOwnChildProperty(obj[props[0]], props.splice(1), val);
  }
};
const _getOwnChildProperty = function(obj, props) {
  if (!obj || !props || !props.length) return false;
  if (props.length == 1) {
    return obj[props[0]];
  } else {
    return this._getOwnChildProperty(obj[props[0]], props.splice(1));
  }
};
const _getRefData = function(field, ref) {
  if (ref) {
    let refType2 = ref && ref.length > 10 ? ref.substr(11, 4) : "";
    let refKey = ref && ref.length > 10 ? ref.substr(16) : "";
    if (refType2 === "func") {
      if (refKey) {
        console.error("attemt to use $reference.func.xxxx - which is not supporeted");
        return null;
      }
    } else if (refType2 === "data") {
      if (refKey) {
        console.error("Model:_getRefData() Calling getMetaReference() is not supported");
        return this.getMetaReference(refKey);
      }
    }
  }
  return null;
};
const _getCursorData = function(field, cursor2) {
  if (cursor2) {
    return this.checkTarget("get", cursor2, null);
  }
  return null;
};
const _setCursorData = function(field, cursor2, value2) {
  if (cursor2) {
    this.addTracker(cursor2);
    return this.checkTarget("set", cursor2, value2);
  } else return false;
};
const checkTargetItem = function(type, value2, targetPath) {
  let isTargetNeedArray = false;
  let isSourceAsArray = false;
  let paletteObj = null;
  let paletteProp = null;
  let isOwnProp = false;
  const wrk = this.editor.work({ entity: "wrk", type: "get" });
  const targetObj = wrk.item;
  if (targetPath && targetPath.length && targetObj) {
    const paletteItem = this.appPalette.find(function(item) {
      return item.wgt === targetObj.wgt;
    });
    paletteProp = deepCopyJson(paletteItem.prop);
    paletteObj = { userProp: paletteProp };
  }
  if (paletteObj && paletteProp && targetPath && targetPath.length && //this._hasOwnChildProperty(targetObj, targetPath.slice(0))
  this._hasOwnChildProperty(paletteObj, targetPath.slice(0))) {
    isOwnProp = true;
    if (targetPath[1] === "options") {
      isTargetNeedArray = true;
    }
    if (Array.isArray(value2)) {
      isSourceAsArray = true;
    }
  }
  if (type == "set") {
    if (isSourceAsArray) {
      if (isTargetNeedArray) {
        this._setOwnChildProperty(targetObj, targetPath, value2);
      } else {
        this._setOwnChildProperty(targetObj, targetPath, value2[0]);
      }
    } else {
      if (isTargetNeedArray) {
        this._setOwnChildProperty(targetObj, targetPath, [value2]);
      } else {
        this._setOwnChildProperty(targetObj, targetPath, value2);
      }
    }
    this._setOwnChildProperty(targetObj, ["updatedAt"], "PENDING");
    this.addTracker("item.updated");
    return true;
  } else if (type == "get") {
    return this._getOwnChildProperty(targetObj, targetPath);
  } else if (type == "check") {
    return isOwnProp;
  } else {
    console.error(`Module:checkTargetItem() - Invalid type: ${type}`);
    return false;
  }
};
const checkTargetForm = function(type, value2, targetPath) {
  let isTargetNeedArray = false;
  let isSourceAsArray = false;
  const targetObj = this.selected({ entity: "forms", type: "get" });
  if (targetPath[1] === "options") {
    isTargetNeedArray = true;
  }
  if (Array.isArray(value2)) {
    isSourceAsArray = true;
  }
  if (type == "set") {
    if (isSourceAsArray) {
      if (isTargetNeedArray) {
        this._setOwnChildProperty(targetObj, targetPath, value2);
      } else {
        this._setOwnChildProperty(targetObj, targetPath, value2[0]);
      }
    } else {
      if (isTargetNeedArray) {
        this._setOwnChildProperty(targetObj, targetPath, [value2]);
      } else {
        this._setOwnChildProperty(targetObj, targetPath, value2);
      }
    }
    this._setOwnChildProperty(targetObj, ["updatedAt"], "PENDING");
    this.addTracker("item.updated");
    return true;
  } else if (type == "get") {
    return this._getOwnChildProperty(targetObj, targetPath);
  } else if (type == "check") {
    return !!targetObj;
  } else {
    console.error(`Module:checkTargetForm() - Invalid type: ${type}`);
    return false;
  }
};
const checkTargetInstance = function(type, value2, targetPath) {
  let isTargetNeedArray = false;
  let isSourceAsArray = false;
  const targetObj = this.selected({ entity: "instances", type: "get" });
  if (targetPath[1] === "options") {
    isTargetNeedArray = true;
  }
  if (Array.isArray(value2)) {
    isSourceAsArray = true;
  }
  if (type == "set") {
    if (isSourceAsArray) {
      if (isTargetNeedArray) {
        this._setOwnChildProperty(targetObj, targetPath, value2);
      } else {
        this._setOwnChildProperty(targetObj, targetPath, value2[0]);
      }
    } else {
      if (isTargetNeedArray) {
        this._setOwnChildProperty(targetObj, targetPath, [value2]);
      } else {
        this._setOwnChildProperty(targetObj, targetPath, value2);
      }
    }
    this._setOwnChildProperty(targetObj, ["updatedAt"], "PENDING");
    this.addTracker("item.updated");
    return true;
  } else if (type == "get") {
    return this._getOwnChildProperty(targetObj, targetPath);
  } else if (type == "check") {
    return !!targetObj;
  } else {
    console.error(`Module:checkTargetInstance() - Invalid type: ${type}`);
    return false;
  }
};
const checkTarget = function(type, cursor2, value2) {
  let cursorSplit = cursor2.split(".");
  let targetPath = cursorSplit.slice(1, cursorSplit.length);
  if (cursor2.startsWith("$item")) {
    return this.checkTargetItem(type, value2, targetPath);
  } else if (cursor2.startsWith("$form")) {
    return this.checkTargetForm(type, value2, targetPath);
  } else if (cursor2.startsWith("$instance")) {
    return this.checkTargetInstance(type, value2, targetPath);
  } else if (cursor2.startsWith("$addanapp")) {
    return this.checkTargetItem(type, value2, targetPath);
  } else {
    console.error(`Module:checkTarget() - No code found to handle cursor: ${cursor2}`);
  }
};
const _handleSubmission = async function() {
  const form = this.selected({ entity: "forms", type: "get" });
  const instance = this.selected({ entity: "instances", type: "get" });
  const items = this.selected({ entity: "items", type: "get" });
  const submission = new Submission();
  const submissionObj = items.reduce(function(accum, item) {
    const value2 = item.userProp.value || "";
    const child = "$children:" + item.child.join(",");
    const colValue = item.child && item.child.length ? child : value2;
    item.userProp.label || item.seqno;
    accum.setUnqColumn(item.userProp.label, item.seqno, value2 || colValue);
    return accum;
  }, submission);
  submissionObj.setReference(this.getEnvVar.locationData.accountNo, form.formNo, instance.instanceNo);
  submissionObj.setCount(items.length);
  submissionObj.setUserNo(this.upap && this.upap.user && this.upap.user.userNo || -1);
  submissionObj.setName(instance.name);
  submissionObj.compress();
  try {
    const results = await this.serverio.run(
      "submissions",
      "create",
      submissionObj,
      this.getEnvVar.locationData.accountNo,
      form.formNo,
      instance.instanceNo
    );
    this.setSnackbar("Submission successful.", "success");
  } catch (e) {
    console.error("Submission failed ", e);
    this.setSnackbar("Submission failed.", "error");
  }
};
const _handleReset = function() {
  const items = this.selected({ entity: "items", type: "get" });
  items.every(function(item, i, src) {
    if (item.wgt !== CONST.SUBMIT_BUTTON && item.wgt !== CONST.RESET_BUTTON) {
      item.userProp.value = "";
    }
    return true;
  });
  this.setSubmitDisabled(false);
};
const _instanceValidate = function() {
  throw "Needs some code for V2";
};
const _itemValidate = function() {
  throw "needs some code for v2";
};
const _isValidItem = function(item) {
  var items = this.selected({ entity: "items", type: "get" });
  var found = false;
  if (item.wgt === CONST.SUBMIT_BUTTON || item.wgt === CONST.CLEAR_BUTTON) {
    found = items.find(function(existing, i, src) {
      return existing.item === item.wgt;
    });
    if (found) {
      return item.wgt + " is already included in the form. Only one is permitted.";
    } else {
      return null;
    }
  } else if (items.length == 0) {
    if (item.category !== CONST.LAYOUT) {
      return "Please first select a layout and then add components.";
    } else {
      return null;
    }
  }
  return null;
};
const _isFormtypeMeta = function(p) {
  if (!p) return false;
  return p.formtype() !== "User";
};
const _checkItemIsDisabled = function(p) {
  if (p && p.item.wgt === "Submit Button" && this.isSubmitDisabled()) return true;
  const configMode = this.editor.work({
    entity: "flag",
    type: "get",
    action: "prop",
    property: "configMode"
  });
  let rc = p && p.item.userProp.isDisabled || configMode === "view";
  return rc;
};
const getId = function(p, type, addl) {
  const uqid = this.getFormUqId(p.accountNo(), p.formNo(), p.instance.instanceNo);
  if (type === "item") {
    return "item-" + uqid + "-" + p.item.seqno;
  } else if (type === "widget" || type === "id") {
    return "Seq-" + uqid + "-" + p.item.seqno + "-" + p.item.wgt.replace(/ /g, "").toLowerCase();
  } else if (type === "name") {
    return "item-" + uqid + "-" + p.item.seqno;
  } else if (type === "valmsg") {
    return "Seq-" + uqid + "-" + p.item.seqno + "-valmsg";
  } else if (type === "help") {
    return "Seq-" + uqid + "-" + p.item.seqno + "-help";
  } else if (type === "output") {
    return "Seq-" + uqid + "-" + p.item.seqno + "-output";
  } else return "UNKNOWN";
};
const isRealWgtOrRelevantMetaWgt = function(p) {
  if (p.formtype() == "User" || p.formtype() == "Raw") return true;
  if (p.item.category == "Layout" || p.item.category == "Container" || p.item.category == "Informational")
    return true;
  if (p.item.wgt == "Filler" || p.item.wgt == "Reset Button" || p.item.wgt == "Static Text" || p.item.wgt == "Submit Button")
    return true;
  if (p.formtype() == "Meta" && this.appState.account.accountNo !== 1 && // The ability to specify cursor value via Prop Editor is only intended for when creating meta forms.
  // The setting cursor value allows to redirect setting value from form to some other object.
  p.rendertype() === "submit" && p.item.userProp.cursor && (p.item.userProp.cursor === "$item.userProp.cursor" || p.item.userProp.cursor === "$item.userProp.ref")) {
    return false;
  }
  if (p.rendertype() === "submit" && p.item.userProp.cursor && p.item.userProp.cursor.startsWith("$")) {
    let cursor2 = p.item.userProp.cursor;
    return this.checkTarget("check", cursor2, null);
  }
  return false;
};
const setScrollChecked = function(checkedOption) {
  return this.scrollChecked = checkedOption;
};
const getScrollChecked = function() {
  return this.scrollChecked;
};
const modelMethods = {
  initRuntimeModel,
  isWhoamiLaunch,
  isWhoamiForm,
  isDev,
  setInit,
  isInit,
  addState,
  removeState,
  isState,
  setUpap,
  getNav,
  setNav,
  isNavModePreview,
  isAuthenticated,
  setIOBusy,
  isFormSelected: isFormSelected$1,
  getMembers: getMembers$1,
  isAccountOwner,
  currentSubscriptions,
  isAccountOwnerSubscriber,
  getStateMsg,
  setStateMsg,
  appendStateMsg,
  getResourcePath,
  getUploadPath,
  getSubmissionUrl,
  getFormUqId,
  path,
  fullFormDisabled,
  getRunEnv,
  getPalette,
  addTracker,
  clearTracker,
  isTracker,
  isTrackerForms,
  isTrackerInstances,
  isTrackerItems,
  processFindChildren,
  processItems,
  formResetHandler,
  getMetaReference,
  setSnackbar,
  getSnackbarMsg,
  setSnackbarMsg,
  getSnackbarDuration,
  setSnackbarDuration,
  getSnackbarVariant,
  setSnackbarVariant,
  label,
  options,
  value,
  setValue,
  _handleChangeAndBlur,
  genericHandleChange,
  genericHandleSelection,
  genericHandleFile,
  genericHandleFocus,
  genericHandleBlur,
  genericHandleButtonClick,
  genericCheckDisabled,
  genericHandleTagChange,
  repo: repo$1,
  selected: selected$1,
  processDeleteForm: processDeleteForm$1,
  processAccountChange,
  setupUserForms,
  setupLaunchForms,
  processActiveInstanceNo: processActiveInstanceNo$1,
  processWidgetSelection: processWidgetSelection$1,
  processSave: processSave$1,
  processInstanceDeleteContinue: processInstanceDeleteContinue$1,
  processChangeInstance,
  shareForm,
  viewData,
  editForm,
  setSelection,
  previewForm,
  getSelectedFormURL,
  launchForm,
  work: work$1,
  setSubmitDisabled,
  isSubmitDisabled,
  getWorkWrk,
  processMoveSelectedItem: processMoveSelectedItem$1,
  resetSelectedItem: resetSelectedItem$1,
  itemDeSelection: itemDeSelection$1,
  selectItem: selectItem$1,
  itemSelection: itemSelection$1,
  setConfigViewItems,
  isConfigViewItems,
  isConfigEditorComponents,
  resetWrk,
  resetNail,
  selectNail: selectNail$1,
  nailSelection: nailSelection$1,
  processCutSelectedItem: processCutSelectedItem$1,
  processCopySelectedItem: processCopySelectedItem$1,
  processPasteSelectedItem: processPasteSelectedItem$1,
  processDeleteSelectedItem: processDeleteSelectedItem$1,
  deleteSelectedItemFromParent: deleteSelectedItemFromParent$1,
  deleteSelectedItemChildren: deleteSelectedItemChildren$1,
  processClearAllItems: processClearAllItems$1,
  setWorkFlag,
  getWorkFlag,
  isWorkFlag,
  _isMetaFormSubmission,
  getMetaFormsProperty: getMetaFormsProperty$1,
  getMetaForms: getMetaForms$1,
  createMetaStructure: createMetaStructure$1,
  processCreateNewForm: processCreateNewForm$1,
  createNewInstance: createNewInstance$1,
  _convertValidationsToObject,
  _runRules,
  _validateSingleItem,
  _validateAllItems,
  _hasOwnChildProperty,
  _setOwnChildProperty,
  _getOwnChildProperty,
  _getRefData,
  _getCursorData,
  _setCursorData,
  checkTargetItem,
  checkTargetForm,
  checkTargetInstance,
  checkTarget,
  _handleSubmission,
  _handleReset,
  _instanceValidate,
  _itemValidate,
  _isValidItem,
  _isFormtypeMeta,
  _checkItemIsDisabled,
  getId,
  isRealWgtOrRelevantMetaWgt,
  setScrollChecked,
  getScrollChecked
};
const selectionProps = {
  selectedForm: {},
  // Used by selected()
  selectedInstance: {},
  // Used by selected()
  selectedItems: [],
  // Used by selected()
  upapMemberNdx: -1
  // Ndx into current Account/Permissions/Preferences
};
async function initRuntimeSelection() {
  console.log("Selection:initRuntimeSelection() invoked");
  this.selection.upapMemberNdx = this.appState.memberNdx;
}
function selected({ entity, ...rest }) {
  if (entity === "users") {
    return this.selection.selectedUsers(rest);
  } else if (entity === "members") {
    return this.selection.selectedMembers(rest);
  } else if (entity === "permissions") {
    return this.selection.selectedPermissions(rest);
  } else if (entity === "preferences") {
    return this.selection.selectedPreferences(rest);
  } else if (entity === "accounts") {
    return this.selection.selectedAccounts(rest);
  } else if (entity === "forms") {
    return this.selection.selectedForms(rest);
  } else if (entity === "instances") {
    return this.selection.selectedInstances(rest);
  } else if (entity === "items") {
    return this.selection.selectedItemsFn(rest);
  }
}
function selectedUsers(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.upap.user;
      case "prop":
        return this.upap.user[property];
    }
  }
}
function selectedMembers(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.upap.members[this.selection.upapMemberNdx].member;
      case "prop":
        return this.upap.members[this.selection.upapMemberNdx].member[property];
      case "index":
        return this.selection.upapMemberNdx;
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        break;
      case "index":
        this.selection.upapMemberNdx = value2;
        break;
    }
  }
}
function selectedPermissions(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.upap.members[this.selection.upapMemberNdx].permissions;
      case "prop":
        return this.upap.members[this.selection.upapMemberNdx].permissions[property];
      case "index":
        return this.selection.upapMemberNdx;
    }
  }
}
function selectedPreferences(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.upap.members[this.selection.upapMemberNdx].preferences;
      case "prop":
        return this.upap.members[this.selection.upapMemberNdx].preferences[property];
      case "index":
        return this.selection.upapMemberNdx;
    }
  }
}
function selectedAccounts(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this?.upap?.members[this.selection.upapMemberNdx].account;
      case "prop":
        return this.upap && this.upap.members && this.upap.members[this.selection.upapMemberNdx].account[property] || "";
      case "index":
        return this.selection.upapMemberNdx;
    }
  }
}
function selectedForms(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.selection.selectedForm;
      case "prop":
        return this.selection.selectedForm && this.selection.selectedForm[property] || null;
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        this.selection.selectedForm = value2;
        break;
      case "prop":
        this.selection.selectedForm[property] = value2;
        this.selection.selectedForm["updatedAt"] = "PENDING";
        break;
    }
  }
}
function selectedInstances(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.selection.selectedInstance;
      case "prop":
        return this.selection.selectedInstance && this.selection.selectedInstance[property] || null;
      case "index":
        let currentInstanceNo = this.selection.selectedInstance.instanceNo;
        let currentInstanceIndex;
        const allInstances = this.repocache.repo({ entity: "instances", type: "get" });
        allInstances.find((instance, i, src) => {
          if (instance.instanceNo === currentInstanceNo) {
            currentInstanceIndex = i;
            return true;
          }
        });
        return currentInstanceIndex;
    }
  } else if (type === "set") {
    let allInstances = null;
    let items = null;
    switch (action) {
      case "":
        this.selection.selectedInstance = value2;
        break;
      case "prop":
        return this.selection.selectedInstance[property] = value2;
      case "index":
        break;
      case "next":
      case "prev":
        let currentInstanceNo = this.selection.selectedInstance.instanceNo;
        allInstances = this.repocache.repo({ entity: "instances", type: "get" });
        const count = allInstances.length;
        let currentInstanceIndex;
        allInstances.find((instance, i, src) => {
          if (instance.instanceNo === currentInstanceNo) {
            currentInstanceIndex = i;
            return true;
          }
        });
        let currentInstance = allInstances[currentInstanceIndex];
        const accountNo = this.selection.selected({
          entity: "accounts",
          type: "get",
          action: "prop",
          property: "accountNo"
        });
        const formNo = this.selection.selected({
          entity: "forms",
          type: "get",
          action: "prop",
          property: "formNo"
        });
        let newInstance;
        if (action == "next") {
          if (currentInstanceIndex + 1 > count - 1) return currentInstance;
          const nextIndex = currentInstanceIndex + 1;
          newInstance = allInstances[nextIndex];
          this.selection.selectedInstance = newInstance;
          items = this.repocache.repo({
            entity: "items",
            type: "get",
            action: "recent",
            accountNo,
            formNo,
            instanceNo: newInstance.instanceNo
          });
          this.selection.selectedItems = items;
        }
        if (action == "prev") {
          if (currentInstanceIndex - 1 < 0) return currentInstance;
          const prevIndex = currentInstanceIndex - 1;
          newInstance = allInstances[prevIndex];
          this.selection.selectedInstance = newInstance;
          items = this.repocache.repo({
            entity: "items",
            type: "get",
            action: "recent",
            accountNo,
            formNo,
            instanceNo: newInstance.instanceNo
          });
          this.selection.selectedItems = items;
        }
        return newInstance;
    }
  }
}
function selectedItemsFn(param) {
  let { type, action = "", property, value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.selection.selectedItems;
      case "prop":
        return null;
      case "index":
        let ndx;
        this.selection.selectedItems.find((item2, i, src) => {
          if (item2.seqno === value2) {
            ndx = i;
            return true;
          }
        });
        return ndx;
      case "specific":
        const item = this.selection.selectedItems.find((item2) => {
          return item2.seqno == value2;
        });
        return item;
      case "nextseqno":
        const accountNo = this.selection.selected({
          entity: "accounts",
          type: "get",
          action: "prop",
          property: "accountNo"
        });
        const formNo = this.selection.selected({
          entity: "forms",
          type: "get",
          action: "prop",
          property: "formNo"
        });
        return this.repocache.findNextSeqno(accountNo, formNo);
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        this.selection.selectedItems = value2;
        break;
      case "prop":
        break;
      case "add":
        this.selection.selectedItems.push(value2);
        break;
      case "remove":
        value2.deletedAt = "PENDING";
        break;
      case "clear":
        const items = this.selection.selectedItems;
        const root = items.find((item) => {
          return item.seqno == CONST.ROOT_SEQNO;
        });
        this.selection.selectedItems = [root];
        break;
    }
  }
}
function isFormSelected() {
  return !!this.selection.selectedForm;
}
function getMembers(type) {
  const members = this.repocache && this.repocache.repo({ entity: "members", type: "get" }) || null;
  if (!members || members.length == 0) return null;
  if (type === "selection") {
    const upapMemberNdx = this.selection.selected({ entity: "members", type: "get", action: "index" });
    return members[upapMemberNdx];
  } else if (type === "accountCode") {
    const upapMemberNdx = this.selection.selected({ entity: "members", type: "get", action: "index" });
    const accountCode = members[upapMemberNdx].account.accountCode || members[upapMemberNdx].account.accountNo;
    return accountCode;
  } else if (type === "all") {
    return members;
  }
}
function changeSelected(form, instance) {
  const account = this.upap.members[this.selection.upapMemberNdx].account;
  const accountNo = account.accountNo;
  const formNo = form.formNo;
  const instanceNo = instance.instanceNo;
  const items = this.repocache.repo({
    entity: "items",
    type: "get",
    action: "recent",
    accountNo,
    formNo,
    instanceNo
  });
  this.selection.selected({ entity: "forms", type: "set", value: form });
  this.selection.selected({ entity: "instances", type: "set", value: instance });
  this.selection.selected({ entity: "items", type: "set", value: items });
}
function setupUserFormsSelection(launchForm2) {
  let account, accountNo, form, formNo, instance, instanceNo, items;
  if (launchForm2) {
    if (this.getEnvVar.locationData.accountNo) ;
    if (this.getEnvVar.locationData.formNo) ;
    accountNo = Number(this.getEnvVar.locationData.accountNo);
    formNo = Number(this.getEnvVar.locationData.formNo);
    form = this.repocache.repo({
      entity: "forms",
      type: "get",
      action: "specific",
      value: formNo,
      accountNo
    });
    if (!form) {
      console.info(
        "Selection:setupUserFormsSelection() - Launch - Form not available : " + formNo
      );
      this.appendStateMsg("Form not available.");
      return;
    }
    instance = this.repocache.repo({
      entity: "instances",
      type: "get",
      action: "per-form",
      accountNo,
      value: form
    });
    if (!instance) {
      console.info(
        "Selection:setupUserFormsSelection() - Launch instance not found for form : " + formNo
      );
      this.appendStateMsg("Launch time unable to access repo data for instance.");
      return;
    }
    instanceNo = instance.instanceNo;
    items = this.repocache.repo({
      entity: "items",
      type: "get",
      action: "recent",
      accountNo,
      formNo,
      instanceNo
    });
    if (!items || !items.length) {
      console.info(
        "Selection:setupUserFormsSelection() - Launch items not found for form/instance : " + formNo + "/" + instanceNo
      );
      this.appendStateMsg("Form not available - missing items.");
      return;
    }
  } else {
    account = this.selection.selected({ entity: "accounts", type: "get" });
    accountNo = account.accountNo;
    form = this.repocache.repo({
      entity: "forms",
      type: "get",
      action: "recent",
      accountNo
    });
    if (!form) {
      console.info("Forms library is empty.");
      this.setSnackbar("Forms library is empty.", "info");
      return;
    } else {
      console.info("Forms Library loaded.");
      this.setSnackbar("Forms library loaded.", "info");
    }
    formNo = form.formNo;
    instance = this.repocache.repo({
      entity: "instances",
      type: "get",
      action: "recent",
      accountNo,
      formNo
    });
    if (!instance) {
      console.info("Build time unable to access repo data for instance.");
      this.setSnackbar("Build time unable to access repo data for instance.", "error");
      return;
    }
    instanceNo = instance.instanceNo;
    items = this.repocache.repo({
      entity: "items",
      type: "get",
      action: "recent",
      accountNo,
      formNo,
      instanceNo
    });
    if (!items || !items.length) {
      console.error("Form not available - missing form items.");
      this.setSnackbar("Form not available - missing form items.", "error");
      return;
    }
  }
  this.selection.selected({ entity: "forms", type: "set", value: form });
  this.selection.selected({ entity: "instances", type: "set", value: instance });
  this.selection.selected({ entity: "items", type: "set", value: items });
}
const selectionMethods = {
  initRuntimeSelection,
  selected,
  selectedUsers,
  selectedMembers,
  selectedPermissions,
  selectedPreferences,
  selectedAccounts,
  selectedForms,
  selectedInstances,
  selectedItemsFn,
  isFormSelected,
  getMembers,
  changeSelected,
  setupUserFormsSelection
};
const localMetaForms = [
  { "formtype": "Meta", "name": "item", "formNo": "1", "instanceNo": "1" },
  { "formtype": "Meta", "name": "form", "formNo": "2", "instanceNo": "1" },
  // commented out as we do not use these and instead using AUTHENTIK
  //  { "formtype": "Meta", "name": "signin", "formNo": "3", "instanceNo": "1" },
  //  { "formtype": "Service", "name": "signup", "formNo": "4", "instanceNo": "1" },
  //  { "formtype": "Service", "name": "forgot", "formNo": "5", "instanceNo": "1" },
  //  { "formtype": "Service", "name": "changeid", "formNo": "6", "instanceNo": "1" },
  //  { "formtype": "Service", "name": "changepwd", "formNo": "7", "instanceNo": "1" },
  //  { "formtype": "Service", "name": "reverify", "formNo": "8", "instanceNo": "1" },
  { "formtype": "Service", "name": "invite", "formNo": "9", "instanceNo": "2" },
  { "formtype": "Service", "name": "addanapp", "formNo": "10", "instanceNo": "1" },
  {
    "formtype": "List",
    "name": "invites",
    "formNo": "",
    "instanceNo": "",
    "table": "invites",
    "title": "Invites",
    "includes": {
      "id": "ID",
      "status": "Status",
      "type": "Type",
      "email": "Email",
      "first": "First",
      "last": "Last",
      "tele": "Telephone",
      "application": "Application",
      "test": "Test",
      "createdAt": "Created",
      "updatedAt": "Updated"
    }
  },
  {
    "formtype": "List",
    "name": "members",
    "formNo": "",
    "instanceNo": "",
    "table": "members",
    "title": "Members",
    "includes": {
      "id": "ID",
      "status": "Status",
      "type": "Type",
      "comment": "Comment",
      "tags": "Tags",
      "createdAt": "Created",
      "updatedAt": "Updated"
    }
  }
];
const metaformsProps = {
  metaForms: {}
  // metaForms has fixed forms/instances/items and modifiable structures. The FIXED stuff need not be in the mobx space. TODO ???
};
async function initRuntimeMetaforms() {
  console.log("MetaForms:initRuntime() - invoked");
}
async function _getMetaForms() {
  const bundleResults = await this.serverio.getBundle(1, null);
  let items = cleanInboundItems(bundleResults.items);
  console.log("YSYSYSYSYSYSYSYSYS ----- migration code changed - review it :  cl-form/meta/models/MetaForms.js");
  const results = {
    account: bundleResults.accounts[0],
    forms: bundleResults.forms,
    instances: bundleResults.instances,
    items
  };
  return results;
}
async function setupMetaForms() {
  let metaFormsData;
  try {
    metaFormsData = await this.metaforms._getMetaForms();
  } catch (e) {
    const msg = `Error in getMetaForms (code = ${e.code}) - `;
    if (e && e.code && (e.code == 400 || e.code == 400)) {
      this.appendStateMsg(msg + e.message || "No Exception message");
    } else if (e && e.code && e.code == 500) {
      this.appendStateMsg(msg + "Service not available. Please contact system support...");
    } else {
      this.appendStateMsg(msg + e + " - Please contact system support...");
    }
    throw e;
  }
  const account = metaFormsData.account;
  const accountNo = account.accountNo;
  const metaFormList = localMetaForms.map((formSpec, i) => {
    const formtype = formSpec.formtype;
    const metaName = formSpec.name;
    const metaFormNo = formSpec.formNo;
    const metaInstanceNo = formSpec.instanceNo;
    let form = null, instance = null, itemList = null;
    if (formtype === "Meta" || formtype === "Service" || formtype === "Record") {
      form = metaFormsData.forms.find((form2) => {
        return form2.accountNo == accountNo && form2.formNo == metaFormNo;
      });
      if (!form) {
        this.appendStateMsg("Meta Form not available...");
        return null;
      }
      form.formNo;
      instance = metaFormsData.instances.find((instance2) => {
        return instance2.accountNo == accountNo && instance2.formNo == metaFormNo && instance2.instanceNo == metaInstanceNo;
      });
      if (!instance) {
        this.appendStateMsg("Meta Form not available - missing instances...");
        return null;
      }
      instance.instanceNo;
      itemList = metaFormsData.items.filter((item) => {
        return item.accountNo == account.accountNo && item.formNo == form.formNo && item.instanceNo == instance.instanceNo;
      });
      if (!itemList || itemList.length == 0) {
        this.appendStateMsg("Meta Form not available - missing items...");
        return null;
      }
    }
    const meta = { ...formSpec, id: metaName, forms: form, instances: instance, items: itemList };
    return meta;
  });
  this.metaforms.metaForms = metaFormList.reduce((accumulator, value2) => {
    if (!value2) return accumulator;
    accumulator[value2.id] = value2;
    return accumulator;
  }, {});
  this.metaforms.metaForms.account = account;
}
function getMetaFormsProperty(metaName, prop) {
  const metaFormObj = this.metaforms.metaForms[metaName];
  if (!metaFormObj) throw `Invalid metaName(${metaName}) or objType(${objType})`;
  return metaFormObj[prop];
}
function getMetaForms(metaName) {
  const metaFormObj = this.metaforms.metaForms[metaName];
  if (!metaFormObj) throw `Invalid metaName(${metaName}) or objType(${objType})`;
  return metaFormObj;
}
function isMetaFormSubmission(url) {
  let path2 = url.split("/");
  return path2[1] === 1;
}
function getMetaFormStructure(formName) {
  const metaFormObj = this.metaforms.metaForms[formName];
  if (!metaFormObj) {
    throw Error(`Invalid meta form (${formName})`);
  }
  return createMetaStructure(formName);
}
async function createMetaStructure(formName) {
  const metaFormObj = this.metaforms.metaForms[formName];
  if (!metaFormObj) {
    throw Error(`Referencing invalid meta form (${formName})`);
  }
  if (metaFormObj.formtype === "List") {
    return;
  }
  const metaStructure = {};
  metaFormObj.metaStructure = metaFormObj.items.reduce((accum, item) => {
    const value2 = item.userProp && item.userProp.value || "";
    const colValue = item.children && item.children.length ? item.children.join(",") : value2;
    const colName = item.name && item.name.toLowerCase() || item.seqno;
    accum[colName] = value2 || colValue;
    return accum;
  }, metaStructure);
  return metaFormObj.metaStructure;
}
const metaformsMethods = {
  initRuntimeMetaforms,
  _getMetaForms,
  setupMetaForms,
  getMetaFormsProperty,
  getMetaForms,
  isMetaFormSubmission,
  getMetaFormStructure,
  createMetaStructure
};
const editorProps = {
  // Wrk/Cut/Copy is gradually using seqno and discarding use of id as of V2
  workWrk: { item: null, id: -1, seqno: -1 },
  workCut: { item: null, id: -1, seqno: -1 },
  workCopy: { item: null, id: -1, seqno: -1 },
  workNail: { item: null, id: -1, seqno: -1, compId: "", ctr: 0 },
  workFlags: {
    // Track instance editability : 'view' / 'edit'
    // Highest instanceNo is editable and all others are view only
    configMode: "view",
    // editorSetup | editorAccess | editorComponents | editorThemes
    configEditor: "editorComponents",
    // Usage: ItemListActionToolbrCtnr
    configView: "configItems",
    // configItems | configForm
    // GUI data
    prevSelCategory: "Container",
    // Track prior category selection
    submitButtonDisabled: false
    // Control submit button enabled/disable
  },
  cutWorkingOffsprings: [],
  redo: []
};
async function initRuntimeEditor() {
  console.log("Editor:initRuntime() invoked");
}
function _unselectItem(wrk) {
  console.log("item:unselectItem() for item seqno : " + wrk.seqno);
  if (wrk.seqno == -1) return;
  const item = this.selection.selected({
    entity: "items",
    type: "get",
    action: "specific",
    value: wrk.seqno
  });
  this.selection.selected({ entity: "items", type: "get" });
  if (wrk.seqno != -1) {
    console.log(
      "item:unselectItem() did it for item seqno: " + item.seqno + ", class:" + item.wgtHiliteClass
    );
    item.wgtHiliteClass = "";
  }
  wrk.seqno = -1;
}
function _deleteItemFromParent(item) {
  if (!item.parent) return;
  var parent = item.parent;
  var parentSeqno = parent.substring(0, parent.indexOf("-"));
  var parentItem = this.selection.selected({
    entity: "items",
    type: "get",
    action: "specific",
    value: parentSeqno
  });
  parentItem && parentItem.child.every((childSeqno, i, src) => {
    if (childSeqno == item.seqno) {
      src.splice(i, 1);
    }
    return true;
  });
  parentItem.updatedAt = "PENDING";
  this.addTracker("item.updated");
}
function _cutOffsprings(parent) {
  parent.deletedAt = "PENDING";
  const childSeqnoList = parent.child;
  if (childSeqnoList.length) {
    childSeqnoList.forEach((childSeqno, i, src) => {
      const child = this.editor.findSelectedItem(childSeqno);
      child.deletedAt = "PENDING";
      this.selection.selected({
        entity: "items",
        type: "set",
        action: "remove",
        value: child
      });
    });
  }
  return parent;
}
function _addChild(item) {
  var nail = this.editor.work({ entity: "nail", type: "get" });
  if (nail.seqno > -1) {
    const childCopy = nail.item.child.slice();
    childCopy.push(item.seqno);
    nail.item.child = childCopy;
    nail.item.updatedAt = "PENDING";
    this.addTracker("item.updated");
  }
}
function replaceChild(parent, oldSeqno, newSeqno, child) {
  var i = _.indexOf(parent.child, oldSeqno);
  if (i != -1) {
    parent.child[i] = newSeqno;
    var compId = child.parent.substring(child.parent.indexOf("-"));
    var parentId = parent.seqno + compId;
    child.parent = parentId;
  }
}
function _addItem(item) {
  var parent = "";
  var nail = this.editor.work({ entity: "nail", type: "get" });
  if (nail.seqno > -1) {
    parent = nail.seqno + "-" + nail.compId;
  }
  item.wgtHiliteClass = "";
  item.nailedHiliteClass = "";
  item.parent = parent;
  this.selection.selected({ entity: "items", type: "set", action: "add", value: item });
  this.repocache.repo({ entity: "items", type: "set", action: "add", value: [item] });
  this.editor._addChild(item);
}
function _addItemAndOffsprings(item, offsprings) {
  var rc = this.editor._addItem(item);
  offsprings && offsprings.every((item2, i, src) => {
    item2.updatedAt = null;
    item2.deletedAt = null;
    this.selection.selected({ entity: "items", type: "set", action: "add", value: item2 });
    return true;
  });
  return rc;
}
function _cloneItem(item, seqno) {
  var dupItem = deepCopyJson(item);
  dupItem.seqno = seqno;
  return dupItem;
}
function _cloneOffsprings(parent, nextSeqno, parentSeqno) {
  let cloneParent;
  cloneParent = this.editor._cloneItem(parent, nextSeqno);
  cloneParent.parent = parentSeqno;
  cloneParent.id = null;
  cloneParent.updatedAt = null;
  cloneParent.createdAt = "PENDING";
  cloneParent.child;
  if (cloneParent.child.length) {
    cloneParent.child = cloneParent.child.map((childSeqno, i, src) => {
      const child = this.editor.findSelectedItem(childSeqno);
      const childParentSeqnoSuffix = child.parent.substring(child.parent.indexOf("-"));
      const cloneChild = this.editor._cloneOffsprings(
        child,
        ++nextSeqno,
        "" + cloneParent.seqno + childParentSeqnoSuffix
      );
      const cloneChildSeqno = cloneChild.seqno;
      return cloneChildSeqno;
    });
  }
  this.repocache.repo({ entity: "items", type: "set", action: "add", value: [cloneParent] });
  this.selection.selected({ entity: "items", type: "set", action: "add", value: cloneParent });
  return cloneParent;
}
function _deleteItemChildren(item) {
  if (item.child.length == 0) return;
  item.child.every((childSeqno, id, src) => {
    const child = this.editor.findSelectedItem(childSeqno);
    this.selection.selected({ entity: "items", type: "set", action: "remove", value: child });
    return true;
  });
  item.child = [];
}
function work(param) {
  let { entity, type, action = "", property, value: value2 } = param;
  switch (entity) {
    case "wrk":
      if (type === "get") {
        switch (action) {
          case "":
            return this.editor.workWrk;
          case "prop":
            return this.editor.workWrk[property];
        }
      } else if (type === "set") {
        switch (action) {
          case "":
            Object.assign(this.editor.workWrk, value2);
            break;
          case "prop":
            this.editor.workWrk[property] = value2;
            break;
          case "reset":
            this.editor.workWrk.item = null;
            this.editor.workWrk.seqno = -1;
            break;
        }
      }
      break;
    case "cut":
      if (type === "get") {
        switch (action) {
          case "":
            return this.editor.workCut;
          case "prop":
            return this.editor.workCut[property];
        }
      } else if (type === "set") {
        switch (action) {
          case "":
            Object.assign(this.editor.workCut, value2);
            break;
          case "prop":
            this.editor.workCut[property] = value2;
            break;
          case "reset":
            this.editor.workCut.item = null;
            this.editor.workCut.seqno = -1;
            break;
        }
      }
      break;
    case "copy":
      if (type === "get") {
        switch (action) {
          case "":
            return this.editor.workCopy;
          case "prop":
            return this.editor.workCopy[property];
        }
      } else if (type === "set") {
        switch (action) {
          case "":
            Object.assign(this.editor.workCopy, value2);
            break;
          case "prop":
            this.editor.workCopy[property] = value2;
            break;
          case "reset":
            this.editor.workCopy.item = null;
            this.editor.workCopy.seqno = -1;
            break;
        }
      }
      break;
    case "nail":
      if (type === "get") {
        switch (action) {
          case "":
            return this.editor.workNail;
          case "prop":
            return this.editor.workNail[property];
        }
      } else if (type === "set") {
        switch (action) {
          case "":
            Object.assign(this.editor.workNail, value2);
            break;
          case "prop":
            this.editor.workNail[property] = value2;
            break;
          case "reset":
            if (this.editor.workNail.item) this.editor.workNail.item.nailedHiliteClass = "";
            this.editor.workNail.item = null;
            this.editor.workNail.seqno = -1;
            this.editor.workNail.compId = "";
            this.editor.workNail.ctr = 0;
            break;
        }
      }
      break;
    case "flag":
      if (type === "get") {
        switch (action) {
          case "":
            return this.editor.workFlags;
          case "prop":
            return this.editor.workFlags[property];
        }
      } else if (type === "set") {
        switch (action) {
          case "":
            Object.assign(this.editor.workFlags, value2);
            break;
          case "prop":
            this.editor.workFlags[property] = value2;
            break;
        }
      }
      break;
  }
}
function findSelectedItem(seqno) {
  var items = this.selection.selected({ entity: "items", type: "get" });
  var item = items.find((item2, i, src) => {
    return item2.seqno == seqno;
  });
  return item;
}
function processMoveSelectedItem(direction) {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  if (wrk.seqno == -1) return;
  const itemA = wrk.item;
  const parentCompositeSeqno = itemA.parent;
  const itemASeqno = itemA.seqno;
  if (parentCompositeSeqno) {
    const parentSeqno = parentCompositeSeqno.substring(0, parentCompositeSeqno.indexOf("-"));
    parentCompositeSeqno.substring(
      parentCompositeSeqno.indexOf("-") + 1
    );
    const parentItem = this.selection.selected({
      entity: "items",
      type: "get",
      action: "specific",
      value: parentSeqno
    });
    const child = this.processFindChildren("User", "user", parentItem, parentCompositeSeqno);
    child.length;
    const childLocation = child.reduce((accum, child2, i) => {
      if (child2.seqno === itemA.seqno) {
        accum = i;
      }
      return accum;
    }, -1);
    if (direction == "up" && childLocation > 0 || direction == "down" && childLocation < child.length - 1) {
      let itemATargetLocation = -1;
      let itemACurrentLocation = parentItem.child.indexOf(itemASeqno);
      if (direction == "up") {
        itemATargetLocation = itemACurrentLocation - 1;
        wrk.seqno = itemASeqno;
      } else {
        itemATargetLocation = itemACurrentLocation + 1;
        wrk.seqno = itemASeqno;
      }
      const itemBSeqno = parentItem.child[itemATargetLocation];
      parentItem.child[itemACurrentLocation] = itemBSeqno;
      parentItem.child[itemATargetLocation] = itemASeqno;
      parentItem.updatedAt = "PENDING";
      this.addTracker("item.updated");
    }
  }
  this.addTracker("item.move");
}
function resetSelectedItem() {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  wrk.seqno = -1;
  wrk.item = null;
}
function itemDeSelection() {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  this.editor._unselectItem(wrk);
  wrk.seqno = -1;
  wrk.item = null;
}
function selectItem(item) {
  if (item != null) {
    item.wgtHiliteClass = CONST.ITEM_HILITE_CLASS;
  }
}
function itemSelection(seqno) {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  if (wrk.seqno != -1) {
    console.log(
      "Builder:selectNewItem- need to unselect the currently set item seqno :" + wrk.item.seqno
    );
  }
  wrk.seqno;
  this.editor._unselectItem(wrk);
  const item = this.selection.selected({
    entity: "items",
    type: "get",
    action: "specific",
    value: seqno
  });
  if (item) {
    wrk.seqno = item.seqno;
    wrk.item = item;
    this.editor.selectItem(wrk.item);
  } else {
    console.log(
      "Builder:selectNewItem- no selected item exists"
    );
  }
}
function selectNail(seqno, compid) {
  this.selection.selected({ entity: "items", type: "get" });
  var nail = this.editor.work({ entity: "nail", type: "get" });
  var itemid = -1;
  if (nail.seqno > -1) {
    nail.item.nailedHiliteClass = "";
  }
  const item = this.selection.selected({
    entity: "items",
    type: "get",
    action: "specific",
    value: seqno
  });
  nail.ctr = nail.ctr + 1;
  if (nail.seqno == seqno) {
    nail.seqno = -1;
    nail.id = -1;
    nail.compId = -1;
    item.nailedHiliteClass = "";
    item.nailedHiliteCompId = "";
  } else {
    nail.seqno = seqno;
    nail.id = itemid;
    nail.compId = compid;
    nail.item = item;
    item.nailedHiliteClass = CONST.NAILED_HILITE_CLASS;
    item.nailedHiliteCompId = compid;
  }
}
function nailSelection(seqno, compid) {
  const configMode = this.editor.work({
    entity: "flag",
    type: "get",
    action: "prop",
    property: "configMode"
  });
  if (configMode === "edit") {
    this.editor.selectNail(seqno, compid);
  } else {
    this.setSnackbar("Earlier versions are not editable.", "warning");
  }
}
function processCutSelectedItem() {
  var cut = this.editor.work({ entity: "cut", type: "get" });
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  if (wrk.item.parent) {
    this.editor._deleteItemFromParent(wrk.item);
  }
  this.editor._cutOffsprings(wrk.item);
  wrk.item.deletedAt = "PENDING";
  this.selection.selected({ entity: "items", type: "set", action: "remove", value: wrk.item });
  cut.item = wrk.item;
  cut.seqno = wrk.item.seqno;
  wrk.seqno = -1;
  wrk.item = null;
  this.editor.work({ entity: "nail", type: "set", action: "reset" });
  this.addTracker("item.cut");
}
function processCopySelectedItem() {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  var copy = this.editor.work({ entity: "copy", type: "get" });
  copy.item = wrk.item;
  copy.seqno = wrk.item.seqno;
  this.editor.work({ entity: "nail", type: "set", action: "reset" });
}
function processPasteSelectedItem() {
  var cut = this.editor.work({ entity: "cut", type: "get" });
  var copy = this.editor.work({ entity: "copy", type: "get" });
  var rc;
  if (cut.item) {
    rc = this.editor._addItemAndOffsprings(cut.item, this.editor.cutWorkingOffsprings);
    cut.item.updatedAt = "PENDING";
    cut.item = null;
    cut.id = -1;
    this.editor.cutWorkingOffsprings = null;
  } else {
    if (copy.item) {
      const cloneSeqno = this.selection.selected({
        entity: "items",
        type: "get",
        action: "nextseqno"
      });
      var parentSeqno = "";
      var nail = this.editor.work({ entity: "nail", type: "get" });
      if (nail.seqno > -1) {
        parentSeqno = nail.seqno + "-" + nail.compId;
      }
      const cloneItem = this.editor._cloneOffsprings(copy.item, cloneSeqno, parentSeqno);
      cloneItem.wgtHiliteClass = "";
      cloneItem.nailedHiliteClass = "";
      this.editor._addChild(cloneItem);
    }
  }
  this.addTracker("item.paste");
  return rc;
}
function deleteSelectedItemFromParent() {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  this.editor._deleteItemFromParent(wrk.item);
}
function deleteSelectedItemChildren() {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  this.editor._deleteItemChildren(wrk.item);
}
function processDeleteSelectedItem() {
  var wrk = this.editor.work({ entity: "wrk", type: "get" });
  this.selection.selected({ entity: "items", type: "set", action: "remove", value: wrk.item });
  this.editor.deleteSelectedItemFromParent();
  this.editor.deleteSelectedItemChildren();
  this.editor.resetSelectedItem();
  this.editor.work({ entity: "nail", type: "set", action: "reset" });
  this.addTracker("item.delete");
}
function processClearAllItems() {
  this.selection.selected({ entity: "items", type: "set", action: "clear" });
  const rootItem = this.selection.selected({ entity: "items", type: "get" });
  rootItem[0].child = [];
  this.editor.redo = [];
  this.addTracker("item.clear");
}
async function processInstanceDeleteContinue() {
  try {
    const accountNo = this.selection.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
    const formNo = this.selection.selected({
      entity: "forms",
      type: "get",
      action: "prop",
      property: "formNo"
    });
    const instance = this.selection.selected({ entity: "instances", type: "get" });
    const instanceNo = instance.instanceNo;
    let results = await this.serverio.run(
      "instances",
      "remove",
      instance,
      accountNo,
      formNo,
      instanceNo
    );
    results = this.repocache.repo({
      entity: "instances",
      type: "set",
      action: "remove",
      value: instance,
      accountNo,
      formNo,
      instanceNo
    });
    this.setSnackbar("Delete successful.", "success");
  } catch (e) {
    this.setSnackbar("Delete failed.", "error");
  }
  this.clearTracker();
  this.selection.setupUserFormsSelection(false);
}
async function processDeleteForm(form, instance) {
  if (!form) {
    this.appendStateMsg("processDeleteForm initiated without specifying a form.");
    return;
  }
  if (!instance) {
    this.appendStateMsg("processDeleteForm initiated without specifying an instance.");
    return;
  }
  try {
    const account = this.selection.selected({ entity: "accounts", type: "get" });
    const accountNo = account.accountNo;
    let results = await this.serverio.run("forms", "remove", form, accountNo, form.formNo);
    results = this.repocache.repo({
      entity: "forms",
      type: "set",
      action: "remove",
      value: form,
      accountNo
    });
    results = this.repocache.repo({
      entity: "instances",
      type: "set",
      action: "removeAll",
      accountNo,
      formNo: form.formNo
    });
    results = this.repocache.repo({
      entity: "items",
      type: "set",
      action: "removeAll",
      accountNo,
      formNo: form.formNo,
      instanceNo: instance.instanceNo
    });
    this.setSnackbar("Delete successful.", "success");
  } catch (e) {
    this.setSnackbar("Delete failed.", "error");
  }
  this.clearTracker();
  this.selection.setupUserFormsSelection(false);
}
function processActiveInstanceNo(instanceNo) {
  this.addTracker("form");
  this.selection.selected({
    entity: "forms",
    type: "set",
    action: "prop",
    property: "activeVerNo",
    value: instanceNo
  });
}
function processWidgetSelection(type, category, paletteItem) {
  console.log(
    "Builder:widgetSelection - invoked for type/category/paletteItem : " + type + "/" + category + "/" + paletteItem.wgt
  );
  console.log("Builder:widgetSelection() - check for edit mode");
  const instance = this.selection.selected({ entity: "instances", type: "get" });
  const configMode = this.editor.work({
    entity: "flag",
    type: "get",
    action: "prop",
    property: "configMode"
  });
  if (configMode == "edit") {
    console.log("Builder:widgetSelection() - addin widget to edit mode instance");
    const seqno = this.selection.selected({
      entity: "items",
      type: "get",
      action: "nextseqno"
    });
    var dupProp = deepCopyJson(paletteItem.prop);
    var parent = "";
    var nail = this.editor.work({ entity: "nail", type: "get" });
    if (nail.seqno > -1) {
      parent = nail.seqno + "-" + nail.compId;
    }
    console.log("Builder:widgetSelection() - create new item");
    var options2 = {
      accountNo: instance.accountNo,
      formNo: instance.formNo,
      instanceNo: instance.instanceNo,
      seqno,
      name: "" + seqno,
      type,
      category,
      wgt: paletteItem.wgt,
      parent,
      userProp: dupProp,
      createdAt: "PENDING"
    };
    let newItem = deepCopyJson(new Item(options2));
    if (nail.seqno > -1) {
      const childCopy = nail.item.child.slice();
      childCopy.push(seqno);
      nail.item.child = childCopy;
      nail.item.updatedAt = "PENDING";
      this.addTracker("item.updated");
    }
    this.selection.selected({ entity: "items", type: "set", action: "add", value: newItem });
    this.repocache.repo({ entity: "items", type: "set", action: "add", value: [newItem] });
    this.addTracker("item.add");
    if (category == "Container" || category == "Layout") {
      this.editor.selectNail(seqno, 0);
    }
    if (category == "Container") {
      this.editor.work({
        entity: "flag",
        type: "set",
        action: "prop",
        property: "prevSelCategory",
        value: "Basic"
      });
    } else {
      this.editor.work({
        entity: "flag",
        type: "set",
        action: "prop",
        property: "prevSelCategory",
        value: "category"
      });
    }
    console.log("Builder:widgetSelection() - create new item done " + JSON.stringify(newItem));
  } else {
    this.setSnackbar("Earlier versions are not editable.", "warning");
  }
}
function cleanUserProps(itemCopy) {
  const userProp = itemCopy.userProp;
  try {
    const keys = Object.keys(userProp);
    for (let i in keys) {
      let prop = keys[i];
      if (typeof userProp[prop] == "undefined" || userProp[prop] == "" || userProp[prop] == null || userProp[prop] == false) {
        delete userProp[prop];
      }
    }
  } catch (e) {
    console.error("Editor:cleanUserProps() - exception in cleanup ", e);
  }
}
async function processSave() {
  try {
    let form, instance, items, accountNo, formNo, instanceNo, results;
    form = this.selection.selected({ entity: "forms", type: "get" });
    instance = this.selection.selected({ entity: "instances", type: "get" });
    items = this.selection.selected({ entity: "items", type: "get" });
    accountNo = form.accountNo;
    formNo = instance.formNo;
    instanceNo = instance.instanceNo;
    console.log(
      "Builder:processSave() - **************************  save : forms updatedAt:" + form.updatedAt,
      ", instances updatedAt:" + instance.updatedAt
    );
    if (form.createdAt === "PENDING") {
      form.id = null;
      const formCopy = deepCopyJson(form);
      formCopy.jsonProp = JSON.stringify(formCopy.jsonProp);
      results = await this.serverio.run("forms", "create", formCopy, accountNo);
      form.id = results.id;
      form.createdAt = results.createdAt;
      form.version = results.version;
      this.setSnackbar(`Save for create form successful.`, "success");
      this.repocache.repo({ entity: "forms", type: "set", action: "remove", accountNo, value: form });
      this.repocache.repo({ entity: "forms", type: "set", action: "add", value: form });
    } else if (form.updatedAt === "PENDING") {
      const formCopy = deepCopyJson(form);
      formCopy.jsonProp = JSON.stringify(formCopy.jsonProp);
      results = await this.serverio.run("forms", "update", formCopy, accountNo);
      form.updatedAt = results.updatedAt;
      form.version = results.version;
      this.setSnackbar(`Save for update form successful.`, "success");
      this.repocache.repo({ entity: "forms", type: "set", action: "remove", accountNo, value: form });
      this.repocache.repo({ entity: "forms", type: "set", action: "add", value: form });
    }
    if (instance.createdAt === "PENDING") {
      instance.formNo = form.formNo;
      instance.id = null;
      const instanceCopy = deepCopyJson(instance);
      instanceCopy.jsonProp = JSON.stringify(instanceCopy.jsonProp);
      results = await this.serverio.run(
        "instances",
        "create",
        instanceCopy,
        accountNo,
        formNo
      );
      instance.id = results.id;
      instance.createdAt = results.createdAt;
      instance.version = results.version;
      this.setSnackbar(`Save for create version successful.`, "success");
      this.repocache.repo({ entity: "instances", type: "set", action: "remove", accountNo, formNo, value: instance });
      this.repocache.repo({ entity: "instances", type: "set", action: "add", value: instance });
    } else if (instance.updatedAt === "PENDING") {
      const instanceCopy = deepCopyJson(instance);
      instanceCopy.jsonProp = JSON.stringify(instanceCopy.jsonProp);
      results = await this.serverio.run(
        "instances",
        "update",
        instanceCopy,
        accountNo,
        formNo
      );
      instance.updatedAt = results.updatedAt;
      instance.version = results.version;
      this.setSnackbar(`Save for update version successful.`, "success");
      this.repocache.repo({ entity: "instances", type: "set", action: "remove", accountNo, formNo, value: instance });
      this.repocache.repo({ entity: "instances", type: "set", action: "add", value: instance });
    }
    if (this.isTrackerItems()) {
      console.log("Builder:processSave() - **************************  save items");
      let createCount = 0;
      let updateCount = 0;
      let deleteCount = 0;
      await items.every(async (item) => {
        if (item.createdAt === "PENDING") {
          console.log(
            "Builder:processSave() - item seqno: " + item.seqno + ", createdAt: " + item.createdAt
          );
          item.id = null;
          item.formNo = formNo;
          item.instanceNo = instanceNo;
          const itemCopy = deepCopyJson(item);
          this.editor.cleanUserProps(itemCopy);
          itemCopy.userProp = JSON.stringify(itemCopy.userProp);
          createCount++;
          results = await this.serverio.run(
            "items",
            "create",
            itemCopy,
            accountNo,
            formNo,
            instanceNo
          );
          item.id = results.id;
          item.createdAt = results.createdAt;
          item.version = results.version;
          this.repocache.repo({ entity: "items", type: "set", action: "remove", accountNo, formNo, instanceNo, itemSeqNo: item.seqno, value: item });
          this.repocache.repo({ entity: "items", type: "set", action: "add", value: [item] });
        } else if (item.updatedAt === "PENDING") {
          const itemCopy = deepCopyJson(item);
          itemCopy.userProp = JSON.stringify(itemCopy.userProp);
          updateCount++;
          results = await this.serverio.run(
            "items",
            "update",
            itemCopy,
            accountNo,
            formNo,
            instanceNo
          );
          item.updatedAt = results.updatedAt;
          item.version = results.version;
          this.repocache.repo({ entity: "items", type: "set", action: "remove", accountNo, formNo, instanceNo, itemSeqNo: item.seqno, value: item });
          this.repocache.repo({ entity: "items", type: "set", action: "add", value: [item] });
        } else if (item.deletedAt === "PENDING") {
          if (!item.id) {
            item.deletedAt = "";
          } else {
            deleteCount++;
            results = await this.serverio.run(
              "items",
              "remove",
              item,
              accountNo,
              formNo,
              instanceNo
            );
            item.deletedAt = /* @__PURE__ */ new Date();
            this.repocache.repo({ entity: "items", type: "set", action: "remove", accountNo, formNo, instanceNo, value: item });
          }
        }
        return true;
      });
      if (createCount || updateCount || deleteCount) {
        this.setSnackbar("Save successful.", "success");
      }
    }
  } catch (e) {
    console.error("Builder:processSave() - exception: " + e);
    this.setSnackbar(`Save ${e}`, "error");
  }
  this.clearTracker();
}
const editorMethods = {
  initRuntimeEditor,
  _unselectItem,
  _deleteItemFromParent,
  _cutOffsprings,
  _addChild,
  replaceChild,
  _addItem,
  _addItemAndOffsprings,
  _cloneItem,
  _cloneOffsprings,
  _deleteItemChildren,
  work,
  findSelectedItem,
  processMoveSelectedItem,
  resetSelectedItem,
  itemDeSelection,
  selectItem,
  itemSelection,
  selectNail,
  nailSelection,
  processCutSelectedItem,
  processCopySelectedItem,
  processPasteSelectedItem,
  deleteSelectedItemFromParent,
  deleteSelectedItemChildren,
  processDeleteSelectedItem,
  processClearAllItems,
  processInstanceDeleteContinue,
  processDeleteForm,
  processActiveInstanceNo,
  processWidgetSelection,
  cleanUserProps,
  processSave
};
const serverioProps = {
  svcurls: {
    none: "none-url",
    authSvc: "authSvc-url",
    formSvc: "formSvc-url",
    tralSvcUrl: "tralSvc-url",
    emrtSvc: "emrtSvc-url"
  }
};
async function initRuntimeServerio() {
  console.log("ServerIO:initRuntimeServerio() invoked");
  this.apiServer = this.appState.getEnvVar.API_SRVR_URL || "http://localhost:3030";
  this.serverio.svcurls = {
    none: this.apiServer,
    authSvc: this.apiServer + "/authSvc",
    formSvc: this.apiServer + "/formSvc",
    tralSvcUrl: this.apiServer + "/tralSvc",
    emrtSvc: this.apiServer + "/emrtSvc"
  };
}
function makeQuery(urlParams) {
  let q = "";
  let first = true;
  for (var p in urlParams) {
    if (!first) {
      q = q + "&" + p + "=" + urlParams[p];
    } else {
      q = q + p + "=" + urlParams[p];
      first = false;
    }
  }
  return q;
}
async function exec(options2) {
  if (!options2.headers) {
    options2.headers = {
      credentials: "include",
      // 'omit' 'same-origin'
      mode: "cors"
      // 'no-cors', '*cors', 'same-origin'
    };
  }
  if (!options2.headers.Authorization && this.appState.token) {
    options2.headers["Authorization"] = `Bearer ${this.appState.token}`;
  }
  if (!options2.headers.Authorization && this.appState.fpid) {
    options2.headers["Authorization"] = `Bearer ${this.appState.fpid}`;
  }
  options2.headers["X-Fpid"] = this.appState.fpid;
  options2.headers["X-Reqaccountno"] = this.appState.account?.accountNo || "";
  options2.headers["X-CorrelationId"] = this.appState.getCorrelationId();
  if (options2.service === "authenticate") {
    options2.headers["Content-Type"] = "application/json";
    options2["body"] = JSON.stringify({ strategy: "jwt", accessToken: this.appState.token });
  }
  if (!options2.headers["Content-Type"]) {
    options2.headers["Content-Type"] = "application/json";
  }
  let queryStr = "";
  if (options2.query) {
    queryStr = this.serverio.makeQuery(options2.query);
  }
  let url;
  if (options2.wrapper === "custom") {
    url = options2.url + (queryStr ? "?" + queryStr : "");
  } else if (options2.wrapper === "none") {
    url = this.serverio.svcurls[options2.wrapper] + "/" + options2.service + (queryStr ? "?" + queryStr : "");
  } else {
    url = this.serverio.svcurls[options2.wrapper] + "?service=" + options2.service + (queryStr ? "&" + queryStr : "");
  }
  let resp;
  try {
    this.setIOBusy(true);
    resp = await myFetch(url, options2);
    this.setIOBusy(false);
  } catch (e) {
    console.error("myFetchAPI() - caught exception while making myFetch() call", e);
    this.setIOBusy(false);
  } finally {
    return resp;
  }
}
async function getBundle(accountNo, formNo, instanceNo) {
  if (!accountNo)
    throw "ServerIO:_serverio: Attempting to get bundle-form but accountNO is missing";
  const query = { accountNo };
  if (formNo) query.formNo = formNo;
  const options2 = {
    method: "get",
    wrapper: "formSvc",
    service: "bundle-form",
    data: null,
    query
  };
  const bundleResults = await this.serverio.exec(options2);
  if (bundleResults && bundleResults.code !== 200 && bundleResults.code !== 201) {
    const dataMsg = bundleResults.msg ? bundleResults.msg : "No bundleResult.msg value";
    const msg = `Get Bundle Failed. Code: ${bundleResults.code} - ${dataMsg}`;
    this.appendStateMsg(msg);
    console.error(`serverio:run() ${msg}`);
    throw msg;
  }
  if (bundleResults && bundleResults.data && bundleResults.data.accounts && bundleResults.data.forms && bundleResults.data.instances && bundleResults.data.items && bundleResults.data.submissions) {
    const accountsResults = bundleResults.data.accounts;
    const formsResults = bundleResults.data.forms;
    const instancesResults = bundleResults.data.instances;
    const itemsResults = bundleResults.data.items;
    const submissionsResults = bundleResults.data.submissions;
    if (accountNo == 1 && (accountsResults.total < 1 || formsResults.total < 1 || itemsResults.total < 1 || instancesResults.total < 1)) {
      this.appendStateMsg("Meta Form not available - missing items");
      throw "ServerIO:getBundle() - Failed: Meta Form not available - missing DB data";
    }
    if (submissionsResults.total < 1) ;
    return {
      accounts: accountsResults.data,
      forms: formsResults.data,
      instances: instancesResults.data,
      items: itemsResults.data,
      submissions: submissionsResults.data
    };
  } else {
    throw "ServerIO:getBundle() - Failed: Unable to get full bundle data";
  }
}
async function run(entity, method, data, accountNo, formNo, instanceNo) {
  let query;
  if (method == "create") {
    if (entity === "submissions") {
      data.createdAt = (/* @__PURE__ */ new Date()).toGMTString();
      data.deletedAt = null;
      data.updatedAt = (/* @__PURE__ */ new Date()).toGMTString();
      data.auditip = this.appState.auditip;
      data.auditlusr = this.upap && this.upap.user && this.upap.user.email || "";
    } else {
      data.createdAt = (/* @__PURE__ */ new Date()).toGMTString();
      data.deletedAt = null;
      data.updatedAt = (/* @__PURE__ */ new Date()).toGMTString();
      data.auditip = this.appState.auditip;
      data.srcNo = 1;
      data.auditlusr = this.upap && this.upap.user && this.upap.user.email || "";
      data.layout = "VERTICAL";
      data.status = "Enabled";
    }
  } else if (method == "update") {
    data.createdAt = (/* @__PURE__ */ new Date()).toGMTString();
    data.deletedAt = null;
    data.updatedAt = (/* @__PURE__ */ new Date()).toGMTString();
    data.auditip = this.appState.auditip;
    data.srcNo = 1;
    data.auditlusr = this.upap && this.upap.user && this.upap.user.email || "";
  } else if (method == "remove") {
    if (!data.id)
      throw "ServerIO:_serverio: Attempting to remove " + entity + " but id is missing";
    if (entity == "forms") {
      query = { accountNo, formNo, id: data.id };
    } else if (entity == "instances") {
      query = { accountNo, formNo, instanceNo, id: data.id };
    } else if (entity == "items") {
      query = { accountNo, formNo, instanceNo, id: data.id };
    }
  } else if (method == "get") {
    if (!accountNo)
      throw "ServerIO:_serverio: Attempting to get " + entity + " but query is missing";
    if (entity == "accounts") {
      query = { accountNo };
    } else {
      query = { accountNo };
      if (formNo) query.formNo = formNo;
    }
  } else throw "ServerIO:_serverio() invalid method";
  let results = [];
  const httpMethod = method === "create" ? "post" : method === "update" ? "put" : method === "remove" ? "delete" : "get";
  try {
    const options2 = {
      method: httpMethod,
      wrapper: "formSvc",
      service: entity,
      body: data ? JSON.stringify(data) : null,
      query: query ? query : null
      // could use something like : { clientName: name }
    };
    results = await this.serverio.exec(options2);
    if (results && results.code !== 200 && results.code !== 201) {
      const dataMsg = results.msg ? results.msg : "No results.msg value";
      const msg = `General Request Failed. Code is not 200/201 (${results.code}) - ${dataMsg}`;
      this.appendStateMsg(msg);
      console.error(`serverio:run() ${msg}`);
      throw msg;
    }
    return results.data;
  } catch (e) {
    if (e) console.error("serverio:serverio() returned error results :" + JSON.stringify(e));
    else console.error("serverio:serverio() returned error");
    throw e;
  }
}
async function fetchList(formName, accountNo) {
  let results;
  const data = null;
  try {
    const query = { accountNo };
    const options2 = {
      method: "get",
      wrapper: "authsvc",
      service: formName,
      // service,
      body: data ? JSON.stringify(data) : null,
      query: query ? query : null
      // could use something like : { clientName: name }
      //jwt: this.c lientContext.jwt,
    };
    results = await this.serverio.exec(options2);
    setResp(results.data);
  } catch (e) {
    this.setSnackbar("Fetch for " + formName + " failed.", "error");
    setResp(e);
  }
}
async function _runForAccess(data) {
  const action = data.action;
  let results;
  switch (action) {
    case "invite":
      console.error("ServerIO:invite invoked <<< NEEDS CODE TO BE ADDED");
      results = await this.apiCall(
        // <<< THIS CODE NEEDS TO BE ADDED along with IOBusy() IT'S COMMENTED OUT ABOVE
        "POST",
        "invites",
        {
          accountNo: data.accountNo,
          dept: data.dept,
          userNo: data.userNo,
          inviteNo: data.inviteNo,
          type: data.type,
          status: data.status,
          application: data.application,
          email: data.email,
          first: data.first,
          last: data.last,
          tele: data.tele,
          jsonProp: data.jsonProp
        },
        null,
        "authsvc"
      );
      if (results && results.code == 201) {
        return results.data;
      } else {
        console.error("Error authenticating!", results);
        return results.data;
      }
    case "addanapp":
      results = await this.apiCall(
        // <<< THIS CODE NEEDS TO BE ADDED along with IOBusy() IT'S COMMENTED OUT ABOVE 
        "POST",
        "addanapp",
        {
          application: data.application,
          plan: data.plan,
          invitecode: data.invitecode,
          email: data.email,
          password: data.password
        },
        null,
        "authsvc"
      );
      if (results && results.code == 201) {
        return results.data;
      } else {
        console.error("Error authenticating!", results);
        return results.data;
      }
    default:
      console.info("ServerIO:_runForAccess - process >" + action + "<  IS NOT HANDLED IN CASE STMT");
  }
}
async function addanapp(formName) {
  const model2 = this.metaforms.getMetaFormStructure(formName);
  let result = null;
  result = await _runForAccess({
    action: "addanapp",
    application: model2.application,
    plan: model2.plan,
    invitecode: model2.invitecode,
    email: model2.email,
    password: model2.password
  });
  if (result && result.email == model2.email) {
    this.setSnackbar(
      "Addanapp Successful. Check your email for notification. (A10)",
      "success"
    );
  } else {
    this.setSnackbar("Addanapp Failed: " + result?.message || "No result.message value  (A10)", "error");
  }
}
async function appsub(data) {
  const options2 = {
    method: "POST",
    wrapper: "authsvc",
    service: "appsub",
    body: data ? JSON.stringify(data) : null,
    query: null
  };
  const results = await this.serverio.exec(options2);
  if (results && results.code == 201) {
    this.setSnackbar(
      "Subscription Successful. Check your email for notification. (A11)",
      "success"
    );
    return results.data;
  } else {
    console.error("ServerIO:_runForAccess() - Error authenticating!", results);
    this.setSnackbar(
      "Subscription Failed. code: " + results.code + " (A11)",
      "error"
    );
    return results.data;
  }
}
async function createCustomer(data) {
  const host = this.appState.getEnvVar.API_SRVR_PYMT_URL;
  const options2 = {
    method: "POST",
    wrapper: "custom",
    url: `${host}/create-customer`,
    service: "",
    body: data ? JSON.stringify(data) : null,
    query: null
  };
  const results = await this.serverio.exec(options2);
  if (results && (results.code == 200 || results.code == 201)) {
    return results.data;
  } else {
    console.error("ServerIO:createCustomer() - Error in payments processing: create-customer", results);
    this.setSnackbar(
      "Payments Processing Failed. code: " + results.code + " (A12)",
      "error"
    );
    return null;
  }
}
async function createSubscription(data) {
  const host = this.appState.getEnvVar.API_SRVR_PYMT_URL;
  const options2 = {
    method: "POST",
    wrapper: "custom",
    url: `${host}/create-subscription`,
    service: "",
    body: data ? JSON.stringify(data) : null,
    query: null
  };
  const results = await this.serverio.exec(options2);
  if (results && (results.code == 200 || results.code == 201)) {
    return results.data;
  } else {
    console.error("ServerIO:createCustomer() - Error in payments processing: create-subscription", results);
    this.setSnackbar(
      "Payments Processing Failed. code: " + results.code + " (A13)",
      "error"
    );
    return null;
  }
}
async function makePayment(data) {
  const host = this.appState.getEnvVar.API_SRVR_PYMT_URL;
  const options2 = {
    method: "POST",
    wrapper: "custom",
    url: `${host}/pymtSvc?service=make-payment`,
    // TODO use the env. var
    service: "",
    body: data ? JSON.stringify(data) : null,
    query: null
  };
  const results = await this.serverio.exec(options2);
  if (results && (results.code == 200 || results.code == 201)) {
    return results;
  } else {
    console.error("ServerIO:createCustomer() - Error in payments processing: makePayment", results);
    this.setSnackbar(
      "Payments Processing Failed. code: " + results.code + " (A13)",
      "error"
    );
    return results || null;
  }
}
async function removePayment(data) {
  const host = this.appState.getEnvVar.API_SRVR_PYMT_URL;
  const options2 = {
    method: "POST",
    wrapper: "custom",
    url: `${host}/pymtSvc?service=remove-payment`,
    // TODO use the env. var
    service: "",
    body: data ? JSON.stringify(data) : null,
    query: null
  };
  const results = await this.serverio.exec(options2);
  if (results && (results.code == 200 || results.code == 201)) {
    return results;
  } else {
    console.error("ServerIO:createCustomer() - Error in payments processing: removePayment", results);
    this.setSnackbar(
      "Payments Processing Failed. code: " + results.code + " (A13)",
      "error"
    );
    return results || null;
  }
}
async function pricelist(data) {
  const host = this.appState.getEnvVar.API_SRVR_PYMT_URL;
  const appEnv = this.appState.getEnvVar.RUN_ENV;
  const options2 = {
    method: "GET",
    wrapper: "custom",
    url: `${host}/pymtSvc?service=pricelist&appEnv=${appEnv}`,
    // TODO use the env. var
    service: "",
    body: null
    //query: { appEnv: appEnv },
  };
  const results = await this.serverio.exec(options2);
  if (results && results.code == 200) {
    return results.data;
  } else {
    console.error("ServerIO:pricelist() - Error in payments processing: get pricelist", results);
    this.setSnackbar(
      "Payments Processing Failed. code: " + results.code + " (A14)",
      "error"
    );
    return null;
  }
}
async function appssubs(data) {
  const host = this.appState.getEnvVar.API_SRVR_PYMT_URL;
  const q = data.appCode ? { appCode: data.appCode } : null;
  const options2 = {
    method: "GET",
    wrapper: "custom",
    url: `${host}/pymtSvc?service=appssubs`,
    // TODO use the env. var
    service: "",
    body: null,
    query: q
  };
  const results = await this.serverio.exec(options2);
  if (results && results.code == 200) {
    return results.data;
  } else {
    console.error("ServerIO:pricelist() - Error in payments processing: get appssubs", results);
    this.setSnackbar(
      "Payments Processing Failed. code: " + results.code + " (A15)",
      "error"
    );
    return null;
  }
}
async function configpymt(data) {
  const host = this.appState.getEnvVar.API_SRVR_PYMT_URL;
  const options2 = {
    method: "GET",
    wrapper: "custom",
    url: `${host}/pymtSvc?service=configpymt`,
    // TODO use the env. var
    service: "",
    body: null,
    query: null
  };
  const results = await this.serverio.exec(options2);
  if (results && results.code == 200) {
    return results.data;
  } else {
    console.error("ServerIO:pricelist() - Error in payments processing: get configpymt", results);
    this.setSnackbar(
      "Payments Processing Failed. code: " + results.code + " (A16)",
      "error"
    );
    return null;
  }
}
async function invite(formName) {
  const model2 = this.metaforms.getMetaFormStructure(formName);
  const result = await _runForAccess({
    action: "invite",
    accountNo: this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    }),
    dept: 1,
    userNo: this.appState.user.userNo,
    inviteNo: 1,
    type: "",
    status: "Invited",
    email: model2.email,
    first: model2.first,
    last: model2.last,
    tele: model2.tele,
    application: model2.application,
    test: model2.test,
    jsonProp: {}
  });
  if (result && result.email == model2.email) {
    this.setSnackbar(
      "Invite Successful. An email will be sent to invitee requesting to Sign Up. (A17)",
      "success"
    );
  } else {
    this.setSnackbar("Invite Failed: " + result?.message || "No result.message value  (A17)", "error");
  }
}
async function webPushTest(url, jwt, fpid) {
  this.setIOBusy(true);
  const resp = await myFetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${jwt || fpid}`,
      "content-type": "application/json"
    }
  });
  this.setIOBusy(false);
  return resp;
}
async function persistSubscription(url, jwt, fpid, subscription) {
  this.setIOBusy(true);
  const resp = await myFetch(url, {
    method: "POST",
    body: JSON.stringify(subscription),
    headers: {
      Authorization: `Bearer ${jwt || fpid}`,
      "content-type": "application/json"
    }
  });
  this.setIOBusy(false);
  return resp;
}
function replaceQuotes(buffer) {
  const resp = buffer.replace(/'/g, '"');
  return resp;
}
const serverioMethods = {
  initRuntimeServerio,
  makeQuery,
  exec,
  getBundle,
  run,
  fetchList,
  _runForAccess,
  addanapp,
  appsub,
  createCustomer,
  createSubscription,
  makePayment,
  removePayment,
  pricelist,
  appssubs,
  configpymt,
  invite,
  webPushTest,
  persistSubscription,
  replaceQuotes
};
const repocacheProps = {
  localCache: null
};
async function initRuntimeRepocache() {
  console.log("RepoCache:initRuntimeRepocache() invoked");
  this.repocache.localCache = {
    forms: [],
    // Repo for forms from all accounts
    instances: [],
    // Repo for instances from all forms/accounts
    items: [],
    // Repo for items from all instances/forms/accounts
    submissions: []
    //accounts: [],  /// Repo for use only when launching a form. As the account is not as same as UPAP acct.
  };
}
function _findRepoInstanceItemAllChildren(parentItem, child) {
  if (!parentItem) return child;
  const childSeqnoList = parentItem.child;
  const accountNo = parentItem.accountNo;
  const formNo = parentItem.formNo;
  const instanceNo = parentItem.instanceNo;
  if (childSeqnoList.length) {
    const items = this.repocache.repo({ entity: "items", type: "get" });
    child = items.reduce((accum, item) => {
      if (item.accountNo != accountNo || item.formNo != formNo || item.instanceNo != instanceNo) {
        return accum;
      }
      if (childSeqnoList.indexOf(item.seqno) != -1) {
        accum.push(item);
        if (item.child && item.child.length) {
          accum = this.repocache._findRepoInstanceItemAllChildren(item, child);
        }
      }
      return accum;
    }, child);
  }
  return child;
}
function _findSpecificAccount(accountNo) {
  let account = this.repocache.localCache.accounts && this.repocache.localCache.accounts.find((acct, i) => {
    return acct.accountNo === accountNo;
  });
  return account;
}
function _findAllForm(accountNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  let formSubset = this.repocache.localCache.forms.filter((form, i) => {
    return form.accountNo == accountNo;
  });
  return formSubset;
}
function _findRecentForm(accountNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  let form = this.repocache.localCache.forms.reduce((accum, form2, i) => {
    if (form2.accountNo == accountNo) {
      if (accum) {
        if (accum.formNo < form2.formNo) {
          accum = form2;
        }
      } else {
        accum = form2;
      }
    }
    return accum;
  }, null);
  return form;
}
function _findSpecificForm(accountNo, formNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  let form = this.repocache.localCache.forms.find((form2, i) => {
    return form2.accountNo === accountNo && form2.formNo === formNo;
  });
  return form;
}
function _removeForm(rmForm) {
  let ndx = -1;
  this.repocache.localCache.forms.find((form, i) => {
    if (form.formNo === rmForm.formNo && form.accountNo === rmForm.accountNo) {
      ndx = i;
      return true;
    } else
      return false;
  });
  if (ndx >= 0) {
    this.repocache.localCache.forms.splice(ndx, 1);
    return true;
  } else {
    return false;
  }
}
function _findRecentInstance(accountNo, formNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  if (!formNo) {
    formNo = this.selected({
      entity: "forms",
      type: "get",
      action: "prop",
      property: "formNo"
    });
  }
  let instance = this.repocache.localCache.instances.reduce((accum, instance2, i) => {
    if (instance2.accountNo == accountNo && instance2.formNo == formNo) {
      if (accum) {
        if (accum.instanceNo < instance2.instanceNo) {
          accum = instance2;
        }
      } else {
        accum = instance2;
      }
    }
    return accum;
  }, null);
  return instance;
}
function _findInstance(accountNo, form, instances) {
  const formNo = form.formNo;
  const activeType = form.activeType;
  const expectedInstanceNo = form.activeVerNo;
  let instance;
  if (activeType === "Specific") {
    instance = instances.find((instance2) => {
      return instance2.accountNo == accountNo && instance2.formNo == formNo && instance2.instanceNo == expectedInstanceNo;
    });
  } else {
    instance = instances.reduce((accum, instance2) => {
      if (instance2.accountNo == accountNo && instance2.formNo == formNo) {
        if (!accum) {
          accum = instance2;
        } else {
          if (accum.instanceNo < instance2.instanceNo) accum = instance2;
        }
        return accum;
      }
    }, null);
  }
  return instance;
}
function _findAllInstance(accountNo, formNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  if (!formNo) {
    formNo = this.selected({
      entity: "forms",
      type: "get",
      action: "prop",
      property: "formNo"
    });
  }
  let subList = this.repocache.localCache.instances.filter((instance, i) => {
    return instance.accountNo == accountNo && instance.formNo == formNo;
  });
  return subList;
}
function _removeInstance(rmInstance) {
  let ndx = -1;
  this.repocache.localCache.instances.find((instance, i) => {
    if (instance.formNo === rmInstance.formNo && instance.accountNo === rmInstance.accountNo && instance.instanceNo === rmInstance.instanceNo) {
      ndx = i;
      return true;
    } else
      return false;
  });
  if (ndx >= 0) {
    this.repocache.localCache.instances.splice(ndx, 1);
  } else {
    return false;
  }
}
function _findRepoInstanceItems(accountNo, formNo, instanceNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  if (!formNo) {
    formNo = this.selected({
      entity: "forms",
      type: "get",
      action: "prop",
      property: "formNo"
    });
  }
  if (!instanceNo) {
    instanceNo = this.selected({
      entity: "instances",
      type: "get",
      action: "prop",
      property: "instanceNo"
    });
  }
  const rootItem = this.repocache.localCache.items.find(
    (item) => item.seqno === 1e3 && item.accountNo === accountNo && item.formNo == formNo && item.instanceNo == instanceNo
  );
  let child = [];
  const subList = rootItem && this.repocache._findRepoInstanceItemAllChildren(rootItem, child);
  subList && subList.unshift(rootItem);
  return subList;
}
function _findAllSubmissions(accountNo, formNo, instanceNo) {
  if (!accountNo) {
    accountNo = this.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    });
  }
  if (!formNo) {
    formNo = this.selected({
      entity: "forms",
      type: "get",
      action: "prop",
      property: "formNo"
    });
  }
  if (!instanceNo) {
    instanceNo = this.selected({
      entity: "instances",
      type: "get",
      action: "prop",
      property: "instanceNo"
    });
  }
  let subList = this.repocache.localCache.submissions.filter((submission, i) => {
    return submission.accountNo == accountNo && submission.formNo == formNo && submission.instanceNo == instanceNo;
  });
  return subList;
}
function repo({ entity, ...rest }) {
  if (entity === "users") {
    return this.repocache.repoUsers(rest);
  } else if (entity === "members") {
    return this.repocache.repoMembers(rest);
  } else if (entity === "accounts") {
    return this.repocache.repoAccounts(rest);
  } else if (entity == "forms") {
    return this.repocache.repoForms(rest);
  } else if (entity == "instances") {
    return this.repocache.repoInstances(rest);
  } else if (entity == "items") {
    return this.repocache.repoItems(rest);
  } else if (entity == "submissions") {
    return this.repocache.repoSubmissions(rest);
  }
}
function repoUsers(param) {
  let { type, action = "", value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.upap.user;
    }
  }
}
function repoMembers(param) {
  let { type, action = "", value: value2 } = param;
  if (!this.upap) return null;
  if (type === "get") {
    switch (action) {
      case "":
        return this.upap.members;
    }
  }
}
function repoAccounts(param) {
  let { type, action = "", value: value2 } = param;
  if (type === "get") {
    switch (action) {
      case "":
        const upapMember = this.upap.members[this.upapMemberNdx];
        return upapMember.account;
      case "specific":
        const account = this.repocache._findSpecificAccount(value2);
        return account;
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        this.repocache.localCache.accounts = value2;
        break;
    }
  }
}
function repoForms(param) {
  let { type, action = "", value: value2, accountNo } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.repocache._findAllForm(accountNo);
      case "recent":
        return this.repocache._findRecentForm(accountNo);
      case "specific":
        return this.repocache._findSpecificForm(accountNo, value2);
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        this.repocache.localCache.forms = value2;
        break;
      case "add":
        this.repocache.localCache.forms.push(value2);
        break;
      case "remove":
        this.repocache._removeForm(value2);
        console.log(
          "RepoCache:repoForm() - delete completed for form account/form: " + accountNo + "/" + value2.formNo
        );
        break;
    }
  }
}
function repoInstances(param) {
  let { type, action = "", value: value2, accountNo, formNo } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.repocache._findAllInstance(accountNo, formNo);
      case "recent":
        return this.repocache._findRecentInstance(accountNo, formNo);
      case "per-form":
        return this.repocache._findInstance(
          accountNo,
          value2,
          this.repocache._findAllInstance(accountNo, value2.formNo)
        );
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        this.repocache.localCache.instances = value2;
        break;
      case "add":
        this.repocache.localCache.instances.push(value2);
        break;
      case "remove":
        this.repocache._removeInstance(value2);
        const instanceNo = value2.instanceNo;
        console.log(
          "RepoCache:repoInstance() - delete completed for instance account/form/instance: " + accountNo + "/" + formNo + "/" + instanceNo
        );
        break;
      case "removeAll":
        this.repocache.localCache.instances.every((instance, i, src) => {
          if (instance.accountNo == accountNo && instance.formNo == formNo) {
            const instanceNo2 = instance.instanceNo;
            this.repocache.repo({
              entity: "instances",
              type: "set",
              action: "remove",
              value: instance
            });
            console.log(
              "RepoCache:repoInstance() - delete completed for instance account/form/instance: " + accountNo + "/" + formNo + "/" + instanceNo2
            );
          }
          return true;
        });
        console.log(
          "RepoCache:repoInstance() - delete completed for all instances for account/form: " + accountNo + "/" + formNo
        );
        break;
    }
  }
}
function repoItems(param) {
  let { type, action = "", value: value2, accountNo, formNo, instanceNo, itemSeqNo } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.repocache.localCache.items;
      case "recent":
        return this.repocache._findRepoInstanceItems(accountNo, formNo, instanceNo);
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        this.repocache.localCache.items = value2;
        break;
      case "add":
        if (value2.length > 1) {
          const combined = this.repocache.localCache.items.concat(value2);
          this.repocache.localCache.items = combined;
        } else {
          this.repocache.localCache.items.push(value2[0]);
        }
        break;
      case "remove":
        let ndx = -1;
        ndx = this.repocache.localCache.items.findIndex((item) => {
          if (item.accountNo == accountNo && item.formNo == formNo && item.instanceNo == instanceNo && item.seqno == itemSeqNo) {
            return true;
          } else
            return false;
        });
        if (ndx >= 0) {
          this.repocache.localCache.items.splice(ndx, 1);
          console.log(
            "RepoCache:repoItems() - remvoe item account/form/instance/item: " + accountNo + "/" + formNo + "/" + instanceNo + "/" + itemSeqNo
          );
          return true;
        } else {
          return false;
        }
      case "removeAll":
        this.repocache.localCache.items = this.repocache.localCache.items.filter((item, i, src) => {
          if (item.accountNo == accountNo && item.formNo == formNo && item.instanceNo == instanceNo) {
            const itemSeqNo2 = item.seqno;
            console.log(
              "RepoCache:repoItems() - removeAll - delete item account/form/instance/item: " + accountNo + "/" + formNo + "/" + instanceNo + "/" + itemSeqNo2
            );
            return false;
          } else return true;
        });
        console.log(
          "RepoCache:repoItems() - delete completed for all items for account/form/instance" + accountNo + "/" + formNo + "/" + instanceNo
        );
        break;
    }
  }
}
function repoSubmissions(param) {
  let { type, action = "", value: value2, accountNo, formNo, instanceNo } = param;
  if (type === "get") {
    switch (action) {
      case "":
        return this.repocache._findAllSubmissions(accountNo, formNo, instanceNo);
    }
  } else if (type === "set") {
    switch (action) {
      case "":
        this.repocache.localCache.submissions = value2;
        break;
    }
  }
}
async function setupUserOrLaunchForms(account, isLaunch) {
  if (isLaunch) {
    if (this.getEnvVar.locationData.accountNo && this.getEnvVar.locationData.accountNo > 0) {
      account = { accountNo: this.getEnvVar.locationData.accountNo, accountCode: "", jsonProp: {} };
    } else {
      const msg = "Form Launched without specifying any form parameters.";
      this.appendStateMsg(msg);
      return msg;
    }
  }
  console.log("RepoCache:setupUserForms() invoked");
  const accountNo = account?.accountNo;
  let bundleResults = await this.serverio.getBundle(
    accountNo,
    isLaunch ? this.appState.getEnvVar.locationData.formNo : null
  );
  this.repocache.repo({ entity: "accounts", type: "set", value: bundleResults.accounts });
  this.repocache.repo({ entity: "forms", type: "set", value: bundleResults.forms });
  this.repocache.repo({ entity: "instances", type: "set", value: bundleResults.instances });
  const items = cleanInboundItems(bundleResults.items);
  this.repocache.repo({ entity: "items", type: "set", value: items });
  const submissions = cleanInboundSubmissions(bundleResults.submissions);
  this.repocache.repo({ entity: "submissions", type: "set", value: submissions });
  console.log("RepoCache:setupUserForms() completed");
  return null;
}
function findRecentInstance(accountNo, formNo) {
  let instance = this.repocache.localCache.instances.reduce((accum, instance2, i) => {
    if (instance2.accountNo == accountNo && instance2.formNo == formNo) {
      if (accum) {
        if (accum.instanceNo < instance2.instanceNo) {
          accum = instance2;
        }
      } else {
        accum = instance2;
      }
    }
    return accum;
  }, null);
  return instance;
}
function findNextSeqno(accountNo, formNo) {
  let seqno = 1e3;
  if (this.repocache.localCache.items.length != 0) {
    seqno = this.repocache.localCache.items.reduce((accum, item) => {
      if (item.accountNo != accountNo || item.formNo != formNo) return accum;
      if (item.seqno > accum) accum = item.seqno;
      return accum;
    }, -1);
  }
  return seqno + 1;
}
const repocacheMethods = {
  initRuntimeRepocache,
  _findRepoInstanceItemAllChildren,
  _findSpecificAccount,
  _findAllForm,
  _findRecentForm,
  _findSpecificForm,
  _removeForm,
  _findRecentInstance,
  _findInstance,
  _findAllInstance,
  _removeInstance,
  _findRepoInstanceItems,
  _findAllSubmissions,
  repo,
  repoUsers,
  repoMembers,
  repoAccounts,
  repoForms,
  repoInstances,
  repoItems,
  repoSubmissions,
  setupUserOrLaunchForms,
  findRecentInstance,
  findNextSeqno
};
const builderProps = {
  specs: null
};
async function initRuntimeBuilder() {
  console.log("Builder:initRuntimeBuilder() invoked");
  let nextSeqno = CONST.ROOT_SEQNO;
  try {
    this.builder.specs = this.builder.createFormSpecs();
    console.log("Builder Sample New Form Specs: " + JSON.stringify(this.builder.specs));
    setFormProps(this.builder.specs, nextSeqno, "", this.appPalette);
    console.log("Builder Sample New Form Specs with userProps: " + JSON.stringify(this.builder.specs));
  } catch (e) {
    console.error("Builder:createFormSpecs() - failed: " + e);
    this.setSnackbar("Create new form failed(1). " + e, "error");
  }
}
function _getNextFormNo(forms) {
  if (!forms || forms.length == 0) return 1;
  var maxFormNo = forms.reduce((accum, form) => {
    if (accum < Number(form.formNo)) {
      accum = Number(form.formNo);
    }
    return accum;
  }, -1);
  return maxFormNo + 1;
}
function _getNextInstanceNo(instances) {
  var maxInstanceNo = instances.reduce((accum, instance) => {
    if (accum < Number(instance.instanceNo)) {
      accum = Number(instance.instanceNo);
    }
    return accum;
  }, -1);
  return maxInstanceNo + 1;
}
function _paletteFind(type, category, wgt) {
  const item = this.appPalette.find((palette, i) => {
    if (palette.type === type && palette.category === category && palette.wgt === wgt) {
      return true;
    } else return false;
  });
  return item;
}
function createFormSpecs() {
  try {
    let parents = manageFormSpecs(null, null, {
      type: "Components",
      category: "Layout",
      wgt: "1 Column"
    });
    parents = manageFormSpecs(parents, 0, {
      type: "Components",
      category: "Layout",
      wgt: "1 Column"
    });
    parents = manageFormSpecs(parents, 0, {
      type: "Components",
      category: "Container",
      wgt: "Inline"
    });
    parents = manageFormSpecs(parents, 2, {
      type: "Components",
      category: "Basic",
      wgt: "Reset Button"
    });
    parents = manageFormSpecs(parents, 2, {
      type: "Components",
      category: "Basic",
      wgt: "Submit Button"
    });
    const specs = parents[0];
    return specs;
  } catch (e) {
    console.error("Builder:createFormSpecs() - failed: " + e);
    this.setSnackbar("Create new form failed(2). " + e, "error");
  }
}
function processCreateNewForm() {
  try {
    this.editor.work({ entity: "wrk", type: "set", action: "reset" });
    this.editor.work({ entity: "nail", type: "set", action: "reset" });
    const account = this.selection.selected({ entity: "accounts", type: "get" });
    const accountNo = account.accountNo;
    const forms = this.repocache.repo({ entity: "forms", type: "get" });
    const nextFormNo = this.builder._getNextFormNo(forms);
    const formStructure = createForm(this.builder.specs, accountNo, nextFormNo);
    console.log(
      "Builder Sample New Form with parts for form/instance/items: " + JSON.stringify(formStructure)
    );
    this.repocache.repo({
      entity: "forms",
      type: "set",
      action: "add",
      value: formStructure.form
    });
    this.repocache.repo({
      entity: "instances",
      type: "set",
      action: "add",
      value: formStructure.instance
    });
    this.repocache.repo({
      entity: "items",
      type: "set",
      action: "add",
      value: formStructure.items
    });
    const repoForm = this.repocache.repo({
      entity: "forms",
      type: "get",
      action: "specific",
      value: formStructure.form.formNo
    });
    const repoInstance = this.repocache.repo({
      entity: "instances",
      type: "get",
      action: "recent",
      accountNo,
      formNo: formStructure.form.formNo
    });
    const repoItems2 = this.repocache.repo({
      entity: "items",
      type: "get",
      action: "recent",
      accountNo,
      formNo: formStructure.form.formNo,
      instanceNo: formStructure.instance.instanceNo
    });
    this.editor.work({
      entity: "flag",
      type: "set",
      action: "prop",
      property: "configMode",
      value: "edit"
    });
    const secondItem = repoItems2[1];
    this.selection.selected({ entity: "forms", type: "set", action: "", value: repoForm });
    this.selection.selected({ entity: "instances", type: "set", value: repoInstance });
    this.selection.selected({ entity: "items", type: "set", value: repoItems2 });
    this.editor.selectNail(secondItem.seqno, 0);
    this.editor.work({
      entity: "flag",
      type: "set",
      action: "prop",
      property: "prevSelCategory",
      value: "Container"
    });
    this.addTracker("item.create");
    this.setSnackbar("Create new form successful. Please click SAVE to persist.", "warning");
  } catch (e) {
    this.setSnackbar("Create new form failed(3). " + e, "error");
  }
}
function createNewInstance() {
  try {
    this.editor.work({ entity: "wrk", type: "set", action: "reset" });
    this.editor.work({ entity: "nail", type: "set", action: "reset" });
    const instances = this.repocache.repo({ entity: "instances", type: "get" });
    const nextInstanceNo = this.builder._getNextInstanceNo(instances);
    const instance = this.selection.selected({ entity: "instances", type: "get" });
    const instanceCopy = deepCopyJson(instance);
    instance.mode = "view";
    instance.updatedAt = "PENDING";
    instanceCopy.id = null;
    instanceCopy.instanceNo = nextInstanceNo;
    instanceCopy.mode = "edit";
    instanceCopy.createdAt = "PENDING";
    const items = this.selection.selected({ entity: "items", type: "get" });
    const itemsCopy = items.map((item) => {
      const itemCopy = deepCopyJson(item);
      itemCopy.instanceNo = nextInstanceNo;
      itemCopy.id = null;
      itemCopy.createdAt = "PENDING";
      if (itemCopy.parent == "null") itemCopy.parent = null;
      return itemCopy;
    });
    this.repocache.repo({
      entity: "instances",
      type: "set",
      action: "add",
      value: instanceCopy
    });
    this.repocache.repo({ entity: "items", type: "set", action: "add", value: itemsCopy });
    const account = this.selection.selected({ entity: "accounts", type: "get" });
    const form = this.selection.selected({ entity: "forms", type: "get" });
    const instanceRepo = this.repocache.repo({
      entity: "instances",
      type: "get",
      action: "recent",
      accountNo: account.accountNo,
      formNo: form.formNo
    });
    const itemsRepo = this.repocache.repo({
      entity: "items",
      type: "get",
      action: "recent",
      accountNo: account.accountNo,
      formNo: form.formNo,
      instanceNo: nextInstanceNo
    });
    this.selection.selected({ entity: "instances", type: "set", value: instanceRepo });
    this.selection.selected({ entity: "items", type: "set", value: itemsRepo });
    this.addTracker("item.create");
    this.setSnackbar("Create new form successful. Please click SAVE to persist.", "warning");
    this.editor.work({
      entity: "flag",
      type: "set",
      action: "prop",
      property: "configMode",
      value: "edit"
    });
  } catch (e) {
    this.setSnackbar("Create new form instance failed(4).", "error");
  }
}
const builderMethods = {
  initRuntimeBuilder,
  _getNextFormNo,
  _getNextInstanceNo,
  _paletteFind,
  createFormSpecs,
  processCreateNewForm,
  createNewInstance
};
function BuildCreateVersion(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const instanceNo = da.selected({
    entity: "instances",
    type: "get",
    action: "prop",
    property: "instanceNo"
  });
  const instanceId = da.selected({
    entity: "instances",
    type: "get",
    action: "prop",
    property: "id"
  });
  const buttonText = "Create From: " + instanceNo;
  const handleClick = (event2, p, item, i) => {
    da.createNewInstance();
    event2.preventDefault();
  };
  const checkDisabled = () => {
    if (!instanceId) return true;
    else return false;
  };
  const buttonList = [
    {
      code: "create",
      display: buttonText,
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Create" })
        //<CreateIcon />,
      }
    }
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CreateButtonGroup,
    {
      list: buttonList,
      onClick: handleClick,
      handleCheckDisabled: checkDisabled,
      user: "save",
      fullWidth: false,
      label: null,
      size: "small"
    }
  );
}
function BuildDeleteVersion(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const [alertOpen, setAlertOpen] = React__default.useState(false);
  da.work({ entity: "flag", type: "get", action: "prop", property: "configMode" });
  const activeType = da.selected({
    entity: "forms",
    type: "get",
    action: "prop",
    property: "activeType"
  });
  const activeVerNo = da.selected({
    entity: "forms",
    type: "get",
    action: "prop",
    property: "activeVerNo"
  });
  const instanceNo = da.selected({
    entity: "instances",
    type: "get",
    action: "prop",
    property: "instanceNo"
  });
  const latestInstance = da.repocache.repo({ entity: "instances", type: "get", action: "recent" });
  const isDisabled = activeType === "Specific" && activeVerNo === instanceNo || activeType === "Recent" && latestInstance?.instanceNo === instanceNo;
  const buttonText = "Delete Version: " + instanceNo;
  const handleClick = (event2, p, item, i) => {
    console.log("handleClick() - item.code is : " + item.code);
    if (item.code === "delete") {
      console.log("delete clicked");
      setAlertOpen(true);
    }
    event2.preventDefault();
  };
  const checkDisabled = () => {
    return isDisabled;
  };
  const handleAccept = () => {
    console.log("handleAccept");
    da.processInstanceDeleteContinue();
    setAlertOpen(false);
  };
  const handleReject = () => {
    console.log("handleReject");
    setAlertOpen(false);
  };
  let alertOptions = {
    format: "form",
    bucket: {
      question: "Delete a form version?",
      content: "This will remove a specific version of a form. This implies once it has been removed, it will not be recoverable. Are you sure you want to delete?",
      accept: "Agree",
      reject: "Reject",
      handleAccept,
      handleReject,
      state: alertOpen
    }
  };
  const buttonList = [
    {
      code: "delete",
      display: buttonText,
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Delete" })
        //<DeleteIcon />,
      }
    }
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CreateButtonGroup,
      {
        list: buttonList,
        onClick: handleClick,
        handleCheckDisabled: checkDisabled,
        user: "save",
        fullWidth: false,
        label: null,
        size: "small"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { ...alertOptions })
  ] });
}
function BuildOutputCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const items = function() {
    let index = 1;
    const items2 = da.selected({ entity: "items", type: "get" });
    return items2.map((item) => {
      let child = item.child && item.child.length > 0 ? item.child.toString().substr(13) : "none";
      let parent = item.parent ? item.parent.toString() : "none";
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { id: "config-items-row", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "item", children: index++ }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "seqno", children: item.seqno }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "parent", children: parent }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "item", children: item.item }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "children", children: child })
      ] }, index);
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: "Form Items" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { border: "1", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { id: "config-items-hdr", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { className: "item", children: "Item" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { className: "seqno", children: "Seqno" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { className: "parent", children: "Parent" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { className: "item", children: "Item" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("th", { className: "children", children: "Children" })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: items() })
    ] })
  ] });
}
function BuildRawhtmlComp(props) {
  const da = props.da;
  let raw;
  let scrubed;
  const scrub = (raw2) => {
    var strNum = function(n) {
      if (n < 10) return "0" + n;
      else return "" + n;
    };
    var depth = 0;
    var cleanMarkup = raw2 && raw2.replace(/<\/div|<div|<\/span|<span|</g, function(x) {
      if (x === "</div" || x === "</span") {
        depth = depth - 1;
        var y = "\n" + strNum(depth) + new Array(depth * 4).join(" ") + x;
        return y;
      } else if (x === "<div" || x === "<span") {
        var y = "\n" + strNum(depth) + new Array(depth * 4).join(" ") + x;
        depth = depth + 1;
        return y;
      } else {
        var y = "\n" + strNum(depth) + new Array(depth * 4).join(" ") + x;
        return y;
      }
    });
    return cleanMarkup;
  };
  let p = new P({
    rendertype: "rawhtml",
    formtype: "Raw",
    formName: "user",
    accountNo: da.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    }),
    formNo: da.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" }),
    instance: da.selected({ entity: "instances", type: "get" }),
    items: da.selected({ entity: "items", type: "get" })
    // <<< NOTE: Passing an array of items
    // inline not set
  });
  React__default.createElement(FormCtnr, { p });
  scrubed = scrub(raw);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: "Form Html" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", { placeholder: "Configured HTML", defaultValue: scrubed })
  ] });
}
function BuildSourceActive(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const activeVerNo = da.selected({
    entity: "forms",
    type: "get",
    action: "prop",
    property: "activeVerNo"
  });
  const instances = da.repo({ entity: "instances", type: "get" });
  let currentActiveInstanceNdx = null;
  const menuList = instances.map((instance, i) => {
    if (instance.instanceNo == activeVerNo) currentActiveInstanceNdx = i;
    return {
      code: instance.instanceNo,
      display: instance.instanceNo,
      bucket: { color: "primary", variant: "contained" }
    };
  });
  const handleSelection = (e, p, item, i) => {
    console.log(
      "ActiveVersion:handleClick - current version is : " + da.selected({ entity: "form", type: "get", action: "prop", property: "activeVerNo" })
    );
    console.log("ActiveVersion:handleClick - change active version to : " + item.code);
    da.processActiveInstanceNo(item.code);
  };
  const menuOptions = {
    format: "form",
    // V1
    items: menuList,
    bucket: {
      p: null,
      color: "primary",
      variant: "outlined",
      size: "small",
      handleSelection,
      selection: currentActiveInstanceNdx,
      sysStyle: {
        width: "30px",
        // button dropdown for 'Active:'
        height: "30px",
        zIndex: "9000"
      },
      usrStyle: null
    }
  };
  const srcNo = da.selected({
    entity: "instances",
    type: "get",
    action: "prop",
    property: "srcNo"
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
    "Source: ",
    srcNo ? srcNo : "None",
    "     Active:",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonMenuCtnr, { ...menuOptions })
  ] }) });
}
function BuildTraversalCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const handlePrevClick = function(e) {
    da.processChangeInstance("prev");
    e.preventDefault();
  };
  const handleNextClick = function(e) {
    da.processChangeInstance("next");
    e.preventDefault();
  };
  da.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" });
  const instanceNo = da.selected({
    entity: "instances",
    type: "get",
    action: "prop",
    property: "instanceNo"
  });
  const currentInstanceNdx = da.selected({ entity: "instances", type: "get", action: "index" });
  const totalInstances = da.repo({ entity: "instances", type: "get" }).length;
  const styleIcon = {
    marginRight: "16px",
    width: 32,
    height: 32,
    display: "inline-flex",
    alignSelf: "center",
    top: "0.4em",
    position: "relative"
  };
  const styleWord = { marginRight: "16px" };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...styleWord }, children: "Form No:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...styleWord }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MainFormNoDisplay, { store: da, display: "inline" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...styleWord }, children: "Version No:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...styleWord }, children: instanceNo }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "", onClick: handlePrevClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Left", color: "primary", sx: styleIcon }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...styleWord }, children: currentInstanceNdx + 1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...styleWord }, children: "of" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...styleWord }, children: totalInstances }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "", onClick: handleNextClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Right", color: "primary", sx: styleIcon }) })
  ] });
}
function CreateButtonGroup(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  const theme = useTheme();
  const { list, onClick, handleCheckDisabled, user, fullWidth, label: label2, size = "small" } = props;
  const matches = useMediaQuery((theme2) => theme2.breakpoints.up("lg"));
  let responsiveType = "button";
  if (!matches) {
    responsiveType = "iconbutton";
  }
  const buttonList = list.map((item) => {
    const display = item.display || item.code;
    const type = item.bucket.type ? item.bucket.type : responsiveType;
    const variant = item.bucket.variant ? item.bucket.variant : "contained";
    const color2 = item.bucket.color ? item.bucket.color : "primary";
    const btnSize = item.bucket.size ? item.bucket.size : size;
    const tip = item.bucket.tip ? item.bucket.tip : display;
    let iconStyleProp = { marginRight: "0px", paddingTop: "6px" };
    let buttonStyleProp = { pt: 0, pb: 0, pl: 1, pr: 1, mr: 2 };
    if (user == "submenu") {
      iconStyleProp = { marginRight: "8px", paddingTop: "6px" };
      buttonStyleProp = { pt: "4px", pb: 0, pl: 1, pr: 1, mr: 0 };
    } else if (user == "formbuilder") {
      iconStyleProp = { marginRight: "0px", paddingTop: "6px" };
      buttonStyleProp = { pt: 0, pb: 0, pl: 1, pr: 1, mr: 2 };
    } else if (user == "save") {
      if (matches) {
        iconStyleProp = { marginRight: "8px", paddingTop: "6px" };
        buttonStyleProp = { pt: 0, pb: 0, pl: 2, pr: 2, mr: 5 };
      } else {
        iconStyleProp = { marginRight: "16px", paddingTop: "6px" };
        buttonStyleProp = { pt: 0, pb: 0, pl: 2, pr: 2, mr: 0 };
      }
    } else if (user == "action") {
      if (matches) {
        iconStyleProp = { marginRight: "8px", paddingTop: "6px" };
        buttonStyleProp = { pt: 0, pb: 0, pl: 2, pr: 2, mr: 2 };
      } else {
        iconStyleProp = { marginRight: "16px", paddingTop: "6px" };
        buttonStyleProp = { pt: 0, pb: 0, pl: 2, pr: 2, mr: 0 };
      }
    }
    const clone = {
      code: item.code,
      display,
      bucket: {
        type,
        iconLeft: item.bucket.iconLeft || null,
        iconRight: item.bucket.iconRight || null,
        variant,
        handleCheckDisabled,
        color: color2,
        size: btnSize,
        tip,
        iconStyle: iconStyleProp,
        btnStyle: buttonStyleProp,
        p: item.bucket.p || {}
      }
    };
    return clone;
  });
  const nav = {
    padding: "4px 4px",
    marginRight: "4px",
    [theme.breakpoints.up("sm")]: {
      marginRight: "24px"
    },
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    // width: 'max-content',
    fontWeight: 300,
    fontSize: "3.0rem",
    color: theme.palette.text.primary
  };
  const active = {
    color: theme.palette.secondary.main,
    "& $icon": {
      color: theme.palette.secondary.main
    }
  };
  const btnOptions = {
    format: "form",
    items: buttonList,
    bucket: {
      p: {},
      label: label2,
      // Label to be used for group of buttons
      handleClick: onClick,
      fullWidth,
      // Span full width of parent 
      variant: "contained",
      // variant for the group
      size,
      // size for the group 'large' 'small' 'medium'
      classNav: nav,
      classActive: active,
      orientation: "horizontal"
      // 'vertical' | 'horizontal'
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...btnOptions });
}
function ItemListActionToolbarCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const toolbarType = props.toolbarType;
  const [alertOpen, setAlertOpen] = React__default.useState(false);
  da.isTracker();
  let wrk = da.work({ entity: "wrk", type: "get" });
  let cut = da.work({ entity: "cut", type: "get" });
  let copy = da.work({ entity: "copy", type: "get" });
  cut.item;
  copy.item;
  wrk.item;
  da.work({ entity: "flag", type: "get", action: "prop", property: "configMode" });
  da.work({
    entity: "flag",
    type: "get",
    action: "prop",
    property: "configView"
  });
  wrk.seqno;
  const itemListActionList = [
    {
      code: "Up",
      display: "Up",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Up" }),
        // KeyboardArrowUpIcon
        variant: "outlined"
      }
    },
    {
      code: "Down",
      display: "Down",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Down" }),
        // KeyboardArrowDownIcon 
        variant: "outlined"
      }
    },
    {
      code: "Cut",
      display: "Cut",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Clear" }),
        // <ClearIcon />,
        variant: "outlined"
      }
    },
    {
      code: "Copy",
      display: "Copy",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "FileCopy" }),
        // <FileCopyIcon />,
        variant: "outlined"
      }
    },
    {
      code: "Paste",
      display: "Paste",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "NoteAdd" }),
        // <NoteAddIcon />,
        variant: "outlined"
      }
    },
    {
      code: "Delete",
      display: "Remove",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Block" }),
        // <BlockIcon />,
        variant: "outlined"
      }
    },
    {
      code: "Clear",
      display: "Clear All",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Delete" }),
        // <DeleteIcon />,
        variant: "outlined"
      }
    }
  ];
  const itemListSaveList = [
    {
      code: "Layout",
      display: "Layout",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Web" })
        // <WebIcon />,
      }
    },
    {
      code: "Description",
      display: "Description",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "GridOn" })
        // <GridOnIcon />,
      }
    },
    {
      code: "Save",
      display: "Save",
      bucket: {
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Save" })
        // <SaveIcon />,
      }
    }
  ];
  const handleAccept = (p) => {
    da.processClearAllItems();
    setAlertOpen(false);
  };
  const handleReject = (p) => {
    setAlertOpen(false);
  };
  let alertOptions = {
    format: "form",
    bucket: {
      p: null,
      question: "Clear this version of form?",
      content: "This will remove all data entry fields from this version of form. This implies once it has been removed, it will not be recoverable. Are you sure you want to clear?",
      accept: "Agree",
      reject: "Reject",
      handleAccept,
      handleReject,
      state: alertOpen
    }
  };
  const buttonGroupOnClick = function(e, p, item, i) {
    const code = item.code;
    switch (code) {
      //
      // Action command processors
      //
      case "Save":
        da.processSave();
        break;
      case "Up":
        da.processMoveSelectedItem("up");
        break;
      case "Down":
        da.processMoveSelectedItem("down");
        break;
      case "Cut":
        da.processCutSelectedItem();
        break;
      case "Copy":
        da.processCopySelectedItem();
        break;
      case "Paste":
        da.processPasteSelectedItem();
        break;
      case "Delete":
        da.processDeleteSelectedItem();
        break;
      case "Clear":
        setAlertOpen(true);
        break;
      case "Layout":
        da.setWorkFlag("configView", "configItems");
        break;
      case "Description":
        da.setWorkFlag("configView", "configForm");
        break;
    }
    e.preventDefault();
  };
  const isDisabledBtn = function(p, item, i) {
    const code = item.code;
    let wrk2 = da.work({ entity: "wrk", type: "get" });
    let cut2 = da.work({ entity: "cut", type: "get" });
    let copy2 = da.work({ entity: "copy", type: "get" });
    da.work({ entity: "nail", type: "get" });
    da.work({ entity: "flag", type: "get" });
    const mode2 = da.work({ entity: "flag", type: "get", action: "prop", property: "configMode" });
    const isViewMode2 = mode2 == "view";
    const itemsSelected = da.selected({ entity: "items", type: "get" });
    const itemsLength = itemsSelected?.length || 0;
    switch (code) {
      case "Up":
        return wrk2.seqno == -1 || isViewMode2;
      case "Down":
        return wrk2.seqno == -1 || isViewMode2;
      case "Cut":
        return wrk2.seqno == -1 || cut2.item !== null || isViewMode2;
      case "Copy":
        return wrk2.seqno == -1;
      case "Paste":
        return cut2.item == null && copy2.item == null || isViewMode2;
      case "Delete":
        return wrk2.seqno == -1 || isViewMode2;
      case "Clear":
        return itemsLength == 0 || isViewMode2;
      case "Save":
        return !da.isTracker() && !da.isTrackerForms() && !da.isTrackerInstances() || itemsLength == 0 || isViewMode2;
      case "Layout":
        return false;
      case "Description":
        return false;
    }
    return true;
  };
  let buttonGroupItems = null;
  let wgtUser = null;
  if (toolbarType === "save") {
    buttonGroupItems = itemListSaveList;
    wgtUser = "save";
  } else {
    buttonGroupItems = itemListActionList;
    wgtUser = "action";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CreateButtonGroup,
      {
        list: buttonGroupItems,
        onClick: buttonGroupOnClick,
        handleCheckDisabled: isDisabledBtn,
        user: wgtUser,
        fullWidth: false,
        label: null,
        size: "small"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { ...alertOptions })
  ] });
}
function ItemPropEditorCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  let show = !da.isConfigEditorComponents();
  if (!show) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " configEditor is not set to editorProperties " }) });
  } else {
    let p = new P({
      rendertype: "submit",
      // 'build' | 'submit' | 'preview' | 'prop editor'
      formtype: "Meta",
      // User|Meta|Record|List|Service
      formName: "item",
      accountNo: 1,
      formNo: da.getMetaForms("item").forms.formNo,
      instance: da.getMetaFormsProperty("item", "instances"),
      items: da.getMetaFormsProperty("item", "items")
      // inline not set
    });
    let prompt = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { color: "red", fontWeight: 600, paddingBottom: "16px", paddingTop: "16px" }, children: "Select a form component to edit properties." });
    if (da.getWorkWrk()?.item?.wgt)
      prompt = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { fontWeight: 600, paddingBottom: "16px", paddingTop: "16px" }, children: [
        "Edit Component: ",
        da.getWorkWrk().item.wgt
      ] });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-where": "ItemPropEditorCtnr", children: [
      prompt,
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormCtnr, { p })
    ] });
  }
}
const MoreVertIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVert");
const ShareIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92"
}), "Share");
const CreateIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Create");
const DeleteIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");
const VisibilityIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), "Visibility");
const LaunchIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "Launch");
const ListIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z"
}), "List");
function ListCreateCard(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const cardInfo = props.cardInfo;
  const size = props.size;
  const keyval = props.keyval;
  const theme = useTheme();
  const DISABLED_FORM_BG = theme.palette.grey[600];
  const getCardValue = function(cardInfo2, colName) {
    let form = cardInfo2.form;
    let instance = cardInfo2.instance;
    let value2 = "";
    switch (colName) {
      // instance values
      case "":
        break;
      case "updatedAt":
        const formValue = form && form[colName] && new Date(form[colName]) || /* @__PURE__ */ new Date();
        const instaValue = instance && instance[colName] && new Date(instance[colName]) || /* @__PURE__ */ new Date();
        value2 = formValue < instaValue ? instaValue : formValue;
        value2 = value2 && value2.toLocaleString("en-US").substr(0, 10) || "";
        break;
      case "accountId":
        break;
      case "audit_lusr":
        break;
      case "name":
        value2 = instance && instance[colName] || "No name specified";
        value2 = value2 && value2.substr(0, 30) || "";
        break;
      case "instanceNo":
        value2 = instance && instance[colName] || "";
        break;
      case "status":
        value2 = form && form[colName] || "";
        break;
      case "accessType":
        value2 = form && form[colName] || "";
        break;
      // form values
      case "activeType":
        value2 = form && form[colName] || "";
        break;
      case "formNo":
        value2 = form && form[colName] || "";
        break;
      case "desc":
        value2 = form && form[colName] || "";
        break;
      // other values
      case "image":
        const rand = Math.floor(Math.random() * 9) + 1 || Math.floor(Math.random() * 9) + 1;
        value2 = `images/flower${rand}.jpg`;
        break;
    }
    return value2;
  };
  const buildCard = (cardInfo2) => {
    const avatar = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MainFormNoDisplay, { store: da, form: cardInfo2.form }) });
    const header = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, children: getCardValue(cardInfo2, "name") });
    const isPublic = getCardValue(cardInfo2, "accessType") == "Public";
    const isPublicStr = isPublic ? "   Public " : "";
    const subheader = getCardValue(cardInfo2, "updatedAt") + "   @ V" + getCardValue(cardInfo2, "instanceNo") + isPublicStr;
    const image2 = getCardValue(cardInfo2, "image");
    const actionBar = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IconButton,
        {
          "aria-label": "Edit",
          title: "Build Form",
          onClick: (event2) => {
            cardInfo2.cardActionHandler(event2, cardInfo2, "edit");
          },
          size: "medium",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(CreateIcon, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IconButton,
        {
          "aria-label": "Preview",
          title: "Preview Active Version",
          onClick: (event2) => {
            cardInfo2.cardActionHandler(event2, cardInfo2, "preview");
          },
          size: "medium",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisibilityIcon, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IconButton,
        {
          "aria-label": "Review Data",
          title: "Review Form Submissions Data",
          onClick: (event2) => {
            cardInfo2.cardActionHandler(event2, cardInfo2, "data");
          },
          size: "medium",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListIcon, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IconButton,
        {
          "aria-label": "Launch Form",
          title: "Launch and Submit Form",
          onClick: (event2) => {
            cardInfo2.cardActionHandler(event2, cardInfo2, "launch");
          },
          size: "medium",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(LaunchIcon, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IconButton,
        {
          "aria-label": "Share in marketplace",
          title: "Share Form In Marketplace",
          onClick: (event2) => {
            cardInfo2.cardActionHandler(event2, cardInfo2, "share");
          },
          size: "medium",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(ShareIcon, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        IconButton,
        {
          "aria-label": "Delete",
          title: "Delete Form",
          onClick: (event2) => {
            cardInfo2.cardActionHandler(event2, cardInfo2, "delete");
          },
          size: "medium",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteIcon, {})
        }
      )
    ] });
    const mainContent = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", color: "textSecondary", component: "p", children: getCardValue(cardInfo2, "desc") || "Some descriptive text explaining what is the functionality for this specific form. The 'desc' field from where this text will be extracted is yet to be added to 'forms' database table. The associated property update logic in the meta form also needs to be handled." });
    const addlContent = null;
    const isDisabled = getCardValue(cardInfo2, "status") !== "Enabled";
    const tip = isDisabled && isPublic ? "This form is public and has been disabled." : isPublic ? "This form is public." : isDisabled ? "This form has been disabled." : "";
    const cardActionAreaHandler = (event2) => {
      cardInfo2.cardActionHandler(event2, cardInfo2, "actionarea");
    };
    const options22 = {
      format: "form",
      bucket: {
        avatar,
        actionMenu: null,
        //actionMenu,
        header,
        subheader,
        image: image2,
        tip,
        mainContent,
        actionBar,
        // optional
        addlContent,
        // optional
        cardActionAreaHandler,
        className: {
          minHeight: "400px",
          minWidth: "280px",
          // 310
          padding: 1,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          backgroundColor: isDisabled ? DISABLED_FORM_BG : "transparent"
        }
      }
    };
    return options22;
  };
  const options2 = buildCard(cardInfo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size, "data-where": "ListCreateCard", children: /* @__PURE__ */ createElement(CardComp, { ...options2, key: keyval }) });
}
const AddIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");
const useStyles$x = (theme) => ({
  button: {
    marginRight: theme.spacing(1)
  }
});
function ListCreateFormComp(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const formCnt = props.formCnt;
  const theme = useTheme();
  const classes = useStyles$x(theme);
  const featureAccessCheckFn = da.appState.featureAccessCheck;
  const handleClick = (event2, p, item, i) => {
    console.log("handleClick() - item.code is : " + item.code);
    if (item.code === "create") {
      da.processCreateNewForm();
    }
    event2.preventDefault();
  };
  const checkDisabled = () => {
    const accessCheckMsg = featureAccessCheckFn.check({ featureId: "form-library-createNewForm", options: { formCnt } });
    if (accessCheckMsg) return true;
    else return false;
  };
  const addIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(AddIcon, {});
  const buttonList = [
    {
      code: "create",
      display: "Create New Form",
      bucket: {
        type: "button",
        handleCheckDisabled: checkDisabled,
        iconLeft: addIcon,
        iconRight: null,
        className: classes.button,
        variant: "contained",
        color: "secondary"
      }
    }
  ];
  const btnOptions = {
    format: "form",
    items: buttonList,
    bucket: {
      p: null,
      label: null,
      handleClick,
      width: "fixed",
      variant: "contained",
      size: "large"
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...btnOptions, "data-where": "ListCreateFormComp" });
}
const FavoriteIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"
}), "Favorite");
function SampleDemoCard(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  props.cardInfo;
  const useStyles3 = (theme2) => ({
    icon: {
      marginRight: theme2.spacing(2)
    },
    heroContent: {
      backgroundColor: theme2.palette.background.paper,
      padding: theme2.spacing(8, 0, 6)
    },
    heroButtons: {
      marginTop: theme2.spacing(4)
    },
    cardGrid: {
      paddingTop: theme2.spacing(8),
      paddingBottom: theme2.spacing(8)
    },
    card: {
      height: "100%",
      display: "flex",
      flexDirection: "column"
    },
    cardMedia: {
      paddingTop: "56.25%"
      // 16:9
    },
    cardContent: {
      flexGrow: 1
    },
    footer: {
      backgroundColor: theme2.palette.background.paper,
      padding: theme2.spacing(6)
    },
    avatar: {
      backgroundColor: colors.red[500]
    }
  });
  const theme = useTheme();
  const classes = useStyles3(theme);
  const buildCard = (cardInfo2) => {
    const avatar = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, { "aria-label": "Recipe", sx: { ...classes.avatar }, children: "R" }) });
    const actionMenu = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { "aria-label": "Settings", size: "large", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MoreVertIcon, {}) }) });
    const header = "Shrimp and Chorizo Paella";
    const subheader = "September 14, 2016";
    const image2 = "https://source.unsplash.com/random";
    const tip = "Paella dish";
    const actionBar = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { "aria-label": "Add to favorites", size: "large", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FavoriteIcon, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { "aria-label": "Share", size: "large", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ShareIcon, {}) })
    ] });
    const mainContent = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", color: "textSecondary", component: "p", children: "This impressive paella is a perfect party dish and a fun meal to cook together with your guests. Add 1 cup of frozen peas along with the mussels, if you like." }) });
    const addlContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { paragraph: true, children: "Method:" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { paragraph: true, children: "Heat 1/2 cup of the broth in a pot until simmering, add saffron and set aside for 10 minutes." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { paragraph: true, children: "Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { paragraph: true, children: "Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook again without stirring, until mussels have opened and rice is just tender, 5 to 7 minutes more. (Discard any mussels that don’t open.)" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { children: "Set aside off of the heat to let rest for 10 minutes, and then serve." })
    ] });
    const options22 = {
      format: "form",
      bucket: {
        avatar,
        actionMenu,
        header,
        subheader,
        image: image2,
        tip,
        mainContent,
        actionBar,
        // optional
        addlContent
        // optional
      }
    };
    return options22;
  };
  const options2 = buildCard();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardComp, { ...options2 });
}
let componentsCategories = [];
let components = [];
let themesCategories = [];
let themes = [];
function _createCategories(da, type, palette) {
  let categories = [];
  palette.forEach((item) => {
    if (!categories.includes(item.category) && item.type == type) {
      categories.push(item.category);
    }
  });
  return categories;
}
const _renderCategoryItems = function(da, type, category, palette) {
  var paletteCategory = palette.filter((item) => {
    if (item.type !== type || item.category !== category) return false;
    else return true;
  });
  var markup = paletteCategory.map((item, i) => {
    item.support.feature ? "" : "feature-notsupported-" + da.getRunEnv();
    const categoryListItem = {
      code: item.wgt,
      // V1
      display: item.wgt,
      bucket: { ref: item, disabled: !item.support.feature }
    };
    return categoryListItem;
  });
  return markup;
};
const _renderTypeCategories = function(da, type, categories, palette) {
  const handleClick = function(e, p, item, i) {
    const ref = item.bucket.ref;
    ref.type;
    const category = ref.category;
    da.processWidgetSelection(ref.type, category, ref);
    e.stopPropagation();
  };
  var markup = categories.map((category, i) => {
    const categoryList = _renderCategoryItems(da, type, category, palette);
    const listOptions = {
      format: "form",
      // V1
      items: categoryList,
      bucket: { p: null, handleClick }
    };
    const Children2 = () => /* @__PURE__ */ jsxRuntimeExports.jsx(ListCtnr, { ...listOptions });
    const accordionListItem = {
      code: category,
      // V1
      display: category,
      bucket: { children: Children2() }
    };
    return accordionListItem;
  });
  return markup;
};
function PaletteListCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const type = props.type;
  let show = da.isConfigEditorComponents() && type === "Components" ? true : (
    //(da.getWorkFlag('configEditor') === 'editorThemes' && type === 'Themes') ?
    //true :
    false
  );
  if (!show) {
    return null;
  } else {
    let accordionList = null;
    console.time("TypeCategories");
    let palette;
    if (type == "Components") {
      if (componentsCategories.length == 0) {
        console.log("PaletteListCtnr: Create Components");
        palette = da.getPalette();
        componentsCategories = _createCategories(da, type, palette);
        components = _renderTypeCategories(da, type, componentsCategories, palette);
      }
      accordionList = components;
    } else if (type == "Themes") {
      if (themesCategories.length == 0) {
        console.log("PaletteListCtnr: Create Themes");
        palette = da.getPalette();
        themesCategories = _createCategories(da, type, palette);
        themes = _renderTypeCategories(da, type, themesCategories, palette);
      }
      accordionList = themes;
    } else {
      console.error("PaletteListCtnr - Unable to handle type = " + type);
    }
    console.timeEnd("TypeCategories");
    console.log("PaletteListCtnr: size of accordionList : " + accordionList.length);
    const accordionOptions = {
      format: "form",
      // V1
      items: accordionList,
      bucket: {}
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(MuiAccordion, { ...accordionOptions });
  }
}
function PreviewItemListCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  da.isSubmitDisabled();
  let p = new P({
    rendertype: "preview",
    // 'build' | 'submit' | 'preview' | 'prop editor'
    formtype: "User",
    // User|Meta|Record|List|Service
    formName: "user",
    accountNo: da.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    }),
    formNo: da.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" }),
    // 'metaAccount' (unused) | 'metaMembers' (unused) etc.,
    instance: da.selected({ entity: "instances", type: "get" }),
    //da.getSelectedInstance(),
    items: da.selected({ entity: "items", type: "get" })
    // da.getSelectedItems()     // <<< NOTE: Passing in an array of items
    // inline not set
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormCtnr, { p });
}
function FormBody(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const nav = da.getNav();
  const auth = useAuth();
  console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FormBody: spaState", spaState);
  auth.isAuthenticated;
  let currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormHomePage, {});
  if (nav === "home") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormHomePage, {});
  if (nav === "library") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(LibraryPage, {});
  if (nav === "build") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(BuildPage, {});
  if (nav === "preview") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(PreviewPage, {});
  if (nav === "submissions") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(SubmissionsPage, {});
  if (nav === "market") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(MarketPage, {});
  if (da.isInit() || nav === "home") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: currentPage });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: da.getStateMsg() });
  }
}
const useStyles$w = (theme) => ({
  drawer: {
    width: "240px",
    marginTop: "64px",
    [theme.breakpoints.up("md")]: {
      marginTop: "64px",
      height: "calc(100% - 64px)"
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  },
  navButton: {
    color: colors.blueGrey[800],
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    fontWeight: theme.typography.fontWeightMedium
  },
  activeButton: {
    textTransform: "none",
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    "& $icon": {
      color: theme.palette.primary.main
    }
  }
});
const FormSidebar = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const { open, variant, onClose, className, ...rest } = props;
  const theme = useTheme();
  const classes = useStyles$w(theme);
  const nav = da.getNav();
  const isAuthenticated2 = da.isAuthenticated();
  const handleClick = (event2, p, item, i) => {
    console.log("handleClick() - item.code is : " + item.code);
    da.setNav(item.code);
    event2.preventDefault();
  };
  const checkDisabled = (p, item, i) => {
    if (da.getNav() === item.code) return true;
    if (item.code === "build" || item.code === "preview" || item.code === "data") {
      if (!da.isFormSelected()) return true;
    }
    return false;
  };
  const buttonList = [
    {
      code: "home",
      display: "Home",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Home" }),
        iconRight: null,
        className: nav === "home" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "App home page"
      }
    }
  ];
  if (isAuthenticated2)
    buttonList.push({
      code: "list",
      display: "Library",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "LibraryBooks" }),
        iconRight: null,
        className: nav === "list" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Library of all forms"
      }
    });
  if (isAuthenticated2)
    buttonList.push({
      code: "build",
      display: "Build",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Build" }),
        iconRight: null,
        className: nav === "build" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "#ff0000",
        tip: "Create/Update a form"
      }
    });
  if (isAuthenticated2)
    buttonList.push({
      code: "preview",
      display: "Preview",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Pageview" }),
        iconRight: null,
        className: nav === "preview" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Preview currently selected form"
      }
    });
  if (isAuthenticated2)
    buttonList.push({
      code: "data",
      display: "Submissions",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "List" }),
        iconRight: null,
        className: nav === "data" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "View form submissions data"
      }
    });
  if (da.isDev()) {
    if (isAuthenticated2)
      buttonList.push({
        code: "market",
        display: "Marketplace",
        bucket: {
          type: "button",
          iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Store" }),
          iconRight: null,
          className: nav === "market" ? classes.activeButton : classes.navButton,
          variant: "contained",
          color: "default",
          tip: "Marketplace forms"
        }
      });
  }
  const navOptions = {
    format: "form",
    items: buttonList,
    bucket: {
      p: null,
      label: null,
      handleClick,
      checkDisabled,
      width: "fixed",
      variant: "contained",
      size: "large",
      className: classes.nav,
      orientation: "vertical"
      // 'vertical' | 'horizontal'
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Drawer,
    {
      anchor: "left",
      onClose,
      open,
      variant,
      sx: {
        [`& .MuiDrawer-paper`]: { ...classes.drawer }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...classes.root }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Profile, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { sx: { ...classes.divider } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ListButtonCtnr, { ...navOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { sx: { ...classes.divider } })
      ] })
    }
  );
};
FormSidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};
const image = "data:image/jpeg;base64,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";
function FormHomePage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  let appName = "Forms Builder";
  const pwa = "Notification" in window && navigator.serviceWorker ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormPWA, {}) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CommonHomePageLayout, { image, appName, pwa });
}
function BuildPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const panelHeight = "480px";
  let instance = da.selected({
    entity: "instances",
    type: "get"
  });
  const componentPanel = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { overflowY: "scroll", overflowX: "hidden", height: panelHeight }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaletteListCtnr, { type: "Components" }) });
  const propertiesPanel = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { overflowY: "scroll", overflowX: "hidden", height: panelHeight }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ItemPropEditorCtnr, {}) });
  const tabList = [
    { code: "Components", display: "Components", bucket: { children: componentPanel } },
    { code: "Properties", display: "Properties", bucket: { children: propertiesPanel } }
  ];
  const handleChange = (e, p, item, i) => {
    console.log("BuildPage:handleSelection for tab : " + item.display + " " + i);
    if (item.code === "Components") da.setWorkFlag("configEditor", "editorComponents");
    else if (item.code === "Properties") da.setWorkFlag("configEditor", "editorProperties");
    else da.setWorkFlag("configEditor", "unknown");
  };
  const selectPanel = da.isConfigEditorComponents() ? 0 : 1;
  const tabOptions = {
    format: "form",
    items: tabList,
    bucket: { p: null, handleChange, selectPanel }
  };
  const isShowFormToolbar = () => {
    let show = da.isConfigViewItems();
    return show;
  };
  const formCtnr = () => {
    let show = da.isConfigViewItems();
    if (!show) {
      return null;
    } else {
      let p = new P({
        rendertype: "build",
        // 'build' | 'submit' | 'preview' | 'prop editor'
        formtype: "User",
        // User|Meta|Record|List|Service
        formName: "user",
        accountNo: da.selected({
          entity: "accounts",
          type: "get",
          action: "prop",
          property: "accountNo"
        }),
        formNo: da.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" }),
        instance: da.selected({ entity: "instances", type: "get" }),
        items: da.selected({ entity: "items", type: "get" })
        // <<< NOTE: Passing an array of items
        // inline not set
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormCtnr, { p });
    }
  };
  const formCtnrHtml = formCtnr();
  const instanceName = instance?.name;
  const mode = da.work({ entity: "flag", type: "get", action: "prop", property: "configMode" });
  if (!instance || !instance.name) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "No Form Available To Build", tip: "Click on LIBRARY tab and then on CREATE NEW FORM to create a form." });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormBuildPageLayout,
      {
        tabs: /* @__PURE__ */ jsxRuntimeExports.jsx(MuiTabs, { ...tabOptions }),
        instanceName,
        buildTraversalCtnr: /* @__PURE__ */ jsxRuntimeExports.jsx(BuildTraversalCtnr, {}),
        buildSourceActive: /* @__PURE__ */ jsxRuntimeExports.jsx(BuildSourceActive, {}),
        itemListActionToolbarCtnrSave: /* @__PURE__ */ jsxRuntimeExports.jsx(ItemListActionToolbarCtnr, { toolbarType: "save" }),
        itemListActionToolbarCtnrAction: /* @__PURE__ */ jsxRuntimeExports.jsx(ItemListActionToolbarCtnr, { toolbarType: "action" }),
        buildCreateVersion: /* @__PURE__ */ jsxRuntimeExports.jsx(BuildCreateVersion, {}),
        buildDeleteVersion: /* @__PURE__ */ jsxRuntimeExports.jsx(BuildDeleteVersion, {}),
        formCtnrHtml,
        formPropEditorCtnr: /* @__PURE__ */ jsxRuntimeExports.jsx(FormPropEditorCtnr, {}),
        isConfigViewItems: da.isConfigViewItems(),
        isShowFormToolbar: isShowFormToolbar(),
        mode: mode.toUpperCase(),
        store: da
      }
    );
  }
}
function PreviewPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const featureAccessCheckFn = da.appState.featureAccessCheck;
  featureAccessCheckFn.check({ featureId: "xyz" });
  const formNo = da.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" });
  if (!formNo) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "No Form Available To Preview", tip: "Click on LIBRARY tab and then on CREATE NEW FORM to create a form." });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormPreviewPageLayout,
      {
        formHeader: /* @__PURE__ */ jsxRuntimeExports.jsx(FormHeader, {}),
        previewItemListCtnr: /* @__PURE__ */ jsxRuntimeExports.jsx(PreviewItemListCtnr, { store: da })
      }
    );
  }
}
function LibraryPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  console.log("LibraryPage ============================= RERENDER =================");
  const { appState, dispatch } = useAppContext();
  const [alertOpen, setAlertOpen] = React__default.useState(false);
  const [delCardInfo, setDelCardInfo] = React__default.useState({ form: null, instance: null });
  const [searchTerm, setSearchTerm] = React__default.useState("");
  da.selected({ entity: "instances", type: "get" });
  const getEnvVar2 = appState.getEnvVar;
  const handleAccept = (p) => {
    da.processDeleteForm(delCardInfo.form, delCardInfo.instance);
    setAlertOpen(false);
  };
  const handleReject = (p) => {
    setAlertOpen(false);
  };
  let alertOptions = {
    format: "form",
    bucket: {
      p: null,
      question: "Delete this form?",
      content: "This will remove the form and all associated form submissions. This implies once it has been removed, it will not be recoverable. You may just want to disable the form and not loose all the associated submissions. Are you sure you want to delete? ",
      accept: "Agree",
      reject: "Reject",
      handleAccept,
      handleReject,
      state: alertOpen
    }
  };
  const accountNo = da.selected({
    entity: "accounts",
    type: "get",
    action: "prop",
    property: "accountNo"
  });
  let forms = da.repo({ entity: "forms", type: "get", accountNo });
  forms = forms.sort((a, b) => {
    return a.formNo - b.formNo;
  });
  const copyToClipboard = () => {
    const url2 = da.getSelectedFormURL();
    navigator.clipboard.writeText(url2);
  };
  const cardActionHandler = (event2, cardInfo, action) => {
    console.log("LibraryPage:cardActionHandler - Clicked " + action);
    if (action === "actionarea") {
      da.setSelection(cardInfo.form, cardInfo.instance);
      copyToClipboard();
    } else if (action === "share") {
      da.shareForm(cardInfo.form, cardInfo.instance);
    } else if (action === "data") {
      da.viewData(cardInfo.form, cardInfo.instance);
    } else if (action === "edit") {
      da.editForm(cardInfo.form, cardInfo.instance);
    } else if (action === "preview") {
      da.previewForm(cardInfo.form, cardInfo.instance);
    } else if (action === "launch") {
      da.launchForm(cardInfo.form, cardInfo.instance);
    } else if (action === "delete") {
      setDelCardInfo(cardInfo);
      setAlertOpen(true);
    }
    event2.preventDefault();
  };
  let cardInfoList = forms.map((form, i, src) => {
    const instance = da.repo({
      entity: "instances",
      type: "get",
      action: "per-form",
      accountNo,
      value: form
    });
    const cardInfo = { form, instance, cardActionHandler };
    return cardInfo;
  });
  cardInfoList = cardInfoList.filter((cardInfo) => {
    return cardInfo.instance?.name.includes(searchTerm) || "";
  });
  let cardList = cardInfoList.map((cardInfo, i, src) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ListCreateCard, { cardInfo, keyval: i, size: { xs: 12, sm: 6, md: 4, lg: 3, xl: 3 } }, i);
  });
  const cardCtnrOptions = {
    format: "form",
    items: cardList,
    bucket: { itemSpacing: 2 }
  };
  const handleSearch = (event2, p) => {
    console.log("ListSearchFormComp:handleSearch() - event search terms : " + event2.target.value);
    setSearchTerm(event2.target.value);
    event2.preventDefault();
  };
  const searchOptions = {
    format: "form",
    items: null,
    bucket: {
      p: null,
      handleChange: handleSearch,
      checkDisabled: () => false,
      //className: className, 
      style: null,
      variant: "contained",
      size: "large"
    }
  };
  const url = cardList && cardList.length && da.getSelectedFormURL() || "";
  const shareForm2 = getEnvVar2.contactUsUrl;
  const preset = {
    "From": appState.user.last + ", " + appState.user.first || appState.user.username || "",
    "Company": "Some Company Name",
    "Email": appState.user.email || "",
    "Question": `FYI the form url is: ${url}`
    //"URL": "FYI the form url is: http://localhost:8019?account=1021&form=1",
  };
  const presetJsonStr = JSON.stringify(preset);
  const uri = shareForm2 + "&preset=" + encodeURIComponent(presetJsonStr);
  const encodedShareForm = uri;
  let formNoDataLayout = null;
  if (!appState.user.email) {
    if (!forms || !forms.length) {
      const msgList = [
        "You are using a pre-assigned anonymous id.",
        "Anonymous access has only a limited set of features available. For a feature full experience please Sign In.",
        "As an anonymous user you may: Only create three forms, only three submissions for each form, not receive submission notifications and the forms/submissions may be purged at anytime."
      ];
      formNoDataLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "Library Contains No Forms", tip: "Click on CREATE NEW FORM to create a form.", msgList });
    } else {
      const msgList = [
        "Anonymous access has only a limited set of features available. For a feature full experience please Sign In.",
        "As an anonymous user you may: Only create three forms, only five submissions for each form, not receive submission notifications and the forms/submissions may be purged at anytime."
      ];
      formNoDataLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "You Are Using A Pre-assigned Anonymous id.", tip: "Use MY ACCOUNT to Sign Up or Sign In.", msgList });
    }
  } else if (!forms || !forms.length) {
    formNoDataLayout = /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "Library Contains No Forms", tip: "Click on LIBRARY tab and then on CREATE NEW FORM to create a form." });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormLibraryPageLayout,
    {
      listCreateFormComp: /* @__PURE__ */ jsxRuntimeExports.jsx(ListCreateFormComp, { store: da, formCnt: forms.length }),
      createBtn: /* @__PURE__ */ jsxRuntimeExports.jsx(ListCreateFormComp, {}),
      search: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchComp, { ...searchOptions }),
      url,
      cardCtnr: /* @__PURE__ */ jsxRuntimeExports.jsx(CardCtnr, { ...cardCtnrOptions }),
      alert: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { ...alertOptions }),
      shareForm: encodedShareForm,
      formNoDataLayout
    }
  );
}
function MarketPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  const msgList = [
    "Listing of marketplace forms are placed here (for sale and free samples).",
    "Users can click to copy any marketplace form into their account. Charges will be based on the form's pricing and usage.",
    "This feature is expected to be introduced in future product releases. Contact support for additional details."
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "Forms Marketplace", tip: "", msgList });
}
function SubmissionsPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const instanceName = da.selected({
    entity: "instances",
    type: "get",
    action: "prop",
    property: "name"
  });
  const submissions = da.repo({ entity: "submissions", type: "get" });
  if (submissions.length) {
    const accum = /* @__PURE__ */ new Set();
    const keySet = submissions.reduce((accum2, sub) => {
      const columns = sub.columns;
      Object.keys(columns).forEach((key, i) => {
        console.log("SubmissionsPage col type: " + typeof columns[key]);
        if (typeof columns[key] == "string") {
          if (columns[key].indexOf("$children:") == 0 || columns[key] == "Submit" || columns[key] == "Reset") {
            return;
          } else {
            if (!accum2.has(key)) accum2.add(key);
          }
        } else if (typeof columns[key] == "boolean") {
          if (!accum2.has(key)) accum2.add(key);
        } else {
          if (!accum2.has(key)) accum2.add(key);
        }
      });
      return accum2;
    }, accum);
    const keys = [...keySet];
    const headers = keys.map((key) => {
      return {
        title: key,
        //key.toUpperCase()
        field: key
      };
    });
    const tableCells = submissions.map((submission, id) => {
      const columns = submission.columns;
      const rowCells = keys.reduce((accum2, key) => {
        if (typeof columns[key] === "string") accum2[key] = columns[key];
        else if (Array.isArray(columns[key])) accum2[key] = columns[key].join(", ");
        else if (typeof columns[key] === "object")
          accum2[key] = Object.values(columns[key]).join(", ");
        else accum2[key] = columns[key];
        return accum2;
      }, {});
      rowCells["id"] = id;
      return rowCells;
    });
    const tableOptions = {
      format: "form",
      items: null,
      bucket: {
        title: instanceName,
        columns: headers,
        cells: tableCells,
        /*
        		       	   columns: [
        			     { title: 'Name', field: 'name' },
        			     { title: 'Surname', field: 'surname' },
        			     { title: 'Birth Year', field: 'birthYear', type: 'numeric' },
        			     { title: 'Birth Place',
        			       field: 'birthCity',
        			       lookup: { 34: 'İstanbul', 63: 'Şanlıurfa' }
        			     },
        			   ],
        
        			   cells:  [
        			     { name: 'Mehmet', surname: 'Baran', birthYear: 1987, birthCity: 63 },
        			     { name: 'Zerya Betül', surname: 'Baran', birthYear: 2017, birthCity: 34 },
        			   ],
        			    */
        options: { maxColumnSort: true }
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormSubmissionsPageLayout, { tableComp: /* @__PURE__ */ jsxRuntimeExports.jsx(TableComp, { ...tableOptions }) });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "No Form Submission Data Available", tip: "Click on LIBRARY tab, select a form and click on the Launch and Submit Form icon" });
  }
}
const setFormProps = (spec, nextSeqno, parentSeqno, palettes) => {
  const paletteFind = function(type, category, wgt) {
    const item = palettes.find((palette, i) => {
      if (palette.type === type && palette.category === category && palette.wgt === wgt) {
        return true;
      } else return false;
    });
    return item;
  };
  const setProps = (spec2, nextSeqno2, parentSeqno2) => {
    const item = spec2.item;
    if (!item) return;
    if (!nextSeqno2) nextSeqno2 = CONST.ROOT_SEQNO;
    if (item.type && item.category && item.wgt) {
      item.parent = "" + parentSeqno2;
      item.seqno = nextSeqno2;
      const paletteItem = paletteFind(item.type, item.category, item.wgt);
      if (!paletteItem)
        throw Error(
          `Requested type/category/widget not found (${item.type}/${item.category}/${item.wgt})`
        );
      item.prop = deepCopyJson(paletteItem.prop);
      if (item.child && item.child.length) {
        item.child.forEach((spec3) => {
          nextSeqno2 = nextSeqno2 + 1;
          setProps(spec3, nextSeqno2, item.seqno);
        });
      }
    } else {
      throw Error("Invalid format for template. Missing type|category|wgt settings");
    }
  };
  setProps(spec, nextSeqno, parentSeqno);
};
const manageFormSpecs = (parents, ndx, { type = "Components", category = "Layout", wgt = "1 Column" }) => {
  const spec = {
    item: {
      type,
      category,
      wgt,
      prop: null,
      seqno: null,
      parent: null,
      child: []
    }
  };
  if (!parents || !parents.length) {
    if (wgt !== "1 Column")
      throw Error("When parents do not exist, the first spec must be for a 1 Column widget");
    parents = [spec];
  } else {
    if (ndx >= parents.length)
      throw Error(
        `Provided ndx value(${ndx}) is invalid. It should be less then ${parents.length}`
      );
    if (wgt == "1 Column" || wgt == "Inline") {
      parents.push(spec);
      parents[ndx].item.child.push(spec);
    } else {
      parents[ndx].item.child.push(spec);
    }
  }
  return parents;
};
const createForm = (specs, accountNo, formNo) => {
  const formOptions = {
    accountNo,
    formNo,
    createdAt: "PENDING"
  };
  const newForm = new Form(formOptions);
  const newFormCopy = deepCopyJson(newForm);
  const instOptions = {
    accountNo,
    formNo,
    instanceNo: 1,
    createdAt: "PENDING"
  };
  const newInstance = new Instance(instOptions);
  const newInstanceCopy = deepCopyJson(newInstance);
  let newItems = [];
  const instanceNo = 1;
  const createItems = (spec) => {
    const item = spec.item;
    if (!item) return;
    const options2 = {
      accountNo,
      formNo,
      instanceNo,
      seqno: item.seqno,
      type: item.type,
      category: item.category,
      wgt: item.wgt,
      parent: item.parent ? item.parent + "-0" : "",
      child: item.child,
      userProp: item.prop,
      createdAt: "PENDING"
    };
    let newItem = new Item(options2);
    const newItemCopy = deepCopyJson(newItem);
    newItems.push(newItemCopy);
    if (item.child && item.child.length) {
      let child = [];
      item.child.forEach((spec2) => {
        createItems(spec2);
        child.push(spec2.item.seqno);
      });
      newItemCopy.child = child;
    }
    return;
  };
  createItems(specs);
  return { form: newFormCopy, instance: newInstanceCopy, items: newItems };
};
function LaunchItemListCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const featureAccessCheckFn = da.appState.featureAccessCheck;
  da.work({
    entity: "flag",
    type: "set",
    action: "prop",
    property: "configMode",
    value: "edit"
  });
  const form = da.selected({ entity: "forms", type: "get" });
  const instance = da.selected({ entity: "instances", type: "get" });
  let lastUpdated = "";
  const formValue = form && form["updatedAt"] && new Date(form["updatedAt"]) || /* @__PURE__ */ new Date();
  const instaValue = instance && instance["updatedAt"] && new Date(instance["updatedAt"]) || /* @__PURE__ */ new Date();
  lastUpdated = formValue < instaValue ? instaValue : formValue;
  lastUpdated = lastUpdated && lastUpdated.toLocaleString("en-US");
  lastUpdated = lastUpdated.substr(0, lastUpdated.indexOf(",")) || "";
  let p = new P({
    rendertype: "submit",
    // 'build' | 'submit' | 'preview' | 'prop editor'
    formtype: "User",
    // User|Meta|Record|List|Service
    formName: "user",
    accountNo: da.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    }),
    formNo: da.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" }),
    // 'metaAccount' (unused) | 'metaMembers' (unused) etc.,
    instance,
    //da.getSelectedInstance(),
    items: da.selected({ entity: "items", type: "get" })
    // da.getSelectedItems()     // <<< NOTE: Passing in an array of items
    // inline not set
  });
  const submissions = da.repo({ entity: "submissions", type: "get" });
  const accessCheckMsg = featureAccessCheckFn.check({ featureId: "form-submissions-limit", options: { submissionsCnt: submissions.length } });
  if (accessCheckMsg) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { children: [
      " ",
      accessCheckMsg,
      " "
    ] });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormCtnr, { p, lastUpdated, version: instance.instanceNo });
  }
}
function LaunchMarketingMsg(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { fontSize: "0.8rem" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
    "Form dynamically created using AI and hosted at ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { target: "_blank", href: "https://form.crudli.com", children: "Form Builder." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    "For inquiries use the Contact Us link below."
  ] }) });
}
function LaunchPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  if (da.isInit()) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      LnchLaunchPageLayout,
      {
        formHeader: /* @__PURE__ */ jsxRuntimeExports.jsx(FormHeader, {}),
        previewItemListCtnr: /* @__PURE__ */ jsxRuntimeExports.jsx(LaunchItemListCtnr, {}),
        marketingMsg: /* @__PURE__ */ jsxRuntimeExports.jsx(LaunchMarketingMsg, {})
      }
    );
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: da.getStateMsg() });
  }
}
const CONST = {
  ACTIVE_TYPES: { RECENT: "RECENT", SPECIFIC: "SPECIFIC" },
  SUBMIT_BUTTON: "Submit Button",
  RESET_BUTTON: "Reset Button",
  CLEAR_BUTTON: "Clear Button",
  LAYOUTS: { INLINE: "Inline", HORIZONTAL: "Horizontal", VERTICAL: "Vertical" },
  LAYOUT: "Layout",
  STYLES: {
    BS3: "BS3",
    HTML: "HTML",
    MUI: "MUI"
    /*	       BS3NG:'Angular BS3',
      NL:'NL',
      INPLACE : 'Inplace Edit',
      PAPER:'Paper'
    */
  },
  ITEM_HILITE_CLASS: "itemHilite",
  NAILED_HILITE_CLASS: "nailedHilite",
  NAILED_UNHILITE_CLASS: "nailedUnhilite",
  HELPDISPLAY: { ONFOCUS: "On Focus", POPUP: "Pop Up", ALWAYS: "Always Displayed" },
  ROOT_SEQNO: 1e3
};
class P {
  constructor({
    rendertype,
    formtype,
    formName,
    accountNo,
    formNo,
    instance = null,
    item = null,
    items = [],
    inline = "",
    ...rest
  }) {
    this._rendertype = rendertype;
    this._formtype = formtype;
    this._formName = formName;
    this._accountNo = accountNo;
    this._formNo = formNo;
    this._inline = inline;
    this.item = item;
    this.instance = instance;
    this.items = items;
  }
  rendertype() {
    return this._rendertype;
  }
  formtype() {
    return this._formtype;
  }
  formName() {
    return this._formName;
  }
  accountNo() {
    return this._accountNo;
  }
  formNo() {
    return this._formNo;
  }
  inline() {
    return this._inline;
  }
  getWgtClass() {
    return "gi-" + this.item.wgt.replace(/ /g, "").toLowerCase();
  }
}
const getBucketProps = (type, category, wgt) => {
  const coreProps = {
    usrStyle: {}
  };
  const layoutProps = {};
  const col1Props = {};
  const col2Props = {};
  const col3Props = {};
  const col4Props = {};
  const containerProps = {};
  const accordionProps = {
    //label: `Label`,
    options: ["Panel 1", "Panel 2", "Panel 3"]
    //isDisabled: false,    ... it's per option
  };
  const collapsProps = {
    label: `Label`,
    isExpanded: false
  };
  const fieldsetProps = {
    label: `Label`
  };
  const inlineProps = {
    isInlined: true
  };
  const panelProps = {
    label: `Label`
  };
  const tabsProps = {
    options: ["Tab 1", "Tab 2", "Tab 3"],
    isVertical: false,
    color: "",
    isFullWidth: false
    // boolean
  };
  const stepperProps = {
    options: ["Step 1", "Step 2", "Step 3"]
  };
  const wizardProps = {};
  const inputsProps = {
    // Props for all inputs
    //enter   autoComplete: null,              // string - helps users to fill forms faster/autofill 'on' | 'off'
    //enter   isAutofocus: false,              // boolean
    // children                      - not used
    // classes                       - obj Override or extend the styles - not used	  
    color: "",
    //  'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning', 'default'
    // defaultValue                  - Use ONLY when the component is not controlled.
    isDisabled: false,
    // boolean
    // isError                         - boolean set during user interactions
    // FormHelperTextProps           - Props applied to the FormHelperText element - not used
    isFullWidth: false,
    // boolean
    helperText: `Helper Text`,
    // string (shows below the input line)
    // id                            - string set in our cl-palette/muipalette/xxx
    // InputLabelProps               - obj
    //   isShrink                      - provided by InputLabelProps
    //   isDisableAnimation            - provided by InputLabelProps
    // isDisableAnimation: false,      - not supported. Don't know what it is for!!!
    // inputProps                    - obj
    isReadonly: false,
    isBare: false,
    isDisableUnderline: false,
    //isShrink: false,               - not used in TextField
    // inputRef                      - not used
    label: `Label`,
    // string 
    margin: "",
    // string 'normal', 'dense'
    //textarea   isMultiline: false,                // boolean (when true it renders TextArea instead of TextField)
    //name: '',                        // string (default is seqno)
    // onBlur                        // RUNTIME ONLY
    // onFocus                       // RUNTIME ONLY 
    //enter   placeholder: '',                 // string
    isRequired: false,
    // boolean
    //textarea   rows: '',                        // string/number text area rows to display when multiline=true 
    //textarea   maxRows: '',                     // string/number text area max rows to display when multiline=true 
    //textarea   minRows: '',                     // string/number text area min rows to display when multiline=true 
    //inputSelect   isSelect: false,                   // boolean use <input type=select>
    // SelectProps                   - obj
    //   field1??                      - provided by SelectProps
    //   field2??                      - provided by SelectProps
    size: "",
    //  'medium', 'small'
    //sx                             // RUNTIME ONLY
    type: "",
    // string
    value: "",
    // 
    tip: "",
    // tooltip text
    variant: "Standard",
    // 'standard', 'filled', 'outlined' 
    // InputProps                    - obj
    //   field1??                      - provided by StandardInputProps
    //   field2??                      - provided by StandardInputProps
    // onChange                      // RUNTIME ONLY 
    //onKeyDown?: React.KeyboardEventHandler<HTMLTextAreaElement | HTMLInputElement>;
    //onKeyUp?: React.KeyboardEventHandler<HTMLTextAreaElement | HTMLInputElement>;
    // onInvalid?: React.FormEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    //adornStartIcon: '',
    adornStartText: "",
    //adornEndIcon: '',
    adornEndText: "",
    cursor: "",
    // used only by metaforms
    ref: "",
    // used only by metaforms
    condition: "",
    // 
    valDfltRules: "",
    // default val rules for this step
    valUserRules: "",
    // addl. validations supplied during form creation
    valPattern: "",
    // addl. val pattern supplied during form creation
    valMsgPosition: "",
    // Where to list val msg (NOT USED. The default position is inline)
    valUserMsgs: ""
    // val failure message
  };
  const enterProps = {
    // Props for all input entry fields where user has to key in values
    isAutofocus: false,
    // boolean
    placeholder: `Sample Value`
    // string
  };
  const minmaxProps = {
    min: "",
    // HTML5 date/datetime-local/month/number/range/time/week
    max: "",
    // HTML5 date/datetime-local/month/number/range/time/week
    step: "1"
    // HTML5 date/datetime-local/month/number/range/time/week
  };
  const lengthProps = {
    minLength: "1",
    // HTML5 email/password/tel/text/url
    maxLength: ""
    // HTML5 email/password/tel/text/url
  };
  const cbProps = {
    options: ["CBOption1", "CBOption2"]
    // For CB/RB/Tab/Accordion/SL/Tags:["Tab 1","Tab 2","Tab 3"]
  };
  const colorProps = {};
  const dateProps = {};
  const dateLocalProps = {};
  const emailProps = {
    isMultiple: false,
    // HTML5 email/
    pattern: ".+@example.com"
  };
  const monthProps = {};
  const fileProps = {};
  const numberProps = {};
  const ooProps = {
    options: ["On"]
  };
  const passwordProps = {
    autoComplete: null
    // string - helps users to fill forms faster/autofill 'on' | 'off'
  };
  const rbProps = {
    options: ["RBOption1", "RBOption2"]
    // For CB/RB/Tab/Accordion/SL/Tags:["Tab 1","Tab 2","Tab 3"]
  };
  const rangeProps = {};
  const selectProps = {
    options: ["SelectOption1", "SelectOption2"],
    // For CB/RB/Tab/Accordion/SL/Tags:["Tab 1","Tab 2","Tab 3"]
    isSelect: true,
    // For Select - implicit setting (user not permitted to change)
    //isMultiple: true, // HTML5 select   --- Unable to get native multiple select to work within TextField Nov 2023
    isNative: false,
    // For Select
    isEmptyOption: true
    // For Select
  };
  const swProps = {
    options: ["SWOption1", "SWOption2"]
    // For CB/RB/Tab/Accordion/SL/Tags:["Tab 1","Tab 2","Tab 3"]
  };
  const tagProps = {
    options: ["TagOption1", "TagOption2"],
    // For CB/RB/Tab/Accordion/SL/Tags:["Tab 1","Tab 2","Tab 3"]
    isMultiple: true,
    // HTML5 email/
    isFreeSolo: true,
    limitTags: 3,
    variant: "Standard"
  };
  const telProps = {
    pattern: "[0-9]{1}-[0-9]{3}-[0-9]{3}-[0-9]{4}"
  };
  const textProps = {
    autoComplete: null,
    // string - helps users to fill forms faster/autofill 'on' | 'off'
    pattern: ""
  };
  const textareaProps = {
    rows: "5",
    // For Text Area
    rowsMax: "",
    // For Text Area
    rowsMin: "",
    // added 10/2023
    isMultiline: true,
    // For Text Area - implicit setting (user not permitted to change)
    pattern: ""
  };
  const timeProps = {};
  const urlProps = {
    pattern: "https://.*"
  };
  const weekProps = {};
  const basicProps = {};
  const fillProps = {
    rows: "5"
  };
  const resetProps = {
    label: "Reset",
    value: "Reset",
    color: "secondary",
    variant: "contained",
    tip: "Reset form data"
  };
  const searchProps = {
    label: "Search Button"
  };
  const staticTextProps = {
    label: `Label`,
    value: "Static text content goes here ...",
    color: "",
    border: false
  };
  const submitProps = {
    label: "Submit",
    value: "Submit",
    color: "",
    variant: "contained",
    tip: "Submit form data"
  };
  const infoProps = {};
  const footerProps = {
    label: `Label`,
    align: "center",
    thick: "5",
    color: "primary",
    value: "Some Footer Text"
  };
  const formattedTextProps = {
    label: `Label`,
    value: "Formatted text content goes here ...",
    color: "",
    border: false
  };
  const headerProps = {
    label: `Label`,
    align: "center",
    thick: "5",
    color: "primary",
    value: "Some Header Text"
  };
  const linkProps = {
    label: `Label`,
    value: "https://example.com"
  };
  const imageProps = {
    label: `Label`,
    value: "",
    imgFormat: "img-rounded",
    width: ""
  };
  const lineProps = {
    thick: 1,
    color: "primary"
  };
  const logoProps = {
    label: `Label`,
    value: "",
    imgFormat: "img-rounded",
    width: ""
  };
  const mapProps = {};
  const printProps = {};
  const videoProps = {};
  const getBucket = (type2, category2, wgt2) => {
    switch (category2 + "-" + wgt2) {
      case "Layout-1 Column":
        return Object.assign({}, coreProps, layoutProps, col1Props);
      case "Layout-2 Column":
        return Object.assign({}, coreProps, layoutProps, col2Props);
      case "Layout-3 Column":
        return Object.assign({}, coreProps, layoutProps, col3Props);
      case "Layout-4 Column":
        return Object.assign({}, coreProps, layoutProps, col4Props);
      case "Container-Accordion":
        return Object.assign({}, coreProps, containerProps, accordionProps);
      case "Container-Collapsable":
        return Object.assign({}, coreProps, containerProps, collapsProps);
      case "Container-Fieldset":
        return Object.assign({}, coreProps, containerProps, fieldsetProps);
      case "Container-Inline":
        return Object.assign({}, coreProps, containerProps, inlineProps);
      case "Container-Panel":
        return Object.assign({}, coreProps, containerProps, panelProps);
      case "Container-Tabs":
        return Object.assign({}, coreProps, containerProps, tabsProps);
      case "Container-Wizard":
        return Object.assign({}, coreProps, containerProps, wizardProps);
      // Valid html <input type> are:
      // button, checkbox, color, date, datetime-local, email, file, hidden, image, month, number,
      // password, radio, range, reset, search, submit, tel, text, time, url, week, 
      case "Inputs-Checkboxes":
        return Object.assign({}, coreProps, inputsProps, cbProps);
      case "Inputs-Color":
        return Object.assign({}, coreProps, inputsProps, colorProps);
      case "Inputs-Date":
        return Object.assign({}, coreProps, inputsProps, enterProps, dateProps);
      case "Inputs-Datetime Local":
        return Object.assign({}, coreProps, inputsProps, enterProps, dateLocalProps);
      case "Inputs-Email":
        return Object.assign({}, coreProps, inputsProps, enterProps, emailProps, lengthProps);
      case "Inputs-File":
        return Object.assign({}, coreProps, inputsProps, fileProps);
      case "Inputs-Month":
        return Object.assign({}, coreProps, inputsProps, enterProps, monthProps);
      case "Inputs-Number":
        return Object.assign({}, coreProps, inputsProps, enterProps, numberProps, minmaxProps);
      case "Inputs-OnOff":
        return Object.assign({}, coreProps, inputsProps, ooProps);
      case "Inputs-Password":
        return Object.assign({}, coreProps, inputsProps, passwordProps, lengthProps);
      case "Inputs-Radio Buttons":
        return Object.assign({}, coreProps, inputsProps, rbProps);
      case "Inputs-Range":
        return Object.assign({}, coreProps, inputsProps, rangeProps, minmaxProps);
      case "Inputs-Select List":
        return Object.assign({}, coreProps, inputsProps, selectProps);
      case "Inputs-Switches":
        return Object.assign({}, coreProps, inputsProps, swProps);
      case "Inputs-Tag Autocomplete":
        return Object.assign({}, coreProps, inputsProps, tagProps);
      case "Inputs-Tel":
        return Object.assign({}, coreProps, inputsProps, enterProps, telProps);
      case "Inputs-Text":
        return Object.assign({}, coreProps, inputsProps, enterProps, textProps, lengthProps);
      case "Inputs-Text Area":
        return Object.assign({}, coreProps, inputsProps, enterProps, textareaProps, lengthProps);
      case "Inputs-Time":
        return Object.assign({}, coreProps, inputsProps, enterProps, timeProps);
      case "Inputs-URL":
        return Object.assign({}, coreProps, inputsProps, enterProps, urlProps, lengthProps);
      case "Inputs-Week":
        return Object.assign({}, coreProps, inputsProps, enterProps, weekProps);
      case "Basic-Filler":
        return Object.assign({}, coreProps, basicProps, fillProps);
      case "Basic-Reset Button":
        return Object.assign({}, coreProps, basicProps, resetProps);
      case "Basic-Search":
        return Object.assign({}, coreProps, basicProps, searchProps);
      case "Basic-Static Text":
        return Object.assign({}, coreProps, basicProps, staticTextProps);
      case "Basic-Submit Button":
        return Object.assign({}, coreProps, basicProps, submitProps);
      case "Informational-Animation":
        return {};
      case "Informational-Audio":
        return {};
      case "Informational-Background Image":
        return {};
      case "Informational-Carousel":
        return {};
      case "Informational-Footer":
        return Object.assign({}, coreProps, infoProps, footerProps);
      case "Informational-Formatted Text":
        return Object.assign({}, coreProps, infoProps, formattedTextProps);
      case "Informational-Header":
        return Object.assign({}, coreProps, infoProps, headerProps);
      case "Informational-Hyper Link":
        return Object.assign({}, coreProps, infoProps, linkProps);
      case "Informational-Image":
        return Object.assign({}, coreProps, infoProps, imageProps);
      case "Informational-Line":
        return Object.assign({}, coreProps, infoProps, lineProps);
      case "Informational-Logo":
        return Object.assign({}, coreProps, infoProps, logoProps);
      case "Informational-Map":
        return Object.assign({}, coreProps, infoProps, mapProps);
      case "Informational-Print Button":
        return Object.assign({}, coreProps, infoProps, printProps);
      case "Informational-Video":
        return Object.assign({}, coreProps, infoProps, videoProps);
      case "Bootstrap-BS 4":
        return Object.assign(
          {},
          coreProps,
          layoutProps,
          col1Props,
          col2Props,
          col3Props,
          col4Props,
          containerProps,
          accordionProps,
          collapsProps,
          fieldsetProps,
          inlineProps,
          panelProps,
          tabsProps,
          stepperProps,
          wizardProps,
          inputsProps,
          enterProps,
          minmaxProps,
          lengthProps,
          cbProps,
          colorProps,
          dateProps,
          dateLocalProps,
          emailProps,
          monthProps,
          fileProps,
          numberProps,
          ooProps,
          passwordProps,
          rbProps,
          rangeProps,
          selectProps,
          swProps,
          tagProps,
          telProps,
          textProps,
          textareaProps,
          timeProps,
          urlProps,
          weekProps,
          basicProps,
          fillProps,
          resetProps,
          searchProps,
          staticTextProps,
          submitProps,
          infoProps,
          footerProps,
          formattedTextProps,
          headerProps,
          linkProps,
          imageProps,
          lineProps,
          logoProps,
          mapProps,
          printProps,
          videoProps
        );
      default:
        return {};
    }
  };
  const props = getBucket(type, category, wgt);
  return props;
};
const getItemUserProps = ({
  caller,
  p,
  da,
  type,
  sysStyle
}) => {
  let parsedUsrStyle = {};
  try {
    parsedUsrStyle = p.item.userProp?.usrStyle ? JSON.parse(p.item.userProp.usrStyle) : {};
  } catch (e) {
  }
  const bucket = {
    // *** Props required for TextFieldComp ***
    autoComplete: p.item.userProp?.autoComplete,
    //// || null,
    isAutofocus: p.item.userProp?.isAutofocus,
    // classes
    color: p.item.userProp?.color,
    //// || 'primary',
    // defaultvalue
    isDisabled: p.item.IsDisabled || da.genericCheckDisabled(p),
    isError: p.item?.isError,
    //// || null,
    // FormHelperTextProps
    isFullWidth: p.item.userProp?.isFullWidth,
    helperText: p.item.userProp?.isBare ? "" : p.item.userProp?.helperText,
    // 
    id: da.getId(p, "item"),
    //inputLabelProps: inputLabelProps, //// || null, // NOT For CB/RB/SW
    //// Values used for inputLabelProps
    //// Not Supported
    ////isDisableAnimation: p.item.userProp?.isDisableAnimation,
    //inputProps: inputProps, //// || null, // NOT For CB/RB/SW
    // InputProps
    //// Values used for InputProps
    isReadonly: p.item.userProp?.isReadonly,
    isBare: p.item.userProp?.isBare,
    // For
    isDisableUnderline: p.item.userProp?.isDisableUnderline,
    //isShrink: p.item.userProp?.isShrink, // It's not used in TextField
    adornStartText: p.item.userProp?.adornStartText,
    //// || null,
    adornStartIcon: p.item.userProp?.adornStartIcon,
    //// || null,
    adornEndText: p.item.userProp?.adornEndText,
    //// || null,
    adornEndIcon: p.item.userProp?.adornEndIcon,
    //// || null,
    min: p.item.userProp?.min,
    //// || '1', // HTML5
    max: p.item.userProp?.max,
    //// || '100', // HTML5
    step: p.item.userProp?.step,
    //// || '1', // HTML5
    pattern: p.item.userProp?.pattern,
    //// || null, // HTML5
    maxLength: p.item.userProp?.maxLength,
    //// || '255', // HTML5
    minLength: p.item.userProp?.minLength,
    //// || '0', // HTML5
    isMultiple: p.item.userProp?.isMultiple,
    // HTML5
    // inputRef
    label: p.item.userProp?.isBare ? "" : p.item.userProp?.label,
    margin: p.item.userProp?.margin?.toLowerCase(),
    // must be one of: 'normal', 'dense', 'none'
    isMultiline: p.item.userProp?.isMultiline,
    // For Text Area -
    //name: p.item.name,   // column name - Using Label as column name
    handleChange: da.genericHandleChange,
    // onChange
    placeholder: p.item.userProp?.placeholder,
    //// || '', // HTML5
    isRequired: p.item.userProp?.isRequired,
    //select
    //selectProps: selectProps, //// || null, // NOT For CB/RB/SW
    //// Values used for selectProps
    isNative: p.item.userProp?.isNative,
    // For Select
    size: p.item.userProp?.size?.toLowerCase(),
    // || 'medium';
    // get it from meta if this is a meta form item
    value: da.value(p),
    //// || null, // NOT For CB/RB/SW
    tip: p.item.userProp?.tip,
    //// || '',
    variant: p.item.userProp?.variant?.toLowerCase(),
    //
    // Inheritance
    handleBlur: da.genericHandleBlur,
    // NOT For CB/RB/SW
    handleClick: da.genericHandleButtonClick,
    handleCheckDisabled: da.genericCheckDisabled,
    rows: p.item.userProp?.rows,
    //// || '5', // HTML5
    rowsMax: p.item.userProp?.rowsMax,
    //// || '5', // HTML5
    rowsMin: p.item.userProp?.rowsMin,
    //// || '3', // HTML5
    isInlined: p.item.userProp?.isInlined,
    // For CB & RB & Switch - inline label and options
    // cursor/ref/condition not required for bucket
    // added Nov 2023 even though above comment
    cursor: p.item.userProp?.cursor,
    // used only by metaforms
    ref: p.item.userProp?.ref,
    // used only by metaforms
    condition: p.item.userProp?.condition,
    valDfltRules: p.item.userProp?.valDfltRules,
    // default val rules for this step
    valUserRules: p.item.userProp?.valUserRules,
    // addl. validations supplied during form creation
    valPattern: p.item.userProp?.valPattern,
    // addl. val pattern supplied during form creation
    valMsgPosition: p.item.userProp?.valMsgPosition,
    // Where to list val msg (NOT USED. The default position is inline)
    valUserMsgs: p.item.userProp?.valUserMsgs,
    // val failure message
    sysStyle,
    //// || null,    // used it for sx value
    usrStyle: parsedUsrStyle,
    type,
    // *** Props required for building any MUI Components ***
    p,
    errorMsg: p.item.errorMsg,
    //// || null,
    // *** Props required for building InfoComp ***
    imgFormat: p.item.userProp?.imgFormat,
    //// || null, // For InfoComp : "img-rounded"
    image: p.item.userProp?.image,
    // for InfoComp & Layout(1/2/3/4 Col)
    // For Text Info
    border: p.item.userProp?.border,
    //// || null,
    thick: p.item.userProp?.thick,
    //// || '1',
    align: p.item.userProp?.align,
    //// || 'center',    
    // type=tele can have multiple emails
    //isMultiple: p.item.userProp?.multiple,
    // *** Props required for building Select ***
    options: da.options(p),
    //// || null, // : ["Tab 1","Tab 2","Tab 3"]
    isSelect: p.item.userProp?.isSelect,
    isEmptyOption: p.item.userProp?.isEmptyOption,
    // *** Props required for building CB/RB/Tab/Accordion/SL/Tags ***
    // get it from meta if this is a meta form item
    //options: da.options(p) || null,  // : ["Tab 1","Tab 2","Tab 3"]
    // get it from meta if this is a meta form item
    //options: da.options(p) || null, // : ["Tab 1","Tab 2","Tab 3"]
    //isMultiple: p.item.userProp?.multiple,
    isFreeSolo: p.item.userProp?.isFreeSolo,
    limitTags: p.item.userProp?.limitTags,
    // *** Props required for building Collapsed Panel/Accordion ***
    isExpanded: p.item.userProp?.isExpanded,
    // *** Props required for building Tabs ***
    isVertical: p.item.userProp?.isVertical,
    // *** Props required for image/logo ***
    width: p.item.userProp?.width
  };
  return bucket;
};
const layoutConfig = [
  // Sheets
  {
    type: "Components",
    category: "Layout",
    wgt: "1 Column",
    icon: "fa fa-columns",
    support: { feature: true, mui: true },
    tip: "This adds a container.",
    prop: getBucketProps("Components", "Layout", "1 Column")
  },
  {
    type: "Components",
    category: "Layout",
    wgt: "2 Column",
    icon: "fa fa-columns",
    support: { feature: true, mui: true },
    tip: "This will spilit the parent container into 2 columns.",
    prop: getBucketProps("Components", "Layout", "2 Column")
  },
  {
    type: "Components",
    category: "Layout",
    wgt: "3 Column",
    icon: "fa fa-columns",
    support: { feature: true, mui: true },
    tip: "This will split the parent container into 3 columns.",
    prop: getBucketProps("Components", "Layout", "3 Column")
  },
  {
    type: "Components",
    category: "Layout",
    wgt: "4 Column",
    icon: "fa fa-columns",
    support: { feature: true, mui: true },
    tip: "This will split the parent container into 4 columns.",
    prop: getBucketProps("Components", "Layout", "4 Column")
  }
];
const containerConfig = [
  // AccordionCtnr
  {
    type: "Components",
    category: "Container",
    wgt: "Accordion",
    icon: "fa fa-align-justify",
    support: { feature: true, mui: true },
    tip: "This adds an accordion container. Accordion provides multiple collapsable sections.",
    prop: getBucketProps("Components", "Container", "Accordion")
  },
  // Collapsable
  {
    type: "Components",
    category: "Container",
    wgt: "Collapsable",
    icon: "fa fa-columns",
    support: { feature: true, mui: true },
    tip: "This adds a single collapsable section.",
    prop: getBucketProps("Components", "Container", "Collapsable")
  },
  /* No Mui version exists yet
   // CollectionCtnr
   {
   'type': 'Components', 
   'category':'Container',
   'wgt':'Collection',
   'icon':'glyphicon glyphicon-trash',
   'support': {'feature':true, mui: true},
   'tip':'This adds a collection section.',
   prop: getBucketProps('Components', 'Container', 'Collection'),
   'prop': {
   'label' : 'Collection Label'
   } // prop
   },    
   */
  // Fieldset
  {
    type: "Components",
    category: "Container",
    wgt: "Fieldset",
    icon: "glyphicon glyphicon-trash",
    support: { feature: true, mui: true },
    tip: "This allows to group and label a set of user components.",
    prop: getBucketProps("Components", "Container", "Fieldset")
  },
  // Inline
  {
    type: "Components",
    category: "Container",
    wgt: "Inline",
    icon: "glyphicon glyphicon-trash",
    support: { feature: true, mui: true },
    tip: "Container inlines it's child components.",
    prop: getBucketProps("Components", "Container", "Inline")
  },
  // PanelCtnr
  {
    type: "Components",
    category: "Container",
    wgt: "Panel",
    icon: "fa fa-columns",
    support: { feature: true, mui: true },
    tip: "This adds a named section.",
    prop: getBucketProps("Components", "Container", "Panel")
  },
  // Tabs
  {
    type: "Components",
    category: "Container",
    wgt: "Tabs",
    icon: "fa fa-columns",
    support: { feature: true, mui: true },
    tip: "This adds a tabbed area. Tab provides multiple sections where each can be viewed by clicking on it's tab.",
    prop: getBucketProps("Components", "Container", "Tabs")
  },
  {
    type: "Components",
    category: "Container",
    wgt: "Wizard",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "This adds a guided user input entry sections. Similar to Tab.",
    prop: getBucketProps("Components", "Container", "Wizard")
  }
  // object
];
const inputConfig = [
  // CheckRadioBoxes
  {
    type: "Components",
    category: "Inputs",
    wgt: "Checkboxes",
    icon: "fa fa-check-square",
    support: { feature: true, mui: true },
    tip: "For selecting one or more options from a small list of options.",
    prop: getBucketProps("Components", "Inputs", "Checkboxes")
  },
  {
    type: "Components",
    category: "Inputs",
    wgt: "Color",
    icon: "fa fa-trash",
    support: { feature: true, mui: true },
    tip: "For entering color choice.",
    prop: getBucketProps("Components", "Inputs", "Color")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Date",
    icon: "fa fa-calendar",
    support: { feature: true, mui: true },
    tip: "For entering a date without a time zone.",
    prop: getBucketProps("Components", "Inputs", "Date")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Datetime Local",
    icon: "fa fa-clock-o",
    support: { feature: true, mui: true },
    tip: "For entering a date and time vlaue where the time zone is provided as GMT.",
    prop: getBucketProps("Components", "Inputs", "Datetime Local")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Email",
    icon: "fa fa-phone",
    support: { feature: true, mui: true },
    prop: getBucketProps("Components", "Inputs", "Email")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "File",
    icon: "glyphicon glyphicon-file",
    support: { feature: false, mui: true },
    tip: "For selecting a file from your local file system.",
    prop: getBucketProps("Components", "Inputs", "File")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Month",
    icon: "fa fa-calendar-o",
    support: { feature: true, mui: true },
    tip: "For entering a date with a year and a month, but no time zone.",
    prop: getBucketProps("Components", "Inputs", "Month")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Number",
    icon: "fa fa-calculator",
    support: { feature: true, mui: true },
    tip: "For numeric input, can be any rational integer or float value (5 | 5.3 | 5.489E20).",
    prop: getBucketProps("Components", "Inputs", "Number")
  },
  // object
  // OnOff
  {
    type: "Components",
    category: "Inputs",
    wgt: "OnOff",
    icon: "fa fa-check-square",
    support: { feature: true, mui: true },
    tip: "For a simple On or Off single switch selection.",
    prop: getBucketProps("Components", "Inputs", "OnOff")
  },
  {
    type: "Components",
    category: "Inputs",
    wgt: "Password",
    icon: "fa fa-unlock-alt",
    support: { feature: true, mui: true },
    tip: "For entering secure value. The entered information is not visible.",
    prop: getBucketProps("Components", "Inputs", "Password")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Radio Buttons",
    icon: "fa fa-dot-circle-o",
    support: { feature: true, mui: true },
    tip: "For selecting one option from a small list of options.",
    prop: getBucketProps("Components", "Inputs", "Radio Buttons")
  },
  {
    type: "Components",
    category: "Inputs",
    wgt: "Range",
    icon: "fa fa-arrows-h",
    support: { feature: true, mui: true },
    tip: "For number input, but unlinke the number input type, the value is less important. It is displayed to the user as a slider control.",
    prop: getBucketProps("Components", "Inputs", "Range")
  },
  // object
  // SelectList
  {
    type: "Components",
    category: "Inputs",
    wgt: "Select List",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: true },
    tip: "For selecting option(s) from a large list of options. By default it will only take one option, but if the multiple attribute is provided, multiple options can be selected.",
    prop: getBucketProps("Components", "Inputs", "Select List")
  },
  // object
  // CheckRadioBoxes
  {
    type: "Components",
    category: "Inputs",
    wgt: "Switches",
    icon: "fa fa-check-square",
    support: { feature: true, mui: true },
    tip: "For enabling one or more options from a small list of options.",
    prop: getBucketProps("Components", "Inputs", "Switches")
  },
  // Tag
  {
    type: "Components",
    category: "Inputs",
    wgt: "Tag Autocomplete",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: true },
    tip: "For selecting option(s) from a large list of options. By default it will only take one option, but if the multiple attribute is provided, multiple options can be selected. It also supports accepting user supplied value which is not listed in the options.",
    prop: getBucketProps("Components", "Inputs", "Tag Autocomplete")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Tel",
    icon: "fa fa-phone",
    support: { feature: true, mui: true },
    tip: "For entering phone numbers.",
    prop: getBucketProps("Components", "Inputs", "Tel")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Text",
    icon: "fa fa-tumblr",
    support: { feature: true, mui: true },
    tip: "For entering text.",
    prop: getBucketProps("Components", "Inputs", "Text")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Text Area",
    icon: "fa fa-tumblr",
    support: { feature: true, mui: true },
    tip: "For entering large amount of text.",
    prop: getBucketProps("Components", "Inputs", "Text Area")
  },
  {
    type: "Components",
    category: "Inputs",
    wgt: "Time",
    icon: "fa fa-clock-o",
    support: { feature: true, mui: true },
    tip: "For entering a time without a time zone.",
    prop: getBucketProps("Components", "Inputs", "Time")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "URL",
    icon: "fa fa-anchor",
    support: { feature: true, mui: true },
    tip: "For entering a URL. It must start with a valid URI scheme.(eg. http://, ftp:// or mailto:)",
    prop: getBucketProps("Components", "Inputs", "URL")
  },
  // object
  {
    type: "Components",
    category: "Inputs",
    wgt: "Week",
    icon: "fa fa-pencil-square-o",
    support: { feature: true, mui: true },
    tip: "For entering a date that consists of a week-year number and a week number, but no time zone.",
    prop: getBucketProps("Components", "Inputs", "Week")
  }
  // object
];
const basicConfig = [
  {
    type: "Components",
    category: "Basic",
    wgt: "Filler",
    icon: "fa fa-calendar-o",
    support: { feature: true, mui: true },
    tip: "For reserving a filler space in your form. It does not hold any information.",
    prop: getBucketProps("Components", "Basic", "Filler")
  },
  // object
  {
    type: "Components",
    category: "Basic",
    wgt: "Reset Button",
    icon: "fa fa-play",
    support: { feature: true, mui: true },
    tip: "To reset the form values.",
    prop: getBucketProps("Components", "Basic", "Reset Button")
  },
  /* ,
   {
   'type': 'Components', 
   'category':'Basic',
   'wgt':'Button',
   'icon':'fa fa-play',
   'support': {'feature':true, mui: true},
   'tip':'For using as Action Button.',
   'prop': {
   'label' : 'A Label',
   'value' : 'Action Button',
   'help' : '',
   'disabled' : '',          // disabled=true or false or just disabled
   'condition' : '',
   'cursor' : '',
   'ref' : '',
   'btnSize' : '',         // from constants:BTN_SIZES 
   'btnStyle' : '',   // from constants:BTN_STYLES
   'colLeft' : '',     // ratio from 12 parts
   'colRight' : '',
   'colHelp' : '',
   'addonLeft' : '',
   'addonLeftTxt' : '',
   'addonRight' : '',
   'addonRightTxt' : '',
   } // prop
   }
   */
  {
    type: "Components",
    category: "Basic",
    wgt: "Search",
    icon: "fa fa-search",
    support: { feature: false, mui: false },
    tip: "A text input field styled in a way that is consistent with the platform's search field.",
    prop: getBucketProps("Components", "Basic", "Search")
  },
  // object
  {
    type: "Components",
    category: "Basic",
    wgt: "Static Text",
    icon: "fa fa-tumblr",
    support: { feature: true, mui: true },
    tip: "For only displaying a preset text.",
    prop: getBucketProps("Components", "Basic", "Static Text")
  },
  // object
  // Button
  {
    type: "Components",
    category: "Basic",
    wgt: "Submit Button",
    icon: "fa fa-play",
    support: { feature: true, mui: true },
    tip: "For submitting the form values.",
    prop: getBucketProps("Components", "Basic", "Submit Button")
  }
];
const infoConfig = [
  {
    type: "Components",
    category: "Informational",
    wgt: "Animation",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Informational", "Animation")
  },
  // object
  {
    type: "Components",
    category: "Informational",
    wgt: "Audio",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Informational", "Audio")
  },
  // object
  {
    type: "Components",
    category: "Informational",
    wgt: "Background Image",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Informational", "Background Image")
  },
  // object
  {
    type: "Components",
    category: "Informational",
    wgt: "Carousel",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Informational", "Carousel")
  },
  // object
  {
    type: "Components",
    category: "Informational",
    wgt: "Footer",
    icon: "glyphicon glyphicon-trash",
    support: { feature: true, mui: false },
    tip: "A Footer.",
    prop: getBucketProps("Components", "Informational", "Footer")
  },
  {
    type: "Components",
    category: "Informational",
    wgt: "Formatted Text",
    icon: "fa fa-paragraph",
    support: { feature: true, mui: false },
    tip: "A formatted text.",
    prop: getBucketProps("Components", "Informational", "Formatted Text")
  },
  // Info
  {
    type: "Components",
    category: "Informational",
    wgt: "Header",
    icon: "glyphicon glyphicon-trash",
    support: { feature: true, mui: false },
    tip: "A Header.",
    prop: getBucketProps("Components", "Informational", "Header")
  },
  {
    type: "Components",
    category: "Informational",
    wgt: "Hyper Link",
    icon: "glyphicon glyphicon-trash",
    support: { feature: true, mui: false },
    tip: "A hyper link.",
    prop: getBucketProps("Components", "Informational", "Hyper Link")
  },
  {
    type: "Components",
    category: "Informational",
    wgt: "Image",
    icon: "fa fa-image",
    support: { feature: true, mui: false },
    tip: "An image .",
    prop: getBucketProps("Components", "Informational", "Image")
  },
  {
    type: "Components",
    category: "Informational",
    wgt: "Line",
    icon: "fa fa-pagelines",
    support: { feature: true, mui: false },
    tip: "A line divider .",
    prop: getBucketProps("Components", "Informational", "Line")
  },
  {
    type: "Components",
    category: "Informational",
    wgt: "Logo",
    icon: "fa fa-pagelines",
    support: { feature: true, mui: false },
    tip: "A logo .",
    prop: getBucketProps("Components", "Informational", "Logo")
  },
  {
    type: "Components",
    category: "Informational",
    wgt: "Map",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Informational", "Map")
  },
  // object
  {
    type: "Components",
    category: "Informational",
    wgt: "Print Button",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Informational", "Print Button")
  },
  // object
  {
    type: "Components",
    category: "Informational",
    wgt: "Video",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Informational", "Video")
  }
  // object
];
const compositeConfig = [
  {
    type: "Components",
    category: "Composite",
    wgt: "Address",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Composite", "Address")
  },
  // object
  {
    type: "Components",
    category: "Composite",
    wgt: "Composite Email",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Composite", "Composite Email")
  },
  // object
  {
    type: "Components",
    category: "Composite",
    wgt: "Full Name",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Composite", "Full Name")
  },
  // object
  {
    type: "Components",
    category: "Composite",
    wgt: "Phone",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Composite", "Phone")
  },
  // object
  {
    type: "Components",
    category: "Composite",
    wgt: "Signiture",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Composite", "Signiture")
  }
  // object
];
const unsupportedConfig = [
  {
    type: "Components",
    category: "Widgets",
    wgt: "Cascade Select List",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Cascade Select List")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Combo Box",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Combo Box")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Credit Card",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Credit Card")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Drag & Drop Upload",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Drag & Drop Upload")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Dual Select Box",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Dual Select Box")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Geo Location",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Geo Location")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "IP Address",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "IP Address")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Like & Dislike",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Like & Dislike")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Photo Capture",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Photo Capture")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Range Slider",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Range Slider")
  },
  // object
  {
    type: "Components",
    category: "Widgets",
    wgt: "Terms of Service",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Widgets", "Terms of Service")
  },
  // object
  {
    type: "Components",
    category: "Survey",
    wgt: "Matrix",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Survey", "Matrix")
  },
  // object
  {
    type: "Components",
    category: "Survey",
    wgt: "Star Rating",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Survey", "Star Rating")
  },
  // object
  {
    type: "Components",
    category: "Survey",
    wgt: "Scale Rating",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Survey", "Scale Rating")
  },
  // object
  {
    type: "Components",
    category: "Survey",
    wgt: "Flash Cards",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Survey", "Flash Cards")
  },
  // object
  {
    type: "Components",
    category: "Education",
    wgt: "Q & A",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Education", "Q & A")
  },
  // object
  {
    type: "Components",
    category: "Calculated",
    wgt: "Discounts",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Calculated", "Discounts")
  },
  // object
  {
    type: "Components",
    category: "Calculated",
    wgt: "FedEx Shipping Charges",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Calculated", "FedEx Shipping Charges")
  },
  // object
  {
    type: "Components",
    category: "Calculated",
    wgt: "UPS Shipping Charges",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Calculated", "UPS Shipping Charges")
  },
  // object
  {
    type: "Components",
    category: "Calculated",
    wgt: "USPS Shipping Charges",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Calculated", "USPS Shipping Charges")
  },
  // object
  {
    type: "Components",
    category: "Calculated",
    wgt: "Smart Dates",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Calculated", "Smart Dates")
  },
  // object
  {
    type: "Components",
    category: "Calculated",
    wgt: "Surcharge",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Calculated", "Surcharge")
  },
  // object
  {
    type: "Components",
    category: "Calculated",
    wgt: "Taxes",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: false, mui: false },
    tip: "???.",
    prop: getBucketProps("Components", "Calculated", "Taxes")
  }
  // object
];
const themeConfig = [
  {
    type: "Themes",
    category: "Standard",
    wgt: "Yellow",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: false },
    tip: "Sample Yellow theme.",
    prop: getBucketProps("Themes", "Standard", "Standard Yellow")
  },
  // object
  {
    type: "Themes",
    category: "Standard",
    wgt: "Slate",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: false },
    tip: "Sample Slate theme.",
    prop: getBucketProps("Themes", "Standard", "Standard Slate")
  },
  // object
  {
    type: "Themes",
    category: "Paper Form",
    wgt: "White",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: false },
    tip: "Sample White Paper theme.",
    prop: getBucketProps("Themes", "Paper Form", "Paper Form White")
  },
  // object
  {
    type: "Themes",
    category: "Paper Form",
    wgt: "Slate",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: false },
    tip: "Sample Slate Paper theme.",
    prop: getBucketProps("Themes", "Paper Form", "Paper Form Slate")
  },
  // object
  {
    type: "Themes",
    category: "Bootstrap",
    wgt: "BS 3",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: false },
    tip: "Sample Bootstrap 3 theme.",
    prop: getBucketProps("Themes", "Bootstrap", "BS 3")
  },
  // object
  {
    type: "Themes",
    category: "Bootstrap",
    wgt: "BS 4",
    icon: "glyphicon glyphicon-th-list",
    support: { feature: true, mui: false },
    tip: "Sample Bootstrap 4 theme.",
    prop: getBucketProps("Themes", "Bootstrap", "BS 4")
  }
  // object
];
function CompConfig() {
  let paletteConfigList = [].concat(
    layoutConfig,
    containerConfig,
    inputConfig,
    basicConfig,
    infoConfig,
    compositeConfig,
    themeConfig,
    unsupportedConfig
  );
  return paletteConfigList;
}
class LazyRipple {
  constructor() {
    __publicField(this, "mountEffect", () => {
      if (this.shouldMount && !this.didMount) {
        if (this.ref.current !== null) {
          this.didMount = true;
          this.mounted.resolve();
        }
      }
    });
    this.ref = {
      current: null
    };
    this.mounted = null;
    this.didMount = false;
    this.shouldMount = false;
    this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new LazyRipple();
  }
  static use() {
    const ripple = useLazyRef(LazyRipple.create).current;
    const [shouldMount, setShouldMount] = React.useState(false);
    ripple.shouldMount = shouldMount;
    ripple.setShouldMount = setShouldMount;
    React.useEffect(ripple.mountEffect, [shouldMount]);
    return ripple;
  }
  mount() {
    if (!this.mounted) {
      this.mounted = createControlledPromise();
      this.shouldMount = true;
      this.setShouldMount(this.shouldMount);
    }
    return this.mounted;
  }
  /* Ripple API */
  start(...args) {
    this.mount().then(() => this.ref.current?.start(...args));
  }
  stop(...args) {
    this.mount().then(() => this.ref.current?.stop(...args));
  }
  pulsate(...args) {
    this.mount().then(() => this.ref.current?.pulsate(...args));
  }
}
function useLazyRipple() {
  return LazyRipple.use();
}
function createControlledPromise() {
  let resolve;
  let reject;
  const p = new Promise((resolveFn, rejectFn) => {
    resolve = resolveFn;
    reject = rejectFn;
  });
  p.resolve = resolve;
  p.reject = reject;
  return p;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r2, e) {
  if (null == r2) return {};
  var t = {};
  for (var n in r2) if ({}.hasOwnProperty.call(r2, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r2[n];
  }
  return t;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
const TransitionGroupContext = React__default.createContext(null);
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children) Children.map(children, function(c) {
    return c;
  }).forEach(function(child) {
    result[child.key] = mapper(child);
  });
  return result;
}
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function(key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children;
}
var values = Object.values || function(obj) {
  return Object.keys(obj).map(function(k) {
    return obj[k];
  });
};
var defaultProps = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children = _extends({}, state.children);
        delete children[child.key];
        return {
          children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props, Component2 = _this$props.component, childFactory2 = _this$props.childFactory, props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component2 === null) {
      return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /* @__PURE__ */ React__default.createElement(Component2, props, children));
  };
  return TransitionGroup2;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout
  } = props;
  const [leaving, setLeaving] = React.useState(false);
  const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  React.useEffect(() => {
    if (!inProp && onExited != null) {
      const timeoutId = setTimeout(onExited, timeout);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return void 0;
  }, [onExited, inProp, timeout]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: childClassName
    })
  });
}
process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const exitKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const pulsateKeyframe = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
});
const TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${touchRippleClasses.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
  }

  &.${touchRippleClasses.ripplePulsate} {
    animation-duration: ${({
  theme
}) => theme.transitions.duration.shorter}ms;
  }

  & .${touchRippleClasses.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${touchRippleClasses.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
  }

  & .${touchRippleClasses.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
const TouchRipple = /* @__PURE__ */ React.forwardRef(function TouchRipple2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTouchRipple"
  });
  const {
    center: centerProp = false,
    classes = {},
    className,
    ...other
  } = props;
  const [ripples, setRipples] = React.useState([]);
  const nextKey = React.useRef(0);
  const rippleCallback = React.useRef(null);
  React.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);
  const ignoringMouseDown = React.useRef(false);
  const startTimer = useTimeout();
  const startTimerCommit = React.useRef(null);
  const container2 = React.useRef(null);
  const startCommit = React.useCallback((params) => {
    const {
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples((oldRipples) => [...oldRipples, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(classes.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(classes.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(classes.child, touchRippleClasses.child),
        childLeaving: clsx(classes.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(classes.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = React.useCallback((event2 = {}, options2 = {}, cb = () => {
  }) => {
    const {
      pulsate: pulsate2 = false,
      center = centerProp || options2.pulsate,
      fakeElement = false
      // For test purposes
    } = options2;
    if (event2?.type === "mousedown" && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if (event2?.type === "touchstart") {
      ignoringMouseDown.current = true;
    }
    const element = fakeElement ? null : container2.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let rippleX;
    let rippleY;
    let rippleSize;
    if (center || event2 === void 0 || event2.clientX === 0 && event2.clientY === 0 || !event2.clientX && !event2.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event2.touches && event2.touches.length > 0 ? event2.touches[0] : event2;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }
    if (event2?.touches) {
      if (startTimerCommit.current === null) {
        startTimerCommit.current = () => {
          startCommit({
            pulsate: pulsate2,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        };
        startTimer.start(DELAY_RIPPLE, () => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        });
      }
    } else {
      startCommit({
        pulsate: pulsate2,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit, startTimer]);
  const pulsate = React.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = React.useCallback((event2, cb) => {
    startTimer.clear();
    if (event2?.type === "touchend" && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.start(0, () => {
        stop(event2, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples((oldRipples) => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, [startTimer]);
  React.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, {
    className: clsx(touchRippleClasses.root, classes.root, className),
    ref: container2,
    ...other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, {
      component: null,
      exit: true,
      children: ripples
    })
  });
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass("MuiButtonBase", slot);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]);
const useUtilityClasses$1 = (ownerState) => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ["root", disabled && "disabled", focusVisible && "focusVisible"]
  };
  const composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }
  return composedClasses;
};
const ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
});
const ButtonBase = /* @__PURE__ */ React.forwardRef(function ButtonBase2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiButtonBase"
  });
  const {
    action,
    centerRipple = false,
    children,
    className,
    component = "button",
    disabled = false,
    disableRipple = false,
    disableTouchRipple = false,
    focusRipple = false,
    focusVisibleClassName,
    LinkComponent = "a",
    onBlur,
    onClick,
    onContextMenu,
    onDragLeave,
    onFocus,
    onFocusVisible,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    tabIndex = 0,
    TouchRippleProps,
    touchRippleRef,
    type,
    ...other
  } = props;
  const buttonRef = React.useRef(null);
  const ripple = useLazyRipple();
  const handleRippleRef = useForkRef(ripple.ref, touchRippleRef);
  const [focusVisible, setFocusVisible] = React.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  React.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
  React.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple) {
      ripple.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, ripple]);
  const handleMouseDown = useRippleHandler(ripple, "start", onMouseDown, disableTouchRipple);
  const handleContextMenu = useRippleHandler(ripple, "stop", onContextMenu, disableTouchRipple);
  const handleDragLeave = useRippleHandler(ripple, "stop", onDragLeave, disableTouchRipple);
  const handleMouseUp = useRippleHandler(ripple, "stop", onMouseUp, disableTouchRipple);
  const handleMouseLeave = useRippleHandler(ripple, "stop", (event2) => {
    if (focusVisible) {
      event2.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event2);
    }
  }, disableTouchRipple);
  const handleTouchStart = useRippleHandler(ripple, "start", onTouchStart, disableTouchRipple);
  const handleTouchEnd = useRippleHandler(ripple, "stop", onTouchEnd, disableTouchRipple);
  const handleTouchMove = useRippleHandler(ripple, "stop", onTouchMove, disableTouchRipple);
  const handleBlur = useRippleHandler(ripple, "stop", (event2) => {
    if (!isFocusVisible(event2.target)) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event2);
    }
  }, false);
  const handleFocus = useEventCallback((event2) => {
    if (!buttonRef.current) {
      buttonRef.current = event2.currentTarget;
    }
    if (isFocusVisible(event2.target)) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event2);
      }
    }
    if (onFocus) {
      onFocus(event2);
    }
  });
  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== "button" && !(button.tagName === "A" && button.href);
  };
  const handleKeyDown = useEventCallback((event2) => {
    if (focusRipple && !event2.repeat && focusVisible && event2.key === " ") {
      ripple.stop(event2, () => {
        ripple.start(event2);
      });
    }
    if (event2.target === event2.currentTarget && isNonNativeButton() && event2.key === " ") {
      event2.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event2);
    }
    if (event2.target === event2.currentTarget && isNonNativeButton() && event2.key === "Enter" && !disabled) {
      event2.preventDefault();
      if (onClick) {
        onClick(event2);
      }
    }
  });
  const handleKeyUp = useEventCallback((event2) => {
    if (focusRipple && event2.key === " " && focusVisible && !event2.defaultPrevented) {
      ripple.stop(event2, () => {
        ripple.pulsate(event2);
      });
    }
    if (onKeyUp) {
      onKeyUp(event2);
    }
    if (onClick && event2.target === event2.currentTarget && isNonNativeButton() && event2.key === " " && !event2.defaultPrevented) {
      onClick(event2);
    }
  });
  let ComponentProp = component;
  if (ComponentProp === "button" && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  const buttonProps = {};
  if (ComponentProp === "button") {
    buttonProps.type = type === void 0 ? "button" : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = "button";
    }
    if (disabled) {
      buttonProps["aria-disabled"] = disabled;
    }
  }
  const handleRef = useForkRef(ref, buttonRef);
  const ownerState = {
    ...props,
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  };
  const classes = useUtilityClasses$1(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, {
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState,
    onBlur: handleBlur,
    onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type,
    ...buttonProps,
    ...other,
    children: [children, enableTouchRipple ? /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple, {
      ref: handleRippleRef,
      center: centerRipple,
      ...TouchRippleProps
    }) : null]
  });
});
function useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
  return useEventCallback((event2) => {
    if (eventCallback) {
      eventCallback(event2);
    }
    if (!skipRippleAction) {
      ripple[rippleAction](event2);
    }
    return true;
  });
}
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
} : void 0;
const ListContext = /* @__PURE__ */ React.createContext({});
if (process.env.NODE_ENV !== "production") {
  ListContext.displayName = "ListContext";
}
function getListItemButtonUtilityClass(slot) {
  return generateUtilityClass("MuiListItemButton", slot);
}
const listItemButtonClasses = generateUtilityClasses("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};
const useUtilityClasses = (ownerState) => {
  const {
    alignItems,
    classes,
    dense,
    disabled,
    disableGutters,
    divider,
    selected: selected2
  } = ownerState;
  const slots = {
    root: ["root", dense && "dense", !disableGutters && "gutters", divider && "divider", disabled && "disabled", alignItems === "flex-start" && "alignItemsFlexStart", selected2 && "selected"]
  };
  const composedClasses = composeClasses(slots, getListItemButtonUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const ListItemButtonRoot = styled(ButtonBase, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver
})(memoTheme(({
  theme
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: theme.transitions.create("background-color", {
    duration: theme.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${listItemButtonClasses.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${listItemButtonClasses.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${listItemButtonClasses.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${listItemButtonClasses.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${listItemButtonClasses.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState
    }) => ownerState.divider,
    style: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
})));
const ListItemButton = /* @__PURE__ */ React.forwardRef(function ListItemButton2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiListItemButton"
  });
  const {
    alignItems = "center",
    autoFocus = false,
    component = "div",
    children,
    dense = false,
    disableGutters = false,
    divider = false,
    focusVisibleClassName,
    selected: selected2 = false,
    className,
    ...other
  } = props;
  const context = React.useContext(ListContext);
  const childContext = React.useMemo(() => ({
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context.dense, dense, disableGutters]);
  const listItemRef = React.useRef(null);
  useEnhancedEffect(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== "production") {
        console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered.");
      }
    }
  }, [autoFocus]);
  const ownerState = {
    ...props,
    alignItems,
    dense: childContext.dense,
    disableGutters,
    divider,
    selected: selected2
  };
  const classes = useUtilityClasses(ownerState);
  const handleRef = useForkRef(listItemRef, ref);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: childContext,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButtonRoot, {
      ref: handleRef,
      href: other.href || other.to,
      component: (other.href || other.to) && component === "div" ? "button" : component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      ownerState,
      className: clsx(classes.root, className),
      ...other,
      classes,
      children
    })
  });
});
process.env.NODE_ENV !== "production" ? ListItemButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
const drawerWidth = 240;
const useStyles$v = (theme) => ({
  root: {
    display: "flex"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#2E2649",
    width: "80vw",
    borderRadius: "32px",
    height: "44px",
    position: "fixed",
    top: "10px",
    left: "10vw"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  toolbar: { ...theme.mixins.toolbar, minheight: "44px" }
});
function Navigation(props) {
  const theme = useTheme();
  const classes = useStyles$v(theme);
  const [values2, setValues] = React__default.useState({
    showMenu: false
  });
  const [selected2, setSelected] = React__default.useState(0);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: classes.root, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CssBaseline, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppBar, { position: "fixed", sx: { ...classes.appBar }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Toolbar, { style: { minHeight: "44px" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h6", noWrap: true, children: "zeus" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "svg",
        {
          style: { right: "10px", position: "absolute" },
          width: "25",
          height: "25",
          viewBox: "0 0 469 784",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          onClick: () => {
            setValues({ ...values2, showMenu: !values2.showMenu });
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M0 783.214V231.8C0 103.792 103.792 0 231.8 0V551.414C231.8 679.422 128.008 783.214 0 783.214Z",
                fill: "#00A69D"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M229.397 404.87C323.654 404.87 400.064 328.46 400.064 234.203C400.064 139.946 323.654 63.5359 229.397 63.5359C135.14 63.5359 58.73 139.946 58.73 234.203C58.73 328.46 135.14 404.87 229.397 404.87Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M231.8 0C362.304 0 468.093 105.789 468.093 236.294C468.093 366.798 362.304 472.587 231.8 472.587V0Z",
                fill: "#FFC500"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M429.086 366.33C388.143 295.648 316.213 245.187 231.8 233.61V472.619C314.247 472.587 386.801 430.334 429.086 366.33Z",
                fill: "#F15918"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M154.939 266.283C172.656 266.283 187.019 251.92 187.019 234.203C187.019 216.486 172.656 202.123 154.939 202.123C137.222 202.123 122.859 216.486 122.859 234.203C122.859 251.92 137.222 266.283 154.939 266.283Z",
                fill: "#333333"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M262.663 76.2369C268.213 76.2369 272.712 71.738 272.712 66.1884C272.712 60.6389 268.213 56.14 262.663 56.14C257.114 56.14 252.615 60.6389 252.615 66.1884C252.615 71.738 257.114 76.2369 262.663 76.2369Z",
                fill: "#EDB20A"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          style: {
            position: "absolute",
            transition: "width 0.3s, height 0.3s",
            backgroundColor: "rgb(197, 197, 197)",
            borderRadius: "20px",
            right: "20px",
            top: "20px",
            width: values2.showMenu ? 300 : 0,
            height: values2.showMenu ? 300 : 0
          }
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Drawer,
      {
        sx: { ...classes.drawer },
        variant: "permanent",
        classes: {
          paper: classes.drawerPaper
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.toolbar }),
          props.menuItems.map((value2, index) => {
            if (value2.divider) {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}, index);
            } else {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(List, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                ListItemButton,
                {
                  selected: selected2 === index,
                  onClick: (event2) => setSelected(index),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { children: value2.icon }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: value2.title })
                  ]
                },
                index
              ) }, index);
            }
          })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("main", { style: classes.content, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.toolbar }),
      props.menuItems[selected2].container
    ] })
  ] });
}
function MainAccountDisplay(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const isWhoamiLaunch2 = da.isWhoamiLaunch();
  let accountCode = null;
  if (isWhoamiLaunch2) {
    accountCode = da.getEnvVar.locationData.accountNo;
  } else {
    if (da.isState("upap")) {
      accountCode = da.getMembers("accountCode");
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: { marginRight: "20" }, children: [
    "Account: ",
    accountCode
  ] });
}
const useStyles$u = (theme) => {
  return {
    menu: {
      zIndex: "9000"
    }
  };
};
function MainAccountSelect(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  useTheme();
  const classes = useStyles$u();
  const members = da.getMembers("all") || [];
  if (members && members.length > 1) {
    const menuList = members.map((member, i) => {
      const code = member.account.accountNo;
      const disp = member.account.accountCode || member.account.accountNo;
      const type = member.member.type;
      return {
        code,
        display: disp + " - " + type,
        bucket: { color: "primary", variant: "contained" }
      };
    });
    const upapMemberNdx = da.selected({ entity: "members", type: "get", action: "index" });
    async function handleSelection(e, p, item, i) {
      console.log("ActiveVersion:handleClick - change active version to : " + item.code);
      await da.processAccountChange(i);
    }
    const menuOptions = {
      format: "form",
      // V1
      items: menuList,
      bucket: {
        p: null,
        color: "primary",
        variant: "outlined",
        size: "small",
        handleSelection,
        selection: upapMemberNdx,
        className: classes.menu
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonMenuCtnr, { ...menuOptions });
  } else {
    members && members.length && members[0].account.accountNo || "Unknown";
    members && members.length && members[0].account.accountCode;
    return null;
  }
}
function MainFormNoDisplay(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const display = props.display || "";
  const form = props.form || null;
  let formNo = "";
  if (form) {
    formNo = form.formNo;
  } else {
    formNo = da.selected({ entity: "forms", type: "get", action: "prop", property: "formNo" });
  }
  if (!formNo) {
    return null;
  } else {
    if (display) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Avatar, { sx: { bgcolor: "secondary.main", display: "inline", p: 1 }, children: [
        " ",
        formNo,
        " "
      ] });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Avatar,
        {
          sx: {
            margin: "10px",
            color: "#fff",
            backgroundColor: "secondary.main"
          },
          children: formNo
        }
      );
    }
  }
}
function MainSnackbarComp(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const msg = da.getSnackbarMsg();
  const onClose = (event2) => {
    da.setSnackbarMsg("");
  };
  if (msg) {
    const snack = {
      open: true,
      variant: da.getSnackbarVariant(),
      message: msg,
      duration: da.getSnackbarDuration(),
      onClose
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SnackbarComp, { ...snack });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: " " });
  }
}
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
  }
  render() {
    return this.props.children;
  }
}
const useStyles$t = (theme) => {
  return {
    image: {
      minHeight: "45vh",
      backgroundImage: "url(https://source.unsplash.com/random)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center"
    }
  };
};
function UnsplashImgComp(props) {
  userTheme();
  const classes = useStyles$t();
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...classes.image, ...className } });
}
function RaisedComp(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { component: Paper, elevation: 6, square: true, children: props.children });
}
function Input({ value: value2, onWrite }) {
  React__default.useEffect(() => {
    const timer = setTimeout(() => onWrite(value2), 1e3);
    return () => clearTimeout(timer);
  }, [value2, onWrite]);
  function handleChange(event2) {
    onWrite(event2.target.value);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "text", value: value2, onChange: handleChange });
}
function Title({ value: value2, isWriting }) {
  React__default.useEffect(() => {
    if (!isWriting) {
      document.title = value2;
    }
  }, [isWriting, value2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: value2 });
}
function HelloWorld() {
  const [title, setTitle] = React__default.useState("Hello, World!");
  const [isWriting, setIsWriting] = React__default.useState(false);
  function handleWrite(value2) {
    setIsWriting(value2 !== title);
    setTitle(value2);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("main", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { value: title, isWriting }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { value: title, onWrite: handleWrite }),
    "User is writing: ",
    isWriting.toString()
  ] });
}
function Sample1() {
  return HelloWorld();
}
function Footer$1({ remaining, total }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
    remaining,
    " / ",
    total,
    " left"
  ] });
}
function TodoList$1({ todos, toggleTodo }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { listStyle: "none" }, children: todos && todos.map((t, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "li",
    {
      onClick: () => toggleTodo(i),
      style: {
        margin: 10,
        opacity: t.completed ? 0.5 : 1,
        cursor: "pointer",
        textDecoration: t.completed ? "line-through" : "none"
      },
      children: t.text
    },
    t.id
  )) });
}
class Todos {
  constructor() {
    __publicField(this, "todos", [
      { id: 1, text: "Buy eggs", completed: true },
      { id: 2, text: "Write a post", completed: false }
    ]);
    __publicField(this, "toggleTodo", (index) => {
      this.todos[index].completed = !this.todos[index].completed;
    });
  }
  get remainingTodos() {
    return this.todos.filter((t) => !t.completed).length;
  }
}
const App$1 = () => {
  const store = useContext(Todos);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "App", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "A Todo App yet again!" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TodoList$1, { todos: store.todos, toggleTodo: store.toggleTodo }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Footer$1, { remaining: store.remainingTodos, total: store.todos.length })
  ] });
};
function Sample2() {
  return App$1();
}
function Footer({ remaining, total }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
    remaining,
    " / ",
    total,
    " left"
  ] });
}
function TodoList({ todos, toggleTodo }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { listStyle: "none" }, children: todos && todos.map((t, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "li",
    {
      onClick: () => toggleTodo(i),
      style: {
        margin: 10,
        opacity: t.completed ? 0.5 : 1,
        cursor: "pointer",
        textDecoration: t.completed ? "line-through" : "none"
      },
      children: t.text
    },
    t.id
  )) });
}
const App = () => {
  const store = useContext(TodoStore);
  return (
    // Can also use return 'useObserver(() => ( dom ));' but 'obserer' is better as it avoids re-rendering child coponents
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "App", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "A Todo App yet again!" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TodoList, { todos: store.todos, toggleTodo: store.toggleTodo }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Footer, { remaining: store.remainingTodos, total: store.todos.length })
    ] })
  );
};
function Sample3() {
  return App();
}
function Sample5(props) {
  const useStyles3 = (theme2) => ({
    button: {
      margin: theme2.spacing(3)
    },
    input: {
      display: "none"
    },
    iconRight: {
      marginLeft: theme2.spacing(1)
    },
    iconLeft: {
      marginRight: theme2.spacing(1)
    },
    svg: {
      display: "block",
      top: "100%",
      left: "0",
      width: "100",
      height: "82",
      //      background: `url(${svgForLogo})`,
      backgroundSize: "100px 82px"
    },
    pattern: {
      backgroundColor: "#2e4057",
      height: "100vh",
      //      background: `url(${pattern})`,
      padding: "20"
    },
    imageIcon: {
      height: "100%"
    },
    iconRoot: {
      textAlign: "center"
    }
  });
  const theme = useTheme();
  const classes = useStyles3(theme);
  const onTFChange = (e, p, item, i) => {
    console.log("onTFChange invoked for Change and Blur : " + e.target.value);
  };
  const anySelection = (e, p, item, i) => {
    console.log("Sample5 Selection Clicked " + item.code + " " + i);
  };
  const anyClick = (e, p, item, i) => {
    console.log("Sample5 Selection Clicked " + item.code + " " + i);
  };
  const anyChange = (e, p, item, i) => {
    console.log("Sample5 Change Clicked " + item.code + " " + i);
  };
  const checkDisabled = (item, i) => {
    return false;
  };
  const tfOptions1 = {
    format: "form",
    bucket: {
      p: null,
      id: "someId",
      label: "someLabel",
      name: "name1",
      type: "text",
      variant: "filled",
      handleChange: onTFChange,
      handleBlur: onTFChange,
      value: "someValue",
      helperText: "Some help text",
      margin: "normal",
      autoComplete: ""
    }
  };
  const tfOptions2 = {
    format: "form",
    bucket: {
      p: null,
      id: "someId",
      label: "someLabel",
      name: "name2",
      type: "text",
      variant: "filled",
      handleChange: onTFChange,
      handleBlur: onTFChange,
      value: "someValue",
      helperText: "Some help text",
      margin: "normal",
      autoComplete: "",
      multiline: true,
      rows: "4",
      rowsMax: "6"
    }
  };
  const tfOptions3 = {
    format: "form",
    items: [
      { code: "a", display: "A", bucket: {} },
      { code: "b", display: "B", bucket: {} },
      { code: "c", display: "C", bucket: {} }
    ],
    bucket: {
      p: null,
      id: "someId",
      label: "some Select Label",
      name: "name3",
      type: "select",
      variant: "filled",
      handleChange: onTFChange,
      handleBlur: onTFChange,
      value: "someValue",
      helperText: "Some help text",
      margin: "normal",
      autoComplete: "",
      select: true,
      required: true
    }
  };
  const tfOptions4 = {
    format: "form",
    items: [
      { code: "a", display: "A", bucket: {} },
      { code: "b", display: "B", bucket: {} },
      { code: "c", display: "C", bucket: {} }
    ],
    bucket: {
      p: null,
      id: "someId",
      label: "TF option 4 Label",
      name: "name3",
      type: "select",
      variant: "filled",
      handleChange: onTFChange,
      handleBlur: onTFChange,
      value: "someValue",
      helperText: "Some help text",
      margin: "normal",
      autoComplete: "",
      select: true,
      required: true
    }
  };
  const fourColOptions = {
    format: "form",
    bucket: {
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...tfOptions1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...tfOptions1 })
      ] }),
      children2: /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...tfOptions2 }),
      children3: /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...tfOptions3 }),
      children4: /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...tfOptions4 })
    }
  };
  const ckrdOptions1 = {
    format: "form",
    items: [
      {
        code: "a",
        display: "A",
        bucket: {
          name: "checkA",
          selected: true,
          className: classes.button,
          labelPlacement: "end"
        }
      },
      {
        code: "b",
        display: "B",
        bucket: {
          name: "checkB",
          selected: false,
          className: classes.button,
          labelPlacement: "end"
        }
      },
      {
        code: "c",
        display: "C",
        bucket: {
          name: "checkC",
          selected: true,
          className: classes.button,
          labelPlacement: "end"
        }
      },
      {
        code: "d",
        display: "D",
        bucket: {
          name: "checkD",
          selected: false,
          className: classes.button,
          labelPlacement: "end"
        }
      }
    ],
    bucket: {
      p: null,
      handleChange: anyChange,
      //selection: 'c'   ... only for Raadiobox
      name: "name4",
      label: "Check Boxes Group Label",
      groupRowPlacement: false,
      type: "check",
      helperText: "Some help text(two are preselected)"
    }
  };
  const ckrdOptions2 = {
    format: "form",
    items: [
      {
        code: "e",
        display: "E",
        bucket: {
          name: "radioE",
          // selected: ,     not used for radio
          className: classes.button,
          labelPlacement: "end"
        }
      },
      {
        code: "f",
        display: "F",
        bucket: {
          name: "radioF",
          // selected: ,     not used for radio
          className: classes.button,
          labelPlacement: "end"
        }
      },
      {
        code: "g",
        display: "G",
        bucket: {
          name: "radioG",
          // selected: ,     not used for radio
          className: classes.button,
          labelPlacement: "end"
        }
      },
      {
        code: "h",
        display: "H",
        bucket: {
          name: "radioH",
          // selected: ,     not used for radio
          className: classes.button,
          labelPlacement: "end"
        }
      }
    ],
    bucket: {
      p: null,
      handleChange: anyChange,
      name: "name5",
      label: "Radio Boxes Group Label",
      groupRowPlacement: true,
      // Makes this horizontal layout
      type: "radio",
      helperText: "Some help text (F is preselectted and horizontal layout)",
      selection: "f"
    }
  };
  const ckrdOptions3 = {
    format: "form",
    items: [
      {
        code: "j",
        display: "J",
        bucket: {
          name: "switchJ",
          selected: true,
          className: classes.button,
          labelPlacement: "start"
        }
      }
    ],
    bucket: {
      p: null,
      handleChange: anyChange,
      name: "name6",
      label: "Group Label",
      groupRowPlacement: true,
      type: "switch",
      helperText: "Some help text"
      //selection: 'c'                  // only used for radio box
    }
  };
  const threeColOptions = {
    format: "form",
    bucket: {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MuiCheckRadioSwitch, { ...ckrdOptions1 }) }),
      children2: /* @__PURE__ */ jsxRuntimeExports.jsx(MuiCheckRadioSwitch, { ...ckrdOptions2 }),
      children3: /* @__PURE__ */ jsxRuntimeExports.jsx(MuiCheckRadioSwitch, { ...ckrdOptions3 })
    }
  };
  let chips1 = ["Toronto", "Halifax"];
  const onTagRemove1 = (tag) => {
    console.log("onTagRemove : " + tag);
    const i = chips1.indexOf(tag);
    if (i != -1) chips1.splice(i, 1);
    return true;
  };
  const onTagAdd1 = (tag) => {
    console.log("onTagAdd : " + tag);
    chips1.push(tag);
    return true;
  };
  const chipOptions1 = {
    value: chips1,
    onDelete: onTagRemove1,
    onAdd: onTagAdd1
  };
  let chips2 = ["Toronto", "Halifax"];
  const onTagRemove2 = (tag) => {
    console.log("onTagRemove : " + tag);
    const i = chips2.indexOf(tag);
    if (i != -1) chips2.splice(i, 1);
    return true;
  };
  const onTagAdd2 = (tag) => {
    console.log("onTagAdd : " + tag);
    chips2.push(tag);
    return true;
  };
  const chipOptions2 = {
    value: chips2,
    onDelete: onTagRemove2,
    onAdd: onTagAdd2
  };
  const twoColOptions = {
    format: "form",
    bucket: {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, { ...chipOptions1 }) }),
      children2: /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, { ...chipOptions2 })
    }
  };
  const buttonList = [
    {
      code: "Default",
      display: "Default",
      bucket: {
        type: "button",
        iconLeft: null,
        iconRight: null,
        className: classes.button,
        variant: "contained",
        color: "primary"
      }
    },
    {
      code: "Primary",
      display: "Primary",
      bucket: {
        type: "button",
        iconLeft: null,
        iconRight: null,
        className: classes.button,
        variant: "contained",
        color: "primary"
      }
    },
    {
      code: "Secondary",
      display: "Secondary",
      bucket: {
        type: "button",
        iconLeft: null,
        iconRight: null,
        className: classes.button,
        variant: "text",
        color: "secondary"
      }
    }
  ];
  const btnOptions = {
    format: "form",
    items: buttonList,
    bucket: {
      p: null,
      label: null,
      handleClick: anyClick,
      checkDisabled,
      width: "fixed",
      variant: "contained",
      size: "large"
    }
  };
  const buttonGroupOnClick = (e, p, item, i) => {
    console.log("buttonGroupOnClick clicked " + item.code + " " + i);
  };
  const buttonGroupCheckDisabled = (p, item, i) => {
    console.log("check if it is disabled for " + item.code + " " + i);
    return false;
  };
  let buttonGroupItems = [
    {
      code: "a",
      display: "A",
      bucket: {
        name: "uniqueName",
        selected: true,
        labelPlacement: "end",
        children: null,
        ref: null,
        ndx: 1,
        disabled: false,
        // true | false
        color: "",
        // 'primary', 'secondary', 'default'
        variant: "",
        // 'outlined' | 'contained' | 'text' - default
        className: classes.button
      }
    }
  ];
  const buttonGroupCtnrOptions = {
    format: "form",
    items: buttonGroupItems,
    bucket: {
      p: null,
      handleClick: buttonGroupOnClick,
      selection: null,
      checkDisabled: buttonGroupCheckDisabled,
      width: "fixed",
      variant: "contained",
      size: "small"
    }
  };
  let butIconGroupItems = [
    {
      code: "b",
      display: "B",
      bucket: {
        name: "uniqueName",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Delete", sx: { ...classes.iconLeft } }),
        iconRight: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Delete", sx: { ...classes.iconRight } }),
        selected: true,
        labelPlacement: "end",
        children: null,
        ref: null,
        ndx: 1,
        disabled: false,
        // true | false
        color: "",
        // 'primary', 'secondary', 'default'
        variant: "",
        // 'outlined' | 'contained' | 'text' - default
        className: classes.button
      }
    }
  ];
  const butIconGroupCtnrOptions = {
    format: "form",
    items: butIconGroupItems,
    bucket: {
      p: null,
      handleClick: buttonGroupOnClick,
      selection: null,
      checkDisabled: buttonGroupCheckDisabled,
      width: "fixed",
      variant: "contained",
      size: "small"
    }
  };
  let butIconOnlyGroupItems = [
    {
      code: "b",
      display: "B",
      bucket: {
        name: "uniqueName",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Delete" }),
        type: "iconbutton",
        selected: true,
        labelPlacement: "end",
        children: null,
        ref: null,
        ndx: 1,
        disabled: false,
        // true | false
        color: "",
        // 'primary', 'secondary', 'default'
        variant: "",
        // 'outlined' | 'contained' | 'text' - default
        className: classes.button
      }
    }
  ];
  const butIconOnlyGroupCtnrOptions = {
    format: "form",
    items: butIconOnlyGroupItems,
    bucket: {
      p: null,
      handleClick: buttonGroupOnClick,
      selection: null,
      checkDisabled: buttonGroupCheckDisabled,
      width: "fixed",
      variant: "contained",
      size: "small"
    }
  };
  let fabIconOnlyGroupItems = [
    {
      code: "b",
      display: "",
      bucket: {
        name: "uniqueName",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Delete" }),
        type: "fab",
        selected: true,
        labelPlacement: "end",
        children: null,
        ref: null,
        ndx: 1,
        disabled: false,
        // true | false
        color: "",
        // 'primary', 'secondary', 'default'
        variant: "extended",
        // 'outlined' | 'contained' | 'text' - default
        className: classes.button
      }
    },
    {
      code: "e",
      display: "Eay! Long Oval Button",
      bucket: {
        name: "uniqueName",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Delete", sx: { ...classes.iconLeft } }),
        type: "fab",
        selected: true,
        labelPlacement: "end",
        children: null,
        ref: null,
        ndx: 1,
        disabled: false,
        // true | false
        color: "",
        // 'primary', 'secondary', 'default'
        variant: "extended",
        // 'outlined' | 'contained' | 'text' - default
        className: classes.button
      }
    }
  ];
  const fabIconOnlyGroupCtnrOptions = {
    format: "form",
    items: fabIconOnlyGroupItems,
    bucket: {
      p: null,
      handleClick: buttonGroupOnClick,
      selection: null,
      checkDisabled: buttonGroupCheckDisabled,
      width: "fixed",
      variant: "contained",
      size: "small"
    }
  };
  const accordionList = [
    { code: "item1", display: "Item 1", bucket: { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Item 1: Child 1 " }) } },
    {
      code: "item2",
      display: "Item 2",
      bucket: {
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Item 2: Child 1 " }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Child 2 " })
        ] })
      }
    }
  ];
  const accordionOptions = {
    format: "form",
    items: accordionList,
    bucket: { handleSelection: null, selection: null }
  };
  const itemsList = [
    { code: "item1", display: "Item 1", bucket: { disabled: true } },
    { code: "item2", display: "Item 2", bucket: { disabled: false } }
  ];
  const listOptions = {
    format: "form",
    items: itemsList,
    bucket: { p: null, handleClick: anyClick }
  };
  const menuItemsList = [
    { code: "1", display: "1", bucket: { color: "primary", variant: "contained" } },
    { code: "2", display: "2", bucket: { color: "primary", variant: "contained" } },
    { code: "3", display: "3", bucket: { color: "primary", variant: "contained" } },
    { code: "4", display: "4", bucket: { color: "primary", variant: "contained" } }
  ];
  const menuItemsOptions = {
    format: "form",
    items: menuItemsList,
    bucket: {
      p: null,
      color: "primary",
      variant: "contained",
      size: "large",
      handleSelection: anySelection,
      selection: 3,
      sysStyle: {
        width: "30px",
        // button dropdown for 'Active:'
        height: "30px",
        zIndex: "9000"
      },
      usrStyle: null
    }
  };
  const tabList = [
    { code: "Components", display: "Components", bucket: { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " 1st tab content " }) } },
    { code: "Properties", display: "Properties", bucket: { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " 2nd tab content " }) } }
  ];
  const tabOptions = { format: "form", items: tabList, bucket: { handleChange: anyChange } };
  const oneColOptions = {
    format: "form",
    bucket: {
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...btnOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...buttonGroupCtnrOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...butIconGroupCtnrOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...butIconOnlyGroupCtnrOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...fabIconOnlyGroupCtnrOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MuiAccordion, { ...accordionOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ListCtnr, { ...listOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonMenuCtnr, { ...menuItemsOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MuiTabs, { ...tabOptions })
      ] })
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FourColumnLayout, { ...fourColOptions }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ThreeColumnLayout, { ...threeColOptions }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TwoColumnLayout, { ...twoColOptions }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(OneColumnLayout, { ...oneColOptions }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { ...classes.svg }, children: "SVG As background image:" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.pattern, children: "SVG As pattern Pulling in the &lt svg &gt content from file and embeding here works." }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        "Use < Icon > to display svg in < img > tag. BUT DOES NOT WORK",
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { classes: { root: classes.iconRoot } })
      ] })
    ] }) })
  ] });
}
const useStyles$s = (theme) => ({
  container: {
    width: "100%",
    // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: "20"
  }
});
function FormProxyCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const theme = useTheme();
  const classes = useStyles$s(theme);
  const formtype = props.formtype;
  const formName = props.formName;
  da.setConfigViewItems("configForm");
  da.setWorkFlag("configMode", "edit");
  let p = new P({
    rendertype: "submit",
    // FormCtnr splits Form into : build|submit|other
    // Here the rendertype should be 'build' ??? TODO
    formtype,
    // User|Meta|Record|List|Service
    formName,
    accountNo: 1,
    formNo: da.getMetaForms(formName).forms.formNo,
    instance: da.getMetaFormsProperty(formName, "instances"),
    items: da.getMetaFormsProperty(formName, "items")
    // <<< NOTE: Passing in an array of items
    // inline not set
  });
  console.log("FormProxyCtnr: List form data: formNo: " + p.formNo + " instanceNo: " + p.instance.instanceNo + " items count: " + p.items.length);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: formtype, style: { ...classes.container }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormCtnr, { p }) });
}
function _addCss(cssCode) {
  var styleElement = document.createElement("style");
  styleElement.type = "text/css";
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = cssCode;
  } else {
    styleElement.appendChild(document.createTextNode(cssCode));
  }
  document.getElementsByTagName("head")[0].appendChild(styleElement);
}
function _injectCSS(instance, resourcePath, formUqId) {
  if (!instance) return;
  let tagId = "#form-" + formUqId;
  if (instance.margin && !isNaN(instance.margin)) {
    _addCss(tagId + " {padding: " + instance.margin + "px;}");
  }
  if (instance.bgimage && instance.bgimage != "") {
    var bgimage = "background-image: url(" + resourcePath + instance.bgimage + ");";
    var bgcover = "background-size: cover;";
    _addCss(tagId + " {" + bgimage + " " + bgcover + "}");
  } else {
    _addCss(tagId + " { background-color: #ff00ff; background-image: none}");
  }
}
function FormCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const p = props.p;
  const lastUpdated = props.lastUpdated;
  const version = props.version;
  const { appState, dispatch } = useAppContext();
  var items = p.items;
  var instance = p.instance;
  var rendertype = p.rendertype();
  var formtype = p.formtype();
  var formName = p.formName();
  const accountNo = p.accountNo();
  const formNo = p.formNo();
  var formUqId = da.getFormUqId(accountNo, formNo, instance?.instanceNo);
  var submissionUrl = da.getSubmissionUrl(accountNo, formNo, instance?.instanceNo);
  _injectCSS(p.instance, da.getResourcePath(accountNo));
  const preset = appState.getEnvVar.locationData.preset;
  const user = appState.user;
  if (user && user.first) {
    preset["FirstName"] = user.first;
    preset["First"] = user.first;
  }
  if (user && user.last) {
    preset["LastName"] = user.last;
    preset["Last"] = user.last;
  }
  if (user && user.email)
    preset["Email"] = user.email;
  if (user && user.tele) {
    preset["Telephone"] = user.tele;
    preset["Tele"] = user.tele;
    preset["Mobile"] = user.tele;
    preset["Cell"] = user.tele;
  }
  if (preset && Object.keys(preset).length) {
    p.items.forEach((item) => {
      const name = item.name;
      if (preset[name]) {
        item.userProp.value = preset[name];
      }
    });
  }
  var parents = items.filter(
    (item, i, src) => item.child && (item.child.length || item.seqno == CONST.ROOT_SEQNO) && !item.parent
  );
  var rows = parents.map((item, ndx, src) => {
    var childProp = new P({
      rendertype,
      formtype: p.formtype(),
      formName: p.formName(),
      accountNo: p.accountNo(),
      formNo: p.formNo(),
      instance,
      item,
      // <<< NOTE: Passing in a SINGLE item
      inline: ""
    });
    if (childProp.instance.style === CONST.STYLES.BS3) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "BS3 styling not supported yet " }, childProp.item.seqno + "-" + ndx);
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetCtnr, { p: childProp, ndx }, childProp.item.seqno + "-" + ndx);
    }
  });
  let layout = {};
  layout = instance?.layout == CONST.LAYOUTS.INLINE ? { display: "flex", flexFlow: "row wrap", alignItems: "center" } : instance?.layout == CONST.LAYOUTS.HORIZONTAL ? {} : {};
  const emptyForm = /* @__PURE__ */ jsxRuntimeExports.jsx(
    "form",
    {
      id: "formSlots",
      name: "formSlots",
      style: { ...layout },
      role: "form",
      autoComplete: "on",
      method: "post",
      encType: "multipart/form-data",
      "data-url": submissionUrl,
      noValidate: true,
      children: "Empty Form"
    }
  );
  const formBody = /* @__PURE__ */ jsxRuntimeExports.jsx(
    "form",
    {
      id: "form-" + formUqId,
      name: "formSlots",
      style: { ...layout },
      role: "form",
      autoComplete: "on",
      method: "post",
      encType: "multipart/form-data",
      "data-url": submissionUrl,
      noValidate: true,
      children: rows
    }
  );
  const [scroll, setScroll] = React__default.useState(da.getScrollChecked());
  const handleChange = (event2) => {
    const isChecked = event2.target.checked;
    setScroll(isChecked);
    da.setScrollChecked(isChecked);
    event2.preventDefault();
  };
  const checkItemList = [{
    code: "scroll",
    display: "Scroll",
    bucket: {
      name: "Scroll",
      // 
      checked: scroll,
      // only for Switch & Checkbox   (true/false)
      className: null,
      // CSS properties for FormControlLabel
      labelPlacement: "start",
      // 
      tip: "Enable/Disable scrollbar for the form area."
      // tooltip
    }
  }];
  const options2 = {
    format: "form",
    items: checkItemList,
    bucket: {
      p: {},
      handleChange,
      // callback
      selection: null,
      // only for Radiobox name
      label: null,
      // Label for the group
      inlined: false,
      // place all Switches in a row   true | false
      type: "switch",
      // 'check' | 'radio' | 'switch'
      helperText: "Scroll"
      //
    }
  };
  const toggle = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { paddingBottom: "16px" }, "data-where": "scroll-toggle", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MuiCheckRadioSwitch, { ...options2 }) });
  if (!items || !instance) {
    return emptyForm;
  } else if (formtype == "User") {
    let scrollOption = null;
    if (scroll) {
      scrollOption = { overflowY: "scroll", overflowX: "hidden", height: "460px", width: "auto" };
    }
    const updtVerHtml = lastUpdated && version ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { fontSize: "0.8rem", paddingTop: "16px" }, children: [
      " Last Updated: ",
      lastUpdated,
      " Version: ",
      version
    ] }) : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      toggle,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-where": "FormCtnr", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...scrollOption }, children: formBody }),
        updtVerHtml
      ] })
    ] });
  } else if (formtype == "Meta") {
    return formBody;
  } else if (formtype == "Service") {
    const form = da.metaforms.classState.metaForms[formName].forms;
    const instance2 = da.metaforms.classState.metaForms[formName].instances;
    const items2 = da.metaforms.classState.metaForms[formName].items;
    da.selection.selectedForms({ type: "set", action: "", value: form });
    da.selection.selectedInstances({ type: "set", action: "", value: instance2 });
    da.selection.selectedItems({ type: "set", action: "", value: items2 });
    return formBody;
  } else if (formtype == "List") {
    (async function() {
      await da.createMetaStructure(formName);
    })();
    return formBody;
  } else if (formtype == "Record") {
    throw Error("Rendering for formtype Record is not supported yet");
  } else {
    throw Error(`Invalid formtype (${formtype})`);
  }
}
function FormPropEditorCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  let show = !da.isConfigViewItems();
  var cl = {
    hide: !show
  };
  if (!show) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "form-dtls", style: cl });
  } else {
    let p = new P({
      rendertype: "submit",
      // FormCtnr splits Form into : build|submit|other
      // Here the rendertype should be 'build' ??? TODO
      formtype: "Meta",
      // Form meta data (User|Meta|Record|List|Service)
      formName: "form",
      accountNo: 1,
      formNo: da.getMetaForms("form").forms.formNo,
      instance: da.getMetaFormsProperty("form", "instances"),
      items: da.getMetaFormsProperty("form", "items")
      // <<< NOTE: Passing in an array of items
      // inline not set
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "form-dtls", style: cl, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormCtnr, { p }) });
  }
}
const useStyles$r = (theme) => ({
  container: {
    width: "100%",
    // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: "20"
  }
});
function ListProxyCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const theme = useTheme();
  const classes = useStyles$r(theme);
  const formtype = props.formtype;
  const formName = props.formName;
  da.setConfigViewItems("configForm");
  da.setWorkFlag("configMode", "edit");
  const params = {
    formtype,
    formName,
    accountNo: da.selection.selected({
      entity: "accounts",
      type: "get",
      action: "prop",
      property: "accountNo"
    })
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: formtype + "-list", sx: { ...classes.container }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListCtnr, { ...params }) });
}
const Sidebar = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const { open, variant, onClose, className, ...rest } = props;
  const nav = da.getNav();
  da.isAuthenticated();
  const handleClick = (event2, p, item, i) => {
    console.log("handleClick() - item.code is : " + item.code);
    da.setNav(item.code);
    event2.preventDefault();
  };
  const checkDisabled = (p, item, i) => {
    if (da.getNav() === item.code) return true;
    if (item.code === "build" || item.code === "preview" || item.code === "data") {
      if (!da.isFormSelected()) return true;
    }
    return false;
  };
  const classNameActive = {
    textTransform: "none",
    //color: theme.palette.primary.main,
    //fontWeight: theme.typography.fontWeightMedium,
    "& $icon": {
      //color: theme.palette.primary.main,
    }
  };
  const classNameNav = {
    //color: colors.blueGrey[800],
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%"
    //fontWeight: theme.typography.fontWeightMedium,
  };
  const buttonList = [
    {
      code: "home",
      display: "Home",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Home" }),
        //<HomeIcon />,
        iconRight: null,
        className: nav === "home" ? classNameActive : classNameNav,
        variant: "contained",
        color: "default",
        tip: "App home page"
      }
    }
  ];
  if (da.isDev())
    buttonList.push({
      code: "examples",
      display: "Examples",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Store" }),
        //<StoreIcon />,
        iconRight: null,
        className: nav === "examples" ? classNameActive : classNameNav,
        variant: "contained",
        color: "default",
        tip: "React Component Examples"
      }
    });
  const navOptions = {
    format: "form",
    items: buttonList,
    bucket: {
      p: null,
      label: null,
      handleClick,
      checkDisabled,
      width: "fixed",
      variant: "contained",
      size: "large",
      className: classNameNav,
      // classes.nav,
      orientation: "vertical"
      // 'vertical' | 'horizontal'
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    MuiDrawer,
    {
      anchor: "left",
      sysStyle: { paper: { width: 240 } },
      onClose,
      open,
      variant,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ...rest, style: {
        //backgroundColor: theme.palette.white,
        display: "flex",
        flexDirection: "column",
        height: "100%"
        //padding: theme.spacing(2),
      }, children: [
        "   // ...className",
        /* @__PURE__ */ jsxRuntimeExports.jsx(Profile, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MuiDivider, { sysStyle: { margin: "16px" } }),
        "   // theme.spacing(2, 0),",
        /* @__PURE__ */ jsxRuntimeExports.jsx(ListButtonCtnr, { ...navOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MuiDivider, { sysStyle: { margin: "16px" } }),
        "   // theme.spacing(2, 0),"
      ] })
    }
  );
};
Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};
const Submenubar = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const { buttonList, ...rest } = props;
  const [subnav, setSubnav] = React__default.useState(da.getNav() || "home");
  const handleClick = (event2, p, item, i) => {
    console.log("Submenubar:handleClick() - =>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>   item.code is : " + item.code);
    da.setNav(item.code);
    setSubnav(item.code);
    event2.preventDefault();
  };
  const checkDisabled = (p, item, i) => {
    if (da.getNav() === item.code) return true;
    return false;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...rest, style: { display: "flex", flexDirection: "column", height: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex", flexDirection: "row", marginTop: "0px", marginBottom: "8px" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MainAccountSelect, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CreateButtonGroup,
      {
        list: buttonList,
        onClick: handleClick,
        handleCheckDisabled: checkDisabled,
        user: "submenu",
        fullWidth: true,
        label: "EDIT",
        size: "medium"
      }
    )
  ] }) });
};
const useStyles$q = (theme) => {
  return {
    slate: {
      // if margin is set here then in responsive screen the Sign In/Sign Up component is clipped on the right side
      // margin: theme.spacing(1),
    }
  };
};
const Slate = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  const { className } = props;
  useTheme();
  const classes = useStyles$q();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Grid,
    {
      container: true,
      spacing: 0,
      direction: "row",
      justifyContent: "center",
      alignItems: "center",
      sx: { ...classes.slate },
      children: props.children
    }
  );
};
const useStyles$p = (theme) => {
  return {
    root: {
      padding: theme.spacing(1),
      boxShadow: "none",
      bottomMargin: theme.spacing(0)
    },
    row: {
      display: "flex",
      alignItems: "center"
    },
    spacer: {
      flexGrow: 1
    }
  };
};
const FormHeader = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const { className } = props;
  const theme = useTheme();
  const classes = useStyles$p(theme);
  const instanceName = da.selected({
    entity: "instances",
    type: "get",
    action: "prop",
    property: "name"
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { ...classes.root, bgcolor: "transparent" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", children: instanceName }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { ...classes.row }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: classes.spacer }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MainAccountDisplay, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MainFormNoDisplay, {})
    ] })
  ] });
};
const MainTopbar = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const { onSidebarOpen, isMenu } = props;
  const [notifications] = useState([]);
  const logoText = da && (da.getEnvVar.locationData.apptgt && !(da.getEnvVar.locationData.apptgt === "apptgt?") && da.getEnvVar.locationData.apptgt) || "";
  if (logoText || isMenu) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-where": "MainTopbar", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          style: {
            fontSize: "180%",
            fontWeight: 400,
            letterSpacing: "0.2em",
            textAlign: "center"
          },
          children: logoText
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: isMenu ? /* @__PURE__ */ jsxRuntimeExports.jsxs(MuiIconButton, { color: "inherit", onClick: onSidebarOpen, size: "large", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Menu" }),
        "   //",
        /* @__PURE__ */ jsxRuntimeExports.jsx(MenuIcon, {})
      ] }) : null })
    ] });
  } else {
    return null;
  }
};
MainTopbar.propTypes = {
  onSidebarOpen: PropTypes.func
};
const MinimalTopbar = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const { app, className, onSidebarOpen, isMenu, ...rest } = props;
  const logoText = da && (da.getEnvVar.locationData.apptgt && !(da.getEnvVar.locationData.apptgt === "apptgt?") && da.getEnvVar.locationData.apptgt.toUpperCase()) || "";
  if (logoText || isMenu) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-where": "MinimalTopbar", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          style: {
            fontSize: "200%",
            fontWeight: 500,
            letterSpacing: "0.2em",
            paddingLeft: g
          },
          children: logoText
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flexGrow: 1 } }),
      isMenu ? /* @__PURE__ */ jsxRuntimeExports.jsxs(MuiIconButton, { color: "inherit", onClick: onSidebarOpen, size: "large", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "Menu" }),
        "   //",
        /* @__PURE__ */ jsxRuntimeExports.jsx(MenuIcon, {})
      ] }) : null
    ] });
  } else {
    return null;
  }
};
MinimalTopbar.propTypes = {
  className: PropTypes.string
};
const useStyles$o = (theme) => {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      minHeight: "fit-content"
    },
    avatar: {
      width: 60,
      height: 60
    },
    name: {
      marginTop: theme.spacing(1)
    }
  };
};
const Profile = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  const { className, ...rest } = props;
  const theme = useTheme();
  const classes = useStyles$o(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...classes.root, ...className }, "data-where": "Profile", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MainAccountSelect, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(MainFormNoDisplay, {})
  ] });
};
Profile.propTypes = {
  className: PropTypes.string
};
const upgradeToProImage = "data:image/jpeg;base64,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";
const useStyles$n = (theme) => {
  return {
    root: {
      backgroundColor: colors.grey[50]
    },
    media: {
      paddingTop: theme.spacing(2),
      height: 80,
      textAlign: "center",
      "& > img": {
        height: "100%",
        width: "auto"
      }
    },
    content: {
      padding: theme.spacing(1, 2)
    },
    actions: {
      padding: theme.spacing(1, 2),
      display: "flex",
      justifyContent: "center"
    }
  };
};
const UpgradePlan = (props) => {
  const { className, ...rest } = props;
  const theme = useTheme();
  const classes = useStyles$n(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ...rest, sx: { ...classes.root, ...className }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.media, children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: "Upgrade to PRO", src: upgradeToProImage }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: classes.content, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { align: "center", gutterBottom: true, variant: "h6", children: "Upgrade to PRO" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { align: "center", variant: "body2", children: "Upgrade to MsgForm PRO and get even more forms to help your business." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.actions, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { color: "primary", component: "a", href: "https://kripa.com/", variant: "contained", children: "Upgrade" }) })
  ] });
};
UpgradePlan.propTypes = {
  className: PropTypes.string
};
function CommonAppLayout(props) {
  const theme = useTheme();
  const { app, Body, Sidebar: Sidebar2, MainTopbar: MainTopbar2, MinimalTopbar: MinimalTopbar2, Submenubar: Submenubar2, Footer: Footer2 } = props;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const isStateInit = da.isState("init");
  da.getNav();
  const [openSidebar, setOpenSidebar] = useState(false);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  if (!isStateInit) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "config", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { children: [
      " Loading ... ",
      da.getStateMsg()
    ] }) });
  } else {
    const isSidebarMenu = Sidebar2 ? true : false;
    const handleSidebarOpen = () => {
      setOpenSidebar(!openSidebar);
    };
    const handleSidebarClose = () => {
      setOpenSidebar(false);
    };
    const topbarHtml = isDesktop ? /* @__PURE__ */ jsxRuntimeExports.jsx(MainTopbar2, { onSidebarOpen: handleSidebarOpen, isMenu: isSidebarMenu }) : /* @__PURE__ */ jsxRuntimeExports.jsx(MinimalTopbar2, { onSidebarOpen: handleSidebarOpen, isMenu: isSidebarMenu });
    const sidebarHtml = isSidebarMenu ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Sidebar2,
      {
        onClose: handleSidebarClose,
        open: openSidebar,
        variant: isDesktop ? "persistent" : "temporary"
      }
    ) : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "config", "data-where": "CommonAppLayout", children: [
      sidebarHtml,
      /* @__PURE__ */ jsxRuntimeExports.jsx(MainSnackbarComp, { store: da }),
      topbarHtml,
      Submenubar2,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Body, {})
    ] });
  }
}
const logBufferLimit = 50, trackBufferLimit = 50, conLevels = "log", rmtLevels = "error";
class Logger {
  constructor(appState) {
    this.appState = appState;
    this.getEnvVar = appState.getEnvVar;
    this.previousExceptionsHash = null;
    this.previousTracesHash = null;
    this.logBuffer = [];
    this.logBufferNdx = 0;
    this.logBufferLimit = 50;
    this.trackBuffer = [];
    this.trackBufferNdx = 0;
    this.trackBufferLimit = 50;
    this.original = {};
    const interceptLevels = interceptLevels || ["error"];
    this.logBufferLimit = logBufferLimit;
    this.trackBufferLimit = trackBufferLimit;
    this.conLevels = conLevels;
    this.rmtLevels = rmtLevels;
    var console2 = window.console;
    if (!console2) return;
    this.stOnError = this.stOnError.bind(this);
    this.track = this.track.bind(this);
    this.preprocess = this.preprocess.bind(this);
    console2.track = this.track;
    console2.spit = this.spit;
    if (interceptLevels.length > 0) {
      window.onerror = this.stOnError;
      Error.stackTraceLimit = 30;
      console2.info(
        "Logger:ctor() - Console intercept is enforced and buffered for : " + interceptLevels
      );
      console2.info(
        "Logger:ctor() - All exceptions will be relayed to tracker service with message buffer "
      );
      console2.info(
        "Logger:ctor() - Message buffer will be relayed to tracker service for : " + this.rmtLevels
      );
      for (var i = 0; i < interceptLevels.length; i++) this.intercept(interceptLevels[i]);
    }
    this.test();
  }
  intercept(method) {
    this.original[method] = console[method];
    const self = this;
    console[method] = async function() {
      var message = Array.prototype.slice.apply(arguments).join(" ");
      let stackTrace;
      stackTrace = await StackTrace.fromError(new Error());
      let item8 = null;
      let source = null;
      let lineNum = null;
      let colNum = null;
      let sourceParts = null;
      let location = null;
      if (stackTrace && stackTrace.length && stackTrace[8]) {
        item8 = stackTrace[8];
        source = item8.fileName + ":" + item8.functionName;
        lineNum = item8.lineNumber;
        colNum = item8.columnNumber;
        sourceParts = item8.fileName.split("/");
        const app = this.getEnvVar.APP_CODE;
        location = app + ":" + sourceParts[sourceParts.length - 1] + ":" + item8.functionName + "():" + lineNum + ":" + colNum;
      }
      self.preprocess(self.original[method], method, message, source, lineNum, colNum, stackTrace);
      if (self.conLevels.indexOf(method) >= 0) {
        self.original[method].call(console, message + "     @ " + location);
      }
    };
  }
  preprocess(original, method, message, source, lineNum, colNum, stackTrace) {
    const logObject = {
      time: +/* @__PURE__ */ new Date(),
      // unix time integer
      level: method,
      // log/info/warn/error/debug
      message,
      source,
      // Logger:44
      line: lineNum,
      column: colNum
    };
    if (method == "track") {
      this.trackBuffer[this.trackBufferNdx] = logObject;
      this.trackBufferNdx++;
      if (this.trackBufferNdx >= this.trackBufferLimit) {
        this.trackBufferNdx = 0;
      }
    } else {
      this.logBuffer[this.logBufferNdx] = logObject;
      this.logBufferNdx++;
      if (this.logBufferNdx >= this.logBufferLimit) this.logBufferNdx = 0;
      if (message.indexOf("Consider adding an error boundary") > 0) ;
      if (this.rmtLevels.indexOf(logObject.level) >= 0) {
        const logData = {
          browser: "unknown",
          fingerprint: "unknown",
          app: this.getEnvVar.APP_CODE,
          version: this.getEnvVar.APP_VERSION,
          source,
          line: lineNum,
          column: colNum,
          message,
          trace: stackTrace,
          logs: this.logBuffer,
          logBufferNdx: this.logBufferNdx - 1
          //error: error // need this?
          //time: + new Date(),
          //hash: 'unknown',  //uniquely identify this type of exception
          //user: 'unknown',
          //bundleid: source.split('?')[1],
        };
        if (this.isWriteRemote("Traces", stackTrace)) {
          console.spit(
            "Logger:preprocess() - Remote server BUFFER write triggered by message : " + message
          );
          this.postRmt("Traces", logData);
        } else {
          console.spit(
            "Logger:preprocess() - SKIPPED Remote server BUFFER write triggered by message : " + message
          );
        }
      }
    }
  }
  async stOnError(message, source, lineNum, colNum, error) {
    if (!message || !message.length) {
      return;
    }
    const stackTrace = await StackTrace.fromError(error);
    const errorData = {
      browser: "unknown",
      fingerprint: "unknown",
      app: this.getEnvVar.APP_CODE,
      version: this.getEnvVar.APP_VERSION,
      source,
      line: lineNum,
      column: colNum,
      message,
      trace: stackTrace,
      logs: this.logBuffer,
      logBufferNdx: this.logBufferNdx - 1
      //error: error // need this?
      //time: + new Date(),
      //hash: 'unknown',  //uniquely identify this type of exception
      //user: 'unknown',
      //bundleid: source.split('?')[1],
    };
    if (this.isWriteRemote("Exceptions", stackTrace)) {
      console.spit(
        "Logger:stOnError() - Remote server EXCEPTION write triggered by message : " + message
      );
      this.postRmt("Exceptions", errorData);
    } else {
      console.spit(
        "Logger:stOnError() - SKIPPED Remote server EXCEPTION write triggered by message : " + message
      );
    }
  }
  isWriteRemote(type, stackTrace) {
    stackTrace[8] + stackTrace[9] + stackTrace[10] + stackTrace[11] + stackTrace[12];
    const isWrite = this[`previous${type}Hash`] != hash;
    this[`previous${type}Hash`] = hash;
    return isWrite;
  }
  async postRmt(type, data) {
    const service = type == "Exceptions" ? "/exceptions" : "/traces";
    const request = {
      service,
      method: "create",
      args: { data }
      //args: { params: { query: {clientName: name} } }
    };
    console.error("Logger:postRmt() - needs code. apiServer.setup() not found");
    const rc = await this.apiServer.setup(request);
    return rc;
  }
  track(message) {
    if (this.original && this.original.log) {
      this.preprocess(this.original.log, "track", message, null);
      this.original.log.call(console, "Track: " + message);
    } else {
      this.preprocess(console.log, "track", message, null);
      console.log("Track: " + message);
    }
  }
  spit(message) {
    console.log("Spit: " + message);
  }
  test() {
    console.log("Logger:test() - Testing message. this is a log message");
    console.info("Logger:test() - Testing message. this is an info message");
    console.warn("Logger:test() - Testing message. this is a warning message");
    console.track("Logger:test() - Testing message. this is a user tracking message");
  }
  // Candidate for an utility lib
  //taken from http://stackoverflow.com/a/21350614
  //modified to get rid of the unused add variable
  str_splice(str, index, endIndex) {
    return str.slice(0, index) + str.slice(endIndex);
  }
  // Candidate for an utility lib
  //taken from http://stackoverflow.com/a/7768006
  //obviously isn't ideal but it's better than telling you to get Modernizr
  //might add other browsers at some point, contributions are welcome!
  stack_trace_format(stackTrace) {
    var is_chrome = navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
    var is_firefox = navigator.userAgent.indexOf("Firefox") > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    if (!String.linkify) {
      String.prototype.linkify = function() {
        var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
        var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        var emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;
        return this.replace(urlPattern, '<span class="link" data-href="$&">$&</span>').replace(pseudoUrlPattern, '$1<span class="link" data-href="http://$2">$2</span>').replace(emailAddressPattern, '<span class="link" data-href="mailto:$&">$&</span>');
      };
    }
    if (is_chrome) {
      stackTrace = stackTrace.replace("Error", "").replace(/\r?\n|\r/g, "").replace("    ", "").replace(/</gm, "&lt;").replace(/>/gm, "&gt;");
      for (var i = 0; i < stackTrace.length; i++) {
        if (stackTrace[i] == "a" && stackTrace[i + 1] == "t" && stackTrace[i + 2] == " ") {
          var startIndex = i;
          for (var j = startIndex + 1; j < stackTrace.length; j++) {
            if (stackTrace[j] == "a" && stackTrace[j + 1] == "t" && stackTrace[j + 2] == " ") {
              stackTrace = this.str_splice(stackTrace, i, j);
              break;
            }
          }
          break;
        }
      }
      stackTrace = stackTrace.replace(/at /gm, "</li><li>").linkify();
    } else if (is_safari || is_firefox) {
      stackTrace = "<li>" + stackTrace.replace(/\s/gm, "</li><li>").linkify().replace(/\@/gm, "&commat;");
      for (var i = 0; i < stackTrace.length; i++) {
        if (stackTrace[i] == "<" && stackTrace[i + 1] == "/" && stackTrace[i + 2] == "l") {
          var index = i;
          stackTrace = this.str_splice(stackTrace, 0, index);
          break;
        }
      }
    }
    return stackTrace;
  }
}
function doubleAfter2Seconds(x) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(x * 2);
    }, 2e3);
  });
}
async function addAsync(x) {
  const a = await doubleAfter2Seconds(10);
  const b = await doubleAfter2Seconds(20);
  const c = await doubleAfter2Seconds(30);
  return x + a + b + c;
}
function sanityCheck() {
  console.info("sanityCheck: App Sanity Check start");
  addAsync(10).then((sum) => {
    console.info("sanityCheck: App Sanity Check ... List sum using Async/Await : " + sum);
  });
}
function debounceWithThrottle(func, debouncewait, throttlewait, callatstart, callatend) {
  var debouncetimeout, throttletimeout;
  return async function() {
    var context = this;
    let args = Array.from(arguments);
    const startParm = () => {
      args.push("start");
      return args;
    };
    const duringParm = () => {
      args.push("during");
      return args;
    };
    const endParm = () => {
      args.push("end");
      return args;
    };
    if (callatstart && !debouncetimeout) func.apply(context, startParm());
    if (!throttletimeout && throttlewait > 0) {
      throttletimeout = await setInterval(async function() {
        await func.apply(context, duringParm());
      }, throttlewait);
    }
    clearTimeout(debouncetimeout);
    debouncetimeout = await setTimeout(async function() {
      clearTimeout(throttletimeout);
      throttletimeout = null;
      debouncetimeout = null;
      if (callatend) await func.apply(context, endParm());
    }, debouncewait);
  };
}
function cleanInboundItems(items) {
  items.every((item) => {
    try {
      if (typeof item.userProp == "string") {
        item.userProp = JSON.parse(item.userProp.replace(/'/g, '"'));
      }
    } catch (e) {
      console.warn("util:cleanInboundItems() - JSON parse failed for item seqno : " + item.seqno + " error: " + e);
      try {
        const regex = /('(?=(,\s*')))|('(?=:))|((?<=([:,]\s*))')|((?<={)')|('(?=}))/g;
        const str = item.userProp.replace(regex, '"');
        item.userProp = JSON.parse(str);
      } catch (e2) {
        console.error(
          "util:_cleanInboundItems() - 2nd JSON parse failed for item seqno : " + item.seqno + " error: " + e2
        );
      }
    }
    if (item.parent == null) {
      item.parent = "";
    }
    return true;
  });
  return items;
}
function cleanInboundSubmissions(submissions) {
  submissions.every((submission) => {
    try {
      if (typeof submission.columns == "string") {
        submission.columns = JSON.parse(submission.columns.replace(/'/g, '"'));
      }
    } catch (e) {
      console.warn(
        "util:_cleanInboundSubmissions() - JSON parse failed for submission : " + submission.id + " error: " + e
      );
      try {
        const regex = /('(?=(,\s*')))|('(?=:))|((?<=([:,]\s*))')|((?<={)')|('(?=}))/g;
        const str = submission.columns.replace(regex, '"');
        submission.columns = JSON.parse(str);
      } catch (e2) {
        console.error(
          "util:_cleanInboundSubmissions() - 2nd JSON parse failed for submission : " + submission.id + " error: " + e2
        );
      }
    }
    return true;
  });
  return submissions;
}
function deepCopyJson(obj) {
  if (obj === void 0 || obj == null || Object.keys(obj).length == 0) {
    return {};
  }
  var t = JSON.parse(JSON.stringify(obj));
  return t;
}
const isArray = function() {
  if (Array.isArray) {
    return Array.isArray;
  }
  var objectToStringFn = Object.prototype.toString, arrayToStringResult = objectToStringFn.call([]);
  return function(subject) {
    return objectToStringFn.call(subject) === arrayToStringResult;
  };
}();
var isExisty = function(value2) {
  return value2 !== null && value2 !== void 0;
};
var isEmpty = function(value2) {
  return value2 == void 0 || value2 === "" || value2 === null || Array.isArray(value2) && value2.length == 0;
};
var validationRules = {
  isDefaultRequiredValue: function(value2) {
    return value2 === void 0 || value2 === "";
  },
  isExisty: function(value2) {
    return isExisty(value2);
  },
  matchRegexp: function(value2, regexp) {
    return !isExisty(value2) || isEmpty(value2) || regexp.test(value2);
  },
  isUndefined: function(value2) {
    return value2 === void 0;
  },
  isEmptyString: function(value2) {
    return isEmpty(value2);
  },
  isTrue: function(value2) {
    return value2 === true;
  },
  isFalse: function(value2) {
    return value2 === false;
  },
  //
  // Following are user accessible but are suffixed with parameters.
  //
  isRange: function(value2) {
    return true;
  },
  isLength: function(value2, args) {
    if (!args || !value2) return false;
    var length = args[0];
    return !isExisty(value2) || isEmpty(value2) || value2.length === length || "Incorrect length actual:" + value2.length + ", expected: " + length;
  },
  isEquals: function(value2, args) {
    if (!args || !value2) return false;
    var eql = args[0];
    return !isExisty(value2) || isEmpty(value2) || value2 == eql || "Values are not equal " + value2 + ":" + eql;
  },
  /* ??? Needs a way to find 2nd field to compare against.
           In formsy, it was done passing 'values' for full form.
  
    isEqualsField: function (values, value, args) {
        if (!args || !value) return false;
        var field = args[0];
      return (value == values[field]) || 'Fields are not equal';
    },
    */
  isMaxLength: function(value2, args) {
    if (!args || !value2) return false;
    var length = args[0];
    return !isExisty(value2) || value2.length <= length || "Length exceeds maximum limit of " + length;
  },
  isMinLength: function(value2, args) {
    if (!args || !value2) return false;
    var length = args[0];
    return !isExisty(value2) || isEmpty(value2) || value2.length >= length || "Length is under minimum limit of " + length;
  },
  isSelect: function(value2, args) {
    if (!args || !value2) return false;
    var count = args[0];
    return !isExisty(value2) || !Array.isArray(value2) || value2.length >= count || "Needs at least " + count + " selections";
  },
  isPattern: function(value2, args) {
    if (!args || !value2) return false;
    var pattern = args[0];
    var flags = args[1] ? args[1] : "";
    if (flags && (flags !== "g" || flags !== "g" || flags !== "i" || flags !== "m" || flags !== "u")) {
      console.log(
        "For a custom isPattern validation, the supplied flags(" + flags + ") are invalid. Valid flags are:gimuy"
      );
      return false;
    }
    var patternObj = new RegExp(pattern, flags);
    return this.matchRegexp(value2, patternObj);
  },
  //
  // Following are user accessible as is.
  //
  isColor: function(value2) {
    return true;
  },
  isDate: function(value2) {
    return true;
  },
  isFile: function(value2) {
    return true;
  },
  isFileImage: function(value2) {
    return true;
  },
  isFilePdf: function(value2) {
    return true;
  },
  isMonth: function(value2) {
    return true;
  },
  isPassword: function(value2) {
    return true;
  },
  isTime: function(value2) {
    return true;
  },
  isWeek: function(value2) {
    return true;
  },
  isDatetime: function(value2) {
    return true;
  },
  isTel: function(value2) {
    return true;
  },
  isText: function(value2) {
    return true;
  },
  isPara: function(value2) {
    return true;
  },
  isEmail: function(value2) {
    return this.matchRegexp(
      value2,
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
    ) || "The value is not an email address";
  },
  isUrl: function(value2) {
    console.log("Validator - isUrl value: " + value2);
    return this.matchRegexp(
      value2,
      /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
    ) || "The value is not an URL";
  },
  // used to be isNumeric
  isNumber: function(value2) {
    if (typeof value2 === "number") {
      return true;
    }
    return this.matchRegexp(value2, /^[-+]?(?:\d*[.])?\d+$/) || "The value is not a number";
  },
  isAlpha: function(value2) {
    return this.matchRegexp(value2, /^[A-Z]+$/i) || "The value is not alphabetic";
  },
  isAlphanumeric: function(value2) {
    return this.matchRegexp(value2, /^[0-9A-Z]+$/i) || "The value is not alphanumeric";
  },
  isInt: function(value2) {
    return this.matchRegexp(value2, /^(?:[-+]?(?:0|[1-9]\d*))$/) || "The value is not an integer";
  },
  isFloat: function(value2) {
    return this.matchRegexp(value2, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/) || "The value is not a Float Number";
  },
  isWords: function(value2) {
    return this.matchRegexp(value2, /^[A-Z\s]+$/i) || "The value should contain words";
  },
  isSpecialWords: function(value2) {
    return this.matchRegexp(value2, /^[A-Z\s\u00C0-\u017F]+$/i) || "The value is not found in the list of special words";
  },
  isRequired: function(value2) {
    return !isEmpty(value2) || "This is a required field";
  }
};
const PanoramaFishEyeIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "PanoramaFishEye");
const ControlPointIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "ControlPoint");
const useStyles$m = (theme) => {
  const borderSelColor = theme.palette.primary.main;
  return {
    nailSelHdr: {
      color: borderSelColor
    },
    //nailUnSelHdr: {
    //  color: borderUnSelColor,
    //},
    nailContent: {
      //border: '1px dotted #ffffff',
      minHeight: "20px",
      minWidth: "100px"
      /*
           '&:hover': {
      border: `1px dotted ${borderSelColor}`
           }
           */
    },
    nailedHilite: {
      border: `1px dotted ${borderSelColor}`
    },
    inline: {
      display: "flex",
      flexWrap: "wrap"
    }
  };
};
function NailCtnr(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const theme = useTheme();
  const classes = useStyles$m(theme);
  const { seqno, compid, nailedHiliteClass, inline } = props;
  const handleClick = function(event2) {
    da.nailSelection(seqno, compid);
    event2.stopPropagation();
  };
  var nailedContentClass = nailedHiliteClass == CONST.NAILED_HILITE_CLASS ? classes.nailedHilite : "";
  const inlineClass = inline ? classes.inline : null;
  const bullsEyeColorPasive = theme.palette.primary.main;
  const bullsEyeColorActive = theme.palette.secondary.main;
  if (p.rendertype() == "build" && !da.fullFormDisabled()) {
    if (nailedHiliteClass == CONST.NAILED_HILITE_CLASS) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            onClick: (event2) => handleClick(event2),
            style: classes.nailSelHdr,
            title: "Click to unselect container",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(ControlPointIcon, { sx: { color: bullsEyeColorActive } })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...classes.nailContent, ...nailedContentClass, ...inlineClass }, children: props.children })
      ] });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            onClick: (event2) => handleClick(event2),
            title: "Click to select container",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(PanoramaFishEyeIcon, { sx: { color: bullsEyeColorPasive } })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...classes.nailContent, ...nailedContentClass, ...inlineClass }, children: props.children })
      ] });
    }
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "no-nail-ctnr", style: inlineClass, children: props.children });
  }
}
function ButtonComp(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const bucket = getItemUserProps({
    caller: "ButtonComp",
    p,
    da,
    type: "button",
    // type
    sysStyle: {}
  });
  const buttonList = [
    {
      code: bucket.label,
      display: bucket.label,
      bucket
    }
  ];
  const options2 = {
    format: "form",
    items: buttonList,
    bucket
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupCtnr, { ...options2 });
}
function BoxCtnr(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const theme = useTheme();
  const handleClick = (event2, p2) => {
    console.log("BoxCtnr handleclick for itemseqno : " + p2.item.seqno);
    da.itemSelection(p2.item.seqno);
    event2.stopPropagation();
  };
  const currentWrk = da.work({ entity: "wrk", type: "get" });
  const currentSeqno = currentWrk?.item?.seqno || -1;
  p.item.seqno === currentSeqno;
  const isShowHdr = props.showHdr === "yes" && p.accountNo() == 1;
  let inlineStyle = p.instance.layout === CONST.LAYOUTS.INLINE ? p.inline() : {};
  const isCompWgt = p.item.category !== "Layout";
  let spacingStyles = {};
  spacingStyles = isCompWgt ? {
    margin: "04px",
    padding: "16px",
    border: `1px solid transparent`
  } : {};
  const itemSelectionBG = alpha(theme.palette.secondary.light, 0.1);
  const itemSelectionBC = theme.palette.primary.main;
  const itemSelectionColor = theme.palette.info.contrastText;
  let hoverStyles = null;
  let bgBorderStyles = null;
  if (da.isWhoamiForm()) {
    hoverStyles = {
      backgroundColor: `${itemSelectionBG}`,
      border: `1px dotted ${itemSelectionBC}`
    };
    bgBorderStyles = p.item.wgtHiliteClass === CONST.ITEM_HILITE_CLASS ? { backgroundColor: `${itemSelectionBG}`, border: `1px solid ${itemSelectionBC}`, color: itemSelectionColor } : "";
  } else {
    hoverStyles = {
      border: `1px solid transparent`
    };
    bgBorderStyles = p.item.wgtHiliteClass === CONST.ITEM_HILITE_CLASS ? { border: `1px solid transparent` } : "";
  }
  let buildWithoutHdrSelectedStyles = {
    ...spacingStyles,
    ...bgBorderStyles,
    "&:hover": { ...hoverStyles }
  };
  let buildWithoutHdrInputsStyles = {
    ...spacingStyles,
    ...bgBorderStyles,
    "&:hover": { ...hoverStyles }
  };
  let buildWithoutHdrNonInputsStyle = {
    ...spacingStyles,
    ...bgBorderStyles
  };
  let buildStyles = null;
  if (isShowHdr) {
    buildStyles = bgBorderStyles;
  } else {
    buildStyles = p.item.seqno === currentSeqno ? buildWithoutHdrSelectedStyles : isCompWgt ? buildWithoutHdrInputsStyles : buildWithoutHdrNonInputsStyle;
  }
  console.log(`BoxCtrn returning for : seqno: ${p.item.seqno}, isCompWgt: ${isCompWgt}, rendertype: ${p.rendertype()}, formtype: ${p.formtype()}, real/meta wgt: ${da.isRealWgtOrRelevantMetaWgt(p)}, children: ${!!props.children}`);
  const id = da.getId(p, "item") + "-box";
  if ((p.rendertype() == "build" || p.rendertype() == "submit") && p.formtype() !== "Meta") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        id,
        className: "item-" + p.item.category.toLowerCase(),
        sx: {
          ...buildStyles
        },
        onClick: (event2) => handleClick(event2, p),
        children: props.children
      }
    );
  } else {
    if (da.isRealWgtOrRelevantMetaWgt(p)) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          id,
          className: "ki-item-" + p.item.category.toLowerCase(),
          style: { ...inlineStyle },
          children: props.children
        }
      );
    } else {
      if (!!props.children) {
        console.info("BoxCtrn: Returning <div> with children. Originally children widgets were not included.");
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: props.children });
    }
  }
}
function CheckRadioSwitchComp(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  let options2, wgtOptions;
  const wgt = p.item.wgt;
  let currentSelections = da.value(p);
  const id = da.getId(p, "item");
  wgtOptions = p.item.userProp.options;
  if (typeof currentSelections == "boolean") {
    currentSelections = currentSelections ? wgtOptions.length ? wgtOptions : ["On"] : ["Off"];
  }
  let items = wgtOptions && wgtOptions.map(function(option, i, source) {
    let code, display, isChecked;
    if (typeof option == "string") {
      code = option;
      display = option;
    } else {
      code = option["key"] ? option.key : option.value;
      display = option["value"] || code;
    }
    let isOptionSelected = null;
    if (Array.isArray(currentSelections)) {
      isOptionSelected = currentSelections && currentSelections.length > 0 && currentSelections.find(function(option2) {
        if (typeof option2 == "string") {
          return option2 === code;
        } else {
          if (option2["key"]) {
            return option2.key === code;
          } else {
            return option2.value === code;
          }
        }
      });
    } else {
      isOptionSelected = currentSelections === code;
    }
    isChecked = !!isOptionSelected;
    return {
      code,
      display,
      bucket: {
        checked: isChecked,
        className: {},
        // For All
        inputProps: "",
        //
        color: "primary",
        //
        disabled: false,
        //
        indeterminate: false,
        //
        icon: null,
        // <FavoriteBorder />, //
        checkedIcon: null,
        //<FavoriteBorder />, //
        labelPlacement: "end",
        //
        size: "medium",
        id: id + "-" + i
      }
    };
  });
  const type = wgt === "Checkboxes" ? "check" : wgt === "Radio Buttons" ? "radio" : "switch";
  const bucket = getItemUserProps({
    caller: "CheckRadioSwitchComp",
    p,
    da,
    type,
    sysStyle: {}
  });
  bucket.id = id;
  options2 = {
    format: "form",
    items,
    bucket
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MuiCheckRadioSwitch, { ...options2 });
}
function CollapsableCtnr(props) {
  useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  da.getId(p, "item");
  var key = p.item.seqno;
  var label2 = da.label(p);
  var nailedHiliteClass = p.item.nailedHiliteClass;
  const accordionList = [
    {
      code: label2,
      display: label2,
      bucket: {
        isExpanded: p.item.userProp?.isExpanded,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 0, nailedHiliteClass, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: "" }) }) })
      }
    }
  ];
  const bucket = getItemUserProps({
    caller: "Collapsable",
    p,
    da,
    type: "Collapsable",
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  const accordionOptions = {
    format: "form",
    items: accordionList,
    bucket
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MuiAccordion, { ...accordionOptions });
}
function FieldsetCtnr(props) {
  const theme = useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  var id = da.getId(p, "item");
  var key = p.item.seqno;
  var nailedHiliteClass = p.item.nailedHiliteClass;
  const bucket = getItemUserProps({
    caller: "Fieldset",
    p,
    da,
    type: "Fieldset",
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      sx: {
        color: theme.palette.secondary.main,
        marginBottom: "8px",
        ...bucket.sysStyle,
        ...bucket.usrStyle
      },
      "data-where": "Fieldset",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("fieldset", { id, className: p.getWgtClass(), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("legend", { children: bucket.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 0, nailedHiliteClass, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ki-fieldset-body", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: "" }) }) })
      ] })
    }
  );
}
function InfoComp(props) {
  const theme = useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  var html = [];
  var type = p.item.wgt;
  let color2 = null, border2 = null, style2 = null;
  const bucket = getItemUserProps({
    caller: type,
    p,
    da,
    type,
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  switch (type) {
    case "Header":
    case "Footer":
      let thick = bucket.thick ? bucket.thick % 6 + 1 : 1;
      let tag = `h${thick}`;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          variant: tag,
          gutterBottom: true,
          sx: {
            color: theme.palette[bucket?.color]?.main || "primary",
            textAlign: bucket.align,
            ...bucket.sysStyle,
            ...bucket.usrStyle
          },
          children: bucket.value || "Please specify text value"
        }
      );
    case "Logo":
    case "Image":
      const src = bucket.value && bucket.value.startsWith("http") ? bucket.value : `${da.path("images")}${bucket.value}`;
      style2 = { objectFit: "contain", backgroundSize: "contain" };
      const alt = "Responsive Image";
      const width2 = bucket.width ? `${bucket.width}%` : "100%";
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          src,
          alt,
          width: width2,
          style: {
            ...style2,
            ...bucket.sysStyle,
            ...bucket.usrStyle
          }
        }
      );
    case "Line":
      color2 = bucket?.color ? theme.palette[bucket?.color]?.main : "primary";
      border2 = bucket.thick ? `${bucket.thick}px solid ${color2}` : `1px solid ${color2}`;
      style2 = { borderTop: border2, marginTop: "8px", marginBottom: "8px" };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box$1,
        {
          sx: {
            ...style2,
            ...bucket.sysStyle,
            ...bucket.usrStyle
          }
        }
      );
    case "Static Text":
    case "Formatted Text":
      color2 = bucket?.color ? theme.palette[bucket?.color]?.main : "primary";
      border2 = bucket?.border ? `1px solid ${color2}` : "";
      style2 = { color: color2, border: border2, padding: "8px" };
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Box$1,
        {
          sx: {
            ...style2,
            ...bucket.sysStyle,
            ...bucket.usrStyle
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { children: [
              " ",
              bucket.label,
              " "
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              " ",
              bucket.value,
              " "
            ] })
          ]
        }
      );
    case "Hyper Link":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Link,
        {
          href: bucket.value,
          target: "_blank",
          sx: {
            ...bucket.sysStyle,
            ...bucket.usrStyle
          },
          children: bucket.label
        }
      );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: html.join(" ") } });
}
function InlineCtnr(props) {
  useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  da.getId(p, "item");
  var key = p.item.seqno;
  var nailedHiliteClass = p.item.nailedHiliteClass;
  const bucket = getItemUserProps({
    caller: "Inline",
    p,
    da,
    type: "Inline",
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      sx: {
        //border: `1px solid ${theme.custom.border}`,
        marginBottom: "8px",
        ...bucket.sysStyle,
        ...bucket.usrStyle
      },
      "data-where": "InlineCtnr",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        NailCtnr,
        {
          p,
          seqno: key,
          compid: 0,
          nailedHiliteClass,
          inline: p.item.userProp.isInlined,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: p.item.userProp.isInlined })
        }
      )
    }
  );
}
function InputComp(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  let options2;
  const types = {
    button: "not supported",
    checkbox: "not supported",
    hidden: "not supported",
    image: "not supported",
    radio: "not supported",
    reset: "not supported",
    search: "not supported",
    submit: "not supported",
    Color: "color",
    Date: "date",
    "Datetime Local": "datetime-local",
    Email: "email",
    File: "file",
    Month: "month",
    Number: "number",
    Password: "password",
    Range: "range",
    Tel: "tel",
    Text: "text",
    "Text Area": "text",
    Time: "time",
    URL: "url",
    Week: "week"
  };
  const type = types[p.item.wgt];
  const bucket = getItemUserProps({
    caller: "InputComp",
    p,
    da,
    type,
    sysStyle: {}
    // remember using sysStyle impacts all InputComp. Including the Prop Editor.
  });
  bucket.id = da.getId(p, "item");
  options2 = {
    format: "form",
    items: null,
    bucket
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...options2 });
}
function PanelCtnr(props) {
  useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  da.getId(p, "item");
  var key = p.item.seqno;
  var label2 = da.label(p);
  var nailedHiliteClass = p.item.nailedHiliteClass;
  console.warn("PanelCtnr - needs code to support flexible height and scrollers");
  const panelHdr = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: label2 }) });
  const panelBody = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 0, nailedHiliteClass, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: "" }) }) });
  const panelFtr = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  const bucket = getItemUserProps({
    caller: "Panel",
    p,
    da,
    type: "Panel",
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  const panelOptions = {
    format: "form",
    bucket: {
      ...bucket,
      children: panelHdr,
      children2: panelBody,
      children3: panelFtr,
      scrollers: "vert",
      height: "400"
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PanelLayout, { ...panelOptions });
}
function SelectListComp(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const handleChange = p.handleChange;
  const label2 = p.label;
  const initValue = p.label;
  const isNative = p.isNative || false;
  let options2;
  let currentSelectionValue = "";
  const value2 = initValue || da && da.value(p) || "";
  if (value2) {
    if (p.item.userProp.isMultiSelect) {
      currentSelectionValue = value2 && value2.length > 1 ? value2 || "" : [value2];
    } else {
      currentSelectionValue = value2;
    }
  }
  options2 = da && da.options(p);
  if (currentSelectionValue == "undefined" || currentSelectionValue == "") currentSelectionValue = options2[0] ? options2[0] : "None";
  let items = options2.map(function(option, i, source) {
    let optionKey, optionVal;
    if (typeof option == "string") {
      optionKey = option;
      optionVal = option;
    } else {
      optionKey = option.key;
      optionVal = option.value;
    }
    return { code: optionKey, display: optionVal, bucket: {} };
  });
  if (p.item.userProp.isEmptyOption && items && items.length) {
    items.unshift({ code: "none", display: "None", bucket: {} });
  }
  const type = "select";
  const bucket = getItemUserProps({
    caller: "Select List",
    p,
    da,
    type
  });
  bucket.currentSelectionValue = currentSelectionValue;
  bucket.id = da.getId(p, "item");
  bucket.isDisabled = false;
  bucket.isSelect = true;
  if (isNative) bucket.isNative = true;
  if (label2) bucket.label = label2;
  if (value2) bucket.value = value2;
  if (handleChange) bucket.handleChange = handleChange;
  options2 = {
    format: "form",
    items,
    bucket
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...options2 });
}
function ColumnCtnr(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  da.getId(p, "item");
  var key = p.item.seqno;
  var nailedHiliteCompId = p.item.nailedHiliteCompId;
  var nailedHiliteClass = p.item.nailedHiliteClass;
  var nailed = function(compId) {
    return nailedHiliteCompId == compId ? nailedHiliteClass : "";
  };
  const bucket = getItemUserProps({
    caller: "Column",
    p,
    da,
    type: "Column",
    sysStyle: {}
    // remember using sysStyle impacts all InputComp. Including the Prop Editor.
  });
  bucket.id = da.getId(p, "item");
  if (p.item.wgt === "1 Column") {
    const oneColOptions = {
      format: "form",
      bucket: {
        ...bucket,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 0, nailedHiliteClass: nailed(0), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: "" }) }) })
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(OneColumnLayout, { ...oneColOptions });
  } else if (p.item.wgt === "2 Column") {
    const twoColOptions = {
      format: "form",
      bucket: {
        ...bucket,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 0, nailedHiliteClass: nailed(0), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: "" }) }) }),
        children2: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 1, nailedHiliteClass: nailed(1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 1, inline: "" }) }) })
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TwoColumnLayout, { ...twoColOptions });
  } else if (p.item.wgt === "3 Column") {
    const threeColOptions = {
      format: "form",
      bucket: {
        ...bucket,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 0, nailedHiliteClass: nailed(0), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: "" }) }) }),
        children2: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 1, nailedHiliteClass: nailed(1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 1, inline: "" }) }) }),
        children3: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 2, nailedHiliteClass: nailed(2), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 2, inline: "" }) }) })
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ThreeColumnLayout, { ...threeColOptions });
  } else if (p.item.wgt === "4 Column") {
    const fourColOptions = {
      format: "form",
      bucket: {
        ...bucket,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 0, nailedHiliteClass: nailed(0), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 0, inline: "" }) }) }),
        children2: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 1, nailedHiliteClass: nailed(1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 1, inline: "" }) }) }),
        children3: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 2, nailedHiliteClass: nailed(2), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 2, inline: "" }) }) }),
        children4: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: 3, nailedHiliteClass: nailed(3), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: 3, inline: "" }) }) })
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FourColumnLayout, { ...fourColOptions });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Unknown Container Type Requested" });
  }
}
function TabCtnr(props) {
  useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  da.getId(p, "item");
  var key = p.item.seqno;
  const bucket = getItemUserProps({
    caller: "Tab",
    p,
    da,
    type: "Tab",
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  var options2 = p.item.userProp.options;
  var nailedHiliteCompId = p.item.nailedHiliteCompId;
  var nailedHiliteClass = p.item.nailedHiliteClass;
  const tabList = options2 && options2.map((label2, i, src) => {
    const compId = i;
    const nailed = nailedHiliteCompId == compId ? nailedHiliteClass : "";
    const panel = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: compId, nailedHiliteClass: nailed, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: compId, inline: "" }) }) });
    return { code: label2, display: label2, bucket: { children: panel } };
  });
  console.warn("TabCtnr - needs code to support handleSelection");
  const handleChange = () => {
    console.log("TabCtnr:handleChange() invoked. Ignoring the callback");
  };
  bucket.handleChange = handleChange;
  const tabOptions = {
    format: "form",
    items: tabList,
    bucket
  };
  if (tabList) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(MuiTabs, { ...tabOptions });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: " Unable to create Tabs as there are no options " });
  }
}
function WizardCtnr(props) {
  this.props.p;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Wizard not available. Don t forget to account for nailedHiliteClass. Similar to tabs and accordion which have multiple ids" });
}
function ChipInputComp(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  let chips = da.value(p);
  if (!chips || !chips.length || chips == "[]") chips = [];
  const onTagRemove = (tag) => {
    return da.genericHandleTagChange(p, tag, "remove");
  };
  const onTagAdd = (tag) => {
    return da.genericHandleTagChange(p, tag, "add");
  };
  const chipOptions = {
    value: chips,
    onDelete: onTagRemove,
    onAdd: onTagAdd,
    id: da.getId(p, "item"),
    name: da.getId(p, "item")
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { class: "form-control", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { for: chipOptions.id, children: p.item.userProp.label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, { id: chipOptions.id, ...chipOptions }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: p.item.userProp.helperText })
  ] });
}
function AutocompleteTaggerComp(props) {
  useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const handleOnChange = (event2, newValue) => {
    if (typeof newValue == "string") {
      newValue = newValue && newValue.replace(/Add: /g, "").replace(/\"/g, "");
    }
    if (typeof newValue == "object") {
      newValue = newValue.map((item) => item.replace(/Add: /g, "").replace(/\"/g, ""));
    }
    da.genericHandleChange(event2, p, p.item, null, newValue);
  };
  const bucket = getItemUserProps({
    caller: "Tag Autocomplete",
    p,
    da,
    type: "Tag Autocomplete",
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  let selection = bucket.value;
  if (!bucket.value) {
    selection = [];
  } else {
    if (typeof bucket.value == "string") {
      selection = [bucket.value];
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    MuiAutoComplete,
    {
      usedBy: "metaform",
      multiple: bucket?.isMultiple,
      freeSolo: bucket?.isFreeSolo,
      id: "metaform",
      label: bucket?.label,
      title: "Enter options for users to select",
      selection,
      options: bucket?.options,
      isFullWidth: bucket?.isFullWidth,
      displayLimit: bucket?.limitTags,
      onChangeCB: handleOnChange,
      variant: bucket?.variant,
      usrStyle: bucket?.usrStyle,
      sysStyle: bucket?.sysStyle
    }
  );
}
function FillerComp(props) {
  useTheme();
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  var key = p.item.seqno;
  const bucket = getItemUserProps({
    caller: "Filler",
    p,
    da,
    type: "Filler",
    sysStyle: {}
  });
  bucket.id = da.getId(p, "item");
  const style2 = { minHeight: (bucket?.rows || 1) * 8 };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      sx: {
        ...style2,
        ...bucket.sysStyle,
        ...bucket.usrStyle
      },
      seqno: key,
      "data-where": "FillerComp"
    }
  );
}
function WidgetCtnr(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  const p = props.p;
  const ndx = props.ndx;
  console.log(`WidgetCtnr:renderWidget - widget: ${p.item.wgt}   key: seqno-ndx: ${p.item.seqno}-${ndx}`);
  switch (p.item.wgt) {
    //
    // Informational
    //
    case "Background Image":
    case "Header":
    case "Footer":
    case "Image":
    case "Line":
    case "Logo":
    case "Static Text":
    case "Formatted Text":
    case "Hyper Link":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoComp, { p }) }, p.item.seqno + "-" + ndx);
    //
    // Basic
    //
    case "Checkboxes":
    case "Radio Buttons":
    case "Switches":
    case "OnOff":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckRadioSwitchComp, { p }) }, p.item.seqno + "-" + ndx);
    /*  
    case 'OnOff':
      return (
        <BoxCtnr p={p} key={p.item.seqno + '-' + ndx}>
          <OnOffComp p={p} />
        </BoxCtnr>
      );
      break;
    */
    case "Select List":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectListComp, { p }) }, p.item.seqno + "-" + ndx);
    case "ChipInput":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChipInputComp, { p }) }, p.item.seqno + "-" + ndx);
    case "Tag Autocomplete":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteTaggerComp, { p }) }, p.item.seqno + "-" + ndx);
    case "Submit Button":
    case "Reset Button":
    case "Clear Button":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComp, { p }) }, p.item.seqno + "-" + ndx);
    case "Color":
    // Data List
    case "Date":
    case "Datetime":
    case "Datetime Local":
    case "Email":
    case "File":
    case "Month":
    case "Number":
    case "Password":
    case "Range":
    case "Search":
    case "Tel":
    case "Text":
    case "Time":
    case "URL":
    case "Week":
    case "Text Area":
      console.log("WidgetCtnr: Render InputComp for " + p.item.wgt);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputComp, { p }) }, p.item.seqno + "-" + ndx);
    case "Filler":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FillerComp, { p }) }, p.item.seqno + "-" + ndx);
    //	Containers
    case "Accordion":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionCtnr, { p }) }, p.item.seqno + "-" + ndx);
    case "Collapsable":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapsableCtnr, { p }) }, p.item.seqno + "-" + ndx);
    /* No MUI VERSION EXISTS YET
     case 'Collection':
     return(<BoxCtnr showHdr="yes" p={p} key={p.item.seqno + '-' + ndx}><CollectionCtnr p={p} /></BoxCtnr>);
     break;
     */
    case "Fieldset":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldsetCtnr, { p }) }, p.item.seqno + "-" + ndx);
    case "Panel":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PanelCtnr, { p }) }, p.item.seqno + "-" + ndx);
    case "Tabs":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabCtnr, { p }) }, p.item.seqno + "-" + ndx);
    case "Wizard":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(WizardCtnr, { p }) }, p.item.seqno + "-" + ndx);
    case "1 Column":
    case "2 Column":
    case "3 Column":
    case "4 Column":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnCtnr, { p }) }, p.item.seqno + "-" + ndx);
    case "Inline":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxCtnr, { showHdr: "yes", p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(InlineCtnr, { p }) }, p.item.seqno + "-" + ndx);
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        "The ",
        p.item.wgt,
        " widget is not defined yet!"
      ] }) });
  }
}
function ChildrenCtnr(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  let compid = props.compid;
  let inline = props.inline;
  var children = da.processFindChildren(
    p.formtype(),
    p.formName(),
    p.item,
    p.item.seqno + "-" + compid
  );
  var rows = children.map((childItem, ndx, src) => {
    var child_p = new P({
      rendertype: p.rendertype(),
      formtype: p.formtype(),
      formName: p.formName(),
      accountNo: p.accountNo(),
      formNo: p.formNo(),
      instance: p.instance,
      item: childItem,
      // <<< NOTE: Passing in a SINGLE item
      inline
    });
    console.log("renderChildWidgets - in loop to handle one child " + child_p.item.wgt + " " + child_p.item.seqno);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetCtnr, { p: child_p, ndx }, "" + ndx);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: rows });
}
function AccordionCtnr(props) {
  const p = props.p;
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  da.getId(p, "item");
  var key = p.item.seqno;
  var options2 = da.options(p);
  var nailedHiliteCompId = p.item.nailedHiliteCompId;
  var nailedHiliteClass = p.item.nailedHiliteClass;
  var accordionList = options2.map((label2, i, src) => {
    var compId = i;
    var nailed = nailedHiliteCompId == compId ? nailedHiliteClass : "";
    p.item.seqno + "-" + i;
    p.compid = compId;
    return {
      code: label2,
      display: label2,
      bucket: {
        isExapanded: p.item.userProp?.isExpanded,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NailCtnr, { p, seqno: key, compid: compId, nailedHiliteClass: nailed, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildrenCtnr, { p, compid: compId, inline: "" }) }) })
      }
    };
  });
  const accordionOptions = {
    format: "form",
    items: accordionList,
    bucket: getItemUserProps({
      caller: "Accordion",
      p,
      da,
      type: null,
      sysStyle: {}
      // remember using sysStyle impacts all InputComp. Including the Prop Editor.
    })
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MuiAccordion, { ...accordionOptions });
}
class Login extends React__default.Component {
  constructor(props) {
    super();
    __publicField(this, "onTabChange", (event2) => {
      this.props.model.changeTab(event2.target.className);
    });
    __publicField(this, "onSigninEmailChange", (event2) => {
      this.props.model.signinEmailChange(event2.target.value);
    });
    __publicField(this, "onSigninPassword1Change", (event2) => {
      this.props.model.signinPasswordChange(event2.target.value);
    });
    __publicField(this, "onSigninClick", () => {
      this.props.model.signin();
    });
    __publicField(this, "onSignupEmailChange", (event2) => {
      this.props.model.signupEmailChange(event2.target.value);
    });
    __publicField(this, "onSignupPassword1Change", (event2) => {
      this.model.signupPassword1Change(event2.target.value);
    });
    __publicField(this, "onSignupPassword2Change", (event2) => {
      this.model.signupPassword2Change(event2.target.value);
    });
    __publicField(this, "onSignupClick", () => {
      this.props.model.signup();
    });
    __publicField(this, "onForgotEmailChange", (event2) => {
      this.props.model.forgotEmailChange(event2.target.value);
    });
    __publicField(this, "onForgotClick", () => {
      this.props.model.forgot();
    });
    this.model = props.model;
    let x = document.createElement("div");
    x.style.position = "absolute";
    x.style.right = "20px";
    x.style.bottom = "29px";
    x.innerHTML = ` <svg width="40" height="40" viewBox="0 0 469 784" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
            setValues({...values, showMenu : !values.showMenu})
          }}>
            <path d="M0 783.214V231.8C0 103.792 103.792 0 231.8 0V551.414C231.8 679.422 128.008 783.214 0 783.214Z" fill="#00A69D"/>
            <path d="M229.397 404.87C323.654 404.87 400.064 328.46 400.064 234.203C400.064 139.946 323.654 63.5359 229.397 63.5359C135.14 63.5359 58.73 139.946 58.73 234.203C58.73 328.46 135.14 404.87 229.397 404.87Z" fill="white"/>
            <path d="M231.8 0C362.304 0 468.093 105.789 468.093 236.294C468.093 366.798 362.304 472.587 231.8 472.587V0Z" fill="#FFC500"/>
            <path d="M429.086 366.33C388.143 295.648 316.213 245.187 231.8 233.61V472.619C314.247 472.587 386.801 430.334 429.086 366.33Z" fill="#F15918"/>
            <path d="M154.939 266.283C172.656 266.283 187.019 251.92 187.019 234.203C187.019 216.486 172.656 202.123 154.939 202.123C137.222 202.123 122.859 216.486 122.859 234.203C122.859 251.92 137.222 266.283 154.939 266.283Z" fill="#333333"/>
            <path d="M262.663 76.2369C268.213 76.2369 272.712 71.738 272.712 66.1884C272.712 60.6389 268.213 56.14 262.663 56.14C257.114 56.14 252.615 60.6389 252.615 66.1884C252.615 71.738 257.114 76.2369 262.663 76.2369Z" fill="#EDB20A"/>
          </svg>`;
    document.body.append(x);
    document.body.style.backgroundColor = "#2E2649";
  }
  render() {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "login-wrap", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "login-html", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            id: "tab-1",
            type: "radio",
            name: "tab",
            className: "sign-in",
            defaultChecked: true,
            onChange: this.onTabChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "tab-1", className: "tab", children: "Sign In" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            id: "tab-2",
            type: "radio",
            name: "tab",
            className: "sign-up",
            onChange: this.onTabChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "tab-2", className: "tab", children: "Sign Up" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            id: "tab-3",
            type: "radio",
            name: "tab",
            className: "forgot",
            onChange: this.onTabChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "tab-3", className: "tab", children: "Forgot" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "login-form", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sign-in-htm", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "email", className: "label", children: "Email Address" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  id: "signinemail",
                  type: "text",
                  className: "input",
                  value: this.model.email,
                  onChange: this.onSigninEmailChange
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "password1", className: "label", children: "Password" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  id: "signinpassword1",
                  type: "password",
                  className: "input",
                  "data-type": "password",
                  value: this.model.password1,
                  onChange: this.onSigninPassword1Change
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("input", { id: "check", type: "checkbox", className: "check", defaultChecked: true }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: "check", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon" }),
                " Keep me Signed in"
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "group", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "submit",
                className: "button",
                value: "Sign In",
                onClick: this.onSigninClick
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hr" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "foot-lnk", children: /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "tab-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { children: "Forgot Password?" }) }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sign-up-htm", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "email", className: "label", children: "Email Address" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  id: "signupemail",
                  type: "text",
                  className: "input",
                  value: this.model.email,
                  onChange: this.onSignupEmailChange
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "password1", className: "label", children: "Password" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  id: "signuppassword1",
                  type: "password",
                  className: "input",
                  "data-type": "password",
                  onChange: this.onSignupPassword1Change
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "password2", className: "label", children: "Repeat Password" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  id: "signuppassword2",
                  type: "password",
                  className: "input",
                  "data-type": "password",
                  onChange: this.onSignupPassword2Change
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "group", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "submit",
                className: "button",
                value: "Sign Up",
                onClick: this.onSignupClick
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hr" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "foot-lnk", children: /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "tab-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { children: "Already Member?" }) }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "forgot-htm", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "email", className: "label", children: "Email Address" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  id: "forgotemail",
                  type: "text",
                  className: "input",
                  value: this.model.email,
                  onChange: this.onForgotEmailChange
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "group", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "submit",
                className: "button",
                value: "Forgot Password ",
                onClick: this.onForgotClick
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hr" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "foot-lnk", children: /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "tab-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { children: "Already Member?" }) }) })
          ] })
        ] }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "message", dangerouslySetInnerHTML: { __html: this.model.message } })
      ] }),
      " "
    ] });
  }
}
const useStyles$l = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function ChangeIdComp() {
  const theme = useTheme();
  const classes = useStyles$l(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.paper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormProxyCtnr, { formtype: "Service", formName: "changeid" }) }) });
}
const useStyles$k = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function ChangePwdComp() {
  const theme = useTheme();
  const classes = useStyles$k(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.paper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormProxyCtnr, { formtype: "Service", formName: "changepwd" }) }) });
}
const useStyles$j = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function ForgotComp() {
  const theme = useTheme();
  const classes = useStyles$j(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.paper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormProxyCtnr, { formtype: "Service", formName: "forgot" }) }) });
}
const useStyles$i = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function InvitesComp() {
  const theme = useTheme();
  useStyles$i(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListProxyCtnr, { formtype: "List", formName: "invites" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormProxyCtnr, { formtype: "Service", formName: "invite" })
  ] });
}
const useStyles$h = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function MembersComp() {
  const theme = useTheme();
  useStyles$h(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " List out members associated with the account " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " Manage members / Invite new members - tool is only avail. for owner subscriber " })
  ] });
}
const useStyles$g = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function ReverifyComp() {
  const theme = useTheme();
  const classes = useStyles$g(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.paper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormProxyCtnr, { formtype: "Service", formName: "reverify" }) }) });
}
const useStyles$f = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function SignInComp() {
  const theme = useTheme();
  const classes = useStyles$f(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.paper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormProxyCtnr, { formtype: "Service", formName: "signin" }) }) });
}
const useStyles$e = (theme) => ({
  paper: {
    marginTop: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
function SignUpComp() {
  const theme = useTheme();
  const classes = useStyles$e(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.paper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormProxyCtnr, { formtype: "Service", formName: "signup" }) }) });
}
function AccountPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  useTheme();
  const { appState, dispatch } = useAppContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " ACCOUNT Coming Soon " }) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: [
      "  ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Manage Account" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "Update User Account Information" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } })
    ] }) })
  ] });
}
const getSubscribedApps = (appsSubs, accountApps) => {
  let subscribedApps = [];
  Object.keys(accountApps).forEach((key) => {
    const subList = accountApps[key];
    if (subList) {
      let isEnrolled = false;
      let isPayment = false;
      subList && subList.forEach((subDtls) => {
        if (!subDtls.deenrollts) {
          isEnrolled = true;
        }
        if (subDtls.paymentts && !subDtls.depaymentts) {
          isPayment = true;
        }
      });
      if (isEnrolled || isPayment) {
        subscribedApps.push(appsSubs[key].display);
      }
    } else {
      subscribedApps.push(appsSubs[key].display);
    }
  });
  if (!subscribedApps.length) subscribedApps.push("None");
  return subscribedApps;
};
function PlansPage(props) {
  const da = props.da;
  const appsSubs = props.appsSubs;
  useTheme();
  const { appState, dispatch } = useAppContext();
  if (!appsSubs) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 10, m: "0 0 2 0" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " Loading..." }) }) }) });
  }
  let qDisplay = "", qPlan = "", qPlanDtls;
  const urlQuery = appState.getEnvVar?.locationData?.urlQuery;
  if (urlQuery) {
    const qParts = urlQuery.split("&");
    qDisplay = qParts[1].startsWith("display") && qParts[1].substr(8) || "";
    qPlan = qParts[2].startsWith("plan") && qParts[2].substr(5) || "";
    if (qDisplay) {
      const { appPlans: appPlans2, availPlans: availPlans2, subKey: subKey2 } = pymtUtil.getPlans(appsSubs, qDisplay);
      if (qPlan) {
        qPlanDtls = appPlans2[qPlan];
      }
    }
  }
  const [app, setApp] = useState(qDisplay || "");
  const [plan, setPlan] = useState(qPlan || "");
  const [planDtls, setPlanDtls] = useState(qPlanDtls || null);
  const [invitecode, setInvitecode] = useState("");
  const [action, setAction] = React__default.useState("add");
  const currentSubsSectHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubscriptions, { caller: "PlansPage" });
  const {
    isAccountOwner: isAccountOwner2,
    accountApps
    /*, acctId, user */
  } = pymtUtil.getAccountApps(appState);
  const subscribedApps = getSubscribedApps(appsSubs, accountApps);
  let unsubscribedApps = [];
  Object.keys(appsSubs).forEach((key) => {
    const ndx = subscribedApps.indexOf(appsSubs[key].display);
    if (ndx === -1) {
      const isActive = appState.getEnvVar.isDev || !appState.getEnvVar.isDev && appsSubs[key].active === "prod";
      if (isActive) {
        unsubscribedApps.push(appsSubs[key].display);
      }
    }
  });
  if (!unsubscribedApps.length) unsubscribedApps.push("None");
  let appSelectListHtml = null;
  let optionsTextFieldAppSelect, items;
  if (action === "add") {
    items = unsubscribedApps.map((availapp, i) => {
      return { code: availapp, display: availapp, bucket: { id: i } };
    });
    optionsTextFieldAppSelect = {
      format: "form",
      items,
      bucket: {
        p: null,
        id: "application",
        label: "Application",
        name: "application",
        type: "select",
        variant: "filled",
        isSelect: true,
        isNative: false,
        handleChange: (event2) => {
          setApp(event2.target.value);
        },
        //handleBlur:  (event) => { },
        currentSelectionValue: app,
        helperText: "Please select your application",
        margin: "normal",
        autoComplete: ""
      }
    };
    appSelectListHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...optionsTextFieldAppSelect });
  } else {
    items = subscribedApps.map((availapp, i) => {
      return { code: availapp, display: availapp, bucket: { id: i } };
    });
    optionsTextFieldAppSelect = {
      format: "form",
      items,
      bucket: {
        p: null,
        id: "application",
        label: "Application",
        name: "application",
        type: "select",
        variant: "filled",
        isSelect: true,
        isNative: false,
        handleChange: (event2) => {
          setApp(event2.target.value);
        },
        //handleBlur:  (event) => { },
        currentSelectionValue: app,
        helperText: "Please select your application",
        margin: "normal",
        autoComplete: ""
      }
    };
    appSelectListHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...optionsTextFieldAppSelect });
  }
  const { appPlans, availPlans, subKey } = pymtUtil.getPlans(appsSubs, app);
  let subList = subKey && accountApps[subKey] || [];
  const activePlans = [];
  subList && subList.forEach((subDtls) => {
    if (!subDtls.deenrollts) {
      if (activePlans.indexOf(subDtls.plan) === -1) {
        activePlans.push(subDtls.plan);
      }
    }
  });
  if (!activePlans.length) activePlans.push("None");
  let planSelectListHtml = "";
  let planDeSelectListHtml = "";
  let planSelectDtlsPriceHtml = "";
  let planSelectDtlsPriceYearHtml = "";
  let planSelectDtlsPricePerSeatHtml = "";
  if (action === "add") {
    const items2 = availPlans.map((availplan, i) => {
      const { partApp, partPlan, partId } = pymtUtil.splitPlanInfo(availplan);
      return { code: availplan, display: partPlan, bucket: { id: i } };
    });
    const optionsTextFieldPlansSelect = {
      format: "form",
      items: items2,
      bucket: {
        p: null,
        id: "plans",
        label: "Plans",
        name: "plans",
        type: "select",
        variant: "filled",
        isSelect: true,
        isNative: false,
        handleChange: (event2) => {
          setPlan(event2.target.value);
          setPlanDtls(appPlans[event2.target.value]);
        },
        //handleBlur:  (event) => { },
        currentSelectionValue: plan,
        helperText: "Please select your application plan",
        margin: "normal",
        autoComplete: ""
      }
    };
    planSelectListHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...optionsTextFieldPlansSelect });
    planSelectDtlsPriceHtml = plan && planDtls ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { m: 0 }, children: "Price: " + planDtls.price }) : null;
    planSelectDtlsPriceYearHtml = plan && planDtls ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { m: 0, marginLeft: "3.0rem" }, children: planDtls.priceYear }) : null;
    planSelectDtlsPricePerSeatHtml = plan && planDtls && planDtls.pricePerSeat && planDtls.pricePerSeat !== "000.00" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { m: 0, marginLeft: "2.2rem" }, children: planDtls.pricePerSeat }) : null;
  } else {
    if (activePlans && activePlans.length && activePlans[0] !== "None") {
      const { partApp, partPlan, partId } = pymtUtil.splitPlanInfo(activePlans[0]);
      planDeSelectListHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "p", sx: {}, children: partPlan ? "Plan: " + partPlan : "" });
      if (plan !== activePlans[0])
        setPlan(activePlans[0]);
    } else {
      planDeSelectListHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "p", sx: {}, children: "Plan: None" });
    }
  }
  const optionsTextFieldInviteCode = {
    format: "form",
    bucket: {
      p: null,
      id: "invitecode",
      label: "Invite Code",
      name: "invitecode",
      type: "text",
      variant: "filled",
      handleChange: (event2) => {
        setInvitecode(event2.target.value);
      },
      //handleBlur:  (event) => { },
      value: invitecode,
      helperText: "Enter a valid invite code",
      margin: "normal",
      autoComplete: ""
    }
  };
  const inviteCodeHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...optionsTextFieldInviteCode });
  const isAddSubBtnDisabled = app && plan ? false : true;
  const handleReset = () => {
    setInvitecode("");
    setPlan("");
    setApp("");
  };
  const resetHtml = CreateFabOrButton("button", "Reset", null, null, null, [0, 0, 0, 0, 0, 0], handleReset, false, { backgroundColor: "gray", padding: "0rem", width: "16rem" });
  const handleAddRemove = async () => {
    await da.serverio.appsub({ action, subKey, display: app, plan, invitecode });
    handleReset();
  };
  const registerHtml = CreateFabOrButton("button", action === "add" ? "ADD PLAN" : "REMOVE PLAN", null, null, null, [0, 0, 0, 0, 0, 0], handleAddRemove, isAddSubBtnDisabled, { padding: "0rem", width: "16rem" });
  const handleActionChange = (event2, newAction) => {
    handleReset();
    setAction(newAction);
  };
  const headerHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Manage Plans" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "Add or remove plan anytime. To change a plan, ensure to remove active subscription and plan prior to adding a new desired plan." })
  ] });
  const toggleOptions = {
    format: "form",
    items: [
      {
        code: "add",
        display: "Add",
        icon: null,
        bucket: {}
      },
      {
        code: "remove",
        display: "Remove",
        icon: null,
        bucket: {}
      }
    ],
    bucket: {
      p: null,
      id: "slider",
      label: "Slider",
      name: "amount",
      color: "primary",
      value: action,
      size: "medium",
      handleChange: handleActionChange,
      ariaLabelledBy: "Action Toggle",
      orientation: "horizontal",
      variant: "filled",
      helperText: "???",
      usrStyle: { display: "flex", justifyContent: "center" }
    }
  };
  const actionButtonHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(ToggleComp, { ...toggleOptions });
  if (!appState.isSignIn) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 10, m: "0 0 2 0" }, elevation: 3, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " Plans are not available to pre-assigned anonymous id." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: " Please Sign Up or Sign In using MY ACCOUNT to access subscriptions." })
    ] }) }) });
  } else if (!isAccountOwner2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 10, m: "0 0 2 0" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " Subscription enrollments are not permitted for members." }) }) }) });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: currentSubsSectHtml }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: headerHtml }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: {}, children: actionButtonHtml }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: {}, children: appSelectListHtml }),
        action === "add" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, size: { xs: 12 }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6 }, sx: {}, children: planSelectListHtml }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12, sm: 6 }, sx: {}, children: [
            planSelectDtlsPriceHtml,
            planSelectDtlsPriceYearHtml,
            planSelectDtlsPricePerSeatHtml
          ] })
        ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 }, children: planDeSelectListHtml }),
        action === "add" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: {}, children: inviteCodeHtml }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, size: { xs: 12 }, sx: { p: 2 }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, sm: 6 }, children: resetHtml }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, sm: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { float: "right" }, children: registerHtml }) })
        ] })
      ] }) })
    ] });
  }
}
function JoinPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  useTheme();
  const { appState, dispatch } = useAppContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " JOIN TEAM Coming Soon " }) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: [
      "  ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Request Team To Become A Member" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } })
    ] }) })
  ] });
}
function MembersPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  useTheme();
  const { appState, dispatch } = useAppContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " MEMBERS Coming Soon " }) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: [
      "  ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Manage Account Team Members" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "Add/Remove/Update/Invite Team Members" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } })
    ] }) })
  ] });
}
function UsersPage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  useTheme();
  const { appState, dispatch } = useAppContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " USERS Coming Soon " }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " System Administration Tool " })
    ] }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionPage-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: [
      "  ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Manage Application Users" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "Add/Remove/Update User Details" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 } })
    ] }) })
  ] });
}
function ScurBody(props) {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const nav = da.getNav();
  const auth = useAuth();
  const { appState, dispatch } = useAppContext();
  const [appsSubs, setAppsSubs] = useState(null);
  useEffect(() => {
    async function fetchData() {
      const respAppssubs = await da.serverio.appssubs({});
      if (respAppssubs) {
        setAppsSubs(respAppssubs.appssubs);
      } else {
        console.error("ScurBody:useEffect: fetch for appssubs failed");
      }
    }
    fetchData();
  }, []);
  auth.isAuthenticated;
  let currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(ScurHomePage, {});
  if (nav === "home") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(ScurHomePage, {});
  if (nav === "account") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(AccountPage, {});
  if (nav === "plans" && appsSubs) {
    currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(PlansPage, { da, appsSubs });
  }
  if (nav === "subscriptions" && appsSubs) {
    currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(SubscriptionsPage, { da, appsSubs });
  }
  if (nav === "join") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(JoinPage, {});
  if (nav === "members") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(MembersPage, {});
  if (nav === "users") currentPage = /* @__PURE__ */ jsxRuntimeExports.jsx(UsersPage, {});
  if (!appsSubs) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormNoDataLayout, { title: "Loading... Plans", tip: "", msgList: null });
  }
  if (da.isInit() || nav === "home") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: currentPage });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: da.getStateMsg() });
  }
}
const useStyles$d = (theme) => ({
  drawer: {
    width: "240px",
    marginTop: "64px",
    [theme.breakpoints.up("md")]: {
      marginTop: "64px",
      height: "calc(100% - 64px)"
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  },
  navButton: {
    color: colors.blueGrey[800],
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {},
  todo: {
    backgroundColor: "yellow"
  },
  activeButton: {
    textTransform: "none",
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    "& $icon": {
      color: theme.palette.primary.main
    }
  }
});
const ScurSidebar = (props) => {
  const { spaState, spaDispatch } = useSpaContext();
  const da = spaState.da;
  const { open, variant, onClose, className, ...rest } = props;
  const theme = useTheme();
  const classes = useStyles$d(theme);
  const nav = da.getNav();
  const isAuthenticated2 = da.isAuthenticated();
  const isAccountOwner2 = da.isAccountOwner();
  const isAccountOwnerSubscriber2 = da.isAccountOwnerSubscriber();
  const handleClick = (event2, p, item, i) => {
    console.log("handleClick() - item.code is : " + item.code);
    da.setNav(item.code);
    event2.preventDefault();
  };
  const checkDisabled = (p, item, i) => {
    if (da.getNav() === item.code) return true;
    if (item.code === "build" || item.code === "preview" || item.code === "data") {
      if (!da.isFormSelected()) return true;
    }
    return false;
  };
  const buttonList = [
    {
      code: "home",
      display: "Home",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "Home" }),
        iconRight: null,
        className: nav === "home" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "App home page"
      }
    }
  ];
  if (!isAuthenticated2)
    buttonList.push({
      code: "signin",
      display: "Sign In",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "LockRounded" }),
        iconRight: null,
        className: nav === "signin" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "User authentication"
      }
    });
  if (!isAuthenticated2)
    buttonList.push({
      code: "signup",
      display: "Sign Up",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "PersonAdd" }),
        iconRight: null,
        className: nav === "signup" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "#ff0000",
        tip: "User registration"
      }
    });
  if (isAuthenticated2 && isAccountOwner2)
    buttonList.push({
      code: "addanapp",
      display: "Add An App",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "PersonAdd" }),
        iconRight: null,
        className: nav === "addanapp" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "#ff0000",
        tip: "User registration"
      }
    });
  if (!isAuthenticated2)
    buttonList.push({
      code: "forgot",
      display: "Forgot Password",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "NoEncryptionRounded" }),
        iconRight: null,
        className: nav === "forgot" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Retrieve forgotten password"
      }
    });
  if (isAuthenticated2)
    buttonList.push({
      code: "changeid",
      display: "Change Email",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "Email" }),
        iconRight: null,
        className: nav === "changeid" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Change registered email address"
      }
    });
  if (isAuthenticated2)
    buttonList.push({
      code: "changepwd",
      display: "Change Password",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "LockRounded" }),
        iconRight: null,
        className: nav === "changepwd" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Change access password"
      }
    });
  if (!isAuthenticated2)
    buttonList.push({
      code: "reverify",
      display: "Reverify",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "SettingsBackupRestoreRounded" }),
        iconRight: null,
        className: nav === "changepwd" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Request an email to verify signup"
      }
    });
  if (da.isDev()) {
    if (isAuthenticated2)
      buttonList.push({
        code: "profile",
        display: "Profile",
        bucket: {
          type: "button",
          iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "Face" }),
          iconRight: null,
          //className: {{...classes.todo, (nav === 'profile' ? ...classes.activeButton : ...classes.navButton) }},
          className: nav === "profile" ? { ...classes.todo, ...classes.activeButton } : { ...classes.todo, ...classes.navButton },
          variant: "contained",
          color: "default",
          tip: "Manage profile"
        }
      });
  }
  if (isAuthenticated2 && isAccountOwnerSubscriber2)
    buttonList.push({
      code: "members",
      display: "Members",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "SupervisedUserCircle" }),
        iconRight: null,
        className: nav === "members" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Manage member invitations"
      }
    });
  if (isAuthenticated2 && isAccountOwnerSubscriber2)
    buttonList.push({
      code: "invites",
      display: "Invites",
      bucket: {
        type: "button",
        iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "PersonAdd" }),
        iconRight: null,
        className: nav === "invites" ? classes.activeButton : classes.navButton,
        variant: "contained",
        color: "default",
        tip: "Invite team members"
      }
    });
  if (da.isDev()) {
    if (isAuthenticated2)
      buttonList.push({
        code: "join",
        display: "Join Team",
        bucket: {
          type: "button",
          iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "AccountCircle" }),
          iconRight: null,
          //className: {{...classes.todo, (nav === 'profile' ? ...classes.activeButton : ...classes.navButton) }},
          className: nav === "profile" ? { ...classes.todo, ...classes.activeButton } : { ...classes.todo, ...classes.navButton },
          variant: "contained",
          color: "default",
          tip: "Register a request to join a team"
        }
      });
  }
  if (da.isDev()) {
    if (isAuthenticated2 && isAccountOwner2)
      buttonList.push({
        code: "accounts",
        display: "Accounts",
        bucket: {
          type: "button",
          iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "AccountBox" }),
          iconRight: null,
          //className: {{...classes.todo, (nav === 'profile' ? ...classes.activeButton : ...classes.navButton) }},
          className: nav === "profile" ? { ...classes.todo, ...classes.activeButton } : { ...classes.todo, ...classes.navButton },
          variant: "contained",
          color: "default",
          tip: "Manage account"
        }
      });
  }
  if (da.isDev()) {
    if (isAuthenticated2 && isAccountOwner2)
      buttonList.push({
        code: "users",
        display: "Users",
        bucket: {
          type: "button",
          iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "Group" }),
          iconRight: null,
          //className: {{...classes.todo, (nav === 'profile' ? ...classes.activeButton : ...classes.navButton) }},
          className: nav === "profile" ? { ...classes.todo, ...classes.activeButton } : { ...classes.todo, ...classes.navButton },
          variant: "contained",
          color: "default",
          tip: "Manage users"
        }
      });
  }
  if (da.isDev()) {
    if (isAuthenticated2 && isAccountOwner2)
      buttonList.push({
        code: "permissions",
        display: "Permissions",
        bucket: {
          type: "button",
          iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "DesktopAccessDisabledRounded" }),
          iconRight: null,
          //className: {{...classes.todo, (nav === 'profile' ? ...classes.activeButton : ...classes.navButton) }},
          className: nav === "profile" ? { ...classes.todo, ...classes.activeButton } : { ...classes.todo, ...classes.navButton },
          variant: "contained",
          color: "default",
          tip: "Manage permissions"
        }
      });
  }
  if (da.isDev()) {
    if (isAuthenticated2 && isAccountOwner2)
      buttonList.push({
        code: "preferences",
        display: "Preferences",
        bucket: {
          type: "button",
          iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette, { name: "Favorite" }),
          iconRight: null,
          //className: {{ ...classes.todo, (nav === 'profile' ? ...classes.activeButton : ...classes.navButton) }},
          className: nav === "profile" ? { ...classes.todo, ...classes.activeButton } : { ...classes.todo, ...classes.navButton },
          variant: "contained",
          color: "default",
          tip: "Manage preferences"
        }
      });
  }
  const navOptions = {
    format: "form",
    items: buttonList,
    bucket: {
      p: null,
      label: null,
      handleClick,
      checkDisabled,
      width: "fixed",
      variant: "contained",
      size: "large",
      className: classes.nav,
      orientation: "vertical"
      // 'vertical' | 'horizontal'
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Drawer,
    {
      anchor: "left",
      onClose,
      open,
      variant,
      "data-where": "Sidebar",
      sx: {
        [`& .MuiDrawer-paper`]: { ...classes.drawer }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { ...classes.root }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Profile, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { sx: { ...classes.divider } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ListButtonCtnr, { ...navOptions }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { sx: { ...classes.divider } })
      ] })
    }
  );
};
ScurSidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};
function ScurHomePage(props) {
  const { spaState, spaDispatch } = useSpaContext();
  spaState.da;
  const appName = "Team Management";
  const pwa = "Notification" in window && navigator.serviceWorker ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormPWA, {}) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CommonHomePageLayout, { image, appName, pwa });
}
function SubscriptionsPage(props) {
  const da = props.da;
  const appssubs2 = props.appsSubs;
  useTheme();
  const { appState, dispatch } = useAppContext();
  if (!appssubs2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, "data-where": "SubscriptionPage", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 10, m: "0 0 2 0" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " Loading..." }) }) }) });
  }
  const { isAccountOwner: isAccountOwner2, accountApps, user } = pymtUtil.getAccountApps(appState);
  const initPlanDtls = { plan: null };
  let qDisplay = "", qPlan = "", qPlanDtls = "", appKey = "", qPaymentIntent = "", qClientSecret = "";
  const url = new URL(window.location);
  const urlQuery = url.searchParams;
  if (urlQuery) {
    url.searchParams.get("nav");
    qPaymentIntent = url.searchParams.get("payment_intent");
    qClientSecret = url.searchParams.get("payment_intent_client_secret");
    qDisplay = url.searchParams.get("display");
    qPlan = url.searchParams.get("plan");
    if (qDisplay) {
      appKey = pymtUtil.getAppKey(appssubs2, qDisplay);
      qPlanDtls = pymtUtil.getAccountAppSub(accountApps, appKey, "subscribed");
    }
    if (qDisplay || qClientSecret) {
      const refresh = () => window.history.replaceState(null, null, `${url.protocol}//${url.host}/?nav=subscriptions`);
      setTimeout(refresh, 1e3);
    }
  }
  const initTxData = {
    app: qDisplay || "",
    plan: qPlan || "",
    priceType: "month",
    priceId: "",
    appKey: appKey || "",
    trialExpiry: null,
    userDtls: {
      email: appState.user.email || "",
      fullName: appState.user.fullname || appState.user.username || "",
      phone: appState.user.phone || ""
    },
    planDtls: qPlanDtls || initPlanDtls,
    planInfo: null,
    priceList: null
  };
  const [txData, setTxData] = useState(initTxData);
  const [stripePromise, setStripePromise] = useState(null);
  const [action, setAction] = React__default.useState("add");
  const [isContinue, setIsContinue] = useState(false);
  useEffect(() => {
    async function fetchData() {
      appState.getEnvVar.API_SRVR_PYMT_URL;
      appState.getEnvVar.RUN_ENV;
      if (appState.token) {
        const respPricelist = await da.serverio.pricelist();
        if (respPricelist) {
          const priceList = respPricelist.pricelist;
          setTxData({ ...txData, priceList });
        } else {
          console.error("SubscriptionsPage:useEffect: get pricelist failed");
        }
        const respConfigpymt = await da.serverio.configpymt();
        if (respConfigpymt) {
          const { publishableKey } = respConfigpymt;
          setStripePromise(loadStripe(publishableKey));
        } else {
          console.error("SubscriptionsPage:useEffect: get pricelist failed");
        }
      } else {
        console.warn("SubscriptionsPage:useEffect token missing - not running pricelist and configpymt");
      }
    }
    fetchData();
  }, [appState.token]);
  const currentSubs = /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubscriptions, { caller: "SubscriptionsPage" });
  const handleAction = (event2, newAction) => {
    qPaymentIntent = null;
    qClientSecret = null;
    handleReset();
    setAction(newAction);
  };
  const toggleOptions = {
    format: "form",
    items: [
      {
        code: "add",
        display: "Add",
        icon: null,
        bucket: {}
      },
      {
        code: "remove",
        display: "Remove",
        icon: null,
        bucket: {}
      }
    ],
    bucket: {
      p: null,
      id: "slider",
      label: "Slider",
      name: "amount",
      color: "primary",
      value: action,
      size: "medium",
      handleChange: handleAction,
      ariaLabelledBy: "Action Toggle",
      orientation: "horizontal",
      variant: "filled",
      helperText: "???",
      usrStyle: { display: "flex", justifyContent: "center" }
    }
  };
  const actionHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(ToggleComp, { ...toggleOptions });
  const handleReset = () => {
    qPaymentIntent = null;
    qClientSecret = null;
    setTxData({ ...txData, app: qDisplay || "", plan: qPlan || "", appKey: appKey || "", planDtls: qPlanDtls || initPlanDtls });
    setIsContinue(false);
  };
  const resetHtml = CreateFabOrButton("button", "Reset", null, null, null, [0, 0, 0, 0, 0, 0], handleReset, isContinue, { backgroundColor: "gray", padding: "0rem", width: "16rem" });
  const handleContinue = async () => {
    qPaymentIntent = null;
    qClientSecret = null;
    setIsContinue(true);
  };
  const continueHtml = CreateFabOrButton("button", "Continue", null, null, null, [0, 0, 0, 0, 0, 0], handleContinue, isContinue || !txData.plan, { padding: "0rem", width: "16rem" });
  const subscriptionSuccessHTML = qPaymentIntent && qClientSecret ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " Subscription payment successfully processed. " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " Check your email for confirmation.  " })
  ] }) : null;
  const subscriptionsInfoHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(
    SubscriptionsInfo,
    {
      da,
      accountApps,
      txData,
      setTxData,
      action,
      setAction,
      handleReset,
      appssubs: appssubs2
    }
  );
  const subscriptionsStripeHtml = txData.plan && isContinue ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    SubscriptionsStripe,
    {
      da,
      accountApps,
      txData,
      setTxData,
      action,
      setAction,
      handleReset
    }
  ) : null;
  const errorProductionUsageHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, "data-where": "SubscriptionsPage", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 10, m: "0 0 2 0" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h2", align: "center", gutterBottom: true, children: "Subscriptions is not available yet! Enjoy your subscription for free!" }) }) }) });
  const errorAnonymousHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, "data-where": "SubscriptionsPage", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 10, m: "0 0 2 0" }, elevation: 3, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h2", align: "center", gutterBottom: true, children: "Subscriptions is not available to pre-assigned anonymous user." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Please Sign Up or Sign In using MY ACCOUNT to access subscriptions." })
  ] }) }) });
  const errorMembersHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, "data-where": "SubscriptionsPage", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 10, m: "0 0 2 0" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h2", align: "center", gutterBottom: true, children: "Subscriptions is not permitted for members." }) }) }) });
  const elementOptions = {
    mode: "subscription",
    amount: 1099,
    currency: "usd",
    // Fully customizable with appearance API.
    /*
       appearance: {
         rules: {
    '.p-PaymentMethodSelector': {
      display: 'none !important',
      backgroundColor: 'red',
    }
         }
       },
       */
    captureMethod: "manual"
  };
  if (!appState.getEnvVar.isDev && !appState.isProdPymt) {
    return errorProductionUsageHtml;
  } else if (!appState.isSignIn) {
    return errorAnonymousHtml;
  } else if (!isAccountOwner2) {
    return errorMembersHtml;
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, "data-where": "SubscriptionsPage", sx: { width: "100%" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionsPage-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: currentSubs }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 6 }, "data-where": "SubscriptionsPage-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 4, height: "100%" }, elevation: 3, children: [
        "  ",
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "Manage Subscriptions" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "Add or remove subscription anytime. Must register a plan prior to subscription setup." })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2 }, children: actionHtml }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { p: 2, minHeight: "18rem", border: "1px dotted green" }, children: subscriptionsInfoHtml }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, size: { xs: 12 }, sx: { p: 2 }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, sm: 6 }, children: resetHtml }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, sm: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { float: "right" }, children: continueHtml }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Elements, { stripe: stripePromise, options: elementOptions, children: subscriptionsStripeHtml }),
        subscriptionSuccessHTML
      ] }) })
    ] });
  }
}
const getPlanInfo = (appssubs2, appCode, plan) => {
  const appDtls = appssubs2[appCode];
  const appPlans = appDtls.plans;
  let planInfo = null;
  Object.keys(appPlans).forEach((subKey) => {
    const info = appPlans[subKey];
    if (subKey === plan) {
      planInfo = info;
    }
  });
  return planInfo;
};
const getPaidApps = (appssubs2, accountApps) => {
  let paidApps = [];
  Object.keys(accountApps).forEach((subKey) => {
    const subList = accountApps[subKey];
    if (subList) {
      let isRegistered = false;
      let isSubscribed = false;
      subList && subList.forEach((subDtls) => {
        if (!subDtls.deenrollts) {
          isRegistered = true;
        }
        if (subDtls.paymentts && !subDtls.depaymentts) {
          isSubscribed = true;
        }
      });
      if (isRegistered && isSubscribed) {
        paidApps.push(appssubs2[subKey].display);
      }
    }
  });
  if (!paidApps.length) paidApps.push("None");
  return paidApps;
};
const getUnPaidApps = (appssubs2, accountApps) => {
  let unpaidApps = [];
  Object.keys(accountApps).forEach((subKey) => {
    const subList = accountApps[subKey];
    if (subList) {
      subList && subList.forEach((subDtls) => {
        let isRegistered = false;
        let isSubscribed = false;
        let isFree = false;
        if (subDtls.enrollts && !subDtls.deenrollts) {
          isRegistered = true;
        }
        if (subDtls.paymentts && !subDtls.depaymentts) {
          isSubscribed = true;
        }
        const planInfo = getPlanInfo(appssubs2, subKey, subDtls.plan);
        if (!planInfo.subscribe) {
          isFree = true;
        }
        if (isRegistered && !isSubscribed && !isFree) {
          unpaidApps.push(appssubs2[subKey].display);
        }
      });
    }
  });
  if (!unpaidApps.length) unpaidApps.push("None");
  return unpaidApps;
};
function SubscriptionsInfo(props) {
  useTheme();
  const { appState, dispatch } = useAppContext();
  const {
    da,
    accountApps,
    txData,
    setTxData,
    action,
    setAction,
    handleReset,
    appssubs: appssubs2
  } = props;
  if (!appssubs2) {
    console.error("No appssubs data available. Not able to render <SubscriptionInfo>");
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: "No appssubs data available. Not able to render SubscriptionInfo." });
  }
  let subscribedApps = getPaidApps(appssubs2, accountApps);
  let registeredApps = getUnPaidApps(appssubs2, accountApps);
  const fullNameHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: 0, marginBottom: 0 }, children: [
    "Name: ",
    txData.userDtls.fullName
  ] });
  const phoneHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: 0, marginBottom: 0 }, children: [
    "Phone: ",
    txData.userDtls.phone
  ] });
  const emailHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: 0, marginBottom: 0 }, children: [
    "Email: ",
    txData.userDtls.email
  ] });
  const handleApps = (event2) => {
    if (event2.target.value === "None") return;
    const selectedApp = event2.target.value;
    let selectedAppSubKey = pymtUtil.getAppKey(appssubs2, selectedApp);
    let selectedPlanDtls = null;
    let selectedPriceType = null;
    let selectedPlan = null;
    let selectedPriceId = null;
    let selectedPlanInfo = null;
    let trialExpiryDate = null;
    if (action === "add") {
      selectedPlanDtls = pymtUtil.getAccountAppSub(accountApps, selectedAppSubKey, "subscribed");
    } else {
      selectedPlanDtls = pymtUtil.getAccountAppSub(accountApps, selectedAppSubKey, "paid");
    }
    if (!selectedPlanDtls) {
      da.setSnackbar(
        `Invalid selectedAppSubKey(${selectedAppSubKey}) - Unable to find plan details`,
        "error"
      );
      handleReset();
      return;
    } else {
      selectedPriceType = selectedPlanDtls.paymenttype ? selectedPlanDtls.paymenttype : txData.priceType;
      selectedPlan = selectedPlanDtls.plan;
      if (txData.priceList[selectedPlan]) {
        selectedPriceId = selectedPriceType == "month" ? txData.priceList[selectedPlan].month : txData.priceList[selectedPlan].year;
      } else {
        da.setSnackbar(
          "Price is not listed in the pricing table",
          "error"
        );
        handleReset();
        return;
      }
      const trial = appssubs2[selectedAppSubKey].trial;
      const createdAt = selectedPlanDtls.createdAt ? new Date(selectedPlanDtls.createdAt) : /* @__PURE__ */ new Date();
      trialExpiryDate = new Date(createdAt.getTime() + trial * 24 * 60 * 60 * 1e3);
      selectedPlanInfo = getPlanInfo(appssubs2, selectedAppSubKey, selectedPlanDtls.plan);
      setTxData({
        ...txData,
        app: selectedApp,
        plan: selectedPlan,
        priceType: selectedPriceType,
        priceId: selectedPriceId,
        appKey: selectedAppSubKey,
        trialExpiry: trialExpiryDate,
        planDtls: selectedPlanDtls,
        planInfo: selectedPlanInfo
      });
    }
  };
  const handlePriceTypeChange = (event2) => {
    const selectedPriceType = event2.target.checked ? "year" : "month";
    const selectedPriceId = selectedPriceType == "month" ? txData.priceList[txData.plan].month : txData.priceList[txData.plan].year;
    setTxData({
      ...txData,
      priceType: selectedPriceType,
      priceId: selectedPriceId
    });
  };
  let planSelectionHtml = null;
  let planEnrolledtsHtml = null;
  let planTrialExpiryHtml = null;
  let planSubscriptionsHtml = null;
  let planAmountHtml = null;
  let planAmountYearHtml = null;
  let planPricePerSeatHtml = null;
  let inviteCodeHtml = null;
  if (txData.plan) {
    const { partApp, partPlan, partId } = pymtUtil.splitPlanInfo(txData.plan);
    if (action === "add") {
      planSelectionHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: "1rem", marginBottom: 0 }, children: [
        " Plan: ",
        partPlan,
        " "
      ] });
      planEnrolledtsHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: 0, marginBottom: 0 }, children: [
        " Enrolled: ",
        new Date(txData.planDtls.enrollts).toLocaleDateString(),
        " "
      ] });
      planTrialExpiryHtml = txData.trialExpiry ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: 0, marginBottom: 0 }, children: [
        " Trial Expiry: ",
        txData.trialExpiry.toLocaleDateString(),
        " "
      ] }) : null;
      inviteCodeHtml = txData.planDtls.invitecode ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: "1rem", marginBottom: 0 }, children: [
        " Invite Code: ",
        txData.planDtls.invitecode,
        " "
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { marginTop: "1rem", marginBottom: 0 }, children: " Invite Code: None " });
      planAmountHtml = txData.planInfo.price ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: "1rem", marginBottom: 0 }, children: [
        " Amount: ",
        txData.planInfo.price,
        " "
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { marginTop: 0, marginBottom: 0 }, children: " Amount: Unknown " });
      planAmountYearHtml = txData.planInfo.priceYear ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: "1rem", marginBottom: 0 }, children: [
        " Amount: ",
        txData.planInfo.priceYear,
        " "
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { marginTop: 0, marginBottom: 0 }, children: " Amount: Unknown " });
      planPricePerSeatHtml = txData.planInfo.pricePerSeat ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: "0rem", marginLeft: "4rem", marginBottom: 0 }, children: [
        "  ",
        txData.planInfo.pricePerSeat,
        " "
      ] }) : null;
    } else {
      planSelectionHtml = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: "1rem", marginBottom: 0 }, children: [
        " Plan: ",
        partPlan,
        " "
      ] });
      planSubscriptionsHtml = txData.planDtls.paymentts ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { marginTop: "1rem", marginBottom: 0 }, children: [
        " Subscription Setup: ",
        new Date(txData.planDtls.paymentts).toLocaleDateString(),
        " "
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { marginTop: 0, marginBottom: 0 }, children: " Subscription Setup: Unknown " });
    }
  }
  let priceTypeSwitchHtml = null;
  let pymtDisclaimerHtml = null;
  if (txData.app && action === "add") {
    priceTypeSwitchHtml = txData.plan && txData.planInfo.priceYear ? /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchComp, { ...{
      format: "form",
      items: null,
      bucket: {
        p: null,
        id: "monthyear",
        label: "Month/Year",
        name: "monthyear",
        variant: "filled",
        leftLabel: "Monthly",
        rightLabel: "Annually",
        color: "secondary",
        checked: txData.priceType == "year",
        handleChange: handlePriceTypeChange,
        inputProps: { "aria-label": "controlled" },
        helperText: "Please select subscription type",
        margin: "normal"
      }
    } }) : null;
    pymtDisclaimerHtml = txData.priceType === "month" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: " Monthly subscription bill date is 1st of the month. The first bill may be prorated." }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: " Annual subscription bill date is 1st of July. The first bill may be prorated." });
  }
  let appSelectListHtml = null;
  let optionsTextFieldAppSelect, items;
  if (action === "add") {
    items = registeredApps.map((availapp, i) => {
      return { code: availapp, display: availapp, bucket: { id: i } };
    });
    optionsTextFieldAppSelect = {
      format: "form",
      items,
      bucket: {
        p: null,
        id: "application",
        label: "Application",
        name: "application",
        type: "select",
        variant: "filled",
        isSelect: true,
        isNative: false,
        handleChange: (event2) => {
          handleApps(event2);
        },
        currentSelectionValue: txData.app,
        helperText: "Please select your application",
        margin: "normal",
        autoComplete: ""
      }
    };
    appSelectListHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...optionsTextFieldAppSelect });
  } else {
    items = subscribedApps.map((availapp, i) => {
      return { code: availapp, display: availapp, bucket: { id: i } };
    });
    optionsTextFieldAppSelect = {
      format: "form",
      items,
      bucket: {
        p: null,
        id: "application",
        label: "Application",
        name: "application",
        type: "select",
        variant: "filled",
        isSelect: true,
        isNative: false,
        handleChange: (event2) => {
          handleApps(event2);
        },
        currentSelectionValue: txData.app,
        helperText: "Please select your application",
        margin: "normal",
        autoComplete: ""
      }
    };
    appSelectListHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldComp, { ...optionsTextFieldAppSelect });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, "data-where": "SubscriptionsInfo", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, sx: { p: "0,1" }, children: appSelectListHtml }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12, md: 6 }, sx: { p: "0,1" }, children: [
      fullNameHtml,
      phoneHtml,
      emailHtml,
      planSelectionHtml,
      planEnrolledtsHtml,
      planTrialExpiryHtml,
      planSubscriptionsHtml,
      inviteCodeHtml,
      txData.priceType == "month" ? planAmountHtml : planAmountYearHtml,
      planPricePerSeatHtml,
      priceTypeSwitchHtml,
      pymtDisclaimerHtml
    ] })
  ] });
}
function SubscriptionsStripe(props) {
  useTheme();
  const { appState, dispatch } = useAppContext();
  const stripeMode = appState.isDev && "send";
  const {
    da,
    accountApps,
    txData,
    setTxData,
    action,
    setAction,
    handleReset
  } = props;
  const [warning, setWarning] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);
  const [actionStatus, setActionStatus] = useState("");
  const [userCheckReasons, setUserCheckReasons] = useState(/* @__PURE__ */ new Set());
  const stripe = useStripe();
  const elements = useElements();
  if (!stripe || !elements) {
    console.warn("SubscriptionsStripe: stripe/elements NOT SETUP yet");
    return /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: "SubscriptionsStripe: stripe/elements NOT SETUP yet" });
  }
  const reasons = [
    "Some features are missing",
    "Ease of use was less than expected",
    "Quality was less than expected",
    "Customer service was less than expected",
    "It’s too expensive",
    "I’m switching to a different service",
    "I don’t use the service enough",
    "Other reason"
  ];
  const handleMakePayment = async (e) => {
    e.preventDefault();
    setWarning("");
    try {
      const submitResp = await elements.submit();
      if (submitResp.error) {
        setWarning("Please provide payment details");
        return;
      }
      setWarning("");
      const result = await da.serverio.makePayment({
        name: txData.userDtls.fullName,
        phone: txData.userDtls.phone,
        email: txData.userDtls.email,
        app: txData.app,
        plan: txData.plan,
        priceId: txData.priceId,
        priceType: txData.priceType,
        amount: txData.priceType == "month" ? txData.planInfo.price : txData.planInfo.priceYear,
        amountPerSeat: txData.planInfo.pricePerSeat,
        trialExpiry: txData.trialExpiry.getTime(),
        stripeMode
      });
      if (result.data && result.data.clientSecret) {
        if (!result.data.clientSecret.startsWith("no-cs-returned")) {
          const confirmIntent = result.data.type === "setup" ? stripe.confirmSetup : stripe.confirmPayment;
          const confirm = await confirmIntent({
            elements,
            clientSecret: result.data.clientSecret,
            confirmParams: {
              return_url: `${window.location.origin}?nav=subscriptions`
            }
          });
          if (confirm.error) {
            setWarning("Unable to process payments - confirmation failed.");
            return;
          }
        }
        setActionStatus("added");
      }
      setWarning(result.data.message);
      return;
    } catch (err) {
      console.error(err);
      setWarning("Payment processing failed! " + err.message);
    }
  };
  const handleRemovePayment = async (e) => {
    e.preventDefault();
    setWarning("");
    try {
      const comments = Array.from(userCheckReasons).map((i) => reasons[i]).join(", ");
      const result = await da.serverio.removePayment({
        name: txData.userDtls.fullName,
        phone: txData.userDtls.phone,
        email: txData.userDtls.email,
        app: txData.app,
        plan: txData.plan,
        priceId: txData.priceId,
        priceType: txData.priceType,
        paymentId: txData.planDtls.paymentid,
        amount: txData.priceType == "month" ? txData.planInfo.price : txData.planInfo.priceYear,
        trialExpiry: txData.trialExpiry.getTime(),
        comments,
        stripeMode
      });
      setWarning(result.data.message);
      if (result && !result.ok) {
        return;
      } else {
        setActionStatus("removed");
      }
    } catch (err) {
      console.error(err);
      setWarning("Payment processing failed! " + err.message);
    }
  };
  const handleCancel = (e) => {
    e.preventDefault();
    handleReset();
  };
  const warningHtml = warning ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert$1, { severity: "warning", children: [
    " ",
    warning,
    " "
  ] }) : null;
  let addPaymentHtml = null;
  let addPaymentConfirmHtml = null;
  let removePaymentHtml = null;
  let removePaymentConfirmHtml = null;
  let removalReasonHtml = null;
  if (action === "add") {
    addPaymentHtml = actionStatus !== "added" && txData.plan && txData.priceId ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentElement, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: warningHtml }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: handleCancel,
            style: {
              backgroundColor: "#A35BFF",
              borderRadius: "3px",
              color: "white",
              border: 0,
              padding: "12px 16px",
              marginTop: "32px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease"
            },
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: handleMakePayment,
            style: {
              backgroundColor: "#635BFF",
              borderRadius: "3px",
              color: "white",
              border: 0,
              padding: "12px 16px",
              marginTop: "32px",
              float: "right",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease"
              //display: 'block',
              //&&:hover filter: 'contrast(115%)'
              //button:active {
              //transform: translateY(0px) scale(0.98);
              //filter: brightness(0.9);
              //}
              //button:disabled {
              //opacity: 0.5;
              //cursor: none;
              //}
            },
            children: "ADD SUBSCRIPTION"
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { marginTop: "1.0rem", fontSize: "0.7rem", padding: "0.0rem", fontWeight: "300" }, children: "Our payments processor Stripe collects information on customer interactions to provide services to you, prevent fraud, and improve its services. This includes using cookies and IP addresses to identify what a customer saw and used during a checkout session." })
    ] }) : null;
    addPaymentConfirmHtml = actionStatus == "added" && txData.plan && txData.priceId ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Subscription payment successfully processed." }) : null;
  } else {
    const handleReasonChange = (e) => {
      const i = event.target.value;
      if (event.target.checked) {
        setUserCheckReasons(/* @__PURE__ */ new Set([...userCheckReasons, i]));
      } else {
        userCheckReasons.delete(i);
        setUserCheckReasons(/* @__PURE__ */ new Set([...userCheckReasons, i]));
      }
    };
    const items = reasons.map((reason, i) => {
      const isChecked = userCheckReasons[i];
      return {
        code: i,
        display: reason,
        bucket: {
          id: i,
          checked: isChecked
          /* checkedIcon: null, icon: null, color: '', disabled: false, 
          indeterminate: false, size: 'medium', className: '' */
        }
      };
    });
    const optionsReason = {
      format: "form",
      items,
      bucket: {
        inlined: false,
        //usrStyle: {},
        type: "check",
        color: "primary",
        id: "reasons",
        //inputProps: {},
        handleChange: (e) => handleReasonChange(),
        //size: 'medium',
        //	  value: 
        //variant: 'filled',
        label: "",
        helperText: ""
      }
    };
    const reasonsHtml = /* @__PURE__ */ jsxRuntimeExports.jsx(MuiCheckRadioSwitch, { ...optionsReason });
    removalReasonHtml = actionStatus !== "removed" && txData.plan && txData.priceId ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", color: "textPrimary", sx: { minHeight: "1rem" }, children: "Reason for removal" }),
      reasonsHtml
    ] }) : null;
    removePaymentHtml = actionStatus !== "removed" && txData.plan && txData.priceId ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: " Are you sure you want to remove above subscription?" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " Subscription removal will reset your account to 'Basic' plan and may prevent access to critical features." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " To change your plan with minimal disruption 1) Remove subscription 2) Remove plan 3) Re-register to your preferred plan 4) Resubscribe to your preferred plan." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: " Removal will be effective as of next billing period. No refunds are issued for monthly plans and refunds for an annual plan are processed upon a request after prorating usage per monthly rate and deducting administrative services fees. Please contact us for details." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: removalReasonHtml }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: warningHtml }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: handleCancel,
            style: {
              backgroundColor: "#A35BFF",
              borderRadius: "3px",
              color: "white",
              border: 0,
              padding: "12px 16px",
              marginTop: "32px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease"
            },
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: handleRemovePayment,
            disabled: !userCheckReasons.size,
            style: {
              backgroundColor: "#635BFF",
              borderRadius: "3px",
              color: "white",
              border: 0,
              padding: "12px 16px",
              marginTop: "32px",
              float: "right",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease"
              //display: 'block',
              //&&:hover filter: 'contrast(115%)'
              //button:active {
              //transform: translateY(0px) scale(0.98);
              //filter: brightness(0.9);
              //}
              //button:disabled {
              //opacity: 0.5;
              //cursor: none;
              //}
            },
            children: "REMOVE SUBSCRIPTION"
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { marginTop: "1.0rem", fontSize: "0.7rem", padding: "0.0rem", fontWeight: "300" }, children: "Our payments processor Stripe collects information on customer interactions to provide services to you, prevent fraud, and improve its services. This includes using cookies and IP addresses to identify what a customer saw and used during a checkout session." })
    ] }) : null;
    removePaymentConfirmHtml = actionStatus == "removed" && txData.plan && txData.priceId ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Subscription payment successfully removed." }) : null;
  }
  if (action == "add") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      addPaymentHtml,
      addPaymentConfirmHtml
    ] });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      removePaymentHtml,
      removePaymentConfirmHtml
    ] });
  }
}
const FormBuildPageLayout = (props) => {
  const {
    tabs,
    instanceName,
    buildTraversalCtnr,
    buildSourceActive,
    itemListActionToolbarCtnrSave,
    itemListActionToolbarCtnrAction,
    buildCreateVersion,
    buildDeleteVersion,
    //formToolbarHtml,
    formCtnrHtml,
    formPropEditorCtnr,
    isConfigViewItems: isConfigViewItems2,
    isShowFormToolbar,
    mode,
    store
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, "data-where": "BuildPage", sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MainSnackbarComp, { da: store }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 4, lg: 3 }, "data-where": "BuildPage-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { p: 0, m: "0 0 2 0" }, elevation: 3, children: tabs }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 12, md: 8, lg: 9 }, "data-where": "BuildPage-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 1 }, elevation: 3, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "subtitle1", gutterBottom: true, children: [
          buildTraversalCtnr,
          buildSourceActive
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { display: "flex", alignItems: "center", mt: 1, mb: 1 }, children: [
          itemListActionToolbarCtnrSave,
          buildCreateVersion,
          buildDeleteVersion
        ] })
      ] }),
      isShowFormToolbar ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, size: { xs: 12 }, sx: { mt: 2, mb: 2 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { size: { xs: 12 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { padding: "4px 32px 0 8px", fontSize: "1.2rem" }, children: mode }),
        itemListActionToolbarCtnrAction
      ] }) }) }) : null,
      formCtnrHtml ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 1 }, elevation: 3, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: instanceName }),
        formCtnrHtml
      ] }) }) : null,
      !isConfigViewItems2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { marginTop: "16px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 1 }, elevation: 3, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", align: "center", gutterBottom: true, children: instanceName }),
        formPropEditorCtnr
      ] }) }) : null
    ] }) })
  ] });
};
const FormPreviewPageLayout = (props) => {
  const { formHeader, previewItemListCtnr } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paper,
    {
      sx: {
        p: 4,
        mt: 0
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: formHeader }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: previewItemListCtnr }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { fontSize: "10px" }, children: "Note: Submit is disabled in preview mode" })
      ] })
    }
  );
};
const useStyles$c = (theme) => ({
  root: {
    padding: theme.spacing(4),
    marginTop: theme.spacing(0)
  }
});
const FormSubmissionsPageLayout = (props) => {
  const {
    tableComp
  } = props;
  const theme = useTheme();
  useStyles$c(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paper,
    {
      sx: {
        p: 4,
        mt: 0
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, spacing: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: tableComp }) })
    }
  );
};
const FormNoDataLayout = (props) => {
  const {
    title,
    tip,
    msgList
  } = props;
  const msgListHtml = msgList && msgList.map((msg, i) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { children: msg }, `msg-${i}`);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paper, { sx: { p: 2, mt: 0 }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h4", gutterBottom: true, align: "center", title: tip, children: title }),
    msgList && msgList.length ? msgListHtml : null
  ] }) }) });
};
const FormLibraryPageLayout = (props) => {
  const {
    listCreateFormComp,
    createBtn,
    search,
    url,
    cardCtnr,
    alert: alert2,
    shareForm: shareForm2,
    formNoDataLayout
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Paper,
    {
      sx: {
        p: 1,
        mt: 0
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 1, "data-where": "FormLibraryPageLayout", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, "data-where": "CreateFormBtn", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              style: {
                marginTop: "8px",
                marginRight: "16px"
              },
              children: listCreateFormComp
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, "data-where": "Search", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              style: {
                width: "100%"
              },
              children: search
            }
          ) }),
          url ? /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, "data-where": "FormUrl", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              style: {
                height: "42px",
                display: "flex",
                alignItems: "center",
                marginTop: 0
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { fontSize: "1.4rem", marginRight: "1.4rem" }, children: " URL: " }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { fontSize: "1.2rem" }, children: url }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Link$1,
                  {
                    target: "_blank",
                    style: {},
                    to: shareForm2 || "unknown",
                    rel: "noopener",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: "AttachEmail", sx: { ml: 1, color: "primary.main" } })
                  }
                )
              ]
            }
          ) }) : null,
          cardCtnr,
          alert2
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, sx: { mt: 1 }, "data-where": "NoData", children: formNoDataLayout })
      ]
    }
  );
};
const CommonHomePageLayout = (props) => {
  const { image: image2, appName, pwa } = props;
  const titleStyle = {
    padding: "32px",
    marginTop: "0px",
    backgroundImage: `url(${image2})`,
    //opacity: 0.7,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    fontFamily: "Lato",
    fontSize: "4em",
    color: "white",
    backgroundColor: "#010005",
    backgroundPosition: "right",
    objectFit: "cover",
    width: "100%",
    height: "450px"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RaisedComp, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { ...titleStyle }, children: appName }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: pwa })
  ] });
};
const LnchLaunchPageLayout = (props) => {
  const { formHeader, previewItemListCtnr, marketingMsg } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paper,
    {
      sx: {
        p: 4,
        mt: 0
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 2, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: formHeader }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: previewItemListCtnr }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12 }, children: marketingMsg })
      ] })
    }
  );
};
const ExpandMoreIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
const useStyles$b = (theme) => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
    //theme.typography.fontWeightRegular,
    padding: "0px",
    margin: "0px"
  }
});
function MuiAccordion({ format, items, bucket }) {
  const theme = useTheme();
  const classes = useStyles$b(theme);
  const expPanels = items.map((item, i) => {
    let accordionProps = {};
    if (item.bucket.isExpanded) {
      accordionProps.defaultExpanded = true;
    }
    return /* @__PURE__ */ createElement(
      Accordion,
      {
        "data-where": "MuiAccordion",
        sx: { backgroundColor: theme.custom.contentpanelBG },
        ...accordionProps,
        key: i
      },
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AccordionSummary,
        {
          expandIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandMoreIcon, {}),
          "aria-controls": item.code + "-content",
          id: item.code + "-header",
          sx: { pt: 0, pb: 0, margin: "0px !important", fontSize: "1.2rem" },
          children: item.display
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDetails, { sx: { pt: 0, pb: 0 }, children: item.bucket.children })
    );
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.root, children: expPanels });
}
const Transition = React__default.forwardRef(function Transition2(props, ref) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Slide, { direction: "up", ref, ...props });
});
function Alert({ format, bucket }) {
  const [open, setOpen] = React__default.useState(bucket.state);
  function handleModalClose() {
    setOpen(false);
    bucket.handleReject(bucket.p);
  }
  function handleModalAccept() {
    setOpen(false);
    bucket.handleAccept(bucket.p);
  }
  function handleModalReject() {
    setOpen(false);
    bucket.handleReject(bucket.p);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Dialog,
    {
      open: bucket.state,
      TransitionComponent: Transition,
      keepMounted: true,
      onClose: handleModalClose,
      "aria-labelledby": "alert-dialog-slide-title",
      "aria-describedby": "alert-dialog-slide-description",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(DialogTitle, { id: "alert-dialog-slide-title", children: bucket.question }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContentText, { id: "alert-dialog-slide-description", children: bucket.content }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(DialogActions, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleModalReject, color: "primary", children: bucket.reject }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleModalAccept, color: "primary", children: bucket.accept })
        ] })
      ]
    }
  ) });
}
function SliderComp({ format, bucket }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slider,
    {
      color: bucket.color,
      value: bucket.value,
      size: bucket.size,
      onChange: bucket.handleChange,
      "aria-labelledby": bucket.ariaLabelledBy,
      orientation: bucket.orientation,
      valueLabelDisplay: bucket.valueLabelDisplay,
      step: bucket.step,
      min: bucket.min,
      max: bucket.max,
      sx: { ...bucket.usrStyle }
    }
  );
}
function ToggleComp({ format, items, bucket }) {
  const toggleButtons = items.map((item, i) => {
    if (item.icon) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(ToggleButton, { value: item.code, children: [
        item.icon,
        " ",
        item.display
      ] }, "toggle-" + i);
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ToggleButton, { value: item.code, sx: { ...item.bucket.usrStyle }, children: item.display }, "toggle-" + i);
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ToggleButtonGroup,
    {
      color: bucket.color,
      value: bucket.value,
      size: bucket.size,
      exclusive: true,
      onChange: bucket.handleChange,
      "aria-label": bucket.ariaLabelledby,
      orientation: bucket.orientation,
      sx: { ...bucket.usrStyle },
      children: toggleButtons
    }
  );
}
function SwitchComp({ format, items, bucket }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: bucket.leftLabel }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Switch,
      {
        color: bucket.color,
        checked: bucket.checked,
        onChange: bucket.handleChange,
        inputProps: { ...bucket.inputProps }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: bucket.rightLabel })
  ] });
}
const LinkBlock = (props) => {
  let { header, url, txt } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
    padding: "40px",
    background: "#f7dfee",
    textAlign: "center",
    margin: "60px",
    border: "10px solid #f44d89"
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { style: {
      font: {
        size: "40px",
        weight: 900
      },
      color: "#24292e"
    }, children: header }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        href: url,
        target: "_blank",
        style: {
          color: "#24292e",
          "&:hover": {
            opacity: 0.5
          }
        },
        children: txt
      }
    )
  ] });
};
const ArrowDropDownIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "m7 10 5 5 5-5z"
}), "ArrowDropDown");
function ButtonMenuCtnr({ format, items, bucket }) {
  const [open, setOpen] = React__default.useState(false);
  const anchorRef = React__default.useRef(null);
  const [selectedIndex, setSelectedIndex] = React__default.useState(bucket.selection || 0);
  function handleClick() {
  }
  function handleMenuItemClick(event2, index) {
    bucket.handleSelection(event2, bucket.p, items[index], index);
    setSelectedIndex(index);
    setOpen(false);
  }
  function handleToggle() {
    setOpen((prevOpen) => !prevOpen);
  }
  function handleClose(event2) {
    if (anchorRef.current && anchorRef.current.contains(event2.target)) {
      return;
    }
    setOpen(false);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ButtonGroup,
      {
        variant: "contained",
        color: "primary",
        ref: anchorRef,
        "aria-label": "Split button",
        sx: { ...bucket.sysStyle },
        "data-where": `ButtonMenuCtnr`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleClick, children: items[selectedIndex] && items[selectedIndex].display || " " }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              color: bucket.color,
              variant: bucket.variant,
              size: bucket.size,
              "aria-owns": open ? "menu-list-grow" : void 0,
              "aria-haspopup": "true",
              onClick: handleToggle,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowDropDownIcon, {})
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popper,
      {
        open,
        anchorEl: anchorRef.current,
        transition: true,
        Disableportal: true,
        sx: { ...bucket.sysStyle },
        children: ({ TransitionProps, placement }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Grow,
          {
            ...TransitionProps,
            style: {
              transformOrigin: placement === "bottom" ? "center top" : "center bottom"
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { id: "menu-list-grow", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClickAwayListener, { onClickAway: handleClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList, { children: items.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              MenuItem,
              {
                color: item.bucket.color,
                variant: item.bucket.variant,
                selected: index === selectedIndex,
                onClick: (event2) => handleMenuItemClick(event2, index),
                children: item.display
              },
              item.code
            )) }) }) })
          }
        )
      }
    )
  ] });
}
function ButtonGroupCtnr({ format, items, bucket }) {
  const renderedButtons = items.map((item, i) => {
    if (!item.bucket) {
      item.bucket = { color: "primary", variant: "contained" };
    } else {
      if (!item.bucket.color || item.bucket.color == "#000000" || item.bucket.color == "default") {
        console.log("COLOR CHANGED TO primary");
        item.bucket.color = "primary";
      }
      if (!item.bucket.variant) item.bucket.variant = "contained";
    }
    if (item.bucket.size != "small" && item.bucket.size != "medium" && item.bucket.size != "large") {
      item.bucket.size = "medium";
    }
    let isDisabled = item.bucket?.handleCheckDisabled(bucket.p, item, i) || false;
    if (item.bucket.type === "iconbutton") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        IconButton,
        {
          onClick: (event2) => bucket.handleClick(event2, bucket.p, item, i),
          sx: {
            ...item.bucket.iconStyle,
            ...item.bucket.sysStyle,
            ...item.bucket.usrStyle
          },
          color: item.bucket.color,
          disabled: isDisabled,
          title: item.bucket.tip || "",
          size: item.bucket.size,
          children: [
            item.bucket.iconLeft ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {}, title: item.display, children: item.bucket.iconLeft }) : null,
            item.bucket.iconRight ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {}, title: item.display, children: item.bucket.iconRight }) : null
          ]
        },
        item.code + "-" + i
      );
    } else if (item.bucket.type === "fab") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Fab,
        {
          onClick: (event2) => bucket.handleClick(event2, bucket.p, item, i),
          sx: {
            ...item.bucket.sysStyle,
            ...item.bucket.usrStyle
          },
          variant: item.bucket.variant,
          color: item.bucket.color,
          disabled: isDisabled,
          title: item.bucket.tip || "",
          children: [
            item.bucket.iconLeft ? item.bucket.iconLeft : "",
            item.display ? item.display : "",
            item.bucket.iconRight ? item.bucket.iconRight : ""
          ]
        },
        item.code + "-" + i
      );
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Button,
        {
          onClick: (event2) => bucket.handleClick(event2, bucket.p, item, i),
          sx: {
            ...item.bucket.btnStyle,
            ...item.bucket.sysStyle,
            ...item.bucket.usrStyle
          },
          variant: item.bucket.variant,
          color: item.bucket.color,
          size: item.bucket.size,
          disabled: isDisabled,
          title: item.bucket.tip,
          children: [
            item.bucket.iconLeft ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { marginTop: "12px", marginRight: "8px", marginBottom: "8px" }, title: item.display, children: item.bucket.iconLeft }) : null,
            item.display,
            item.bucket.iconRight ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {}, title: item.display, children: item.bucket.iconRight }) : null
          ]
        },
        item.code + "-" + i
      );
    }
  });
  if (bucket.variant != "outlined" && bucket.variant != "contained" && bucket.variant != "text") {
    bucket.variant = "contained";
  }
  if (bucket.size != "small" && bucket.size != "medium" && bucket.size != "large") {
    bucket.size = "medium";
  }
  if (bucket.label) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ButtonGroup,
      {
        variant: bucket.variant,
        size: bucket.size,
        "aria-label": bucket.size + " " + bucket.variant + " button group",
        fullWidth: bucket.fullWidth ? true : false,
        "data-where": `ButtonGroupCtnr}`,
        children: renderedButtons
      }
    );
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: renderedButtons });
  }
}
function MuiIconButton(props) {
  const { color: color2, onClick, size } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { color: color2, onClick, size });
}
const useStyles$a = (theme) => ({
  card: {
    maxWidth: 800,
    border: "1px solid transparent",
    "&:hover": {
      borderTop: `1px solid ${theme.palette.grey[200]}`,
      borderLeft: `1px solid ${theme.palette.grey[200]}`,
      borderRight: `1px solid ${theme.palette.grey[700]}`,
      borderBottom: `1px solid ${theme.palette.grey[700]}`
    },
    height: 500
  },
  media: {
    height: 0,
    paddingTop: "56.25%",
    // 16:9
    width: "100%",
    //height: 100%;
    objectFit: "cover",
    verticalAlign: "top",
    //backgroundSize: 'contain',
    //backgroundPosition: 'center',
    backgroundRepeat: "no-repeat"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  cardContent: {
    flexGrow: 1
  }
});
function CardComp({ format, bucket }) {
  const theme = useTheme();
  const classes = useStyles$a(theme);
  const [expanded, setExpanded] = React__default.useState(false);
  function handleExpandClick() {
    setExpanded(!expanded);
  }
  let icsx = expanded ? { ...classes.expand, ...classes.expandOpen } : { ...classes.expand };
  const expandButton = bucket.addlContent ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton,
    {
      sx: { icsx },
      onClick: handleExpandClick,
      "aria-expanded": expanded,
      "aria-label": "Show more",
      size: "large",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandMoreIcon, {})
    }
  ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  const collapseContent = bucket.addlContent ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { in: expanded, timeout: "auto", unmountOnExit: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardContent, { children: bucket.addlContent }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { sx: { ...classes.card, ...bucket.className }, "data-where": `CardComp`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CardActionArea, { onClick: (event2) => bucket.cardActionAreaHandler(event2), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CardHeader,
        {
          avatar: bucket.avatar,
          action: bucket.actionMenu,
          title: bucket.header,
          subheader: bucket.subheader,
          sx: { height: "100px" }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardMedia, { sx: { ...classes.media }, image: bucket.image, title: bucket.tip }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardContent, { sx: { ...classes.cardContent }, children: bucket.mainContent })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CardActions, { disableSpacing: true, children: [
      bucket.actionBar,
      expandButton
    ] }),
    collapseContent
  ] });
}
function CardCtnr({ format, items, bucket }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Grid,
    {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "stretch",
      sx: { p: 0, m: 0 },
      "data-where": "CardCtnr",
      spacing: 2,
      children: items
    }
  ) });
}
function MuiDrawer(props) {
  const { anchor, onClose, open, variant, sysStyle } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Drawer,
    {
      anchor,
      classes: { ...sysStyle },
      onClose,
      open,
      variant,
      children: props.children
    }
  );
}
function MuiDivider(props) {
  const { sysStyle } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { sx: { ...sysStyle } });
}
const renderItems = (items, bucket, theme) => {
  const localInputProps = { "aria-label": "checkbox" };
  const renderedItems = items && items.map((item, i) => {
    const id = item.bucket?.id + "-" + bucket.type || bucket.type;
    let generalProps = {};
    if (item.bucket.checkedIcon) generalProps.checkedIcon = item.bucket.checkedIcon;
    if (item.bucket.icon) generalProps.icon = item.bucket.icon;
    let controlled = null;
    if (bucket.type === "check") {
      controlled = /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox,
        {
          checked: item.bucket.checked,
          color: item.bucket.color,
          disabled: item.bucket.disabled,
          id,
          indeterminate: item.bucket.indeterminate,
          inputProps: localInputProps,
          onChange: (event2) => bucket.handleChange(event2, bucket.p, item, i),
          size: item.bucket.size,
          sx: {},
          value: item.code,
          name: id,
          title: item.bucket.tip || item.display,
          ...generalProps
        }
      );
    } else if (bucket.type === "radio") {
      controlled = /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio,
        {
          checked: item.bucket.checked,
          color: item.bucket.color,
          disabled: item.bucket.disabled,
          id,
          inputProps: localInputProps,
          onChange: (event2) => bucket.handleChange(event2, bucket.p, item, i),
          size: item.bucket.size,
          sx: {},
          value: item.code,
          name: id,
          title: item.bucket.tip || item.display,
          ...generalProps
        }
      );
    } else if (bucket.type === "switch") {
      controlled = /* @__PURE__ */ jsxRuntimeExports.jsx(
        Switch,
        {
          checked: item.bucket.checked || false,
          color: item.bucket.color,
          disabled: item.bucket.disabled,
          id,
          inputProps: localInputProps,
          onChange: (event2) => bucket.handleChange(event2, bucket.p, item, i),
          size: item.bucket.size,
          sx: {},
          value: item.code,
          name: id,
          title: item.bucket.tip || item.display,
          ...generalProps
        }
      );
    } else {
      console.error("MuiCheckRadioSwitch: renderItems() - Invalid bucket.type: " + bucket.type);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormControlLabel,
      {
        control: controlled,
        label: item.display,
        labelPlacement: item.bucket.labelPlacement || "start",
        sx: { ...item.bucket.className }
      },
      i
    );
  });
  return renderedItems;
};
const renderGroup = (renderedItems, bucket, theme) => {
  let renderedGroup = null;
  if (bucket.type === "check") {
    renderedGroup = /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormGroup,
      {
        row: bucket.inlined,
        children: renderedItems
      }
    );
  } else if (bucket.type === "radio") {
    renderedGroup = /* @__PURE__ */ jsxRuntimeExports.jsx(
      RadioGroup,
      {
        value: bucket.value,
        row: bucket.inlined,
        sx: {},
        children: renderedItems
      }
    );
  } else if (bucket.type === "switch") {
    renderedGroup = /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormGroup,
      {
        row: bucket.inlined,
        children: renderedItems
      }
    );
  } else {
    console.error("MuiCheckRadioSwitch: renderItems() - Invalid bucket.type: " + bucket.type);
  }
  return renderedGroup;
};
const renderLabel = (renderedGroup, bucket, theme) => {
  if (!bucket.label) {
    return renderedGroup;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    FormControl$1,
    {
      component: "fieldset",
      error: bucket.error,
      required: bucket.required,
      variant: bucket.variant || "standard",
      sx: { margin: theme.spacing(3) },
      "data-where": `MuiCheckRadioSwitch-${bucket.type}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormLabel,
          {
            component: "legend",
            children: bucket.label
          }
        ),
        renderedGroup,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormHelperText$1,
          {
            children: bucket.helperText
          }
        )
      ]
    }
  );
};
function MuiCheckRadioSwitch({ format, items, bucket }) {
  const theme = useTheme();
  const classRoot = bucket.inlined ? null : { display: "flex" };
  bucket?.sysStyle || {};
  bucket?.usrStyle || {};
  const renderedItems = renderItems(items, bucket);
  const renderedGroup = renderGroup(renderedItems, bucket);
  const renderedLabel2 = renderLabel(renderedGroup, bucket, theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...classRoot }, children: renderedLabel2 });
}
const useStyles$9 = (theme) => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
});
function FourColumnLayout({ format, bucket }) {
  const theme = useTheme();
  useStyles$9(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, "data-where": "ColumnLayout-4col", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, md: 3 }, sx: {}, children: bucket.children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, md: 3 }, sx: {}, children: bucket.children2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, md: 3 }, sx: {}, children: bucket.children3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 6, md: 3 }, sx: {}, children: bucket.children4 })
  ] });
}
function ThreeColumnLayout({ format, bucket }) {
  const theme = useTheme();
  useStyles$9(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, "data-where": "ColumnLayout-3col", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 4 }, sx: {}, children: bucket.children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 4 }, sx: {}, children: bucket.children2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 4 }, sx: {}, children: bucket.children3 })
  ] });
}
function TwoColumnLayout({ format, bucket }) {
  const theme = useTheme();
  useStyles$9(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, "data-where": "ColumnLayout-2col", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6 }, sx: {}, children: bucket.children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 6 }, sx: {}, children: bucket.children2 })
  ] });
}
function OneColumnLayout({ format, bucket }) {
  const theme = useTheme();
  useStyles$9(theme);
  bucket?.sysStyle || {};
  bucket?.usrStyle || {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: true, "data-where": "ColumnLayout-1col", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Grid,
    {
      size: { xs: 12 },
      sx: {
        //border: `1px solid ${theme.custom.border}`,
        marginBottom: "8px",
        ...bucket.sysStyle,
        ...bucket.usrStyle
      },
      children: bucket.children
    }
  ) });
}
const useStyles$8 = (theme) => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
});
function AsideBodyLayout({ format, bucket }) {
  const theme = useTheme();
  const classes = useStyles$8(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: classes.root, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: true, spacing: 3, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 3 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { ...classes.paper }, children: bucket.children }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, sm: 9 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { ...classes.paper }, children: bucket.children2 }) })
  ] }) });
}
const useStyles$7 = (theme) => ({
  paper: {
    padding: theme.spacing(1)
  }
});
function PaperLayout(props) {
  const theme = useTheme();
  const classes = useStyles$7(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, { sx: { ...classes.paper }, "data-where": `PaperLayout`, children: props.children });
}
function PanelLayout({ format, bucket }) {
  const useStyles3 = (theme2) => ({
    root: {
      padding: theme2.spacing(1),
      height: bucket.height
    },
    kiVert: {
      overflowY: "scroll"
    },
    kiHoriz: {
      overflowX: "scroll"
    }
  });
  const theme = useTheme();
  const classes = useStyles3(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Paper,
    {
      elevation: 3,
      sx: {
        ...classes.root,
        //borderTop: `1px solid ${theme.custom.border}`,
        marginBottom: "8px",
        ...bucket.sysStyle,
        ...bucket.usrStyle
      },
      "data-where": "PanelLayout",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: bucket.children }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: bucket.children2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: bucket.children3 })
      ]
    }
  );
}
function ListCtnr({ format, items, bucket }) {
  useTheme();
  const renderedList = items.map((item, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    ListItemButton,
    {
      onClick: (event2) => bucket.handleClick(event2, bucket.p, item, i),
      disabled: item.bucket.disabled,
      sx: { pt: 0, pb: 0 },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: item.display })
    },
    i
  ));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    List,
    {
      component: "nav",
      "aria-label": "Main mailbox folders",
      sx: { p: 0 },
      "data-where": `ListCtnr`,
      children: renderedList
    }
  );
}
const useStyles$6 = (theme) => ({
  root: {},
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0
  },
  icon: {
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1)
  }
});
function ListButtonCtnr({ format, items, bucket, className, ...rest }) {
  const theme = useTheme();
  const classes = useStyles$6(theme);
  const matchesUpMD = useMediaQuery((theme2) => theme2.breakpoints.up("md"));
  const renderedList = items.map((item, i) => {
    const display = matchesUpMD ? item.display : "";
    const isDisabled = bucket.checkDisabled(item.bucket.p, item, i);
    const buttonStyles = isDisabled ? { ...bucket.classNav, ...bucket.classActive } : bucket.classNav;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, { sx: { ...classes.item }, disableGutters: true, disabled: isDisabled, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Button,
      {
        sx: { ...buttonStyles },
        onClick: (event2) => bucket.handleClick(event2, item.bucket.p, item, i),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { ...classes.icon }, title: item.display, children: item.bucket.iconLeft }),
          display
        ]
      }
    ) }, i);
  });
  if (bucket.orientation === "vertical") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(List, { ...rest, sx: { ...classes.root, ...bucket.className }, children: renderedList });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      List,
      {
        component: Stack,
        direction: "row",
        ...rest,
        sx: { ...classes.root, ...bucket.className },
        "data-where": `ListButtonCtnr`,
        children: renderedList
      }
    );
  }
}
const useStyles$5 = (theme) => ({
  progress: {
    margin: theme.spacing(2)
  }
});
function CircularProgressComp({ format, items, bucket }) {
  const theme = useTheme();
  const classes = useStyles$5(theme);
  if (!bucket) {
    bucket = { color: "primary", variant: "determinate" };
  } else {
    if (!bucket.color) bucket.color = "primary";
    if (!bucket.variant) bucket.variant = "determinate";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { sx: { ...classes.progress }, color: bucket.color }) });
}
function LinearProgressComp({ format, items, bucket }) {
  useTheme();
  const progress = bucket.busy ? /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { flexGrow: 1, marginTop: "8px" }, "data-where": "LinearProgressComp", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgress, { color: bucket?.color || "primary" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { marginTop: "8px", height: "4px", flexGrow: 1 }, "data-where": "LinearProgressComp" });
  return progress;
}
const SearchIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");
const useStyles$4 = (theme) => ({
  root: {
    borderRadius: "4px",
    alignItems: "center",
    padding: theme.spacing(1),
    display: "flex",
    flexBasis: 420
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  input: {
    flexGrow: 1,
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "-0.05px"
  }
});
function SearchComp(props) {
  const { format, items, bucket, ...rest } = props;
  const theme = useTheme();
  const classes = useStyles$4(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Paper,
    {
      ...rest,
      sx: { ...classes.root, ...bucket.className },
      style: bucket.style,
      "data-where": `SearchComp`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { sx: { ...classes.icon } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Input$1, { ...rest, sx: { ...classes.input }, disableUnderline: true, onChange: bucket.handleChange })
      ]
    }
  );
}
const CheckCircleIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle");
const ErrorIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error");
const InfoIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), "Info");
const WarningIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "Warning");
const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};
const useStyles1 = (theme) => ({
  success: {
    backgroundColor: colors.green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.main,
    color: "primary.contrastText"
  },
  warning: {
    backgroundColor: colors.amber[700],
    color: "primary.contrastText"
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});
function SnackbarComp(props) {
  const theme = useTheme();
  const classes = useStyles1(theme);
  const { className, message, onClose, variant, duration: duration2, ...other } = props;
  const Icon2 = variantIcon[variant];
  const [open, setOpen] = React__default.useState(true);
  function handleClose(event2, reason) {
    if (reason === "clickaway") {
      return;
    }
    onClose();
    setOpen(false);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Snackbar,
    {
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      open,
      autoHideDuration: duration2,
      onClose: (event2, reason) => handleClose(event2, reason),
      TransitionProps: {
        onExit: onClose
      },
      "data-where": "SnackbarComp",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SnackbarContent,
        {
          "data-where": `SnackbarComp`,
          sx: { ...classes[variant], ...className },
          "aria-describedby": "client-snackbar",
          message: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { id: "client-snackbar", style: classes.message, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Icon2, { sx: { ...classes.icon, ...classes.iconVariant } }),
            message
          ] }),
          action: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                "aria-label": "Close",
                color: "inherit",
                onClick: onClose,
                size: "large",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { sx: { ...classes.icon } })
              },
              "close"
            )
          ],
          ...other
        }
      )
    }
  );
}
SnackbarComp.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["error", "info", "success", "warning"]).isRequired
};
function TabPanel$1(props) {
  const { children, value: value2, index, ...other } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      role: "tabpanel",
      hidden: value2 !== index,
      id: `full-width-tabpanel-${index}`,
      "aria-labelledby": `full-width-tab-${index}`,
      ...other,
      sx: { padding: "8px" },
      children: value2 === index && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", children }) })
    }
  );
}
function MuiTabs({ format, items, bucket }) {
  const theme = useTheme();
  const [value2, setValue2] = React__default.useState(bucket.selectPanel || 0);
  function handleChange(event2, newValue) {
    setValue2(newValue);
    const item = items[newValue];
    bucket.handleChange(event2, bucket.p, item, newValue);
  }
  const tabLabels = items.map((item, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(Tab, { label: item.display || `Tab Label ${i}`, id: "full-width-tab-" + i }, item.code));
  const tabPanels = items.map((item, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel$1, { index: i, value: value2, children: item.bucket.children }, item.code));
  let orientationStyle = {};
  if (bucket.isVertical)
    orientationStyle = { flexGrow: 1, bgcolor: "background.paper", display: "flex", pt: 2 };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box$1,
    {
      sx: {
        backgroundColor: theme.palette.background.paper,
        //borderTop: `1px solid ${theme.custom.border}`,   ends up adding border to Prop Editor and Form/Instance Editor
        //borderBottom: `1px solid ${theme.custom.border}`,
        marginBottom: "8px",
        ...orientationStyle,
        ...bucket.sysStyle,
        ...bucket.usrStyle
      },
      "data-where": "MuiTabs",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Tabs,
          {
            value: value2,
            onChange: handleChange,
            textColor: bucket.color == "primary" ? "primary" : "secondary",
            indicatorColor: bucket.color == "primary" ? "primary" : "secondary",
            variant: bucket.isFullWidth ? "fullWidth" : "scrollable",
            orientation: bucket.isVertical ? "vertical" : "horizontal",
            "data-where": "MuiTabs",
            children: tabLabels
          }
        ),
        tabPanels
      ]
    }
  );
}
const useStyles$3 = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper
    //width: 500,
  }
});
function TableComp({ format, items, bucket }) {
  const theme = useTheme();
  useStyles$3(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    MaterialTable,
    {
      title: bucket.title,
      columns: bucket.columns,
      data: bucket.cells,
      options: bucket.options
    }
  );
}
function TextFieldComp({ format, items, bucket }) {
  useTheme();
  const selectValue = bucket.currentSelectionValue || "";
  let tf;
  const type = bucket.type;
  const id = bucket.id + "-" + type;
  if (type === "button" || type === "checkbox" || type === "datetime" || type === "file" || type === "hidden" || type === "image" || type === "radio" || type === "reset" || type === "search" || type === "submit") {
    console.log("TextFieldComp: Unsupported type : " + type);
    tf = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      " Request for $",
      type,
      " TextFieldComp is not supported "
    ] });
    return tf;
  }
  const sysStyle = bucket?.sysStyle || {};
  const usrStyle = bucket?.usrStyle || {};
  const currentDateTime = (/* @__PURE__ */ new Date()).toISOString().substring(0, 16);
  let smartvalue = bucket.value;
  if (!bucket.value) {
    smartvalue = type === "color" ? "#ffffff" : type === "datetime-local" && bucket.isReadonly && (bucket.p.rendertype() === "preview" || // 'build'|'submit'|'preview'|'rawhtml'
    bucket.p.rendertype() === "submit") ? currentDateTime : "";
  }
  if (typeof smartvalue === "object") {
    smartvalue = JSON.stringify(smartvalue);
  }
  let smartLabel = bucket?.label;
  if (type === "range" && smartvalue || type === "color" && smartvalue) {
    smartLabel = smartLabel + " : " + smartvalue;
  }
  let startAdornment = null;
  if (bucket.adornStartIcon || bucket.adornStartText) {
    startAdornment = /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, { position: "start", children: bucket.adornStartIcon ? bucket.adornStartIcon : bucket.adornStartText });
  }
  let endAdornment = null;
  if (bucket.adornEndIcon || bucket.adornEndText) {
    endAdornment = /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, { position: "end", children: bucket.adornEndIcon ? bucket.adornEndIcon : bucket.adornEndText });
  }
  const wgtProps = {};
  if (bucket.max) wgtProps.max = bucket.max;
  if (bucket.maxLength) wgtProps.maxLength = bucket.maxLength;
  if (bucket.min) wgtProps.min = bucket.min;
  if (bucket.minLength) wgtProps.minLength = bucket.minLength;
  if (bucket.isMultiple) wgtProps.multiple = bucket.isMultiple;
  if (bucket.pattern) wgtProps.pattern = bucket.pattern;
  if (bucket.placeholder) wgtProps.placeholder = bucket.placeholder;
  if (bucket.isReadonly) wgtProps.readOnly = bucket.isReadonly;
  if (bucket.isRequired) wgtProps.required = bucket.isRequired;
  if (bucket.step) wgtProps.step = bucket.step;
  const tfProps2 = {};
  if (bucket.isDisableUnderline) tfProps2.disableUnderline = true;
  if (startAdornment) tfProps2.startAdornment = startAdornment;
  if (endAdornment) tfProps2.endAdornment = endAdornment;
  let labelProps2 = {};
  if (type === "number" || type === "date" || type === "month" || type === "datetime-local" || type === "week" || type === "time" || type === "range") {
    labelProps2.shrink = true;
  }
  if (bucket.isDisableAnimation) labelProps2.disableAnimation = true;
  let selectProps = {};
  let selectOptions = null;
  let selectiveProps = {};
  if (type === "select") {
    if (bucket.isSelect) {
      selectProps.native = bucket.isNative;
    }
    const handleSelectChange = (event2) => {
      bucket.handleChange(event2, bucket.p, null, null);
    };
    selectiveProps.onChange = (event2) => handleSelectChange(event2);
    selectiveProps.select = bucket.isSelect;
    selectiveProps.SelectProps = selectProps;
    selectiveProps.value = selectValue;
    if (bucket?.isNative) {
      selectOptions = items && items.map((item, i) => {
        const optionId = item.bucket?.id || bucket?.id + "-" + i || "xxx";
        return /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: item.display, id: optionId, children: item.display }, item.code);
      });
    } else {
      selectOptions = items && items.map((item, i) => {
        const optionId = item.bucket?.id || bucket?.id + "-" + i || "xxx";
        return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: item.code, id: optionId, children: item.display }, item.code);
      });
    }
  } else {
    selectiveProps.onChange = (event2) => bucket.handleChange(event2, bucket.p, null, null, event2.target.value);
    selectiveProps.value = smartvalue;
    if (bucket.isMultiline) {
      selectiveProps.multiline = true;
      if (bucket.rowsMin && bucket.rowsMax) {
        selectiveProps.maxRows = bucket.rowsMax;
        selectiveProps.minRows = bucket.rowsMin;
      } else {
        selectiveProps.rows = bucket.rows;
      }
    }
  }
  tf = /* @__PURE__ */ jsxRuntimeExports.jsxs(
    TextField,
    {
      autoComplete: bucket.autoComplete,
      autoFocus: bucket.isAutofocus,
      color: bucket.color,
      disabled: bucket.isDisabled,
      error: bucket.isError,
      fullWidth: bucket.isFullWidth,
      helperText: bucket.errorMsg || bucket.helperText,
      id,
      InputLabelProps: labelProps2,
      inputProps: wgtProps,
      InputProps: tfProps2,
      label: smartLabel,
      margin: bucket.margin || "normal",
      name: id,
      size: bucket.size,
      sx: { minWidth: "128px", ...sysStyle, ...usrStyle },
      type: bucket.type || "unknown",
      title: bucket.tip || "",
      variant: bucket.variant || "standard",
      onBlur: (event2) => bucket.handleBlur && bucket.handleBlur(event2, bucket.p, null, null),
      ...selectiveProps,
      "data-where": `TextFieldComp-${bucket.type}`,
      children: [
        selectOptions,
        "               // Only for the 'select' otherwise it's null"
      ]
    }
  );
  return tf;
}
function SelectComp({ format, items, bucket }) {
  useTheme();
  const selectValue = bucket.currentSelectionValue || "";
  let tf;
  const type = bucket.type;
  const id = bucket.id + "-" + type;
  console.log("SelectComp ---------------------- options:", items);
  const sysStyle = bucket?.sysStyle || {};
  const usrStyle = bucket?.usrStyle || {};
  bucket?.label;
  bucket.value;
  let startAdornment = null;
  if (bucket.adornStartIcon || bucket.adornStartText) {
    startAdornment = /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, { position: "start", children: bucket.adornStartIcon ? bucket.adornStartIcon : bucket.adornStartText });
  }
  let endAdornment = null;
  if (bucket.adornEndIcon || bucket.adornEndText) {
    endAdornment = /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, { position: "end", children: bucket.adornEndIcon ? bucket.adornEndIcon : bucket.adornEndText });
  }
  if (startAdornment) tfProps.startAdornment = startAdornment;
  if (endAdornment) tfProps.endAdornment = endAdornment;
  if (bucket.isDisableAnimation) labelProps.disableAnimation = true;
  let selectOptions = null;
  let selectiveProps = bucket.selectProps || {};
  if (type === "select") {
    if (bucket.isSelect) {
      selectiveProps.native = bucket.isNative;
    }
    const handleSelectChange = (event2) => {
      bucket.handleChange(event2, bucket.p, null, null);
    };
    selectiveProps.onChange = (event2) => handleSelectChange(event2);
    selectiveProps.select = bucket.isSelect;
    selectiveProps.value = selectValue;
    if (bucket?.isMultiple) {
      if (typeof selectValue == "string") {
        if (selectValue.indexOf(",") !== -1) {
          selectiveProps.value = selectValue.split(",");
        } else {
          selectiveProps.value = [selectValue];
        }
      } else if (Array.isArray(selectValue)) {
        selectiveProps.value = selectValue;
      } else {
        console.error(`SelectComp:select settings - Invalid selectValue type: ${typeof selectValue}`);
      }
    } else {
      selectiveProps.value = selectValue;
    }
    if (bucket?.isNative) {
      selectOptions = items && items.map((item, i) => {
        const optionId = item.bucket?.id || bucket?.id + "-" + i || "xxx";
        return /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: item.display, id: optionId, children: item.display }, item.code);
      });
    } else {
      selectOptions = items && items.map((item, i) => {
        const optionId = item.bucket?.id || bucket?.id + "-" + i || "xxx";
        return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: item.display, id: optionId, children: item.display }, item.code);
      });
    }
    console.log("SelectComp ---------------------- options:", selectOptions);
  } else {
    selectiveProps.onChange = (event2) => bucket.handleChange(event2, bucket.p, null, null, event2.target.value);
  }
  tf = /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl, { variant: bucket.variant, sx: { ...bucket.sx }, size: bucket.size, disabled: bucket.disabled, required: bucket.required, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { id: bucket.id, children: bucket.label }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Select,
      {
        labelId: id + "-label",
        id,
        value: bucket.value,
        onChange: bucket.handleChange,
        autoWidth: bucket.autoWidth,
        autoFocus: bucket.isAutofocus,
        color: bucket.color,
        disabled: bucket.isDisabled,
        error: bucket.isError,
        fullWidth: bucket.isFullWidth,
        margin: bucket.margin || "none",
        name: id,
        size: bucket.size,
        sx: { minWidth: "128px", ...sysStyle, ...usrStyle },
        type: bucket.type || "unknown",
        title: bucket.tip || "",
        variant: bucket.variant || "standard",
        onBlur: (event2) => bucket.handleBlur(event2, bucket.p, null, null),
        ...selectiveProps,
        "data-where": `SelectComp-${bucket.type}`,
        children: [
          selectOptions,
          "               // Only for the 'select' otherwise it's null"
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: bucket.helperText })
  ] });
  return tf;
}
const useStyles$2 = (theme) => {
  return {
    iconContainer: {
      "& .close": {
        opacity: 0.3
      }
    },
    group: {
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 1,
      width: "100%"
    },
    groupBorder: {
      // borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    root: {
      height: "auto",
      flexGrow: 1,
      maxWidth: [400, 600, 600, 600],
      margin: "5px"
    },
    selected: {
      color: "green",
      marginLeft: 2,
      width: 20,
      height: 20
    },
    unselected: {
      color: "red",
      marginLeft: 2,
      width: 20,
      height: 20
    }
  };
};
const Tree = (props) => {
  const { bitMap, categories, handleModelChange } = props;
  useTheme();
  const classes = useStyles$2();
  const [ctr, setCtr] = React__default.useState(0);
  const labelIcon = (item) => {
    const result = item.selection ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: item.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { title: "Click to check or uncheck", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Check, { sx: { ...classes.selected }, onClick: (event2) => handleClick(event2, item) }) })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: item.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { title: "Click to check or uncheck", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Clear, { sx: { ...classes.unselected }, onClick: (event2) => handleClick(event2, item) }) })
    ] });
    return result;
  };
  const percolate = (item, i) => {
    if (!item.category) {
      return !item.selection;
    }
    const isUnselectedChild = item.category.find((child) => {
      if (child.category) {
        return percolate(child);
      } else return !child.selection;
    });
    item.selection = !isUnselectedChild;
    return !item.selection;
  };
  const handleClick = (event2, item) => {
    item.selection = item.selection ? false : true;
    if (item.category) {
      item.category.forEach((cat) => cat.selection = item.selection);
    }
    percolate(categories);
    bitMapCheck(categories);
    setCtr(ctr + 1);
    handleModelChange();
    event2.stopPropagation();
  };
  const treeItems = (item, i) => {
    if (!item) return;
    const children = item.category && item.category.map((cat, i2) => {
      return treeItems(cat, i2);
    });
    const s = i === 0 ? (
      // to control extra left dashed border
      { ...classes.group, ...classes.iconContainer }
    ) : { ...classes.groupBorder, ...classes.group, ...classes.iconContainer };
    i = i + 1;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      TreeItem,
      {
        sx: { ...s },
        label: labelIcon(item),
        itemId: item.name.replaceAll(" ", "-"),
        children
      },
      item.name.replaceAll(" ", "-")
    );
  };
  const bitMapCheck = (item, i) => {
    if (!item) return;
    item.category && item.category.map((cat, i2) => {
      return bitMapCheck(cat);
    });
    bitMap[Number(item.reg)][Number(item.id)] = item.selection ? "1" : "0";
    return;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SimpleTreeView,
    {
      sx: { ...classes.root },
      children: treeItems(categories, 0)
    }
  );
};
function TabPanel(props) {
  const { children, value: value2, index, unqKey, ...other } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Typography,
    {
      component: "div",
      role: "tabpanel",
      hidden: value2 !== index,
      id: `vertical-tabpanel-${unqKey}-${index}`,
      "aria-labelledby": `vertical-tab-${unqKey}-${index}`,
      ...other,
      children: value2 === index && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...other.classeName }, children })
    }
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};
function a11yProps(index, unqKey) {
  return {
    id: `vertical-tab-${unqKey}-${index}`,
    "aria-controls": `vertical-tabpanel-${unqKey}-${index}`
  };
}
function TabComp({ items, bucket }) {
  const theme = useTheme();
  const matchesSMdown = useMediaQuery(theme.breakpoints.down("sm"));
  const [value2, setValue2] = React__default.useState(bucket.value);
  const unqKey = bucket.unqKey || "unqkey";
  const handleChange = (event2, newValue) => {
    setValue2(newValue);
    const item = items[newValue];
    bucket.onChange(event2, bucket.p, item, newValue);
  };
  const tabLabels = items.map((item, i) => {
    const tabIcon = matchesSMdown ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: item.icon, style: { verticalAlign: "middle", px: "8px", fontSize: "2.4rem" }, title: item.code }) : /* @__PURE__ */ jsxRuntimeExports.jsx(IconPalette$1, { name: item.icon, style: { verticalAlign: "middle", fontSize: "2.4rem" }, title: item.code });
    const tabLabel = matchesSMdown ? "" : item.code;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tab,
      {
        label: tabLabel,
        icon: tabIcon,
        "aria-label": item.display,
        sx: {
          minWidth: "40px",
          fontSize: { xs: "0.90rem", sm: "1.0rem", md: "1.2rem" },
          color: "primary.contrastText"
        },
        ...a11yProps(i, unqKey)
      },
      item.code
    );
  });
  const tabPanels = items.map((item, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    TabPanel,
    {
      value: value2,
      index: i,
      unqKey,
      sx: {
        border: "2px solid #cecece",
        xheight: { xs: "56vh", sm: "56vh", md: "56vh", lg: "56vh" },
        // Height of panel inside tab below nav
        width: "100%",
        overflowX: "hidden",
        xoverflowY: "scroll",
        overscrollBehaviorY: "contain",
        backgroundColor: theme.custom.contentpanelBG
      },
      children: item.bucket.children
    },
    "panel-" + i
  ));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: {
    flexGrow: 1,
    backgroundColor: theme.custom.contentpanelBG,
    display: "flex",
    marginTop: "8px",
    flexDirection: { xs: "column", sm: "column", md: "row" }
    // width: { xs: '93vw', sm: '95vw', md: '95vw', lg: '95vw', xl: '1500px' },   Comment out to accomodate Adverts. Let parent dictate width
  }, "data-where": "TabComp", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tabs,
      {
        orientation: bucket.orientation,
        variant: bucket.variant,
        textColor: "secondary",
        sx: {
          backgroundColor: theme.custom.contentpanelBG,
          marginRight: "0.4rem",
          minWidth: "10rem"
          // Required when tabs are verticle - for width of the gray tab area
        },
        value: value2,
        onChange: handleChange,
        "aria-label": bucket.ariaLabel || "Vertical tabs",
        children: tabLabels
      }
    ),
    tabPanels
  ] });
}
const NavItems = (props) => {
  const { navPaths, onClick, urlPathname, activeStyle, inactiveStyle } = props;
  const items = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: navPaths.map((pp) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      component: Link,
      href: pp.path,
      onClick: (e) => onClick(e, pp.path, pp),
      sx: {
        mt: 1,
        mr: 1,
        fontSize: "0.9rem",
        fontWeight: 500,
        color: pp.draft ? "error.light" : "primary.contrastText",
        "borderBottom": urlPathname && urlPathname === pp.path ? activeStyle : inactiveStyle,
        ":hover": { "borderBottom": activeStyle },
        letterSpacing: ".15rem"
      },
      children: pp.display
    },
    pp.path
  )) });
  return items;
};
({
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
});
const useStyles2 = (theme) => {
  return {
    table: {
      minWidth: 460
    }
  };
};
const MuiTableComp = (props) => {
  useTheme();
  const classes = useStyles2();
  const { bucket } = props;
  const rows = bucket.cells;
  const columns = bucket.columns;
  const rowsPerPageOptions = bucket.options.rowsPerPageOptions || [100];
  const onRowClickCB = bucket.onRowClickCB;
  const [page] = React__default.useState(0);
  const [rowsPerPage] = React__default.useState(rowsPerPageOptions[0]);
  const [rowSelection, setRowSelection] = React__default.useState(-1);
  const emptyRows = 0;
  const dumpColVal = (row, field, j) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TableCell, { component: "th", scope: "row", children: bucket.options.cellDataFormatter(row, field, row[field]) }, j);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TableContainer, { component: Paper, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table, { sx: { ...classes.table }, "aria-label": "custom pagination table", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TableHead, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TableRow, { children: columns.map((column) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      TableCell,
      {
        title: column.tip,
        align: column.align,
        style: { minWidth: column.minWidth },
        children: column.title
      },
      column.field
    )) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TableBody, { children: [
      (rowsPerPage > 0 && rows.length > rowsPerPage ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : rows).map((row, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableRow, { hover: true, selected: i === rowSelection ? true : false, onClick: () => {
        setRowSelection(i);
        onRowClickCB(row, i);
      }, children: columns.map((colObj, j) => dumpColVal(row, colObj.field, j)) }, i)),
      emptyRows > 0
    ] })
  ] }) });
};
const useStyles$1 = (theme) => {
  return {
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper
    },
    headers: {
      marginLeft: "0.8rem"
    }
  };
};
const MuiListComp = (props) => {
  const theme = useTheme();
  const classes = useStyles$1(theme);
  const { bucket } = props;
  const rows = bucket.cells;
  const onRowClickCB = bucket.onRowClickCB;
  const [rowSelection, setRowSelection] = React__default.useState(-1);
  const getPrimaryValue = (row, i) => {
    return bucket.options.primaryDataFormatter(row, i);
  };
  const getSecondaryValue = (row, i) => {
    return bucket.options.secondaryDataFormatter(row, i);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(List, { sx: { ...classes.root }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { component: "div", sx: { ...classes.headers }, children: bucket.columns }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { variant: "inset", component: "li", sx: { marginLeft: "0px" } }),
    rows.map((row, i) => {
      const primary = getPrimaryValue(row, i);
      const secondary = getSecondaryValue(row, i);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, { alignItems: "flex-start", selected: i === rowSelection ? true : false, onClick: () => {
          setRowSelection(i);
          onRowClickCB(row, i);
        }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary, secondary }) }),
        rows.length === i + 1 ? null : (
          // No underline for last entry
          /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { variant: "inset", component: "li", sx: { marginLeft: "0px" } })
        )
      ] }, i);
    })
  ] });
};
const MuiCard = (props) => {
  useTheme();
  const { img, alt, imgTitle = "", title = "", excerpt = "", updated, draft = false, agency } = props;
  const draftHtml = draft ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h5", color: "secondary", component: "h5", align: "center", gutterBottom: true, sx: {
    position: "absolute",
    top: "88%",
    left: "10%"
  }, children: "DRAFT" }) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { sx: {
    boxShadow: "0 10px 13px rgba(0,0,0,0.22), 0 11px 12px rgba(0,0,0,0.24)",
    "&:hover": {
      boxShadow: "0 20px 28px rgba(0,0,0,0.45), 0 20px 28px rgba(0,0,0,0.42)"
    },
    width: { xs: "88vw", sm: "260px", md: "280px", lg: "320px" },
    margin: { xs: "0.4rem", sm: "0.6rem", md: "0.8rem", lg: "1rem" }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardActionArea, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CardContent, { sx: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    height: { xs: "24rem", sm: "26rem", md: "26rem", lg: "28rem" }
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: {}, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        crossOrigin: "anonymous",
        src: img,
        alt,
        style: { width: "100%", height: "auto", maxWidth: "100%", maxHeight: "200px", objectFit: "contain" }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { padding: "1rem" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { gutterBottom: true, variant: "h5", component: "h2", sx: {
        fontWeight: 700,
        fontStyle: "black",
        fontSize: "1.4rem"
      }, children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", component: "p", children: excerpt }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography, { variant: "caption", component: "p", align: "right", sx: {
        position: "absolute",
        top: "90%",
        right: "10%",
        marginTop: "1rem"
      }, children: [
        agency ? agency + " - " : "",
        updated
      ] }),
      draftHtml
    ] })
  ] }) }) });
};
const filter = createFilterOptions();
const useStyles = (theme) => {
  return {
    option: {
      fontSize: 15,
      "& > span": {
        marginRight: 10,
        fontSize: 18
      }
    },
    vertContainer: {
      display: "flex",
      flexDirection: "column"
    },
    horizContainer: {
      display: "flex",
      flexDirection: "row",
      //justifyContent: 'space-evenly',
      flexWrap: "wrap",
      marginBottom: "16px"
    },
    autocomplete: {
      marginBottom: "8px",
      minWidth: "240px"
    }
  };
};
const MuiAutoComplete = (props) => {
  useTheme();
  const classes = useStyles();
  const defaultGetOptionLabel = (option) => {
    if (typeof option === "string") {
      return option;
    } else if (option && option.inputValue) {
      return option.inputValue;
    } else
      return "";
  };
  const defaultFilterOptions = (options22, params) => {
    const filtered = filter(options22, params);
    const { inputValue } = params;
    const isExisting = options22.some((option) => inputValue === option);
    if (inputValue !== "" && !isExisting) {
      filtered.push(`Add: "${inputValue}"`);
    }
    return filtered;
  };
  const defaultRenderOption = (props2, option) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { ...props2, children: option });
  };
  const defaultIsOptionEqualToValue = (option) => {
    return true;
  };
  const {
    usedBy,
    multiple,
    freeSolo = true,
    id,
    label: label2,
    title,
    selection,
    options: options2,
    displayLimit,
    onChangeCB,
    variant,
    isFullWidth,
    usrStyle = {},
    sysStyle = {},
    getOptionLabel = defaultGetOptionLabel,
    filterOptions = defaultFilterOptions,
    renderOption = defaultRenderOption,
    isOptionEqualToValue = defaultIsOptionEqualToValue,
    muiAutoCompStyle = {}
  } = props;
  const [stateWords, setStateWords] = useState(selection);
  const onChange = (event2, value2) => {
    setStateWords(value2);
    onChangeCB(event2, value2);
  };
  let moreProps = {};
  if (usedBy === "vehicles") {
    moreProps = { ...moreProps, isOptionEqualToValue: (option) => isOptionEqualToValue(option) };
  }
  if (usedBy !== "vehicles") {
    moreProps = { ...moreProps, filterOptions: (options22, params) => filterOptions(options22, params) };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { ...classes.horizContainer }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Autocomplete,
    {
      id,
      selectOnFocus: true,
      clearOnBlur: true,
      handleHomeEndKeys: true,
      title,
      multiple,
      freeSolo,
      value: selection,
      limitTags: displayLimit,
      onChange: (e, v) => onChange(e, v),
      options: options2,
      fullWidth: isFullWidth,
      getOptionLabel: (option) => getOptionLabel(option),
      sx: { ...classes.autocomplete, ...sysStyle, ...usrStyle },
      classes: { option: classes.option },
      autoHighlight: true,
      renderOption: (props2, option) => renderOption(props2, option),
      ...moreProps,
      renderInput: (params) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField,
        {
          ...params,
          label: label2,
          variant: variant ? variant : "standard",
          inputProps: { ...params.inputProps }
        }
      ),
      style: { ...muiAutoCompStyle }
    }
  ) });
};
const PersonAddIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m-9-2V7H4v3H1v2h3v3h2v-3h3v-2zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), "PersonAdd");
const GroupAddIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 1c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4m4.51-8.95C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95m4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17"
}), "GroupAdd");
const GroupIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), "Group");
const FaceIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25m6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8"
}), "Face");
const SupervisedUserCircleIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m3.61 6.34c1.07 0 1.93.86 1.93 1.93s-.86 1.93-1.93 1.93-1.93-.86-1.93-1.93c-.01-1.07.86-1.93 1.93-1.93m-6-1.58c1.3 0 2.36 1.06 2.36 2.36s-1.06 2.36-2.36 2.36-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36m0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68M11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09"
}), "SupervisedUserCircle");
const AccountCircleIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), "AccountCircle");
const LockIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1z"
}), "Lock");
const EmailIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"
}), "Email");
const LockRoundedIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2z"
}), "LockRounded");
const DesktopAccessDisabledRoundedIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M.31 2c-.39.39-.39 1.02 0 1.41l.69.68V16c0 1.1.9 2 2 2h7v2H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2h.9l5.29 5.29c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L1.72 2A.996.996 0 0 0 .31 2m2.68 13V6.09L12.9 16H3.99c-.55 0-1-.45-1-1M4.55 2l2 2H20c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1h-1.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
}), "DesktopAccessDisabledRounded");
const NoEncryptionRoundedIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66L20 17.56V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46zm-3.78-.49a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l1.33 1.33C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l.29.29c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41z"
}), "NoEncryptionRounded");
const SettingsBackupRestoreRoundedIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M11.77 3c-2.65.07-5 1.28-6.6 3.16L3.85 4.85c-.31-.31-.85-.09-.85.36V9.5c0 .28.22.5.5.5h4.29c.45 0 .67-.54.35-.85L6.59 7.59C7.88 6.02 9.82 5 12 5c4.32 0 7.74 3.94 6.86 8.41-.54 2.77-2.81 4.98-5.58 5.47-3.8.68-7.18-1.74-8.05-5.16-.12-.42-.52-.72-.96-.72-.65 0-1.14.61-.98 1.23C4.28 18.12 7.8 21 12 21c5.06 0 9.14-4.17 9-9.26-.14-4.88-4.35-8.86-9.23-8.74M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2"
}), "SettingsBackupRestoreRounded");
const SignalWifiOffIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27z"
}), "SignalWifiOff");
const CloudUploadIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), "CloudUpload");
const KeyboardVoiceIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3m5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72z"
}), "KeyboardVoice");
const CurrencyExchangeIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V5h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V19h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44M3 21H1v-6h6v2H4.52c1.61 2.41 4.36 4 7.48 4 4.97 0 9-4.03 9-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67zm-2-9C1 5.92 5.92 1 12 1c3.72 0 7.01 1.85 9 4.67V3h2v6h-6V7h2.48C17.87 4.59 15.12 3 12 3c-4.97 0-9 4.03-9 9z"
}), "CurrencyExchange");
const AttachMoneyIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4"
}), "AttachMoney");
const CheckIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
const AttachEmailIcon = createSvgIcon([/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M21 10V4c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2L1 16c0 1.1.9 2 2 2h11v-5c0-1.66 1.34-3 3-3zm-10 1L3 6V4l8 5 8-5v2z"
}, "0"), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M21 14v4c0 1.1-.9 2-2 2s-2-.9-2-2v-4.5c0-.28.22-.5.5-.5s.5.22.5.5V18h2v-4.5c0-1.38-1.12-2.5-2.5-2.5S15 12.12 15 13.5V18c0 2.21 1.79 4 4 4s4-1.79 4-4v-4z"
}, "1")], "AttachEmail");
const IconPalette$1 = (props) => {
  useTheme();
  const { name, ...rest } = props;
  let icon;
  switch (name) {
    case "Vehicles":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(DirectionsCar, { ...rest });
      break;
    case "Equipments":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Highlight$1, { ...rest });
      break;
    case "Child Safety Seats":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(EventSeat, { ...rest });
      break;
    case "Tires":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Adjust, { ...rest });
      break;
    case "Drugs":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(LocalHospital, { ...rest });
      break;
    case "Food":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(LocalGroceryStore, { ...rest });
      break;
    case "Veterinary":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Pets, { ...rest });
      break;
    case "Tobacco":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(SmokingRooms, { ...rest });
      break;
    case "Devices":
    case "Stethoscope":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Scanner, { ...rest });
      break;
    case "Digital":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Devices, { ...rest });
      break;
    case "Consumer Products":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(House, { ...rest });
      break;
    case "Biologics":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Colorize, { ...rest });
      break;
    case "Left":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(KeyboardArrowLeft, { ...rest });
      break;
    case "Right":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(KeyboardArrowRight, { ...rest });
      break;
    case "Down":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(KeyboardArrowDown, { ...rest });
      break;
    case "Up":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(KeyboardArrowUp, { ...rest });
      break;
    case "FirstPage":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(FirstPage, { ...rest });
      break;
    case "LastPage":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(LastPage, { ...rest });
      break;
    case "Category":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Category, { ...rest });
      break;
    case "Notification":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Notifications, { ...rest });
      break;
    case "Products":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(AddShoppingCart, { ...rest });
      break;
    case "Offline":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(OfflineBolt, { ...rest });
      break;
    case "Sell":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Sell, { ...rest });
      break;
    case "Info":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Info, { ...rest });
      break;
    case "Collections":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Collections, { ...rest });
      break;
    case "Dangerous":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(DangerousSharp, { ...rest });
      break;
    case "Call":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Call, { ...rest });
      break;
    case "Family":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(FamilyRestroom, { ...rest });
      break;
    case "Factory":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Factory, { ...rest });
      break;
    case "Business":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Business, { ...rest });
      break;
    case "Storefront":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Storefront, { ...rest });
      break;
    case "Menu":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$1, { ...rest });
      break;
    case "Home":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Home, { ...rest });
      break;
    case "Store":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Store, { ...rest });
      break;
    case "Clear":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Clear, { ...rest });
      break;
    case "Delete":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Delete, { ...rest });
      break;
    case "FileCopy":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(FileCopy, { ...rest });
      break;
    case "NoteAdd":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(NoteAdd, { ...rest });
      break;
    case "Save":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Save, { ...rest });
      break;
    case "Block":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Block, { ...rest });
      break;
    case "GridOn":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(GridOn, { ...rest });
      break;
    case "Web":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Web, { ...rest });
      break;
    case "Create":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Create, { ...rest });
      break;
    case "Dashboard":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Dashboard, { ...rest });
      break;
    case "People":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(People, { ...rest });
      break;
    case "ShoppingBasket":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(ShoppingBasket, { ...rest });
      break;
    case "TextFields":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(TextFields, { ...rest });
      break;
    case "Image":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Image, { ...rest });
      break;
    case "AccountBox":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(AccountBox, { ...rest });
      break;
    case "LockOpen":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(LockOpen, { ...rest });
      break;
    case "LibraryBooks":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(LibraryBooks, { ...rest });
      break;
    case "Settings":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Settings, { ...rest });
      break;
    case "Pageview":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Pageview, { ...rest });
      break;
    case "Build":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Build, { ...rest });
      break;
    case "List":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, { ...rest });
      break;
    case "PersonAdd":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(PersonAddIcon, { ...rest });
      break;
    case "GroupAdd":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(GroupAddIcon, { ...rest });
      break;
    case "Group":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(GroupIcon, { ...rest });
      break;
    case "Face":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(FaceIcon, { ...rest });
      break;
    case "SupervisedUserCircle":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(SupervisedUserCircleIcon, { ...rest });
      break;
    case "AccountCircle":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(AccountCircleIcon, { ...rest });
      break;
    case "Lock":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(LockIcon, { ...rest });
      break;
    case "Favorite":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(FavoriteIcon, { ...rest });
      break;
    case "Email":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(EmailIcon, { ...rest });
      break;
    case "LockRounded":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(LockRoundedIcon, { ...rest });
      break;
    case "DesktopAccessDisabledRounded":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopAccessDisabledRoundedIcon, { ...rest });
      break;
    case "NoEncryptionRounded":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(NoEncryptionRoundedIcon, { ...rest });
      break;
    case "SettingsBackupRestoreRounded":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsBackupRestoreRoundedIcon, { ...rest });
      break;
    case "SignalWifiOff":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(SignalWifiOffIcon, { ...rest });
      break;
    case "CloudUpload":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(CloudUploadIcon, { ...rest });
      break;
    case "KeyboardVoice":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(KeyboardVoiceIcon, { ...rest });
      break;
    case "CurrencyExchange":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(CurrencyExchangeIcon, { ...rest });
      break;
    case "Visibility":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(VisibilityIcon, { ...rest });
      break;
    case "AttachMoney":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(AttachMoneyIcon, { ...rest });
      break;
    case "Check":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, { ...rest });
      break;
    case "AttachEmail":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(AttachEmailIcon, { ...rest });
      break;
    case "Meat":
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Savings, { ...rest });
      break;
    default:
      icon = null;
  }
  return icon;
};
function Facebook(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$1, { ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M9.53144612,22.005 L9.53144612,13.0552149 L6.44166667,13.0552149 L6.44166667,9.49875 L9.53144612,9.49875 L9.53144612,6.68484375 C9.53144612,5.19972656 9.95946769,4.04680661 10.8155103,3.22608401 C11.6715529,2.4053613 12.808485,1.995 14.2263057,1.995 C15.3766134,1.995 16.3129099,2.04710915 17.0351961,2.15132812 L17.0351961,5.3169726 L15.1090998,5.3169726 C14.3868137,5.3169726 13.8919142,5.47330073 13.6244006,5.78595698 C13.4103902,6.04650407 13.3033846,6.46337874 13.3033846,7.03658198 L13.3033846,9.49875 L16.71418,9.49875 L16.2326559,13.0552149 L13.3033846,13.0552149 L13.3033846,22.005 L9.53144612,22.005 Z" }) });
}
function Google(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$1, { ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21,12.2177419 C21,13.9112905 20.6311475,15.4233869 19.8934426,16.7540323 C19.1557377,18.0846776 18.1168031,19.1249998 16.7766393,19.875 C15.4364756,20.6250002 13.8934424,21 12.147541,21 C10.4999998,21 8.97540984,20.5947579 7.57377049,19.7842742 C6.17213115,18.9737905 5.05942604,17.8790323 4.23565574,16.5 C3.41188543,15.1209677 3,13.6209679 3,12 C3,10.3790321 3.41188543,8.87903226 4.23565574,7.5 C5.05942604,6.12096774 6.17213115,5.02620949 7.57377049,4.21572581 C8.97540984,3.40524212 10.4999998,3 12.147541,3 C14.5327871,3 16.5737705,3.78629051 18.2704918,5.35887097 L15.7991803,7.71774194 C15.0122953,6.96774175 14.0655738,6.52016129 12.9590164,6.375 C11.9262295,6.22983871 10.9057375,6.375 9.89754098,6.81048387 C8.88934445,7.24596774 8.07786904,7.89919355 7.46311475,8.77016129 C6.79918033,9.71370968 6.46721311,10.7903228 6.46721311,12 C6.46721311,13.0403228 6.72540984,13.9899192 7.24180328,14.8487903 C7.75819672,15.7076615 8.4467215,16.3971776 9.30737705,16.9173387 C10.1680326,17.4374998 11.1147541,17.6975806 12.147541,17.6975806 C13.2540984,17.6975806 14.2254096,17.455645 15.0614754,16.9717742 C15.7254098,16.5846772 16.2786885,16.0645161 16.7213115,15.4112903 C17.0409838,14.8790321 17.2499998,14.3467744 17.3483607,13.8145161 L12.147541,13.8145161 L12.147541,10.6935484 L20.852459,10.6935484 C20.9508199,11.2258066 21,11.7338712 21,12.2177419 Z" }) });
}
const DropDownMenu = (props) => {
  const theme = useTheme();
  const { type, ddPaths, userName, ddLabel, onClick, viteUrlPathname = null, activeStyle, inactiveStyle } = props;
  const [menuItem, setMenuItem] = React__default.useState(null);
  const onMenuOpen = (event2) => {
    setMenuItem(event2.currentTarget);
  };
  const onMenuClose = (event2, pp) => {
    setMenuItem(null);
  };
  const onMenuClick = async (path2) => {
    onClick(path2);
    setMenuItem(event.currentTarget);
  };
  const menuItems = ddPaths.map((ddOption, i) => {
    const burgerStyles = type === "burger" ? { color: ddOption.draft ? "error.light" : "text.primary", "borderBottom": viteUrlPathname && viteUrlPathname.includes(ddOption.path) ? activeStyle : inactiveStyle, ":hover": { "borderBottom": activeStyle } } : {};
    if (ddOption.display === "divider") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}, ddOption.path + "-" + i);
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { component: Link, onClick: () => onMenuClick(ddOption.path), href: ddOption.path, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Typography,
        {
          textAlign: "center",
          sx: { ...burgerStyles },
          children: ddOption.display
        }
      ) }, ddOption.path + "-" + i);
    }
  });
  const base = type === "burger" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton,
    {
      size: "large",
      "aria-label": "account of current user",
      "aria-controls": "menu-appbar",
      "aria-haspopup": "true",
      onClick: onMenuOpen,
      color: "inherit",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$1, {})
    }
  ) : (
    // 'dropdown'
    /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { onClick: onMenuOpen, sx: { p: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "span", sx: {
      pt: "6px",
      fontSize: "0.9rem",
      color: theme.palette.primary.contrastText
    }, children: props.ddLabel || "Menu" }) })
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: "Click to open menu", children: base }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Menu,
      {
        sx: {
          mt: "45px"
          // for dd
          // display: { xs: 'block', md: 'none' },  // for burger
        },
        id: "dd-appbar",
        anchorEl: menuItem,
        anchorOrigin: {
          vertical: "top",
          // 'bottom' for burger
          horizontal: "right"
          // 'left' for burger
        },
        keepMounted: true,
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
          // 'left' for burger
        },
        open: Boolean(menuItem),
        onClose: onMenuClose,
        onClick: onMenuClose,
        children: menuItems
      }
    )
  ] });
};
const KImage = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { ...props });
};
const KBlogImage = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { ...props, style: { marginTop: "2.0rem", marginBottom: "2.0rem", marginLeft: "10%", marginRight: "10%", width: "80%", height: "auto", maxWidth: "100%", maxHeight: "400px", objectFit: "contain" } });
};
const KLogoImage = (props) => {
  const { src, height: height2, width: width2, alt, children } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src, height: height2, width: width2, alt });
};
const KBackgroundImage = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { ...props });
};
const KBannerImage = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      ...props,
      layout: "fill"
    }
  );
};
const CreateFabOrButton = (btnType, name, linkType, url, target, marginTop, cb = null, disabled = false, sx = {}, helperText, helperTextWidth) => {
  if (btnType === "button")
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: { marginBottom: "0.6rem", marginTop, textAlign: "center" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          variant: "contained",
          color: "secondary",
          sx: {
            padding: "0.6rem 3.0rem",
            fontSize: "1.4rem",
            letterSpacing: "0.2rem",
            textAlign: "center",
            ...sx
          },
          disabled,
          onClick: (e) => {
            if (cb) {
              cb(e);
            } else {
              kNavigateToPage(linkType, url, target);
            }
          },
          children: name
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center", width: helperTextWidth, margin: "auto" }, children: helperText })
    ] });
  else
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: { marginTop, alignItems: "center", ml: "20%", mr: "20%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Fab,
      {
        color: "secondary",
        variant: "extended",
        sx: { padding: 4, fontSize: 16 },
        onClick: (e) => {
          kNavigateToPage(linkType, url, target);
        },
        children: name
      }
    ) });
};
function getAppCodeDtls(appCode, member) {
  let xxxxUser = null;
  let plans = null;
  let subCode = appCode;
  switch (appCode) {
    case "RECL":
      xxxxUser = member.consumer;
      plans = member.account.jsonProp["apps"]["RECL"] || null;
      break;
    case "KRIP":
      break;
    case "BITI":
      xxxxUser = member.bitiuser;
      plans = member.account.jsonProp["apps"]["BITI"] || null;
      break;
    case "NULC":
      xxxxUser = member.nulluser;
      plans = member.account.jsonProp["apps"]["NULC"] || null;
      break;
    case "TMPL":
      break;
    case "CRUD":
    case "LNCH":
    case "FORM":
    case "SCUR":
      xxxxUser = member.formuser;
      subCode = "CRUD";
      plans = member.account.jsonProp["apps"]["CRUD"] || null;
      break;
  }
  return { xxxxUser, subCode, plans };
}
function findMembership(members, accountNo) {
  if (typeof accountNo === "string") accountNo = Number(accountNo);
  const membership = members && members.length && members.find((member) => {
    const account = member.account;
    if (account.accountNo === accountNo) return true;
    else return false;
  });
  return membership;
}
class FeaturesAccessSecurity {
  constructor(clntOptions, srvrOptions = null) {
    this.clntOptions = clntOptions;
    this.srvrOptions = srvrOptions;
    this.vitals = {
      member: null,
      account: null,
      permission: null,
      preference: null,
      xxxxuser: null,
      isAuthUser: null,
      activeSub: null,
      isPlanEnroll: false,
      isSubscriptionEnroll: false,
      isTrialExpired: false
    };
    this._init(clntOptions, srvrOptions);
  }
  _init(options2, srvrOptions) {
    const upap = options2.upap;
    const appCode = options2.appCode;
    const reqAccountNo = options2.reqAccountNo && Number(options2.reqAccountNo) || -1;
    if (!upap || !upap.user || !upap.members) {
      console.log("FeaturesAccessSecurity:_init(): No upap or upap.user or upap.members");
    }
    let user = upap?.user || null;
    let members = upap?.members || null;
    let member = null;
    let account = null;
    let permission = null;
    let preference = null;
    let isAuthUser = false;
    let xxxxUser;
    let activeSub = null;
    let isPlanEnroll = false;
    let isSubscriptionEnroll = false;
    let isTrialExpired = true;
    let isFpidUser = false;
    let isBasicPlanUser = false;
    let isPaidPlanUser = false;
    try {
      if (members) {
        if (members.length > 1) {
          if (reqAccountNo == -1) {
            member = members.find((member2) => {
              return member2.member.type == "Owner";
            });
          } else {
            member = members.find((member2) => {
              const memberAccount = member2.account;
              return memberAccount.accountNo == reqAccountNo;
            });
          }
        } else {
          member = members[0];
        }
      }
      if (member) {
        account = member.account;
        permission = member.permission;
        preference = member.preference;
        const resp = getAppCodeDtls(appCode, member);
        xxxxUser = resp.xxxxUser;
      } else {
        if (reqAccountNo !== -1) {
          console.warn(`FeaturesAccessSecurity:_init(): problem extracting member based on reqAccountNo(${reqAccountNo}) - condition ignored`);
        }
      }
      if (user && user.email && user.email !== "undefined") {
        isAuthUser = true;
      } else isAuthUser = false;
      if (isAuthUser) {
        const jsonPropApps = account.jsonProp["apps"];
        const appSubs = jsonPropApps[appCode];
        activeSub = appSubs && appSubs.length && appSubs.find((sub) => {
          return !sub.deenrollts && !sub.depaymentts;
        });
        if (activeSub) {
          isPlanEnroll = !!activeSub;
          isSubscriptionEnroll = !!activeSub.paymentts;
          const trial = 21;
          const createdAt = activeSub.createdAt ? new Date(activeSub.createdAt) : /* @__PURE__ */ new Date();
          const trialExpiry = new Date(createdAt.getTime() + trial * 24 * 60 * 60 * 1e3);
          const today = /* @__PURE__ */ new Date();
          isTrialExpired = trialExpiry < today;
          if (activeSub.plan.indexOf("Basic") !== -1) {
            isBasicPlanUser = true;
          } else {
            if (isTrialExpired && !activeSub.paymentts) {
              isBasicPlanUser = true;
            } else {
              isPaidPlanUser = true;
            }
          }
        } else {
          isBasicPlanUser = true;
        }
      } else {
        isFpidUser = true;
      }
    } catch (e) {
      console.log("FeaturesAccessSecurity:_init(): exception : ", e);
      throw e;
    }
    let isPassThrough = false;
    let isUpapAuthorized = false;
    let isAppAuthorized = false;
    let ownerAccountNo = null;
    try {
      if (srvrOptions) {
        const { logger = console, appConfig, serverContext, service, query, findId, reqAccountNo: reqAccountNo2 } = srvrOptions;
        switch (service) {
          case "emerts":
            if (query && query.recallDate && query.recallDate["$gte"]) {
              const gte = query.recallDate["$gte"];
              const gteStr = gte.substr(1, 10);
              const gteDate = gteStr.split("-");
              const reqDate = new Date(Number(gteDate[0]), Number(gteDate[1]) - 1, Number(gteDate[2]));
              const today = /* @__PURE__ */ new Date();
              const diffTime = Math.abs(today - reqDate);
              const diffDays = Math.ceil(diffTime / (1e3 * 60 * 60 * 24));
              const allowedDays = appConfig["emert"].freeRecallsAccessDays;
              if (diffDays < allowedDays) {
                isPassThrough = true;
              }
              logger.info(`FeaturesAccessSecurity:_init() - request exceeded permitted allowedDays ${allowedDays} `);
            }
            if (findId) {
              isPassThrough = true;
            }
            break;
          case "products":
            isPassThrough = true;
            break;
          case "search":
            isPassThrough = true;
            break;
          case "recallsWidget":
            isPassThrough = serverContext.isCorsListed;
            break;
          case "???":
            isPassThrough = true;
            break;
          default:
            break;
        }
        if (!upap || !members || !members.length) {
          isUpapAuthorized = false;
        } else {
          isUpapAuthorized = true;
          const membership = findMembership(upap.members, reqAccountNo2 || upap.user.userNo);
          const account2 = membership.account;
          if (account2) {
            isAppAuthorized = this._checkAppRegistered(account2, appCode);
          }
        }
        if (members) {
          member = members.find((member2) => {
            return member2.member.type === "Owner";
          });
          ownerAccountNo = member?.account?.accountNo;
        }
      } else {
        console.log("FeaturesAccessSecurity:_init() only performed for client side usage");
      }
    } catch (e) {
      console.error("FeaturesAccessSecurity:_init() srvr side init exception", e);
    }
    this.vitals = {
      member,
      account,
      permission,
      preference,
      xxxxUser,
      isAuthUser,
      activeSub,
      isPlanEnroll,
      isSubscriptionEnroll,
      isTrialExpired,
      isFpidUser,
      isBasicPlanUser,
      isPaidPlanUser,
      isPassThrough,
      isUpapAuthorized,
      isAppAuthorized,
      ownerAccountNo
    };
  }
  setup() {
    return this.vitals;
  }
  check(params) {
    const { featureId, options: options2 } = params;
    let userCheckMsg = "";
    let planCheckMsg = "";
    let accessCheckMsg = "";
    try {
      const {
        member,
        account,
        permission,
        preference,
        xxxxUser,
        isAuthUser,
        activeSub,
        isPlanEnroll,
        isSubscriptionEnroll,
        isTrialExpired,
        isFpidUser,
        isBasicPlanUser,
        isPaidPlanUser
      } = this.vitals;
      const totalAllowForms = 3;
      const totalAllowSubmissions = 5;
      switch (featureId) {
        case "form-library-createNewForm":
          const formCnt = options2.formCnt;
          if (isFpidUser && formCnt >= totalAllowForms) {
            accessCheckMsg = "Exceeded maximum forms limit for an anonymous user.";
          }
          break;
        case "form-submissions-limit":
          const submissionsCnt = options2.submissionsCnt;
          if (!isAuthUser && submissionsCnt >= totalAllowSubmissions) {
            accessCheckMsg = "Excceeded maximum form submissions limit for an anonymous user.";
          }
          break;
        default:
      }
      return userCheckMsg || planCheckMsg || accessCheckMsg;
    } catch (e) {
      console.error("FeaturesAccessSecurity:check() - exception: ", e);
      throw e;
    }
  }
  _checkAppRegistered(account, appCode) {
    return true;
  }
  _validateAccess(service, req, account, query, findId, app) {
    return true;
  }
  _isDatePastGone(d) {
    var now = /* @__PURE__ */ new Date();
    now.setHours(0, 0, 0, 0);
    if (d < now) {
      return true;
    } else {
      return false;
    }
  }
}
export {
  AccordionCtnr,
  Account,
  AccountOidc,
  AccountPage,
  AccountPermissions,
  AccountPreferences,
  Advert,
  Alert,
  AppProvider,
  Articles,
  AsideBodyLayout,
  AutocompleteTaggerComp,
  Banner,
  BannerImage,
  Bitiuser,
  BlogCards,
  BoxCtnr,
  BuildCreateVersion,
  BuildDeleteVersion,
  BuildOutputCtnr,
  BuildPage,
  BuildRawhtmlComp,
  BuildSourceActive,
  BuildTraversalCtnr,
  BurgerMenu,
  ButtonComp,
  ButtonGroupCtnr,
  ButtonMenuCtnr,
  CONST,
  CardComp,
  CardCtnr,
  ChangeIdComp,
  ChangePwdComp,
  CheckRadioSwitchComp,
  ChildrenCtnr,
  Chip2 as ChipInput,
  ChipInputComp,
  CircularProgressComp,
  CollapsableCtnr,
  ColumnCtnr,
  CommonAppLayout,
  CommonHomePageLayout,
  CompConfig,
  Consumer,
  ContentLayout,
  ContentLayoutMdx,
  ContentLayoutSpa,
  ContentLayoutTest,
  ContentLayoutTsx,
  Counter,
  CowIcon,
  CreateButtonGroup,
  CreateFabOrButton,
  DropDownMenu,
  ErrorBoundary,
  Facebook,
  FaqFormatter,
  FeaturesAccessSecurity,
  FieldsetCtnr,
  FillerComp,
  Footer$2 as Footer,
  ForgotComp,
  Form,
  FormBody,
  FormBuildPageLayout,
  FormCtnr,
  FormHeader,
  FormHomePage,
  FormLibraryPageLayout,
  FormNoDataLayout,
  FormPWA,
  FormPreviewPageLayout,
  FormPropEditorCtnr,
  FormProxyCtnr,
  FormSidebar,
  FormSubmissionsPageLayout,
  Formuser,
  FourColumnLayout,
  Frame,
  GetStartedPlans,
  GooAdverts,
  Google,
  Header,
  Highlight,
  HowToFormatter,
  IconPalette$1 as IconPalette,
  Identity,
  InfoComp,
  InlineCtnr,
  InputComp,
  Instance,
  InvitesComp,
  Item,
  ItemListActionToolbarCtnr,
  ItemPropEditorCtnr,
  JoinPage,
  KBackgroundImage,
  KBannerImage,
  KBlogImage,
  KImage,
  KLogoImage,
  Konsole,
  KripaRedBallIcon,
  LaunchItemListCtnr,
  LaunchMarketingMsg,
  LaunchPage,
  LibraryPage,
  LinearProgressComp,
  LinkBlock,
  ListButtonCtnr,
  ListCreateCard,
  ListCreateFormComp,
  ListCtnr,
  ListProxyCtnr,
  ListSubscriptions,
  LnchLaunchPageLayout,
  Logger,
  Login,
  MDXCodeBlock,
  MDXComponents,
  MainAccountDisplay,
  MainAccountSelect,
  MainFormNoDisplay,
  MainSnackbarComp,
  MainTopbar,
  MarketPage,
  MeatIcon,
  MembersComp,
  MembersPage,
  MinimalTopbar,
  Modal,
  MuiAccordion,
  MuiAutoComplete,
  MuiCard,
  MuiCheckRadioSwitch,
  MuiComp,
  MuiDivider,
  MuiDrawer,
  MuiIconButton,
  MuiListComp,
  MuiTableComp,
  MuiTabs,
  NailCtnr,
  NavItems,
  Navigation,
  Nulluser,
  OneColumnLayout,
  P,
  PWA,
  PageContentFormat,
  PageContextProvider,
  PageHeader,
  PageLayout,
  PaletteListCtnr,
  PanelCtnr,
  PanelLayout,
  PaperLayout,
  Permissions,
  PlansDisplay,
  PlansDisplayDetails,
  PlansPage,
  Preferences,
  PreviewItemListCtnr,
  PreviewPage,
  PricingDisplay,
  PricingDisplayDetails,
  MDXContent$1 as Privacy,
  Profile,
  PromoteDonate,
  RaisedComp,
  RecallsWidgetWrapper,
  ReverifyComp,
  Sample1,
  Sample2,
  Sample3,
  Sample5,
  SampleDemoCard,
  MDXContent$2 as SampleFaq,
  SampleMdxComponent,
  SampleMdxSection,
  SampleSection,
  SampleSectionBG,
  SampleSectionTwoCol,
  SampleSignature,
  SampleTitleBar,
  Scroller,
  ScurBody,
  ScurHomePage,
  ScurSidebar,
  SearchComp,
  SectionHeader,
  SectionLayout,
  SectionWrapper,
  SelectComp,
  SelectListComp,
  Sidebar,
  SignInComp,
  SignUpComp,
  Slate,
  SliderComp,
  SnackbarComp,
  SpaProvider,
  StethoscopeIcon,
  Submenubar,
  Submission,
  SubmissionsPage,
  SubscriptionsInfo,
  SubscriptionsPage,
  SubscriptionsStripe,
  SwitchComp,
  TabComp,
  TabCtnr,
  TableComp,
  MDXContent as TermsConditions,
  TestimonialsDisplay,
  TestimonialsDisplayDetails,
  TextFieldComp,
  ThemeEditor,
  ThreeColumnLayout,
  ToggleComp,
  TopProgressBar,
  Tree,
  TwoColumnLayout,
  UnsplashImgComp,
  UpgradePlan,
  User,
  UsersPage,
  WidgetCtnr,
  WizardCtnr,
  YouTube,
  advertSvc,
  appReducer,
  appUpdtStateFn,
  builderMethods,
  builderProps,
  cleanInboundItems,
  cleanInboundSubmissions,
  commonHead,
  contentHead,
  createForm,
  createInitState,
  createJsonLdContent,
  createRoutes,
  createSeoContent,
  createSpaInitState,
  debounceWithThrottle,
  deepCopyJson,
  defaultAccount,
  defaultBitiuser,
  defaultConsumer,
  defaultFormuser,
  defaultNulluser,
  defaultPermissions,
  defaultPreferences,
  defaultUser,
  displayDate,
  displayNumber,
  editorMethods,
  editorProps,
  friendlyDate,
  friendlyMonthDay,
  friendlyStatus,
  friendlyTitle,
  genMuiThemes,
  getAppCodeDtls,
  getBucketProps,
  getDisplayCommonLocalStore,
  getItemUserProps,
  getPageMeta,
  getUrlParm,
  isArray,
  isHomeSiteReachable,
  kNavigateToPage,
  manageFormSpecs,
  metaformsMethods,
  metaformsProps,
  modelMethods,
  modelProps,
  myFetch,
  particles,
  pymtUtil,
  recallTypeToText,
  relativeDaysDiff,
  repocacheMethods,
  repocacheProps,
  sanityCheck,
  selectionMethods,
  selectionProps,
  serverioMethods,
  serverioProps,
  setFormProps,
  slugify,
  spaReducer,
  spaUpdtStateFn,
  suffixSeverity,
  updateDisplayCommonLocalStore$1 as updateDisplayCommonLocalStore,
  useAppContext,
  useLocalStorage,
  usePageContext,
  useSpaContext,
  useWindowScrollPosition,
  validationRules
};
//# sourceMappingURL=clnt-common.js.map
